{
  "language_switcher": {
    "language": "Language",
    "english": "English",
    "french": "Français"
  },
  "clinical_data": {
    "loading": "Loading care records…",
    "unavailable_title": "We couldn’t load these records",
    "unavailable_body": "Your saved records are still safe. Check your connection and try again.",
    "stale_body": "Some information may be out of date because we couldn’t refresh it.",
    "retry": "Try again",
    "retrying": "Trying again…"
  },
  "cycle_header": {
    "today": "today",
    "tomorrow": "tomorrow",
    "yesterday": "yesterday",
    "in_n_days": "in ${n} days"
  },
  "access": {
    "back": "Access",
    "overview": {
      "title": "Access",
      "subtitle": "Discover providers, tests & programs",
      "featured_program_eyebrow": "Featured program",
      "featured_fallback_title": "Programs",
      "featured_fallback_subtitle": "Explore our structured fertility programs",
      "categories": {
        "find_care_title": "Find Care",
        "find_care_subtitle": "Search clinics, compare providers",
        "testing_title": "Testing",
        "testing_subtitle": "Order tests, track results",
        "programs_title": "Programs",
        "programs_subtitle": "Bundles & structured plans",
        "supplements_title": "Supplements",
        "supplements_subtitle": "Evidence-based protocols",
        "donor_registry_title": "Donor Registry",
        "donor_registry_subtitle": "Find & match with donors",
        "therapies_title": "Therapies & Add-ons",
        "therapies_subtitle": "Compare interventions, evidence",
        "pharmacy_title": "Pharmacy",
        "pharmacy_subtitle": "Find pharmacies and contact them directly"
      }
    },
    "pharmacy": {
      "header_subtitle": "Find verified pharmacy contacts and current service details.",
      "tab_prescription": "Prescription",
      "tab_quotes": "Quotes",
      "tab_savings": "Savings",
      "medication_help_section_eyebrow": "Medication help",
      "medication_help_storage_title": "Store and protect your medication",
      "medication_help_storage_summary": "Keep each medication at the temperature on its label.",
      "medication_help_storage_body": "Storage depends on the product and the form you were prescribed. Use the medication rows below to check the labeled window. If a dose was left in a car, on a counter, or in a freezer, do not guess from appearance.",
      "medication_help_storage_next": "Write down how long it was out and the approximate temperature, keep it in the original package, and call the dispensing pharmacy before using or discarding it.",
      "medication_help_medications_section": "Your medications",
      "medication_help_injectables_section": "Injectables in your prescription",
      "medication_help_missed_section": "Medication to check",
      "medication_help_delivery_section": "Prescriptions to track",
      "medication_help_travel_section": "Pack with your medication",
      "medication_help_no_medications": "No medications are connected yet. Use the prescription label or patient leaflet as the source of truth, and ask the pharmacy about any storage or use question.",
      "medication_help_storage_refrigerate": "Refrigerate",
      "medication_help_storage_room_temperature": "Room temperature",
      "medication_help_storage_check_label": "Check label",
      "medication_help_storage_gonal_window": "Refrigerate at 2–8°C, or keep at 20–25°C for up to 3 months before first use or 28 days after the first injection.",
      "medication_help_storage_gonal_detail": "Keep the pen capped and protected from light. Do not freeze.",
      "medication_help_storage_cetrotide_window": "Refrigerate at 2–8°C. The prepared solution should be used immediately; no patient room-temperature window is listed.",
      "medication_help_storage_cetrotide_detail": "Keep the packaged tray in its outer carton to protect it from light.",
      "medication_help_storage_ovidrel_window": "Refrigerate at 2–8°C, or keep at room temperature up to 25°C for no more than 30 days.",
      "medication_help_storage_ovidrel_detail": "Protect from light and use within the labeled 30-day room-temperature window.",
      "medication_help_storage_endometrin_window": "Store at 20–25°C; excursions between 15–30°C are permitted.",
      "medication_help_storage_endometrin_detail": "This insert is a room-temperature product. Keep it in the original package.",
      "medication_help_storage_dexamethasone_window": "Store at 20–25°C; excursions between 15–30°C are permitted.",
      "medication_help_storage_dexamethasone_detail": "Protect tablets from moisture and keep the dispensing container closed.",
      "medication_help_storage_unknown_window": "Storage window not verified for this medication.",
      "medication_help_storage_unknown_detail": "Use the pharmacy label or patient leaflet before making a storage decision.",
      "medication_help_injection_title": "Inject and dispose of supplies",
      "medication_help_injection_summary": "Learn about new needles, sharps, and safe cleanup.",
      "medication_help_injection_body": "Use a new needle or syringe for every injection. Keep used sharps where the injection happens so they can go straight into a puncture-resistant sharps container.",
      "medication_help_injection_next": "Put each needle, syringe, or pen needle into the container immediately after use. Never put loose sharps in household trash, recycling, or the toilet; follow your local full-container instructions.",
      "medication_help_injection_row": "Use the route and instructions on your prescription; use a new needle or syringe each time.",
      "medication_help_missed_title": "Missed dose or damaged medication",
      "medication_help_missed_summary": "Know who to call before taking another dose.",
      "medication_help_missed_body": "Fertility timing can be specific to your protocol. If a dose is late, missed, dropped, leaking, or looks different, pause before taking a replacement dose.",
      "medication_help_missed_next": "Write down the medication, prescribed dose, planned time, and what happened. Call your clinic for timing instructions and your pharmacy for a replacement or product question. Do not double a dose unless they tell you to.",
      "medication_help_missed_row": "Do not replace or double this dose without instructions from your clinic.",
      "medication_help_delivery_title": "Delivery, refills, and pharmacy problems",
      "medication_help_delivery_summary": "Know what to ask when an order is late or cannot be filled.",
      "medication_help_delivery_body": "A pharmacy can help confirm whether it received the prescription, has stock, can refill it, or needs information from your clinic or insurer.",
      "medication_help_delivery_next": "Call before the next dose is due. Ask about stock, refill date, prior authorization, copay, transfer, and the fastest safe replacement if the shipment is delayed.",
      "medication_help_delivery_row": "Confirm stock, refill timing, coverage, and delivery before the next dose.",
      "medication_help_travel_title": "Travel with fertility medication",
      "medication_help_travel_summary": "Plan for temperature, supplies, and delays.",
      "medication_help_travel_body": "Keep every medication in its original labeled package in your carry-on. For temperature-sensitive items, plan the cold chain before you leave rather than improvising with a hotel refrigerator.",
      "medication_help_travel_next": "Bring enough for the trip plus extra for delays. Ask your pharmacy about a travel cooler, storage limits, needles, and a letter or other documentation before departure.",
      "medication_help_open_source": "Open guidance",
      "section_meds_eyebrow": "Your Medications",
      "section_meds_title": "Current Cycle",
      "section_best_price_eyebrow": "Best Price For You",
      "section_savings_eyebrow": "Savings Programs",
      "section_directory_eyebrow": "All Pharmacies",
      "directory_source_live_title": "Live provider directory",
      "directory_source_live_body": "Provider details are loaded from the live directory when available. Coverage, pricing, and fulfillment still need pharmacy confirmation.",
      "directory_source_curated_title": "Curated provider directory",
      "directory_source_curated_body": "Louise is showing provider records while the live directory is unavailable. Official contact links are shown where they could be verified.",
      "directory_source_demo_title": "Demo pharmacy data",
      "directory_source_demo_body": "This preview uses illustrative medications and sample quotes. Savings cards link to current public program sources, but pricing and eligibility are not live.",
      "demo_mode_title": "Show demo experience",
      "demo_mode_body": "Preview example medications, quotes, savings, and richer pharmacy cards.",
      "demo_mode_hint": "Switch between the connected directory and the illustrative demo experience.",
      "demo_mode_enabled": "Demo data is on · nothing here is a live quote",
      "demo_mode_disabled": "Showing live or curated provider records",
      "directory_loading_title": "Loading pharmacy directory",
      "directory_loading_body": "We’re checking the latest provider records.",
      "directory_error_title": "Pharmacy directory unavailable",
      "directory_error_body": "We couldn’t load pharmacy records right now. Try again later or use your clinic’s pharmacy instructions.",
      "coverage_varies": "Coverage varies by plan",
      "cash_price_label": "Cash price",
      "call_pharmacy": "Call",
      "view_details": "View details",
      "view_details_a11y": "${name}. View pharmacy details",
      "medication_guide_a11y": "Open medication guide for ${name}",
      "meds_loading_title": "Loading medications",
      "meds_loading_body": "Louise is checking your connected medication records.",
      "meds_error_title": "Medication records unavailable",
      "meds_error_body": "We couldn’t load your connected medications. Your clinic or pharmacy instructions remain the source of truth.",
      "detail_source_live": "Loaded from the live provider directory",
      "detail_source_curated": "Loaded from a curated provider record",
      "detail_source_demo": "Showing an illustrative pharmacy preview",
      "contact_section_title": "Contact",
      "services_section_title": "Listed services",
      "services_disclaimer": "Services and delivery options can change. Confirm the current details with the pharmacy before sending a prescription.",
      "phone_unverified": "Phone not verified in this directory",
      "open_website": "Open official pharmacy website",
      "detail_pricing_body": "Louise does not yet have a verified quote, benefits adjudication, prescription transfer, or order workflow. Contact the pharmacy directly to confirm your price, coverage, and fulfillment options.",
      "quote_request_title": "Request a pharmacy quote",
      "quote_request_body": "Open the pharmacy's official contact or quote page, then ask for current price, coverage, stock, and delivery. Louise will not submit a prescription or quote request for you.",
      "quote_request_loading": "Loading your connected medications…",
      "quote_request_medications": "Medication list to review",
      "quote_request_no_medications": "No medications are connected yet. You can still contact the pharmacy and provide the prescription details yourself.",
      "open_quote_source": "Open pharmacy quote or contact page",
      "open_insurance_source": "Sign up or log in to see fertility & pharmacy services",
      "quote_request_insurance_body": "This pharmacy dispenses through your insurance benefit. Sign up or log in on their site to see the fertility and pharmacy services available to you — Louise will not submit a prescription for you.",
      "in_house_compounding": "Custom medications made on-site",
      "delivery_section_title": "Delivery",
      "delivery_cold_chain": "Cold-chain shipping guaranteed",
      "delivery_same_day": "Same-day delivery in ${cities}",
      "delivery_overnight_nationwide": "Overnight shipping to all 50 states",
      "published_prices_section_title": "Published price list",
      "published_prices_body": "Rates posted by the pharmacy on ${date}. These are cash prices — your insurance or a savings program may cover part of the cost.",
      "published_prices_view_source": "View full price list",
      "prescription_estimate_title": "Your prescription at ${pharmacy} cash rates",
      "prescription_estimate_body": "Each matched medication is priced at ${pharmacy}'s published unit rate. Actual total depends on prescribed quantity and cycle length.",
      "prescription_estimate_no_match": "Not on ${pharmacy}'s published list",
      "prescription_estimate_starting_from": "Starting from ${amount} per unit",
      "prescription_estimate_disclaimer": "Estimate assumes one unit of each medication. Your protocol may require several — ask the pharmacy for a full quote.",
      "share_medication_list": "Share medication list",
      "quote_share_message_title": "Medication list for ${pharmacy}",
      "quote_share_message_reminder": "Please confirm current price, coverage, stock, and delivery with the pharmacy.",
      "manufacturer_programs_title": "Manufacturer Programs",
      "matched_to_meds": "Matched to your medications",
      "meds_empty_body": "Add a medication or upload a prescription to see pharmacy prices, savings, and fulfillment options here.",
      "meds_add_medication": "Add medication",
      "meds_upload_prescription": "Upload prescription",
      "price_coming_title": "Price comparisons are not connected yet",
      "price_coming_body": "Louise is not showing estimated medication prices in production. Contact pharmacies directly for personalized quotes and insurance verification.",
      "quote_empty_body": "Upload a quote or save a price you received so you have it on hand. Soon, Louise will be able to read your quotes and compare them with other pharmacies.",
      "quote_upload": "Upload quote",
      "quote_add_price": "Add price",
      "quote_upload_or_add_price": "Upload quote or add price",
      "quote_patient_provided": "Patient-provided",
      "quote_needs_confirmation": "Needs confirmation",
      "quote_price_not_added": "Price not added",
      "quote_added_date": "Added ${date}",
      "quote_details_a11y": "Open quote details for ${name}",
      "quote_detail_patient_subtitle": "Patient-provided quote · Added ${date}",
      "quote_detail_demo_subtitle": "Illustrative quote",
      "quote_detail_total": "Total price",
      "quote_detail_estimated_savings": "Estimated savings",
      "quote_detail_source": "Source",
      "quote_detail_uploaded": "Uploaded quote",
      "quote_detail_manual": "Price added manually",
      "quote_detail_demo": "Demo quote",
      "quote_detail_document": "Attached file",
      "quote_detail_note": "Notes",
      "quote_detail_close": "Close",
      "quote_add_title": "Add a pharmacy quote",
      "quote_add_body": "Enter a price you received or attach a written quote. Patient-provided prices are kept separate from connected pharmacy pricing until confirmed.",
      "quote_pharmacy_label": "Pharmacy",
      "quote_pharmacy_placeholder": "Pharmacy name",
      "quote_total_label": "Total price",
      "quote_total_placeholder": "$0",
      "quote_date_label": "Quote date",
      "quote_date_placeholder": "YYYY-MM-DD",
      "quote_notes_label": "Notes",
      "quote_notes_placeholder": "Insurance, quantity, shipping, or other details",
      "quote_attach_title": "Attach the quote",
      "quote_take_photo": "Take photo",
      "quote_upload_file": "Upload file",
      "quote_opening": "Opening…",
      "quote_saving": "Saving…",
      "quote_save": "Save quote",
      "quote_cancel": "Cancel",
      "quote_upload_error": "We couldn’t save that quote. Check your connection and try again.",
      "pharmacy_prices_section_eyebrow": "Pharmacy prices",
      "demo_quote_label": "Illustrative quote",
      "demo_quote_medication": "Example total for your cycle medications",
      "demo_quote_savings": "Save $${amount}",
      "demo_detail_quote_body": "Sample only for walkthroughs. Confirm current pricing, coverage, and fulfillment directly with the pharmacy.",
      "medication_prices_section_title": "Medication-by-medication pricing",
      "medication_prices_section_body": "Compare each item before deciding whether to keep the order together.",
      "medication_price_contact": "Contact for pricing",
      "medication_price_lower_elsewhere": "Lower by $${amount} at ${pharmacy}",
      "medication_price_split_title": "Possible split-order savings",
      "medication_price_split_body": "${count} item(s) are lower at another pharmacy. Compare delivery and pickup details before splitting an order.",
      "medication_price_demo_disclaimer": "Illustrative demo prices only. Confirm current price, coverage, and availability with each pharmacy.",
      "fulfillment_section_eyebrow": "FULFILLMENT",
      "fulfillment_delivery_title": "Medication delivery",
      "fulfillment_delivery_status": "Shipped",
      "fulfillment_delivery_timing": "Arrives tomorrow, 2–6 PM",
      "fulfillment_delivery_detail": "Cold-chain shipment · keep refrigerated when it arrives.",
      "fulfillment_pickup_title": "Local pharmacy pickup",
      "fulfillment_pickup_status": "Ready today",
      "fulfillment_pickup_timing": "Pickup by 7 PM",
      "fulfillment_pickup_detail": "Pickup window closes at 7:00 PM.",
      "fulfillment_refill_title": "Refill needed",
      "fulfillment_refill_status": "Action needed",
      "fulfillment_refill_timing": "Cetrotide runs out tomorrow",
      "fulfillment_refill_detail": "Request before your next monitoring call.",
      "fulfillment_more_medications": "+${count} more medications",
      "fulfillment_view_a11y": "View ${title}",
      "savings_programs_title": "Savings programs and public pricing",
      "savings_programs_body": "Based on current program-owner pages. Eligibility and pricing can change; Louise does not determine eligibility.",
      "savings_summary_title": "${count} savings programs identified",
      "savings_summary_body": "They range from instant manufacturer savings and reduced cash pricing to income-based, military, and patient assistance. Final eligibility depends on coverage and program criteria.",
      "savings_programs_medications": "Program medications: ${medications}",
      "savings_programs_verified": "Source checked ${date}",
      "savings_programs_open": "View source",
      "savings_programs_view_details": "View details",
      "savings_programs_eligibility": "Eligibility",
      "savings_programs_process": "How it works",
      "savings_programs_medications_title": "Eligible medications",
      "savings_programs_close": "Close",
      "savings_coming_title": "Savings guidance is coming",
      "savings_coming_body": "Manufacturer savings and eligibility can vary by prescription and coverage. Confirm programs directly with your clinic, pharmacy, or manufacturer until Louise connects verified data.",
      "search_placeholder": "Search pharmacies...",
      "filter_all": "All",
      "filter_specialty": "Specialty",
      "filter_mail_order": "Mail Order",
      "filter_retail": "Retail",
      "result_count_one": "${count} pharmacy",
      "result_count_other": "${count} pharmacies",
      "accepts_named": "Accepts ${insurer}",
      "accepts_generic": "Accepts insurance",
      "cash_pay_only": "Cash pay only",
      "contact_for_pricing": "Contact for pricing",
      "save_amount": "Save $${amount}",
      "est_savings": "Est. savings: ${amount}",
      "empty": "No pharmacies match your search",
      "coverage": {
        "covered": "Covered",
        "pa_approved": "PA Approved",
        "cash_pay": "Cash Pay"
      },
      "type": {
        "specialty": "Specialty",
        "mail_order": "Mail Order",
        "retail": "Retail"
      }
    },
    "testing": {
      "title": "Testing",
      "subtitle": "Discover fertility tests, screenings, and at-home kits to understand your reproductive health.",
      "search_placeholder": "Search tests and kits...",
      "guide_section_label": "What do you want to know?",
      "shop_at_home": "Shop at-home",
      "tests_and_kits": "Tests and kits",
      "empty_search": "No tests or kits match your search",
      "empty_no_options": "No testing options available yet",
      "empty_in_guide": "No matching tests or kits are available for this profile yet.",
      "location": {
        "at_home": "At-home",
        "clinic": "Clinic",
        "lab": "Lab"
      },
      "hero": {
        "eyebrow": "Personalised protocol",
        "title": "Unlock your recommended testing plan",
        "summary": "See a personalised shortlist of labs, screenings, and at-home kits matched to your profile before booking anything.",
        "cta_unlock": "Complete profile to unlock"
      },
      "recommendations": {
        "eyebrow": "Picked for you",
        "title": "Your personalised shortlist",
        "subtitle": "Based on what you shared with us. Open a card to learn more about the test."
      },
      "recommendation": {
        "trigger": {
          "baseline_afab": "Baseline for you",
          "baseline_amab": "Baseline for you",
          "varicocele": "You mentioned a varicocele",
          "pcos": "You mentioned PCOS",
          "endo": "You mentioned endometriosis",
          "low_reserve": "Low ovarian reserve concern",
          "age_35_plus": "For your age group",
          "age_38_plus_ivf": "You're 38+ and planning IVF",
          "age_40_plus_ivf": "You're 40+ and planning IVF",
          "rpl": "You've had 2+ pregnancy losses",
          "rif": "You've had 3+ failed cycles",
          "ethnicity": "Your family background",
          "irregular_cycles": "Irregular cycles",
          "planned_cycle": "You're planning a cycle",
          "planned_ivf": "You're planning IVF",
          "egg_freezing": "You're planning egg freezing",
          "cancer_history": "Fertility after cancer",
          "early_menopause_reported": "Early menopause concern",
          "fibroids_reported": "You mentioned fibroids",
          "ovarian_surgery_reported": "You had ovarian surgery",
          "thyroid_reported": "You mentioned thyroid disease",
          "tubal_issues_reported": "You mentioned tubal issues"
        },
        "reason": {
          "amh_baseline": "A first read on your egg supply — done any cycle day.",
          "afc_baseline": "Confirms the AMH picture with an ultrasound count.",
          "semen_baseline": "The starting point of every male fertility workup.",
          "dna_frag_varicocele": "Standard semen tests can miss the sperm DNA damage varicocele can cause.",
          "dna_frag_rpl": "Recurrent pregnancy loss is one of the specific indications for testing sperm DNA damage.",
          "hormone_pcos": "Confirms PCOS and rules out look-alike causes.",
          "tracker_pcos": "Reveals whether — and when — you're actually ovulating.",
          "sonogram_endo": "Looks inside the cavity for changes endometriosis can cause.",
          "endometritis_endo": "Checks for silent inflammation that reduces implantation.",
          "hormone_low_reserve": "Day 2–4 hormones tell us how your ovaries are responding.",
          "thyroid_age": "Thyroid glitches become more common — and easier to catch — after 35.",
          "prolactin_irregular": "A common, easily-treated cause of missed or late periods.",
          "thyroid_irregular": "Thyroid issues are a top driver of cycle irregularity.",
          "carrier_planned_cycle": "Screens both of you for conditions worth knowing before conception.",
          "infectious_planned_cycle": "Required by most clinics before starting IVF or IUI.",
          "lining_ivf": "Your lining before transfer is a leading predictor of success.",
          "hormone_egg_freezing": "Sets the right stimulation protocol for your freeze cycle.",
          "amh_cancer": "A fast read on egg supply before treatment — critical if fertility preservation matters to you.",
          "afc_cancer": "Confirms the AMH picture with a live follicle count before any treatment.",
          "hormone_cancer": "Day 2–4 hormones tell your team how your ovaries are functioning right now.",
          "carrier_cancer": "Some cancer histories overlap with hereditary syndromes (e.g. BRCA) worth screening for.",
          "semen_cancer": "Standard baseline before treatments that can affect sperm production.",
          "dna_frag_cancer": "Chemo, radiation, and some cancers raise sperm DNA damage — worth measuring.",
          "hormone_early_menopause": "Confirms whether your ovarian function is dropping earlier than expected.",
          "fsh_early_menopause": "A high day-2 FSH is one of the clearest signs of early menopause.",
          "sonogram_fibroids": "Maps where the fibroids are and whether they touch the cavity.",
          "baseline_ultrasound_fibroids": "Sizes and locates each fibroid so your team can plan around them.",
          "hormone_ovarian_surgery": "Checks how much ovarian function remains after your procedure.",
          "thyroid_reported": "Full TSH / T3 / T4 panel — since you already have a thyroid diagnosis, monitoring matters.",
          "sonogram_tubal": "Assesses tubal patency — the standard next step when tubal issues are a concern.",
          "pgt_a_age": "At 38+, PGT-A is worth discussing with your team — the evidence is mixed but aneuploidy risk climbs sharply at this age.",
          "thrombophilia_rpl": "Antiphospholipid antibodies are one of the few reversible causes of recurrent loss.",
          "thyroid_rpl": "Even mild thyroid dysfunction significantly raises miscarriage risk.",
          "sonogram_rpl": "Checks the uterine cavity for structural causes of repeated loss.",
          "karyotype_rpl": "Parental chromosome rearrangements explain about 5% of recurrent losses.",
          "endometritis_rif": "Silent uterine inflammation is a common — and treatable — cause of implantation failure.",
          "era_rif": "Personalises transfer timing to when your lining is most receptive.",
          "dna_frag_rif": "Sperm DNA damage is a recognised RIF driver, even with normal semen analysis.",
          "sonogram_rif": "Rules out cavity issues that may only appear on saline imaging.",
          "pgt_a_rif": "Selects a chromosomally normal embryo — the biggest lever left after multiple failed transfers.",
          "carrier_ethnicity": "Because you told us your background, expanded screening for higher-frequency conditions is worth doing.",
          "karyotype_ethnicity": "Some backgrounds carry higher rates of chromosomal rearrangements — worth ruling out."
        },
        "detail": {
          "amh_baseline": "Because you're just getting started, AMH is the fastest, gentlest way to get a snapshot of your egg supply. It's a single blood draw, works on any cycle day, and is the marker most clinics anchor a stimulation plan around. Guideline: ASRM Committee Opinion 2020 on ovarian reserve testing.",
          "afc_baseline": "Pairing AFC with AMH is the gold standard: AMH tells you the hormone story, AFC lets your clinician actually count follicles on ultrasound. Together they're far more accurate than either alone at predicting how you'll respond to stimulation. Guideline: ASRM Committee Opinion 2020.",
          "semen_baseline": "Every male fertility evaluation starts here. WHO's 6th edition manual defines the reference values every lab uses, and a single sample gives your clinician the concentration, motility, and morphology data they need before recommending anything else. Guideline: WHO Laboratory Manual for Human Semen 2021.",
          "dna_frag_varicocele": "Because a varicocele is in your record, the risk of sperm DNA fragmentation is higher than a standard semen analysis can show. Elevated fragmentation is linked to lower fertilisation rates and recurrent pregnancy loss, and varicoceles are often treatable. Guideline: Agarwal et al., World J Mens Health 2020;38(4):412-471.",
          "dna_frag_rpl": "The 2024 AUA/ASRM male infertility guideline specifically recommends sperm DNA fragmentation testing for couples with a history of recurrent pregnancy loss. Elevated fragmentation is one of the treatable male contributors to recurrent loss, and finding it changes options (ICSI, testicular sperm, antioxidants). Guideline: AUA/ASRM Male Infertility Guideline (2020, amended 2024).",
          "hormone_pcos": "Since PCOS is in your history, a full hormone panel (LH, FSH, total & free testosterone, SHBG, DHEA-S) lets your clinician confirm the diagnosis and rule out mimics like non-classical CAH or thyroid disease. It's also what guides medication choice if you need it. Guideline: ESHRE 2023 International PCOS Guideline.",
          "tracker_pcos": "PCOS often means unpredictable — or absent — ovulation. Continuous tracking picks up the actual cycle pattern (LH surges, temperature, hormone trends) so you and your clinician know whether ovulation is happening and, if so, when. Guideline: ESHRE 2023 International PCOS Guideline.",
          "sonogram_endo": "Because endometriosis is in your history, a saline sonogram gives a clearer view of the uterine cavity than a standard ultrasound — it's the best way to spot polyps, fibroids, adhesions, or endometriotic changes that could interfere with implantation. Guideline: ESHRE 2022 Endometriosis Guideline.",
          "endometritis_endo": "Chronic endometritis (a low-grade uterine lining inflammation) is more common alongside endometriosis and can quietly reduce implantation rates. Treating it is straightforward once diagnosed. Guideline: ESHRE 2022 Endometriosis Guideline.",
          "hormone_low_reserve": "With a low ovarian reserve concern, day 2–4 FSH and estradiol add crucial context to your AMH and AFC results — they tell your clinician whether your ovaries are working harder to recruit follicles, which changes protocol choices. Guideline: ASRM 2020 ovarian reserve testing.",
          "thyroid_age": "Subclinical thyroid dysfunction becomes more common past 35, and even mildly elevated TSH is linked to lower fertility and higher miscarriage rates. A simple blood test catches it early. Guideline: ATA 2026 Guidelines for Thyroid Disease in Preconception, Pregnancy, and Postpartum (supersedes ATA 2017).",
          "prolactin_irregular": "Because your cycles are irregular, checking prolactin rules in — or out — one of the most common, easily-treated causes. Elevated prolactin suppresses ovulation and responds well to medication. Guideline: ASRM 2021 Fertility Evaluation of Infertile Women — Committee Opinion.",
          "thyroid_irregular": "Thyroid dysfunction is one of the top endocrine causes of irregular cycles. Because your cycles are irregular, a TSH-first thyroid panel is a high-yield next step. Guideline: ASRM 2021 Fertility Evaluation of Infertile Women.",
          "carrier_planned_cycle": "Since you're planning a cycle, expanded carrier screening for both partners is the standard-of-care step to identify recessive conditions worth knowing about before conception. It's a one-time test with lifelong information. Guideline: ACOG Committee Opinion 691 (2017).",
          "infectious_planned_cycle": "Most fertility clinics require an up-to-date infectious disease panel (HIV, Hep B/C, syphilis, HTLV) before starting IVF or IUI — running it early avoids delaying your cycle. Guideline: ASRM 2019 Fertility Evaluation.",
          "lining_ivf": "Because IVF is in your plan, endometrial thickness and pattern immediately before transfer are among the strongest short-term predictors of implantation. A lining check is quick and directly informs transfer timing. Guideline: ASRM 2021 Fertility Evaluation of Infertile Women.",
          "hormone_egg_freezing": "For egg freezing, day 2–4 hormones (FSH, LH, estradiol) directly shape your stimulation protocol dose and predict your expected egg yield. They're worth getting locked in before any medications start. Guideline: ASRM 2020 on ovarian reserve testing.",
          "amh_cancer": "Because a cancer history is in your record, an early AMH gives you and your team a baseline to compare against once treatment starts — many chemotherapy and radiation protocols directly impact ovarian reserve, and knowing where you stand now is critical for any fertility-preservation decision. Guideline: ASRM 2020 ovarian reserve testing.",
          "afc_cancer": "Pairing AFC with AMH is even more important with a cancer history because it captures the picture visually before any treatment starts affecting follicle counts. Both give your team the numbers needed to advise on fertility preservation quickly. Guideline: ASRM 2020.",
          "hormone_cancer": "Day 2–4 FSH and estradiol let your team see how your ovaries are functioning right now, which matters before any treatment that could damage them. It also flags subtle changes chemo may have already caused. Guideline: ASRM 2020.",
          "carrier_cancer": "Some cancer histories — particularly breast, ovarian, or early-onset — overlap with hereditary syndromes like BRCA1/BRCA2 or Lynch. Expanded carrier and hereditary cancer screening is worth doing when planning a family. Guideline: ACOG Committee Opinion 691 (2017).",
          "semen_cancer": "Because a cancer history is in your record, establishing a semen analysis baseline early matters — many treatments (chemo, radiation, surgery near reproductive organs) can reduce sperm production temporarily or permanently, and a baseline lets your team compare later. Guideline: WHO Laboratory Manual 2021.",
          "dna_frag_cancer": "Cancer treatments — especially chemotherapy and radiation — significantly raise sperm DNA fragmentation for months to years afterward, even when a standard semen analysis looks normal. Measuring fragmentation gives your team a truer picture of sperm quality. Guideline: AUA/ASRM Male Infertility Guideline (2020, amended 2024); Agarwal et al., World J Mens Health 2020.",
          "hormone_early_menopause": "You mentioned an early menopause concern — a full hormone panel (FSH, LH, estradiol on day 2–4) is the clearest way to confirm or rule out premature ovarian insufficiency. Catching it early opens more preservation options. Guideline: ASRM 2020.",
          "fsh_early_menopause": "A specifically-timed day 2–4 FSH is one of the most sensitive markers of premature ovarian insufficiency — often elevated well before AMH or AFC decline become obvious. Guideline: ASRM 2020.",
          "sonogram_fibroids": "Because you mentioned fibroids, a saline sonogram is the gold standard to map exactly where they sit — especially whether any distort the uterine cavity, which is the type most likely to reduce fertility. Guideline: ASRM 2021 Fertility Evaluation of Infertile Women — Committee Opinion.",
          "baseline_ultrasound_fibroids": "A standard pelvic ultrasound sizes and locates each fibroid, giving your team enough information to advise on whether they need treatment before a cycle or can be left alone. Guideline: ASRM 2021 Fertility Evaluation of Infertile Women.",
          "hormone_ovarian_surgery": "Because you had ovarian surgery, day 2–4 FSH and estradiol give your team a functional check — surgery can reduce ovarian reserve even when AMH looks reasonable, and hormones catch subtle drops. Guideline: ASRM 2020 ovarian reserve testing.",
          "thyroid_reported": "Since you already have a thyroid diagnosis, keeping TSH — and ideally free T3/T4 with thyroid antibodies — well-controlled is one of the highest-impact things you can do for fertility. Even mild dysregulation lowers conception rates and raises miscarriage risk. Guideline: ATA 2026 Guidelines for Thyroid Disease in Preconception, Pregnancy, and Postpartum (supersedes ATA 2017).",
          "sonogram_tubal": "Because tubal issues are a concern, a saline sonogram (or HSG) is the standard next step to check whether both tubes are open. Blocked tubes are one of the most common — and most treatable — infertility causes. Guideline: ASRM 2021 Fertility Evaluation of Infertile Women — Committee Opinion.",
          "pgt_a_age": "Because you're planning IVF at 38 or older, PGT-A is a decision worth having with your care team. Aneuploidy in embryos rises sharply with maternal age — over 50% at 40 and over 75% at 43 — and PGT-A can reduce time-to-pregnancy and miscarriage risk in this range. That said, the 2024 ASRM Committee Opinion is deliberately cautious: routine PGT-A has not been shown superior for everyone, and it's explicitly not recommended based on paternal age alone. Guideline: ASRM Committee Opinion on the use of PGT-A (2024, Fertil Steril; supersedes 2018).",
          "thrombophilia_rpl": "Because you've had 2 or more pregnancy losses, screening for antiphospholipid syndrome — lupus anticoagulant, anticardiolipin antibodies, and anti-β2-glycoprotein I — is standard workup. It's one of the few identifiable and treatable causes of recurrent loss, and finding it changes management (low-dose aspirin ± heparin in a next pregnancy). Guideline: ESHRE 2022 Recurrent Pregnancy Loss Guideline (Bender Atik et al., Hum Reprod Open).",
          "thyroid_rpl": "Both overt and subclinical thyroid dysfunction — as well as thyroid autoimmunity (TPO antibodies) — significantly raise the risk of miscarriage. Because you've had recurrent loss, a full thyroid panel including TPO-Ab is one of the highest-yield tests. Guideline: ESHRE 2022 RPL Guideline.",
          "sonogram_rpl": "Structural uterine anomalies — septate uterus, submucosal fibroids, polyps, or adhesions — are found in around 15% of women with recurrent pregnancy loss and are often treatable. A saline sonogram is the standard first-line cavity assessment. Guideline: ASRM Committee Opinion 2020 on Recurrent Pregnancy Loss (Fertil Steril 2020;113:533-535).",
          "karyotype_rpl": "Balanced chromosomal rearrangements in one parent account for roughly 3–5% of couples with recurrent pregnancy loss. Even though the finding rate is modest, the result changes counselling and IVF planning (including whether PGT-SR becomes relevant). Guideline: ASRM 2020 RPL Committee Opinion.",
          "endometritis_rif": "Because you've had multiple failed transfers, chronic endometritis (low-grade uterine lining inflammation, often symptomless) is now recognised as one of the most common and most treatable RIF causes — with 20–40% prevalence in RIF populations in recent reviews. A single course of antibiotics reverses it. Guideline: ESHRE 2023 Good Practice Recommendations on Recurrent Implantation Failure (Cimadomo et al., Hum Reprod Open 2023;hoad023).",
          "era_rif": "An endometrial receptivity test (ERA / ER-Peak / beReady) checks whether your window of implantation aligns with a standard transfer timing — a mismatch in 25–30% of RIF cases. Personalising transfer timing has moved from experimental to recommended in this population. Guideline: ESHRE 2023 RIF Recommendations.",
          "dna_frag_rif": "Sperm DNA fragmentation is a recognised RIF driver even when a standard semen analysis is normal, especially with prior failed transfers. Testing lets your team decide whether ICSI, testicular sperm, or antioxidant intervention should be added. Guideline: ESHRE 2023 RIF Recommendations; Agarwal et al., World J Mens Health 2020.",
          "sonogram_rif": "Cavity distortions that don't show on a standard scan — subtle polyps, adhesions, or septae — are more prevalent after multiple failed transfers. Saline sonography (or hysteroscopy) is the standard cavity re-assessment. Guideline: ESHRE 2023 RIF Recommendations.",
          "pgt_a_rif": "After 3 or more failed transfers of morphologically good embryos, aneuploidy remains the single largest identifiable driver — and PGT-A now offers your team a way to select a chromosomally-normal embryo, particularly if you're 35+. Guideline: ESHRE 2023 RIF Recommendations; ASRM 2018 Committee Opinion on PGT-A.",
          "carrier_ethnicity": "Because you shared your ethnicity, expanded (pan-ethnic) carrier screening is worth doing before pregnancy. Modern guidelines now recommend expanded screening for everyone considering conception — but certain backgrounds (e.g. Ashkenazi Jewish, African, Mediterranean, Southeast Asian, French Canadian) carry higher frequencies of specific recessive conditions worth flagging. Guideline: ACMG 2021 Practice Resource on Carrier Screening (Gregg et al., Genet Med 2021;23:1793-1806); ACOG Committee Opinion 690 (2017, reaffirmed 2023).",
          "karyotype_ethnicity": "Some backgrounds carry higher rates of balanced chromosomal rearrangements. A one-time karyotype paired with your expanded carrier screening rounds out the pre-conception genetic picture. Guideline: ACOG Committee Opinion 691 (2017, reaffirmed 2023)."
        }
      },
      "sections": {
        "ovarian_reserve_title": "Ovarian Reserve",
        "ovarian_reserve_desc": "Understand your egg supply",
        "semen_analysis_title": "Semen Analysis",
        "semen_analysis_desc": "Evaluate sperm health",
        "cycle_monitoring_title": "Cycle Monitoring",
        "cycle_monitoring_desc": "Track ovulation & hormones",
        "genetic_screening_title": "Genetic Screening",
        "genetic_screening_desc": "Screen for genetic conditions",
        "implantation_title": "Implantation",
        "implantation_desc": "Optimize your transfer window"
      },
      "guides": {
        "fertility": {
          "label": "Am I fertile?",
          "subtitle": "Ovarian reserve & sperm health",
          "overview": "Fertility testing is usually a panel, not one result. It combines egg-supply markers, cycle hormones, ultrasound findings, and sperm testing when sperm is part of the plan.",
          "detail_1_title": "What this can answer",
          "detail_1_body": "These tests can show whether ovarian reserve looks high, low, or expected for age, whether sperm parameters may affect fertilization, and whether more clinic-led evaluation is worth doing before treatment.",
          "detail_2_title": "What it cannot answer alone",
          "detail_2_body": "A normal panel does not guarantee pregnancy, and an abnormal marker does not mean pregnancy is impossible. Results are most useful when interpreted with age, cycle history, diagnosis, and treatment goals."
        },
        "amh": {
          "label": "What does AMH mean?",
          "subtitle": "Egg supply markers",
          "overview": "AMH is one marker of ovarian reserve. It is often used to estimate how the ovaries may respond to stimulation, especially for IVF or egg freezing planning.",
          "detail_1_title": "How to use it",
          "detail_1_body": "AMH is most useful beside an antral follicle count, age, cycle regularity, and prior response to medication. It helps with dose planning and expectations around egg yield.",
          "detail_2_title": "Common misunderstanding",
          "detail_2_body": "AMH is not a direct measure of egg quality and should not be treated as a simple yes-or-no fertility score."
        },
        "sperm": {
          "label": "Is sperm a factor?",
          "subtitle": "Semen analysis & DNA damage",
          "overview": "Sperm testing starts with count, motility, morphology, and volume. If results are abnormal, or there is recurrent loss or failed fertilization, DNA fragmentation may add useful context.",
          "detail_1_title": "First-line testing",
          "detail_1_body": "A standard semen analysis is usually the first step because it is relatively fast and can reveal whether sperm concentration, movement, or shape may affect treatment choices.",
          "detail_2_title": "When to go deeper",
          "detail_2_body": "DNA fragmentation testing is more specific. It may be considered when standard results do not explain the clinical picture, or when there are repeated losses or embryo development concerns."
        },
        "ovulation": {
          "label": "Am I ovulating?",
          "subtitle": "Cycle hormones & timing",
          "overview": "Ovulation testing looks at whether a follicle is developing, whether the LH surge happens, and whether progesterone rises afterward.",
          "detail_1_title": "What to check",
          "detail_1_body": "Useful signals can include LH patterns, estradiol, progesterone after ovulation, and ultrasound monitoring if you are in a medicated or treatment cycle.",
          "detail_2_title": "Why timing matters",
          "detail_2_body": "The same hormone can mean different things depending on cycle day. This is why cycle context is just as important as the number itself."
        },
        "embryo_testing": {
          "label": "Should we test embryos?",
          "subtitle": "PGT & carrier screening",
          "overview": "Genetic testing can happen before pregnancy, during IVF, or on embryos. The right option depends on whether you are screening carrier status, chromosomes, or a known inherited condition.",
          "detail_1_title": "Different tests answer different questions",
          "detail_1_body": "Carrier screening looks at inherited conditions in the parents. PGT-A looks at embryo chromosome copy number. PGT-M and PGT-SR are used for specific genetic or chromosomal risks.",
          "detail_2_title": "What to discuss with your clinic",
          "detail_2_body": "Ask what the result would change. Some genetic tests guide embryo selection, while others guide counseling, partner testing, or whether a custom probe is needed."
        },
        "uterus": {
          "label": "Could my uterus be the issue?",
          "subtitle": "Lining & transfer window",
          "overview": "Uterine and implantation testing looks at the cavity, lining development, inflammation or microbiome signals, and sometimes transfer timing.",
          "detail_1_title": "Start with structure",
          "detail_1_body": "A cavity evaluation can look for polyps, fibroids, adhesions, or fluid that might interfere with implantation or increase miscarriage risk.",
          "detail_2_title": "Add-ons need context",
          "detail_2_body": "Tests like ERA or EMMA/ALICE may be discussed after failed transfers or specific symptoms, but they are not the same as first-line cavity and lining checks."
        },
        "at_home": {
          "label": "Can I test at home?",
          "subtitle": "Hormone & semen kits",
          "overview": "At-home kits can be useful for a first read on hormones, ovulation patterns, or semen parameters, especially before booking a clinic appointment.",
          "detail_1_title": "Where they help",
          "detail_1_body": "They can lower friction, give you a baseline, and help you decide what to ask a clinician. Some kits include lab processing and clinician-reviewed reports.",
          "detail_2_title": "Where they are limited",
          "detail_2_body": "At-home testing cannot replace ultrasound, a full infertility workup, or clinic-specific labs needed before IVF, IUI, or embryo transfer."
        },
        "baseline": {
          "label": "Am I ready for treatment?",
          "subtitle": "Baseline labs & timing",
          "overview": "Before a treatment cycle, clinics often need baseline imaging, bloodwork, infectious disease screening, and sometimes genetic or uterine evaluation.",
          "detail_1_title": "What readiness usually means",
          "detail_1_body": "The goal is to confirm there are no cysts or unexpected hormone levels, that required safety labs are complete, and that timing fits the planned cycle.",
          "detail_2_title": "Why the list varies",
          "detail_2_body": "A retrieval, IUI, embryo transfer, donor cycle, or recurrent-loss workup can each require a different panel. Your clinic will decide what is mandatory versus optional."
        }
      },
      "comparison": {
        "at_a_glance": "At a glance",
        "your_results": "Your results",
        "connected_markers": "Connected markers",
        "blood_test": "Blood test",
        "also_available_at_home": "Also available at home",
        "amh_subtitle": "Anti-Müllerian hormone, usually to measure egg reserve.",
        "get_tested": "Get tested",
        "get_tested_short": "Test",
        "go_to_results": "Go to results",
        "markers_tracked": "Biomarkers tracked",
        "markers_tracked_count": "${count} Biomarkers tracked",
        "external_option": "External option",
        "included_in": "These markers are also included in:",
        "add_result": "Add result",
        "add_result_description": "There's no AMH test logged on your profile yet.",
        "test_not_logged_description": "There's no ${marker} test logged on your profile yet.",
        "get_tested_description": "Compare in-lab and at-home options.",
        "no_result_body": "No ${marker} result is connected yet. Add or upload a result to see its value and history here.",
        "panel_no_result_value": "Not logged",
        "panel_marker_not_logged": "No ${marker} result is logged yet.",
        "panel_overview_summary": "${completed} of ${total} biomarkers have results · Latest ${marker}",
        "panel_no_marker_result_title": "No ${marker} result yet",
        "panel_add_result_body": "Add a result from this panel or upload the source report.",
        "panel_no_results_body": "No results from this panel are logged on your profile yet.",
        "panel_results_summary": "Review each marker separately so the values keep their own units, ranges, and timing.",
        "panel_view_values": "View values",
        "panel_related_tests_body": "Review the individual markers or related panels below.",
        "panel_parameter_count": "${count} parameters",
        "semen_panel_options_body": "Choose a semen panel and see which parameters it includes before ordering through Louise.",
        "pgt_types_description": "PGT is an umbrella category. These related types answer different genetic questions from embryo biopsy material.",
        "pgt_commercial_options_description": "These commercial options offer this PGT type through a clinic or partner lab. Compare what each profile includes before arranging testing.",
        "pgt_commercial_options_empty": "Commercial options for this PGT type are being added."
      }
    },
    "programs": {
      "back": "Access",
      "title": "Programs",
      "subtitle": "Step-by-step fertility plans that combine testing, treatment, and support.",
      "filter_all": "All",
      "filter_assessment": "Assessment",
      "filter_optimization": "Optimization",
      "filter_treatment": "Treatment",
      "filter_support": "Support",
      "category_assessment": "Assessment",
      "category_optimization": "Optimization",
      "category_treatment": "Treatment",
      "category_support": "Support",
      "for_whom_her": "Her",
      "for_whom_him": "Him",
      "for_whom_both": "Her & Him",
      "price_from": "From",
      "open_a11y": "Open ${title}",
      "hero_recommended_eyebrow": "Recommended for you",
      "hero_find_eyebrow": "Find your program",
      "hero_fallback_title": "Tell us your goals",
      "hero_fallback_subtitle": "Answer a few questions so we can recommend the best program for you",
      "detail_category": {
        "assessment": "Assessment program",
        "optimization": "Optimization program",
        "treatment": "Treatment program",
        "support": "Support program",
        "default": "Program"
      },
      "module_title_overrides": {
        "female_hormone_baseline": "Hormone panel and ultrasound",
        "male_fertility_baseline": "Semen testing",
        "female_optimization": "Egg quality support",
        "male_optimization": "Sperm health support"
      }
    },
    "supplements": {
      "title": "Supplements",
      "subtitle": "Evidence-based protocols to support your fertility journey",
      "search_placeholder": "Search supplements...",
      "for_whom": {
        "her": "For Her",
        "him": "For Him",
        "both": "For Both"
      },
      "goal": {
        "egg_quality": "Egg Quality",
        "sperm_health": "Sperm Health",
        "pcos_support": "PMOS (ex PCOS) Support",
        "pre_ivf": "Pre-IVF Prep",
        "implantation": "Implantation",
        "stress_support": "Stress Support",
        "antioxidant": "Antioxidant",
        "general_wellness": "General Wellness"
      },
      "evidence": {
        "strong": "Strong evidence",
        "moderate": "Moderate evidence",
        "emerging": "Emerging",
        "mixed": "Mixed evidence",
        "debunked": "Not supported"
      },
      "for_you": "For you",
      "hero": {
        "eyebrow": "Personalised protocol",
        "title": "Unlock your recommended supplement stack",
        "with_count": "${count} supplements match your current profile. Review them with your clinician before starting anything.",
        "without_count": "See a personalized shortlist built from your goals, conditions, and cycle timing before buying anything.",
        "cta_show_all": "Show all supplements",
        "cta_view_stack": "View my stack",
        "cta_unlock": "Complete profile to unlock"
      },
      "empty": "No supplements match your search or filters",
      "food_info": {
        "label": {
          "organ_meats": "Organ meats",
          "sardines": "Sardines",
          "broccoli": "Broccoli",
          "cauliflower": "Cauliflower",
          "fatty_fish": "Fatty fish",
          "egg_yolks": "Egg yolks",
          "fortified_milk": "Fortified milk",
          "mushrooms": "Mushrooms",
          "salmon": "Salmon",
          "walnuts": "Walnuts",
          "flaxseeds": "Flaxseeds",
          "leafy_greens": "Leafy greens",
          "legumes": "Legumes",
          "citrus_fruits": "Citrus fruits",
          "fortified_grains": "Fortified grains",
          "fortified_cereals": "Fortified cereals",
          "chicken": "Chicken",
          "turkey": "Turkey",
          "garlic": "Garlic",
          "onions": "Onions",
          "cruciferous_vegetables": "Cruciferous vegetables",
          "oysters": "Oysters",
          "red_meat": "Red meat",
          "fish": "Fish",
          "poultry": "Poultry",
          "pumpkin_seeds": "Pumpkin seeds",
          "chickpeas": "Chickpeas",
          "milk": "Milk",
          "avocado": "Avocado",
          "brazil_nuts": "Brazil nuts",
          "tuna": "Tuna",
          "eggs": "Eggs",
          "sunflower_seeds": "Sunflower seeds",
          "beans": "Beans",
          "brown_rice": "Brown rice",
          "cantaloupe": "Cantaloupe",
          "bell_peppers": "Bell peppers",
          "strawberries": "Strawberries",
          "kiwi": "Kiwi",
          "tomatoes": "Tomatoes",
          "almonds": "Almonds",
          "spinach": "Spinach",
          "tart_cherries": "Tart cherries",
          "pistachios": "Pistachios",
          "goji_berries": "Goji berries",
          "lentils": "Lentils",
          "dark_chocolate": "Dark chocolate",
          "red_grapes": "Red grapes",
          "blueberries": "Blueberries",
          "peanuts": "Peanuts",
          "turmeric_root": "Turmeric root",
          "curry_powder": "Curry powder",
          "yogurt": "Yogurt",
          "kefir": "Kefir",
          "sauerkraut": "Sauerkraut",
          "kimchi": "Kimchi"
        },
        "serving": {
          "organ_meats": "85g beef heart",
          "sardines": "85g canned sardines",
          "broccoli": "1 cup cooked (156g)",
          "cauliflower": "1 cup cooked (124g)",
          "fatty_fish": "85g salmon or mackerel",
          "egg_yolks": "1 large egg yolk",
          "fortified_milk": "1 cup (240ml)",
          "mushrooms": "1 cup UV-exposed (70g)",
          "salmon": "85g wild salmon",
          "walnuts": "30g (1/4 cup)",
          "flaxseeds": "1 tablespoon ground",
          "leafy_greens": "1 cup raw spinach (30g)",
          "legumes": "1 cup cooked lentils (198g)",
          "citrus_fruits": "1 medium orange",
          "fortified_grains": "1 cup fortified cereal",
          "fortified_cereals": "1 cup fortified cereal",
          "chicken": "85g cooked breast",
          "turkey": "85g cooked turkey",
          "garlic": "3 cloves (9g)",
          "onions": "1 medium onion (110g)",
          "cruciferous_vegetables": "1 cup cooked (156g)",
          "oysters": "6 medium oysters (85g)",
          "red_meat": "85g cooked beef",
          "fish": "85g cooked fish",
          "poultry": "85g cooked chicken or turkey",
          "pumpkin_seeds": "30g (1/4 cup)",
          "chickpeas": "1 cup cooked (164g)",
          "milk": "1 cup (240ml)",
          "avocado": "1 medium avocado (150g)",
          "brazil_nuts": "1-2 nuts (5g)",
          "tuna": "85g canned tuna",
          "eggs": "1 large egg",
          "sunflower_seeds": "30g (1/4 cup)",
          "beans": "1 cup cooked (177g)",
          "brown_rice": "1 cup cooked (195g)",
          "cantaloupe": "1 cup diced (160g)",
          "bell_peppers": "1 medium red bell pepper (119g)",
          "strawberries": "1 cup (152g)",
          "kiwi": "1 medium kiwi (69g)",
          "tomatoes": "1 medium tomato (123g)",
          "almonds": "30g (about 23 almonds)",
          "spinach": "1 cup cooked (180g)",
          "tart_cherries": "1 cup juice (240ml)",
          "pistachios": "30g (about 49 nuts)",
          "goji_berries": "30g dried",
          "lentils": "1 cup cooked (198g)",
          "dark_chocolate": "30g (70%+ cacao)",
          "red_grapes": "1 cup (151g)",
          "blueberries": "1 cup (148g)",
          "peanuts": "30g (about 1/4 cup)",
          "turmeric_root": "1 tablespoon grated (about 7g)",
          "curry_powder": "1 teaspoon (about 2g)",
          "yogurt": "1 cup (245g)",
          "kefir": "1 cup (240ml)",
          "sauerkraut": "1/2 cup (75g)",
          "kimchi": "1/2 cup (75g)"
        },
        "amount": {
          "organ_meats": "~113mg CoQ10",
          "sardines": "~6mg CoQ10 / ~1.4g Omega-3",
          "broccoli": "~0.6mg CoQ10",
          "cauliflower": "~0.4mg CoQ10",
          "fatty_fish": "~600-1,000 IU Vitamin D",
          "egg_yolks": "~40 IU Vitamin D",
          "fortified_milk": "~120 IU Vitamin D",
          "mushrooms": "~400 IU Vitamin D",
          "salmon": "~1.5g Omega-3",
          "walnuts": "~2.5g ALA (plant Omega-3)",
          "flaxseeds": "~2.3g ALA",
          "leafy_greens": "~58mcg folate",
          "legumes": "~358mcg folate",
          "citrus_fruits": "~40mcg folate",
          "fortified_grains": "~400mcg folic acid",
          "fortified_cereals": "~400mcg folic acid",
          "chicken": "~1.5mg NAC precursors",
          "turkey": "~1.8mg NAC precursors",
          "garlic": "Trace sulfur compounds",
          "onions": "Trace sulfur compounds",
          "cruciferous_vegetables": "Trace sulfur compounds",
          "oysters": "~32mg zinc",
          "red_meat": "~5mg zinc / ~56mg L-carnitine",
          "fish": "~0.3-0.8g creatine",
          "poultry": "~0.2-0.4g creatine",
          "pumpkin_seeds": "~2.2mg zinc",
          "chickpeas": "~2.5mg zinc",
          "milk": "~8mg L-carnitine",
          "avocado": "~2mg L-carnitine",
          "brazil_nuts": "~68-91mcg selenium",
          "tuna": "~92mcg selenium",
          "eggs": "~15mcg selenium",
          "sunflower_seeds": "~19mcg selenium",
          "beans": "~30mg myo-inositol",
          "brown_rice": "~44mg myo-inositol",
          "cantaloupe": "~355mg myo-inositol",
          "bell_peppers": "~152mg vitamin C",
          "strawberries": "~89mg vitamin C",
          "kiwi": "~64mg vitamin C",
          "tomatoes": "Trace alpha-lipoic acid",
          "almonds": "~7.3mg vitamin E",
          "spinach": "~3.7mg vitamin E / ~157mg magnesium",
          "tart_cherries": "~0.1mg melatonin",
          "pistachios": "~0.23mg melatonin",
          "goji_berries": "Trace melatonin",
          "lentils": "~6.6mg iron",
          "dark_chocolate": "~3.3mg iron / ~64mg magnesium",
          "red_grapes": "Small amounts of resveratrol",
          "blueberries": "Trace resveratrol",
          "peanuts": "Trace resveratrol",
          "turmeric_root": "Variable curcumin content",
          "curry_powder": "Small amounts of curcumin",
          "yogurt": "~1-10 billion CFU",
          "kefir": "~10-50 billion CFU",
          "sauerkraut": "~1-10 billion CFU",
          "kimchi": "~1-10 billion CFU"
        },
        "note": {
          "organ_meats": "Organ meats are the richest food source, but most people would need 3-5 servings daily to reach therapeutic doses (400-600mg). Supplementation is far more practical.",
          "sardines": "A great source of both CoQ10 and Omega-3, but CoQ10 content is low relative to supplement doses. For Omega-3, 2-3 servings of fatty fish per week can meaningfully contribute.",
          "broccoli": "Contains trace amounts of CoQ10. Valuable for fiber and other nutrients, but not a meaningful source for therapeutic CoQ10 levels.",
          "cauliflower": "Similar to broccoli, cauliflower contains very small amounts. You would need hundreds of servings to match a single supplement dose.",
          "fatty_fish": "One of the best natural sources of Vitamin D. A single serving of salmon can provide 600-1,000 IU, which approaches the daily recommended amount. Regular fish consumption can reduce the need for supplementation.",
          "egg_yolks": "Eggs provide small amounts of Vitamin D. You would need 50-100 eggs daily to reach therapeutic doses, making supplementation necessary for most people.",
          "fortified_milk": "Fortified dairy provides a moderate amount. 3-4 cups daily approaches the lower end of recommended intake, but supplementation is usually needed to reach optimal levels.",
          "mushrooms": "UV-exposed mushrooms are surprisingly rich in Vitamin D2 (not D3). While helpful, D3 from supplements or animal sources is more effectively used by the body.",
          "salmon": "Wild salmon is one of the richest Omega-3 sources. Two servings per week provides meaningful EPA/DHA. Farm-raised salmon has less Omega-3 but is still beneficial.",
          "walnuts": "Walnuts are rich in ALA, a plant-based Omega-3. However, the body converts only 5-10% of ALA to EPA/DHA, so walnuts alone are not a substitute for fish oil or supplements.",
          "flaxseeds": "Very high in ALA, but the same low conversion to EPA/DHA applies. Best used alongside direct sources of EPA/DHA rather than as a replacement.",
          "leafy_greens": "Leafy greens are a good source of natural folate, but cooking reduces content by 40-50%. Reaching 800mcg from food alone would require very large daily portions.",
          "legumes": "Lentils and beans are among the richest folate foods. Two cups daily could approach supplement doses, but bioavailability of food folate is ~50% compared to supplements.",
          "citrus_fruits": "A modest source of folate. You would need ~20 oranges daily to match a supplement dose. Better as part of a varied diet alongside supplementation.",
          "fortified_grains": "Fortified grains use folic acid (synthetic form). If you have MTHFR variants (30-40% of women), your body may not convert folic acid efficiently — methylfolate supplements bypass this.",
          "fortified_cereals": "Same as fortified grains — uses synthetic folic acid which may not be ideal for everyone. Check for MTHFR variants with your doctor.",
          "chicken": "Contains cysteine, the amino acid precursor to NAC. Protein-rich foods help your body produce glutathione naturally, but not at therapeutic supplement levels.",
          "turkey": "Slightly higher in cysteine than chicken. Good for general glutathione support but cannot replace NAC supplementation for targeted antioxidant therapy.",
          "garlic": "Contains allicin and sulfur compounds that support glutathione production. Beneficial for general antioxidant support but not a substitute for NAC.",
          "onions": "Similar to garlic, provides sulfur compounds. Best as part of a varied diet rather than a targeted nutrient source.",
          "cruciferous_vegetables": "Broccoli, cauliflower, and Brussels sprouts support the body's detoxification pathways. Complementary to NAC but not a replacement.",
          "oysters": "By far the richest food source of zinc. A single serving exceeds the daily requirement. However, most people don't eat oysters regularly enough for consistent intake.",
          "red_meat": "A good source of both zinc and L-carnitine. Regular moderate consumption contributes meaningfully, but supplement doses of L-carnitine (2-3g) far exceed what food provides.",
          "fish": "Fish naturally contains creatine, with oily fish often providing meaningful amounts. Even so, reaching common supplement doses of 3-5g daily from fish alone would require large daily portions.",
          "poultry": "Poultry contributes some creatine and high-quality protein. It supports dietary intake, but it does not approach the standardized dose used in most creatine supplementation protocols.",
          "pumpkin_seeds": "A plant-based zinc source, though bioavailability is lower than animal sources due to phytates. Good for snacking but not sufficient as a sole zinc source.",
          "chickpeas": "Moderate zinc content with the same phytate caveat as other legumes. Soaking and cooking improves absorption. A useful part of a zinc-rich diet.",
          "milk": "Contains small amounts of L-carnitine. You would need over 250 cups daily to reach supplement doses, making supplementation the practical choice.",
          "avocado": "Trace L-carnitine content. Valuable for healthy fats and overall nutrition, but not a meaningful source for targeted supplementation.",
          "brazil_nuts": "Extraordinarily rich in selenium. Just 1-2 Brazil nuts per day can meet the full daily requirement. Be careful not to overdo it — selenium toxicity is possible with excess.",
          "tuna": "An excellent selenium source. One serving provides the full daily requirement. Also contains Omega-3, making it a double benefit for male fertility.",
          "eggs": "A modest selenium source. Several eggs daily contribute, but Brazil nuts or seafood are far more efficient for meeting selenium needs.",
          "sunflower_seeds": "A reasonable plant-based selenium source. Combined with other selenium-rich foods, they can contribute meaningfully to daily intake.",
          "beans": "Contains myo-inositol but at levels far below therapeutic doses (2-4g). Food sources alone cannot replace supplementation for PMOS (ex PCOS) management.",
          "brown_rice": "One of the richer food sources of inositol, but still a fraction of the 2-4g therapeutic dose. Supplementation is needed for clinical effects.",
          "cantaloupe": "Among the highest food sources of myo-inositol. Even so, you would need 6-12 cups daily to reach supplement doses.",
          "bell_peppers": "One of the richest vitamin C sources — more than oranges. A single pepper can provide the full daily minimum. Raw is best, as cooking reduces content.",
          "strawberries": "A delicious source of vitamin C. Two cups provides a good daily dose, though supplement levels (500-1,000mg) would require much more.",
          "kiwi": "Surprisingly dense in vitamin C. Two kiwis per day provides a solid natural dose and also supports gut health through fiber and enzymes.",
          "tomatoes": "Tomatoes contain small amounts of alpha-lipoic acid along with antioxidants like lycopene. They are useful as part of an antioxidant-rich diet, but not a practical source for therapeutic ALA dosing.",
          "almonds": "One of the best food sources of vitamin E. A handful provides about half the daily requirement. Also rich in magnesium and healthy fats.",
          "spinach": "A good source of both vitamin E and magnesium, plus iron and folate. Cooking increases nutrient density per serving. A true fertility superfood.",
          "tart_cherries": "One of the few natural food sources of melatonin. Studies show tart cherry juice can modestly raise melatonin levels and improve sleep quality.",
          "pistachios": "The richest known food source of melatonin — significantly more than other nuts. A handful before bed may support natural melatonin production.",
          "goji_berries": "Contains small amounts of melatonin along with antioxidants. More useful as a general antioxidant food than a melatonin source.",
          "lentils": "A top plant-based iron source. However, non-heme iron from plants is absorbed at only 2-20% vs 15-35% for heme iron from meat. Pair with vitamin C to boost absorption.",
          "dark_chocolate": "A surprisingly good source of both iron and magnesium. Choose 70%+ cacao for maximum benefit. A guilt-free fertility snack in moderation.",
          "red_grapes": "Most resveratrol in grapes is concentrated in the skin. Red grapes can contribute, but the amount is much lower and more variable than a standardized resveratrol supplement.",
          "blueberries": "Blueberries provide polyphenols and antioxidant support, but only trace amounts of resveratrol. They are better thought of as a general antioxidant food than a therapeutic resveratrol source.",
          "peanuts": "Peanuts contain small amounts of resveratrol, especially in the skins. The dose is far below typical supplement ranges, so they are supportive rather than a replacement.",
          "turmeric_root": "Fresh turmeric contains curcuminoids, but the amount varies and absorption is naturally low. Pairing with fat and black pepper can help, but standardized extracts are more predictable.",
          "curry_powder": "Curry powder usually contains turmeric, but the turmeric percentage varies widely. It is useful for regular dietary exposure, not for matching a bioavailable curcumin supplement dose.",
          "yogurt": "Live-culture yogurt supports gut and vaginal microbiome diversity. Look for brands listing specific Lactobacillus strains. Not all yogurts contain live cultures.",
          "kefir": "Contains far more probiotic strains than yogurt — often 30+ different species. One of the most potent natural probiotic foods available.",
          "sauerkraut": "Raw, unpasteurized sauerkraut is rich in Lactobacillus. Must be refrigerated — shelf-stable versions have been heat-treated and contain no live cultures.",
          "kimchi": "Rich in Lactobacillus and other beneficial bacteria. The fermentation process also produces vitamins B and K. Choose refrigerated, unpasteurized varieties."
        }
      }
    },
    "donor_registry": {
      "title": "Donor Registry",
      "subtitle": "Find and connect with verified donors",
      "feature_browse_title": "Browse verified and screened donor profiles",
      "feature_browse_dialog_title": "Browse donor profiles",
      "feature_browse_description": "Search and filter verified egg and sperm donors by background, health history, and preferences.",
      "feature_match_title": "Get matched",
      "feature_match_dialog_title": "Find your match",
      "feature_match_description": "Our matching system recommends donors based on your criteria and medical needs.",
      "private_preview": "Private preview",
      "request_card_title": "Request access to Donor Registry",
      "request_card_body": "We're opening this to select users first, then making it easy to invite friends and partners as access expands.",
      "request_cta": "Request Access",
      "request_cta_done": "Requested",
      "preview_label": "Preview"
    },
    "therapies": {
      "title": "Therapies & Add-ons",
      "subtitle": "Compare therapies, IVF add-ons, evidence, and fit.",
      "search_placeholder": "Search therapies and add-ons...",
      "empty": "No therapies or add-ons match your search",
      "evidence_filter": {
        "all": "All evidence levels",
        "strong": "Strong",
        "moderate": "Moderate",
        "emerging": "Emerging",
        "mixed": "Mixed",
        "debunked": "Not supported"
      },
      "category": {
        "mind_body": "Mind-Body",
        "traditional": "Traditional",
        "physical": "Physical",
        "nutritional": "Nutritional",
        "lifestyle": "Lifestyle",
        "clinical": "Clinical Add-on"
      },
      "evidence_label": {
        "strong": "Strong evidence",
        "moderate": "Moderate evidence",
        "emerging": "Emerging",
        "mixed": "Mixed evidence",
        "debunked": "Not supported by evidence"
      },
      "for_whom": {
        "her": "Her",
        "him": "Him",
        "both": "Both partners"
      },
      "detail": {
        "section_how_it_works": "How it works",
        "section_research": "What the research shows",
        "section_practical": "Practical details",
        "section_what_to_expect": "What to expect",
        "section_keep_in_mind": "Keep in mind",
        "section_considerations": "Considerations",
        "section_best_for": "Best for",
        "section_supporting_supplements": "Supporting supplements",
        "section_evidence": "Evidence",
        "session_label": "Session: ${value}",
        "frequency_label": "Frequency: ${value}",
        "cost_per_session": "${low} - ${high} per session",
        "find_provider_cta": "Find a provider near me"
      }
    },
    "find_care": {
      "back": "Access",
      "title": "Find Care",
      "providers_count": "${count} providers",
      "search_placeholder": "Search by name, city, or state...",
      "location": {
        "near": "Near ${place}",
        "clear": "Clear location",
        "suggestions_label": "Search near"
      },
      "include_international_a11y": "Include international clinics",
      "empty_state": "No providers found matching your search.\nTry adjusting your filters.",
      "international_section_title": "International options",
      "international_section_count": "${count} outside ${country}",
      "quick_filter": {
        "all": "All",
        "saved": "Saved",
        "ivf": "IVF",
        "fet": "FET",
        "embryo_freezing": "Embryo Freezing",
        "egg_freezing": "Egg Freezing",
        "sperm_freezing": "Sperm Freezing",
        "iui": "IUI",
        "pgt": "PGT",
        "donor": "Donor"
      },
      "sort": {
        "label": "Sort by",
        "best_match": "Best for me",
        "nearest": "Nearest",
        "success_rate": "Success Rate",
        "most_experience": "Most Experience",
        "name": "A–Z"
      },
      "country": {
        "us": "United States",
        "fr": "France"
      },
      "sector": {
        "all": "All sectors",
        "public": "Public",
        "private": "Private"
      },
      "filters": {
        "title": "Filters",
        "include_international": "Include international clinics",
        "scope_home_plus_selected": "${country} plus selected countries",
        "scope_selected_only": "Selected international countries only",
        "scope_home_only": "${country} only",
        "accepts_insurance": "Accepts insurance",
        "clear_all": "Clear all",
        "loading_providers": "Loading providers...",
        "show_provider_one": "Show ${count} provider",
        "show_provider_other": "Show ${count} providers",
        "section": {
          "location_scope": "Location Scope",
          "treatments": "Treatments",
          "consultation_type": "Consultation Type",
          "clinic_type": "Clinic Type",
          "practice_setting": "Practice Setting",
          "specialties": "Specialties",
          "languages": "Languages",
          "inclusive_care": "Inclusive Care",
          "insurance_carrier": "Insurance Carrier",
          "fertility_benefits": "Fertility Benefits",
          "other": "Other"
        },
        "treatment": {
          "ivf_icsi": "IVF & ICSI",
          "iui": "IUI",
          "egg_freezing": "Egg Freezing",
          "embryo_freezing": "Embryo Freezing",
          "sperm_freezing": "Sperm Freezing",
          "fertility_preservation": "Fertility Preservation",
          "pgt": "PGT",
          "donor_programs": "Donor Programs",
          "surrogacy": "Surrogacy",
          "ovulation_induction": "Ovulation Induction"
        },
        "consultation": {
          "in_person": "In Person",
          "telehealth": "Telehealth"
        },
        "clinic_type": {
          "fertility_clinic": "Fertility Clinic",
          "medical_practice": "Medical Practice",
          "solo_practitioner": "Solo Practitioner",
          "wellness_provider": "Wellness Provider",
          "lab": "Lab",
          "pharmacy": "Pharmacy"
        },
        "setting": {
          "boutique": "Boutique",
          "hospital-based": "Hospital-based",
          "network-group": "Network & group"
        },
        "specialty": {
          "reproductive_endocrinology": "Reproductive Endocrinology",
          "pmos": "PMOS (ex PCOS)",
          "male_fertility": "Male Fertility",
          "egg_freezing": "Egg Freezing",
          "genetics": "Genetics",
          "fertility_acupuncture": "Fertility Acupuncture",
          "fertility_nutrition": "Fertility Nutrition",
          "urology": "Urology",
          "ob_gyn": "OB-GYN",
          "pelvic_medicine": "Pelvic Medicine",
          "microsurgery": "Microsurgery",
          "hormone_management": "Hormone Management"
        },
        "language": {
          "english": "English",
          "spanish": "Spanish",
          "mandarin": "Mandarin",
          "korean": "Korean",
          "russian": "Russian",
          "french": "French",
          "arabic": "Arabic",
          "vietnamese": "Vietnamese",
          "japanese": "Japanese",
          "portuguese": "Portuguese",
          "german": "German",
          "italian": "Italian"
        },
        "patient_group": {
          "lgbtq_friendly": "LGBTQ+ friendly",
          "lgbtqia": "LGBTQIA+",
          "single_parents": "Single Parents",
          "same_sex_couples": "Same sex couples"
        }
      },
      "empty_saved_fr": "No saved French clinics yet",
      "empty_saved_fr_hint": "Tap the heart on a clinic to save it for later",
      "empty_pgt_fr": "Only 5 French clinics offer PGT",
      "empty_pgt_fr_hint": "Make sure no other filters are restricting the list",
      "empty_donor_private_fr": "Donor programs are public-sector only in France",
      "empty_donor_private_fr_hint": "Try Public or All sectors",
      "empty_multi_filter_fr": "No clinics match all of those filters",
      "empty_multi_filter_fr_hint": "Try relaxing the sector or treatment filter"
    },
    "clinic_card": {
      "your_insurance": "In-network",
      "insurance": "Insurance",
      "also_virtual": "Virtual",
      "free_consult": "Free Consult",
      "rank_badge": "#${rank} in France"
    },
    "clinic_detail": {
      "back": "Clinics",
      "loading": "Loading provider details...",
      "load_failed": "Failed to load details.",
      "not_found": "Provider not found",
      "badge": {
        "insurance": "Accepts insurance",
        "free_consult": "Free first consult",
        "telehealth": "Telehealth",
        "military": "Military discount",
        "locations_count": "${count} locations"
      },
      "cta": {
        "schedule_consult": "Schedule a consult",
        "coming_soon": "COMING SOON",
        "schedule_consultation": "Schedule a consultation"
      },
      "action_dock": {
        "back": "Back",
        "schedule": "Schedule",
        "website": "Website",
        "note": "Note"
      },
      "section": {
        "success_rates": "Success rates",
        "cost_coverage": "Cost & coverage",
        "treatments": "Treatments & capabilities",
        "services": "Treatments & services",
        "what_people_say": "What people say",
        "location_hours": "Location & hours",
        "visit_information": "Visit information",
        "your_journey": "Your journey",
        "pricing": "Pricing",
        "treatment_pricing": "Treatment pricing",
        "accepted_insurance": "Accepted insurance",
        "accepted_insurance_benefits": "Accepted Insurance and Employer Benefits",
        "financing_options": "Financing Options",
        "take_a_look": "Take a look",
        "employer_benefits": "Employee fertility benefits",
        "medical_team": "Medical team (${count})",
        "the_facility": "The facility",
        "clinic_details": "Clinic details"
      },
      "success_modal": {
        "title": "About reported success rates",
        "what_this_shows": "What this shows",
        "data_source": "Data source",
        "national_average": "National average",
        "disclaimer": "Success rates depend on many factors and the most relevant predictor is your own diagnosis and history. These numbers are a starting point, not a guarantee."
      },
      "network_modal": {
        "title": "About network comparison",
        "what_this_shows": "What this shows",
        "why_it_matters": "Why it matters"
      },
      "estimate_modal": {
        "title": "How your estimate works"
      },
      "stat": {
        "clinic_age_rate": "Clinic age based success rate",
        "personalized_estimate": "Personalized estimate"
      },
      "success_tabs": {
        "location": "At this location",
        "network": "Across the network"
      },
      "success_context": {
        "cycles_source": "${count} cycles/year reported to ${source}"
      },
      "network": {
        "highest_rates": "Highest rates across ${network} locations",
        "highest_rates_fallback": "Highest rates across other locations",
        "no_data": "This location hasn't reported its own data",
        "best_reported": "Best reported rate per age group across all locations",
        "siblings_heading": "Other ${network} locations (${count})",
        "siblings_heading_fallback": "Other locations (${count})",
        "locations_name": "${network} locations",
        "other_locations_name": "Other locations"
      },
      "entity": {
        "provider": "provider",
        "clinic": "clinic"
      },
      "reporting_sources": {
        "abm": {
          "short_label": "ABM data",
          "full_name": "Agence de la Biomédecine",
          "rate_heading": "Official success rate at this location",
          "what_this_shows": "The cumulative delivery rate per egg-retrieval cycle reported by this clinic, combining fresh and frozen embryo transfers across all patient ages.",
          "data_source": "All French AMP centers report activity to the Agence de la Biomédecine. These rates come from the ABM's 28 April 2025 publication of 2021–2022 data, aggregated by fiv.fr.",
          "national_average": "The national average across all reporting French centers is 30%."
        },
        "ontario": {
          "short_label": "Ontario funded",
          "full_name": "Ontario Fertility Program",
          "rate_heading": "Published success rate",
          "what_this_shows": "This source confirms public funding participation for Ontario clinics. It does not publish comparable clinic-level success rates.",
          "data_source": "Ontario publishes participating fertility-treatment providers for the Ontario Fertility Program, but not CDC-style public clinic-level IVF success rates.",
          "national_average": "CFAS/CARTR publishes Canadian aggregate ART reporting, but the Ontario Fertility Program listing does not provide comparable clinic-level rates."
        },
        "redlara": {
          "short_label": "REDLARA member",
          "full_name": "REDLARA",
          "rate_heading": "Published success rate",
          "what_this_shows": "This source confirms registry participation and clinic identity details. It does not provide comparable clinic-level public success rates.",
          "data_source": "REDLARA publishes member center information, but it is not a mandatory national public clinic-level success-rate reporting system.",
          "national_average": "REDLARA publishes regional registry reporting, but this member listing does not provide mandatory public clinic-level success rates."
        },
        "hfea": {
          "short_label": "HFEA data",
          "full_name": "Human Fertilisation and Embryology Authority",
          "rate_heading": "Reported success rate at this location",
          "what_this_shows": "The HFEA clinic profile is the source of record. Where rates are imported, compare clinics using the same HFEA metric, treatment type, and reporting period.",
          "data_source": "HFEA is the UK fertility regulator and its Choose a Fertility Clinic service is the official public source for licensed clinic data.",
          "national_average": "Use HFEA comparisons only when the metric, treatment type, age band, and reporting period match."
        },
        "sef": {
          "short_label": "SEF registry",
          "full_name": "Registro Nacional de Actividad - Registro SEF",
          "rate_heading": "Official success rate at this location",
          "what_this_shows": "The SEF source identifies participating Spanish assisted-reproduction centers and publishes official center-level result materials.",
          "data_source": "SEF's 2023 public materials describe the Registro Nacional de Actividad as the official Spanish ART registry and state that center participation is mandatory.",
          "national_average": "Only compare Spanish clinics when the SEF metric, population, and year match."
        },
        "dutch_ivf": {
          "short_label": "Dutch IVF figures",
          "full_name": "deGynaecoloog / NVOG",
          "rate_heading": "Official success rates at this center",
          "what_this_shows": "The report's ongoing-pregnancy percentages for IVF, ICSI, and cryo treatment columns at this Dutch IVF center.",
          "data_source": "deGynaecoloog publishes Dutch IVF figures per licensed IVF center. The 2022 report states it covers all license-holding IVF centers in the Netherlands.",
          "national_average": "The grey bars use the report's NL 2022 national totals for the same IVF, ICSI, or cryo treatment column."
        },
        "anzard": {
          "short_label": "YourIVFSuccess",
          "full_name": "YourIVFSuccess / ANZARD",
          "rate_heading": "Official success rates at this location",
          "what_this_shows": "The public Australian clinic-comparison measures published for this RTAC-accredited clinic, with national comparison values where the source provides them.",
          "data_source": "YourIVFSuccess is an Australian public clinic-comparison service using ANZARD data for accredited fertility clinics.",
          "national_average": "Grey bars use the YourIVFSuccess national average for the same measure and age group."
        },
        "belrap": {
          "short_label": "BELRAP report",
          "full_name": "Belgian Register for Assisted Procreation",
          "rate_heading": "Published success rate",
          "what_this_shows": "This source confirms that the center appears in BELRAP reporting materials. It does not give us a normalized clinic-level success-rate value for this page.",
          "data_source": "BELRAP reports are published by the Belgian College of Physicians in Reproductive Medicine.",
          "national_average": "No comparable clinic-level national average is available in this record."
        },
        "dir": {
          "short_label": "D.I.R. member",
          "full_name": "Deutsches IVF-Register",
          "rate_heading": "Published success rate",
          "what_this_shows": "This source confirms registry membership and clinic identity/contact details.",
          "data_source": "The Deutsches IVF-Register publishes a member-center address list and national reporting materials.",
          "national_average": "D.I.R. publishes national aggregate annual outcome reporting, but this record does not include a mapped clinic-level value to compare against it."
        },
        "iss": {
          "short_label": "ISS PMA registry",
          "full_name": "Registro Nazionale Procreazione Medicalmente Assistita",
          "rate_heading": "Published success rate",
          "what_this_shows": "This source confirms the authorized Italian PMA center, level, and public/private service type. It does not give us a normalized clinic-level success-rate value for this page.",
          "data_source": "The Italian Istituto Superiore di Sanità maintains the Registro Nazionale PMA.",
          "national_average": "ISS publishes national PMA activity and outcome reporting, but this record does not include a mapped clinic-level value to compare against it."
        },
        "cnpma": {
          "short_label": "CNPMA authorized",
          "full_name": "Conselho Nacional de Procriação Medicamente Assistida",
          "rate_heading": "Published success rate",
          "what_this_shows": "This source confirms that the center is authorized for PMA in Portugal and provides location/contact details.",
          "data_source": "CNPMA publishes the authorized public and private PMA center list.",
          "national_average": "No comparable clinic-level national average is available from this source."
        },
        "eaiya": {
          "short_label": "EAIYA licensed",
          "full_name": "Greek National Authority of Assisted Reproduction",
          "rate_heading": "Published success rate",
          "what_this_shows": "This source confirms Greek licensure status for the assisted-reproduction unit.",
          "data_source": "EAIYA publishes the licensed IVFU and cryopreservation-bank list.",
          "national_average": "No comparable clinic-level national average is available from this source."
        },
        "clinic_published": {
          "short_label": "Clinic-published",
          "full_name": "Clinic-published outcomes",
          "rate_heading": "Clinic-published success rate",
          "inline_disclosure": "This data comes from the clinic's own public materials and is not enforced or normalized by a mandatory national reporting system.",
          "what_this_shows": "The success metric publicly posted by this clinic. Definitions can vary by clinic, such as pregnancy per transfer, ongoing pregnancy, live birth, or cumulative success per retrieval.",
          "data_source": "These values come from the clinic's own public website or published materials. Treat them differently from mandatory national registry data.",
          "national_average": "Only compare against a national benchmark when the clinic uses the same metric, year, population, and denominator."
        },
        "cdc": {
          "short_label": "CDC data",
          "full_name": "CDC NASS",
          "rate_heading": "Reported success rate at this location",
          "what_this_shows": "The live birth rate per egg retrieval cycle reported by this clinic to the CDC, broken down by patient age group.",
          "data_source": "All U.S. fertility clinics are required to report outcomes to the CDC's National ART Surveillance System (NASS). These are verified, clinic-level results — not estimates.",
          "national_average": "The grey bars show the national average success rate for each age group across all reporting clinics, so you can see how this clinic compares."
        }
      },
      "empty": {
        "pricing": "We don't have pricing information for this clinic yet. Costs vary by treatment plan, so we can't show package prices here.",
        "insurance": "We don't have insurance details for this clinic yet, so we can't confirm which carriers or fertility benefits they accept.",
        "clinic_details": "We don't have consultation, language, lab, or founding-year details for this ${entity} yet."
      },
      "military": {
        "section_title": "Military Discount",
        "eligibility": "Eligibility",
        "coverage": "Coverage",
        "exclusions": "Exclusions",
        "additional_programs": "Additional Programs"
      },
      "facility": {
        "onsite_lab": "On-site embryology lab",
        "consultations": "Consultations",
        "telehealth": "Telehealth",
        "in_person": "In-person",
        "languages": "Languages",
        "established": "Established ${year}"
      },
      "journey": {
        "status_label": "Status",
        "note_label": "Private note",
        "note_placeholder": "Write your thoughts about this clinic...",
        "saved": "Saved",
        "saving": "Saving…",
        "save_failed_message": "We couldn't save this clinic update. Your draft is still here.",
        "conflict_message": "This clinic changed elsewhere. Your draft is still here.",
        "save": "Save",
        "compare": "Compare",
        "compare_soon": "Soon",
        "share": "Share",
        "share_copied": "Link copied",
        "status": {
          "researching": "Researching",
          "contacted": "Contacted",
          "consulted": "Consulted",
          "in_treatment": "In treatment",
          "past_patient": "Past patient"
        }
      },
      "team_modal": {
        "research_focus": "Research focus",
        "publications_one": "${count} publication",
        "publications_other": "${count} publications",
        "add_to_care_team": "Add this person to my care team",
        "added_to_care_team": "Added to my care team",
        "add_error": "We couldn’t add this person to your care team. Please try again."
      },
      "footer": {
        "info_prefix": "Information on this page is sourced from publicly available data on the clinic's website",
        "info_with_cdc": " and CDC/SART national reports",
        "info_with_abm": " and Agence de la Biomédecine reports",
        "info_with_ontario": " and Ontario Fertility Program provider listings",
        "info_with_redlara": " and REDLARA registry/member information",
        "info_with_clinic_published": " and clinic-published outcome materials",
        "info_suffix": ". Pricing, insurance, and services may have changed since last updated.",
        "last_updated": "Last updated: ${date}",
        "last_updated_unknown": "Unknown",
        "verify": "Always verify details directly with the clinic before making decisions."
      },
      "source_badge": {
        "official_national": "Official national data",
        "program_listing": "Program listing",
        "registry_participation": "Registry participation",
        "mandatory_registry": "Mandatory registry",
        "clinic_published": "Clinic-published"
      },
      "rate_heading": {
        "official": "Official success rate at this location",
        "published": "Published success rate",
        "clinic_published": "Clinic-published success rate",
        "reported": "Reported success rate at this location"
      },
      "inline_disclosure": {
        "abm": "Official national publication. These clinic-level French outcomes come from a national reporting body, not clinic marketing copy.",
        "ontario": "Program-listing data only. This identifies publicly funded Ontario fertility providers; it is not a public clinic-level success-rate feed.",
        "redlara": "Registry participation only. REDLARA membership is not a mandatory national public success-rate report for Mexico.",
        "clinic_self_published": "Clinic-published data. This rate comes from the clinic's own public materials and is not enforced or normalized by a mandatory national reporting system.",
        "cdc": "Mandatory national registry data. U.S. clinics are required to report these clinic-level outcomes to CDC NASS."
      },
      "sources_extra": {
        "ontario_short": "Ontario funded",
        "ontario_full": "Ontario Fertility Program",
        "redlara_short": "REDLARA member",
        "redlara_full": "REDLARA",
        "clinic_published_short": "Clinic-published",
        "clinic_published_full": "Clinic-published outcomes",
        "ontario_what_this_shows": "This source confirms public funding participation for Ontario clinics. It does not publish comparable clinic-level success rates.",
        "ontario_data_source": "Ontario publishes participating fertility-treatment providers for the Ontario Fertility Program, but not CDC-style public clinic-level IVF success rates.",
        "ontario_national_average": "No clinic-level national average is available from this source.",
        "redlara_what_this_shows": "This source confirms registry participation and clinic identity details. It does not provide comparable clinic-level public success rates.",
        "redlara_data_source": "REDLARA publishes member center information, but it is not a mandatory national public clinic-level success-rate reporting system.",
        "redlara_national_average": "No clinic-level national average is available from this source.",
        "clinic_published_what_this_shows": "The success metric publicly posted by this clinic. Definitions can vary by clinic, such as pregnancy per transfer, ongoing pregnancy, live birth, or cumulative success per retrieval.",
        "clinic_published_data_source": "These values come from the clinic's own public website or published materials. Treat them differently from mandatory national registry data.",
        "clinic_published_national_average": "Only compare against a national benchmark when the clinic uses the same metric, year, population, and denominator."
      },
      "success_rate_empty": {
        "no_usable_title": "No usable success-rate value",
        "no_published_title": "No published success rates",
        "no_comparable_title": "No comparable success rates",
        "no_imported_title": "No imported success-rate value",
        "no_usable_body": "This ${entity} has clinic-published outcome material, but we don't have a usable success-rate value for this page. Clinic-published rates are not enforced or normalized by a mandatory national reporting system.",
        "no_cdc_sart_body": "This ${entity} does not have a positive published success-rate value in the U.S. CDC/SART data we imported. The public file may suppress results for low volume, zero reported cycles, or other reporting limits.",
        "no_abm_body": "This ${entity} does not have a comparable clinic-level success-rate value in the French ABM data we imported yet.",
        "no_ontario_body": "This clinic appears in Ontario Fertility Program provider listings, but that source does not publish comparable clinic-level IVF success rates. This clinic has not published its own success rate either.",
        "no_redlara_body": "This clinic appears in REDLARA registry/member information, but that is not a mandatory Mexican public clinic-level success-rate report. This clinic has not published its own success rate either.",
        "no_hfea_body": "HFEA is the UK's mandatory public clinic data source, but this record does not yet include an imported positive success-rate value for this clinic.",
        "no_sef_body": "Spain has an official mandatory national ART registry through Registro SEF. This center appears in the SEF participant/results source, but this record does not yet include a comparable clinic-level success-rate value.",
        "no_belrap_body": "BELRAP official reports identify Belgian reporting centers, but this record does not include a comparable public clinic-level success-rate value.",
        "no_dir_body": "D.I.R. membership confirms German registry participation and contact details, but it is not a public normalized clinic-level success-rate feed in this record.",
        "no_iss_body": "ISS lists authorized Italian PMA centers with public/private and level details, but this record does not include a comparable clinic-level success-rate value.",
        "no_ontario_listing_body": "Canada has CFAS/CARTR aggregate ART reporting, but there is no mandatory public clinic-level success-rate source for this clinic. This clinic appears in Ontario Fertility Program provider listings and has not published its own success-rate value for this page.",
        "no_redlara_country_body": "REDLARA publishes Latin American registry reporting and member information, but that is not a mandatory public clinic-level success-rate source for ${country}. This clinic has not published its own success-rate value for this page.",
        "no_cnpma_body": "CNPMA is a Portuguese PMA authorization listing, not a public clinic-level success-rate feed. No clinic-published success-rate value is recorded for this page.",
        "no_eaiya_body": "EAIYA is a Greek licensing listing, not a public clinic-level success-rate feed. No clinic-published success-rate value is recorded for this page.",
        "no_ca_body": "There is no national mandatory public clinic-level success-rate source for Canada, and this clinic has not published its own success rate either.",
        "no_mx_body": "There is no mandatory Mexican public clinic-level success-rate source for this clinic, and this clinic has not published its own success rate either.",
        "no_redlara_mexico_body": "REDLARA publishes Latin American registry reporting, but there is no mandatory Mexican public clinic-level success-rate source for this clinic. This clinic has not published its own success rate either.",
        "no_redlara_record_country_body": "REDLARA publishes Latin American registry reporting and member information, but there is no mandatory public clinic-level success-rate source for this ${country} clinic in our record. This clinic has not published its own success rate either.",
        "no_country_body": "There is no national mandatory public clinic-level success-rate source for ${country}, and this clinic has not published its own success rate either.",
        "no_au_body": "Australia has public clinic-comparison data through YourIVFSuccess / ANZARD, but this clinic record does not include an imported positive clinic-level success-rate value.",
        "no_in_body": "India's National ART & Surrogacy Registry confirms clinic registration or authorization. The imported registry source does not publish comparable public clinic-level success-rate values, and this clinic has not published its own success-rate value for this page.",
        "no_id_body": "PERFITRI publishes Indonesian IVF cycle-count registry entries, but this is not a public clinic-level success-rate source. No clinic-published success-rate value is recorded for this page.",
        "no_vn_body": "No mandatory public clinic-level success-rate source has been imported for Vietnam, and this clinic record does not include a clinic-published success-rate value.",
        "no_ng_body": "No mandatory public clinic-level success-rate source has been imported for Nigeria, and this clinic record does not include a clinic-published success-rate value.",
        "no_ru_body": "RAHR publishes Russian national ART registry reporting, but this record does not include a comparable clinic-level success-rate value. RAHR directory participation is not a clinic-specific success rate.",
        "no_jp_body": "Japan's JSOG facility search confirms IVF, embryo-transfer, or ICSI facility capability. The imported JSOG source is not a public clinic-level success-rate feed, and this clinic has not published its own success-rate value for this page.",
        "no_kr_body": "South Korea's public data sources confirm IVF-designated and embryo-production institution status. The imported government sources do not publish comparable clinic-level success-rate values, and no clinic-published success-rate value is recorded for this page.",
        "no_cn_body": "China's National Health Commission list confirms approved ART technologies and operating status. The imported NHC source does not publish comparable public clinic-level success-rate values, and no clinic-published success-rate value is recorded for this page.",
        "no_fr_body": "Some French AMP centers have official ABM outcome data, but this ${entity} does not have a comparable published success-rate value in our record yet.",
        "no_gb_body": "The UK has mandatory public clinic-level HFEA data, but this clinic record does not yet include an imported positive success-rate value.",
        "no_es_body": "Spain has an official mandatory national ART registry through Registro SEF, but this clinic record does not yet include a comparable clinic-level success-rate value.",
        "no_be_body": "Belgium has BELRAP national ART reporting, but this clinic record does not include a comparable public clinic-level success-rate value.",
        "no_de_body": "Germany has D.I.R. national aggregate reporting and member-center context, but this clinic record does not include a public normalized clinic-level success-rate value.",
        "no_it_body": "Italy has ISS Registro PMA national reporting and a center registry, but this clinic record does not include a comparable clinic-level success-rate value.",
        "no_pt_body": "Portugal's CNPMA source is an authorization listing, not a public clinic-level success-rate feed. No clinic-published success-rate value is recorded for this page.",
        "no_gr_body": "Greece's EAIYA source is a licensing listing, not a public clinic-level success-rate feed. No clinic-published success-rate value is recorded for this page.",
        "supplemental_europe_at": "Austria has IVF-Fonds annual reports and contract-center listings, but this supplemental record is not linked to a comparable public clinic-level success-rate value. No clinic-published success-rate value is recorded for this page.",
        "supplemental_europe_dk": "Denmark has national IVF-register data and Danish Fertility Society annual result tables, but this supplemental record is not yet mapped to a comparable clinic-level outcome value. No clinic-published success-rate value is recorded for this page.",
        "supplemental_europe_nl": "The Netherlands publishes 2022 IVF figures for licensed IVF centers through deGynaecoloog/NVOG. This supplemental record is not matched to one of those licensed-center rows yet, which may mean it is a satellite, monitoring-only, historical, or otherwise non-reporting location.",
        "supplemental_europe_se": "Sweden has Q-IVF national quality registry reporting and public report materials, but this supplemental record is not yet mapped to a comparable clinic-level outcome value. No clinic-published success-rate value is recorded for this page.",
        "supplemental_europe_default": "For ${country}, this clinic record is not linked to a verified mandatory public clinic-level success-rate source, and no clinic-published success-rate value is recorded for this page. Directory/contact sources are used only for identity and location, not outcomes.",
        "no_us_body": "We do not have a CDC/SART success-rate value for this ${entity} yet.",
        "no_default_body": "We do not have published success-rate data for this ${entity} yet."
      },
      "wikipedia_source": "Source: Wikipedia",
      "clinic_images_title": "Clinic images",
      "no_contact_details": "Contact details are not available yet.",
      "sources": {
        "cdc": {
          "data": "CDC data",
          "name": "CDC NASS",
          "success_rate_desc": "The live birth rate per egg retrieval cycle reported by this clinic to the CDC, broken down by patient age group.",
          "reporting_desc": "All U.S. fertility clinics are required to report outcomes to the CDC's National ART Surveillance System (NASS). These are verified, clinic-level results — not estimates.",
          "average_desc": "The grey bars show the national average success rate for each age group across all reporting U.S. clinics."
        },
        "abm": {
          "data": "ABM data",
          "name": "Agence de la Biomédecine",
          "success_rate_desc": "The cumulative delivery rate per egg-retrieval cycle reported by this clinic to the Agence de la Biomédecine, broken down by patient age group.",
          "reporting_desc": "All French AMP centers report activity to the Agence de la Biomédecine. These are verified, clinic-level results — not estimates.",
          "average_desc": "The national average across all reporting French centers is 30%."
        }
      },
      "note_cta": {
        "edit": "Edit note",
        "add": "Add a private note"
      },
      "international_care": {
        "title": "International care",
        "body": "This clinic is in ${clinicCountry}. Outcomes and logistics may use different reporting, travel, payment, and coverage rules than clinics in ${homeCountry}."
      },
      "location_success_rate_heading": "Reported success rate at this location",
      "visit_website": "Visit clinic website",
      "empty_state": {
        "no_success_rates_title": "No published success rates",
        "no_success_rates_provider": "This provider doesn't have published success-rate data in SART or CDC reports.",
        "no_success_rates_clinic": "This clinic doesn't have published success-rate data in SART or CDC reports.",
        "no_facility_provider": "No images of this provider are available yet.",
        "no_facility_clinic": "No images of this clinic are available yet.",
        "no_medical_team_provider": "We don't have medical team information for this provider yet.",
        "no_medical_team_clinic": "We don't have medical team information for this clinic yet.",
        "medical_team_title": "Medical team"
      },
      "schedule_caption": "We'll reach out to this clinic on your behalf to schedule",
      "estimate_modal_extra": {
        "factors_title": "Factors used in your estimate",
        "confidence_title": "Confidence range",
        "confidence_body": "${low}–${high}% estimated range based on this clinic's sample size and your profile adjustments."
      },
      "network_modal_body": {
        "what_this_shows": "For each age group, this chart shows the highest reported success rate across all locations in this clinic's network, along with which city reported that rate.",
        "why_it_matters": "Multi-location networks may have different outcomes at each site. This helps you see the best-performing location for your age group if you're flexible on where to go.",
        "source_note": "Rates are based on the same ${source} data. Differences between locations can reflect patient volume, protocols, or patient demographics."
      },
      "social_channels": "Social channels",
      "uk_context": {
        "title": "UK treatment context",
        "hfea_title": "HFEA licensed treatment centre",
        "hfea_body": "UK fertility treatment centres are licensed and inspected by HFEA. This record is linked to the HFEA clinic profile, including public inspection and outcome materials when HFEA publishes them.",
        "diagnostics_title": "Diagnostics or monitoring provider",
        "diagnostics_body": "This provider is listed for fertility-related testing, monitoring, or specialist guidance. Confirm directly whether it provides treatment itself or works alongside an HFEA-licensed clinic.",
        "provider_title": "UK fertility provider",
        "provider_body": "Confirm the current HFEA licence status for any provider that stores gametes or embryos, uses donor sperm, or provides regulated assisted reproduction treatment.",
        "nhs_title": "NHS funding is local",
        "nhs_body": "NHS-funded IVF access depends on the nation and, in England, local ICB criteria. Eligibility, number of cycles, medicines, storage, and frozen transfers can vary by area.",
        "referral_title": "Referral and letters matter",
        "referral_body": "Many NHS pathways start with GP or hospital referral, fertility investigations, eligibility review, and a funding or next-steps letter before a clinic can start treatment.",
        "consent_title": "Consent, donors, and storage",
        "consent_body": "HFEA consent forms are a core UK step for treatment and storage. Donor treatment also has UK-specific identity and counselling rules that patients should review before choosing a route."
      }
    },
    "cumulative_rate": {
      "national_rank": "National rank",
      "volume": "Volume",
      "this_clinic": "This clinic",
      "national_avg": "National avg",
      "live_birth_per_retrieval": "live-birth rate per egg retrieval",
      "vs_national_average": "vs French national average",
      "volume_unit_year": "${count} egg retrievals (${year})",
      "volume_unit_no_year": "${count} egg retrievals",
      "rank_format": "#${rank} of ${total} in France",
      "what_this_means_title": "What this means",
      "what_this_means_body": "In IVF, an egg retrieval is one round of ovarian stimulation where eggs are collected. The eggs become embryos — some are transferred fresh, others frozen for later attempts. This rate is the % of egg retrievals at this clinic that led to a birth, counting any embryo (fresh or frozen) from that retrieval."
    },
    "location_card": {
      "day_mon": "Mon",
      "day_tue": "Tue",
      "day_wed": "Wed",
      "day_thu": "Thu",
      "day_fri": "Fri",
      "day_sat": "Sat",
      "day_sun": "Sun",
      "closed": "Closed",
      "open_in_maps": "Open in Maps",
      "opening_hours": "Opening hours",
      "open_now": "Open now",
      "no_hours": "Hours are not published in this record yet. Check the clinic website for current hours.",
      "email_subject": "Inquiry about fertility services at ${clinic}",
      "email_body": "Hi ${clinic} team,\n\nI found your clinic through Louise and I'm interested in learning more about your fertility services.\n\nI'd love to schedule a consultation or learn about next steps.\n\nThank you"
    },
    "pricing_card": {
      "free": "Free",
      "excludes_medications": "Excludes medications",
      "includes_label": "Includes:",
      "excludes_label": "Excludes:",
      "medications_additional_footer": "Medications are additional and billed separately by the pharmacy.",
      "in_house_payment_plans": "In-house payment plans",
      "fertile_guarantee": "Fertile Guarantee",
      "financing_options": "Financing options",
      "financing_empty": "We don't have financing details for this clinic yet, so we don't know whether they offer payment plans or partner with a financing provider.",
      "financing_details_unavailable": "Contact the clinic for current terms and eligibility.",
      "learn_more": "Learn more",
      "enrichment": {
        "patientfi": {
          "tagline": "Monthly payments for fertility treatments",
          "highlight_1": "0% APR plans available",
          "highlight_2": "No hard credit check to prequalify",
          "highlight_3": "Pay over 6-60 months"
        },
        "capexmd": {
          "tagline": "Fertility-focused financing and shared risk programs",
          "highlight_1": "Shared risk: refund if no live birth",
          "highlight_2": "Multi-cycle discount programs",
          "highlight_3": "Covers IVF, meds, and PGT"
        },
        "future_family": {
          "tagline": "Loans designed specifically for fertility care",
          "highlight_1": "Covers IVF, egg freezing, and surrogacy",
          "highlight_2": "Fixed rates from 5.99% APR",
          "highlight_3": "Up to $50K, approval within 24 hours"
        },
        "prosper": {
          "tagline": "Personal loans for medical expenses",
          "highlight_1": "Borrow $2K-$50K",
          "highlight_2": "Fixed rates, no prepayment penalties",
          "highlight_3": "Funds in 1-3 business days"
        },
        "lendingclub": {
          "tagline": "Patient financing for healthcare",
          "highlight_1": "Flexible monthly payment plans",
          "highlight_2": "No prepayment penalties",
          "highlight_3": "Check rate without affecting credit"
        }
      }
    },
    "success_chart": {
      "national_average": "National average",
      "all_ages": "All ages",
      "not_reported": "Not reported",
      "avg_value": "avg ${value}%",
      "unavailable_title": "Success rates not available",
      "unavailable_body": "This clinic hasn’t reported IVF success data yet",
      "clinic_success_rate": "Clinic success rate",
      "based_on_age": "based on age",
      "personalized_estimate": "Personalized estimate",
      "confidence_range": "${low}–${high}% range",
      "personalize_cta": "Personalize my estimate",
      "no_adjustments_body_prefix": "This clinic reports a ",
      "no_adjustments_body_suffix": " live birth rate for your age group. Complete your health profile to see how other factors could shift this number for you.",
      "info": {
        "how_title": "How this works",
        "how_body": "Your personalized estimate starts with this clinic’s reported success rate for your age group, then adjusts it based on factors from your health profile that are known to affect IVF outcomes.",
        "adjust_title": "What we adjust for",
        "adjust_body": "Diagnosis (e.g. PCOS, endometriosis, low ovarian reserve), BMI, smoking status, prior pregnancies, and number of previous IVF cycles. Each factor shifts the estimate up or down based on peer-reviewed clinical research.",
        "sources_title": "Data sources",
        "sources_body": "Clinic success rates come from the CDC’s National ART Surveillance System (NASS), which collects verified outcomes from every U.S. fertility clinic. Adjustment factors are derived from large-scale published studies in reproductive medicine.",
        "confidence_title": "Confidence range",
        "confidence_body": "The range reflects statistical uncertainty based on the clinic’s sample size and the number of adjustments applied. Clinics with more cycles per year produce narrower, more reliable ranges.",
        "disclaimer": "This is a statistical estimate, not a medical prediction. Individual outcomes depend on many factors not captured here. Always discuss your chances with your fertility specialist."
      }
    },
    "clinic_services": {
      "group": {
        "treatment-options": "Treatment options",
        "fertility-preservation": "Fertility preservation",
        "testing-lab": "Testing & lab services",
        "donor-lgbtq-surrogacy-support": "Donor, LGBTQ+, surrogacy & support services"
      },
      "item": {
        "ivf": "IVF & ICSI",
        "iui": "IUI",
        "mini-ivf": "Mini-IVF",
        "ovulation-induction": "Ovulation induction",
        "egg-freezing": "Egg freezing",
        "embryo-freezing": "Embryo freezing",
        "sperm-freezing": "Sperm freezing",
        "fertility-preservation": "Fertility preservation",
        "onsite-lab": "On-site embryology lab",
        "fertility-testing": "Fertility testing",
        "pgt-a": "PGT-A",
        "pgt-m": "PGT-M",
        "pgt-sr": "PGT-SR",
        "pgt-p": "PGT-P",
        "donor-programs": "Donor programs",
        "gestational-carrier": "Gestational carrier support",
        "lgbtq-care": "LGBTQ+ care",
        "monitoring": "Monitoring appointments"
      },
      "status": {
        "offered": "Confirmed offered",
        "not-offered": "Confirmed not offered",
        "unknown": "Availability not confirmed"
      },
      "metadata": {
        "source": "Source: ${source}",
        "verified": "Verified: ${date}",
        "source_missing": "Source not supplied",
        "verified_missing": "Verification date not supplied"
      },
      "pgt_subtypes_hint": "PGT is a family of tests. Availability can differ by subtype."
    },
    "capabilities": {
      "category": {
        "art": "Core treatments",
        "preservation": "Fertility preservation",
        "diagnostic": "Diagnostics",
        "surgical": "Surgical",
        "wellness": "Supportive & wellness",
        "lab": "Lab & embryology",
        "other": "Other"
      },
      "item": {
        "onsite-lab": "On-site embryology lab",
        "pgt": "Genetic testing (PGT)",
        "blastocyst": "Blastocyst culture",
        "assisted-hatching": "Assisted hatching",
        "time-lapse": "Time-lapse imaging",
        "ai-embryo": "AI embryo grading",
        "onco": "Onco-fertility preservation",
        "era": "Endometrial receptivity (ERA)",
        "embryoglue": "EmbryoGlue",
        "ovarian-tissue": "Ovarian tissue cryopreservation",
        "ivm": "IVM (in-vitro maturation)",
        "immunology": "Reproductive immunology",
        "prp": "PRP (ovarian / endometrial)",
        "peptides": "Peptide therapies",
        "longevity": "Longevity protocols"
      },
      "no_info": "We don’t have information about ${label} for this clinic yet.",
      "no_info_label_confirmed_treatments": "confirmed treatments"
    },
    "sentiment": {
      "soon_body": "Soon you'll find a summary of what patients really say about this clinic here, pulled together from reviews, Reddit and fertility forums."
    },
    "empty_state": {
      "contact_verify": "Get in touch to verify"
    },
    "clinic_detail_extra": {
      "cycles_per_year_source": "${count} cycles/year · ${source}"
    }
  },
  "region_gate": {
    "not_available_in_region": "Not available in your region",
    "us_only_coming_soon": "This feature is for US users. French support is coming soon."
  },
  "status_badge": {
    "beta": "Beta",
    "coming_soon": "Coming soon"
  },
  "costs": {
    "costs": "Costs",
    "coverage_and_ways_to_pay": "Coverage & Ways to Pay",
    "coming_soon": "Coming soon",
    "insurance": "Insurance",
    "employer_benefits": "Employer & State Benefits",
    "financing": "Financing Options",
    "grants": "Fertility Grants",
    "tax_deductions": "Tax Deductions",
    "donor_scenario_note": "Costs vary a lot for donor scenarios. If you are receiving donor eggs or sperm, ask clinics to itemize donor, lab, legal, and storage fees. If you are the donor, treatment may be free or compensated.",
    "us_first_title": "Costs support is U.S.-first for now",
    "us_first_body": "Louise can still help collect clinic quotes, receipts, and benefit questions while localized pricing support is added.",
    "insurance_fallback": "Insurance",
    "insurance_add_prompt": "Add your insurance to see coverage",
    "insurance_verified_suffix": "${name} · Verified",
    "insurance_pending_suffix": "${name} · Verification pending",
    "employer_subtitle_default": "Employer programs · HSA/FSA · State mandates",
    "financing_subtitle_default": "5 providers · promotional options available",
    "financing_page": {
      "hero_eyebrow": "Financing options",
      "hero_title": "Find a payment path that fits your care",
      "hero_summary": "Compare the ways each provider works, what they may ask for, and which details to verify before you apply.",
      "prepare_applicant_info": "Prepare my applicant info",
      "edit_applicant_info": "Edit applicant info",
      "best_for": "Best for",
      "funding": "Funding",
      "coverage": "Coverage",
      "pricing": "Pricing",
      "credit_check": "Credit check",
      "provider_access": "Provider access",
      "provider_details": "View provider details",
      "visit_provider": "Visit provider",
      "fact_sheet_summary_heading": "At a glance",
      "fact_sheet_details_heading": "What to verify",
      "fact_sheet_reviewed": "Reviewed ${date} · ${jurisdiction}",
      "read_provider_terms": "Read current provider terms",
      "close_fact_sheet": "Close",
      "verify_with_provider": "Confirm with provider",
      "not_a_credit_product": "Not a credit product",
      "review_pending_details": "Some details are waiting for their next content review.",
      "fact_sheet_unavailable": "Current provider details are unavailable until they are reviewed.",
      "applicant_dialog_heading": "Build your applicant snapshot",
      "applicant_dialog_intro": "These details help you prepare for conversations with financing providers. Louise does not submit applications or send this snapshot to them.",
      "full_name": "Full name",
      "date_of_birth": "Date of birth",
      "email_address": "Email address",
      "phone_number": "Mobile phone",
      "physical_address": "Physical mailing address",
      "physical_address_placeholder": "Start typing your address",
      "state": "State",
      "zip_code": "ZIP code",
      "clinic_name": "Clinic or provider",
      "treatment_type": "Treatment or expense",
      "estimated_treatment_cost": "Estimated treatment cost",
      "requested_financing_amount": "Amount you'd like to finance",
      "employment_status": "Employment status",
      "employment_status_placeholder": "Employed, self-employed, retired, etc.",
      "employer": "Employer",
      "occupation": "Occupation",
      "annual_gross_income": "Annual gross income",
      "household_annual_income": "Household annual income",
      "housing_status": "Housing status",
      "housing_status_placeholder": "Rent, own, live with family, etc.",
      "monthly_housing_cost": "Monthly housing cost",
      "monthly_debt_payments": "Monthly debt payments",
      "co_applicant_full_name": "Co-applicant full name",
      "co_applicant_date_of_birth": "Co-applicant date of birth",
      "co_applicant_email": "Co-applicant email",
      "co_applicant_phone": "Co-applicant phone",
      "co_applicant_annual_gross_income": "Co-applicant annual gross income",
      "co_applicant_employment_status": "Co-applicant employment status",
      "co_applicant_relationship": "Relationship to co-applicant",
      "co_applicant_relationship_placeholder": "Partner, spouse, family member, etc.",
      "save_applicant_info": "Save",
      "save_applicant_info_error": "We couldn't save these details. Please try again.",
      "cancel_applicant_info": "Cancel",
      "application_profile_disclaimer": "This is a planning snapshot, not an application and not a credit assessment."
    },
    "grants_subtitle_count": "${count} programs available",
    "tax_subtitle_default": "Fertility expenses may be deductible",
    "tax_review": {
      "tax_year_review": "Tax review",
      "tax_year_review_subtitle": "Review your ${tax_year} payments, receipts, and supporting documents in one place.",
      "review_this_tax_year": "Review this tax year",
      "recap": "Recap",
      "your_tax_year_recap": "Your ${tax_year} deduction recap",
      "records_analyzed": "${count} records analyzed",
      "expenses_added_basis": "Based on ${count} expenses you've added",
      "ready_for_review_count": "${count} ready for review",
      "needs_attention_count": "${count} need attention",
      "patient_paid_costs": "Patient-paid costs",
      "non_patient_allocations_basis": "${amount} in non-patient allocations are tracked separately",
      "potential_deduction": "Potential deduction",
      "potential_deduction_empty_title": "See your potential ${tax_year} deduction",
      "potential_deduction_empty_body": "Add your AGI to compare patient-paid medical expenses with the 7.5% threshold.",
      "deduction_illustration": "Medical expense deduction illustration",
      "add_tax_inputs": "Add tax inputs",
      "add_agi_to_calculate": "Add your AGI to calculate the threshold",
      "tax_inputs": "Tax inputs",
      "adjusted_gross_income": "Adjusted gross income (AGI)",
      "itemization_status": "Itemization status",
      "itemizes_deductions": "I itemize deductions",
      "takes_standard_deduction": "I take the standard deduction",
      "itemization_unknown": "I'm not sure yet",
      "itemized_deduction_amount_label": "Itemized",
      "standard_deduction_amount_label": "Standard",
      "review_tax_inputs": "Review tax inputs",
      "view_tax_inputs": "View tax inputs",
      "view_tax_review": "View tax review",
      "tax_review_action": "Tax review",
      "tax_inputs_explanation": "AGI sets the 7.5% threshold. Itemization tells us whether a medical expense deduction may apply.",
      "view_tax_sources": "View medical expense deduction sources",
      "tax_sources_title": "Medical expense deduction sources",
      "agi_threshold_explanation": "${rate}% of AGI applies before a medical expense deduction may be available.",
      "uploaded_photo": "Uploaded photo",
      "uploaded_file": "Uploaded file",
      "save_tax_inputs": "Save tax inputs",
      "needs_attention": "Needs your attention",
      "no_attention": "Everything currently has a review decision",
      "expenses_in_review": "Expenses in this review",
      "documents_attached": "${count} document(s) attached",
      "missing_items_count": "${count} missing item(s)",
      "missing_receipt": "Missing receipt",
      "missing_payment_document": "Add a payment or receipt document",
      "missing_insurance_outcome": "Add an insurance or reimbursement outcome",
      "missing_payer_allocation": "Confirm who paid this expense",
      "missing_eligibility_context": "Confirm this is an eligible medical expense",
      "not_medical_expense": "Not a medical expense",
      "tax_eligibility": "Tax eligibility",
      "tax_eligibility_body": "Answer these questions so we can separate potential expenses from confirmed medical deductions.",
      "tax_expense_type": "Expense type",
      "tax_expense_medical": "Medical expense",
      "tax_expense_not_medical": "Not medical",
      "tax_expense_unknown": "Not sure",
      "tax_care_recipient": "Who received care?",
      "tax_care_self": "Me",
      "tax_care_spouse": "Spouse",
      "tax_care_dependent": "Dependent",
      "tax_care_other": "Someone else",
      "tax_care_unknown": "Not sure",
      "tax_insurance_outcome": "Reimbursement outcome",
      "tax_insurance_not_applicable": "Not applicable",
      "tax_insurance_not_reimbursed": "Not reimbursed",
      "tax_insurance_partially_reimbursed": "Partially reimbursed",
      "tax_insurance_fully_reimbursed": "Fully reimbursed",
      "tax_insurance_unknown": "Not sure",
      "missing_amount_or_date": "Confirm the amount and paid date",
      "missing_provider": "Add the provider",
      "ready_for_review": "Ready for review",
      "needs_your_decision": "Needs your decision",
      "excluded_from_review": "Excluded from review",
      "included_in_review": "Included in review",
      "tax_review_decision": "Tax review decision",
      "tax_review_decision_body": "Choose whether this expense should count toward your potential deduction.",
      "include_expense_in_review": "Include in review",
      "exclude_expense_from_review": "Exclude from review",
      "reset_expense_review_decision": "Reset decision",
      "review_expense": "Review expense",
      "open_payments": "Open payments",
      "add_expense": "Add expense",
      "payment_records_empty_title": "Your payments and receipts",
      "payment_records_empty_body": "Add a payment or receipt from ${tax_year} to review it here. Claims and reimbursements are not counted as deductible expenses.",
      "no_records_title": "No payment records yet",
      "no_records_body": "Add a payment or receipt anywhere in Costs and it will appear here automatically.",
      "not_enough_information": "Not enough information",
      "invalid_agi": "Enter your AGI, such as 100000.",
      "save_tax_inputs_error": "We couldn't save your tax inputs. Try again.",
      "missing_document_linkage": "The uploaded document is missing its canonical link.",
      "uploaded_document_label": "Uploaded ${kind} document",
      "potential_result_disclaimer": "This is a review aid, not a tax-return calculation or tax advice. Confirm your situation with a qualified tax professional."
    }
  },
  "compare_clinic": {
    "compare_clinic_costs": "Compare Clinic Costs",
    "comparison_coming_soon": "Side-by-side clinic comparison with procedure fees, medication costs, and financing options is on the way.",
    "find_care": "Find Care"
  },
  "faq": {
    "frequently_asked": "Frequently asked"
  },
  "phase_content": {
    "getting_started": {
      "title": "Pre-treatment",
      "description": "This is the preparation phase where you'll complete initial testing and get ready for your cycle. Your clinic will review your medical history, order baseline labs, and create a personalized treatment plan.",
      "key_facts": [
        "You may take birth control pills to synchronize your cycle",
        "Baseline blood tests and ultrasounds will be scheduled",
        "Your medication protocol will be finalized",
        "This is a good time to prepare mentally and ask questions"
      ],
      "typical_duration": "1-4 weeks",
      "what_happens": "Your body is being prepared for the stimulation phase.",
      "when_to_call": [
        "You have questions about your medication protocol",
        "You need help understanding your calendar"
      ]
    },
    "baseline": {
      "title": "Baseline",
      "description": "Baseline testing confirms you're ready to start stimulation. You'll have blood work and an ultrasound to check your hormone levels and ovarian status before beginning medications.",
      "key_facts": [
        "Blood tests check E2, FSH, LH, and progesterone levels",
        "Ultrasound measures your antral follicle count (AFC)",
        "Results determine if you're ready to start or need adjustments",
        "This usually happens on day 2-3 of your period"
      ],
      "typical_duration": "1-2 days",
      "what_happens": "Establishing your baseline hormone levels and follicle count.",
      "when_to_call": [
        "Your period doesn't start as expected",
        "You're unsure when to come in for baseline"
      ]
    },
    "stimulation": {
      "title": "Stimulation",
      "description": "Daily hormone injections stimulate your ovaries to develop multiple eggs. You'll have monitoring visits every 2-3 days with blood work and ultrasounds to track your response.",
      "key_facts": [
        "Injections are given subcutaneously (under the skin) in the abdomen",
        "Most patients take 2-3 different medications",
        "Follicles grow about 1-2mm per day",
        "Estradiol (E2) levels rise as follicles grow",
        "You may feel bloated or have mild discomfort, this is normal",
        "Doses may be adjusted based on your response"
      ],
      "typical_duration": "8-14 days",
      "what_happens": "Multiple follicles are growing, each potentially containing a mature egg.",
      "when_to_call": [
        "Severe abdominal pain or bloating",
        "Difficulty giving yourself injections",
        "You miss a dose or take it at the wrong time",
        "Fever over 100.4°F / 38°C"
      ]
    },
    "trigger": {
      "title": "Trigger Shot",
      "description": "The trigger shot causes final egg maturation. This injection must be given at the exact time prescribed by your doctor. Egg retrieval happens exactly 36 hours after the trigger.",
      "key_facts": [
        "Usually given as a single injection (Ovidrel, Lupron, or dual trigger)",
        "TIMING IS CRITICAL: take at the exact time prescribed",
        "Retrieval is scheduled exactly 36 hours later",
        "Stop all other stimulation medications unless told otherwise",
        "You may need to mix the medication, follow instructions carefully"
      ],
      "typical_duration": "36 hours until retrieval",
      "what_happens": "The trigger mimics the natural LH surge, causing eggs to complete maturation.",
      "when_to_call": [
        "You're unsure how to mix or administer the trigger",
        "You miss the trigger or take it at the wrong time",
        "You have a reaction to the injection"
      ]
    },
    "retrieval": {
      "title": "Egg Retrieval",
      "description": "A short procedure (15-20 minutes) under light sedation where eggs are collected from your ovaries using ultrasound-guided aspiration. You'll go home the same day. Plan to rest for 1-2 days afterward.",
      "key_facts": [
        "No food or water after midnight before the procedure",
        "Bring a companion — you cannot drive after sedation and someone must sign you out",
        "Wear comfortable, loose clothing (no jewelry, contacts, or nail polish)",
        "The procedure takes about 15-20 minutes",
        "You'll rest in recovery for 1-2 hours",
        "Mild cramping and bloating afterward is normal — most people take 1-2 days off work",
        "Your doctor will tell you how many eggs were collected before you leave",
        "Avoid strenuous activity for 1-2 weeks to prevent ovarian torsion while ovaries are still enlarged"
      ],
      "typical_duration": "1 day (procedure + 1-2 days recovery)",
      "what_happens": "A needle guided by ultrasound aspirates fluid from each follicle to collect eggs. You'll be under light sedation (IV anesthesia) and won't feel the procedure.",
      "when_to_call": [
        "Heavy bleeding (more than a period)",
        "Fever over 100.4°F / 38°C",
        "Severe pain not relieved by prescribed medication",
        "Difficulty urinating or significantly decreased urine output",
        "Rapid weight gain or severe abdominal swelling (signs of OHSS)"
      ]
    },
    "fertilization": {
      "title": "Fertilization & Development",
      "description": "In the lab, eggs and sperm are combined (IVF) or a single sperm is injected into each egg (ICSI). Embryologists monitor development over 5-7 days.",
      "key_facts": [
        "Not all eggs will fertilize, this is normal",
        "Fertilization results are usually available the next day",
        "Embryos are graded on days 3 and 5",
        "Some attrition is expected at each stage",
        "PGT-A testing (if planned) happens around day 5-7"
      ],
      "typical_duration": "5-7 days",
      "what_happens": "Eggs are being fertilized and developing into embryos in the lab.",
      "when_to_call": [
        "You have questions about your fertilization report",
        "You need to discuss freezing vs. transfer plans"
      ]
    },
    "transfer": {
      "title": "Embryo Transfer",
      "description": "A selected embryo is carefully placed into the uterus using a thin catheter. This quick, painless procedure doesn't require sedation.",
      "key_facts": [
        "The procedure takes about 5-10 minutes",
        "No sedation needed, you'll be awake",
        "Your doctor may recommend bed rest for 24-48 hours",
        "Continue progesterone as prescribed",
        "A full bladder may be requested for ultrasound guidance"
      ],
      "typical_duration": "1 day",
      "what_happens": "An embryo is gently placed into your uterine cavity.",
      "when_to_call": [
        "Heavy bleeding or cramping after the procedure",
        "You have questions about activity restrictions"
      ]
    },
    "waiting": {
      "title": "Two-Week Wait",
      "description": "The waiting period between embryo transfer and pregnancy test. This is often the most emotionally challenging part. Be kind to yourself.",
      "key_facts": [
        "Continue all prescribed medications (especially progesterone)",
        "A blood test (beta-hCG) is typically done 10-14 days after transfer",
        "Mild cramping and spotting can be normal and don't indicate the outcome",
        "Avoid home pregnancy tests: they can give false results",
        "Gentle activity is fine; avoid strenuous exercise"
      ],
      "typical_duration": "10-14 days",
      "what_happens": "The embryo is implanting and beginning to develop.",
      "when_to_call": [
        "Heavy bleeding (soaking a pad)",
        "Severe pain or cramping",
        "You feel dizzy or faint",
        "Emotional distress: support is available"
      ]
    },
    "complete": {
      "title": "Cycle Complete",
      "description": "Your treatment cycle is complete. Your care team will review results with you and discuss next steps, whether that's additional cycles, transfer planning, or long-term storage.",
      "key_facts": [
        "Schedule a follow-up with your doctor to discuss results",
        "Review your frozen specimen inventory",
        "Discuss future plans and timing"
      ],
      "typical_duration": "",
      "what_happens": "Your cycle data has been recorded for your medical history.",
      "when_to_call": [
        "You want to discuss results or next steps",
        "You have ongoing symptoms from the cycle"
      ]
    }
  },
  "test_preview": {
    "amh": {
      "test_name": "AMH",
      "test_purpose": "Reflects the size of your remaining egg supply",
      "value": "2.1",
      "unit": "ng/mL",
      "headline": "Your AMH is in the normal range for your age",
      "interpretation": "AMH (Anti-Müllerian Hormone) reflects the size of your remaining egg supply. Your value sits in the typical range for your age.",
      "what_this_means": "Your clinic can use this to plan a standard stimulation protocol. Expect 10-15 eggs retrieved per cycle, give or take.",
      "next_step": "Pair this with an antral follicle count (AFC) ultrasound on cycle day 2-3 for the fullest picture."
    },
    "fsh": {
      "test_name": "FSH",
      "test_purpose": "How hard your body works to mature an egg",
      "value": "12.5",
      "unit": "mIU/mL",
      "headline": "Your FSH is higher than expected",
      "interpretation": "FSH (Follicle-Stimulating Hormone) is what your brain releases to recruit a follicle each cycle. A higher value means your body is working harder than usual to get there.",
      "what_this_means": "Your clinic may adjust your stimulation protocol and dose to account for this.",
      "next_step": "Discuss with your RE whether a higher-dose protocol is right for you."
    },
    "vitamin_d": {
      "test_name": "Vitamin D",
      "test_purpose": "Supports egg quality and implantation",
      "value": "18",
      "unit": "ng/mL",
      "headline": "Your vitamin D is below the typical range",
      "interpretation": "Vitamin D is linked to egg quality, implantation, and overall fertility outcomes. Below 30 ng/mL is generally considered insufficient.",
      "what_this_means": "Bringing your level above 30 ng/mL before retrieval is a common, low-cost optimization.",
      "next_step": "Ask your clinic about supplementation (typically 2,000 to 4,000 IU/day) and retesting in 8 to 12 weeks."
    },
    "tsh": {
      "test_name": "TSH",
      "test_purpose": "How your thyroid is keeping pace with fertility hormones",
      "value": "See details",
      "unit": "mIU/L",
      "headline": "Your TSH is on the higher side of typical",
      "interpretation": "TSH (Thyroid-Stimulating Hormone) below 2.5 mIU/L is considered ideal during fertility treatment. Yours is just above that threshold.",
      "what_this_means": "Your clinic may want to bring this down before retrieval or transfer to support implantation.",
      "next_step": "Ask whether a low-dose thyroid medication is worth considering for this cycle."
    }
  },
  "treatment_dashboard": {
    "cycle_fallback": "Treatment",
    "monitoring_hint": {
      "label": "Not scheduled yet",
      "detail": "Ultrasound + bloodwork"
    },
    "follicle_bands": {
      "small_label": "Small",
      "small_range": "<10mm",
      "growing_label": "Growing",
      "growing_range": "10-13mm",
      "near_ready_label": "Near-ready",
      "near_ready_range": "14-17mm",
      "ready_label": "Ready",
      "ready_range": "18mm+",
      "unknown_label": "Measured",
      "unknown_range": "size not listed"
    },
    "phases": {
      "baseline": {
        "side_effects": "No medication side effects yet. You may still be on birth control pills from the suppression phase.",
        "when_to_call": "If you start your period before your baseline appointment, call your clinic to confirm timing."
      },
      "stimulation": {
        "side_effects": "Bloating, mood swings, fatigue, headaches. These are normal responses to rising estrogen. You may feel your ovaries: they're enlarging to accommodate growing follicles.",
        "when_to_call": "Severe pain, difficulty breathing, sudden weight gain (>2 lbs/day), very dark urine, or fever. These could indicate ovarian hyperstimulation syndrome (OHSS)."
      },
      "trigger": {
        "side_effects": "You may feel a surge of bloating and breast tenderness as your eggs undergo final maturation. This is your body's response to the surge of hormones.",
        "when_to_call": "If you accidentally take the trigger at the wrong time, call immediately. Timing is critical for retrieval success."
      },
      "retrieval": {
        "side_effects": "Cramping and bloating are normal after retrieval. You may have light spotting. Rest for the remainder of the day. Most women return to normal activities within 1-2 days.",
        "when_to_call": "Fever, heavy bleeding, severe pain not relieved by over-the-counter medication, or signs of OHSS (rapid weight gain, difficulty breathing, decreased urination)."
      },
      "fertilization": {
        "side_effects": "You may still feel bloated from the retrieval. Continue prescribed medications (usually progesterone). Stay hydrated and rest.",
        "when_to_call": "If your clinic hasn't contacted you with fertilization results by the next afternoon."
      },
      "embryo_development": {
        "side_effects": "Recovery from retrieval continues. Follow your clinic's instructions for progesterone and other medications.",
        "when_to_call": "If you haven't received an update from your embryology team by day 6."
      },
      "transfer": {
        "side_effects": "You may feel mild cramping. There's no need for bed rest. Normal activity is fine. Continue progesterone as prescribed.",
        "when_to_call": "Heavy bleeding, severe cramping, or fever after the procedure."
      },
      "waiting": {
        "side_effects": "Cramping, spotting, breast tenderness: these can mean pregnant OR not pregnant. They're mostly caused by the progesterone you're taking. Trust the blood test, not symptoms.",
        "when_to_call": "Heavy bleeding, severe pain, or signs of OHSS."
      },
      "complete": {
        "side_effects": "Your body will return to its normal cycle within 1-2 weeks.",
        "when_to_call": "Any concerning symptoms post-procedure."
      }
    }
  },
  "test_result_insights": {
    "amh": {
      "test_purpose": "Reflects the size of your remaining egg supply",
      "test_name": "AMH (Anti-Müllerian Hormone)"
    },
    "fsh": {
      "test_purpose": "How hard your body works to mature an egg",
      "test_name": "FSH (Follicle-Stimulating Hormone)"
    },
    "sa": {
      "test_purpose": "Sperm count, motility, and morphology together",
      "test_name": "Semen Analysis",
      "value_see_details": "See details"
    },
    "progesterone": {
      "test_purpose": "Signals ovulation and supports early pregnancy",
      "test_name": "Progesterone"
    },
    "e2": {
      "test_purpose": "Estrogen rising with growing follicles — a key stimulation signal",
      "test_name": "Estradiol (E2)"
    },
    "lh": {
      "test_purpose": "The hormone that triggers ovulation — timing signal for the cycle",
      "test_name": "LH (Luteinizing Hormone)"
    }
  },
  "partner_invite_landing": {
    "eyebrow": "Partner Invite",
    "title_named": "${name} invited you",
    "title_default": "You've been invited",
    "body_named": "${name} chose Louise to navigate their fertility care from start to finish. Through our +1 feature, join them to stay in the loop on appointments, treatment milestones, and next steps, so you can be there for each other through it all.",
    "body_default": "Your partner chose Louise to navigate their fertility care from start to finish. Through our +1 feature, join them to stay in the loop on appointments, treatment milestones, and next steps, so you can be there for each other through it all.",
    "link_is_incomplete": "This invitation link is incomplete",
    "ask_partner_to_resend": "Ask your partner to send the invitation again before continuing.",
    "get_started": "Get started"
  },
  "all_lab_results": {
    "back": "Back",
    "title_all": "All Results & Labs",
    "title_for_cycle": "${cycle} Tests & Labs",
    "search_placeholder": "Search results...",
    "count_one": "${count} result",
    "count_other": "${count} results",
    "count_filtered_one": "${count} of ${total} results",
    "count_filtered_other": "${count} of ${total} results",
    "no_results_found": "No results found",
    "no_results_filtered": "No results match these filters",
    "clear_filters": "Clear filters",
    "no_date": "No date",
    "see_details": "See details",
    "needs_review": "${name} needs review",
    "compare_with_range": "Compare with the reference range: ${range}",
    "badge_waiting": "Waiting",
    "badge_scheduled": "Scheduled",
    "name_unknown": "Unknown",
    "purpose_amh": "Reflects the size of your remaining egg supply",
    "purpose_fsh": "How hard your body works to mature an egg",
    "purpose_vitamin_d": "Supports egg quality, hormones, and general health",
    "purpose_tsh": "How your thyroid is keeping pace with fertility hormones",
    "purpose_default": "Latest value available in your records",
    "empty_title": "Upload any result",
    "empty_body": "Drop lab reports, ultrasound summaries, imaging files, genetics, full records, or several files at once. Louise will scan them and create results where it can.",
    "empty_note": "You can also upload a full records packet. We will pull out test results automatically when the documents are clear enough.",
    "empty_manual_entry": "Enter result manually",
    "empty_chip_blood_work": "Blood work",
    "empty_chip_hormones": "Hormones",
    "empty_chip_ultrasounds": "Ultrasounds",
    "empty_chip_imaging": "Imaging",
    "empty_chip_genetics": "Genetics",
    "empty_chip_semen": "Semen analysis",
    "empty_chip_pathology": "Pathology",
    "empty_chip_full_records": "Full records",
    "filter_all": "All",
    "filter_all_cycles": "All cycles",
    "filter_current_cycle": "Current cycle",
    "filter_cycle_fallback": "Cycle",
    "filter_no_cycle": "No cycle",
    "filter_blood": "Blood",
    "filter_imaging": "Imaging",
    "filter_genetics": "Genetics",
    "filter_urine": "Urine",
    "filter_semen": "Semen",
    "filter_pathology": "Pathology",
    "filter_other": "Other",
    "filter_resulted": "Resulted",
    "filter_pending": "Pending",
    "filter_needs_review": "Needs review",
    "manual_title": "Add test result",
    "manual_subtitle": "Enter the basics now. You can add more details later from the result.",
    "manual_upload_title": "Upload a test result",
    "manual_upload_subtitle": "Drag and drop or choose files",
    "manual_type_blood": "Blood",
    "manual_type_imaging": "Imaging",
    "manual_type_genetics": "Genetic",
    "manual_type_semen": "Semen",
    "manual_type_urine": "Urine",
    "manual_type_other": "Other",
    "manual_name_placeholder": "Test name",
    "manual_value_placeholder": "Value",
    "manual_unit_placeholder": "Unit",
    "manual_date_placeholder": "Date, YYYY-MM-DD",
    "manual_save": "Save result",
    "manual_notes": "Manually entered in Louise",
    "manual_error_required": "Add a test name, value, and date to save this result.",
    "manual_error_save": "We could not save this result. Please try again."
  },
  "auth": {
    "session_recovery": {
      "taking_longer_than_expected": "Louise is taking longer than expected",
      "session_setup_failed": "We couldn't finish setting up this session. You can reload or sign out and start again.",
      "reload": "Reload Louise",
      "sign_out": "Sign out"
    },
    "two_fa_challenge": {
      "title_totp": "Two-factor authentication",
      "title_recovery": "Recovery code",
      "subtitle_totp": "Enter the 6-digit code from your authenticator app.",
      "subtitle_recovery": "Enter one of your recovery codes.",
      "placeholder_recovery": "Recovery code",
      "error_invalid_totp": "Invalid code. Please try again.",
      "error_invalid_recovery": "Invalid recovery code.",
      "error_generic": "Something went wrong. Please try again.",
      "verify": "Verify",
      "use_recovery_code": "Lost your authenticator? Use a recovery code",
      "back_to_totp": "Back to authenticator code",
      "use_passkey": "Use a passkey",
      "subtitle_passkey": "Use your passkey to verify it's you.",
      "error_passkey": "Couldn't verify your passkey. Please try again."
    }
  },
  "chat": {
    "have_a_question": "Have a question? Chat with us",
    "reply_time": "We typically reply within an hour",
    "hub": {
      "close_chat": "Close chat",
      "open_chat": "Open chat",
      "mode_care_label": "Care team",
      "mode_care_short": "Care",
      "mode_support_label": "Support",
      "mode_support_short": "Support",
      "ai_title": "Louise AI",
      "ai_subtitle": "Your personal co-pilot",
      "ai_empty_prompt": "Ask me anything. If it’s about your care, I’ll help you make sense of it and figure out what comes next.",
      "ai_input_placeholder": "What's on your mind?",
      "care_title": "Your Care Team",
      "care_subtitle": "Clinic messages",
      "care_empty_prompt": "Care-team messaging is coming soon. Your clinic or care team hasn't connected with Louise for direct messaging yet. This isn't anything you've done.",
      "care_empty_title": "Care-team messaging",
      "care_team_fallback": "your care team",
      "care_clinic_empty_prompt": "${clinic} hasn't connected with Louise for direct messaging yet. This isn't anything you've done.",
      "care_connected_empty_prompt": "Messaging with your care team is coming soon. ${clinic} is connected to Louise, but clinic messages aren't available here yet.",
      "care_input_placeholder": "Care-team messaging is coming soon.",
      "support_title": "Louise Support",
      "support_subtitle": "Product support",
      "support_empty_prompt": "Ask Louise Support about the app. A member of our product support team will reply here.",
      "support_team_label": "Louise product support",
      "support_loading": "Loading your support conversation…",
      "support_input_placeholder": "Ask Louise support for help with the app."
    }
  },
  "home": {
    "loading": "Loading your plan...",
    "lets_set_up_plan": "Let's set up your plan.",
    "choose_your_journey": "Choose your journey",
    "helper_not_available_title": "Coming soon to France",
    "helper_not_available_body": "We're adapting the donor and surrogate paths for the French system. In the meantime, you can explore the rest of Louise from the bottom tab bar.",
    "greeting_morning": "Good morning",
    "greeting_morning_named": "Good morning, ${name}",
    "greeting_afternoon": "Good afternoon",
    "greeting_afternoon_named": "Good afternoon, ${name}",
    "greeting_evening": "Good evening",
    "greeting_evening_named": "Good evening, ${name}",
    "your_partner_fallback": "your partner",
    "back": "Back",
    "appointment_fallback": "Appointment",
    "online": "Online",
    "clinic_visit": "Clinic visit",
    "any_time": "Any time",
    "test_result_fallback": "Test result",
    "result_recorded": "Result recorded",
    "daily_check_in": "Daily check-in",
    "symptoms_logged": "Symptoms logged",
    "logged_with_symptom": "Logged: ${symptom}",
    "medication_fallback": "Medication",
    "take_as_prescribed": "Take as prescribed",
    "alert_unable_to_start_cycle_title": "Unable to start cycle",
    "alert_unable_to_start_cycle_body": "Something went wrong. Please try again.",
    "alert_ok": "OK",
    "oauth_phone_link": {
      "chat_from_your_phone": "Chat with Louise from your phone",
      "confirm_phone_number": "Confirm your phone number",
      "connect_account_to_texting_concierge": "This keeps your account more secure while giving you access to more features.",
      "otp_subtitle": "We sent a 6-digit code to ${phone}",
      "otp_resend": "Resend code",
      "otp_send_failed": "We couldn't send the code. Try again.",
      "otp_invalid_code": "That code isn't right. Try again.",
      "otp_save_failed": "Your number was verified, but we couldn't finish saving it. Try again.",
      "change_phone_number": "Change number",
      "save_verified_phone": "Save verified number",
      "phone_verified_title": "Your number is verified",
      "phone_verified_subtitle": "Your number is saved to your account and ready for more secure features.",
      "phone_verified_done": "Done",
      "message_user_question": "What should I do next?",
      "message_concierge_reply": "Let's look at your plan.",
      "phone_placeholder": "Phone number",
      "phone_required": "Enter your phone number to continue",
      "add_phone": "Add my phone number"
    },
    "what_to_know": "What to know",
    "about_you": "About you",
    "side_effects_title": "Common side effects right now",
    "log_my_symptoms": "Log my symptoms",
    "when_to_call_clinic": "When to call your clinic",
    "call_my_clinic": "Call my clinic",
    "add_my_clinic": "Add my clinic",
    "no_clinic_on_file": "We do not have your clinic on file yet. Tap to find it so you can call them in one tap next time.",
    "donor_modal": {
      "title_source": "Are you doing this with a partner or a donor?",
      "title_donor_status": "Do you already have a donor selected?",
      "partner_title": "Partner",
      "partner_subtitle": "Invite them into Louise so their side of the plan can be included.",
      "donor_title": "Donor",
      "donor_subtitle": "Tell us whether the donor is already selected or you need help finding one.",
      "donor_selected_title": "I already selected a donor",
      "donor_selected_subtitle": "Add the donor source and documents that the clinic will need before the cycle.",
      "donor_need_help_title": "I need help finding one",
      "donor_need_help_subtitle": "Go to donor matching and registry support."
    },
    "coverage_modal": {
      "title": "What coverage should we check first?",
      "body": "Fertility costs can be affected by health insurance, employer benefits, pharmacy benefits, state rules, and self-pay options.",
      "health_insurance_title": "Health insurance",
      "health_insurance_subtitle": "Add carrier and member details so we can check fertility, diagnostics, medication, and storage coverage.",
      "employer_benefit_title": "Employer fertility benefit",
      "employer_benefit_subtitle": "Check programs like Progyny, Carrot, Maven, Kindbody, or direct employer coverage.",
      "unsure_title": "I'm not sure",
      "unsure_subtitle": "See the cost overview first, including self-pay ranges, grants, financing, HSA/FSA, and what to verify."
    },
    "helper_steps": {
      "donor": {
        "apply_title": "Apply to a clinic or agency",
        "apply_subtitle": "Browse partners accepting new donors and submit your application. They're the ones who fund screening, so they come first.",
        "screened_title": "Get screened",
        "screened_subtitle": "Once accepted, your clinic schedules and pays for medical, psychological, and genetic screening.",
        "match_title": "Match with intended parents",
        "match_subtitle": "Your profile is shared with potential intended parents looking for a donor.",
        "sign_title": "Sign your donor agreement",
        "sign_subtitle": "Review and sign legal documents covering rights, terms, and compensation.",
        "begin_title": "Begin your donation cycle",
        "begin_subtitle": "The procedure itself: egg retrieval or sperm-donation visits, depending on your path."
      },
      "carrier": {
        "apply_title": "Apply to a surrogacy agency",
        "apply_subtitle": "Browse agencies accepting new carriers and submit your application. They coordinate (and fund) screening once you're in.",
        "screened_title": "Get screened",
        "screened_subtitle": "Your agency or its partner clinic schedules and covers medical, psychological, and obstetric evaluation.",
        "match_title": "Match with intended parents",
        "match_subtitle": "Your agency introduces you to families looking for a surrogate.",
        "sign_title": "Sign your surrogacy agreement",
        "sign_subtitle": "Review and sign legal documents covering medical, financial, and post-birth terms.",
        "begin_title": "Begin treatment",
        "begin_subtitle": "Medication prep, embryo transfer, pregnancy, and postpartum care."
      }
    },
    "learn_card": {
      "title": "Learn",
      "subtitle": "Articles on screening, what to expect, and the conditions involved."
    }
  },
  "plan_builder_card": {
    "your_plan_is_ready": "Your plan is ready",
    "personalized_based_on": "Personalized based on your answers",
    "edit": "Edit",
    "continue_building": "Continue building your plan",
    "lets_build": "Let's build your plan",
    "pick_up_where": "Pick up where you left off.",
    "tailor_everything": "A few quick questions to tailor everything to you.",
    "benefit_testing": "Testing built around your body",
    "benefit_clinics": "Clinics and costs, compared for you",
    "benefit_timeline": "A timeline that fits your life",
    "benefit_guidance": "Guidance at every step",
    "continue": "Continue",
    "get_started": "Get started",
    "just_3_minutes": "Just 3 minutes"
  },
  "role_banner": {
    "donor_title": "Donor support",
    "donor_body": "Tailored compensation guidance, screening expectations, and clinic matching for egg and sperm donors are on the way.",
    "carrier_title": "Surrogate support",
    "carrier_body": "Tailored compensation guidance, legal pathways, and stage-by-stage expectations for surrogates are on the way.",
    "intended_parent_title": "Intended parent support",
    "intended_parent_body": "Tailored surrogacy and donor pathways, agency matching, and legal guidance for intended parents are on the way."
  },
  "active_cycle": {
    "progress_through_cycle": "${percent}% through your cycle"
  },
  "condition_insight": {
    "your_condition": "Your condition",
    "show_less": "Show less",
    "learn_more": "Learn more",
    "recommended_supplements": "Recommended supplements"
  },
  "test_result": {
    "your_result": "Your result",
    "category_normal": "Normal",
    "category_low": "Below range",
    "category_high": "Above range",
    "category_borderline": "Borderline",
    "show_less": "Show less",
    "what_this_means": "What this means for your treatment",
    "suggested_next_step": "Suggested next step"
  },
  "plan_builder": {
    "save_failure_title": "Your progress was not saved",
    "save_failure_detail": "This change could not be kept on this device. Try again.",
    "continue": "Continue",
    "age": {
      "title": "When were you born?",
      "subtitle": "Age affects fertility timelines, testing protocols, and the guidance we provide. We use this to personalize your plan.",
      "placeholder": "MM/DD/YYYY",
      "age_label": "Age ${age}",
      "invalid": "Please enter a valid date of birth."
    },
    "goal_recap": {
      "title": "Which goal best describes you?",
      "subtitle": "Select your goal so we can tailor your plan.",
      "preserve_label": "Fertility preservation",
      "preserve_label_female": "Egg freezing",
      "preserve_label_male": "Sperm freezing",
      "preserve_detail": "Preserve your fertility for the future",
      "preserve_detail_female": "Freeze and store your eggs",
      "preserve_detail_male": "Bank and store your sperm",
      "embryo_label": "Embryo freezing",
      "embryo_detail": "Create and store embryos",
      "pregnancy_label": "Pregnancy",
      "pregnancy_detail": "Trying to conceive with or without treatment",
      "egg_donation_label": "Egg donation",
      "egg_donation_detail": "Become an egg donor",
      "sperm_donation_label": "Sperm donation",
      "sperm_donation_detail": "Become a sperm donor"
    },
    "modality": {
      "title": "What treatments are you considering?",
      "subtitle": "Select all that apply. This helps us tailor your journey steps, testing, and cost estimates. You can always change this later.",
      "ivf_label": "IVF",
      "ivf_description": "In vitro fertilization — eggs are retrieved and fertilized in a lab.",
      "iui_label": "IUI",
      "iui_description": "Intrauterine insemination — sperm is placed directly in the uterus.",
      "fet_label": "Frozen embryo transfer",
      "fet_description": "Transfer an embryo that is already frozen; no egg retrieval is part of this path.",
      "not_sure_label": "I'm not sure yet",
      "not_sure_description": "We'll help you understand the options and figure out the right path."
    },
    "accepted_plan": {
      "current_plan_title": "What treatment plan have you accepted?",
      "current_plan_subtitle": "Tell us what you and your clinic have agreed to. This is separate from treatments you are still considering, and it helps us show the right next steps.",
      "distinction_note": "If your plan is not decided yet, choose that option. We will keep your journey exploratory instead of guessing.",
      "treatment_family_prompt": "Which treatment is in your current plan?",
      "fertilization_method_prompt": "How will the eggs be fertilized?",
      "egg_source_prompt": "Where will the eggs come from?",
      "egg_state_prompt": "What is the egg state?",
      "sperm_source_prompt": "Where will the sperm come from?",
      "sperm_state_prompt": "What is the sperm state?",
      "transfer_plan_prompt": "What is the transfer plan?",
      "pgt_plan_prompt": "Is genetic testing planned?",
      "decision_source_prompt": "Who made this treatment decision?",
      "ivf_option": "IVF",
      "ivf_detail": "Eggs will be retrieved and fertilized in a laboratory.",
      "iui_option": "IUI",
      "iui_detail": "Prepared sperm will be placed directly in the uterus.",
      "egg_freezing_option": "Egg freezing",
      "egg_freezing_detail": "Eggs will be retrieved and stored for later.",
      "embryo_freezing_option": "Embryo freezing",
      "embryo_freezing_detail": "Embryos will be created and stored for later.",
      "sperm_freezing_option": "Sperm freezing",
      "sperm_freezing_detail": "Sperm will be collected and stored for later.",
      "fet_option": "Frozen embryo transfer",
      "fet_detail": "A stored embryo will be thawed and transferred.",
      "conventional_ivf_option": "Conventional IVF",
      "conventional_ivf_detail": "Eggs and sperm are placed together to fertilize.",
      "icsi_option": "ICSI",
      "icsi_detail": "A single sperm is injected into each selected egg.",
      "split_ivf_icsi_option": "Split IVF and ICSI",
      "split_ivf_icsi_detail": "Eggs are divided between conventional IVF and ICSI.",
      "rescue_icsi_option": "Rescue ICSI",
      "rescue_icsi_detail": "ICSI is used when conventional fertilization does not occur.",
      "self_source_option": "My own",
      "self_source_detail": "My own eggs or sperm.",
      "partner_source_option": "My partner's",
      "partner_source_detail": "Eggs or sperm from my partner.",
      "donor_source_option": "A donor's",
      "donor_source_detail": "Donor eggs or sperm.",
      "external_source_option": "Another source",
      "external_source_detail": "A source arranged outside this clinic.",
      "fresh_state_option": "Fresh",
      "fresh_state_detail": "Collected or used without being frozen.",
      "frozen_state_option": "Frozen",
      "frozen_state_detail": "Previously frozen and stored.",
      "surgically_retrieved_option": "Surgically retrieved",
      "surgically_retrieved_detail": "Retrieved using a surgical procedure.",
      "fresh_transfer_option": "Fresh transfer",
      "fresh_transfer_detail": "Transfer in the same treatment cycle.",
      "freeze_all_option": "Freeze all",
      "freeze_all_detail": "Freeze embryos now and plan transfer later.",
      "later_fet_option": "Transfer later",
      "later_fet_detail": "Plan a frozen embryo transfer in a later cycle.",
      "no_transfer_option": "No transfer planned",
      "no_transfer_detail": "There is no embryo transfer in this plan.",
      "pgt_a_option": "PGT-A",
      "pgt_a_detail": "Testing for chromosome number.",
      "pgt_m_option": "PGT-M",
      "pgt_m_detail": "Testing for a specific inherited condition.",
      "pgt_sr_option": "PGT-SR",
      "pgt_sr_detail": "Testing for structural chromosome rearrangements.",
      "other_pgt_option": "Another genetic test",
      "other_pgt_detail": "A different test recommended by your care team.",
      "not_planned_option": "No genetic testing planned",
      "not_planned_detail": "Genetic testing is not part of this plan.",
      "patient_decision_option": "I decided",
      "patient_decision_detail": "This reflects my own treatment decision.",
      "clinic_decision_option": "My clinic decided",
      "clinic_decision_detail": "This was selected by my care team.",
      "shared_decision_option": "My clinic and I decided together",
      "shared_decision_detail": "This was a shared treatment decision.",
      "not_applicable_option": "Not applicable",
      "not_applicable_detail": "This part does not apply to my plan.",
      "not_decided_option": "Not decided yet",
      "not_decided_detail": "I do not have a confirmed answer yet.",
      "continue_with_plan": "Continue with this plan",
      "save_failed": "We couldn't save your treatment plan. Please try again."
    },
    "conditions": {
      "title": "Any relevant medical history?",
      "subtitle": "Select anything that applies. This helps us adjust your testing recommendations and flag relevant information.",
      "pcos": "PMOS (ex PCOS)",
      "endometriosis": "Endometriosis",
      "thyroid_disease": "Thyroid condition",
      "irregular": "Irregular periods",
      "loss": "Pregnancy loss",
      "low_ovarian_reserve": "Diminished ovarian reserve",
      "male_factor": "Male factor infertility",
      "cancer": "Cancer (current or past)",
      "other": "Other",
      "none_or_unsure": "None / not sure"
    },
    "ethnicity": {
      "title": "What's your ethnicity?",
      "subtitle": "Select all that apply. Certain genetic conditions are more common in specific populations. This helps us recommend the right carrier screenings.",
      "white": "White / Caucasian",
      "black": "Black / African American",
      "hispanic": "Hispanic / Latino",
      "east_asian": "East Asian",
      "south_asian": "South Asian",
      "southeast_asian": "Southeast Asian",
      "middle_eastern": "Middle Eastern / North African",
      "native_american": "Native American / Alaska Native",
      "pacific_islander": "Pacific Islander",
      "mixed": "Mixed / Multiracial",
      "prefer_not_to_say": "Prefer not to say"
    },
    "partner_status": {
      "title": "Who are you doing this with?",
      "subtitle": "This determines the testing and legal steps in your plan.",
      "with_partner_label": "With a partner",
      "with_partner_detail": "Using your partner's sperm or eggs",
      "using_donor_label": "Using a donor",
      "using_donor_detail": "Donor sperm, eggs, or embryos",
      "solo_label": "On my own",
      "solo_detail": "Solo with donor gametes"
    },
    "clinic_status": {
      "title": "Where are you with finding a clinic?",
      "subtitle": "This helps us tailor your plan to where you are right now.",
      "no_clinic_label": "Not looking yet",
      "no_clinic_sublabel": "Still learning about the process",
      "researching_label": "Researching clinics",
      "researching_sublabel": "Comparing options, haven't chosen yet",
      "at_clinic_label": "Already at a clinic",
      "at_clinic_sublabel": "I've chosen a clinic or had a consultation"
    },
    "timeline": {
      "title": "When are you looking to start?",
      "subtitle": "This helps us prioritize your action items.",
      "asap_label": "As soon as possible",
      "asap_detail": "Ready to start now",
      "three_months_label": "Within 3 months",
      "three_months_detail": "Getting things in order first",
      "six_months_label": "Within 6 months",
      "six_months_detail": "Planning ahead",
      "exploring_label": "Just exploring",
      "exploring_detail": "Learning about options"
    },
    "past_cycles": {
      "title": "Have you done any fertility treatments before?",
      "subtitle": "This includes IVF, IUI, egg freezing, embryo freezing, or medicated cycles. Past experience helps us skip what you already know.",
      "yes_label": "Yes, I have or I'm currently in treatment",
      "yes_detail": "Past or ongoing IVF, IUI, egg freezing, or other cycles",
      "no_label": "No, this is my first time",
      "no_detail": "I haven't started any treatments yet"
    },
    "past_cycle_details": {
      "title": "Tell us about your cycles",
      "subtitle": "What type of treatment, how many cycles, and the outcome.",
      "cycle_n": "Cycle ${n}",
      "type_label": "Type",
      "count_label": "How many cycles?",
      "outcome_label": "Outcome",
      "outcome_n_label": "${type} ${n} outcome",
      "add_another": "Add another treatment",
      "type": {
        "ivf": "IVF",
        "iui": "IUI",
        "egg_freezing": "Egg freezing",
        "embryo_freezing": "Embryo freezing",
        "medicated_cycle": "Medicated cycle",
        "other": "Other"
      },
      "outcome": {
        "successful": "Successful",
        "unsuccessful": "Unsuccessful",
        "cancelled": "Cancelled",
        "ongoing": "Still ongoing",
        "prefer_not_to_say": "Prefer not to say"
      }
    },
    "known_results": {
      "title": "Do you have any test results?",
      "subtitle": "If you already have results, we can interpret them and adjust your plan. Skip anything you don't have.",
      "amh_label": "AMH (Anti-Müllerian Hormone)",
      "amh_detail": "Ovarian reserve indicator",
      "amh_unit": "Value (ng/mL)",
      "amh_placeholder": "e.g. 2.5",
      "fsh_label": "FSH (Follicle-Stimulating Hormone)",
      "fsh_detail": "Ovarian function marker",
      "fsh_unit": "Value (mIU/mL)",
      "fsh_placeholder": "e.g. 7.2",
      "sa_label": "Semen Analysis",
      "sa_detail": "Sperm count, motility, morphology",
      "sa_overall_label": "Overall result",
      "sa": {
        "normal": "Normal",
        "borderline": "Borderline",
        "low": "Low",
        "unknown": "Not sure"
      },
      "skip": "I don't have any results yet"
    },
    "location_insurance": {
      "title": "Location and insurance",
      "subtitle": "For clinic recommendations and cost estimates.",
      "zip_label": "ZIP Code",
      "zip_placeholder": "e.g. 10001",
      "postal_label_fr": "Postal code",
      "postal_placeholder_fr": "e.g. 75001",
      "insurance_label": "Do you have health insurance?",
      "insurance_label_fr": "Do you have a mutuelle?",
      "insurance_yes": "Yes",
      "insurance_no": "No",
      "carrier_label": "Insurance carrier (optional)",
      "carrier_placeholder": "e.g. Aetna, UnitedHealthcare",
      "carrier_placeholder_fr": "e.g. MGEN, Harmonie Mutuelle",
      "benefit_label": "Employer fertility benefit?",
      "benefit_yes": "Yes",
      "benefit_no": "No",
      "benefit_not_sure": "Not sure"
    },
    "free_text": {
      "title": "Anything else we should know?",
      "subtitle": "Previous diagnoses, specific concerns, questions you have, or anything that would help us tailor your experience. Completely optional.",
      "placeholder": "e.g. I had one IVF cycle that was cancelled due to poor response. My doctor mentioned diminished ovarian reserve but I want a second opinion...",
      "skip": "Skip",
      "char_count": "${current}/${max}"
    },
    "building": {
      "title": "Building your plan",
      "subtitle": "Tailoring your testing, timeline, and recommendations.",
      "save_error": "Your plan could not be kept safely on this device.",
      "retry_save": "Try saving again"
    },
    "plan_reveal": {
      "title": "Your plan is ready",
      "subtitle": "Here's what we've tailored for you.",
      "goal_journey_fallback": "Your Journey",
      "journey_step_count": "${count} steps — we'll guide you through each one.",
      "testing_title": "Testing tailored to you",
      "testing_have_results": "We'll interpret the results you already have and recommend what's still needed.",
      "testing_no_results": "Based on your goal and history, we've prepared a personalized testing checklist to get started.",
      "clinics_title": "${count}+ clinics to explore",
      "clinics_body": "Compare success rates, costs, and patient reviews — all in one place.",
      "clinics_distance_suffix": " We'll sort them by distance from you.",
      "cost_title": "Cost estimate",
      "cost_out_of_pocket": "estimated out-of-pocket",
      "cost_total": "estimated total",
      "cost_with_insurance": "Upload your insurance details later to get a more precise estimate.",
      "cost_without_insurance": "We'll help you explore financing options and reduction strategies.",
      "conditions_title": "Personalized for your history",
      "conditions_body_prefix": "We've factored in ",
      "conditions_body_suffix": " — you'll see tailored guidance at every step.",
      "accepted_plan_title": "Your current treatment plan",
      "accepted_plan_subtitle": "We'll use these confirmed details to tailor the steps that follow.",
      "accepted_plan_treatment": "Treatment: ${value}",
      "accepted_plan_fertilization": "Fertilization: ${value}",
      "accepted_plan_transfer": "Transfer: ${value}",
      "accepted_plan_genetic_testing": "Genetic testing: ${value}",
      "cta_go_to_plan": "Go to my plan",
      "goal": {
        "preserve": "Egg Freezing",
        "embryo_preserve": "Embryo Freezing",
        "pregnancy": "Getting Pregnant",
        "egg_donation": "Egg Donation",
        "sperm_donation": "Sperm Donation",
        "adoption": "Adoption",
        "surrogacy": "Surrogacy"
      },
      "condition": {
        "pcos": "PMOS (ex PCOS)",
        "endometriosis": "Endometriosis",
        "thyroid_disease": "Thyroid condition",
        "diminished_ovarian_reserve": "Diminished ovarian reserve",
        "primary_ovarian_insufficiency": "Primary ovarian insufficiency",
        "fibroids": "Fibroids",
        "irregular": "Irregular periods",
        "loss": "Pregnancy loss",
        "cancer": "Cancer history",
        "male_factor": "Male factor",
        "other": "Other condition"
      }
    }
  },
  "cost_estimate": {
    "estimated_cost": "Estimated cost",
    "of_total": "of ${total} total",
    "coverage_verified": "Coverage verified",
    "verification_pending": "Verification pending",
    "not_yet_verified": "Not yet verified",
    "no_coverage_uploaded": "No coverage uploaded",
    "insurance_covers": "Insurance covers ${amount}",
    "you_pay": "You pay ${amount}",
    "upload_to_see": "Upload your insurance to see what's covered",
    "see_breakdown": "See full breakdown",
    "hide_breakdown": "Hide breakdown",
    "percent_covered": "${percent}% covered",
    "estimated_total": "Your estimated total",
    "ways_to_reduce": "Ways to reduce your cost",
    "hide_ways_to_reduce": "Hide",
    "disclaimer": "These are national average estimates. Actual costs vary by clinic, location, and protocol. Your clinic will provide a detailed cost breakdown during consultation."
  },
  "onboarding": {
    "back": "Back",
    "continue": "Continue",
    "next": "Next",
    "splash": {
      "eyebrow": "REPRODUCTIVE INTELLIGENCE",
      "title": "Understand every possibility.",
      "body": "Get tested, find the right care, understand costs, manage every step of treatment, and plan what comes next.",
      "get_started": "Get started",
      "text_louise": "Text Louise",
      "already_have_account": "Already have an account?",
      "log_in": "Log in"
    },
    "login": {
      "title": "Welcome back",
      "phone_subtitle": "Log in to pick up where you left off.",
      "or_sign_in_with": "or log in with",
      "sign_in_with": "Log in with ${provider}",
      "passkey": "Sign in with a passkey",
      "passkey_error": "Passkey sign-in didn't work. Try again or use another option.",
      "oauth_error": "That sign-in option didn't work. Try again or use another option.",
      "new_to_louise": "New to Louise?",
      "get_started": "Get started",
      "new_to_louise_get_started": "New to Louise? Get started"
    },
    "welcome_goals": {
      "title": "What brings you to Louise?",
      "subtitle": "We'll personalize everything from here.",
      "preserve_label": "Preserve your fertility",
      "preserve_sublabel": "Freeze eggs, sperm, or embryos",
      "grow_label": "Build your family",
      "grow_sublabel": "Naturally or with treatment",
      "donate_label": "Help someone else",
      "donate_sublabel": "Thinking about donation",
      "learn_label": "Just exploring",
      "learn_sublabel": "See what's out there",
      "already_have_account": "Already have an account?",
      "log_in": "Log in"
    },
    "family_building_path": {
      "title": "How are you planning to build your family?",
      "subtitle": "This helps us understand your family-building context without assuming the rest of your plan.",
      "with_partner_label": "With a partner",
      "with_partner_sublabel": "We're planning this together",
      "on_my_own_label": "On my own",
      "on_my_own_sublabel": "I'm planning this independently",
      "unsure_label": "I'm not sure yet",
      "unsure_sublabel": "Show me the options first"
    },
    "journey_stage": {
      "preserve_title": "What are you looking into?",
      "preserve_subtitle": "This helps us tailor your prep plan and clinic matches.",
      "grow_title": "Where are you in building your family?",
      "grow_subtitle": "We'll match you with the right resources.",
      "exploring_label": "Just exploring",
      "exploring_sublabel": "Not sure yet. I'm learning my options.",
      "egg_freezing_label": "Egg freezing",
      "egg_freezing_sublabel": "Thinking about it or already started",
      "sperm_freezing_label": "Sperm freezing",
      "sperm_freezing_sublabel": "Thinking about it or already started",
      "embryo_freezing_label": "Embryo freezing",
      "embryo_freezing_sublabel": "Thinking about it or already started",
      "trying_naturally_label": "Trying naturally",
      "trying_naturally_sublabel": "No medical intervention yet",
      "exploring_options_label": "Exploring my options",
      "exploring_options_sublabel": "Not sure where to start",
      "getting_ready_label": "Getting ready for treatment",
      "getting_ready_sublabel": "Considering IUI, IVF, or other procedures",
      "in_treatment_label": "Already in treatment",
      "in_treatment_sublabel": "Currently doing IUI, IVF, or similar"
    },
    "treatment_type": {
      "getting_ready_title": "Which treatment are you considering?",
      "getting_ready_subtitle": "Choose the option that feels closest. You can refine this later.",
      "in_treatment_title": "Which treatment are you currently in?",
      "in_treatment_subtitle": "This helps us show the most relevant care and guidance.",
      "ivf_label": "IVF",
      "ivf_sublabel": "In vitro fertilization",
      "iui_label": "IUI",
      "iui_sublabel": "Intrauterine insemination",
      "oi_label": "Ovulation induction",
      "oi_sublabel": "Medication to support ovulation",
      "embryo_freezing_label": "Embryo freezing",
      "embryo_freezing_sublabel": "Create and preserve embryos for later",
      "fet_label": "Frozen embryo transfer",
      "fet_sublabel": "Transfer a previously frozen embryo",
      "not_sure_label": "I'm not sure yet",
      "not_sure_sublabel": "Keep my options open"
    },
    "how_are_you_helping": {
      "title": "How would you like to help?",
      "subtitle": "Pick the path that fits. We'll set up the right experience for you.",
      "egg_label": "Donate eggs",
      "egg_sublabel": "Help others build their family",
      "sperm_label": "Donate sperm",
      "sperm_sublabel": "Help others build their family",
      "carrier_label": "Be a surrogate",
      "carrier_sublabel": "Carry a pregnancy for someone else"
    },
    "working_with_surrogate": {
      "title": "Who will carry the pregnancy?",
      "subtitle": "Whether it's you, your partner, or a surrogate, we'll tailor guidance to your path.",
      "carry_label": "I will carry",
      "carry_sublabel": "I plan to go through the pregnancy",
      "partner_label": "My partner will carry",
      "partner_sublabel": "My partner plans to go through the pregnancy",
      "considering_label": "We're considering surrogacy",
      "considering_sublabel": "We haven't decided who will carry",
      "surrogate_label": "A surrogate will carry",
      "surrogate_sublabel": "Someone outside our partnership will carry"
    },
    "sex": {
      "title": "Your care depends on your biology",
      "subtitle": "This helps us tailor the testing, options, procedures, and guidance that are relevant to you",
      "afab_label": "Female",
      "afab_sublabel": "Assigned female at birth",
      "amab_label": "Male",
      "amab_sublabel": "Assigned male at birth"
    },
    "birthday": {
      "title": "How old are you?",
      "subtitle": "Age is the single biggest factor in fertility. It shapes treatment options, expected outcomes, and how we plan your timeline.",
      "placeholder": "MM/DD/YYYY",
      "years_old": "${age} years old"
    },
    "location": {
      "title": "Where are you based?",
      "subtitle": "Enter your ${label} so we can find clinics and check coverage in your area.",
      "country_search_placeholder": "Search country or code",
      "country_search_no_matches": "No country matches “${query}”",
      "postal_code_optional_subtitle": "Add your postal code if you have one so we can tailor your experience.",
      "postal_code_optional_placeholder": "Postal code (optional)",
      "postal_code_required": "Enter your postal code to continue.",
      "postal_code_invalid": "Enter a valid postal code for this country."
    },
    "partner_confirm": {
      "default_partner_name": "your partner",
      "save_error": "Couldn't save your journey. Please try again.",
      "linking_accounts": "Linking your accounts…",
      "title": "You're joining ${name}",
      "subtitle": "We'll set up your plan to support ${name}'s ${journey} journey. You can adjust this anytime from your profile.",
      "their_journey": "Their journey",
      "cta_save": "Sounds right",
      "cta_saving": "Saving…"
    },
    "auth_callback": {
      "completing_sign_in": "Completing sign in...",
      "sign_in_link_expired": "This sign-in link has expired",
      "link_no_longer_valid": "This link is no longer valid. You can sign in again below.",
      "go_sign_in": "Go sign in"
    },
    "create_account": {
      "loading_putting_together": "Putting it all together...",
      "loading_mapping": "Mapping out your options...",
      "loading_personalizing": "Personalizing your timeline...",
      "loading_ready": "Your journey starts here",
      "saving": "Setting up your account...",
      "welcome_otp": "Enter your code",
      "welcome": "Welcome",
      "welcome_with_name": "Welcome, ${name}",
      "otp_subtitle": "We sent a 6-digit code to ${phone}",
      "phone_subtitle": "We recommend using your phone number to enjoy our texting agent.",
      "or_sign_up_with": "or sign up with",
      "phone_placeholder": "Phone number",
      "phone_label": "Phone number",
      "country_search_placeholder": "Search country or calling code",
      "country_search_no_matches": "No country matches “${query}”",
      "send_code": "Send code",
      "sending": "Sending...",
      "verifying": "Verifying...",
      "resend_code": "Resend code",
      "resend_code_countdown": "Resend code in ${seconds}s",
      "use_different_number": "Use different number",
      "sign_up_with": "Sign up with ${provider}",
      "error_invalid_phone": "Please enter a valid phone number",
      "error_send_failed": "Failed to send code. Try again.",
      "error_invalid_code": "Invalid code. Please try again.",
      "error_verify_failed": "Something went wrong. Please try again.",
      "error_resend_failed": "Failed to resend code. Try again.",
      "error_setup_failed": "Failed to finish setup. Please try again.",
      "setup_recovery_title": "We couldn't finish setting up your account",
      "setup_recovery_body": "Your answers are still saved. Try again to finish setting up your account.",
      "retry_setup": "Retry setup",
      "partner_invite_account_ready": "Your account is ready",
      "partner_invite_unavailable": "Your account was created, but we couldn't connect you to this invitation. Try again, or continue without connecting and ask your partner to send a new invitation.",
      "partner_invite_invalid": "Your account was created, but this invitation is not available. Continue without connecting and ask your partner to send a new invitation.",
      "partner_invite_expired": "Your account was created, but this invitation has expired. Continue without connecting and ask your partner to send a new invitation.",
      "partner_invite_already_used": "Your account was created, but this invitation has already been used. Continue without connecting and ask your partner to send a new invitation.",
      "partner_invite_cancelled": "Your account was created, but this invitation was cancelled. Continue without connecting and ask your partner to send a new invitation.",
      "partner_invite_retry": "Try connecting again",
      "partner_invite_retrying": "Trying again…",
      "partner_invite_continue_unconnected": "Continue without connecting",
      "test_sign_in": "Test sign in",
      "test_email": "Email",
      "test_password": "Password",
      "test_signin_button": "Sign in",
      "test_signin_loading": "Signing in..."
    }
  },
  "country": {
    "us": "United States",
    "gb": "United Kingdom",
    "ca": "Canada",
    "au": "Australia",
    "de": "Germany",
    "fr": "France",
    "es": "Spain",
    "it": "Italy",
    "nl": "Netherlands",
    "se": "Sweden",
    "ch": "Switzerland",
    "ie": "Ireland",
    "nz": "New Zealand",
    "sg": "Singapore",
    "jp": "Japan",
    "kr": "South Korea",
    "in": "India",
    "ae": "UAE",
    "il": "Israel",
    "br": "Brazil",
    "mx": "Mexico",
    "za": "South Africa",
    "xx": "Other"
  },
  "care": {
    "your_care": "Your Care",
    "view_all": "View all",
    "add_medication": "Add medication",
    "add_appointment": "Add appointment",
    "start_a_cycle": "Start a cycle",
    "start_a_cycle_help": "Begin tracking your treatment",
    "active_cycle": {
      "badge": "Active Cycle",
      "started": "Started ${date}"
    },
    "today": {
      "title": "Today"
    },
    "coming_up": {
      "title": "Coming up",
      "see_all": "See all",
      "until": "until ${day}",
      "ongoing": "ongoing",
      "daily_until": "Daily · ${until}"
    },
    "check_in": {
      "title": "Check In",
      "how_are_you_feeling": "How are you feeling"
    },
    "calendar": {
      "title": "Schedule",
      "week": "Week",
      "month": "Month",
      "morning": "Morning",
      "evening": "Evening",
      "as_needed": "As needed",
      "log_period": "Log Period",
      "save_period": "Save period",
      "day_monday": "Monday",
      "day_tuesday": "Tuesday",
      "day_wednesday": "Wednesday",
      "day_thursday": "Thursday",
      "day_friday": "Friday",
      "day_saturday": "Saturday",
      "day_sunday": "Sunday",
      "month_jan": "Jan",
      "month_feb": "Feb",
      "month_mar": "Mar",
      "month_apr": "Apr",
      "month_may": "May",
      "month_jun": "Jun",
      "month_jul": "Jul",
      "month_aug": "Aug",
      "month_sep": "Sep",
      "month_oct": "Oct",
      "month_nov": "Nov",
      "month_dec": "Dec"
    },
    "care_team": {
      "title": "Care team",
      "manage": "Manage",
      "primary": "Primary"
    },
    "cycle_history": {
      "title": "Past cycles",
      "open_cycle_a11y": "Open ${title}",
      "cycle": "cycle",
      "cycles": "cycles",
      "view_all_past": "View all past cycles",
      "outcome_positive": "Positive",
      "outcome_negative": "Not successful",
      "outcome_cancelled": "Cancelled",
      "outcome_closed": "Closed",
      "outcome_ongoing": "Ongoing",
      "outcome_frozen": "Frozen",
      "outcome_completed": "Completed",
      "status_active": "Active",
      "metric_started": "Started",
      "metric_ended": "Ended",
      "subtitle_default": "Past cycle",
      "empty": {
        "title": "Have you had fertility treatment before?",
        "subtitle": "Add any past treatment now, or tell us this section does not apply so we can keep the page quieter.",
        "type_iui": "IUI",
        "type_ivf": "IVF",
        "type_medicated_cycle": "Medicated cycle",
        "type_retrieval": "Retrieval",
        "type_transfer": "Transfer",
        "type_egg_or_embryo_freezing": "Egg or embryo freezing",
        "none_button": "No past treatment",
        "none_a11y": "I have not had fertility treatment before",
        "none_saved_title": "No past treatment saved",
        "none_saved_subtitle": "This now counts in Medical History. You can undo it or add a treatment later.",
        "undo_none_button": "Undo",
        "undo_none_a11y": "Undo no past treatment answer",
        "add_button": "Add treatment",
        "add_a11y": "Add past treatment history"
      }
    },
    "results_labs": {
      "title": "Results & labs"
    },
    "conditions": {
      "title": "Diagnoses & conditions",
      "primary_diagnosis": "Primary diagnosis",
      "contributing_factor": "Contributing factor",
      "surgical_history": "Surgical history",
      "detail_modal": {
        "source_label": "Source",
        "close_a11y": "Close condition details",
        "care_impact": "Care impact",
        "fertility_context": "Fertility context",
        "insurance_and_records": "Insurance and records",
        "what_to_watch": "What Louise should watch",
        "add_records_cta": "Add records",
        "done_cta": "Done",
        "view_details_a11y": "View ${title} details"
      }
    },
    "cryo_vault": {
      "title": "Cryo vault",
      "embryo": "Embryo",
      "embryos": "Embryos",
      "egg": "Egg",
      "eggs": "Eggs",
      "semen": "Semen",
      "overview": {
        "title_empty": "Cryo vault",
        "title_count_one": "${count} specimen in cryo vault",
        "title_count_other": "${count} specimens in cryo vault",
        "subtitle_empty": "Track frozen eggs, embryos, and sperm.",
        "subtitle_one_facility": "Your frozen eggs, embryos, and sperm in ${count} facility.",
        "subtitle_other_facility": "Your frozen eggs, embryos, and sperm in ${count} facilities.",
        "open_a11y": "Open cryo vault",
        "type_egg_singular": "egg",
        "type_egg_plural": "eggs",
        "type_embryo_singular": "embryo",
        "type_embryo_plural": "embryos",
        "type_sperm_singular": "sperm vial",
        "type_sperm_plural": "sperm vials",
        "renewal_not_set": "Not set",
        "detail_stored_since": "Stored since ${date}",
        "detail_collected": "Collected ${date}",
        "detail_default": "Storage record saved in CryoVault.",
        "status_stored": "Stored",
        "status_report_pending": "Report pending",
        "empty_title": "Any frozen specimens to keep with your care?",
        "empty_subtitle": "Add stored eggs, embryos, sperm, facility details, reports, or tell us this does not apply right now.",
        "empty_chip_eggs": "Eggs",
        "empty_chip_embryos": "Embryos",
        "empty_chip_sperm": "Sperm",
        "empty_chip_facility": "Facility",
        "empty_chip_reports": "Reports",
        "empty_none_a11y": "I do not have frozen specimens to add",
        "empty_none_button": "None to add",
        "empty_add_a11y": "Add frozen specimens",
        "empty_add_button": "Add specimens"
      }
    },
    "cryo_vault_bridge": {
      "title": "Cryo Vault",
      "view_all": "View All",
      "specimen": "specimen",
      "specimens": "specimens",
      "egg": "egg",
      "eggs": "eggs",
      "embryo": "embryo",
      "embryos": "embryos",
      "vial": "vial",
      "vials": "vials",
      "empty_help": "Add your frozen specimen details to keep track of stored eggs or embryos.",
      "has_step_help": "Record your cryo vault details to complete your cycle.",
      "add_more": "Add more",
      "record_details": "Record details",
      "add_specimens": "Add specimens",
      "complete_cycle": "Complete Cycle",
      "type_label_eggs": "Eggs",
      "type_label_embryos": "Embryos",
      "type_label_sperm": "Sperm",
      "pill_vitrification": "Vitrification",
      "pill_slow_freeze": "Slow Freeze",
      "pill_day": "Day ${day}",
      "pill_pgt_a": "PGT-A",
      "pill_pgt_m": "PGT-M",
      "pill_pgt_sr": "PGT-SR",
      "pill_pgt_a_m": "PGT-A+M",
      "pill_pgt_pending": "PGT Pending",
      "pill_pgt": "PGT",
      "pill_icsi": "ICSI",
      "pill_ivf": "IVF",
      "pill_split": "Split",
      "expand_label": "Expand",
      "collapse_label": "Collapse",
      "live_birth_estimate_a11y": "${action} live birth estimate"
    },
    "documents_vault": {
      "title": "Your folder",
      "import_my_records": "Import my records",
      "import_my_records_help": "Retrieve records from your clinics and hospitals",
      "category_medical_records_label": "Medical Records",
      "category_medical_records_subtitle": "Labs & reports",
      "category_coverage_benefits_label": "Insurance & Coverage",
      "category_coverage_benefits_subtitle": "Cards & auths",
      "category_legal_consent_label": "Forms & Agreements",
      "category_legal_consent_subtitle": "Consents & signed forms",
      "category_admin_label": "Bills & Payments",
      "category_admin_subtitle": "Invoices & receipts"
    },
    "insurance": {
      "title": "Insurance & coverage",
      "lifetime_max": "Lifetime max",
      "out_of_pocket_ytd": "Out-of-pocket YTD: ${amount}",
      "preauth_approved": "Pre-auth approved",
      "preauth_pending": "Pre-auth pending",
      "preauth_denied": "Pre-auth denied"
    },
    "medical_history": {
      "title": "Medical History",
      "loading": "Loading...",
      "all_complete": "All sections complete!",
      "of_done": "${completed} of ${total} sections done",
      "remaining_level": "${remaining} remaining · ${level}",
      "xp_level": "${xp} XP · Lv.${level}",
      "continue_to_earn": "Continue to earn ${xp} XP",
      "level_1": "Newcomer",
      "level_2": "Getting Started",
      "level_3": "Health Explorer",
      "level_4": "Wellness Pro",
      "level_5": "Health Champion",
      "group_basic": "Basic Info",
      "group_cycles": "Fertility & Testing",
      "group_gynae": "Gynae & Obstetrics",
      "group_medical": "Medical History",
      "group_lifestyle": "Lifestyle"
    },
    "notes": {
      "title": "Notes",
      "today": "Today",
      "day_n": "Day ${n}",
      "add_a_note": "Add a note...",
      "on_your_mind": "Whatever's on your mind today...",
      "saving": "Saving...",
      "save": "Save"
    },
    "embryo_report": {
      "back": "Back",
      "screen_title": "Embryo Testing",
      "screen_intro": "Review your results and discuss next steps with your care team.",
      "loading_failed_title": "We couldn't load your report",
      "loading_failed_body": "Something went wrong fetching your testing results. Please try again in a moment.",
      "retry_report": "Try again",
      "empty_title": "No testing report yet",
      "empty_body": "Once your PGT or genomic results come back from the lab, they'll appear here.",
      "upload_or_import_report": "Upload or import a report",
      "open_source_document": "Open source document",
      "replace_source_document": "Replace source document",
      "source_document_heading": "Source document",
      "source_document_body": "This document is linked to the report and can be opened by you or your care team.",
      "source_document_file": "Uploaded report",
      "download_full_report": "Download full report (PDF)",
      "open_cryo_vault": "Open Cryo Vault",
      "report_state_pending": "Pending",
      "report_state_partial": "Partial report",
      "report_state_final": "Final report",
      "report_state_corrected": "Corrected report",
      "report_state_superseded": "Superseded",
      "report_state_retracted": "Retracted",
      "report_date": "Report date",
      "biopsy_date": "Biopsy date",
      "retrieval_date": "Retrieval date",
      "clinic": "Clinic",
      "physician": "Physician",
      "laboratory": "Laboratory",
      "sample_type": "Sample type",
      "indication": "Indication",
      "review_title": "Review with your care team",
      "review_wgs": "Genomic results are complex. We recommend reviewing with a genetic counselor who can help interpret these findings in context.",
      "review_pgt": "Your fertility specialist can help you understand these results and discuss next steps for embryo selection and transfer.",
      "review_no_testing": "No genetic testing decision is recorded here. Your care team can explain whether testing is planned, not planned, or still undecided.",
      "review_clinic_pending": "Your clinic has not recorded a testing decision yet. Ask your care team when the testing plan will be confirmed.",
      "transfer_yes": "Recommended",
      "transfer_no": "Not recommended",
      "transfer_counseling": "With counseling",
      "result_euploid": "Euploid",
      "result_aneuploid": "Aneuploid",
      "result_mosaic": "Mosaic",
      "result_no_result": "No result",
      "result_na": "N/A",
      "section_summary": "Results Summary",
      "section_comparison": "Comparison",
      "section_embryos": "Embryos",
      "embryo_search_label": "Find an embryo",
      "embryo_search_placeholder": "Search by embryo or sample ID",
      "embryo_search_clear": "Clear embryo search",
      "embryo_filter_result": "Filter by result",
      "embryo_filter_all": "All results",
      "embryo_filter_empty": "No embryos match these filters. Try another search or result filter.",
      "col_grade": "Grade",
      "col_karyotype": "Karyotype",
      "col_sex": "Sex",
      "col_result": "Result",
      "col_biopsy_day": "Biopsy Day",
      "col_transfer": "Transfer",
      "col_abnormalities": "Abnormalities",
      "col_mosaicism": "Mosaicism",
      "col_carrier_status": "Carrier Status",
      "col_polygenic_risk": "Polygenic Risk",
      "col_embryo": "Embryo",
      "carrier_clear": "Clear",
      "carrier_typical": "Typical",
      "above_avg": "${count} above avg",
      "embryo_number": "Embryo ${number}",
      "grade_day": "${grade} · Day ${day}",
      "day_label": "Day ${day}",
      "development_section": "Embryo development",
      "development_day": "Day ${day}",
      "development_stage": "Stage",
      "development_grade": "Grade",
      "development_cells": "Cells",
      "development_status": "Status",
      "development_arrested": "Arrested",
      "development_progressing": "Developing",
      "development_notes": "Notes",
      "development_source": "Source",
      "development_verification": "Verification",
      "of_total": "of ${total}",
      "entry": {
        "title": "Add testing report details",
        "edit_title": "Edit testing report details",
        "edit_intro": "Update the patient-entered facts when your report changes. This does not create a new clinical interpretation.",
        "edit": "Edit report details",
        "open_form": "Add report details",
        "intro": "Enter the facts shown on your lab report. Leave anything not shown unknown and discuss the results with your care team.",
        "source_document_ready": "This document will be linked when you save the report.",
        "report_details": "Report details",
        "report_state": "Report status",
        "correction_reason": "Why are you correcting this report?",
        "correction_reason_placeholder": "For example, the lab issued a corrected report",
        "select_date": "Select a date",
        "clinic_placeholder": "Clinic named on the report",
        "physician_placeholder": "Referring physician",
        "laboratory_placeholder": "Testing laboratory",
        "indication_placeholder": "Reason listed for testing",
        "sample_type_placeholder": "For example, embryo biopsy",
        "test_type": "Test type",
        "report_state_pending": "Report pending",
        "report_state_partial": "Partial report",
        "report_state_final": "Final report",
        "test_type_not_tested": "No genetic testing",
        "test_type_undecided": "Not yet decided",
        "test_type_clinic_pending": "Clinic decision pending",
        "test_type_pgt_a": "PGT-A",
        "test_type_pgt_m": "PGT-M",
        "test_type_pgt_sr": "PGT-SR",
        "test_type_pgt_a_pgt_m": "PGT-A + PGT-M",
        "test_type_pgt_a_pgt_sr": "PGT-A + PGT-SR",
        "test_type_pgt_a_pgt_m_pgt_sr": "PGT-A + PGT-M + PGT-SR",
        "test_type_wgs": "Whole genome sequencing",
        "test_type_other": "Other reported testing",
        "embryo_results": "Embryo results",
        "add_embryo": "Add embryo",
        "remove_embryo": "Remove embryo",
        "no_embryo_results": "You can save the report details first and add embryo-level results when you have them.",
        "embryo_number": "Embryo ${number}",
        "sample_id": "Sample ID",
        "embryo_number_field": "Embryo number",
        "karyotype": "Karyotype",
        "biopsy_day": "Biopsy day",
        "embryo_biopsy_date": "Embryo biopsy date",
        "comments": "Comments",
        "unknown_note": "Only enter what the report states. Moon does not interpret genetic findings or recommend embryo selection.",
        "cancel": "Cancel",
        "save": "Save report",
        "update": "Update report"
      },
      "history": {
        "title": "Report history",
        "saved_versions": "${count} saved versions of this report",
        "version_label": "Version ${version}",
        "current_report_label": "Current",
        "corrected_report_label": "Corrected",
        "updated_on": "Updated ${date}",
        "correction_reason_label": "Correction reason: ${reason}"
      }
    },
    "journey_ahead": {
      "title": "Your Journey Ahead",
      "n_medication": "${n} medication",
      "n_medications": "${n} medications",
      "status_completed": "Completed",
      "status_current": "Current Phase",
      "status_upcoming": "Upcoming",
      "status_now": "Now",
      "section_medications": "Medications",
      "section_how_it_works": "How it works",
      "section_what_to_expect": "What to expect",
      "section_how_to_prepare": "How to prepare",
      "section_emotional_support": "Emotional support",
      "emotional_support_body": "Every step of this journey brings its own emotions. Be gentle with yourself and lean on your support system."
    },
    "phase_education": {
      "pre_treatment": {
        "description": "Baseline testing, medications, and getting your body ready",
        "how_it_works": "Before stimulation begins, your clinic will confirm you're ready with baseline bloodwork and ultrasound. You'll review your medication protocol and may begin suppression medications.",
        "duration": "5–7 days",
        "what_to_expect": [
          "Baseline blood draw and ultrasound",
          "Review of medication protocol",
          "Pharmacy coordination for medication delivery"
        ],
        "prep_instructions": [
          "Fill all prescriptions",
          "Attend injection training",
          "Start prenatal vitamins if you haven't already"
        ],
        "partner": {
          "description": "Supplements, lifestyle, and habits to support sperm quality before collection",
          "how_it_works": "In the weeks before sperm collection, many clinics recommend supplements (antioxidants, CoQ10, zinc, selenium, vitamin E) and lifestyle adjustments to support sperm quality. Sperm production takes about 70 days, so changes made now affect what's collected later.",
          "duration": "Weeks before collection",
          "what_to_expect": [
            "Possible antioxidant or vitamin supplement recommendations",
            "Lifestyle adjustments (sleep, hydration, less alcohol/tobacco)",
            "Optional baseline semen analysis to set expectations"
          ],
          "prep_instructions": [
            "Follow your clinic's abstinence guidance close to collection day",
            "Avoid hot tubs, saunas, and laptops on the lap",
            "Cut alcohol and tobacco where you can",
            "Stay hydrated and eat well — sperm respond to lifestyle"
          ]
        }
      },
      "protocol": {
        "description": "Daily hormone injections to grow multiple follicles",
        "how_it_works": "You'll take daily injectable medications to stimulate your ovaries. Your doctor will monitor follicle growth with ultrasounds and blood tests every 1–3 days.",
        "duration": "8–12 days",
        "what_to_expect": [
          "Mild bloating as follicles grow",
          "Injection site tenderness",
          "Frequent monitoring visits"
        ],
        "prep_instructions": [
          "Take injections at the same time each day",
          "Stay hydrated and eat protein-rich foods",
          "Avoid strenuous exercise"
        ],
        "partner": {
          "description": "Your partner takes daily hormone injections to grow multiple follicles",
          "how_it_works": "Your partner takes daily injectable medications to stimulate her ovaries. Her doctor monitors follicle growth with ultrasounds and blood tests every 1–3 days.",
          "what_to_expect": [
            "She may feel bloated as follicles grow",
            "Injection sites can be tender",
            "Frequent monitoring visits — early mornings are common"
          ],
          "prep_instructions": [
            "Help her stay on schedule with the daily injections",
            "Drive her to monitoring appointments when you can",
            "Mood swings are normal — be patient"
          ]
        }
      },
      "egg_retrieval": {
        "description": "Short procedure to collect eggs under light sedation",
        "how_it_works": "Under light sedation, your doctor uses an ultrasound-guided needle to collect eggs from each follicle. The procedure takes about 15–30 minutes.",
        "duration": "15–30 min procedure",
        "what_to_expect": [
          "You won't feel anything during the procedure",
          "Mild cramping afterward",
          "Your clinic will call with the egg count same day"
        ],
        "prep_instructions": [
          "Nothing to eat or drink after midnight",
          "Arrange someone to drive you home",
          "Plan to rest for the day"
        ],
        "partner": {
          "description": "Short procedure to collect your partner's eggs under light sedation",
          "how_it_works": "Under light sedation, the doctor uses an ultrasound-guided needle to collect eggs from each of your partner's follicles. The procedure takes about 15–30 minutes.",
          "what_to_expect": [
            "She won't feel anything during the procedure",
            "Mild cramping afterward",
            "The clinic will call with the egg count the same day"
          ],
          "prep_instructions": [
            "Plan to be available the day of retrieval",
            "Drive her home — she can't drive after sedation",
            "Give her a quiet day to rest"
          ]
        }
      },
      "fertilization": {
        "description": "Eggs fertilized and embryos cultured in the lab",
        "how_it_works": "Your eggs are combined with sperm on the day of retrieval. The embryology team monitors development over 5–6 days.",
        "duration": "5–6 days",
        "what_to_expect": [
          "Day 1: Fertilization report",
          "Day 3: Early development update",
          "Day 5–6: Blastocyst report and grading"
        ]
      },
      "embryo_development": {
        "description": "Embryos growing and being graded in the lab",
        "how_it_works": "Embryos continue developing to the blastocyst stage. They may be biopsied for genetic testing (PGT-A).",
        "duration": "3–5 days",
        "what_to_expect": [
          "Daily updates from embryology team",
          "Not all embryos will reach blastocyst",
          "Waiting period can be emotionally challenging"
        ]
      },
      "transfer": {
        "description": "Embryo placed into uterus via thin catheter",
        "how_it_works": "A single embryo is gently placed into your uterus using a thin catheter guided by ultrasound. Quick and painless.",
        "duration": "5–10 min procedure",
        "what_to_expect": [
          "Quick procedure (5–10 minutes)",
          "You may see the embryo on ultrasound",
          "Begin progesterone support as directed"
        ],
        "prep_instructions": [
          "Drink water to have a full bladder",
          "Wear comfortable clothing",
          "Plan a calm, low-stress day"
        ],
        "partner": {
          "description": "Embryo placed into your partner's uterus via thin catheter",
          "how_it_works": "A single embryo is gently placed into your partner's uterus using a thin catheter guided by ultrasound. Quick and painless.",
          "what_to_expect": [
            "Quick procedure (5–10 minutes)",
            "She may see the embryo on ultrasound",
            "She begins progesterone support as directed"
          ],
          "prep_instructions": [
            "Come with her if she'd like the support",
            "Help plan a calm, low-stress day for her",
            "Take care of any errands so she can rest"
          ]
        }
      },
      "luteal_phase": {
        "description": "Waiting period until pregnancy blood test",
        "how_it_works": "Continue progesterone support and wait for your beta hCG blood test, typically 10–14 days after transfer.",
        "duration": "10–14 days",
        "what_to_expect": [
          "Continue all prescribed medications",
          "Mild cramping and spotting can be normal",
          "Avoid home pregnancy tests"
        ],
        "prep_instructions": [
          "Continue progesterone exactly as prescribed",
          "Consider stress-relief activities",
          "Lean on your support system"
        ],
        "partner": {
          "description": "Waiting period until your partner's pregnancy blood test",
          "how_it_works": "Your partner continues progesterone support and you wait together for her beta hCG blood test, typically 10–14 days after transfer.",
          "what_to_expect": [
            "She continues all prescribed medications",
            "Mild cramping and spotting can be normal for her",
            "Avoid home pregnancy tests — the beta is more reliable"
          ],
          "prep_instructions": [
            "Make sure she has her progesterone on time",
            "Be patient with mood changes — hormones are intense",
            "Go to the beta appointment together"
          ]
        }
      },
      "sperm_collection": {
        "description": "Sperm sample collection for fertilization",
        "how_it_works": "A semen sample is collected and prepared by the lab for use in fertilization or insemination.",
        "duration": "Same day",
        "what_to_expect": [
          "Sample collected at the clinic",
          "Lab prepares the sample"
        ]
      },
      "insemination": {
        "description": "Prepared sperm placed directly into the uterus",
        "how_it_works": "A thin catheter is used to place washed sperm directly into the uterus, timed with ovulation.",
        "duration": "5–10 minutes",
        "what_to_expect": [
          "Quick, minimally uncomfortable procedure",
          "You can resume normal activities after"
        ],
        "partner": {
          "description": "Prepared sperm placed directly into your partner's uterus",
          "how_it_works": "A thin catheter is used to place washed sperm directly into your partner's uterus, timed with her ovulation.",
          "what_to_expect": [
            "Quick, minimally uncomfortable procedure for her",
            "She can resume normal activities after"
          ]
        }
      }
    },
    "treatment_hub": {
      "partner_calendar": {
        "invite_your_partner": "Invite your partner",
        "once_connected_and_shared_their_calendar_receives_them": "Once they're connected and you've shared your appointments, their calendar receives the ones that involve them — this one included. You won't have to pass anything on.",
        "invite_my_partner": "Invite my partner",
        "not_now": "Not now"
      },
      "title": "Treatment Hub",
      "start_your_treatment": "Start Your Treatment",
      "start_your_treatment_help": "Track your cycle progress step by step.",
      "start_tracking": "Start Tracking",
      "save_failed_title": "Couldn't save",
      "save_failed_message": "We couldn't save that step. Please try again.",
      "waiting_requires_performed_title": "Transfer not recorded",
      "waiting_requires_performed_message": "The waiting period starts after you record that the transfer happened. Record the completed transfer first, then try again.",
      "completion": {
        "all_steps_complete": "All Steps Complete!",
        "treatment_complete": "Treatment complete",
        "cycle_label": "${treatment} — Cycle n°${number}",
        "days_clinic_separator": "${days} days · ${clinic}",
        "days_only": "${days} days",
        "summary_header": "Treatment Summary",
        "skipped": "Skipped",
        "completed": "Completed",
        "trigger_confirmed": "Trigger confirmed",
        "iui_completed": "IUI completed",
        "eggs_collected": "${count} eggs collected",
        "mature_count": "${count} mature",
        "frozen_count": "${count} frozen",
        "fertilized_count": "${count} fertilized",
        "transferred_count": "${count} transferred",
        "med_count_one": "${count} med",
        "med_count_other": "${count} meds",
        "med_more_suffix": "+${count} more",
        "cta_complete_cycle": "Complete Cycle",
        "cta_complete_preservation": "Complete Preservation",
        "cta_enter_waiting": "Enter Waiting Phase",
        "cta_complete_this_cycle": "Complete this cycle",
        "cryo_add_default": "Add to Cryo Vault",
        "cryo_add_eggs": "Add eggs to Cryo Vault",
        "cryo_add_embryos": "Add embryos to Cryo Vault",
        "cryo_add_subtitle": "Enter vial counts, storage facility, and dates for your records.",
        "cryo_added_title": "Saved to your Cryo Vault",
        "cryo_added_subtitle": "Open the vault to review or update details.",
        "cryo_added_a11y": "View Cryo Vault"
      },
      "scheduled_view": {
        "eyebrow": "Scheduled",
        "due_eyebrow": "It's the day",
        "countdown_unit_days": "days",
        "countdown_unit_soon": "soon",
        "due_hero_unit": "time to log",
        "subline_with_time": "${date} · ${time}",
        "due_today_title": "Today · time to log",
        "due_today_cta": "Log results",
        "edit_a11y": "Edit date",
        "prep_tips_title": "What to expect",
        "prep_tips": {
          "egg_retrieval": "No solid food in the 8 h before · Arrive 30 min early for check-in · Have someone to drive you home",
          "transfer": "Full bladder for transfer · No strict rest after",
          "insemination": "Arrive on time — the sperm is prepared right before",
          "sperm_collection": "2-5 days abstinence recommended · Bring photo ID"
        }
      },
      "step_card": {
        "current_badge": "Current",
        "skipped_badge": "Skipped",
        "scheduled_badge": "Scheduled for ${date}",
        "partner_data_chip": "Partner's data",
        "partner_named_data_chip": "${name}'s data",
        "awaiting_partner_update": "Awaiting your partner's update",
        "awaiting_partner_named_update": "Awaiting ${name}'s update",
        "add_info": "Add info",
        "sperm_question": "What sperm are you using?",
        "sperm_fresh": "Fresh",
        "sperm_frozen_own": "Frozen (own)",
        "sperm_frozen_partner": "Frozen (partner)",
        "sperm_frozen_donor": "Frozen (donor)"
      },
      "step_filled": {
        "completed": "Completed",
        "waiting_in_progress": "Waiting period in progress",
        "medications_one": "${count} medication",
        "medications_other": "${count} medications",
        "eggs_collected": "${count} eggs collected",
        "mature_count": "${count} mature",
        "frozen_count": "${count} frozen",
        "fertilized_count": "${count} fertilized",
        "embryo_transferred_one": "${count} embryo transferred",
        "embryo_transferred_other": "${count} embryos transferred",
        "grade_label": "Grade ${grade}",
        "iui_completed": "IUI completed",
        "specimen_linked": "Semen specimen linked",
        "trigger_confirmed": "Trigger confirmed"
      },
      "phase_widget": {
        "e2_label": "E2: ${value}",
        "follicles_count": "${count} follicles",
        "trigger_confirmed": "Trigger confirmed",
        "trigger_pending": "Trigger shot pending",
        "recovery_day": "Recovery day ${day} · Rest and hydrate",
        "recovery_in_progress": "Recovery in progress"
      },
      "educational": {
        "what_to_expect": "What to expect",
        "key_facts": "Key facts",
        "how_to_prepare": "How to prepare",
        "emotional_support": "Emotional support",
        "during_phase": "During ${phase}",
        "when_to_call": "When to call your clinic",
        "typical_duration_label": "Typical duration: ${duration}",
        "emotional_support_default": "Every step of this journey brings its own emotions. Be gentle with yourself and lean on your support system. Your care team is here for you every step of the way."
      },
      "recorded_result": {
        "title_pregnancy": "A positive result",
        "title_birth": "A baby was born",
        "title_no_pregnancy": "This cycle didn't end in a pregnancy",
        "title_miscarriage": "This cycle has ended",
        "title_cancelled": "This cycle was cancelled",
        "title_other": "Your result is recorded",
        "body_pregnancy": "Congratulations. It's saved to this cycle — your clinic will confirm what comes next.",
        "body_birth": "Congratulations. It's saved to this cycle.",
        "body_no_pregnancy": "We're sorry. It's saved to this cycle, and nothing needs deciding today.",
        "body_miscarriage": "We're so sorry. It's saved to this cycle. Your care team is the right place for what comes next, and Louise can hold your questions until you're ready.",
        "body_cancelled": "It's saved to this cycle. A cancelled cycle isn't a result, and nothing needs deciding today.",
        "body_other": "It's saved to this cycle. You can add more detail whenever you have it.",
        "recorded_on": "Recorded on ${date}",
        "close_cycle": "Close this cycle",
        "update_result": "Update this beta result",
        "partner_title_pregnancy": "A positive result",
        "partner_title_birth": "A baby was born",
        "partner_title_no_pregnancy": "This cycle didn't end in a pregnancy",
        "partner_title_miscarriage": "This cycle has ended",
        "partner_title_cancelled": "This cycle was cancelled",
        "partner_title_other": "The result is recorded",
        "partner_body_pregnancy": "Congratulations to you both. It's saved to this cycle — the clinic will confirm what comes next.",
        "partner_body_birth": "Congratulations to you both. It's saved to this cycle.",
        "partner_body_no_pregnancy": "We're sorry. It's saved to this cycle, and there's nothing you need to fix today.",
        "partner_body_miscarriage": "We're so sorry. It's saved to this cycle. Take the time you both need.",
        "partner_body_cancelled": "It's saved to this cycle. A cancelled cycle isn't a result.",
        "partner_body_other": "It's saved to this cycle.",
        "partner_hint": "Closing the cycle is theirs to do, whenever they're ready.",
        "close_hint": "Closing moves this cycle into your history. You can still open it any time."
      },
      "waiting_phase": {
        "section_label": "Two-week wait",
        "made_it_through": "The two-week wait",
        "test_will_be_on": "your pregnancy test will be on",
        "test_day_self_chip": "It's test day — you've got this",
        "test_day_partner_chip": "It's test day — you've got each other",
        "past_test_self_chip": "Time to record your result",
        "past_test_partner_chip": "Time to record partner result",
        "days_to_go_one": "1 day to go",
        "days_to_go_other": "${count} days to go",
        "test_day_self_announce": "Today is your test day",
        "test_day_partner_announce": "Today is partner test day",
        "test_was_ago_one": "Test was 1 day ago — record anytime",
        "test_was_ago_other": "Test was ${count} days ago — record anytime",
        "test_date_save_failed": "We couldn't save that test date. Your waiting phase is still active. Try again.",
        "retry_test_date": "Try again",
        "beta_order_title": "Pregnancy-test tracking",
        "beta_order_status": "Status: ${status}",
        "beta_order_collection_window": "Collection window: ${date}",
        "beta_order_latest_result": "Latest linked result: ${value} ${unit}",
        "beta_order_result_series": "Results recorded",
        "beta_order_result_entry": "Result ${sequence}: ${value} ${unit}",
        "beta_order_result_date": "Reported ${date}",
        "beta_order_result_collected_date": "Collected ${date}",
        "beta_interpretation_title": "Interpretation",
        "beta_interpretation_state": "Interpretation: ${state}",
        "beta_interpretation_follow_up": "Follow-up: ${action} · ${date}",
        "beta_interpretation_no_due_date": "date not provided",
        "beta_interpretation_urgent": "Urgent follow-up was recorded.",
        "beta_interpretation_state_negative": "Negative",
        "beta_interpretation_state_indeterminate": "Indeterminate",
        "beta_interpretation_state_pregnancy_detected": "Pregnancy detected",
        "beta_interpretation_state_unknown_location": "Pregnancy location not yet established",
        "beta_interpretation_state_intrauterine": "Intrauterine pregnancy",
        "beta_interpretation_state_ectopic_concern": "Ectopic pregnancy concern",
        "beta_interpretation_state_ectopic_diagnosis": "Ectopic pregnancy diagnosis",
        "beta_interpretation_state_biochemical": "Biochemical pregnancy",
        "beta_interpretation_state_early_loss": "Early pregnancy loss",
        "beta_interpretation_state_ongoing": "Ongoing pregnancy",
        "beta_interpretation_state_live_birth": "Live birth",
        "beta_interpretation_state_unavailable": "Unavailable",
        "beta_interpretation_state_unknown": "Unknown",
        "beta_interpretation_state_corrected": "Corrected",
        "beta_interpretation_state_refuted": "Refuted",
        "beta_follow_up_repeat": "Repeat beta",
        "beta_follow_up_ultrasound": "Ultrasound",
        "beta_follow_up_review": "Review",
        "beta_follow_up_urgent": "Urgent evaluation",
        "beta_follow_up_none": "No follow-up recorded",
        "beta_follow_up_unknown": "Follow-up not provided",
        "beta_order_no_order": "No beta test is linked to this wait yet.",
        "beta_order_no_result": "No result is linked yet.",
        "beta_order_status_not_reported": "Not reported",
        "beta_order_status_ordered": "Ordered",
        "beta_order_status_scheduled": "Scheduled",
        "beta_order_status_collected": "Sample collected",
        "beta_order_status_missed": "Missed",
        "beta_order_status_cancelled": "Cancelled",
        "beta_order_status_changed": "Changed",
        "beta_order_status_completed": "Completed",
        "beta_order_status_unknown": "Unknown",
        "pregnancy_test_label": "Pregnancy test",
        "tap_to_pick_date": "Tap to pick a date",
        "edit_label": "Edit",
        "record_beta_self": "Record beta result",
        "record_beta_partner": "Record partner result",
        "record_beta_waiting_for_order": "No beta test linked yet",
        "record_beta_waiting_for_collection": "Waiting for sample collection",
        "chat_about_this": "Chat about this",
        "chat_seed_prompt": "I'm in my two-week wait and could use some support right now.",
        "tap_enter_hcg_self": "Tap to enter your hCG result",
        "tap_enter_hcg_partner": "Tap to enter your partner's hCG result",
        "upload_test_photo": "Upload test photo",
        "upload_coming_soon_title": "Coming soon",
        "upload_coming_soon_body": "Photo upload of your beta hCG result will be available in a future update.",
        "while_you_wait": "While you wait",
        "take_care": "Take care of yourself",
        "tip_hydrate": "Stay hydrated and rested — sleep helps your body do its work.",
        "tip_movement": "Gentle movement is good — walking, prenatal yoga. Skip heavy lifting.",
        "tip_caffeine": "Limit caffeine to ~200mg per day, and avoid alcohol.",
        "tip_symptoms": "Symptom-spotting can be exhausting — a linked clinic result and interpretation guide next steps.",
        "day_label": "Day",
        "test_day_label": "Test day",
        "test_passed_label": "Test passed",
        "of_total": "of ${total}",
        "pick_test_date": "Pick a test date",
        "tw_self_past_test_title": "Time to record your result",
        "tw_self_past_test_body": "Your test date has passed. When you have your beta hCG result, tap the button below — we'll guide you through what's next.",
        "tw_self_test_day_title": "It's test day",
        "tw_self_test_day_body": "Take a deep breath. Whatever the result, your care team is here. When you have your beta hCG number, tap the button below.",
        "tw_self_setup_title": "Setting up your wait",
        "tw_self_setup_body": "Pick your test date below so we can keep you company through the next two weeks.",
        "tw_self_implant_title": "While you wait",
        "tw_self_implant_body": "Your care team’s protocol, records, and follow-up order are the best guide for this part of the wait. There’s nothing you need to diagnose today.",
        "tw_self_hormones_title": "Waiting for your result",
        "tw_self_hormones_body": "One hCG value cannot establish pregnancy location or viability. Your care team will interpret the result and tell you whether follow-up is needed.",
        "tw_self_days_until_one": "1 day until your test",
        "tw_self_days_until_other": "${count} days until your test",
        "tw_self_days_until_body": "Almost there. Try to be gentle with yourself — symptoms rarely tell the full story. Your care team’s result and interpretation will guide what comes next.",
        "tw_partner_past_test_title": "Time to record the result",
        "tw_partner_past_test_body": "${name}'s test date has passed. When the beta hCG result is available, tap the button below — we'll guide you through what's next together.",
        "tw_partner_test_day_title": "It's test day",
        "tw_partner_test_day_body": "Take a deep breath. Whatever the result, you're in this together. When the beta hCG number comes in, tap the button below.",
        "tw_partner_setup_title": "Setting up the wait",
        "tw_partner_setup_body": "Pick the test date below so we can keep you both company through the next two weeks.",
        "tw_partner_implant_title": "While you wait",
        "tw_partner_implant_body": "The care team’s protocol, records, and follow-up order are the best guide for this part of the wait. Neither of you needs to diagnose anything today.",
        "tw_partner_hormones_title": "Waiting for the result",
        "tw_partner_hormones_body": "One hCG value cannot establish pregnancy location or viability. The care team will interpret the result and explain whether follow-up is needed.",
        "tw_partner_days_until_one": "1 day until the test",
        "tw_partner_days_until_other": "${count} days until the test",
        "tw_partner_days_until_body": "Almost there. Be gentle with each other — symptoms rarely tell the full story. The care team's result and interpretation will guide what comes next.",
        "partner_learn_practical_title": "Practical ways to help",
        "partner_learn_practical_subtitle": "Logistical things you can take off your partner's plate.",
        "partner_learn_practical_line_1": "Go with your partner to the beta hCG appointment.",
        "partner_learn_practical_line_2": "Help collect prescriptions and refills when asked.",
        "partner_learn_practical_line_3": "Support the medication schedule ordered by the care team.",
        "partner_learn_practical_line_4": "Track the appointment schedule together.",
        "partner_learn_practical_line_5": "Handle small logistics so your partner can rest.",
        "partner_learn_beta_title": "What the linked result means",
        "partner_learn_beta_subtitle": "The care team's interpretation and what happens next.",
        "partner_learn_beta_intro": "A beta hCG is a blood test that measures a hormone. Result timing and interpretation come from the laboratory and care team.",
        "partner_learn_beta_section_positive": "Pregnancy detected",
        "partner_learn_beta_positive_line_1": "A numeric value needs clinical interpretation; there is no single cutoff for every situation.",
        "partner_learn_beta_positive_line_2": "The care team may order another result or imaging based on the record and protocol.",
        "partner_learn_beta_positive_line_3": "Follow-up imaging timing comes from the care team.",
        "partner_learn_beta_section_negative": "Negative",
        "partner_learn_beta_negative_line_1": "The clinic may report that pregnancy was not detected.",
        "partner_learn_beta_negative_line_2": "Clinic will discuss next steps when she's ready.",
        "partner_learn_beta_section_borderline": "Result needs review",
        "partner_learn_beta_borderline_line_1": "An unresolved result stays unresolved until the care team interprets it or orders follow-up.",
        "partner_learn_symptoms_title": "What's normal — and when to call",
        "partner_learn_symptoms_subtitle": "Symptoms during the wait, plus the red flags.",
        "partner_learn_symptoms_section_normal": "Possible symptoms",
        "partner_learn_symptoms_normal_line_1": "Light cramping or spotting can happen, but contact the clinic if you are unsure.",
        "partner_learn_symptoms_normal_line_2": "Mild bloating can have many causes.",
        "partner_learn_symptoms_normal_line_3": "Breast tenderness can have many causes.",
        "partner_learn_symptoms_normal_line_4": "Fatigue or mood changes can have many causes.",
        "partner_learn_symptoms_section_call": "Call the clinic",
        "partner_learn_symptoms_call_line_1": "Heavy bleeding (more than spotting).",
        "partner_learn_symptoms_call_line_2": "Severe pain not relieved by prescribed meds.",
        "partner_learn_symptoms_call_line_3": "Fever over 38°C / 100.4°F.",
        "partner_learn_symptoms_call_line_4": "Rapid weight gain or severe abdominal swelling (signs of OHSS).",
        "partner_learn_symptoms_call_line_5": "Difficulty urinating or significantly decreased urine output."
      },
      "breadcrumb": {
        "prep": "Prep",
        "stim": "Stim",
        "trigger": "Trigger",
        "retr": "Retr.",
        "outcome": "Outcome",
        "luteal": "Luteal",
        "fert": "Fert.",
        "emb": "Emb.",
        "transfer": "Transfer",
        "wait": "Wait",
        "sperm": "Sperm",
        "iui": "IUI",
        "screen": "Screen",
        "analysis": "Analysis"
      },
      "status": {
        "done": "Done",
        "skipped": "Skipped",
        "here": "You're here",
        "planned": "Planned",
        "coming_up": "Coming up"
      },
      "partner_data": "Partner data",
      "partner_name_data": "${name}'s data",
      "position_current": "You're on step ${current} of ${total}",
      "position_completed": "${completed} of ${total} done",
      "step_of": "Step ${current} of ${total}",
      "continue_where_left": "Continue where you left off",
      "continue_to_a11y": "Continue to ${title}",
      "cta": {
        "save_planned": "Save planned details",
        "next": "Next",
        "edit": "Edit",
        "change": "Change"
      },
      "view_steps": "Steps",
      "view_calendar": "Calendar",
      "view_a11y": "Show ${label}",
      "quick_add": {
        "menu_a11y": "Log to this cycle",
        "medication": "Log medication",
        "appointment": "Log appointment",
        "test": "Log test result"
      },
      "skipped_message": "This step was skipped.",
      "waiting_partner": "Waiting for linked partner data.",
      "your_clinic_recorded_this_transfer": "Your clinic recorded this transfer. Contact your care team to change it.",
      "your_clinic_recorded_this_step": "Your clinic recorded this. Contact your care team to change it.",
      "what_will_cover": "What this step will cover",
      "medication_empty": {
        "pre_treatment_title": "Add pre-treatment medication",
        "stimulation_title": "Add stimulation medication",
        "support_title": "Add support medication",
        "default_title": "Add medication",
        "pre_treatment_subtitle": "No pre-treatment medications logged yet.",
        "stimulation_subtitle": "No stimulation medications logged yet.",
        "support_subtitle": "No support medications logged yet.",
        "default_subtitle": "No medications logged yet."
      },
      "schedule_procedure": {
        "egg_retrieval_title": "Schedule egg retrieval",
        "transfer_title": "Schedule embryo transfer",
        "sperm_collection_title": "Schedule sperm collection",
        "insemination_title": "Schedule IUI",
        "default_title": "Schedule appointment",
        "subtitle": "Add it to your calendar and we'll keep this step in sync."
      },
      "iui_specimen_linkage": {
        "sample_of_date": "Sample of ${date}",
        "title": "Semen specimen",
        "link_or_add": "Link or add a sample",
        "sample_unavailable": "Sample unavailable",
        "choose_sample_title": "Choose a semen sample",
        "add_new_sample": "Add a new semen sample",
        "link_failed": "We couldn't link that sample. Please try again.",
        "origin": {
          "mine": "My sample",
          "partner": "Partner sample",
          "donor": "Donor sample"
        },
        "processing": {
          "fresh": "Fresh",
          "washed": "Washed",
          "frozen": "Frozen",
          "thawed": "Thawed"
        },
        "status": {
          "collected": "Collected",
          "processed": "Processed",
          "stored": "Stored",
          "in_transit": "In transit"
        }
      },
      "retrieval_outcome": {
        "add_title": "Add retrieval results",
        "add_subtitle": "Record the eggs retrieved and freezing details in Cryo Vault.",
        "add_more_results": "Add more results",
        "results_are_on_the_outcome_tab": "What you have recorded is on the Outcome tab, where you can also change it."
      },
      "cycle_outcome": {
        "record_title": "Record your result",
        "record_subtitle": "Add your beta hCG value whenever you have it."
      },
      "results_upload": {
        "analysis_title": "Add semen analysis results",
        "analysis_subtitle": "Upload the report and we'll pull in the values."
      },
      "step_details": {
        "screening_title": "Upload screening results",
        "screening_upload_subtitle": "Upload any screening document or add notes for your clinic.",
        "pgt_testing_title": "Add PGT results",
        "fertilization_title": "Add fertilization details",
        "embryo_development_title": "Add embryo development",
        "freezing_title": "Add freezing details",
        "default_title": "Add details",
        "subtitle": "Log the details for this step."
      },
      "endometrial_prep": {
        "title": "Endometrial Preparation",
        "description": "Prepare your uterine lining for transfer with estrogen and progesterone.",
        "prompt": "What medications did you take during preparation?",
        "skip_text": "I didn't take preparation medications this cycle"
      },
      "phase_extensions": {
        "getting_started": {
          "how_it_works": "Before stimulation begins, your clinic will confirm you're ready to start with baseline bloodwork (estradiol, FSH, LH) and a transvaginal ultrasound to check for cysts and measure your antral follicle count. You'll review your medication protocol and may begin birth control pills or estrogen priming depending on your plan.",
          "what_to_expect": [
            "Baseline blood draw and ultrasound on cycle day 2–3",
            "Review of your full medication protocol with your nurse",
            "Pharmacy coordination for medication delivery",
            "Possible suppression medications (birth control, Lupron)",
            "Emotional mix of excitement and nervousness — totally normal"
          ],
          "prep_instructions": [
            "Fill all prescriptions and confirm medication delivery dates",
            "Attend your injection training session",
            "Set up a clean, organized space for medication storage",
            "Clear your calendar for the upcoming 2–3 weeks of monitoring",
            "Start prenatal vitamins if you haven't already"
          ],
          "partner": {
            "description": "Supplements, lifestyle, and habits to support sperm quality before collection",
            "what_happens": "Sperm production takes around 70 days, so the prep you do now shapes the sample collected later. Many clinics recommend supplements and lifestyle adjustments during this phase.",
            "how_it_works": "In the weeks before collection, many clinics recommend antioxidant supplements (CoQ10, zinc, selenium, vitamin E) and lifestyle adjustments to support sperm quality. A baseline semen analysis may be ordered to set a starting point.",
            "what_to_expect": [
              "Possible antioxidant or vitamin supplement recommendations",
              "Lifestyle adjustments around sleep, hydration, alcohol, tobacco",
              "Optional baseline semen analysis to set expectations",
              "Time — sperm respond to changes over weeks, not days"
            ],
            "prep_instructions": [
              "Follow your clinic's abstinence guidance close to collection day (usually 2–5 days)",
              "Avoid hot tubs, saunas, and laptops on your lap",
              "Cut alcohol and tobacco where you can",
              "Stay hydrated, eat well, and prioritize sleep",
              "Move your body — moderate exercise helps"
            ]
          }
        },
        "stimulation": {
          "how_it_works": "You'll take daily injectable medications (typically FSH and LH) to stimulate your ovaries to produce multiple eggs instead of the single egg that normally matures each cycle. Your doctor will monitor follicle growth with ultrasounds and blood tests every 1–3 days.",
          "what_to_expect": [
            "Mild bloating and abdominal fullness as follicles grow",
            "Injection site tenderness or bruising",
            "Frequent monitoring visits (every 1–3 days)",
            "Possible mood changes from hormonal fluctuations",
            "Gradually increasing ovarian sensitivity"
          ],
          "prep_instructions": [
            "Learn injection technique from your nurse before starting",
            "Store medications per instructions (some require refrigeration)",
            "Take injections at the same time each day",
            "Stay hydrated and eat protein-rich foods",
            "Avoid strenuous exercise as follicles grow"
          ],
          "partner": {
            "description": "Your partner takes daily hormone injections to grow multiple follicles. She'll have monitoring visits every 2–3 days with blood work and ultrasounds to track her response.",
            "what_happens": "Multiple follicles are growing in your partner, each potentially containing a mature egg.",
            "how_it_works": "Your partner takes daily injectable medications (typically FSH and LH) to stimulate her ovaries to produce multiple eggs instead of the single egg that normally matures each cycle. Her doctor will monitor follicle growth with ultrasounds and blood tests every 1–3 days.",
            "what_to_expect": [
              "She may feel bloated and full as follicles grow",
              "Injection sites can be tender or bruised",
              "Frequent monitoring visits — early mornings are common",
              "Mood changes from hormonal fluctuations are normal",
              "Her ovaries become gradually more sensitive"
            ],
            "prep_instructions": [
              "Sit in on the injection training so you can help",
              "Store medications per instructions (some require refrigeration)",
              "Help her stay on schedule — same time every day",
              "Drive her to monitoring appointments when you can",
              "Be patient with mood changes — hormones are intense"
            ]
          }
        },
        "trigger": {
          "how_it_works": "When your follicles reach the right size (typically 18–20mm), you'll receive a trigger shot (hCG or Lupron) to initiate the final maturation of your eggs. The timing is critical — egg retrieval is scheduled exactly 36 hours after this injection.",
          "what_to_expect": [
            "Single injection, usually in the evening",
            "Your clinic will give you a precise time to administer",
            "Mild cramping or bloating may increase",
            "You may feel emotionally heightened"
          ],
          "prep_instructions": [
            "Set an alarm for the exact injection time",
            "Have a backup plan in case of issues with the injection",
            "Confirm your retrieval time with your clinic",
            "Arrange transportation for retrieval day"
          ]
        },
        "retrieval": {
          "how_it_works": "Under light sedation (twilight anesthesia), your doctor uses an ultrasound-guided needle to aspirate fluid from each follicle, collecting the eggs. The procedure takes about 15–30 minutes. You'll rest in recovery for 1–2 hours afterward.",
          "what_to_expect": [
            "You won't feel anything during the procedure",
            "Mild to moderate cramping afterward",
            "Some spotting is normal for 1–2 days",
            "Bloating may peak in the days following retrieval",
            "Your clinic will call with the egg count the same day"
          ],
          "prep_instructions": [
            "Nothing to eat or drink after midnight",
            "Wear comfortable, loose clothing",
            "Remove all jewelry and nail polish",
            "Arrange someone to drive you home",
            "Plan to rest for the remainder of the day"
          ],
          "partner": {
            "description": "A short procedure (15–20 minutes) under light sedation where your partner's eggs are collected using ultrasound-guided aspiration. She'll go home the same day. Plan to support her for 1–2 days afterward.",
            "what_happens": "Under light sedation, an ultrasound-guided needle aspirates fluid from each of your partner's follicles to collect the eggs. She won't feel the procedure.",
            "how_it_works": "Under light sedation, the doctor uses an ultrasound-guided needle to aspirate fluid from each of your partner's follicles, collecting the eggs. The procedure takes about 15–30 minutes. She rests in recovery for 1–2 hours afterward.",
            "what_to_expect": [
              "She won't feel anything during the procedure",
              "Mild to moderate cramping afterward",
              "Some spotting is normal for 1–2 days",
              "Bloating may peak in the days following retrieval",
              "The clinic will call with the egg count the same day"
            ],
            "prep_instructions": [
              "Plan to be available the day of retrieval",
              "Drive her to and from the clinic — she can't drive after sedation",
              "Help her be comfortable (loose clothing, no jewelry)",
              "Sign her out at the clinic when recovery is done",
              "Give her a quiet day at home to rest"
            ]
          }
        },
        "fertilization": {
          "how_it_works": "Your eggs are combined with sperm (via conventional IVF or ICSI) on the day of retrieval. The embryology team monitors development over 5–6 days, providing updates on fertilization rates and embryo grades. Embryos that reach the blastocyst stage may be biopsied for genetic testing (PGT-A).",
          "what_to_expect": [
            "Day 1: Fertilization report (how many eggs fertilized)",
            "Day 3: Early development update",
            "Day 5–6: Blastocyst report and grading",
            "Not all eggs will fertilize, and not all embryos will reach blastocyst",
            "This waiting period can be emotionally challenging"
          ],
          "partner": {
            "description": "Your partner's eggs are combined with sperm in the lab. The embryology team monitors embryo development over 5–6 days and reports the results to you both.",
            "what_happens": "Your partner's eggs and the sperm sample meet in the lab. Over 5–6 days the embryology team tracks fertilization and embryo development.",
            "how_it_works": "Your partner's eggs are combined with sperm (via conventional IVF or ICSI) on the day of retrieval. The embryology team monitors development over 5–6 days, providing updates on fertilization rates and embryo grades. Embryos that reach the blastocyst stage may be biopsied for genetic testing (PGT-A).",
            "what_to_expect": [
              "Day 1: Fertilization report (how many eggs fertilized)",
              "Day 3: Early development update",
              "Day 5–6: Blastocyst report and grading",
              "Not all eggs will fertilize, and not all embryos will reach blastocyst",
              "The waiting period can be emotionally challenging for both of you"
            ]
          }
        },
        "transfer": {
          "how_it_works": "A single embryo is gently placed into your uterus using a thin catheter guided by ultrasound. The procedure is quick and painless — no anesthesia needed. You'll be asked to have a comfortably full bladder for better ultrasound visualization.",
          "what_to_expect": [
            "Quick, painless procedure (5–10 minutes)",
            "You may see the embryo on the ultrasound screen",
            "Light spotting afterward is normal",
            "Resume normal activities the next day",
            "Begin progesterone support as directed"
          ],
          "prep_instructions": [
            "Drink water to have a full bladder",
            "Take prescribed medications (valium, antibiotics) if directed",
            "Wear comfortable clothing",
            "Arrange a calm, low-stress day afterward"
          ],
          "partner": {
            "description": "A single embryo is gently placed into your partner's uterus using a thin catheter guided by ultrasound. Quick and painless — no anesthesia needed.",
            "what_happens": "The embryo is placed into your partner's uterus. The procedure is brief and she's awake throughout.",
            "how_it_works": "A single embryo is gently placed into your partner's uterus using a thin catheter guided by ultrasound. The procedure is quick and painless — no anesthesia needed. She'll have a comfortably full bladder for better ultrasound visualization.",
            "what_to_expect": [
              "Quick, painless procedure (5–10 minutes)",
              "She may see the embryo on the ultrasound screen",
              "Light spotting afterward is normal for her",
              "She resumes normal activities the next day",
              "She begins progesterone support as directed"
            ],
            "prep_instructions": [
              "Come with her if she'd like the support",
              "Help her with any prescribed medications beforehand",
              "Plan a calm, low-stress day for her afterward",
              "Take care of errands so she can rest"
            ]
          }
        },
        "waiting": {
          "how_it_works": "After transfer, you'll continue progesterone support and wait for your beta hCG blood test, typically 10–14 days later. This test measures pregnancy hormone levels to determine if the embryo has implanted.",
          "what_to_expect": [
            "Continue all prescribed medications",
            "Mild cramping and spotting can be normal (and don't indicate failure)",
            "Emotional ups and downs are very common",
            "Avoid home pregnancy tests — they can give false results",
            "Your clinic will schedule your blood test date"
          ],
          "prep_instructions": [
            "Continue progesterone exactly as prescribed",
            "Maintain normal activities but avoid extremes",
            "Consider stress-relief activities (walks, meditation)",
            "Lean on your support system during this time"
          ],
          "partner": {
            "description": "Your partner continues progesterone support and you wait together for her beta hCG blood test, typically 10–14 days later.",
            "what_happens": "Your partner is in the two-week wait. Her body is working — the embryo either implants or it doesn't, and the beta test will tell you both.",
            "how_it_works": "After transfer, your partner continues progesterone support and you wait together for her beta hCG blood test, typically 10–14 days later. This test measures pregnancy hormone levels to determine if the embryo has implanted.",
            "what_to_expect": [
              "She continues all prescribed medications",
              "Mild cramping and spotting can be normal for her",
              "Emotional ups and downs for both of you",
              "Avoid home pregnancy tests — beta hCG is more reliable",
              "The clinic will schedule the blood test date"
            ],
            "prep_instructions": [
              "Make sure she has her progesterone on time",
              "Be patient with mood changes — hormones are intense",
              "Plan low-stress activities together",
              "Go to the beta appointment together"
            ]
          }
        }
      },
      "frozen_egg_ivf_overrides": {
        "stimulation": {
          "how_it_works": "Your uterine lining is prepared for transfer. Estrogen builds the lining; progesterone is added closer to transfer day. No ovarian stimulation is needed — your eggs are already collected and frozen.",
          "what_to_expect": [
            "Daily estrogen (oral, patch, or injection) for 2–4 weeks",
            "Lining ultrasounds to confirm thickness reaches ≥7–8 mm",
            "Progesterone added (vaginal, injection, or both) ~5 days before transfer",
            "Your frozen eggs stay safely stored until thaw day",
            "Far fewer monitoring visits than a fresh stim cycle"
          ],
          "prep_instructions": [
            "Confirm your estrogen and progesterone delivery with your pharmacy",
            "Schedule your lining-check ultrasound(s) with the clinic",
            "Coordinate the thaw date once your lining is ready",
            "Plan a calm, low-stress lead-up to transfer"
          ]
        },
        "fertilization": {
          "how_it_works": "On thaw day, your frozen eggs are warmed in the lab and fertilized — typically with ICSI, since the egg's outer layer hardens after freezing. The embryology team monitors development over 5–6 days.",
          "what_to_expect": [
            "Eggs are thawed in the morning; survival rate is typically 80–90%",
            "ICSI is the default fertilization method for thawed eggs",
            "Day 1: Fertilization report (how many eggs fertilized)",
            "Day 3: Early development update",
            "Day 5–6: Blastocyst report and grading",
            "Not all eggs survive thaw or fertilize — this is expected"
          ]
        }
      }
    },
    "treatment_milestones": {
      "egg_retrieval": "Egg Retrieval",
      "transfer": "Embryo Transfer",
      "trigger_shot": "Trigger Shot",
      "stimulation_start": "Stimulation Start"
    },
    "treatment_flows": {
      "scheduled_for_date": "Scheduled for ${date}",
      "dated_on": "Dated ${date}",
      "options": {
        "none": "No additional preparation",
        "washed": "Washed",
        "swim_up": "Swim-up selection",
        "density_gradient": "Density-gradient selection",
        "dgc_swim_up": "Density-gradient + swim-up",
        "microfluidics": "Microfluidic selection",
        "macs": "MACS selection",
        "partner": "Partner",
        "donor": "Donor",
        "fresh": "Fresh",
        "frozen": "Frozen",
        "ivf": "IVF",
        "icsi": "ICSI",
        "yes": "Yes",
        "no": "No",
        "other": "Other",
        "select_placeholder": "Select…",
        "other_enter_below": "Other (enter below)"
      },
      "actions": {
        "confirm_save": "Confirm & Save",
        "schedule": "Schedule",
        "undo": "Undo",
        "cancel": "Cancel",
        "delete_medication": "Delete medication",
        "add_medication": "Add medication",
        "add_another_medication": "Add another medication",
        "add_trigger": "Add trigger shot",
        "trigger_added": "Trigger shot added",
        "add_trigger_a11y": "Add trigger shot medication",
        "default_skip": "I didn't have this step"
      },
      "status": {
        "completed": "Completed",
        "skipped": "Skipped",
        "in_progress": "In Progress"
      },
      "state": {
        "step_complete": "This step is complete",
        "step_skipped": "This step was skipped",
        "required_field": "Required: ${field}"
      },
      "medications": {
        "unnamed": "Unnamed medication",
        "medication": "Medication",
        "trigger_badge": "Trigger",
        "none_logged": "No medications logged yet",
        "none_found": "No medications found",
        "more_count": "+${count} more medications"
      },
      "collection_methods": {
        "ejaculation": "Ejaculation",
        "tese": "TESE",
        "tesa": "TESA",
        "pesa": "PESA",
        "mesa": "MESA",
        "mtese": "Micro-TESE",
        "electroejaculation": "Electroejaculation",
        "post_ejaculatory_urine": "Post-ejaculatory urine"
      },
      "ivf": {
        "pre_treatment": {
          "title": "Pre-treatment",
          "description": "Birth control or priming medications before stimulation",
          "prompt": "Did you take birth control or priming medications before stimulation?",
          "skip_text": "I didn't have pre-treatment this cycle",
          "partner": {
            "description": "Supplements or medications to support sperm quality before collection",
            "prompt": "Are you taking any supplements or medications before collection?"
          }
        },
        "protocol": {
          "title": "Ovarian Stimulation",
          "description": "Medication phase to stimulate egg development, including trigger shot",
          "prompt": "What medications did you take during stimulation?",
          "skip_text": "I didn't have ovarian stimulation this cycle",
          "partner": {
            "description": "Medication phase your partner is taking to stimulate egg development, including trigger shot",
            "prompt": "What medications is your partner taking during stimulation?",
            "skip_text": "My partner didn't have ovarian stimulation this cycle"
          }
        },
        "egg_retrieval": {
          "title": "Egg Retrieval",
          "description": "Egg collection procedure",
          "prompt": "How did your egg retrieval go?",
          "scheduling_prompt": "When is your egg retrieval scheduled?",
          "fields": {
            "procedureDate": { "label": "Procedure Date & Time" },
            "eggsCollected": { "label": "Eggs Collected", "placeholder": "0" },
            "notes": { "label": "Notes", "placeholder": "Quality notes…" }
          },
          "partner": {
            "description": "Your partner's egg collection procedure",
            "prompt": "How did your partner's egg retrieval go?",
            "fields": {
              "eggsCollected": {
                "label": "Eggs partner retrieved",
                "placeholder": "0"
              }
            }
          }
        },
        "fertilization": {
          "title": "Fertilization",
          "description": "How your eggs were fertilized",
          "prompt": "What are your fertilization results?",
          "skip_text": "I don't have fertilization details yet",
          "fields": {
            "spermSource": { "label": "Sperm Source" },
            "spermType": { "label": "Fresh or Frozen" },
            "fertilizationMethod": { "label": "Fertilization Method" },
            "eggsFertilized": {
              "label": "Eggs Fertilized (2PN)",
              "placeholder": "0"
            },
            "notes": { "label": "Notes" }
          },
          "partner": {
            "skip_text": "We don't have fertilization details yet"
          }
        },
        "embryo_development": {
          "title": "Embryo Development",
          "description": "Embryo growth, grading, and freezing decisions",
          "prompt": "How are your embryos developing?",
          "skip_text": "I don't have embryo details yet",
          "fields": {
            "embryoGrade": { "label": "Top Embryo Grade" },
            "embryosFrozen": { "label": "Embryos Frozen", "placeholder": "0" }
          },
          "partner": {
            "skip_text": "We don't have embryo details yet"
          }
        },
        "transfer": {
          "title": "Embryo Transfer",
          "description": "Embryo transfer to the uterus",
          "prompt": "Tell us about your embryo transfer",
          "scheduling_prompt": "When is your transfer scheduled?",
          "skip_text": "I'm freezing all embryos this cycle",
          "fields": {
            "transferDate": { "label": "Transfer Date" },
            "embryosTransferred": {
              "label": "Embryos Transferred",
              "placeholder": "0"
            },
            "embryoType": { "label": "Embryo Type" },
            "notes": { "label": "Notes" }
          },
          "partner": {
            "description": "Your partner's embryo transfer to the uterus",
            "prompt": "Tell us about your partner's embryo transfer",
            "skip_text": "We're freezing all embryos this cycle"
          }
        },
        "luteal_phase": {
          "title": "Luteal Support",
          "description": "Post-transfer support medications",
          "prompt": "What support medications are you taking?",
          "partner": {
            "title": "Partner's Luteal Support",
            "description": "Post-transfer support medications your partner is taking",
            "prompt": "What support medications is your partner taking?"
          }
        },
        "outcome": {
          "title": "Outcome",
          "description": "Your result for this cycle",
          "prompt": "What was the result of this cycle?",
          "partner": {
            "description": "The result of your partner's cycle",
            "prompt": "What was the result of this cycle?"
          }
        },
        "sperm_collection": {
          "title": "Sperm Collection",
          "description": "Sperm sample collection and preparation",
          "prompt": "Tell us about the sperm collection",
          "scheduling_prompt": "When is the sperm collection scheduled?",
          "skip_text": "I don't have sperm collection details",
          "fields": {
            "spermSource": { "label": "Sperm Source" },
            "spermType": { "label": "Fresh or Frozen" },
            "collectionMethod": { "label": "Collection Type" },
            "preparationMethod": { "label": "Preparation" },
            "abstinencePeriod": {
              "label": "Days of Abstinence",
              "placeholder": "0"
            },
            "collectionDate": { "label": "Collection Date" },
            "notes": { "label": "Notes" }
          }
        }
      },
      "icsi": {
        "pre_treatment": {
          "title": "Pre-treatment",
          "description": "Birth control or priming medications before stimulation",
          "prompt": "Did you take birth control or priming medications?",
          "skip_text": "I didn't have pre-treatment this cycle",
          "partner": {
            "description": "Supplements or medications to support sperm quality before collection",
            "prompt": "Are you taking any supplements or medications before collection?"
          }
        },
        "protocol": {
          "title": "Ovarian Stimulation",
          "description": "Medication phase to stimulate egg development, including trigger shot",
          "prompt": "What medications did you take during stimulation?",
          "skip_text": "I didn't have ovarian stimulation this cycle",
          "partner": {
            "description": "Medication phase your partner is taking to stimulate egg development, including trigger shot",
            "prompt": "What medications is your partner taking during stimulation?",
            "skip_text": "My partner didn't have ovarian stimulation this cycle"
          }
        },
        "egg_retrieval": {
          "title": "Egg Retrieval",
          "description": "Egg collection procedure",
          "prompt": "How did your egg retrieval go?",
          "scheduling_prompt": "When is your egg retrieval scheduled?",
          "fields": {
            "procedureDate": { "label": "Procedure Date & Time" },
            "eggsCollected": { "label": "Eggs Collected", "placeholder": "0" },
            "notes": { "label": "Notes" }
          },
          "partner": {
            "description": "Your partner's egg collection procedure",
            "prompt": "How did your partner's egg retrieval go?",
            "fields": {
              "eggsCollected": {
                "label": "Eggs partner retrieved",
                "placeholder": "0"
              }
            }
          }
        },
        "sperm_collection": {
          "title": "Sperm Collection",
          "description": "Sperm sample collection and preparation",
          "prompt": "Tell us about the sperm collection",
          "scheduling_prompt": "When is the sperm collection scheduled?",
          "skip_text": "I don't have sperm collection details",
          "fields": {
            "spermSource": { "label": "Sperm Source" },
            "spermType": { "label": "Fresh or Frozen" },
            "collectionMethod": { "label": "Collection Type" },
            "preparationMethod": { "label": "Preparation" },
            "abstinencePeriod": {
              "label": "Days of Abstinence",
              "placeholder": "0"
            },
            "collectionDate": { "label": "Collection Date" },
            "notes": { "label": "Notes" }
          }
        },
        "fertilization": {
          "title": "Fertilization (ICSI)",
          "description": "Intracytoplasmic sperm injection results",
          "prompt": "What are your ICSI fertilization results?",
          "skip_text": "I don't have fertilization details yet",
          "fields": {
            "spermSource": { "label": "Sperm Source" },
            "spermType": { "label": "Fresh or Frozen" },
            "eggsInjected": {
              "label": "Eggs Injected (ICSI)",
              "placeholder": "0"
            },
            "eggsFertilized": {
              "label": "Eggs Fertilized (2PN)",
              "placeholder": "0"
            },
            "notes": { "label": "Notes" }
          },
          "partner": { "skip_text": "We don't have fertilization details yet" }
        },
        "embryo_development": {
          "title": "Embryo Development",
          "description": "Embryo growth, grading, and freezing decisions",
          "prompt": "How are your embryos developing?",
          "skip_text": "I don't have embryo details yet",
          "fields": {
            "embryoGrade": { "label": "Top Embryo Grade" },
            "embryosFrozen": { "label": "Embryos Frozen", "placeholder": "0" }
          },
          "partner": { "skip_text": "We don't have embryo details yet" }
        },
        "transfer": {
          "title": "Embryo Transfer",
          "description": "Embryo transfer to the uterus",
          "prompt": "Tell us about your embryo transfer",
          "scheduling_prompt": "When is your transfer scheduled?",
          "skip_text": "I'm freezing all embryos this cycle",
          "fields": {
            "transferDate": { "label": "Transfer Date" },
            "embryosTransferred": {
              "label": "Embryos Transferred",
              "placeholder": "0"
            },
            "embryoType": { "label": "Embryo Type" },
            "notes": { "label": "Notes" }
          },
          "partner": {
            "description": "Your partner's embryo transfer to the uterus",
            "prompt": "Tell us about your partner's embryo transfer",
            "skip_text": "We're freezing all embryos this cycle"
          }
        },
        "luteal_phase": {
          "title": "Luteal Support",
          "description": "Post-transfer support medications",
          "prompt": "What support medications are you taking?",
          "partner": {
            "title": "Partner's Luteal Support",
            "description": "Post-transfer support medications your partner is taking",
            "prompt": "What support medications is your partner taking?"
          }
        },
        "outcome": {
          "title": "Outcome",
          "description": "Your result for this cycle",
          "prompt": "What was the result of this cycle?",
          "partner": {
            "description": "The result of your partner's cycle",
            "prompt": "What was the result of this cycle?"
          }
        }
      },
      "iui": {
        "pre_treatment": {
          "title": "Pre-treatment",
          "description": "Preparation before IUI cycle",
          "prompt": "Did you take any medications before your IUI cycle?",
          "skip_text": "I didn't have pre-treatment this cycle",
          "partner": {
            "description": "Supplements or medications to support sperm quality before collection",
            "prompt": "Are you taking any supplements or medications before collection?"
          }
        },
        "protocol": {
          "title": "Ovarian Stimulation",
          "description": "Medication to support egg development, including trigger shot",
          "prompt": "What medications did you take during stimulation?",
          "partner": {
            "description": "Medication your partner is taking to support egg development, including trigger shot",
            "prompt": "What medications is your partner taking during stimulation?"
          }
        },
        "sperm_collection": {
          "title": "Sperm Collection",
          "description": "Sperm sample collection and preparation",
          "prompt": "Tell us about the sperm collection",
          "scheduling_prompt": "When is the sperm collection scheduled?",
          "skip_text": "I don't have sperm collection details",
          "fields": {
            "spermSource": { "label": "Sperm Source" },
            "spermType": { "label": "Fresh or Frozen" },
            "collectionMethod": { "label": "Collection Type" },
            "preparationMethod": { "label": "Preparation" },
            "abstinencePeriod": {
              "label": "Days of Abstinence",
              "placeholder": "0"
            },
            "collectionDate": { "label": "Collection Date" },
            "notes": { "label": "Notes" }
          }
        },
        "insemination": {
          "title": "Insemination (IUI)",
          "description": "Sperm is placed directly in the uterus",
          "prompt": "How did your IUI procedure go?",
          "scheduling_prompt": "When is your IUI scheduled?",
          "fields": {
            "procedureDate": { "label": "Procedure Date & Time" },
            "inseminationType": { "label": "IUI Type" },
            "catheterType": { "label": "Catheter Type" },
            "catheterBrand": { "label": "Catheter Brand" },
            "ultrasoundGuided": { "label": "Ultrasound Guided" },
            "inseminationDuration": {
              "label": "Procedure Duration (minutes)",
              "placeholder": "0"
            },
            "notes": { "label": "Notes" }
          },
          "partner": {
            "description": "Sperm is placed directly in your partner's uterus",
            "prompt": "How did your partner's IUI procedure go?"
          }
        },
        "luteal_phase": {
          "title": "Luteal Support",
          "description": "Post-insemination support",
          "prompt": "Are you taking any support medications?",
          "skip_text": "I'm not taking luteal support",
          "partner": {
            "title": "Partner's Luteal Support",
            "description": "Post-insemination support your partner is taking",
            "prompt": "Is your partner taking any support medications?",
            "skip_text": "My partner isn't taking luteal support"
          }
        },
        "outcome": {
          "title": "Outcome",
          "description": "Your result for this cycle",
          "prompt": "What was the result of this cycle?",
          "partner": {
            "description": "The result of your partner's cycle",
            "prompt": "What was the result of this cycle?"
          }
        }
      },
      "fet": {
        "pre_treatment": {
          "title": "Pre-treatment",
          "description": "Preparation before transfer cycle",
          "prompt": "Did you take any medications before your FET cycle?",
          "skip_text": "I didn't have pre-treatment this cycle",
          "partner": {
            "description": "Supplements or medications to support sperm quality before collection",
            "prompt": "Are you taking any supplements or medications before collection?"
          }
        },
        "protocol": {
          "title": "Endometrial Preparation",
          "description": "Building up the uterine lining for transfer",
          "prompt": "What medications are you taking to prepare your lining?",
          "partner": {
            "description": "Medications your partner is taking to build up her uterine lining for transfer",
            "prompt": "What medications is your partner taking to prepare her lining?"
          }
        },
        "transfer": {
          "title": "Embryo Transfer",
          "description": "Frozen embryo transfer to the uterus",
          "prompt": "Tell us about your embryo transfer",
          "scheduling_prompt": "When is your transfer scheduled?",
          "fields": {
            "transferDate": { "label": "Transfer Date" },
            "embryosTransferred": {
              "label": "Embryos Transferred",
              "placeholder": "0"
            },
            "embryoType": { "label": "Embryo Type" },
            "notes": { "label": "Notes" }
          },
          "partner": {
            "description": "Frozen embryo transfer to your partner's uterus",
            "prompt": "Tell us about your partner's embryo transfer"
          }
        },
        "luteal_phase": {
          "title": "Luteal Support",
          "description": "Post-transfer support medications",
          "prompt": "What support medications are you taking?",
          "partner": {
            "title": "Partner's Luteal Support",
            "description": "Post-transfer support medications your partner is taking",
            "prompt": "What support medications is your partner taking?"
          }
        },
        "outcome": {
          "title": "Outcome",
          "description": "Your result for this cycle",
          "prompt": "What was the result of this cycle?",
          "partner": {
            "description": "The result of your partner's cycle",
            "prompt": "What was the result of this cycle?"
          }
        }
      },
      "oi": {
        "pre_treatment": {
          "title": "Pre-treatment",
          "description": "Baseline tests and preparation",
          "prompt": "Did you take any pre-treatment medications?",
          "skip_text": "I didn't have pre-treatment this cycle"
        },
        "protocol": {
          "title": "Ovulation Induction",
          "description": "Medication to stimulate ovulation, including trigger shot and timing",
          "prompt": "What medications are you taking for ovulation induction?",
          "fields": {
            "timingWindow": {
              "label": "Timed Intercourse Window",
              "placeholder": "e.g. Feb 12–14"
            },
            "notes": { "label": "Notes" }
          }
        },
        "luteal_phase": {
          "title": "Luteal Support",
          "description": "Post-ovulation support and waiting period",
          "prompt": "Are you taking any support medications?",
          "skip_text": "I'm not taking luteal support"
        },
        "outcome": {
          "title": "Outcome",
          "description": "Your result for this cycle",
          "prompt": "What was the result of this cycle?"
        }
      },
      "egg_freezing": {
        "pre_treatment": {
          "title": "Pre-treatment",
          "short_title": "Pre-treatment",
          "description": "Birth control or priming medications",
          "prompt": "Did you take birth control or priming medications?",
          "skip_text": "I didn't have pre-treatment this cycle"
        },
        "stimulation": {
          "title": "Stimulation & Monitoring",
          "short_title": "Stimulation",
          "description": "Medication phase to stimulate egg development",
          "prompt": "What medications did you take during stimulation?",
          "skip_text": "I didn't have ovarian stimulation this cycle"
        },
        "trigger_shot": {
          "title": "Trigger Shot",
          "short_title": "Trigger",
          "description": "Final injection to trigger egg maturation before retrieval",
          "prompt": "Log your trigger shot the same way as your other medications."
        },
        "egg_retrieval": {
          "title": "Egg Retrieval",
          "short_title": "Retrieval",
          "description": "Egg collection procedure",
          "prompt": "How did your egg retrieval go?",
          "scheduling_prompt": "When is your egg retrieval scheduled?",
          "fields": {
            "procedureDate": { "label": "Procedure Date & Time" },
            "eggsCollected": { "label": "Eggs Collected", "placeholder": "0" },
            "notes": { "label": "Notes", "placeholder": "How did it go?" }
          }
        },
        "freezing": {
          "title": "Outcome",
          "short_title": "Outcome",
          "description": "Mature eggs, eggs frozen, and lab notes",
          "prompt": "What were your freezing outcomes?",
          "fields": {
            "matureEggs": { "label": "Mature Eggs (MII)", "placeholder": "0" },
            "eggsFrozen": { "label": "Eggs Frozen", "placeholder": "0" },
            "notes": { "label": "Notes", "placeholder": "Quality notes…" }
          }
        }
      },
      "embryo_freezing": {
        "pre_treatment": {
          "title": "Pre-treatment",
          "description": "Birth control or priming medications",
          "prompt": "Did you take birth control or priming medications?",
          "skip_text": "I didn't have pre-treatment this cycle",
          "partner": {
            "description": "Supplements or medications to support sperm quality before collection",
            "prompt": "Are you taking any supplements or medications before collection?"
          }
        },
        "protocol": {
          "title": "Ovarian Stimulation",
          "description": "Medication to stimulate egg development, including trigger shot",
          "prompt": "What medications did you take during stimulation?",
          "skip_text": "I didn't have ovarian stimulation this cycle",
          "partner": {
            "description": "Medication your partner is taking to stimulate egg development, including trigger shot",
            "prompt": "What medications is your partner taking during stimulation?",
            "skip_text": "My partner didn't have ovarian stimulation this cycle"
          }
        },
        "egg_retrieval": {
          "title": "Egg Retrieval",
          "description": "Egg collection procedure",
          "prompt": "How did your egg retrieval go?",
          "scheduling_prompt": "When is your egg retrieval scheduled?",
          "fields": {
            "procedureDate": { "label": "Procedure Date & Time" },
            "eggsCollected": { "label": "Eggs Collected", "placeholder": "0" },
            "notes": { "label": "Notes" }
          },
          "partner": {
            "description": "Your partner's egg collection procedure",
            "prompt": "How did your partner's egg retrieval go?",
            "fields": {
              "eggsCollected": {
                "label": "Eggs partner retrieved",
                "placeholder": "0"
              }
            }
          }
        },
        "sperm_collection": {
          "title": "Sperm Collection",
          "description": "Sperm sample collection and preparation",
          "prompt": "Tell us about the sperm collection",
          "scheduling_prompt": "When is the sperm collection scheduled?",
          "skip_text": "I don't have sperm collection details",
          "fields": {
            "spermSource": { "label": "Sperm Source" },
            "spermType": { "label": "Fresh or Frozen" },
            "collectionMethod": { "label": "Collection Type" },
            "abstinencePeriod": {
              "label": "Days of Abstinence",
              "placeholder": "0"
            },
            "collectionDate": { "label": "Collection Date" },
            "notes": { "label": "Notes" }
          }
        },
        "fertilization": {
          "title": "Fertilization & Freezing",
          "description": "Fertilization results, embryo grading, and storage",
          "prompt": "What happened in the lab, and how many embryos were frozen?",
          "skip_text": "I don't have embryo details yet",
          "fields": {
            "spermSource": { "label": "Sperm Source" },
            "fertilizationMethod": { "label": "Method" },
            "eggsFertilized": {
              "label": "Eggs Fertilized (2PN)",
              "placeholder": "0"
            },
            "embryosFrozen": { "label": "Embryos Frozen", "placeholder": "0" },
            "embryoGrade": {
              "label": "Embryo Grade",
              "placeholder": "e.g. 4AA, 3AB"
            },
            "procedureDate": { "label": "Freeze Date & Time" },
            "storageLocation": {
              "label": "Storage Location",
              "placeholder": "Clinic / Bank / Other"
            },
            "notes": { "label": "Notes" }
          },
          "partner": { "skip_text": "We don't have fertilization details yet" }
        },
        "embryo_development": {
          "title": "Embryo Development",
          "short_title": "Development",
          "description": "Embryo growth, grading, and freezing decisions",
          "prompt": "How are your embryos developing?",
          "skip_text": "I don't have embryo development details yet",
          "fields": {
            "embryoGrade": { "label": "Top Embryo Grade" },
            "embryosDay3": {
              "label": "Embryos at Day 3",
              "placeholder": "0"
            },
            "embryosDay5": {
              "label": "Embryos at Day 5",
              "placeholder": "0"
            },
            "embryosFrozen": {
              "label": "Embryos Frozen",
              "placeholder": "0"
            },
            "procedureDate": { "label": "Freeze Date & Time" },
            "storageLocation": {
              "label": "Storage Location",
              "placeholder": "Clinic / Bank / Other"
            },
            "notes": { "label": "Notes" }
          }
        }
      },
      "sperm_freezing": {
        "pre_treatment": {
          "title": "Pre-collection prep",
          "short_title": "Pre-treatment",
          "description": "Medications or supplements before your collection",
          "prompt": "Are you taking any medications or supplements before your collection?",
          "skip_text": "I'm not taking anything"
        },
        "screening": {
          "title": "Screening",
          "short_title": "Screening",
          "description": "Screening results before freezing; add infectious-disease, genetic, or carrier documents",
          "prompt": "Upload any screening documents and add notes for your clinic",
          "fields": {
            "screeningDocumentId": { "label": "Upload screening document" },
            "stdScreeningDate": {
              "label": "STD / infectious-disease screening date"
            },
            "stdResultNotes": {
              "label": "STD / infectious-disease screening notes",
              "placeholder": "Add the result or any notes about the screening…"
            },
            "geneticScreeningDate": {
              "label": "Genetic / carrier screening date"
            },
            "geneticResultNotes": {
              "label": "Genetic / carrier screening notes",
              "placeholder": "Add the result or any notes about the screening…"
            },
            "notes": {
              "label": "Additional Notes",
              "placeholder": "Anything else to flag for your clinic…"
            }
          }
        },
        "sperm_collection": {
          "title": "Sperm Collection",
          "short_title": "Collection",
          "description": "Sample collection at the clinic or laboratory",
          "prompt": "Tell us about the collection",
          "scheduling_prompt": "When is the sperm collection scheduled?",
          "fields": {
            "collectionDate": { "label": "Collection Date & Time" },
            "abstinenceDays": {
              "label": "Days of Abstinence",
              "placeholder": "e.g. 3"
            },
            "spermType": { "label": "Fresh or Frozen" },
            "notes": {
              "label": "Notes",
              "placeholder": "Quality, conditions, anything notable…"
            }
          }
        },
        "analysis": {
          "title": "Semen Analysis",
          "short_title": "Analysis",
          "description": "Sperm count, motility, morphology, and volume",
          "prompt": "Upload your analysis report to auto-fill, or enter the values manually.",
          "skip_text": "I don't have analysis results yet",
          "fields": {
            "analysisResultDocId": { "label": "Analysis Report (PDF)" },
            "concentration": {
              "label": "Concentration (M/mL)",
              "placeholder": "0"
            },
            "totalCount": { "label": "Total Count (M)", "placeholder": "0" },
            "motilityPercent": { "label": "Motility (%)", "placeholder": "0" },
            "morphologyPercent": {
              "label": "Normal Morphology (%)",
              "placeholder": "0"
            },
            "volumeMl": { "label": "Volume (mL)", "placeholder": "0" },
            "notes": { "label": "Notes" }
          }
        },
        "freezing": {
          "title": "Freezing",
          "short_title": "Freezing",
          "description": "Vials frozen — storage details captured in Cryo Vault",
          "prompt": "How many vials were frozen? You'll add storage location in your Cryo Vault.",
          "fields": {
            "vialsFrozen": { "label": "Vials Frozen", "placeholder": "0" },
            "freezeDate": { "label": "Freeze Date" },
            "notes": {
              "label": "Notes",
              "placeholder": "Anything to remember…"
            }
          }
        }
      }
    },
    "all_past_cycles": {
      "title": "Past Cycles",
      "subtitle": "Keep a clear record of the treatment cycles in your history.",
      "add_button": "Add past cycle",
      "add_title": "Add a past cycle",
      "add_subtitle": "Capture the details you want to keep in your treatment history.",
      "step_progress": "Step {current} of {total}",
      "type_step_title": "What kind of cycle was it?",
      "type_step_subtitle": "Start with the treatment type. Next, you’ll add when it happened.",
      "when_step_title": "When did this cycle happen?",
      "when_step_subtitle": "A month and year is enough to save it. Continue when you’re ready to add details.",
      "outcome_step_title": "What happened in this cycle?",
      "outcome_step_subtitle": "Choose an outcome if you remember it. You can add the details next.",
      "treatment_outcome_step_title": "How did treatment end?",
      "treatment_outcome_step_subtitle": "First tell us whether treatment was completed or stopped before it was finished.",
      "treatment_completed": "Treatment completed",
      "treatment_completed_description": "The planned treatment reached the point where you could assess the pregnancy result.",
      "treatment_cancelled": "Cycle cancelled",
      "treatment_cancelled_description": "Treatment stopped before it was completed.",
      "treatment_other": "Other or not sure",
      "treatment_other_description": "Choose this when another description fits, or you do not remember.",
      "pregnancy_outcome_step_title": "Was there a pregnancy?",
      "pregnancy_outcome_step_subtitle": "Count a pregnancy here even if it ended later in a pregnancy loss. You can add what happened next.",
      "pregnancy_including_loss": "Pregnancy, including a later loss",
      "pregnancy_including_loss_description": "A positive result at some point after treatment, whether or not the pregnancy continued.",
      "pregnancy_result_not_recorded": "Not sure or not recorded",
      "pregnancy_result_not_recorded_description": "You can save the cycle and come back to add the pregnancy result later.",
      "pregnancy_details_step_title": "What happened after the pregnancy?",
      "pregnancy_details_step_subtitle": "Add the outcome you know now. You can add more details later.",
      "pregnancy_ongoing": "Pregnancy is ongoing",
      "pregnancy_ongoing_description": "The pregnancy was still ongoing when you recorded this cycle.",
      "pregnancy_live_birth": "Live birth",
      "pregnancy_live_birth_description": "The pregnancy resulted in one live birth.",
      "pregnancy_multiple_live_birth": "Multiple live birth",
      "pregnancy_multiple_live_birth_description": "The pregnancy resulted in more than one live birth.",
      "pregnancy_loss": "Pregnancy loss",
      "pregnancy_loss_description": "The pregnancy ended in a loss. You can add the type of loss later.",
      "pregnancy_details_other": "Other or not sure",
      "pregnancy_details_other_description": "Choose this when another pregnancy outcome fits better.",
      "outcome_followup_title": "Would you like to add more details about this outcome now?",
      "outcome_followup_subtitle": "You can save the cycle now, or add the beta result and other outcome details.",
      "outcome_details_available_title": "Add the beta and outcome details",
      "outcome_details_available_subtitle": "Record the beta value, result status, and any details you want to keep with this cycle.",
      "add_outcome_details_button": "Add details",
      "outcome_note_step_subtitle": "Add a note about what happened. You can add more later.",
      "when_month_year_label": "Month and year",
      "month_year_placeholder": "MM/YYYY",
      "details_step_title": "Add details to this cycle",
      "details_step_subtitle": "Add the details you remember. You can add more later.",
      "metric_follicles": "Follicles measured",
      "metric_eggs_retrieved": "Eggs retrieved",
      "metric_mature_eggs": "Mature eggs",
      "metric_eggs_frozen": "Eggs frozen",
      "metric_fertilized_eggs": "Fertilized eggs",
      "metric_day3_embryos": "Day 3 embryos",
      "metric_blastocysts": "Blastocysts",
      "metric_embryos_frozen": "Embryos frozen",
      "metric_embryos_transferred": "Embryos transferred",
      "egg_cohort_label": "Egg freezing cycle",
      "save_cycle_button": "Save cycle",
      "add_details_button": "Continue to add details",
      "continue_button": "Continue",
      "back_button": "Back",
      "validation_outcome_required": "Choose an outcome to continue.",
      "validation_treatment_outcome_required": "Choose how treatment ended to continue.",
      "validation_pregnancy_result_required": "Choose whether there was a pregnancy to continue.",
      "validation_pregnancy_details_required": "Choose what happened after the pregnancy to continue.",
      "type_label": "Cycle type",
      "clinic_label": "Clinic or provider",
      "clinic_placeholder": "Where did this cycle take place?",
      "start_date_label": "Started",
      "end_date_label": "Finished (optional)",
      "outcome_label": "Outcome",
      "preservation_outcome_unavailable": "Specimen and storage outcomes are recorded in Cryo Vault.",
      "notes_label": "Notes (optional)",
      "notes_placeholder": "Anything you want to remember…",
      "when": "When",
      "where": "Where",
      "no_date": "Dates not recorded",
      "no_clinic": "Clinic not recorded",
      "open_details": "Open cycle details",
      "cancel_button": "Cancel",
      "save_button": "Add cycle",
      "validation_required": "Choose a cycle type to continue.",
      "validation_type_required": "Choose a cycle type to continue.",
      "validation_month_year_required": "Add the month and year to continue.",
      "validation_dates": "The finish date cannot be before the start date.",
      "save_error": "Could not add this cycle. Please try again.",
      "empty": "No past cycles yet",
      "outcome_positive": "Positive",
      "outcome_negative": "Not successful",
      "outcome_cancelled": "Cancelled",
      "outcome_completed": "Completed",
      "outcome_ongoing": "Ongoing",
      "outcome_frozen": "Frozen"
    },
    "past_cycle_detail": {
      "loading": "Loading cycle details…",
      "outcome_cancelled": "Cancelled",
      "outcome_cancelled_with_reason": "Cancelled · ${reason}",
      "outcome_live_birth": "Live birth",
      "outcome_multiple_live_birth": "Multiple live birth",
      "outcome_positive_beta": "Positive beta",
      "outcome_negative": "Not successful",
      "outcome_completed": "Completed",
      "outcome_frozen": "Frozen",
      "outcome_ongoing": "Ongoing",
      "eggs_retrieved": "${count} eggs retrieved",
      "embryos_frozen": "${count} embryos frozen",
      "add_outcome": "Add outcome",
      "add_outcome_unavailable": "Recording an outcome on past cycles isn't available yet.",
      "add_clinic": "Add clinic",
      "add_dates": "Add dates",
      "edit_unavailable": "Editing past cycle details isn't available yet.",
      "header_eyebrow": "Past Cycle",
      "error_title": "Could not load cycle",
      "error_body": "This cycle may no longer exist.",
      "go_back": "Go back",
      "backfill_alert_title": "Coming soon",
      "backfill_alert_body": "Editing past-cycle data isn't available yet — it's on the roadmap. For now you can record this for active cycles and we'll let you backfill earlier ones soon.",
      "labels": {
        "eggs_retrieved": "Eggs retrieved",
        "mature_eggs": "Mature eggs",
        "fertilized": "Fertilized",
        "day3_embryos": "Day 3 embryos",
        "blastocysts": "Blastocysts",
        "embryos_transferred": "Embryos transferred",
        "embryos_frozen": "Embryos frozen",
        "eggs_frozen": "Eggs frozen"
      },
      "specimen_status": {
        "used_later": "Used later",
        "discarded": "Discarded",
        "donated": "Donated",
        "in_transit": "In transit",
        "not_active": "Not active"
      },
      "lab_cryo_dialog": {
        "retrieval_title": "Egg retrieval",
        "retrieval_subtitle": "Start with what the lab found at retrieval. If this stopped early, we will stop there too.",
        "fertilization_title": "Fertilization",
        "fertilization_subtitle": "Record how many mature eggs fertilized. If this was zero, embryo, transfer, and cryo details are skipped.",
        "embryo_title": "Embryo, transfer & cryo",
        "embryo_subtitle": "Add what happened after fertilization for this cycle.",
        "back": "Back",
        "cancel": "Cancel",
        "save": "Save",
        "next": "Next",
        "fill_in_all": "Fill in all"
      }
    },
    "cycle_protocol": {
      "section_title": "Protocol",
      "tabs": {
        "medications": "Medications",
        "medications_compact": "Meds",
        "timeline": "Timeline",
        "timeline_compact": "Timeline",
        "notes": "Notes",
        "notes_compact": "Notes"
      },
      "empty": {
        "medications_title": "Add medication",
        "medications_subtitle": "Add a medication used during this cycle.",
        "timeline_title": "Add medication",
        "timeline_subtitle": "Add a medication to start this cycle timeline.",
        "notes_title": "Add protocol notes and changes",
        "notes_subtitle": "Save dose changes, care-team instructions, and notes from this cycle."
      },
      "labels": {
        "medication_timeline": "Medication timeline",
        "daily": "Daily",
        "once": "Once",
        "since": "Since ${day}",
        "until": "Until ${day}",
        "default_medication_name": "Medication"
      },
      "add_medication": "Add medication",
      "timeline": {
        "add_note_menu": "Add note",
        "day_menu": "Open actions for ${date}",
        "add_note_title": "Add timeline note",
        "add_note_placeholder": "What happened on this day?",
        "save_note": "Save note",
        "status_taken": "Taken",
        "status_late": "Late",
        "status_missed": "Missed",
        "status_upcoming": "Upcoming",
        "status_scheduled": "Scheduled",
        "no_dose": "Dose not recorded",
        "day_label": "Day ${day}",
        "medication_singular": "medication",
        "medication_plural": "medications",
        "scheduled_recap": "scheduled",
        "logged_recap": "logged",
        "note_only_recap": "A note was added to this day.",
        "event_added": "Added",
        "event_dose_changed": "Dose changed",
        "event_swapped": "Possible swap",
        "event_stopped": "Stopped"
      }
    },
    "update_pregnancy": {
      "add_anything_you_want_to": "Add anything you want to. You can also just save.",
      "choose_a_different_answer": "Choose a different answer",
      "weeks_along_one": "At ${count} week",
      "weeks_along_other": "At ${count} weeks",
      "babies_count_one": "${count} baby",
      "babies_count_other": "${count} babies",
      "where_things_stand": "Where things stand",
      "tell_us_only_what_you_want_to": "Tell us only what you want to. You can leave the rest.",
      "stands_continuing": "Pregnant",
      "stands_ended": "The pregnancy ended",
      "stands_birth": "A baby was born",
      "how_many_weeks_if_you_know": "How many weeks, if you know",
      "weeks_placeholder": "Weeks",
      "if_your_clinic_told_you_which": "If your clinic told you which kind, you can add it. You do not have to.",
      "i_am_not_sure": "I'm not sure",
      "loss_complete_miscarriage": "Miscarriage",
      "loss_incomplete_miscarriage": "Incomplete miscarriage",
      "loss_missed_miscarriage": "Missed miscarriage",
      "loss_chemical_pregnancy": "Very early loss (chemical pregnancy)",
      "loss_ectopic_pregnancy": "Ectopic pregnancy",
      "loss_anembryonic_pregnancy": "Anembryonic pregnancy (empty sac)",
      "loss_still_birth": "Stillbirth",
      "loss_recurrent_miscarriage": "Recurrent miscarriage",
      "how_many_babies_if_you_want_to_say": "How many babies, if you want to say",
      "babies_placeholder": "Babies",
      "save": "Save",
      "specify_the_outcome": "Add the outcome",
      "say_where_things_stand": "Say where things stand, whenever you're ready."
    },
    "cycle_tests": {
      "section_title": "Tests",
      "view_all": "View all",
      "empty_title": "Add test result",
      "empty_subtitle": "Upload or tag lab reports, imaging, semen analysis, genetics, and other diagnostics to this cycle.",
      "see_details": "See details",
      "badge_waiting": "Waiting",
      "badge_scheduled": "Scheduled",
      "no_date": "No date",
      "linked_to_cycle": "Linked to this cycle"
    },
    "cycle_clinic_team": {
      "rei": "REI",
      "reproductive_endocrinologist": "Reproductive endocrinologist",
      "clinic": "Clinic",
      "clinic_connected": "Clinic connected to this cycle.",
      "add_providers_portal": "Add providers, portal details, and cycle instructions.",
      "connect_care_team_fallback": "Connect your care team",
      "menu_edit_team": "Edit team",
      "menu_add_provider": "Add provider or clinic",
      "connect_clinic_title": "Connect clinic",
      "connect_clinic_subtitle": "Find care, add the clinic, or keep portal details with this cycle.",
      "add_physicians_title": "Add physicians",
      "add_physicians_subtitle": "Add your REI, nurse coordinator, OB-GYN, or other provider.",
      "team_subtitle_present": "Monitoring, protocol changes, portal instructions, and retrieval updates stay connected to this cycle.",
      "team_subtitle_empty": "Add clinics, physicians, and providers so instructions, visits, and records stay together.",
      "open_member": "Open ${name}",
      "open_actions": "Open cycle team actions",
      "call_clinic": "Call clinic",
      "open_portal": "Open clinic portal",
      "manage_title": "Manage this cycle’s care team",
      "manage_description": "Keep the providers and clinic connected to this cycle in view. New people can be recorded in your care team first.",
      "manage_match_note": "Add someone from your care team to keep them visible for this cycle. Their details can be confirmed later.",
      "cycle_clinic_label": "Recorded for this cycle",
      "recorded_badge": "Recorded",
      "recorded_team_title": "Patient-recorded care team",
      "add_recorded_member_title": "Add from your care team",
      "add_recorded_member_description": "Choose a person or organization you’ve already recorded and associate it with this cycle.",
      "add_recorded_member_action": "Add",
      "remove_recorded_member_action": "Remove",
      "no_available_records": "Record a provider, clinic, or pharmacy in your care team first.",
      "attach_failed": "We couldn’t add this care-team record to the cycle. Please try again.",
      "detach_failed": "We couldn’t remove this care-team record from the cycle. Please try again.",
      "empty_manage": "No official care-team members are attached to this cycle yet.",
      "open_profile_action": "Open care team",
      "done": "Done",
      "cancel": "Cancel",
      "remove_member_action": "Remove",
      "remove_member_title": "Remove ${name} from this cycle?",
      "remove_member_description": "This removes the official care-team assignment from this cycle. It does not delete the provider’s profile.",
      "remove_member_confirm": "Remove",
      "remove_member_failed": "We couldn’t update this cycle’s care team. Please try again."
    },
    "cycle_documents": {
      "section_title": "Related Documents",
      "view_all": "View all",
      "empty_title": "Add related document",
      "empty_subtitle": "Upload or tag lab reports, consent forms, invoices, and other records to this cycle.",
      "no_date": "No date",
      "doc_lab_record": "Lab record",
      "doc_imaging_report": "Imaging report",
      "doc_treatment_plan": "Treatment plan",
      "doc_genetic_report": "Genetic report",
      "doc_billing": "Billing, fees, or receipts",
      "doc_consent": "Consent or directive",
      "doc_coverage": "Coverage record",
      "doc_default": "Cycle document"
    },
    "cycle_detail": {
      "menu": {
        "edit_cycle": "Edit cycle",
        "add_specimen": "Add specimen",
        "end_cycle": "End cycle"
      },
      "alerts": {
        "save_failed_title": "Unable to save cycle",
        "save_failed_message": "Something went wrong. Please try again.",
        "coming_soon_title": "Coming soon",
        "coming_soon_message": "Connecting clinics and providers to an active cycle will be wired into care-team records soon. Once connected, they will show here for this cycle.",
        "error_generic": "Something went wrong. Please try again."
      },
      "empty": {
        "no_active_cycle_title": "No active cycle",
        "no_active_cycle_subtitle": "There isn't an active treatment cycle right now. Start one when you're ready, or add a previous cycle to your history.",
        "active_cycle_eyebrow": "Active Cycle",
        "starting_soon": "Starting soon",
        "no_active_cycle_main": "No Active Cycle",
        "post_cycle_positive_title": "Congratulations on this beautiful news",
        "post_cycle_positive_body": "Your cycle is now archived in your past cycles.",
        "post_cycle_eyebrow": "Cycle complete",
        "back_to_care": "Back to my care",
        "read_article_positive": "Read: The two-week wait & early pregnancy",
        "read_article_negative": "Read: Emotional support during fertility care"
      },
      "buttons": {
        "add_clinic": "Add clinic",
        "add_start_date": "Add start date"
      },
      "sections": {
        "cryo_vault": "Cryo Vault",
        "connect_care_team": "Connect Your Care Team"
      },
      "timeline": {
        "day_label": "Day ${day}",
        "day_of_phase": "Day ${day} of ${phase}",
        "day_of_treatment": "Day ${day} of treatment",
        "started_with_day": "Started ${date} · Day ${day}",
        "started_on": "Started ${date}",
        "starts": "Starts ${date}",
        "upcoming": "Upcoming",
        "started_marker": "Started ${date} — you are here (Day ${day})",
        "starts_short": "Starts ${date}",
        "est_window": "Est. ${window}",
        "filled": "Filled ${date}",
        "test_on": "Test on ${date}",
        "result_recorded_on": "Recorded ${date}"
      },
      "timeline_steps": {
        "pre_treatment": "Pre-treatment",
        "stimulation": "Stimulation",
        "trigger": "Trigger",
        "retrieval": "Retrieval",
        "freezing": "Freezing outcome",
        "fertilization": "Fertilization",
        "embryo_culture": "Embryo culture",
        "transfer": "Transfer",
        "waiting_period": "Waiting period",
        "sperm_sample": "Sperm sample",
        "sperm_short": "Sperm",
        "trigger_shot_full": "Trigger shot",
        "screening": "Screening",
        "semen_analysis": "Semen analysis",
        "insemination": "Insemination"
      },
      "frozen_protocol": {
        "step_title": "Endometrial Preparation",
        "description": "Prepare your uterine lining for transfer with estrogen and progesterone.",
        "prompt": "What medications did you take during preparation?",
        "skip_text": "I didn't take preparation medications this cycle"
      },
      "lab_labels": {
        "e2": "E2 (pg/mL)",
        "lh": "LH (mIU/mL)",
        "p4": "P4 (ng/mL)",
        "follicles_r": "Follicles R",
        "follicles_l": "Follicles L",
        "lining": "Lining (mm)"
      },
      "biomarkers": {
        "estradiol": {
          "label": "Estradiol",
          "description": "Primary estrogen produced by growing follicles.",
          "why_matters": "Rising E2 confirms follicles are growing.",
          "normal_range": "~200–300 pg/mL per mature follicle.",
          "assessment_high": "Monitor closely",
          "assessment_rising": "Rising well",
          "assessment_low": "Low — may need adjustment",
          "assessment_on_track": "On track"
        },
        "follicles": {
          "label": "Follicles",
          "description": "Fluid-filled sacs each potentially containing an egg.",
          "why_matters": "Number and size predict how many eggs may be retrieved.",
          "normal_range": "Good response: 8–15 follicles.",
          "assessment_strong": "Strong response",
          "assessment_good": "Good response",
          "assessment_moderate": "Moderate response",
          "assessment_low": "Low response"
        },
        "lining": {
          "label": "Endometrial Lining",
          "description": "Tissue lining the uterus.",
          "why_matters": "Thick lining associated with better implantation.",
          "normal_range": "Optimal: ≥7–8mm trilaminar.",
          "assessment_optimal": "Optimal thickness",
          "assessment_nearly": "Nearly optimal",
          "assessment_thickening": "Still thickening",
          "assessment_thin": "Thin — monitoring"
        },
        "lh": {
          "label": "LH",
          "description": "Triggers ovulation.",
          "why_matters": "Suppressed during IVF to prevent premature ovulation.",
          "normal_range": "During stim, below 10 IU/L.",
          "assessment_elevated": "Elevated — alert team",
          "assessment_suppressed": "Well suppressed",
          "assessment_in_range": "Within range"
        }
      },
      "detail": {
        "what_is_it": "What is it",
        "why_it_matters": "Why it matters",
        "typical_range": "Typical range",
        "your_values_this_cycle": "Your values this cycle",
        "values_by_cycle": "Values by cycle",
        "values_over_time": "Values over time",
        "not_tracked_badge": "Not tracked yet",
        "not_tracked_title": "No results yet",
        "not_tracked_body": "This metric can still be reviewed before you have a result. Upload a lab report when you have one and the history will appear here.",
        "upload_results": "Upload results",
        "related_documents": "Related documents",
        "previous_value": "Previous: ${value} ${unit}",
        "history_point": "${day} — ${date}"
      },
      "medication": {
        "default_name": "Medication",
        "scheduled_at": "Scheduled ${times}"
      },
      "cycle_label": {
        "with_type": "${type} Cycle",
        "fallback": "Cycle",
        "started_chip": "Started ${date}"
      },
      "phase_content": {
        "pre_treatment": {
          "description": "Baseline testing, medication review, and preparation before stimulation begins.",
          "detail_1": "Baseline bloodwork and ultrasound",
          "detail_2": "Review and order medications",
          "detail_3": "Practice injection technique with your nurse",
          "detail_4": "Confirm your protocol and schedule"
        },
        "protocol": {
          "description": "Daily hormone injections stimulate your ovaries to grow multiple follicles, each containing a potential egg.",
          "detail_1": "Daily injections to stimulate follicle growth",
          "detail_2": "Antagonist added mid-cycle to prevent premature ovulation",
          "detail_3": "Regular bloodwork and ultrasounds to monitor response",
          "detail_4": "Medication doses may be adjusted based on how you're responding"
        },
        "egg_retrieval": {
          "description": "A short outpatient procedure under light sedation where eggs are collected from your follicles using ultrasound guidance.",
          "detail_1": "Nothing to eat or drink after midnight the night before",
          "detail_2": "The procedure takes about 15–20 minutes under light sedation",
          "detail_3": "A needle guided by ultrasound aspirates fluid from each follicle",
          "detail_4": "You'll know how many eggs were retrieved when you wake up",
          "detail_5": "Plan to rest for the remainder of the day"
        },
        "fertilization": {
          "description": "Retrieved eggs are fertilized (via IVF or ICSI) and embryos are cultured in the lab for 3–5 days.",
          "detail_1": "Day 1: Fertilization check — how many eggs fertilized normally",
          "detail_2": "Day 3: Embryos typically at 6–8 cells",
          "detail_3": "Day 5: Surviving embryos may reach blastocyst stage",
          "detail_4": "Not all eggs fertilize, and not all embryos make it — this is normal",
          "detail_5": "Your clinic will update you on development daily or every other day"
        },
        "transfer": {
          "description": "A single embryo is gently placed into your uterus through a thin catheter. No sedation needed.",
          "detail_1": "Arrive with a comfortably full bladder (helps with ultrasound guidance)",
          "detail_2": "The procedure takes about 5–10 minutes and is usually painless",
          "detail_3": "You'll see the transfer on the ultrasound screen",
          "detail_4": "Return to normal activities the same day",
          "detail_5": "Begin or continue progesterone support as prescribed"
        },
        "luteal_phase": {
          "description": "The waiting period between transfer and your pregnancy blood test (beta hCG).",
          "detail_1": "Continue progesterone and any other prescribed medications",
          "detail_2": "Blood test (beta hCG) around 10–14 days post-transfer confirms pregnancy",
          "detail_3": "Avoid home pregnancy tests early — they can give false results",
          "detail_4": "Mild cramping and spotting can be normal",
          "detail_5": "Lean on your support system — this is often the hardest part emotionally"
        }
      }
    },
    "lab_result": {
      "ref_prefix": "Ref: ${range}",
      "context_title": "How this result was interpreted",
      "context_meta": "Timing context",
      "context_cycle_day": "Cycle day",
      "context_cycle_phase": "Cycle phase",
      "context_treatment_phase": "Treatment phase",
      "context_used": "Context used",
      "context_day_value": "Day ${day}",
      "context_baseline": "Baseline",
      "context_follicular": "Follicular",
      "context_stimulation": "Stimulation",
      "context_ovulatory": "Ovulatory",
      "context_luteal": "Luteal",
      "context_unknown": "Unknown",
      "context_show_details": "Show timing details",
      "context_hide_details": "Hide timing details",
      "abnormal_warning": "Outside reference range. Discuss with your care team.",
      "trend_over_time": "Trend over time",
      "what_is_it": "What is it",
      "why_it_matters": "Why it matters",
      "typical_range": "Typical range",
      "no_info_title": "No detailed information available",
      "no_info_body": "We don't have educational content for this test yet. Your value and history are still recorded above.",
      "all_values": "All values",
      "add_value": "Add another result",
      "add_value_body": "Record a new ${name} value",
      "delete_value_prompt": "Delete this value?",
      "cancel": "Cancel",
      "delete": "Delete",
      "edit_error": "We couldn't save this result. Check the details and try again.",
      "delete_error": "We couldn't delete this result. Try again or cancel to keep it.",
      "edit_value": "Edit value",
      "delete_confirm": "Are you sure you want to delete this result? This action cannot be undone.",
      "disclaimer": "Lab values should be interpreted by your doctor\nin the context of your full clinical picture.",
      "edit_value_label": "Value",
      "edit_value_placeholder": "Enter value",
      "edit_unit_label": "Unit",
      "edit_unit_placeholder": "e.g. pg/mL",
      "edit_cancel": "Cancel",
      "edit_save": "Save",
      "category_lab_result": "Lab Result",
      "loinc_label": "LOINC ${code}",
      "edit_result_title": "Edit result",
      "tab_overview": "Overview",
      "tab_overview_short": "Info",
      "tab_values": "Values",
      "tab_values_short": "Values",
      "tab_biology": "Biology",
      "tab_biology_short": "Bio",
      "tab_related": "Related",
      "tab_related_short": "More",
      "no_values_title": "No history yet",
      "no_values_body": "Add another result to see how this value changes over time.",
      "biological_basis": "Biological basis",
      "how_it_is_measured": "How it is measured",
      "how_it_changes_over_time": "How it changes over time",
      "when_it_is_measured": "When it is measured",
      "how_to_read_it": "How to read it",
      "related_markers": "Connected markers",
      "testing_options": "Get tested",
      "testing_options_empty": "We don't have a linked testing option for this marker yet.",
      "view_test_details": "View test details",
      "related_documents": "Related documents",
      "source_document": "Source report",
      "source_document_pending": "Report processing",
      "source_document_add": "Add source report",
      "source_document_missing": "No report linked yet",
      "documents_empty_title": "No documents linked",
      "documents_empty_body": "Lab reports and appointment documents related to this result will appear here when linked.",
      "latest_value": "Latest value",
      "trend_stable": "Stable",
      "trend_up": "Trending up",
      "trend_down": "Trending down",
      "reference_label": "Reference: ${range}",
      "tag_amh": "AMH",
      "tag_afc": "AFC",
      "tag_testing": "Testing",
      "tag_at_home": "At home",
      "tag_lab": "Lab",
      "tag_clinic_visit": "Clinic visit",
      "tag_pre_cycle": "Pre-cycle",
      "tag_during_cycle": "During cycle",
      "tag_post_cycle": "Post-cycle",
      "tag_ivf": "IVF",
      "tag_fet": "FET",
      "tag_pcos": "PCOS",
      "tag_pmos": "PMOS",
      "tag_thyroid": "Thyroid",
      "sample_blood": "Blood",
      "sample_ultrasound": "Ultrasound",
      "sample_imaging": "Imaging",
      "sample_urine": "Urine",
      "sample_saliva": "Saliva",
      "sample_semen": "Semen",
      "sample_genetic": "Genetic",
      "sample_swab": "Swab",
      "sample_tissue": "Tissue"
    },
    "delivery": {
      "title": "Medication Delivery",
      "in_this_shipment": "In this shipment",
      "estimated_arrival": "Estimated arrival ${time}",
      "tracking_label": "Tracking: ${number}",
      "copied": "Copied!",
      "contact_pharmacy": "Contact ${pharmacy}",
      "not_connected_body": "Delivery tracking will appear here once Louise has a real pharmacy or delivery connection.",
      "not_connected_sheet_title": "Pharmacy delivery tracking",
      "not_connected_sheet_description": "Track shipments from your pharmacy here once Louise connects to real pharmacy or delivery data. Until then, contact your pharmacy directly for ETA and tracking details.",
      "step_placed": "Placed",
      "step_preparing": "Preparing",
      "step_shipped": "Shipped",
      "step_in_transit": "In Transit",
      "step_delivered": "Delivered"
    },
    "cycle_type": {
      "ivf": "IVF Cycle",
      "iui": "IUI Cycle",
      "fet": "FET Cycle",
      "icsi": "IVF + ICSI Cycle",
      "oi": "Ovulation Induction",
      "egg_freezing": "Egg Freezing",
      "embryo_freezing": "Embryo Freezing",
      "sperm_freezing": "Sperm Freezing"
    },
    "phase_type": {
      "pre_treatment": "Pre-Treatment",
      "protocol": "Stimulation Phase",
      "egg_retrieval": "Egg Retrieval",
      "sperm_collection": "Sperm Collection",
      "fertilization": "Fertilization",
      "insemination": "Insemination",
      "embryo_development": "Embryo Development",
      "transfer": "Embryo Transfer",
      "luteal_phase": "Waiting Period"
    },
    "calendar_full_month": {
      "january": "January",
      "february": "February",
      "march": "March",
      "april": "April",
      "may": "May",
      "june": "June",
      "july": "July",
      "august": "August",
      "september": "September",
      "october": "October",
      "november": "November",
      "december": "December"
    },
    "weekday_short": {
      "mon": "MON",
      "tue": "TUE",
      "wed": "WED",
      "thu": "THU",
      "fri": "FRI",
      "sat": "SAT",
      "sun": "SUN"
    },
    "weekday_long": {
      "mon": "Monday",
      "tue": "Tuesday",
      "wed": "Wednesday",
      "thu": "Thursday",
      "fri": "Friday",
      "sat": "Saturday",
      "sun": "Sunday"
    },
    "symptoms": {
      "title": "Daily symptom tracking",
      "question_today": "${question} today?",
      "question_on_date": "${question} on ${date}?",
      "view_all": "View all symptoms",
      "view_fewer": "View fewer",
      "n_logged_today": "${count} logged today — your care team can see this",
      "n_logged_on_date": "${count} logged ${date} — your care team can see this",
      "today": "today",
      "yesterday": "yesterday",
      "category": {
        "digestion": "Digestion",
        "sexual": "Sexual & Reproductive",
        "urogenital": "Urogenital",
        "bleeding": "Bleeding & Clotting",
        "psychological": "Psychological",
        "heart": "Heart & Lungs"
      },
      "symptom": {
        "bloated": "Bloated",
        "nauseous": "Nauseous",
        "cravings": "Cravings",
        "indigestion": "Indigestion",
        "constipation": "Constipation",
        "diarrhea": "Diarrhea",
        "weight_gain": "Weight gain",
        "weight_loss": "Weight loss",
        "high_libido": "High libido",
        "low_libido": "Low libido",
        "ovulation_pain": "Ovulation pain",
        "breast_tenderness": "Breast tenderness",
        "hot_flashes": "Hot flashes",
        "vaginal_dryness": "Vaginal dryness",
        "acne": "Acne",
        "frequent_urination": "Frequent urination",
        "burning": "Burning",
        "incontinence": "Incontinence",
        "spotting": "Spotting",
        "light_bleeding": "Light bleeding",
        "heavy_bleeding": "Heavy bleeding",
        "clots": "Clots",
        "moody": "Moody",
        "anxious": "Anxious",
        "irritable": "Irritable",
        "tired": "Tired",
        "insomnia": "Insomnia",
        "good_energy": "Good energy",
        "feeling_okay": "Feeling okay",
        "palpitations": "Palpitations",
        "shortness_of_breath": "Shortness of breath",
        "injection_site_sore": "Injection site sore",
        "headache": "Headache",
        "cramping": "Cramping",
        "shoulder_pain": "Shoulder pain",
        "fever": "Fever",
        "dizziness": "Dizziness",
        "erectile_difficulty": "Erectile difficulty",
        "testicular_discomfort": "Testicular discomfort",
        "ejaculation_pain": "Ejaculation pain",
        "difficulty_starting_urination": "Difficulty starting urination"
      }
    },
    "start_treatment": {
      "title_start": "Start a treatment cycle",
      "title_edit": "Edit treatment cycle",
      "title_where_when": "Where and when?",
      "subtitle_step1": "Pick the type of treatment you're starting.",
      "subtitle_step2": "${label} · add your clinic and an expected start date.",
      "cycle_ivf": "IVF",
      "cycle_icsi": "IVF + ICSI",
      "cycle_iui": "IUI",
      "cycle_fet": "FET (Frozen Embryo Transfer)",
      "cycle_oi": "Ovulation Induction",
      "cycle_egg_freezing": "Egg Freezing",
      "cycle_embryo_freezing": "Embryo Freezing",
      "cycle_sperm_freezing": "Sperm Freezing",
      "cycle_unavailable": "Supported treatment",
      "cycle_ivf_partner": "IVF (with partner)",
      "cycle_icsi_partner": "IVF + ICSI (with partner)",
      "cycle_iui_partner": "IUI (with partner)",
      "cycle_fet_partner": "FET (with partner)",
      "cycle_embryo_freezing_partner": "Embryo Freezing (with partner)",
      "clinic_label": "Clinic name",
      "clinic_placeholder": "Enter clinic name",
      "date_label": "Expected start date",
      "date_hint": "Approximate is fine. You can update it later.",
      "frozen_selection_title": "CryoVault records selected",
      "frozen_selection_summary": "${count} exact record(s) came from CryoVault and will be reserved when the cycle starts.",
      "frozen_selection_authority_confirmation": "I confirm that I have the authority and required consent to reserve these exact CryoVault records for this treatment cycle.",
      "change_frozen_selection": "Change selection",
      "next": "Next",
      "back": "Back",
      "cancel": "Cancel",
      "save": "Save",
      "start_cycle": "Start cycle",
      "update_cycle": "Update cycle",
      "cycle_already_open": {
        "you_have_open_cycle": "You already have an open cycle",
        "finish_before_starting_new": "Finish your current cycle before starting a new one.",
        "go_to_current_cycle": "Go to my current cycle",
        "not_now": "Not now"
      }
    },
    "discontinue": {
      "title": "Did something change?",
      "description": "This will end the current cycle. All your treatment information, progress, and records will remain accessible from your treatment history.",
      "reason_header": "Reason",
      "reason_medical_advice": "Doctor's recommendation",
      "reason_personal_choice": "Personal reasons",
      "reason_side_effects": "Side effects",
      "reason_protocol_switch": "Switching protocol",
      "reason_financial": "Financial",
      "reason_trigger_not_administered": "Trigger not administered",
      "reason_no_retrieval": "No retrieval performed",
      "reason_other": "Other",
      "notes_label": "Notes (Optional)",
      "notes_placeholder": "If you wish, share a few words about why you're discontinuing...",
      "confirm": "Discontinue Treatment",
      "cancel": "Cancel"
    },
    "complete_cycle": {
      "title": "Complete Cycle",
      "description": "This will mark your cycle as complete. Your treatment history and frozen specimens will remain accessible from past cycles.",
      "summary_header": "Cycle Summary",
      "treatment_label": "Treatment",
      "clinic_label": "Clinic",
      "started_label": "Started",
      "outcome_review_header": "Treatment outcome",
      "retrieved_count": "Eggs retrieved",
      "mature_count": "Mature eggs",
      "fertilized_count": "Normally fertilized",
      "frozen_count": "Frozen eggs",
      "embryos_frozen_count": "Embryos frozen",
      "vials_frozen_count": "Vials frozen",
      "not_recorded": "Not recorded",
      "confirmed_no_stored_specimens": "No specimens were stored from this cycle. You can complete the cycle without adding an inventory record.",
      "stored_specimens_count_mismatch": "The outcome says ${expectedCount} specimens were frozen, but ${storedCount} matching specimens are linked to this cycle. You can add or correct them, or complete the cycle — the record keeps both numbers.",
      "no_frozen_count_recorded": "No frozen count has been recorded for this cycle yet. You can add the stored specimens, or complete the cycle without them.",
      "add_stored_specimens": "Add stored specimens",
      "specimens_one": "${count} frozen specimen",
      "specimens_other": "${count} frozen specimens",
      "stored_specimens_label": "Stored specimens",
      "eggs_one": "${count} egg",
      "eggs_other": "${count} eggs",
      "embryos_one": "${count} embryo",
      "embryos_other": "${count} embryos",
      "vials_one": "${count} vial",
      "vials_other": "${count} vials",
      "group_eggs": "Eggs",
      "group_embryos": "Embryos",
      "group_sperm": "Sperm",
      "notes_label": "Notes (Optional)",
      "notes_placeholder": "Any notes about this cycle...",
      "confirm": "Confirm completion",
      "cancel": "Cancel"
    },
    "beta_result": {
      "header_self": "Record beta hCG result",
      "header_partner": "Record beta hCG result",
      "header_we_are_sorry": "We're sorry",
      "header_pregnancy_confirmed": "Pregnancy confirmed",
      "header_congrats": "Congratulations",
      "header_with_you": "We're with you",
      "intro_self": "Attach the report or enter the number.",
      "intro_partner": "Attach the report or enter the number.",
      "section_result_self": "Your beta hCG result",
      "section_result_partner": "${name}'s beta hCG result",
      "choice_yes_self_title": "Yes, I'm pregnant",
      "choice_yes_partner_title": "Yes, she's pregnant",
      "choice_yes_self_subtitle": "Your beta hCG confirmed pregnancy",
      "choice_yes_partner_subtitle": "${name}'s beta hCG confirmed pregnancy",
      "choice_no_title": "No, not this cycle",
      "choice_no_subtitle": "The beta hCG was negative",
      "not_pregnant_intro_title": "Take whatever time you need.",
      "not_pregnant_intro_body": "Before we close out the cycle, one quick question — feel free to skip it.",
      "notes_label": "Notes (optional)",
      "notes_placeholder_default": "Anything you'd like to remember about this...",
      "notes_placeholder_negative": "Anything you want to write down for yourself? (optional)",
      "notes_placeholder_positive": "Anything you want to remember about this moment? (optional)",
      "continued_title": "Wonderful news ✨",
      "continued_body": "We'll mark this cycle as a positive pregnancy. You can come back and add delivery details later — there's no need to fill anything in now.",
      "save": "Save",
      "value_label_self": "Your beta hCG value",
      "value_label_partner": "${name}'s beta hCG value",
      "value_unit": "mIU/mL",
      "value_placeholder": "e.g. 142",
      "value_notes_prefix": "Beta hCG",
      "collection_date_label": "Collection date (optional)",
      "collection_date_hint": "Add the date if you know when the sample was collected. You can add the time separately.",
      "collection_time_label": "Collection time (optional)",
      "documents_label": "Result document",
      "documents_drop_action": "Add a document",
      "documents_drop_hint": "PDF or photo",
      "document_name_prefix": "Beta hCG result",
      "confirm_your_transfer_before_recording_a_beta": "Confirm your transfer first — the date it happened is what a beta result attaches to. You can do that from your plan, then come back.",
      "fet_order_lookup_pending": "We're still loading beta tracking for this cycle. Please try again in a moment.",
      "earlier_entry_saved": "Your earlier entry was already saved. We've refreshed this cycle — save again to update it with this value.",
      "recorded_by_your_clinic": "Your clinic recorded the result for this cycle, so it cannot be changed here. Contact your care team to update it.",
      "result_cannot_be_changed_here": "This result can't be changed here. Your care team can update it for you.",
      "only_they_can_record_this_result": "${name} is the only person who can record a result for this cycle. They can add it from their own account.",
      "only_the_person_this_cycle_belongs_to_can_record": "Only the person this cycle belongs to can record its result. They can add it from their own account.",
      "uploading": "Uploading…",
      "reading": "Reading…",
      "parsed_badge": "Read",
      "parsed": "Check the value below and edit if needed.",
      "unreadable": "We couldn't read it. Add the value below.",
      "cancel": "Cancel",
      "header_borderline": "A repeat beta is recommended",
      "borderline_subhead": "A level of ${value} mIU/mL is detectable but still low. A repeat test is what tells us whether it's rising, so try not to read too much into this single number.",
      "borderline_repeat_label": "Repeat beta test",
      "borderline_repeat_hint": "Usually in about 48 hours, so your beta series can show whether the level is climbing.",
      "borderline_note": "We've saved this value. You can update the outcome once your repeat result is back.",
      "positive_headline": "Such wonderful news ✨",
      "positive_subhead": "Take a moment. You've been through a lot to get here.",
      "whats_next": "What's next",
      "milestone_first_ultrasound": "First ultrasound",
      "milestone_first_ultrasound_hint": "around 6 weeks gestational",
      "milestone_first_trimester_end": "End of first trimester",
      "milestone_first_trimester_end_hint": "13 weeks",
      "milestone_half_way": "Half-way",
      "milestone_half_way_hint": "20 weeks",
      "keep_cycle_title": "We'll keep this cycle here",
      "keep_cycle_body": "You can come back any time to add delivery details (live birth, twins, etc.) once you're holding your baby.",
      "negative_subhead": "Whatever you're feeling right now is valid. Disappointment, grief, anger, numbness — there's no right way to feel.",
      "resource_care_team_label": "Talk to your care team",
      "resource_care_team_hint": "They can review this cycle and help you think about what comes next.",
      "resource_self_care_label": "Self-care ideas",
      "resource_self_care_hint": "Rest, eat well, move gently. Lean on your support people.",
      "resource_community_label": "Connect with others who understand",
      "resource_community_hint": "Communities of people who've been here too.",
      "done": "Done"
    },
    "select_specimens": {
      "title_embryo": "Select embryos to transfer",
      "title_oocyte": "Select eggs to fertilize",
      "subtitle_embryo": "Pick the embryos you'll use in this transfer.",
      "subtitle_oocyte": "Pick the frozen eggs you'll thaw and fertilize.",
      "starting": "Starting...",
      "pick_at_least_one_embryo": "Pick at least one embryo",
      "pick_at_least_one_egg": "Pick at least one egg",
      "confirm": "Confirm and start",
      "back": "Back",
      "different_retrieval": "different retrieval",
      "reserved_by_open_cycle": "already reserved",
      "reserved_notice": "Some specimens are already reserved for an open cycle and can't be selected here."
    },
    "protocol_notes": {
      "adjustment_type": {
        "dose_change": "Dose change",
        "add_medication": "Add medication",
        "remove_medication": "Stop medication",
        "swap_medication": "Swap medication",
        "protocol_change": "Protocol change",
        "timing_change": "Timing change"
      },
      "urgency": {
        "immediate": "Immediate",
        "next_visit": "Next visit",
        "consider": "Consider"
      },
      "quality": {
        "excellent": "Excellent Response",
        "good": "Good Response",
        "moderate": "Moderate Response",
        "poor": "Poor Response",
        "over": "Over Response"
      },
      "self_reported": "Self-reported",
      "analyzing": "Analyzing protocol...",
      "empty_state": "No protocol adjustments yet",
      "add_button": "Add adjustment",
      "modal_title": "Add protocol adjustment",
      "missing_info_title": "Missing info",
      "missing_info_message": "Please fill in the required fields.",
      "save_error_title": "Error",
      "save_error_message": "Could not save. Please try again.",
      "save_button": "Save adjustment",
      "reason_label": "Reason (optional)",
      "reason_placeholder": "e.g. Doctor adjusted after monitoring",
      "select_medication_title": "Select medication",
      "select_medication_subtitle_stop": "Pick the one you want to stop.",
      "select_medication_subtitle_dose": "Pick the one to adjust.",
      "select_medication_subtitle_swap": "Pick the one to replace.",
      "no_active_meds": "No active medications yet. Add one first.",
      "swap_replacing_banner": "Replacing ${medication}",
      "confirm_stop_title": "Stop ${medication}?",
      "confirm_stop_message": "This will mark ${medication} as stopped today.",
      "confirm_stop_cta": "Stop",
      "cancel": "Cancel",
      "stop_reason_label": "Reason (optional)",
      "stop_reason_placeholder": "e.g. side effect, doctor instructed, dose change…",
      "stop_heading": "Stop ${medication}",
      "stop_heading_help": "Add a quick reason if you'd like — it's saved in your notes.",
      "swap_step1_heading": "Replace ${medication}",
      "swap_step1_help": "We'll mark it as stopped, then walk you through the new medication.",
      "swap_reason_label": "Reason (optional)",
      "swap_reason_placeholder": "e.g. side effect, doctor changed protocol, dose issue…",
      "swap_continue_cta": "Continue",
      "note_dose_change_summary": "${oldDose} → ${newDose}",
      "start_medication": "Start ${medication}",
      "stop_medication": "Stop ${medication}",
      "ai_swap_current": "Current",
      "ai_swap_new": "New",
      "ai_timing_fallback": "Timing Adjustment",
      "user_fallback": {
        "dose_change": "Dose Adjustment",
        "add_medication": "Add Medication",
        "remove_medication": "Stop Medication",
        "swap_medication": "Swap Medication",
        "protocol_change": "Protocol Change"
      },
      "field": {
        "medication": "Medication",
        "current_dose": "Current dose",
        "new_dose": "New dose",
        "dosage": "Dosage",
        "medication_to_stop": "Medication to stop",
        "current_medication": "Current medication",
        "new_medication": "New medication",
        "new_dosage": "New dosage",
        "description": "Description"
      },
      "placeholder": {
        "medication_gonal": "e.g. Gonal-F",
        "current_dose": "e.g. 150 IU",
        "new_dose": "e.g. 225 IU",
        "medication_cetrotide": "e.g. Cetrotide",
        "dosage": "e.g. 0.25mg daily",
        "medication_menopur": "e.g. Menopur",
        "medication_follistim": "e.g. Follistim",
        "new_dosage": "e.g. 150 IU daily",
        "description": "e.g. Switch to antagonist protocol"
      }
    },
    "response_chart": {
      "default_title": "Your Response",
      "last_label": "Last: ${date}",
      "empty_title": "No monitoring data yet",
      "empty_subtitle": "Add your first entry to start tracking your response.",
      "add_data_button": "Add monitoring data",
      "axis_day": "Day",
      "axis_follicles": "Follicles",
      "axis_lining": "Lining (mm)",
      "axis_estradiol": "Estradiol (pg/mL)",
      "axis_lh": "LH (mIU/mL)",
      "axis_progesterone": "Progesterone (ng/mL)",
      "trigger_label": "Trigger",
      "follicle_avg": "avg ${size} mm",
      "mode": {
        "e2": "E2",
        "follicles": "Follicles",
        "lining": "Lining",
        "lh": "LH",
        "p4": "P4"
      },
      "metric": {
        "estradiol_label": "Estradiol",
        "estradiol_description": "Estradiol (E2) is the primary estrogen produced by growing ovarian follicles. It rises as follicles mature during stimulation.",
        "estradiol_why": "Rising E2 levels confirm that follicles are growing and responding to medication. Your doctor uses this to adjust medication doses and determine when you're ready for trigger.",
        "estradiol_range": "During stim, E2 typically rises ~200–300 pg/mL per mature follicle. Values of 1,500–3,000 pg/mL are common at trigger.",
        "follicles_label": "Follicles",
        "follicles_description": "Follicles are fluid-filled sacs in the ovaries, each potentially containing an egg. They are counted and measured via ultrasound during monitoring.",
        "follicles_why": "The number and size of follicles helps predict how many eggs may be retrieved. Your doctor aims for multiple follicles growing at a similar rate.",
        "follicles_range": "A good response is typically 8–15 follicles. Follicles are considered mature at 17–22mm diameter.",
        "lining_label": "Lining",
        "lining_description": "The endometrial lining is the tissue that lines the inside of your uterus. Rising estrogen causes it to thicken during stimulation.",
        "lining_why": "A thick, receptive lining is essential for successful implantation. Thin linings can sometimes be improved with additional estrogen support.",
        "lining_range": "Ideal for transfer is 8–14mm with a trilaminar pattern. Below 7mm may prompt a freeze-all strategy.",
        "lh_label": "LH",
        "lh_description": "Luteinizing Hormone (LH) triggers ovulation naturally. During IVF, LH is suppressed with antagonist medication to prevent premature ovulation.",
        "lh_why": "If LH surges too early, you could ovulate before egg retrieval. Keeping it suppressed ensures eggs remain in the follicles until retrieval day.",
        "lh_range": "During antagonist protocol, LH should stay below 10 mIU/mL. A sudden rise above 10 may signal a premature surge.",
        "p4_label": "Progesterone",
        "p4_description": "Progesterone (P4) prepares the uterine lining for implantation. During stimulation it should stay low — a premature rise can indicate follicles are luteinizing before retrieval.",
        "p4_why": "Your doctor monitors P4 close to trigger. If it rises above ~1.5 ng/mL late in stimulation, retrieval timing or the protocol may need adjustment.",
        "p4_range": "During antagonist protocol, P4 typically stays under 1.5 ng/mL until after trigger."
      },
      "context": {
        "on_track": "On track",
        "monitor_closely": "Monitor closely",
        "rising_well": "Rising well",
        "low_adjustment": "Low — may need adjustment",
        "strong_response": "Strong response",
        "good_response": "Good response",
        "moderate_response": "Moderate response",
        "low_response": "Low response",
        "optimal_thickness": "Optimal thickness",
        "nearly_optimal": "Nearly optimal",
        "still_thickening": "Still thickening",
        "thin_monitoring": "Thin — monitoring",
        "elevated_contact": "Elevated — contact your clinic",
        "well_suppressed": "Well suppressed",
        "within_range": "Within range",
        "approaching_threshold": "Approaching threshold"
      }
    },
    "outcome_funnel_card": {
      "embryo_title": "Embryo funnel estimate",
      "embryo_subtitle": "A planning estimate from retrieval through fertilization, blastocysts, possible PGT-A, and freezing.",
      "egg_title": "Egg-freezing funnel estimate",
      "egg_subtitle": "A planning estimate from retrieval through maturity check and freezing.",
      "collapse": "Collapse",
      "expand": "Expand",
      "embryo_a11y": "embryo funnel estimate",
      "egg_a11y": "egg-freezing funnel estimate"
    },
    "stim_editor": {
      "empty_cta": "Add monitoring data",
      "empty_subtitle": "Track your stim metrics here",
      "table_metric": "Metric",
      "row": {
        "e2": "E2 (pg/mL)",
        "lh": "LH (mIU/mL)",
        "p4": "P4 (ng/mL)",
        "follicles_right": "Follicles R",
        "follicles_left": "Follicles L",
        "lining": "Lining (mm)"
      },
      "edit_cell": {
        "count_label": "Count",
        "sizes_label": "Sizes (mm)",
        "count_placeholder": "e.g. 5",
        "sizes_placeholder": "e.g. 12, 14, 16",
        "sizes_hint": "Optional. Separate sizes with commas.",
        "value_placeholder": "Enter value",
        "save": "Save"
      },
      "add_day": {
        "title": "Add monitoring data",
        "today": "Today",
        "subtitle": "Enter your monitoring values",
        "save_all": "Save All",
        "saving": "Saving..."
      },
      "validation": {
        "enter_number": "Enter a number.",
        "must_be_zero_or_more": "Must be 0 or greater.",
        "must_be_max_or_less": "Must be ${max} or less.",
        "sizes_format": "Enter sizes in mm separated by commas (e.g. 12,14,16).",
        "sizes_zero_or_more": "Sizes must be 0 mm or greater.",
        "sizes_max": "Each size must be ${max} mm or less."
      },
      "alert": {
        "unable_to_save_title": "Unable to save",
        "no_cycle": "No active cycle found.",
        "save_failed_title": "Save failed",
        "save_failed_message": "Could not save monitoring data. Please try again."
      }
    },
    "overview": {
      "eyebrow_care": "Care",
      "eyebrow_current_cycle": "Current cycle · ${type}",
      "pre_cycle_title": "Your care space",
      "pre_cycle_summary": "Use the calendar, logs, appointments, and records here now. Start a treatment cycle only if and when you choose one.",
      "summary_default": "Keep medications, appointments, labs, documents, and care-team updates connected to this active cycle.",
      "summary": {
        "egg_freezing": "Keep medications, monitoring, retrieval timing, lab updates, and storage records connected to this egg-freezing cycle.",
        "sperm_freezing": "Track collection timing, testing, storage, and follow-up tasks for this sperm-freezing cycle.",
        "iui": "Track medications, monitoring, insemination timing, and the waiting period for this IUI cycle.",
        "ivf": "Keep medications, monitoring, retrieval, lab updates, transfer planning, and records connected to this IVF cycle.",
        "icsi": "Keep medications, monitoring, retrieval, ICSI lab updates, transfer planning, and records connected to this cycle.",
        "fet": "Track transfer preparation, medications, lining checks, transfer timing, and the waiting period.",
        "embryo_freezing": "Keep medications, monitoring, retrieval timing, fertilization updates, embryo development, and storage records connected to this cycle."
      },
      "title_phase_day": "${phase} day ${day}",
      "header": {
        "cycle_closed_title": "Cycle complete",
        "pre_treatment_title": "Pre-treatment · day ${day}",
        "stim_trigger_logged_title": "Trigger done · schedule your retrieval",
        "stim_trigger_logged_summary": "Usually ~36 h after the trigger. Add your retrieval date once the clinic confirms it.",
        "stim_monitoring_title": "Stim · monitoring ${when}",
        "stim_med_title": "Stim · next injection ${when} at ${time}",
        "stim_generic_title": "Stim · day ${day}",
        "retrieval_scheduled_title": "Retrieval ${when}",
        "retrieval_done_pending_title": "Retrieval done · results coming",
        "fertilization_title": "Fertilization in progress",
        "embryo_dev_title": "Embryo development · day ${day}",
        "transfer_scheduled_title": "Transfer ${when}",
        "beta_scheduled_title": "Two-week wait · beta ${when}",
        "beta_pending_title": "Two-week wait · schedule your beta",
        "result_recorded_title": "Your result is saved",
        "unknown_active_title": "Active cycle"
      },
      "team": {
        "role_provider": "Provider",
        "label_clinic": "Clinic",
        "clinic_connected": "Clinic connected to this cycle.",
        "clinic_add_details": "Add providers, portal details, and cycle instructions.",
        "section_title": "Your team for this cycle"
      },
      "quick_add": {
        "medication": "Medication",
        "appointment": "Appointment",
        "document": "Document",
        "start_cycle": "Start cycle"
      },
      "menu": {
        "view_cycle_details": "View cycle details",
        "view_past_cycles": "View past cycles",
        "cycle_documents": "Cycle documents",
        "end_cycle": "End cycle",
        "start_cycle": "Start cycle",
        "documents": "Documents"
      },
      "alerts": {
        "choose_treatment_title": "Choose a treatment type",
        "choose_treatment_message": "Please select a supported treatment type before starting a cycle.",
        "unable_to_start_title": "Unable to start cycle",
        "unable_to_start_message": "Something went wrong. Please try again.",
        "reserve_specimens_failed_title": "Cycle started, specimens not linked",
        "reserve_specimens_failed_message": "Your cycle was created, but we couldn't link your selected frozen specimens to it. Press Start cycle again to retry; your selection is still here.",
        "frozen_specimen_consent_required_title": "Confirmation required",
        "frozen_specimen_consent_required_message": "Confirm that you have the authority and required consent to reserve the selected CryoVault records before starting this cycle.",
        "frozen_selection_mismatch_title": "Choose the matching treatment",
        "frozen_selection_mismatch_message": "Frozen embryos can be linked to a frozen embryo transfer, frozen eggs can be linked to IVF or ICSI, and frozen semen can be linked to IUI, IVF, or ICSI. Your frozen selection is still here."
      },
      "calendar": {
        "markers": {
          "meds": "Meds",
          "appointment": "Appointment",
          "test": "Test",
          "period": "Period",
          "fertileWindow": "Fertile window"
        },
        "prediction": {
          "title": "Fertile window estimate",
          "insufficient_title": "Fertile window unavailable",
          "insufficient_body": "Log at least two period starts to get a personalized fertile-window estimate.",
          "dismiss_a11y": "Dismiss fertile window notice",
          "confidence": "Confidence: ${level}.",
          "confidence_levels": {
            "low": "low",
            "medium": "medium",
            "high": "high"
          },
          "cycle": "Cycle",
          "logged": "Logged",
          "peak_fertility": "Peak fertility",
          "fertile_window": "Fertile window",
          "predicted": "Predicted",
          "peak": "Peak",
          "fertile": "Fertile",
          "warnings": {
            "limited_history": "This estimate is based on limited cycle history and will improve as more cycles are logged.",
            "irregular_history": "Your cycle history looks irregular, so this estimate is wider and less certain."
          },
          "disclaimer": "These dates are estimates, not a contraceptive method or medical advice."
        },
        "log_tabs": {
          "symptoms": "Symptoms",
          "monitoring": "Monitoring",
          "schedule": "Meds & visits"
        },
        "check_in": {
          "saved": "Saved",
          "future_date": "This date is in the future, so you cannot log symptoms for it yet.",
          "choose": "Choose",
          "today": "today",
          "or_past_day": "or a past day instead.",
          "select_today_a11y": "Select today",
          "bleeding_title": "Bleeding or spotting",
          "notes_title": "Notes",
          "notes_placeholder": "Whatever's on your mind today...",
          "view_all": "View all symptoms",
          "view_fewer": "View fewer",
          "view_all_a11y": "View all symptoms",
          "view_fewer_a11y": "View fewer symptoms",
          "log_symptoms_a11y": "Log symptoms",
          "log_button": "Log",
          "save_failed": "We couldn't save your check-in. Your draft is still here. Try again.",
          "selected_day_loading": "Loading this day's check-in…",
          "selected_day_unavailable_title": "We couldn't load this day's check-in",
          "selected_day_unavailable_body": "Your saved records are safe. Try again before adding or changing symptoms."
        },
        "nav": {
          "previous_week_a11y": "Previous week",
          "previous_month_a11y": "Previous month",
          "next_week_a11y": "Next week",
          "next_month_a11y": "Next month",
          "show_week_view_a11y": "Show week view",
          "show_month_view_a11y": "Show month view"
        },
        "empty": {
          "title": "Nothing scheduled for ${monthName} ${date}.",
          "subtitle": "Add an appointment, medication, test, or period log from the quick actions above."
        },
        "no_selected_day": {
          "title": "Select a day to review it.",
          "body": "Choose a day in the calendar to see medications, appointments, and check-in details."
        },
        "summary": {
          "title": "Symptoms saved",
          "no_symptoms": "No symptoms logged",
          "symptom_one": "${count} symptom",
          "symptom_other": "${count} symptoms",
          "notes_added": "notes added"
        },
        "monitoring_log": {
          "action_label": "log monitoring results",
          "add_result": "Add monitoring result",
          "future_date": "This date is in the future, so you cannot ${action} for it yet.",
          "read_loading": "Loading monitoring data…",
          "read_unavailable_title": "We couldn't load monitoring data",
          "read_unavailable_body": "Your saved monitoring records are safe. Try again before adding or changing results.",
          "subtitle": "Review the last visit, then record what changed on this date.",
          "field": {
            "follicles_label": "Follicles",
            "follicles_value": "Add count",
            "lead_size_label": "Lead follicle",
            "lead_size_value": "Add mm",
            "lining_label": "Lining",
            "lining_value": "Add mm",
            "estradiol_label": "Estradiol",
            "estradiol_value": "Add pg/mL",
            "lh_label": "LH",
            "lh_value": "Optional",
            "progesterone_label": "Progesterone",
            "progesterone_value": "Optional"
          },
          "modal": {
            "title": "Add monitoring result",
            "subtitle": "Capture the ultrasound and bloodwork together for one visit.",
            "date_label": "Monitoring on ${date}",
            "date_input_label": "Monitoring date",
            "date_required": "Add the monitoring date before saving.",
            "date_future": "Choose today or an earlier date.",
            "needs_one_value": "Add at least one monitoring value before saving.",
            "save_failed_keep_draft": "We couldn't save these monitoring results. Your entries are still here — try saving again.",
            "date_detail": "This saves a separate result for the selected calendar date.",
            "previous_title": "Previous monitoring",
            "previous_detail": "Use this as context. Only values you enter below will be saved for this date.",
            "import_title": "Add from document",
            "import_detail": "Add one or more images or PDFs to prefill these fields.",
            "import_action": "Upload",
            "import_notice": "Parsed values have been added below. Review them before saving this monitoring visit.",
            "ultrasound_title": "Ultrasound",
            "ultrasound_detail": "Enter the follicle measurements when they are available; counts and lead follicle are derived.",
            "left_follicles": "Left ovary follicles",
            "right_follicles": "Right ovary follicles",
            "derived_count_left": "Left count",
            "derived_count_right": "Right count",
            "derived_lead": "Lead follicle",
            "fallback_count_left": "Left follicle count",
            "fallback_count_right": "Right follicle count",
            "count_placeholder": "Optional",
            "lining_placeholder": "e.g. 8.5",
            "blood_title": "Bloodwork",
            "blood_detail": "Add the values shown on the same monitoring report.",
            "estradiol_label": "Estradiol (E2)",
            "lh_label": "LH",
            "fsh_label": "FSH",
            "progesterone_label": "Progesterone",
            "lining_label": "Endometrial lining thickness",
            "notes_label": "Notes or instructions",
            "notes_placeholder": "Anything you want to remember…",
            "cancel": "Cancel",
            "save": "Save",
            "left": "Left",
            "right": "Right",
            "input_placeholder": "Add value",
            "input_placeholder_with_unit": "Add ${unit}",
            "sizes_placeholder": "e.g. 12, 14, 16",
            "cell_edit": {
              "subtitle": "${date} · Update only this monitoring detail.",
              "follicles_title": "Follicles",
              "left_ovary": "Left ovary",
              "right_ovary": "Right ovary",
              "lining_title": "Endometrial lining",
              "lining_label": "Lining thickness",
              "estradiol_title": "Estradiol",
              "estradiol_label": "Estradiol (E2)",
              "lh_title": "LH",
              "lh_label": "LH",
              "progesterone_title": "Progesterone",
              "progesterone_label": "Progesterone",
              "value_placeholder": "Add value",
              "value_required": "Add a value before saving.",
              "save_error": "We couldn't save this monitoring value. Please try again.",
              "cancel": "Cancel",
              "save": "Save"
            }
          }
        },
        "schedule_log": {
          "subtitle": "Add or review medications and appointments connected to this date.",
          "add_medication": "Add medication",
          "add_visit": "Add visit",
          "empty": "Nothing is scheduled on this date yet.",
          "read_loading": "Loading medications and appointments…",
          "read_unavailable_title": "We couldn't load medications and appointments",
          "read_unavailable_body": "Your saved schedule is still safe. Check your connection and try again.",
          "read_stale_body": "Some medications or appointments may be out of date. Try again to refresh them.",
          "read_medication_log_stale_body": "We couldn't load completion status for your medications. Your scheduled doses are still shown, but their status may be out of date. Try again to refresh it."
        },
        "overlay": {
          "cancel": "Cancel",
          "save": "Save"
        }
      },
      "symptoms": {
        "bleeding": {
          "none": "None",
          "spotting": "Spotting",
          "light_bleeding": "Light bleeding",
          "medium_bleeding": "Medium bleeding",
          "heavy_bleeding": "Heavy bleeding",
          "clots": "Clots"
        },
        "category": {
          "worth_flagging": "Worth flagging",
          "digestion": "Digestion",
          "sexual_reproductive": "Sexual & Reproductive",
          "urogenital": "Urogenital",
          "psychological": "Psychological",
          "body_skin": "Body & skin"
        },
        "item": {
          "injection_site_sore": "Injection site sore",
          "headache": "Headache",
          "cramping": "Cramping",
          "dizziness": "Dizziness",
          "palpitations": "Palpitations",
          "shortness_of_breath": "Shortness of breath",
          "chest_tightness": "Chest tightness",
          "fever": "Fever",
          "chills": "Chills",
          "vomiting": "Vomiting",
          "bloated": "Bloated",
          "nauseous": "Nauseous",
          "constipation": "Constipation",
          "diarrhea": "Diarrhea",
          "cravings": "Cravings",
          "indigestion": "Indigestion",
          "appetite_changes": "Appetite changes",
          "high_libido": "High libido",
          "low_libido": "Low libido",
          "ovulation_pain": "Ovulation pain",
          "breast_tenderness": "Breast tenderness",
          "frequent_urination": "Frequent urination",
          "burning": "Burning",
          "incontinence": "Incontinence",
          "moody": "Moody",
          "anxious": "Anxious",
          "irritable": "Irritable",
          "tired": "Tired",
          "insomnia": "Insomnia",
          "good_energy": "Good energy",
          "feeling_okay": "Feeling okay",
          "fatigue": "Fatigue",
          "body_aches": "Body aches",
          "hot_flashes": "Hot flashes",
          "acne": "Acne",
          "dry_skin": "Dry skin",
          "hair_loss": "Hair loss"
        }
      },
      "guides": {
        "early_pregnancy_title": "Early-pregnancy guide",
        "early_pregnancy_subtitle": "Repeat blood tests, the first ultrasound, symptoms worth calling about, and how dating gets confirmed.",
        "egg_freezing_title": "Egg-freezing guide",
        "egg_freezing_subtitle": "Medication timing, monitoring visits, retrieval prep, and what lab updates usually mean.",
        "ivf_title": "IVF guide",
        "ivf_subtitle": "Stimulation, retrieval, fertilization, embryo development, transfer planning, and lab updates.",
        "embryo_freezing_title": "Embryo-freezing guide",
        "embryo_freezing_subtitle": "Retrieval, fertilization, embryo growth, freezing, storage, and report timing.",
        "transfer_title": "Transfer guide",
        "transfer_subtitle": "Lining checks, medication timing, transfer day, and the waiting period.",
        "iui_title": "IUI guide",
        "iui_subtitle": "Medication timing, monitoring, trigger timing, insemination, and the waiting period.",
        "sperm_freezing_title": "Sperm-freezing guide",
        "sperm_freezing_subtitle": "Testing, collection timing, storage records, and follow-up tasks.",
        "fallback_title": "Care guide",
        "fallback_subtitle": "Treatment basics, testing, medication references, procedures, and records."
      },
      "conditions": {
        "pcos": "PCOS",
        "endometriosis": "Endometriosis",
        "fibroids": "Fibroids",
        "low_ovarian_reserve": "Low ovarian reserve",
        "early_menopause": "Early menopause",
        "varicocele": "Varicocele",
        "klinefelter": "Klinefelter syndrome",
        "y_microdeletion": "Y-chromosome microdeletion",
        "undescended_testicles": "Undescended testicles",
        "genital_tract_obstruction": "Genital tract obstruction",
        "retrograde_ejaculation": "Retrograde ejaculation",
        "erectile_dysfunction": "Erectile dysfunction",
        "thyroid": "Thyroid",
        "modal": {
          "condition_a11y": "I do not have conditions to add",
          "condition_none": "None to add",
          "condition_none_suggestions_a11y": "Hide these condition suggestions",
          "condition_none_suggestions": "None of these suggestions",
          "condition_add": "Add condition",
          "specimen_a11y": "I do not have frozen specimens to add",
          "specimen_none": "None to add",
          "specimen_add_a11y": "Add frozen specimens",
          "specimen_type_eggs": "Eggs",
          "specimen_type_embryos": "Embryos",
          "specimen_type_sperm": "Sperm",
          "specimen_type_facility": "Facility",
          "specimen_type_reports": "Reports"
        },
        "section_title": "Conditions & diagnoses",
        "section_subtitle": "Conditions, diagnoses, and surgical history that may affect care, coverage, or records.",
        "add_a11y": "Add a condition or diagnosis",
        "add_short": "Add",
        "empty_title": "Any conditions or diagnoses to keep with your care?",
        "empty_subtitle": "Add anything relevant now, or hide these suggestions if none of them apply.",
        "suggestions_hidden_title": "Condition suggestions hidden",
        "suggestions_hidden_subtitle": "This only hides these quick suggestions. It does not mark your full disease history as complete.",
        "restore_suggestions": "Show suggestions",
        "restore_suggestions_a11y": "Show condition suggestions again"
      },
      "screen_title": "Care",
      "testing_actions": {
        "order_title": "Order or schedule tests",
        "order_subtitle": "At-home, clinic, and lab options for everything",
        "learn_title": "Learn what each test means",
        "learn_subtitle": "Ranges, timing, prep notes, and why markers can shift"
      },
      "testing": {
        "title": "Testing",
        "all_tests": "All tests",
        "lab_results_title": "Lab results",
        "upload_results_title": "Upload results",
        "lab_results_subtitle_one": "${count} result saved from your records.",
        "lab_results_subtitle_other": "${count} results saved from your records.",
        "upload_results_subtitle": "Add lab reports, ultrasound reports, and other test results as they come in.",
        "upload_lab_results_title": "Upload lab results"
      },
      "good_to_know": {
        "title": "Good to know",
        "tests_markers_title": "Tests & markers",
        "tests_markers_subtitle": "Ranges, timing, prep notes, and why markers can shift"
      },
      "pharmacy": {
        "section_title": "Pharmacy",
        "medication_guide_title": "Medication guide",
        "medication_guide_subtitle": "Fact sheets, side effects, timing notes, and interaction checks.",
        "inventory_title": "Medication inventory",
        "inventory_subtitle": "Physical stock currently available for this cycle.",
        "session_only_note": "Inventory lives on this device for now — it isn't saved to your account and resets when the app restarts.",
        "inventory_on_hand_badge": "${count} on hand",
        "add_stock": "Add stock",
        "open_guide": "Open guide",
        "contact_pharmacy": "Contact pharmacy",
        "edit_inventory": "Edit inventory",
        "inventory_dialog_cancel": "Cancel",
        "inventory_dialog_save": "Save",
        "inventory_dialog_title": "Edit inventory",
        "inventory_dialog_subtitle": "This only tracks what is physically on hand. It does not create a dose schedule or prescription.",
        "in_this_shipment": "In this shipment",
        "decrease_a11y": "Decrease ${name}",
        "increase_a11y": "Increase ${name}",
        "hide_a11y": "Hide ${title}",
        "expand_a11y": "Expand ${title}",
        "collapse_a11y": "Collapse ${title}",
        "confirmed_status_label": "On hand",
        "confirmed_timing_delivery": "Confirmed on hand",
        "confirmed_timing_pickup": "Picked up just now",
        "confirmed_estimated_delivery": "Medications confirmed on hand",
        "confirmed_estimated_pickup": "Pickup confirmed",
        "confirmed_detail": "Marked on hand. Keep these medications where you can find them when the clinic updates your plan.",
        "confirmation_done": "Medications on hand",
        "confirmation_default": "I got them"
      },
      "lab_cryo": {
        "lab_and_cryo_heading": "Lab & cryo",
        "add_lab_report": "Add report",
        "laboratory_activity_title": "In the lab",
        "laboratory_activity_subtitle": "Your eggs' journey through this cycle.",
        "view_my_cycle": "View my cycle",
        "funnel_retrieved": "Eggs retrieved",
        "funnel_mature": "Mature",
        "funnel_injected": "Injected (ICSI)",
        "funnel_fertilized": "Fertilized",
        "funnel_day3": "Day 3 embryos",
        "funnel_blastocysts": "Blastocysts",
        "funnel_transferred": "Transferred",
        "funnel_frozen_embryos": "Frozen embryos",
        "funnel_frozen_eggs": "Frozen eggs",
        "funnel_detail_share": "${share}% of retrieved eggs",
        "funnel_detail_recorded": "Recorded",
        "report_saved_one": "${count} result saved in your records.",
        "report_saved_other": "${count} results saved in your records.",
        "report_add_subtitle": "Add retrieval reports, maturity checks, freezing confirmations, and storage records.",
        "report_status_saved": "Saved",
        "report_status_add": "Add"
      },
      "medical_context": {
        "section_title": "Medical Context"
      },
      "cycle_handoff": {
        "title": "Done with this cycle?",
        "subtitle": "Close it when the outcome is clear. Everything you logged stays attached.",
        "end_cycle_a11y": "End cycle",
        "end_cycle_button": "End cycle"
      },
      "past_cycles": {
        "title_one": "${count} past cycle",
        "title_other": "${count} past cycles",
        "subtitle": "Previous IUI, medicated cycles, IVF, transfers, retrievals, and freezing rounds.",
        "add_a11y": "Add past treatment history",
        "add_short": "Add"
      }
    },
    "records": {
      "section_title": "Records",
      "view_all": "View all",
      "import_title": "Import my records",
      "import_subtitle": "Retrieve records from clinics and hospitals",
      "category": {
        "medical_title": "Medical records",
        "medical_subtitle": "Labs & reports",
        "coverage_title": "Insurance & coverage",
        "coverage_subtitle": "Cards & auths",
        "legal_title": "Forms & agreements",
        "legal_subtitle": "Consents & signed forms",
        "admin_title": "Bills & payments",
        "admin_subtitle": "Invoices, receipts & claims"
      }
    },
    "stim_monitoring_section": {
      "stimulation_monitoring": "Stimulation monitoring",
      "endometrial_monitoring": "Endometrial monitoring",
      "view_chart": "Chart",
      "view_table": "Table",
      "show_view_a11y": "Show ${label} view",
      "add_monitoring_a11y": "Add monitoring data",
      "monitoring_recorded": "Monitoring recorded",
      "decision_recorded": "Decision recorded",
      "not_proceeding": "Not proceeding"
    },
    "stim_response_chart": {
      "empty_title": "Not enough data yet",
      "empty_subtitle": "Add a couple of monitoring days to see follicle growth and estradiol together.",
      "legend_mature": "Mature ≥17",
      "legend_maturing": "Maturing 14-16",
      "legend_size": "Follicle size",
      "legend_e2": "Estradiol",
      "legend_lining": "Lining",
      "threshold_mature": "17 mm",
      "threshold_maturing": "14 mm",
      "axis_size": "Follicle mm",
      "axis_follicles_and_lining_mm": "Follicles · Lining (mm)",
      "axis_lining_mm": "Lining mm",
      "axis_days": "Day",
      "trigger": "Trigger"
    },
    "stim_sheet_view": {
      "no_monitoring_logged": "No monitoring logged yet",
      "monitoring_empty_prompt": "Add a monitoring result from a clinic report or enter it yourself.",
      "row_meds": "Meds",
      "row_e2": "E2 (pg/mL)",
      "row_lh": "LH (mIU/mL)",
      "row_p4": "P4 (ng/mL)",
      "row_lining": "Lining (mm)",
      "row_follicles": "Follicles",
      "follicle_larger_summary": "Lead ${lead} mm · ${larger} ≥17 mm",
      "trigger_label": "Trigger",
      "medication_fallback": "Medication",
      "more_meds": "+${count} more",
      "outcome_title": "Cycle outcome",
      "outcome_subtitle": "From this stimulation cycle",
      "outcome_retrieved": "Eggs retrieved",
      "outcome_mature": "Mature (M2)",
      "outcome_fertilized": "Fertilized",
      "outcome_blastocysts": "Blastocysts",
      "outcome_frozen": "Frozen"
    },
    "clinic_team": {
      "rei_label": "REI",
      "rei_description": "Reproductive endocrinologist",
      "clinic_label": "Clinic",
      "clinic_connected": "Clinic connected to this cycle.",
      "clinic_add_details": "Add providers, portal details, and cycle instructions."
    },
    "guidance": {
      "status_done": "Done",
      "status_skipped": "Skipped",
      "status_current": "Current",
      "a11y_expand_step": "Expand ${step}",
      "a11y_collapse_step": "Collapse ${step}",
      "cards": {
        "how_it_works": "How it works",
        "what_to_expect": "What to expect",
        "how_to_prepare": "How to prepare",
        "when_to_call": "When to call your clinic"
      },
      "step": {
        "sperm_collection": {
          "description": "Sperm sample collection for fertilization",
          "how_it_works": "A semen sample is collected and prepared by the lab for use in fertilization or insemination. Timing is coordinated with the egg retrieval or insemination procedure.",
          "what_to_expect": [
            "Sample collected at the clinic or brought from home if pre-arranged",
            "Lab washes and prepares the sample",
            "Results are usually available the same day"
          ],
          "prep_instructions": [
            "Follow your clinic's abstinence guidance",
            "Avoid alcohol, hot tubs, and heavy exercise in the days before",
            "Stay hydrated"
          ]
        },
        "pgt": {
          "description": "Genetic testing of your embryos before transfer",
          "how_it_works": "A few cells are biopsied from each embryo at the blastocyst stage and sent to a genetics lab. Embryos are frozen while you wait for results, which usually take one to two weeks. The results show which embryos are chromosomally normal (euploid) and best to transfer.",
          "what_to_expect": [
            "Biopsy at the blastocyst stage, then embryos are frozen",
            "Results typically take 1 to 2 weeks",
            "Each embryo is reported as euploid, aneuploid, or no result",
            "Your clinic uses the results to choose which embryo to transfer"
          ],
          "prep_instructions": [
            "Upload the PGT report when your clinic shares it",
            "Note how many embryos came back euploid",
            "Ask your clinic which embryo they recommend transferring"
          ]
        },
        "freezing_sperm": {
          "description": "Frozen vial count and storage handoff",
          "how_it_works": "After the sample is analyzed, the lab divides it into vials or straws, freezes them, and records how many are available for future use. Storage details can then be connected to the Cryo Vault.",
          "what_to_expect": [
            "Final vial or straw count",
            "Freeze date and storage facility",
            "Lab notes from the freezing report",
            "Specimen IDs or storage labels if the clinic provides them"
          ],
          "prep_instructions": [
            "Upload the semen analysis or freezing report if you have it",
            "Confirm the storage facility and annual storage plan",
            "Save vial IDs or labels when they are available"
          ],
          "when_to_call": [
            "The vial count does not match your report",
            "You are missing the storage location or specimen IDs",
            "You need to transfer storage to another facility"
          ]
        },
        "freezing_embryo": {
          "description": "Embryos frozen and stored from this cycle",
          "how_it_works": "The embryology team tracks fertilization and embryo development, then freezes embryos that are suitable for storage. This outcome summarizes what made it to freezing and what records should be attached.",
          "what_to_expect": [
            "Fertilization and embryo development counts",
            "Embryos frozen, often with day and grade details",
            "PGT biopsy status if genetic testing was used",
            "Storage location and embryo identifiers"
          ],
          "prep_instructions": [
            "Upload the embryology or freezing report",
            "Confirm embryo grades and freeze dates",
            "Attach storage details in Cryo Vault when available"
          ],
          "when_to_call": [
            "Embryo counts or grades are unclear",
            "You are missing the freezing report",
            "Storage or genetic testing details do not match your records"
          ]
        },
        "freezing_eggs": {
          "description": "Mature eggs, eggs frozen, and lab notes",
          "how_it_works": "After retrieval, the lab checks which eggs are mature enough to freeze and confirms how many are stored. This outcome summarizes the cycle result rather than the retrieval procedure itself.",
          "what_to_expect": [
            "Total eggs retrieved and mature egg count",
            "Number of eggs frozen",
            "Any egg quality or lab notes from the report",
            "Storage details that can be connected to Cryo Vault"
          ],
          "prep_instructions": [
            "Upload the retrieval or embryology report if you have it",
            "Confirm mature egg and frozen egg counts",
            "Add storage location, vial IDs, or straw IDs when available"
          ],
          "when_to_call": [
            "The numbers do not match what the clinic told you",
            "You are missing the lab or storage report",
            "You have worsening pain, bloating, fever, or heavy bleeding after retrieval"
          ]
        },
        "fertilization_embryo": {
          "description": "Fertilization, embryo growth, and frozen embryo outcome",
          "how_it_works": "After retrieval, eggs are fertilized in the lab and followed through embryo development. This step captures the lab outcome: how many fertilized, how many reached a usable stage, which embryos were frozen, and what records should be attached.",
          "what_to_expect": [
            "Fertilization method and normally fertilized eggs",
            "Embryo development updates through day 5 or day 6",
            "Embryo grades and PGT status if testing was used",
            "Embryos frozen with freeze date and storage details"
          ],
          "prep_instructions": [
            "Upload the embryology or freezing report if you have it",
            "Confirm embryo grades, freeze dates, and specimen IDs",
            "Attach storage location details in Cryo Vault when available"
          ],
          "when_to_call": [
            "The embryo count or grade does not match your report",
            "PGT or biopsy status is unclear",
            "You are missing storage or freeze confirmation details"
          ]
        },
        "fertilization_icsi": {
          "description": "ICSI fertilization results from the lab",
          "how_it_works": "For ICSI, the embryology team injects a single sperm into each mature egg and checks the next day for normal fertilization. This step records the lab result, not the retrieval procedure.",
          "what_to_expect": [
            "Number of mature eggs injected",
            "Normally fertilized eggs, often called 2PN",
            "Lab notes about egg or sperm quality",
            "Next update timing for embryo development"
          ],
          "prep_instructions": [
            "Upload the fertilization or embryology report",
            "Confirm injected and normally fertilized counts",
            "Keep sperm source and lab notes attached to the cycle"
          ],
          "when_to_call": [
            "The fertilization count is missing or unclear",
            "The clinic mentions abnormal fertilization",
            "You need help interpreting the lab report"
          ]
        },
        "fertilization_ivf": {
          "description": "Fertilization results from the lab",
          "how_it_works": "After retrieval, mature eggs are combined with sperm and checked the next day for normal fertilization. This step records what happened in the lab before embryo development continues.",
          "what_to_expect": [
            "Number of eggs fertilized normally",
            "Fertilization method if IVF or ICSI was used",
            "Any lab notes about egg or sperm quality",
            "Next update timing for embryo development"
          ],
          "prep_instructions": [
            "Upload the fertilization or embryology report",
            "Confirm the normally fertilized count",
            "Keep sperm source and lab notes attached to the cycle"
          ],
          "when_to_call": [
            "The fertilization count is missing or unclear",
            "The clinic mentions abnormal fertilization",
            "You need help interpreting the lab report"
          ]
        },
        "embryo_development": {
          "description": "Embryo growth, grading, testing, and freeze decisions",
          "how_it_works": "After fertilization, embryos are monitored as they grow toward the blastocyst stage. This step captures the outcome of that lab window: embryo grades, testing decisions, transfer plans, and any embryos frozen.",
          "what_to_expect": [
            "Day 3 or day 5/6 development updates",
            "Blastocyst count and embryo grades",
            "PGT biopsy or test status if used",
            "Which embryos were transferred, frozen, or still pending"
          ],
          "prep_instructions": [
            "Upload the embryology, PGT, or freeze report",
            "Confirm embryo grades and development day",
            "Attach freeze and storage details for embryos kept on ice"
          ],
          "when_to_call": [
            "The blastocyst count or grades are unclear",
            "You are missing a PGT or embryo report",
            "Transfer or freezing decisions changed and need documenting"
          ]
        },
        "transfer_fet": {
          "description": "Frozen embryo transfer details and test plan",
          "how_it_works": "For an FET, a frozen embryo is thawed and transferred once the lining and progesterone timing are ready. This step captures the transfer details and the pregnancy test plan that follows.",
          "what_to_expect": [
            "Embryo thaw and transfer confirmation",
            "Embryo identity, grade, and PGT status if known",
            "Transfer date and progesterone timing",
            "Beta hCG test date after transfer"
          ],
          "prep_instructions": [
            "Confirm embryo thaw and transfer instructions",
            "Keep taking estrogen and progesterone as directed",
            "Upload the transfer note or embryo report if you have it"
          ],
          "when_to_call": [
            "You miss progesterone or take it at the wrong time",
            "You have heavy bleeding before or after transfer",
            "The embryo identity or transfer report is unclear"
          ]
        },
        "transfer_ivf": {
          "description": "Embryo transfer details and what happens next",
          "how_it_works": "If a transfer happens in this cycle, the clinic places the selected embryo into the uterus and sets the next pregnancy test date. This step connects the embryo selected, the transfer note, and the follow-up plan.",
          "what_to_expect": [
            "Embryo transferred and transfer date",
            "Embryo grade or PGT status if known",
            "Medication instructions after transfer",
            "Beta hCG test date after the waiting window"
          ],
          "prep_instructions": [
            "Upload the transfer note if you have it",
            "Confirm the embryo selected for transfer",
            "Save beta test timing and support medication instructions"
          ],
          "when_to_call": [
            "You miss a support medication dose",
            "You have heavy bleeding, severe pain, or fever",
            "Transfer details do not match the report"
          ]
        },
        "analysis": {
          "description": "Semen analysis results before freezing",
          "how_it_works": "The lab measures the sample's volume, sperm concentration, total count, motility, and morphology. These values help explain how much usable sample was available before freezing.",
          "what_to_expect": [
            "Concentration, total count, motility, morphology, and volume",
            "A report from the lab or clinic",
            "Notes about sample quality or preparation"
          ],
          "prep_instructions": [
            "Upload the semen analysis report if you have it",
            "Enter the key values from the report",
            "Keep the analysis linked to the freezing outcome"
          ],
          "when_to_call": [
            "A result is missing or hard to interpret",
            "The sample could not be frozen",
            "Your clinic recommends repeat testing"
          ]
        },
        "screening": {
          "description": "Required screening before storage",
          "how_it_works": "Many clinics require infectious disease screening, and sometimes genetic screening, before a sample can be stored or used later. This step keeps those results connected to the cycle.",
          "what_to_expect": [
            "STD or infectious disease panel results",
            "Possible genetic screening results",
            "Documents that may need to be shared with the storage lab"
          ],
          "prep_instructions": [
            "Upload screening reports when available",
            "Confirm whether any result needs follow-up",
            "Keep dates and documents attached to this cycle"
          ],
          "when_to_call": [
            "A required screening report is missing",
            "A result needs clarification",
            "Your clinic will not release the sample without more testing"
          ]
        },
        "insemination": {
          "description": "IUI procedure and timing",
          "how_it_works": "During IUI, a prepared sperm sample is placed directly into the uterus around ovulation. This step captures the procedure timing, notes, and any related details.",
          "what_to_expect": [
            "A brief in-office procedure",
            "Mild cramping or spotting can happen afterward",
            "Timing is usually coordinated with ovulation or trigger shot"
          ],
          "prep_instructions": [
            "Confirm procedure time and sperm sample logistics",
            "Follow clinic instructions around trigger timing",
            "Ask when to test or start luteal support"
          ],
          "when_to_call": [
            "You develop severe pain, fever, or heavy bleeding",
            "You are unsure about timing after trigger",
            "You miss or need to reschedule the appointment"
          ]
        },
        "protocol_fet": {
          "description": "Lining preparation before embryo transfer",
          "how_it_works": "For a frozen embryo transfer, medications are used to prepare the uterine lining. Estrogen usually helps build the lining, and progesterone is timed before transfer.",
          "what_to_expect": [
            "Estrogen pills, patches, or injections depending on protocol",
            "Lining checks by ultrasound",
            "Progesterone started before transfer",
            "Transfer timing based on lining readiness and embryo age"
          ],
          "prep_instructions": [
            "Confirm medication delivery and dosing schedule",
            "Track lining check appointments",
            "Save transfer and progesterone timing instructions"
          ],
          "when_to_call": [
            "You miss a dose or take it at the wrong time",
            "You have heavy bleeding before transfer",
            "You are unsure when to start progesterone"
          ]
        },
        "protocol_oi": {
          "description": "Ovulation induction medication and timing",
          "how_it_works": "Ovulation induction uses medication to support follicle growth and ovulation. Monitoring and trigger timing help define the best window for intercourse or insemination.",
          "what_to_expect": [
            "Oral or injectable medication depending on your plan",
            "Ultrasound or bloodwork monitoring if ordered",
            "Trigger shot or timed intercourse window"
          ],
          "prep_instructions": [
            "Track medication start and stop dates",
            "Save timing instructions from the clinic",
            "Confirm when to test or start support medication"
          ],
          "when_to_call": [
            "You miss a medication dose",
            "You have severe pain or heavy bleeding",
            "You are unsure about trigger or timing instructions"
          ]
        },
        "luteal_ivf": {
          "description": "Support medications after transfer",
          "how_it_works": "After transfer, support medications continue. This step keeps the medication instructions and your symptom notes connected to the cycle.",
          "what_to_expect": [
            "Progesterone or other support medication",
            "Symptoms that can overlap with medication effects"
          ],
          "prep_instructions": [
            "Keep taking support medication exactly as prescribed",
            "Log symptoms or bleeding in the calendar"
          ],
          "when_to_call": [
            "You miss progesterone or another support dose",
            "You have heavy bleeding, severe pain, or fever"
          ]
        },
        "luteal_iui": {
          "description": "Support after ovulation or insemination",
          "how_it_works": "After ovulation or insemination, your clinic may prescribe progesterone or other support. This step keeps those medications and your symptom notes together.",
          "what_to_expect": [
            "Possible progesterone or other support medication",
            "Symptoms that can overlap with medication side effects"
          ],
          "prep_instructions": [
            "Keep taking support medication exactly as prescribed",
            "Log symptoms or bleeding in the calendar"
          ],
          "when_to_call": [
            "You have heavy bleeding or severe pain",
            "You miss support medication"
          ]
        },
        "outcome_iui": {
          "description": "Waiting for your pregnancy test",
          "how_it_works": "After insemination or ovulation, you wait for the pregnancy test window your clinic set. Testing too early is the most common reason for a misleading result.",
          "what_to_expect": [
            "A defined pregnancy test date",
            "Mild cramping or spotting, which don't tell you the outcome either way",
            "Emotional ups and downs — this stretch is hard for most people"
          ],
          "prep_instructions": [
            "Confirm the date your clinic wants you to test",
            "Wait for that date rather than testing early",
            "Lean on your support system while you wait"
          ],
          "when_to_call": [
            "You get a positive test before your scheduled bloodwork",
            "You have heavy bleeding or severe pain",
            "You need help deciding what to do with a result"
          ]
        }
      }
    }
  },
  "add_medication": {
    "step_title_add": "Add medication",
    "step_title_edit": "Edit medication",
    "step_title_search": "Search medication",
    "step_title_configure": "Configure",
    "step_title_review": "Review",
    "trigger_step_title_add": "Add trigger shot",
    "trigger_step_title_search": "Search trigger medication",
    "trigger_step_title_configure": "Configure trigger shot",
    "trigger_step_title_review": "Review trigger timing",
    "entry_intro": "How would you like to add your medication?",
    "trigger_entry_intro": "Add the trigger shot exactly as prescribed. The dose time is critical because retrieval or insemination is scheduled from it.",
    "entry_search_by_name": "Search by name",
    "entry_search_by_name_help": "Type the medication name",
    "entry_scan_prescription": "Scan prescription",
    "entry_scan_prescription_help": "Upload a photo to auto-fill details",
    "entry_reading_prescription": "Reading prescription...",
    "scanned_document_name": "Prescription",
    "alert_ocr_no_meds_title": "No medications found",
    "alert_ocr_no_meds_message": "We couldn't pick up any medications from this image. Try a clearer photo or fill the form manually.",
    "alert_file_document_failed_title": "Couldn't save document",
    "alert_file_document_failed_message": "Your medication was saved, but we couldn't file the scanned document in your vault.",
    "ocr_queue_progress": "Medication ${current} of ${total}",
    "ocr_queue_help": "Validate this medication to add it, then we'll move to the next one.",
    "quick_add": "Quick add",
    "search_intro": "Search for your medication",
    "trigger_search_intro": "Search for the trigger medication your clinic prescribed.",
    "search_placeholder": "e.g., Gonal-F, Letrozole...",
    "trigger_search_placeholder": "e.g., Ovidrel, Pregnyl, Novarel, Lupron...",
    "search_loading": "Searching medications...",
    "search_no_match": "No match found — tap Next to enter details manually",
    "trigger_search_no_match": "No exact match — tap Next to use this trigger medication name",
    "next": "Next",
    "back": "Back",
    "medication_name": "Medication name",
    "is_trigger_shot": "This is a trigger shot",
    "trigger_context_title": "Trigger timing matters",
    "trigger_context_body": "Enter the exact date and time from your clinic. Retrieval or insemination is usually scheduled from this dose.",
    "dosage": "Dosage",
    "dosage_placeholder": "e.g., 150",
    "dosage_unit_default": "unit",
    "route": "Route",
    "delivery_method": "Delivery method",
    "start_date": "Start date",
    "duration": "Duration",
    "custom": "Custom",
    "custom_duration_placeholder": "e.g., 5",
    "duration_unit_days": "days",
    "duration_unit_weeks": "weeks",
    "duration_unit_months": "months",
    "time_of_day": "Time of day",
    "custom_time_placeholder": "HH:MM (e.g., 22:30)",
    "add": "Add",
    "as_needed": "As needed",
    "notes_optional": "Notes (optional)",
    "notes_placeholder": "Any additional notes...",
    "link_to_cycle": "Link to current cycle",
    "review": "Review",
    "review_intro": "Review your medication details",
    "trigger_review_intro": "Confirm the trigger medication, dose, and exact time before saving.",
    "edit_details": "Edit details",
    "save_add_different_dose": "Save & add different dose",
    "save_add_different_dose_help": "Same medication, different dose or dates",
    "submit_add": "Add medication",
    "submit_add_trigger": "Add trigger shot",
    "submit_edit": "Save changes",
    "inventory": {
      "step_title_add": "Add to inventory",
      "step_title_configure": "Stock details",
      "step_title_review": "Review stock",
      "stock_on_hand_label": "Stock on hand",
      "stock_on_hand_helper": "This tracks what you physically have. It does not create a dose schedule unless you add one below.",
      "toggle_add_schedule": "Add taking details",
      "toggle_hide_schedule": "Hide taking details",
      "toggle_schedule_helper": "Use this if the stock should also create a medication schedule.",
      "submit_add_only": "Add to inventory",
      "submit_add_with_schedule": "Add stock and schedule"
    },
    "submitting_add": "Adding...",
    "submitting_edit": "Saving...",
    "summary_role": "Role",
    "summary_role_trigger_shot": "Trigger shot",
    "summary_dosage": "Dosage",
    "summary_route": "Route",
    "summary_delivery_method": "Delivery method",
    "summary_start_date": "Start date",
    "summary_duration": "Duration",
    "summary_end_date": "End date",
    "summary_schedule": "Schedule",
    "summary_notes": "Notes",
    "summary_linked_to_cycle": "Linked to cycle",
    "summary_yes": "Yes",
    "alert_ocr_failed_title": "OCR Failed",
    "alert_ocr_failed_message": "Could not read the prescription. Please enter details manually.",
    "alert_permission_title": "Permission needed",
    "alert_permission_message": "Please allow access to your photo library to scan prescriptions.",
    "alert_update_failed_title": "Update Failed",
    "alert_update_failed_message": "Could not save changes.",
    "alert_trigger_phase_failed_title": "Trigger date not saved to cycle",
    "alert_trigger_phase_failed_message": "The medication was saved, but the trigger date couldn't be written to your cycle. You can set it from the cycle's trigger step.",
    "dose_error_invalid": "Enter the dose as a number, like 150 or 0.5.",
    "dose_error_not_positive": "The dose must be greater than zero.",
    "dose_error_too_large": "That dose looks too large — double-check the amount.",
    "historical_date_error_title": "Date outside cycle",
    "historical_date_error_message": "For a past cycle, the medication dates must stay within that cycle.",
    "time_preset": {
      "morning": "Morning",
      "afternoon": "Afternoon",
      "evening": "Evening",
      "night": "Night"
    },
    "dose_unit": {
      "units": "units",
      "pills": "pills",
      "tablets": "tablets",
      "capsules": "capsules",
      "drops": "drops",
      "patches": "patches"
    },
    "route_option": {
      "oral": "Oral",
      "subcutaneous": "Subcutaneous",
      "intramuscular": "Intramuscular",
      "vaginal": "Vaginal",
      "topical": "Topical",
      "patch": "Patch",
      "not_specified": "Not specified"
    },
    "delivery_method_option": {
      "pre_filled_syringe": "Pre-filled syringe",
      "pre_filled_pen": "Pen injector",
      "injection_solution": "Vial + syringe",
      "lyophilized_powder": "Powder + diluent",
      "multi_vial": "Multi vial"
    },
    "duration_preset": {
      "once": "Once",
      "7_days": "7 days",
      "10_days": "10 days",
      "14_days": "14 days",
      "3_weeks": "3 weeks",
      "1_month": "1 month",
      "3_months": "3 months",
      "ongoing": "Ongoing"
    }
  },
  "add_appointment": {
    "title_new": "New appointment",
    "title_details": "Details",
    "title_edit": "Edit appointment",
    "title_review": "Review",
    "go_back": "Go back",
    "close": "Close",
    "next": "Next",
    "type_intro": "What type of appointment?",
    "error_invalid_date": "Please pick a valid appointment date.",
    "error_invalid_time": "Please pick a time for the appointment.",
    "error_end_before_start": "The end time must be after the start time.",
    "error_invalid_title": "Give this appointment a title.",
    "entry_scan_letter": "Scan appointment letter",
    "entry_scan_letter_help": "Upload a photo to auto-fill the appointment",
    "entry_reading_letter": "Reading appointment letter...",
    "scanned_document_name": "Appointment letter",
    "alert_ocr_failed_title": "Couldn't read letter",
    "alert_ocr_failed_message": "We couldn't read the appointment letter. Try a clearer photo or fill the form manually.",
    "alert_permission_title": "Photo access needed",
    "alert_permission_message": "Allow photo access to scan an appointment letter.",
    "alert_file_document_failed_title": "Couldn't save document",
    "alert_file_document_failed_message": "Your appointment was saved, but we couldn't file the scanned document in your vault.",
    "no_results": "No matching results",
    "exam_label": "Exam",
    "procedure_label": "Procedure",
    "what_exam_placeholder": "What exam?",
    "what_procedure_placeholder": "What procedure?",
    "continue": "Continue",
    "title_label": "Title",
    "title_placeholder": "Appointment title",
    "activity_remove_accessibility": "Remove ${activity}",
    "date_label": "Date",
    "time_label": "Time",
    "time_placeholder": "HH:MM",
    "duration_label": "Duration",
    "duration_hint": "1 hr is selected by default. Change it if you need to.",
    "duration_minutes_value": "${count} min",
    "duration_hours_value": "${count} hr",
    "duration_custom": "Custom",
    "duration_default_badge": "Default",
    "duration_default_accessibility": "${value}, default duration",
    "duration_custom_accessibility": "Custom duration in minutes",
    "duration_custom_placeholder": "e.g. 120",
    "end_preview": "Ends: ${value}",
    "end_value_next_day": "${date} at ${time}",
    "error_invalid_duration": "Enter a duration in minutes greater than zero.",
    "location_label": "Location / Room",
    "location_placeholder": "e.g. Room 204, Building A",
    "format_label": "Format",
    "format_in_person": "In-person",
    "format_online": "Online",
    "meeting_link_label": "Meeting Link",
    "meeting_link_placeholder": "https://...",
    "notes_optional": "Notes (optional)",
    "notes_placeholder": "Any additional notes...",
    "review_button": "Review",
    "review_intro": "Review your appointment",
    "review_hint": "Confirm the details below",
    "summary_title": "Title",
    "summary_type": "Type",
    "summary_date": "Date",
    "summary_time": "Time",
    "summary_duration": "Duration",
    "summary_ends": "Ends",
    "summary_location": "Location",
    "summary_format": "Format",
    "summary_meeting_link": "Meeting Link",
    "summary_notes": "Notes",
    "submit_add": "Save",
    "submit_edit": "Save changes",
    "submitting_add": "Saving...",
    "submitting_edit": "Saving...",
    "error_save_failed": "Failed to save appointment",
    "type": {
      "exam": "Exam",
      "procedure": "Procedure",
      "consult": "Consult",
      "counseling": "Counseling"
    },
    "activity_section": {
      "common": "Common activities"
    },
    "activity": {
      "item": {
        "consultation": "Consultation",
        "blood_tests": "Blood tests",
        "ultrasound": "Ultrasound",
        "counseling": "Counseling"
      }
    },
    "exam_section": {
      "blood_lab": "Blood & Lab",
      "imaging": "Imaging",
      "genetic": "Genetic",
      "item": {
        "beta_hcg": "Beta hCG",
        "hormonal_testing": "Hormonal testing",
        "std_testing": "STD testing",
        "thyroid_testing": "Thyroid testing",
        "urinalysis": "Urinalysis",
        "semen_analysis": "Semen analysis",
        "swab_test": "Swab test",
        "pap_smear": "Pap smear",
        "transabdominal_ultrasound": "Transabdominal ultrasound",
        "transvaginal_ultrasound": "Transvaginal ultrasound",
        "doppler_ultrasound": "Doppler ultrasound",
        "hysterosonography": "Hysterosonography",
        "hsg": "HSG (Hysterosalpingogram)",
        "antral_follicle_count": "Antral follicle count",
        "pelvic_mri": "Pelvic MRI",
        "karyotyping": "Karyotyping",
        "carrier_testing": "Carrier testing",
        "exome_sequencing": "Exome or genome sequencing"
      }
    },
    "procedure_section": {
      "retrieval": "Retrieval",
      "transfer": "Transfer",
      "surgical": "Surgical",
      "item": {
        "egg_retrieval": "Egg retrieval",
        "sperm_collection": "Sperm collection",
        "surgical_sperm_retrieval": "Surgical sperm retrieval",
        "embryo_transfer": "Embryo transfer",
        "laparoscopy": "Laparoscopy",
        "hysteroscopy": "Hysteroscopy",
        "endometrial_biopsy": "Endometrial biopsy",
        "testicular_biopsy": "Testicular biopsy"
      }
    }
  },
  "procedure_detail": {
    "your_appointment": "Your Appointment",
    "section_how_it_works": "How it works",
    "section_part_of": "Part of",
    "section_how_to_prepare": "How to prepare",
    "section_what_to_expect": "What to expect",
    "section_results": "Results",
    "section_pain_and_comfort": "Pain and comfort",
    "section_sample_purpose": "What this sample is for",
    "section_tests_using_sample": "Tests using this sample",
    "tests_using_sample_description": "The biopsy collects the sample; these canonical test categories describe what that sample can be used for.",
    "section_risks": "Risks",
    "section_evidence": "Evidence",
    "sample_endometrial_tissue": "Endometrial tissue",
    "anesthesia_none": "None",
    "recovery_label": "Recovery",
    "tab_procedure": "Procedure",
    "tab_procedure_short": "Steps",
    "recovery_prefix": "Recovery: ${value}",
    "delete_confirm": "Delete this appointment?",
    "confirm": "Confirm",
    "disclaimer": "Procedures may vary based on your clinic's protocols. Always follow your care team's specific guidance."
  },
  "appointment_note": {
    "title": "Add a note?",
    "body": "Anything to remember about this appointment?",
    "placeholder": "e.g. Doctor said follicles look good…",
    "save": "Save",
    "skip": "Skip",
    "cancel": "Cancel"
  },
  "appointment_detail": {
    "row_date": "Date",
    "row_time": "Time",
    "row_duration": "Duration",
    "row_ends": "Ends",
    "row_location": "Location",
    "row_format": "Format",
    "row_notes": "Notes",
    "appointment_notes": "Appointment notes",
    "completion_title": "Notes after the visit",
    "documents_title": "Documents",
    "documents_upload": "Upload a document",
    "completion_edit": "Edit notes",
    "completion_save": "Save",
    "completion_cancel": "Cancel",
    "completion_input_label": "Your notes after the visit",
    "completion_save_error": "We couldn’t save your notes. Try again.",
    "completion_loading": "Loading your notes after the visit…",
    "completion_unavailable": "Your notes after the visit are temporarily unavailable.",
    "edit": "Edit",
    "delete": "Delete",
    "cancel": "Cancel",
    "confirm_delete": "Delete appointment",
    "deleting": "Deleting…",
    "delete_title": "Delete this appointment?",
    "delete_confirm": "Are you sure you want to delete “${title}”? This action is permanent and can’t be undone.",
    "delete_error": "We couldn’t delete this appointment. It’s still here—try again.",
    "delete_retry": "Try again",
    "learn_more": "Learn more about this appointment",
    "learn_about_activity": "Learn about ${activity}"
  },
  "medication_log": {
    "status_taken": "Taken",
    "status_late": "Late",
    "status_missed": "Missed"
  },
  "medication_factsheet": {
    "missing_med_id": "Missing medication ID — cannot stop from this view.",
    "stop_med_error": "Failed to stop medication",
    "delete_med_error": "Failed to delete medication",
    "partner_both": "Both partners",
    "partner_her": "Her",
    "partner_him": "Him",
    "section_purpose": "Purpose",
    "section_how_to_take": "How to take",
    "section_good_to_know": "Good to know",
    "badge_keep_refrigerated": "Keep refrigerated",
    "section_side_effects": "Side effects",
    "side_effects_log_hint": "Tap a symptom for details. Use + to log it for today.",
    "symptom_detail_severity": "Severity",
    "symptom_detail_normal": "What can be normal",
    "symptom_detail_dangerous": "When it can be dangerous",
    "symptom_detail_call_doctor": "When to call your doctor",
    "symptom_detail_notes_label": "Add details for today's log",
    "symptom_detail_notes_placeholder": "When did it happen? How often? How severe? What helped?",
    "symptom_detail_log_button": "I'm experiencing or have experienced this",
    "symptom_detail_update_log": "Update today's symptom log",
    "section_interacts_with": "Interacts with",
    "section_injection_technique": "Injection technique",
    "section_subcutaneous": "Subcutaneous injection",
    "section_intramuscular": "Intramuscular injection",
    "subq_step_1": "Wash hands thoroughly. Clean the injection site with an alcohol swab.",
    "subq_step_2": "Pinch a fold of skin on your lower abdomen (2 inches from the navel). Alternate sides each day.",
    "subq_step_3": "Insert the needle at a 45-90° angle in one smooth motion.",
    "subq_step_4": "Inject the medication slowly and steadily.",
    "subq_step_5": "Release the skin fold and withdraw the needle. Apply gentle pressure — do not rub.",
    "subq_step_6": "Rotate injection sites to reduce bruising and discomfort.",
    "im_body": "Intramuscular injections go into the upper outer quadrant of the buttock. Many patients have a partner or friend help with these. Your clinic can demonstrate the technique at your first monitoring visit.",
    "guide_title": "Injection Guide",
    "guide_intro": "Step-by-step instructions for each injection type in your protocol.",
    "guide_steps_heading": "Steps",
    "guide_tips_heading": "Tips",
    "guide_subq_title": "Subcutaneous (belly)",
    "guide_subq_subtitle": "Gonal-F, Menopur, Cetrotide, Ovidrel",
    "guide_subq_step_1": "Wash hands thoroughly with soap and water.",
    "guide_subq_step_2": "Clean injection site with alcohol swab: 2 inches around the belly button, alternating sides.",
    "guide_subq_step_3": "Pinch a fold of skin between thumb and finger.",
    "guide_subq_step_4": "Insert needle at 90° angle (or 45° if very thin).",
    "guide_subq_step_5": "Push plunger slowly and steadily.",
    "guide_subq_step_6": "Remove needle, release skin, apply light pressure.",
    "guide_subq_tip_1": "Ice the area for 1–2 minutes before to reduce sting.",
    "guide_subq_tip_2": "Rotate injection sites to prevent bruising.",
    "guide_subq_tip_3": "Let refrigerated medication warm 5–10 min before injecting.",
    "guide_subq_tip_4": "Do not rub the injection site afterward.",
    "guide_im_title": "Intramuscular (thigh/buttock)",
    "guide_im_subtitle": "Progesterone in oil, some trigger shots",
    "guide_im_step_1": "Wash hands thoroughly.",
    "guide_im_step_2": "Clean upper outer quadrant of buttock or outer thigh with alcohol swab.",
    "guide_im_step_3": "Spread the skin taut (do not pinch).",
    "guide_im_step_4": "Insert needle at 90° angle with a quick, dart-like motion.",
    "guide_im_step_5": "Aspirate briefly: if blood appears, withdraw and retry in a new spot.",
    "guide_im_step_6": "Inject slowly over 5–10 seconds.",
    "guide_im_step_7": "Withdraw needle, apply pressure with gauze.",
    "guide_im_tip_1": "Warm the vial in your hands or under warm water for 2 minutes.",
    "guide_im_tip_2": "Use the largest comfortable needle for injection (drawing needle is usually larger).",
    "guide_im_tip_3": "Massage the area gently afterward to help absorption.",
    "guide_im_tip_4": "A warm compress after can ease soreness.",
    "injection_tips_heading": "Tips to reduce pain and bruising",
    "injection_tip_im_help": "Many people have a partner or nurse help with intramuscular shots. Ask your clinic to demonstrate at your first visit.",
    "section_storage": "Storage",
    "section_available_as": "Available as",
    "section_videos": "How-to videos",
    "interaction_taking": "Taking",
    "interaction_severity_note": "Note",
    "interaction_severity_caution": "Caution",
    "interaction_severity_critical": "Critical",
    "section_official_resources": "Official resources",
    "official_resource_ansm_label": "Official ANSM/BDPM page — ${brand}",
    "section_evidence": "Evidence",
    "section_your_history": "Your history",
    "section_prescription": "Prescription",
    "section_actions": "Actions",
    "stopped_badge": "Stopped",
    "you_are_taking": "You're taking this",
    "you_have_taken": "You've taken this before",
    "you_stopped_taking": "You stopped taking this",
    "context_status_current": "Taking",
    "context_status_previous": "Taken before",
    "context_status_stopped": "Stopped",
    "context_since": "Since ${date}",
    "context_ends_on": "Ends ${date}",
    "context_ended_on": "Ended ${date}",
    "context_stopped_on": "Stopped ${date}",
    "stopped_banner_title": "Stopped medication",
    "stopped_banner_since": "Stopped since ${date}",
    "stopped_banner_reason": "Stop reason: ${reason}",
    "context_show_details": "Show details",
    "context_hide_details": "Hide details",
    "context_edit_medication": "Edit medication",
    "your_medication_fallback": "Your medication",
    "row_your_medication": "Medication",
    "row_dosage": "Dosage",
    "row_route": "Route",
    "row_delivery_method": "Delivery method",
    "row_schedule": "Schedule",
    "row_start_date": "Start date",
    "row_end_date": "End date",
    "row_duration": "Duration",
    "row_type": "Type",
    "row_since": "Since",
    "row_notes": "Notes",
    "row_doses_logged": "Doses logged",
    "row_prescriber": "Prescriber",
    "row_pharmacy": "Pharmacy",
    "row_rx_number": "Rx number",
    "row_quantity": "Quantity",
    "row_prescribed": "Prescribed",
    "row_refills_remaining": "Refills remaining",
    "refills_none": "None — contact clinic",
    "action_edit": "Edit",
    "action_edit_help": "Change dosage, schedule, or notes",
    "action_log_dose": "Log today's dose",
    "action_log_dose_help": "Record taken on time, late, missed, or skipped",
    "action_refill": "Request refill",
    "action_refill_help": "Send to ${pharmacy}",
    "provider_owned_title": "Managed by your care team",
    "provider_owned_note": "This medication is part of your prescribed plan. Ask your clinic about any change — you can still log your doses.",
    "action_stop": "Stop medication",
    "action_stop_help": "Record why and mark as stopped",
    "action_delete": "Delete medication",
    "action_delete_help": "Remove permanently",
    "delete_mistake_action": "I created this medication by mistake",
    "stop_form_title": "Why are you stopping?",
    "stop_form_help": "This marks ${name} as stopped today. The reason is saved with the medication notes.",
    "stop_form_placeholder": "e.g. side effects, doctor's advice, course completed",
    "stop_form_cancel": "Cancel",
    "stop_form_submit": "Stop medication",
    "stop_form_submitting": "Stopping…",
    "delete_modal_title": "Delete ${name}?",
    "delete_modal_message": "This permanently removes the medication and its history. This cannot be undone.",
    "delete_modal_cancel": "Cancel",
    "delete_modal_confirm": "Delete",
    "delete_modal_deleting": "Deleting…",
    "minimal_no_details": "No additional details saved for this medication.",
    "minimal_no_factsheet": "Detailed factsheet coming soon. You can still edit or stop this medication below.",
    "minimal_stop_title": "Stop this medication?",
    "minimal_stop_help": "It will be marked as stopped today. You can always add it back later.",
    "minimal_stop_placeholder": "Why are you stopping? (optional)",
    "minimal_delete_title": "Delete ${name}?",
    "minimal_delete_help": "This will remove the medication from your schedule. This can't be undone.",
    "disclaimer": "Always follow your clinic's specific instructions. This is general reference information only.",
    "schedule_as_needed": "As needed",
    "schedule_morning": "Morning",
    "schedule_afternoon": "Afternoon",
    "schedule_evening": "Evening",
    "schedule_night": "Night",
    "schedule_daily_template": "${count}× daily — ${labels}",
    "duration_ongoing": "Ongoing",
    "duration_1_day": "1 day",
    "duration_n_days": "${n} days",
    "duration_1_week": "1 week",
    "duration_n_weeks": "${n} weeks",
    "duration_1_month": "1 month",
    "duration_n_months": "${n} months",
    "route_subcutaneous": "Subcutaneous",
    "route_intramuscular": "Intramuscular",
    "route_oral": "Oral",
    "route_vaginal": "Vaginal",
    "route_topical": "Topical",
    "route_nasal": "Nasal",
    "route_sublingual": "Sublingual",
    "route_transdermal": "Transdermal",
    "route_rectal": "Rectal",
    "route_intravenous": "Intravenous",
    "molecule_androgen_supplement": "Androgen Supplement",
    "molecule_antithyroid_agent": "Antithyroid Agent",
    "molecule_biguanide": "Biguanide",
    "molecule_clomiphene_citrate": "Clomiphene Citrate",
    "molecule_corticosteroid": "Corticosteroid",
    "molecule_dopamine_agonist": "Dopamine Agonist",
    "molecule_estrogen": "Estrogen",
    "molecule_gnrh_agonist": "GnRH Agonist",
    "molecule_gnrh_antagonist": "GnRH Antagonist",
    "molecule_gonadotropin": "Gonadotropin",
    "molecule_hcg": "hCG",
    "molecule_letrozole": "Letrozole",
    "molecule_macrolide_antibiotic": "Macrolide Antibiotic",
    "molecule_nsaid": "NSAID",
    "molecule_progestogen": "Progestogen",
    "molecule_tamoxifen": "Tamoxifen",
    "molecule_tetracycline_antibiotic": "Tetracycline Antibiotic",
    "molecule_thyroid_hormone": "Thyroid Hormone",
    "molecule_folate_supplement": "Folate Supplement",
    "molecule_unknown": "Unknown",
    "delivery_pre_filled_syringe": "Pre-filled syringe",
    "delivery_pre_filled_pen": "Pen injector",
    "delivery_injection_solution": "Vial + syringe",
    "delivery_lyophilized_powder": "Powder + diluent",
    "delivery_multi_vial": "Multi vial"
  },
  "date_picker": {
    "placeholder": "Date",
    "today": "Today"
  },
  "time_picker": {
    "placeholder": "Select time",
    "header": "Enter time",
    "input_placeholder_en": "e.g. 9:30 AM",
    "input_placeholder_fr": "ex. 09:30",
    "now": "NOW",
    "invalid_format_en": "Invalid time format. Try \"9:30 AM\" or \"2:15 PM\"",
    "invalid_format_fr": "Format invalide. Utilisez \"09:30\" ou \"14:15\""
  },
  "journey": {
    "pregnancy_exploring": {
      "description": "You have not chosen a treatment path yet. We will keep your options open while you learn and decide with your care team.",
      "learn_title": "Explore your options",
      "learn_subtitle": "Choose a treatment path with your care team"
    },
    "ivf_with_partner": {
      "description": "In vitro fertilization with your partner",
      "learn_title": "How IVF Works",
      "learn_subtitle": "The most effective fertility treatment",
      "test_title": "Baseline Testing for Both of You",
      "test_subtitle": "Comprehensive fertility workup",
      "clinic_title": "Find Your Clinic",
      "clinic_subtitle": "Success rates matter most for IVF",
      "prep_title": "Get Ready for Your Cycle",
      "prep_subtitle": "Pre-cycle paperwork and decisions",
      "treatment_title": "Your IVF Cycle",
      "treatment_subtitle": "Active treatment with daily guidance",
      "wait_title": "The Two-Week Wait",
      "wait_subtitle": "Between transfer and pregnancy test"
    },
    "ivf_with_partner_male": {
      "description": "In vitro fertilization with your partner",
      "learn_title": "How IVF Works",
      "learn_subtitle": "The most effective fertility treatment",
      "test_title": "Baseline Testing for Both of You",
      "test_subtitle": "Comprehensive fertility workup",
      "clinic_title": "Find Your Clinic",
      "clinic_subtitle": "Success rates matter most for IVF",
      "prep_title": "Get Ready for Your Cycle",
      "prep_subtitle": "Pre-cycle paperwork and decisions",
      "treatment_title": "Your IVF Cycle",
      "treatment_subtitle": "Active treatment with daily guidance",
      "wait_title": "The Two-Week Wait",
      "wait_subtitle": "Between transfer and pregnancy test"
    }
  },
  "chips": {
    "primary_intent": {
      "preserve": "Preservation",
      "grow": "Conception",
      "donate": "Donation",
      "learn": "Exploring"
    },
    "treatment_intent": {
      "exploring": "Exploring",
      "preserve": "Egg freezing",
      "sperm_preserve": "Sperm freezing",
      "embryo_preserve": "Embryo freezing",
      "pregnancy": "Trying to conceive",
      "egg_donation": "Egg donation",
      "sperm_donation": "Sperm donation",
      "adoption": "Adoption",
      "surrogacy": "Surrogacy",
      "trying_naturally": "Trying naturally",
      "starting_treatment": "Starting treatment",
      "in_treatment": "In treatment",
      "donation": "Donation"
    },
    "condition": {
      "pcos": "PMOS (ex PCOS)",
      "endo": "Endometriosis",
      "thyroid": "Thyroid",
      "irregular": "Irregular cycles",
      "loss": "Pregnancy loss",
      "cancer": "Cancer history",
      "none": "No conditions",
      "unsure": "Not sure"
    },
    "partner": {
      "with_partner": "With partner",
      "using_donor": "Using donor",
      "solo": "Solo",
      "unsure": "Not sure yet"
    },
    "timeline": {
      "asap": "ASAP",
      "three_months": "3 months",
      "six_months": "6 months",
      "exploring": "Exploring timing"
    },
    "ethnicities_count": "${count} ethnicities",
    "conditions_count": "${count} conditions",
    "no_coverage": "No coverage"
  },
  "documents": {
    "filter": {
      "all": "All",
      "current_cycle": "Current cycle",
      "uploaded_by_you": "Uploaded by you",
      "action_needed": "Action needed",
      "cycle_documents_fallback": "Cycle documents",
      "medical_records": "Medical records"
    },
    "preview": {
      "side_front": "Front",
      "side_back": "Back",
      "attachment_fallback": "Attachment",
      "open": "Open"
    },
    "no_date": "No date",
    "cycle_type": {
      "ivf": "IVF",
      "fet": "FET",
      "iui": "IUI",
      "egg_freezing": "Egg freezing",
      "embryo_freezing": "Embryo freezing",
      "sperm_freezing": "Sperm freezing"
    },
    "clinical_value": {
      "reference_range": "Reference range: ${range}",
      "purpose": {
        "amh": "Reflects the size of your remaining egg supply",
        "fsh": "How hard your body works to mature an egg",
        "e2": "Shows how estrogen is rising during follicle growth",
        "afc": "Counts the follicles visible at baseline ultrasound",
        "tsh": "How your thyroid is keeping pace with fertility hormones"
      }
    },
    "imaging_notes": {
      "type_line": "Type: ${value}",
      "findings_line": "Findings: ${value}",
      "afc_line": "AFC: ${value}",
      "endo_thickness_line": "Endo Thickness: ${value}mm"
    },
    "genetic_notes": {
      "test_type_line": "Test Type: ${value}",
      "summary_line": "Summary: ${value}"
    },
    "semen_result": {
      "volume": "Volume",
      "concentration": "Concentration",
      "motility": "Motility",
      "morphology": "Morphology"
    },
    "semen_analysis_status": {
      "normal": "Normal",
      "borderline": "Borderline",
      "abnormal": "Abnormal",
      "unknown": "Unknown",
      "unassessed": "Not assessed"
    },
    "title": "Documents",
    "back": "Back",
    "search_placeholder": "Search documents...",
    "date_unknown": "Date unknown",
    "more_count": "+${count} more",
    "category": {
      "medical_records": {
        "label": "Medical Records",
        "short_label": "Medical",
        "description": "Labs, imaging, reports, and treatment plans",
        "example_1": "Lab results",
        "example_2": "Ultrasound reports",
        "example_3": "Treatment plans"
      },
      "coverage_benefits": {
        "label": "Insurance & Coverage",
        "short_label": "Insurance",
        "description": "Insurance proof, benefits, authorizations, and EOBs",
        "example_1": "Insurance card",
        "example_2": "Pre-auth letters",
        "example_3": "EOB statements"
      },
      "legal_consent": {
        "label": "Forms & Agreements",
        "short_label": "Forms",
        "description": "Consent forms, agreements, and signed clinic paperwork",
        "example_1": "Consent forms",
        "example_2": "Legal agreements",
        "example_3": "Donor contracts"
      },
      "admin": {
        "label": "Bills & Payments",
        "short_label": "Bills",
        "description": "Quotes, invoices, receipts, and payment records",
        "example_1": "Clinic invoices",
        "example_2": "Pharmacy receipts",
        "example_3": "Payment records"
      },
      "uncategorized": {
        "label": "Uncategorized",
        "short_label": "Uncategorized",
        "description": "Documents that need a category",
        "example_1": "Older uploads",
        "example_2": "Imported files",
        "example_3": "Unsorted documents"
      }
    },
    "doc_type": {
      "header": "Document type",
      "choose": "Choose document type",
      "lab": "Lab",
      "imaging": "Imaging",
      "treatment_plan": "Prescription",
      "appointment_letter": "Appointment",
      "genetic": "Genetic",
      "other": "Other"
    },
    "status": {
      "on_file": "On file",
      "requested": "Requested",
      "missing": "Missing"
    },
    "empty": {
      "no_documents": "No documents yet",
      "add_records": "Add records like ${examples}",
      "add_any_documents": "Add medical records, insurance documents, bills, forms, or any other document you want to keep here.",
      "upload_first": "Upload your first document",
      "upload_anything_title": "Upload anything",
      "upload_anything_body": "Drop PDFs, images, batches, or a full record. Louise sorts them automatically and pulls out results, medications, appointments, bills, and forms for review.",
      "upload_anything_note": "Large files or full record packets may take longer. You can review extracted details before saving them.",
      "chip_full_records": "Full records",
      "chip_lab_results": "Lab results",
      "chip_ultrasounds": "Ultrasounds",
      "chip_prescriptions": "Prescriptions",
      "chip_appointments": "Appointments",
      "chip_genetics": "Genetics",
      "chip_quotes": "Quotes",
      "chip_receipts": "Receipts",
      "chip_referrals": "Referrals",
      "no_matches": "No documents match those filters",
      "adjust_filters": "Try clearing search or changing filters.",
      "clear_filters": "Clear filters"
    },
    "processing_review": {
      "summary_title": "Quick summary",
      "summary_subtitle": "The important details are shown here. The original file and full extraction stay saved with it.",
      "summary_key_details": "Key details",
      "summary_medication_plan": "Medication plan",
      "summary_appointment": "Appointment",
      "summary_key_results": "Key results",
      "summary_unknown_medication": "Medication",
      "summary_unknown_appointment": "Appointment",
      "summary_unknown_result": "Result",
      "summary_no_action": "The document is saved. There is nothing else you need to review here.",
      "summary_incomplete": "Some details may be missing because the file could not be fully read.",
      "anomaly_count": "${count} value(s) need attention",
      "loading_meaning": "Loading extracted information…",
      "meaning_not_ready": "The file is saved. Extracted information is still being prepared.",
      "meaning_unavailable": "Extracted information is temporarily unavailable.",
      "document_fallback_title": "Document",
      "mark_as_reviewed": "Mark as reviewed",
      "processed_automatically": "This document was processed and saved automatically."
    },
    "processing_toast": {
      "documents_saved_one": "Your document was saved.",
      "documents_saved_many": "Your documents were saved.",
      "medications_added_one": "Added a medication to your care plan.",
      "medications_added_many": "Added ${count} medications to your care plan.",
      "appointments_added_one": "Added an appointment.",
      "appointments_added_many": "Added ${count} appointments.",
      "results_added_one": "Added a test result.",
      "results_added_many": "Added ${count} test results."
    },
    "slot": {
      "amh": {
        "name": "AMH blood test",
        "why": "Measures your egg reserve — the single most important number for planning"
      },
      "day3_panel": {
        "name": "Day 3 hormone panel (FSH, LH, E2)",
        "why": "Baseline hormones your RE needs before choosing a protocol"
      },
      "afc_ultrasound": {
        "name": "Antral follicle count (AFC) ultrasound",
        "why": "Shows how many follicles are available this cycle"
      },
      "hsg_saline": {
        "name": "HSG or saline sonogram",
        "why": "Confirms your uterus and tubes are clear for transfer"
      },
      "carrier_screening": {
        "name": "Carrier screening results",
        "why": "Identifies genetic conditions you could pass to a child"
      },
      "pgt_results": {
        "name": "PGT-A / PGT-M results",
        "why": "Chromosomal status of your embryos after testing"
      },
      "semen_analysis": {
        "name": "Semen analysis",
        "why": "Evaluates sperm count, motility, and morphology"
      },
      "thyroid_panel": {
        "name": "Thyroid panel (TSH, T3, T4)",
        "why": "Thyroid issues directly affect implantation and pregnancy"
      },
      "pcos_labs": {
        "name": "PMOS (ex PCOS) lab panel (insulin, testosterone, DHEA-S)",
        "why": "Tracks the hormones driving your PMOS (ex PCOS) symptoms"
      },
      "endo_imaging": {
        "name": "Endometriosis imaging or surgical notes",
        "why": "Documents the extent and location of endometrial tissue"
      },
      "genetic_counseling": {
        "name": "Genetic counseling summary",
        "why": "Recommended when carrier screening flags a variant"
      },
      "treatment_plan": {
        "name": "Treatment plan / protocol",
        "why": "Your RE's roadmap: medications, doses, timing, and monitoring schedule"
      },
      "insurance_card": {
        "name": "Insurance card (front & back)",
        "why": "Every provider visit starts here"
      },
      "benefits_summary": {
        "name": "Fertility benefits summary",
        "why": "Details your coverage limits, lifetime max, and excluded services"
      },
      "pre_auth": {
        "name": "Pre-authorization letter",
        "why": "Required before most IVF procedures — without it, you pay full price"
      },
      "eob": {
        "name": "Explanation of Benefits (EOB)",
        "why": "Shows what insurance actually paid vs. what you owe"
      },
      "appeal_letter": {
        "name": "Denial appeal documentation",
        "why": "If a claim is denied, this is your path to getting it reversed"
      },
      "consent_forms": {
        "name": "Treatment consent forms",
        "why": "Legal authorization for your procedure — clinics require these signed"
      },
      "referral_letter": {
        "name": "Referral letter",
        "why": "Some insurers require a referral from your OB/GYN to an RE"
      },
      "donor_agreement": {
        "name": "Donor agreement",
        "why": "Legal contract defining parental rights and donor obligations"
      },
      "partner_consent": {
        "name": "Partner consent forms",
        "why": "Both partners must sign for embryo creation and storage"
      },
      "storage_agreement": {
        "name": "Cryostorage agreement",
        "why": "Specifies storage duration, annual fees, and disposition instructions"
      },
      "disposition_directive": {
        "name": "Disposition directive",
        "why": "What happens to your eggs or embryos if you can't make decisions"
      },
      "clinic_invoices": {
        "name": "Clinic invoices",
        "why": "Track total spend — fertility treatments are often tax-deductible"
      },
      "pharmacy_receipts": {
        "name": "Pharmacy / medication receipts",
        "why": "Medications can be $3,000–$7,000 per cycle — keep every receipt"
      },
      "storage_invoices": {
        "name": "Storage fee invoices",
        "why": "Annual fees for egg or embryo storage are an ongoing cost"
      },
      "lab_bills": {
        "name": "Lab / testing bills",
        "why": "Genetic testing and bloodwork bills for FSA/HSA reimbursement"
      },
      "travel_receipts": {
        "name": "Travel receipts",
        "why": "Travel for fertility care may be tax-deductible or employer-reimbursable"
      },
      "treatment_plan_fallback_name": "Treatment plan"
    },
    "upload": {
      "header_title": "Upload a document",
      "header_subtitle": "We'll read it automatically and extract the key info",
      "choose_file": "Drag and drop or choose files",
      "file_hint": "PDFs, images, batches, or full record packets",
      "uploading_document_title": "Uploading your document",
      "uploading_document_subtitle": "We will read it automatically after the secure upload finishes.",
      "reading_document_title": "Reading your document",
      "reading_document_subtitle": "The upload is complete. Louise is looking for information you can review.",
      "add_more_files": "Add more files",
      "secure_upload": "Secure upload",
      "upload_complete_reading": "Upload complete · Reading now",
      "queued_file_added": "Queued · Added just now",
      "processing_uploading": "Uploading…",
      "processing_reading": "Reading…",
      "processing_next_up": "Next up",
      "reading": "Reading your document",
      "reading_subtitle": "Extracting key information from your document. This may take a moment.",
      "source_uploading": "Uploading…",
      "source_filing": "Saving the file…",
      "source_saved": "File saved",
      "retry_source": "Retry upload",
      "monitoring_reading": "Parsing monitoring values",
      "monitoring_reading_subtitle": "Looking for follicle measurements, endometrial lining, and bloodwork values.",
      "review_title": "Review extracted data",
      "review_subtitle": "Verify the information below and make any corrections before saving",
      "back": "Back",
      "save": "Save to my records",
      "retry_care_rows": "Retry Care rows",
      "saving": "Saving...",
      "saved": "Saved successfully",
      "results_added_count": "${count} results added to your records",
      "medications_detected_count": "${count} medications detected",
      "more_documents_pending_count": "${count} more document(s) ready to review",
      "review_next_document": "Review next document",
      "queued_documents_title": "More documents selected",
      "queued_documents_subtitle": "We’ll review each file separately so the extracted results stay accurate.",
      "queued_documents_more": "+${count} more",
      "monitoring_parsed_title": "Monitoring values parsed",
      "monitoring_parsed_subtitle": "We found values that can fill your monitoring entry. Continue to review them in the form before saving.",
      "monitoring_parsed_count": "${count} monitoring value(s) ready to review",
      "monitoring_parsed_action": "Continue to monitoring",
      "monitoring_parsed_empty_title": "Document parsed",
      "monitoring_parsed_empty_subtitle": "No monitoring values were found, but we’ll still save this document to your records.",
      "error_failed_process": "Failed to process document. Please try again.",
      "error_failed_save": "Failed to save. Please try again.",
      "failure": {
        "unsupported_type": {
          "title": "This file type is not supported",
          "description": "Choose a PDF, image, or document file instead."
        },
        "file_too_large": {
          "title": "This file is too large",
          "description": "Try a smaller file or split the record into a few parts."
        },
        "batch_too_many_files": {
          "title": "Too many files selected",
          "description": "Try a smaller group of files so Louise can keep each upload clear."
        },
        "batch_too_large": {
          "title": "This group of files is too large",
          "description": "Try uploading this record in a few smaller groups."
        },
        "empty_file": {
          "title": "This file is empty",
          "description": "Choose a file that contains information to upload."
        },
        "corrupt_file": {
          "title": "This file could not be opened",
          "description": "The file may be incomplete or damaged. Choose another copy."
        },
        "password_protected": {
          "title": "This file is password protected",
          "description": "Remove the password and upload the file again."
        },
        "duplicate": {
          "title": "This file is already on file",
          "description": "This file is already saved in Documents. Use the saved version or choose another file."
        },
        "network_stalled": {
          "title": "Upload paused",
          "description": "The connection stalled before this file finished. Retry from the last safe upload step."
        },
        "upload_failed": {
          "title": "Upload could not finish",
          "description": "The original upload was not completed. Retry from the last safe upload step."
        },
        "extraction_failed": {
          "title": "Louise could not read this file",
          "description": "The original file is still saved. Retry reading it without uploading it again."
        },
        "persistence_failed": {
          "title": "The extracted information was not saved",
          "description": "The file is still available. Retry saving it without uploading it again."
        },
        "canceled": {
          "title": "Upload canceled",
          "description": "This upload was canceled before it was saved."
        },
        "status": {
          "not_uploaded": "Not uploaded",
          "not_saved": "Upload incomplete · Not saved",
          "saved_not_read": "Uploaded and saved · Could not read",
          "extracted_not_saved": "Uploaded · Extracted information not saved",
          "already_saved": "Already saved",
          "canceled": "Canceled · Not saved"
        },
        "checkpoint": {
          "validation": "File check",
          "upload": "Upload",
          "processing": "Reading",
          "saving": "Saving"
        },
        "choose_another": "Choose another file",
        "use_saved_file": "Use saved file",
        "retry_upload": "Retry upload",
        "retry_reading": "Retry reading",
        "retry_saving": "Retry saving",
        "dismiss": "Dismiss",
        "details": "See details",
        "attention_title": "A file needs attention",
        "attention_body": "Choose another file or retry from the last safe step.",
        "partial_title": "Some files need attention",
        "partial_ready": "Ready to continue: ${fileCount}.",
        "partial_not_uploaded": "Not uploaded: ${fileCount}.",
        "partial_already_saved": "Already saved: ${fileCount}.",
        "partial_not_saved": "Not saved because the upload did not finish: ${fileCount}.",
        "partial_canceled": "Canceled before saving: ${fileCount}.",
        "partial_saved_not_read": "Uploaded and saved, but could not be read: ${fileCount}.",
        "partial_extracted_not_saved": "Uploaded, but extracted information was not saved: ${fileCount}.",
        "partial_next_step": "Open a file below to see the next step.",
        "continue_ready": "Continue with ready files"
      },
      "error_med_missing_start_date": "Add a start date for the medication \"${name}\" before saving.",
      "error_appt_missing_date_time": "Add a date and a time for the appointment \"${title}\" before saving.",
      "error_derived_rows_failed": "Your document was saved, but Louise could not add these Care rows: ${items}. Tap Save to retry. The document will not be uploaded again.",
      "derived_medication_label": "Medication",
      "derived_appointment_label": "Appointment",
      "doc_type_label": "Document type",
      "fields": {
        "test_name": "Test name",
        "date": "Date",
        "date_placeholder": "YYYY-MM-DD",
        "lab_clinic": "Lab / clinic",
        "lab": "Lab",
        "exam_name": "Exam name",
        "clinic": "Clinic",
        "imaging_type": "Imaging type",
        "findings": "Findings",
        "afc": "AFC (antral follicle count)",
        "afc_placeholder": "Count",
        "endo_thickness": "Endometrial thickness",
        "endo_placeholder": "Thickness",
        "test_type": "Test type",
        "test_type_placeholder": "Karyotype, Carrier screening...",
        "result": "Result",
        "result_default_label": "Result",
        "result_placeholder": "Value",
        "summary": "Summary",
        "volume": "Volume (mL)",
        "concentration": "Concentration (M/mL)",
        "motility": "Motility (%)",
        "morphology": "Morphology (%)",
        "notes": "Notes",
        "prescriber": "Prescriber",
        "medication_name": "Medication name",
        "dosage": "Dosage",
        "unit": "Unit",
        "unit_placeholder": "mg, IU...",
        "frequency": "Frequency",
        "frequency_placeholder": "Once daily...",
        "route": "Route",
        "route_placeholder": "Oral, SC...",
        "schedule": "Schedule",
        "ends": "Ends",
        "appointment_title": "Title",
        "appointment_type": "Type",
        "appointment_type_placeholder": "exam, procedure...",
        "time": "Time",
        "time_placeholder": "HH:MM",
        "document_title": "Document title",
        "provider": "Provider"
      },
      "table": {
        "marker": "Marker",
        "value": "Value",
        "unit": "Unit",
        "name": "Name",
        "dose": "Dose"
      },
      "results_label": "Results",
      "select_placeholder": "Select ▾",
      "unit_placeholder": "unit ▾",
      "add_marker": "Add marker",
      "add_medication": "Add medication",
      "add_appointment": "Add appointment",
      "medications_count": "Medications (${count})",
      "appointments_count": "Appointments (${count})",
      "unnamed_medication": "Unnamed medication",
      "unnamed_appointment": "Unnamed appointment"
    },
    "preview": {
      "info": {
        "record_date": "Record date",
        "document_name": "Document name",
        "uploaded": "Uploaded"
      },
      "section": {
        "results": "Results",
        "medications": "Medications",
        "appointments": "Appointments",
        "notes_findings": "Notes & findings"
      },
      "save": "Save",
      "add_value": "Add a value",
      "add_medication": "Add a medication",
      "add_appointment": "Add an appointment",
      "medications_empty": "No medication linked to this document yet.",
      "appointments_empty": "No appointment linked to this document yet.",
      "medications_start": "Start date: ${date}",
      "select_placeholder": "Select ▾",
      "unit_placeholder": "unit ▾",
      "frequency_placeholder": "Frequency ▾",
      "medication_name_placeholder": "Medication name",
      "time_placeholder": "HH:MM",
      "title_placeholder": "Title",
      "appointment_type": {
        "exam": "Exam",
        "procedure": "Procedure",
        "consult": "Consult",
        "counseling": "Counseling"
      },
      "delete": "Delete",
      "open_document": "Open document",
      "reupload": "Re-upload",
      "delete_confirm_title": "Delete document",
      "delete_confirm_message": "Are you sure you want to delete \"${name}\"? This cannot be undone.",
      "cancel": "Cancel"
    }
  },
  "cryo_vault": {
    "title": "Cryo vault",
    "subtitle": "Your frozen specimens and storage details",
    "hero": {
      "eyebrow": "Your cryo vault",
      "title_singular": "${count} specimen stored",
      "title_plural": "${count} specimens stored",
      "facility_one": "in 1 facility",
      "facility_other": "across ${count} facilities"
    },
    "back": "Back",
    "summary": {
      "embryos": "Embryos",
      "eggs": "Eggs",
      "semen": "Semen"
    },
    "specimen_type": {
      "embryo_singular": "Embryo",
      "embryo_plural": "Embryos",
      "egg_singular": "Egg",
      "egg_plural": "Eggs",
      "sperm_sample_singular": "Sperm sample",
      "sperm_sample_plural": "Sperm samples"
    },
    "pgt": {
      "euploid": "Euploid",
      "aneuploid": "Aneuploid",
      "mosaic": "Mosaic",
      "untested": "Untested"
    },
    "top_pick_badge": "TOP PICK",
    "top_pick": "Top pick",
    "grade_prefix": "Grade ${grade}",
    "motility_suffix": "${value} motility",
    "source_labels": {
      "self_egg": "Your egg",
      "partner_egg": "Partner's egg",
      "donor_egg": "Donor egg",
      "self_sperm": "Your sample",
      "partner_sperm": "Partner's sample",
      "donor_sperm": "Donor sample",
      "default_egg": "Egg",
      "default_sperm": "Semen sample",
      "subtitle_used_for_fertilization": "Used for fertilization"
    },
    "source_values": {
      "your_own": "Your own",
      "partner": "Partner",
      "donor": "Donor"
    },
    "modal": {
      "grade_alert_title": "Embryo Grading",
      "grade_alert_message": "Grading helps assess embryo quality. Ask your clinic about your specific grades.",
      "grade_label": "Grade",
      "learn_what_grades_mean": "Learn what embryo grades mean",
      "semen_sample_title": "Semen sample #${n}",
      "semen_sample_title_without_number": "Semen sample",
      "egg_cohort_title": "Egg cohort #${n}",
      "egg_cohort_title_without_number": "Egg cohort",
      "tab_summary": "Info",
      "tab_clinical": "Data",
      "tab_reports": "Reports",
      "tab_reports_short": "Report",
      "tab_storage": "Storage",
      "tab_storage_short": "Store",
      "tab_usage": "Use",
      "tab_documents": "Docs",
      "cycle_linked_tag": "Cycle linked",
      "egg_cohort_tag": "Cohort",
      "cycle_header_tag": "${cycle} | ${date}",
      "overview_section": "Overview",
      "embryo_section": "Embryo details",
      "embryo_quality_section": "Embryo quality",
      "embryo_development_section": "Embryo development",
      "development_day_value": "Day ${day}",
      "development_stage_value": "Stage: ${stage}",
      "development_grade_value": "Grade: ${grade}",
      "development_cells_value": "${count} cells",
      "development_arrested_value": "Culture arrested",
      "development_record_source": "Source: ${source}",
      "development_record_verification": "Verification: ${status}",
      "development_not_recorded": "No additional development details recorded",
      "oocyte_section": "Egg details",
      "oocyte_cohort_section": "Egg cohort details",
      "sperm_section": "Semen sample details",
      "semen_analysis_section": "Semen analysis",
      "extended_semen_panel_section": "Extended semen panel",
      "retrieval_cohort_section": "Retrieval cohort",
      "report_backed_outlook_section": "Report-backed outlook",
      "storage_section": "Storage",
      "status": "Status",
      "storage_pending": "Storage pending confirmation",
      "storage_unverified": "Storage not verified",
      "at_location": "at",
      "collection_date": "Collection date",
      "retrieval_date": "Retrieval date",
      "analysis_date": "Analysis date",
      "frozen": "Frozen",
      "fertilized": "Fertilized",
      "facility": "Facility",
      "storage_locator": "Storage locator",
      "storage_context": "Storage type",
      "sample_id": "Sample ID",
      "embryo_id": "Embryo ID",
      "embryo_grade": "Embryo grade",
      "day_of_development": "Day of development",
      "day_value": "Day ${day}",
      "pgt": "PGT",
      "sex": "Sex",
      "freezing_method": "Freezing method",
      "maturity": "Maturity",
      "cohort": "Cohort",
      "retrieval_cohort": "Retrieval cohort",
      "total_retrieved": "Total retrieved",
      "mature_mii": "Mature MII",
      "number_frozen": "Number frozen",
      "number_thawed": "Number thawed",
      "fertilized_count": "Fertilized",
      "embryos_created": "Embryos created",
      "embryos_created_from_cohort": "Embryos created from cohort",
      "remaining_frozen": "Remaining frozen",
      "maturity_rate": "Maturity rate",
      "thaw_history": "Thaw history",
      "no_thaw_recorded": "No thaw recorded",
      "no_cohort_counts": "No cohort counts",
      "predicted_egg_quality": "Blastocyst potential",
      "predicted_fertility_outlook": "Live birth prediction",
      "source_report": "Source report",
      "report_linked": "Report linked",
      "report_assumptions": "Report assumptions",
      "collection_method": "Collection method",
      "processing_method": "Processing method",
      "preparation_method": "Preparation method",
      "volume": "Volume",
      "total_count": "Total count",
      "tmsc": "TMSC",
      "abstinence": "Abstinence",
      "abstinence_value": "${count} days",
      "total_retrieved_value": "${count} retrieved",
      "mature_mii_value": "${count} MII",
      "immature_mi_value": "${count} MI",
      "degenerated_value": "${count} degenerated",
      "number_thawed_value": "${count} thawed",
      "thawed_for_fertilization_value": "${count} thawed for fertilization",
      "fertilized_count_value": "${count} fertilized",
      "embryos_created_count_value": "${count} embryos created",
      "survival_value": "${percent}% survival",
      "pgt_report": "PGT report",
      "view_pgt_report": "View PGT report",
      "embryo_report": "Embryo testing report",
      "view_embryo_report": "View embryo report",
      "motility": "Motility",
      "progressive_motility": "Progressive motility",
      "non_progressive_motility": "Non-progressive motility",
      "immotile": "Immotile",
      "agglutination_aggregation": "Agglutination / aggregation",
      "vitality": "Vitality",
      "leukocytes": "Leukocytes",
      "dna_fragmentation_index": "DNA fragmentation index",
      "antisperm_antibody": "Antisperm antibody",
      "sperm_epigenetics": "Sperm epigenetics",
      "oxidative_stress": "Oxidative stress",
      "sperm_function": "Sperm function",
      "not_tested": "Not tested",
      "concentration": "Concentration",
      "morphology": "Morphology",
      "ph": "pH",
      "viscosity": "Viscosity",
      "created_from": "Created from",
      "cycle_section": "Cycle",
      "origin_cycle": "Origin cycle",
      "used_in_cycle": "Used in cycle",
      "transfer_cycle": "Transfer cycle",
      "cycle_linked_value": "Cycle linked",
      "transfer_cycle_linked_value": "Transfer cycle linked",
      "cohort_partially_used": "Cohort partially used",
      "cohort_state": "Cohort state",
      "cohort_use": "Cohort use",
      "current_state": "Current state",
      "treatment_use": "Treatment use",
      "next_available_action": "Next available action",
      "embryo_use_state": "No transfer recorded yet",
      "oocyte_use_state": "No thaw or fertilization recorded yet",
      "semen_use_state": "No IUI/IVF/ICSI use recorded yet",
      "usage_empty_title": "No cycle use linked",
      "usage_empty_body": "This specimen has no linked source or treatment cycle yet.",
      "documents_empty_title": "No source documents linked",
      "documents_empty_body": "Add the report, consent, or storage document that supports these specimen details.",
      "source_documents_section": "Source documents",
      "source_not_linked": "Source not linked",
      "upload_source_report": "Upload",
      "semen_analysis_empty_title": "No semen analysis values",
      "semen_analysis_empty_body": "Add or upload a semen analysis report before showing clinical values for this sample.",
      "semen_analysis_report": "Semen analysis report",
      "semen_analysis_report_body": "Supports volume, concentration, count, motility, morphology, and other lab values.",
      "embryology_report": "Embryology report",
      "retrieval_report": "Retrieval report",
      "retrieval_report_body": "Supports retrieval date, total retrieved, maturity counts, and the link to the retrieval cycle.",
      "embryology_lab_report": "Embryology or lab report",
      "embryology_lab_report_body": "Supports egg maturity, freezing method, thaw history, fertilization use, and lab handling details.",
      "predictive_fertility_report": "Predictive fertility report",
      "predictive_fertility_report_body": "Supports any future-fertility, egg-quality, or cohort-outlook estimates shown in the modal.",
      "consent_to_use_document": "Consent or authorization to use",
      "consent_to_use_document_body": "Needed before this sample can be used in IUI, IVF, ICSI, donation, discard, or transfer workflows.",
      "cryostorage_agreement_document": "Cryostorage agreement",
      "cryostorage_agreement_document_body": "Confirms storage terms, facility, and administrative obligations for the stored sample.",
      "chain_of_custody_document": "Shipping or chain-of-custody document",
      "chain_of_custody_document_body": "Relevant when a sample was moved between clinics, labs, storage providers, or jurisdictions.",
      "source_document_upload_why": "Upload the document that supports this specimen's clinical values, consent, or storage details.",
      "edit_specimen": "Edit specimen",
      "edit_specimen_body": "Update this specimen or record what happened next.",
      "focused_edit_body": "Update only this detail. The rest of the specimen stays unchanged.",
      "edit_status_title": "Edit status",
      "edit_notes_title": "Edit notes",
      "edit_sample_id_title": "Edit sample ID",
      "edit_identification_number_title": "Edit identification number",
      "edit_collection_date_title": "Edit collection date",
      "edit_freeze_date_title": "Edit freeze date",
      "edit_facility_title": "Edit facility",
      "edit_storage_locator_title": "Edit storage locator",
      "focused_edit_required": "Enter a value before saving.",
      "not_recorded": "Not recorded",
      "record_details_section": "Record details",
      "record_date_placeholder": "YYYY-MM-DD",
      "freeze_date": "Freeze date",
      "facility_placeholder": "Clinic or storage facility",
      "storage_locator_placeholder": "Tank 4, Canister B, Cane 13",
      "sample_id_placeholder": "Sample identifier",
      "identification_number": "Identification number",
      "identification_number_placeholder": "Egg identifier",
      "record_date_invalid": "Use dates in YYYY-MM-DD format.",
      "remove_specimen": "Remove specimen",
      "confirm_remove_specimen": "Remove this specimen?",
      "remove_specimen_consequences": "This removes ${specimen} from your Cryo Vault and future treatment selections.",
      "remove_specimen_failed": "We couldn’t remove this specimen. Try again.",
      "status_label": "Status",
      "current_status": "Current status",
      "status_value_collected": "Collected",
      "status_value_processed": "Processed",
      "status_value_stored": "Stored",
      "status_value_used": "Used",
      "status_value_discarded": "Discarded",
      "status_value_donated": "Donated",
      "status_value_in_transit": "In transit",
      "record_lifecycle_event": "Record a lifecycle event",
      "lifecycle_event_help": "Choose an event to add to this specimen's history. Event details are saved separately from the specimen fields.",
      "record_lifecycle_event_button": "Record event",
      "cohort_lifecycle_event_help": "Record lifecycle events from the individual egg records in this cohort.",
      "lifecycle_event_thaw": "Thaw",
      "lifecycle_event_donate": "Donate",
      "lifecycle_event_fertilize": "Fertilize",
      "lifecycle_event_mature": "Mature",
      "lifecycle_event_discard": "Discard",
      "lifecycle_event_use": "Use",
      "lifecycle_event_release": "Release reservation",
      "lifecycle_event_test": "Test",
      "lifecycle_event_culture": "Culture",
      "lifecycle_event_transfer": "Transfer",
      "lifecycle_event_biopsy": "Biopsy",
      "lifecycle_event_freeze": "Freeze",
      "lifecycle_event_reserve": "Reserve",
      "lifecycle_event_date": "Event date",
      "lifecycle_event_date_placeholder": "YYYY-MM-DD",
      "lifecycle_event_time": "Event time",
      "lifecycle_event_time_placeholder": "HH:MM",
      "lifecycle_event_quantity": "Exact quantity",
      "lifecycle_event_quantity_placeholder": "Enter quantity",
      "lifecycle_event_unit_count": "count",
      "lifecycle_event_unit_vial": "vial",
      "fertilization_source_label": "Semen specimen source",
      "fertilization_source_empty": "Add a semen specimen before recording fertilization.",
      "fertilization_source_quantity": "Semen quantity",
      "fertilization_output_label": "Produced material label",
      "fertilization_output_placeholder": "e.g. Fertilized oocyte 1",
      "fertilization_required": "Choose a semen source and output label before saving.",
      "lifecycle_thaw_motility": "Motility (%)",
      "lifecycle_thaw_viability": "Viability (%)",
      "lifecycle_thaw_percentage_placeholder": "0–100",
      "lifecycle_thaw_percentage_error": "Enter a percentage between 0 and 100.",
      "lifecycle_thaw_surviving_quantity": "Number surviving",
      "lifecycle_thaw_surviving_quantity_placeholder": "Enter count",
      "lifecycle_thaw_surviving_quantity_error": "Enter a whole number from zero through the thaw quantity.",
      "lifecycle_thaw_survival_rate": "Survival rate (%)",
      "lifecycle_thaw_survival_rate_unrecorded": "Not recorded",
      "lifecycle_event_note": "Notes",
      "lifecycle_event_note_placeholder": "Notes",
      "lifecycle_event_required": "Choose an event, exact quantity, date, and time before saving.",
      "lifecycle_event_history_unavailable": "This specimen history is unavailable. Reload the specimen before recording an event.",
      "lifecycle_history": "Lifecycle history",
      "notes_placeholder": "Add a note about this specimen",
      "save_changes": "Save changes",
      "saving_changes": "Saving…",
      "save_error": "Unable to save changes.",
      "lifecycle_event_error": "Unable to record this event.",
      "source": "Source",
      "notes": "Notes",
      "your_notes": "Your notes",
      "media": "Media",
      "media_day": "Day ${day}",
      "time_lapse": "Time-lapse",
      "plan_transfer_alert_title": "Plan a Transfer",
      "plan_transfer_alert_message": "Please contact your clinic to discuss embryo transfer options and scheduling.",
      "plan_transfer_button": "Plan transfer",
      "view_transfer_alert_title": "Transfer cycle",
      "view_transfer_button": "View transfer",
      "fertilize_alert_title": "Use egg",
      "fertilize_alert_message": "This action needs the egg thaw, fertilization, or treatment-use workflow before it can update your care plan.",
      "fertilize_button": "Use this egg",
      "use_remaining_eggs_button": "Use eggs",
      "use_semen_button": "Plan treatment",
      "view_cycle_button": "View cycle",
      "cycle_button_compact": "Cycle",
      "cycle_number_button": "Cycle #${number}",
      "link_cycle_button": "Link cycle",
      "view_cycle_alert_title": "View source cycle",
      "view_cycle_alert_message": "Source-cycle navigation is tracked separately and is not wired in this modal yet.",
      "link_cycle_alert_title": "Link cycle",
      "link_cycle_alert_message": "Cycle linking needs a backend-backed relationship before this action can save.",
      "cohort_availability_section": "Cohort availability",
      "add_document_button": "Add doc",
      "add_files_button": "Add files",
      "add_document_alert_title": "Add source document",
      "add_document_alert_message": "Document provenance for specimen details is tracked separately and is not wired in this modal yet."
    },
    "metric_info": {
      "current_value": "Current value",
      "reference_context": "Reference context",
      "result_status": "Status",
      "result_source": "Source",
      "status_needs_source_range_title": "Needs source range",
      "status_needs_source_range_body": "This value is shown for context, but Louise is not classifying it until the source report or lab-specific range is linked.",
      "status_not_tested_title": "Not tested",
      "status_not_tested_body": "No result for this metric is available for this sample yet.",
      "oocyte_status_needs_source_title": "Needs source report",
      "oocyte_status_needs_source_body": "This value should be tied to a retrieval report, embryology report, storage record, predictive report, clinic import, or verified manual source before it is treated as confirmed.",
      "source_not_linked_title": "Source not linked",
      "source_not_linked_body": "This metric is not yet tied to a report, OCR extraction, clinic import, or verified manual entry.",
      "source_report_linked_title": "Source report linked",
      "source_report_linked_body": "This value is shown as report-backed in the fixture. Production needs the actual report link, extraction, and source metadata.",
      "what_it_means": "What this means",
      "keep_in_mind": "Keep in mind",
      "disclaimer": "Reference limits are population-based and lab methods vary. Your clinic should interpret this with abstinence time, collection conditions, partner factors, and treatment plan.",
      "oocyte_disclaimer": "Egg and cohort estimates depend on age, clinic methods, lab reporting, thaw outcomes, sperm source, and treatment plan. Predictive reports are estimates, not guarantees.",
      "analysis_date": {
        "range": "Report date or lab analysis date",
        "summary": "This is when the semen analysis was performed or reported. It helps connect the values to the right collection and source document.",
        "context": "Semen parameters can vary over time, so date matters when comparing samples or deciding whether a newer analysis is needed."
      },
      "collection_method": {
        "range": "Usually masturbation or ejaculate collection; alternatives depend on clinical context",
        "summary": "Collection method describes how the semen sample was obtained.",
        "context": "Method and completeness of collection can affect volume, concentration, and interpretation. Surgical retrieval samples are interpreted differently from ejaculated samples."
      },
      "processing_method": {
        "range": "Lab-specific preparation step",
        "summary": "Processing method describes what the lab did to prepare or freeze the sample.",
        "context": "Processing affects what the sample can be used for later and how post-thaw results should be interpreted."
      },
      "preparation_method": {
        "range": "Examples include simple wash, density gradient, or swim-up",
        "summary": "Preparation method describes how the lab selected or cleaned sperm before use or freezing.",
        "context": "Different methods can change the final motile count and may be chosen based on sample quality and planned treatment."
      },
      "abstinence": {
        "range": "Often collected after about 2-7 days, depending on lab instructions",
        "summary": "Abstinence is the number of days since the last ejaculation before collection.",
        "context": "Short or long abstinence can change volume, count, and motility, so it helps explain why results vary between samples."
      },
      "volume": {
        "range": "WHO 2021 lower reference limit: about 1.4 mL",
        "summary": "Volume is the amount of semen in the sample. It affects the total number of sperm available and how many vials or uses a sample may support.",
        "context": "Low volume can happen if part of the sample was missed, abstinence time was short, or there are issues with seminal fluid production or ducts. It is usually interpreted together with total count and collection notes."
      },
      "concentration": {
        "range": "WHO 2021 lower reference limit: about 16 million/mL",
        "summary": "Concentration is how many sperm are present in each milliliter of semen.",
        "context": "A lower concentration may reduce the number of usable sperm, but total count, motility, morphology, and planned use matter. IVF with ICSI can sometimes use samples that would be limited for IUI."
      },
      "total_count": {
        "range": "WHO 2021 lower reference limit: about 39 million per ejaculate",
        "summary": "Total count estimates how many sperm are in the whole sample, combining volume and concentration.",
        "context": "This helps distinguish a small-but-concentrated sample from a larger dilute sample. It is more useful when interpreted with motility and post-processing recovery."
      },
      "tmsc": {
        "range": "No single WHO reference limit; clinic thresholds vary by IUI/IVF/ICSI plan",
        "summary": "TMSC usually means total motile sperm count: an estimate of how many sperm are moving in the sample.",
        "context": "Clinics often use TMSC to decide whether IUI is reasonable or whether IVF/ICSI is a better fit. The exact cutoff depends on the clinic, processing method, and whether the value is pre-wash or post-wash."
      },
      "motility": {
        "range": "WHO 2021 lower reference limit for total motility: about 42%",
        "summary": "Motility is the share of sperm that are moving, including progressive and non-progressive movement.",
        "context": "Motility matters because sperm need movement for natural conception and IUI. For IVF/ICSI, the clinic may still be able to use lower-motility samples depending on the number and quality of motile sperm recovered."
      },
      "progressive_motility": {
        "range": "WHO 2021 lower reference limit: about 30%",
        "summary": "Progressive motility is the share of sperm swimming forward rather than just moving in place.",
        "context": "This is one of the most practical motility measures for fertility planning. If it is low, the clinic may discuss repeat testing, processing results, IUI odds, or IVF/ICSI."
      },
      "non_progressive_motility": {
        "range": "No standalone universal normal range; interpreted with total and progressive motility",
        "summary": "Non-progressive motility means sperm are moving but not efficiently swimming forward.",
        "context": "A sample can have movement but still have limited forward progression. This matters most when progressive motility or total motile count is low."
      },
      "immotile": {
        "range": "Interpreted as the complement of motile sperm",
        "summary": "Immotile sperm are not moving at the time the sample is assessed.",
        "context": "A high immotile share can lower usable motile sperm. If motility is very low, vitality testing can help tell whether non-moving sperm are alive or dead."
      },
      "morphology": {
        "range": "WHO strict morphology lower reference limit: about 4% normal forms",
        "summary": "Morphology is the percentage of sperm with normal shape under strict lab criteria.",
        "context": "Morphology is only one part of the picture and can vary by lab. Low morphology may influence whether a clinic recommends ICSI, but it does not by itself prove that fertilization is impossible."
      },
      "agglutination_aggregation": {
        "range": "Usually expected: none or minimal",
        "summary": "Agglutination or aggregation describes sperm sticking to each other or to debris/cells.",
        "context": "Clumping can make motility harder to interpret and may prompt the lab to consider antibodies, inflammation, infection, or sample-handling factors depending on the pattern."
      },
      "ph": {
        "range": "Common lower reference context: pH about 7.2 or higher",
        "summary": "pH describes how acidic or alkaline the semen is.",
        "context": "pH can point to issues with accessory gland fluid or sample timing, but it is not interpreted alone. The lab's own reference range should be used."
      },
      "viscosity": {
        "range": "Usually expected: normal liquefaction and low thread length after liquefaction",
        "summary": "Viscosity describes how thick or stringy the semen remains after it liquefies.",
        "context": "High viscosity can make measurement and sperm movement harder. It may reflect incomplete liquefaction, inflammation, or handling factors and is interpreted with the lab report."
      },
      "vitality": {
        "range": "WHO 2021 lower reference limit: about 54% live sperm",
        "summary": "Vitality measures the share of sperm that are alive, whether or not they are moving.",
        "context": "Vitality is especially useful when motility is low because it separates live-but-not-moving sperm from dead sperm. WHO guidance emphasizes vitality assessment when total motility is low."
      },
      "leukocytes": {
        "range": "Many labs flag leukocytospermia around 1 million WBC/mL or higher",
        "summary": "Leukocytes are white blood cells seen in semen.",
        "context": "Elevated leukocytes can suggest inflammation or infection, but round cells need correct identification. Your clinic may repeat the test, order culture, or evaluate symptoms."
      },
      "dna_fragmentation_index": {
        "range": "Assay-specific; many reports group DFI as low, borderline, or elevated",
        "summary": "DNA fragmentation estimates the share of sperm with damaged or fragmented DNA.",
        "context": "This can add context when semen analysis is normal but there is recurrent loss, failed fertilization, or repeated treatment failure. Thresholds depend on the assay, such as SCSA, TUNEL, COMET, or SCD."
      },
      "antisperm_antibody": {
        "range": "Assay-specific; often expected to be negative or low binding",
        "summary": "Antisperm antibody testing looks for immune proteins attached to sperm.",
        "context": "Antibodies can interfere with movement or sperm-egg interaction in some cases. The type of assay and degree of binding determine how clinically relevant the result is."
      },
      "sperm_epigenetics": {
        "range": "Assay-specific score; no WHO reference limit",
        "summary": "Sperm epigenetic testing looks at chemical markers on sperm DNA, such as methylation patterns.",
        "context": "These tests are usually offered as advanced or proprietary panels. They may provide context about sperm aging or exposures, but interpretation depends on the vendor and clinician."
      },
      "oxidative_stress": {
        "range": "Assay-specific; no single WHO reference limit",
        "summary": "Oxidative stress testing looks for reactive oxygen stress that can affect sperm membranes and DNA.",
        "context": "Oxidative stress may be linked with inflammation, varicocele, smoking, heat exposure, or other factors. Results are usually interpreted with history, semen parameters, and any DNA fragmentation testing."
      },
      "sperm_function": {
        "range": "Assay-specific; no standard WHO reference limit",
        "summary": "Sperm function testing tries to assess whether sperm can perform steps such as binding, penetrating, or fertilizing an egg.",
        "context": "This goes beyond standard count and motility. Some tests are proprietary or gene-expression based, so the report's own categories and your clinic's treatment plan matter most."
      },
      "oocyte_maturity": {
        "range": "Common categories include MII, MI, GV, or unknown",
        "summary": "Maturity describes the egg's stage at retrieval or freezing. MII eggs are mature and are usually the eggs considered ready for fertilization.",
        "context": "Maturity is usually cohort-level lab data from the retrieval or embryology report. MI or GV eggs may mature later in some settings, but interpretation depends on the lab and treatment plan."
      },
      "oocyte_freezing_method": {
        "range": "Most modern egg freezing uses vitrification",
        "summary": "Freezing method describes how the lab cryopreserved the egg.",
        "context": "Vitrification is the common modern approach because it freezes cells rapidly. The method should come from the lab or storage report, especially if comparing older samples."
      },
      "oocyte_retrieval_date": {
        "range": "Procedure date from the retrieval cycle",
        "summary": "Retrieval date anchors this egg to the cycle and cohort it came from.",
        "context": "Age at retrieval and cycle context are often more clinically relevant than age today when discussing frozen eggs."
      },
      "oocyte_frozen_date": {
        "range": "Usually the retrieval date or shortly after lab assessment",
        "summary": "Frozen date records when the egg entered cryostorage.",
        "context": "This date helps reconcile storage records, billing, chain-of-custody documents, and later thaw/use history."
      },
      "oocyte_total_retrieved": {
        "range": "Cohort-level count from the retrieval report",
        "summary": "Total retrieved is the number of eggs collected in the retrieval cycle before maturity filtering.",
        "context": "This is cohort context, not a property of one egg. It helps explain how this individual egg fits into the full retrieval outcome."
      },
      "oocyte_mature_mii": {
        "range": "Cohort-level count of mature eggs",
        "summary": "MII count is the number of mature eggs in the cohort, usually the eggs considered usable for freezing or fertilization.",
        "context": "MII count is one of the most important cohort values for planning, but it should be tied to the embryology or retrieval report."
      },
      "oocyte_number_frozen": {
        "range": "Cohort-level count stored after retrieval/lab assessment",
        "summary": "Number frozen records how many eggs from the cohort were cryopreserved.",
        "context": "This may be lower than retrieved or mature counts if some eggs were used immediately, did not meet criteria, or were not frozen."
      },
      "oocyte_number_thawed": {
        "range": "Cohort-level count of eggs already thawed or used",
        "summary": "Number thawed records how many eggs from this cohort have already left frozen storage for thaw/use.",
        "context": "This is cohort availability context. A stored individual egg should still be understood as frozen unless a specific thaw/use event is linked to that egg."
      },
      "oocyte_remaining_frozen": {
        "range": "Frozen count minus recorded thaw/use events",
        "summary": "Remaining frozen estimates how many eggs from the cohort are still available in storage.",
        "context": "This needs backend-backed lifecycle tracking before it can be considered definitive across thaw, use, discard, donation, transfer, or shipping events."
      },
      "oocyte_maturity_rate": {
        "range": "Mature MII divided by total retrieved",
        "summary": "Maturity rate estimates what share of retrieved eggs were mature enough to freeze or fertilize.",
        "context": "This is a cohort-level calculation, not a property of one egg. It should be interpreted with age at retrieval, protocol, trigger timing, lab handling, and the source retrieval report."
      },
      "oocyte_predictive_quality": {
        "range": "Provider-specific probability, often based on oocyte images",
        "summary": "Some reports estimate each egg's or the cohort's chance of developing into a blastocyst after thaw and fertilization.",
        "context": "This should always be shown as a report-backed estimate from a named source, not as Louise independently predicting egg quality or embryo development."
      },
      "oocyte_predictive_outlook": {
        "range": "Provider-specific live-birth estimate for the frozen egg cohort",
        "summary": "Some reports combine personalized egg assessment with statistical modeling to estimate chances of at least one live birth from the frozen cohort.",
        "context": "These estimates are sensitive to assumptions and do not replace medical counseling. Outcomes also depend on thaw survival, sperm source, fertilization, embryo development, transfer, implantation, and uterine factors."
      }
    },
    "grade_explanations": {
      "6AA": "Hatching blastocyst, top quality inner cell mass and trophectoderm",
      "5AA": "Hatching blastocyst, excellent quality",
      "4AA": "Expanded blastocyst, top quality — strong transfer candidate",
      "4AB": "Expanded blastocyst, excellent inner cells, good trophectoderm",
      "4BA": "Expanded blastocyst, good inner cells, excellent trophectoderm",
      "4BB": "Expanded blastocyst, good quality — viable for transfer",
      "3AA": "Full blastocyst, top quality — strong transfer candidate",
      "3AB": "Full blastocyst, excellent inner cells, good outer cells",
      "3BA": "Full blastocyst, good inner cells, excellent outer cells",
      "3BB": "Full blastocyst, good quality — viable for transfer",
      "2BB": "Early blastocyst, good quality — may continue developing",
      "1BB": "Early cavitation, good quality"
    },
    "egg_grid": {
      "default_cycle_label": "Egg Freeze",
      "frozen_date": "Frozen ${date}"
    },
    "grouped_inventory": {
      "unknown_facility": "Storage facility",
      "frozen_date": "Frozen ${date}",
      "egg_cohort_title_frozen": "${count} frozen | ${label}",
      "egg_cohort_title_used": "${remaining} frozen, ${used} used | ${label}"
    },
    "funnel": {
      "subtitle": "Each stage has natural attrition — here's how your cycle progressed",
      "view_full_cycle": "View full cycle details",
      "retrieved": "Retrieved",
      "retrieved_subtitle": "From retrieval procedure",
      "mature": "Mature",
      "mature_subtitle": "Ready for fertilization",
      "fertilized": "Fertilized",
      "fertilized_subtitle": "Successfully combined",
      "blastocysts": "Blastocysts",
      "blastocysts_subtitle": "Day 5 embryos ready for biopsy",
      "pgt_tested": "PGT tested",
      "pgt_tested_subtitle": "Genetic screening completed",
      "euploid": "Euploid",
      "euploid_subtitle": "Genetically normal",
      "frozen": "Frozen",
      "frozen_subtitle": "Vitrified and in storage",
      "embryos_frozen": "Embryos frozen",
      "no_result": "No result",
      "title": "Results Funnel",
      "observed_subtitle": "Recorded counts from this cycle, with each stage shown against the retrieved cohort.",
      "recorded_detail": "Recorded from this cycle.",
      "share_detail": "${share}% of the retrieved cohort; recorded from this cycle."
    },
    "facility": {
      "specimen_count_one": "${count} specimen stored",
      "specimen_count_other": "${count} specimens stored",
      "since": "Since ${date}",
      "annual_cost": "${cost}/year",
      "next_payment": "Next payment ${date}"
    },
    "disposition": {
      "on_file_title": "Disposition directive on file",
      "on_file_subtitle": "Your instructions for your specimens are documented",
      "expiring_title": "Disposition directive expiring soon",
      "missing_title": "Disposition directive missing",
      "missing_subtitle": "Required document — specifies what happens to your specimens"
    },
    "action_card": {
      "coming_soon": "COMING SOON"
    },
    "egg_planning": {
      "title": "Family planning context",
      "body_singular": "With ${count} frozen eggs, you may have enough for approximately ${attempts} IVF attempt. This varies significantly by age and egg quality. Discuss your specific outlook with your RE.",
      "body_plural": "With ${count} frozen eggs, you may have enough for approximately ${attempts} IVF attempts. This varies significantly by age and egg quality. Discuss your specific outlook with your RE."
    },
    "potential": {
      "section_title": "Your vault's potential",
      "tab_combined": "All potential",
      "tab_embryos": "Embryos",
      "tab_eggs": "Eggs",
      "summary_card_title": "Live birth estimate",
      "intro": "Based on published success rates, here's how your frozen specimens could translate into live births",
      "from_embryos": "From embryos",
      "from_embryos_with_euploid": "From embryos (${count} euploid)",
      "from_frozen_eggs": "From frozen eggs",
      "what_this_means": "What this means",
      "recommendation": "Recommendation",
      "frozen_embryos": "Frozen embryos",
      "survive_thaw": "Survive thaw",
      "implant_successfully": "Implant successfully",
      "estimated_live_births": "Estimated live births",
      "combined_inventory": "Vault inventory",
      "combined_thaw": "Survive thaw",
      "combined_transfer_ready": "Transfer-ready embryos",
      "combined_implant": "Implant successfully",
      "combined_live_births": "Estimated live births",
      "combined_inventory_detail": "${embryos} embryos + ${eggs} eggs stored in your vault.",
      "combined_thaw_detail": "${embryos} embryos + ${eggs} eggs expected to survive thaw.",
      "combined_transfer_ready_detail": "${embryos} thawed embryos + ${eggs} egg-derived embryos expected.",
      "combined_implant_detail": "${embryos} embryos + ${eggs} egg-derived embryos may implant.",
      "combined_live_birth_detail": "${embryos} expected from frozen embryos + ${eggs} from frozen eggs.",
      "stored_cohort_detail": "Stored in your CryoVault and available for this estimate.",
      "survive_thaw_detail": "Some may not survive thaw later.",
      "fertilize_detail": "Some may not fertilize after thaw.",
      "reach_blastocyst_detail": "Some may stop developing before blastocyst stage.",
      "implant_detail": "Some may not implant after transfer.",
      "live_birth_detail": "Estimated live births after the remaining steps.",
      "frozen_eggs": "Frozen eggs",
      "fertilize": "Fertilize",
      "reach_blastocyst": "Reach blastocyst",
      "insight_high_singular": "Based on published averages, your current cryo inventory could lead to approximately ${count} live birth. These are statistical estimates — your RE can refine them based on your specific situation.",
      "insight_high_plural": "Based on published averages, your current cryo inventory could lead to approximately ${count} live births. These are statistical estimates — your RE can refine them based on your specific situation.",
      "insight_one": "Your current inventory gives you a reasonable shot at one live birth based on statistical averages. Consider discussing with your RE whether additional cycles could improve your odds.",
      "insight_low": "With your current inventory, the statistical odds are tight. Your RE can help you decide whether an additional retrieval or freeze cycle would meaningfully improve your chances.",
      "recommendation_no_embryos": "With only frozen eggs and no embryos, consider an additional egg freeze cycle to increase your chances, or discuss fertilizing your current eggs to create embryos.",
      "recommendation_untested": "None of your embryos have been PGT-tested. Genetic screening can help identify the strongest transfer candidates and improve success rates.",
      "recommendation_few_euploid": "Having only one euploid embryo means limited attempts. Discuss with your RE whether another cycle could give you more options.",
      "disclaimer": "Estimates based on published SART/CDC averages. Individual outcomes vary by age, egg quality, clinic, and other factors. Discuss your personalized outlook with your reproductive endocrinologist."
    },
    "sections": {
      "what_to_do": "What would you like to do?",
      "retrieval_results": "Retrieval results",
      "storage_facilities": "Storage facilities",
      "related_documents": "Related documents",
      "common_questions": "Common questions"
    },
    "actions": {
      "plan_transfer_label": "Plan a transfer",
      "plan_transfer_subtitle": "Start the process to transfer a frozen embryo",
      "fertilize_label": "Fertilize my eggs",
      "fertilize_subtitle": "Begin an IVF cycle using your frozen eggs",
      "start_cycle_label": "Start another cycle",
      "start_cycle_subtitle": "Add more eggs, embryos, or sperm to your vault",
      "move_label": "Move my specimens",
      "move_subtitle": "Organize transport between facilities with tracking"
    },
    "transfer_selection": {
      "title": "Choose embryos for this transfer",
      "subtitle": "Select the exact records you want to review with your clinic. Nothing is reserved until you start the cycle.",
      "cancel": "Cancel",
      "continue": "Review selection"
    },
    "documents": {
      "cryo_agreement_label": "Cryostorage agreement",
      "cryo_agreement_subtitle": "Storage terms, fees, and renewal",
      "disposition_label": "Disposition directive",
      "disposition_subtitle": "Instructions for your specimens",
      "invoices_label": "Storage fee invoices",
      "invoices_subtitle": "Payment history",
      "empty_title": "No CryoVault documents linked",
      "empty_body": "Documents appear here when they are explicitly linked to a cycle or specimen.",
      "empty_action": "Upload a CryoVault document"
    },
    "faq": {
      "expire_question": "Do frozen specimens expire?",
      "expire_answer": "Vitrified embryos and eggs can remain viable for decades. There is no known time limit — specimens frozen for 20+ years have resulted in healthy births.",
      "quality_question": "Does quality decrease the longer they're stored?",
      "quality_answer": "No. Vitrification preserves cells in a stable state. The quality at thaw is determined by the quality at freeze, not by storage duration.",
      "eggs_needed_question": "How many eggs do I need for one baby?",
      "eggs_needed_answer": "It depends on age and egg quality. On average, 10-20 eggs may yield 1 live birth for women under 35, with more needed at older ages. Your RE can give you a personalized estimate.",
      "move_facility_question": "Can I move my specimens to a different facility?",
      "move_facility_answer": "Yes. Specimens can be shipped between clinics using specialized cryogenic couriers. Both facilities need to coordinate the transfer. We're building tools to help manage this."
    },
    "empty": {
      "title": "Add any frozen specimen",
      "body": "Upload a cryo report, storage agreement, embryology summary, or enter details for eggs, embryos, or sperm. Louise will scan what it can and keep the record connected to your care.",
      "chip_eggs": "Eggs",
      "chip_embryos": "Embryos",
      "chip_sperm": "Sperm",
      "chip_freeze_reports": "Freeze reports",
      "chip_storage": "Storage agreements",
      "chip_facility": "Facilities",
      "chip_disposition": "Disposition forms",
      "drop_title": "Drag and drop or choose a cryo report",
      "drop_hint": "PDFs, images, storage reports, and embryology summaries",
      "note": "You can add one specimen, a full freezing report, or a storage packet. We will pull out facility, freeze date, counts, and specimen details where clear."
    },
    "labels": {
      "embryo_label": "Embryo #${n}",
      "egg_label": "Egg #${n}",
      "egg_cohort_label": "Egg cohort #${n}",
      "sample_label": "Sample #${n}"
    },
    "add_modal": {
      "header_title": "Add specimens",
      "form_title": "Add ${type}",
      "upload_intro": "Upload a cryo report to fill in specimen details automatically, or enter them manually.",
      "extracting": "Extracting specimen data...",
      "extraction_failed_message": "We couldn't extract this report. The file is still attached; retry extraction or enter the values manually.",
      "retry_extraction": "Retry extraction",
      "upload_document": "Upload Document",
      "enter_manually": "Enter manually",
      "manual_option": "Or enter manually",
      "uploaded_file_hint": "Review the specimen type, then choose its source.",
      "back": "Back",
      "next": "Next",
      "steps": {
        "related": "Choose the related cycle",
        "analysis": "Review sample analysis",
        "counts": "Record retrieval details",
        "usage": "What happened next?",
        "development": "Describe embryo development",
        "embryo_group_details": "Embryo group details",
        "embryo_shared_details": "Fertilisation details",
        "inventory": "Choose how to record the embryos",
        "details": "Optional details",
        "progress": "Step ${step} of ${total}"
      },
      "add_another_cycle": "Add another cycle",
      "add_another_sample_action": "Add another sample",
      "add_another_sample_prompt": "Would you like to add another sample?",
      "done": "Done",
      "save": "Save",
      "success_title": "Added ${type}",
      "success_title_eggs": "Your eggs are safely in the vault",
      "success_body": "Your specimen has been added to your CryoVault.",
      "embryo_follow_up": {
        "prompt": "You mentioned that some of your eggs were fertilized.\nWould you like to add details about those embryos now?",
        "not_now": "Not now",
        "add_details": "Add details"
      },
      "save_button_singular": "Save ${count} specimen",
      "save_button_plural": "Save ${count} specimens",
      "saved": "Saved",
      "partial_save_message": "Some specimen records were saved. ${count} still need attention. Try again to finish saving.",
      "batch_save_failed_message": "We couldn't save these specimen records. Try again to finish saving.",
      "document_upload_failed_message": "The specimen was saved, but one or more supporting documents could not be linked. Retry the document upload before leaving.",
      "document_upload_failed_files": "Needs retry: ${files}",
      "retry_document_upload": "Retry document upload",
      "post_save_sync_error": "Your specimen was saved, but the treatment step could not be updated. Try again to finish syncing it.",
      "retry_post_save_sync": "Retry step sync",
      "optional_add_button": "+ Add",
      "validation_error": "Add at least one frozen specimen and a collection, retrieval, or freeze date.",
      "validation_error_embryos": "Add at least one embryo or embryo group, development details, and a fertilisation or freeze date.",
      "generic_error": "Something went wrong.",
      "cycle_card": {
        "eggs": "Eggs",
        "sperm": "Sperm",
        "embryos": "Embryos",
        "cycle_index": "${type} #${n}",
        "no_clinic": "No clinic",
        "specimen_count_singular": "${count} specimen",
        "specimen_count_plural": "${count} specimens",
        "summary_dot": "${clinic} · ${count_text}"
      },
      "type_toggle": {
        "eggs": "Oocytes (Eggs)",
        "sperm": "Sperm",
        "embryos": "Embryos"
      },
      "source": {
        "who_specimen_from_optional": "Who is this specimen from? (optional)",
        "mine": "Mine",
        "partner": "Partner’s",
        "donor": "Donor’s",
        "unknown": "I don't know"
      },
      "past_cycle": {
        "title": "Add a past cycle",
        "subtitle": "This cycle is not fully added yet. Add its type and when it happened now; you can add more details later.",
        "type_label": "What kind of cycle was it?",
        "when_label": "When was this cycle?",
        "month_year": "MM/YYYY",
        "cancel": "Cancel",
        "save": "Save cycle"
      },
      "related_cycle_specimen": {
        "eggs": "eggs",
        "sperm": "sperm samples",
        "embryos": "embryos"
      },
      "fields": {
        "clinic": "Clinic",
        "stored_at": "Where are they stored?",
        "stored_at_optional": "Clinic or facility (optional)",
        "storage_location": "Storage location (optional)",
        "storage_location_placeholder": "Choose a city or country",
        "clinic_placeholder": "Select or type clinic name...",
        "use_custom": "Use \"${value}\"",
        "search_placeholder": "Search or type custom...",
        "search_location": "Search city or country...",
        "location_no_matches": "No locations found",
        "search_country": "Search country...",
        "country": "Country",
        "country_placeholder": "Choose country",
        "upload_supporting_document": "Upload a supporting document",
        "related_cycle": "Related cycle",
        "related_cycle_optional": "Related cycle (optional)",
        "sperm_related_cycle": "Was this sample related to a cycle?",
        "sperm_related_cycle_optional": "Was this sample related to a cycle? (optional)",
        "sperm_preservation": "Preservation only",
        "related_cycle_another": "Another cycle",
        "related_cycle_not_linked": "Don't link to a cycle yet",
        "related_cycle_not_linked_hint": "This specimen will stay separate until you choose a cycle.",
        "related_cycle_existing": "${count} ${specimen} already added",
        "storage_type": "Storage Type",
        "storage_type_optional": "Storage type (optional)",
        "storage_id": "Storage ID / Tank Reference",
        "storage_id_optional": "Storage reference (optional)",
        "storage_id_placeholder": "e.g. \"Tank 4, Canister B\"",
        "storage_state_optional": "What is the storage state? (optional)",
        "storage_state_placeholder": "Choose a storage state",
        "storage_state_stored": "Stored at a facility",
        "storage_state_not_stored": "Not currently stored",
        "storage_state_unknown": "Unknown / needs confirmation",
        "notes": "Notes",
        "notes_placeholder": "Additional notes...",
        "documents": "Documents (optional)",
        "documents_prompt": "Drop any documents you would like to add about these specimens, including legal, financial, storage, or clinic records. We’ll parse them for you.",
        "documents_drop_action": "Drop documents or choose files",
        "documents_drop_hint": "PDFs, images, or full record packets",
        "embryo_report": "Embryo report (optional)",
        "embryo_report_prompt": "Upload a report and we’ll populate the embryo counts and details we can find. You can review and edit everything below.",
        "embryo_report_drop_action": "Drop a report or choose a file",
        "embryo_report_drop_hint": "PDFs, images, or full lab record packets",
        "attachments": "Attachments",
        "attach_file": "Attach file (PDF or image)",
        "select_placeholder": "Select..."
      },
      "oocyte": {
        "retrieval_date": "Retrieval Date",
        "retrieval_date_placeholder": "Retrieval date",
        "freeze_date": "Freeze Date",
        "freeze_date_placeholder": "Freeze date",
        "freeze_date_optional": "Optional — this may be available on your report.",
        "freezing_method": "Freezing Method",
        "retrieval_counts": "Additional cohort details (optional)",
        "total_retrieved": "How many eggs were retrieved?",
        "mature_mii": "How many eggs were mature (MII)?",
        "immature_mi": "How many eggs were immature (MI)?",
        "degenerated": "How many eggs were degenerated?",
        "cohort_disposition": "What happened to the eggs retrieved in this cycle?",
        "disposition_all_frozen": "All were frozen",
        "disposition_mixed_frozen_fertilized": "Some were frozen, some fertilized",
        "disposition_all_fertilized": "All were fertilized",
        "disposition_unknown": "I don’t know",
        "number_frozen": "How many eggs were frozen?",
        "number_frozen_now": "How many eggs are frozen now?",
        "number_frozen_prefill_hint": "We started with ${count} based on your earlier answers. Change it to match your report.",
        "number_fertilized": "How many eggs were fertilized?",
        "number_fertilized_hint": "You can add the resulting embryos separately and link them to this cycle.",
        "all_fertilized_hint": "There are no frozen eggs to add from this cohort. Add the resulting embryos separately.",
        "all_fertilized_save_hint": "This flow adds frozen eggs, so there is nothing to save here until a frozen egg count is recorded. Add the resulting embryos separately.",
        "i_dont_know": "I don’t know"
      },
      "sperm": {
        "analysis_title": "Some details about the sample",
        "advanced_results": "Advanced results",
        "dna_fragmentation": "DNA Fragmentation",
        "vitality": "Vitality",
        "progressive_motility": "Progressive Motility",
        "other": "Other",
        "other_placeholder": "Add any other sample details...",
        "collection_date": "Collection Date",
        "collection_date_placeholder": "Collection date",
        "freeze_date": "Freeze Date",
        "freeze_date_placeholder": "Freeze date",
        "freeze_date_optional": "Optional — this may be available on your report.",
        "vials_frozen": "How many vials are frozen?",
        "collection_method": "Collection Method",
        "processing_method": "How was the sample prepared?",
        "sample_details": "Collection details",
        "sample_details_hint": "If you remember how long you abstained, you can add it here. Otherwise, skip it.",
        "days_abstinence": "Days of Abstinence",
        "sample_analysis": "Sample analysis",
        "sample_analysis_hint": "If you have a report, add any values you know. You can leave the rest blank.",
        "concentration": "Concentration",
        "total_count": "Total Count",
        "motility": "Motility",
        "morphology": "Normal Morphology",
        "volume": "Volume"
      },
      "embryo": {
        "fertilisation_date": "Fertilisation Date",
        "fertilisation_date_placeholder": "Fertilisation date",
        "freeze_date": "Freeze Date",
        "freeze_date_placeholder": "Freeze date",
        "day_of_development": "Day of Development",
        "date_relationship_hint": "If one date is missing, we estimate it from the other date and the selected development day. You can edit the estimate to match your report.",
        "fertilisation_method": "Fertilisation Method",
        "genetic_testing": "Genetic Testing (PGT)",
        "development_scope_group": "For this embryo group",
        "development_scope_group_hint": "These dates and development details apply to the whole group you defined in the previous step.",
        "entry_mode": "Entry Mode",
        "group_mode": "Group Summary",
        "individual_mode": "Individual Embryos",
        "group_summary": "Group Summary",
        "individual_development_hint": "For each embryo, record the furthest day it reached and whether it was frozen or arrested. The day tiles show the development stage visually.",
        "development_day_reached": "Furthest Day Reached",
        "outcome": "Outcome",
        "total_embryos_created": "Total Embryos Created",
        "number_frozen": "Number Frozen",
        "number_tested": "Embryos Genetically Tested",
        "number_euploid": "Euploid (Normal)",
        "number_aneuploid": "Aneuploid (Abnormal)",
        "number_mosaic": "Mosaic",
        "number_no_result": "No Result / Pending",
        "transferred": "Transferred",
        "discarded": "Discarded",
        "currently_in_storage": "Currently in Storage",
        "override": "override",
        "auto": "auto",
        "embryo_index": "Embryo #${n}",
        "embryo_id": "Embryo ID",
        "embryo_id_placeholder": "e.g. E1",
        "grade": "Grade",
        "grade_placeholder": "Grade",
        "genetic_status": "Genetic Status",
        "genetic_status_placeholder": "Genetic status",
        "sex": "Sex",
        "sex_placeholder": "Sex",
        "status": "Status",
        "notes_placeholder": "Notes for this embryo...",
        "add_embryo": "Add embryo"
      },
      "options": {
        "storage_type": {
          "clinic": "Clinic",
          "hospital": "Hospital",
          "cryobank": "Cryobank",
          "other": "Other"
        },
        "country": {
          "us": "United States",
          "gb": "United Kingdom",
          "ca": "Canada",
          "au": "Australia",
          "de": "Germany",
          "fr": "France",
          "es": "Spain",
          "it": "Italy",
          "cz": "Czech Republic",
          "gr": "Greece",
          "cy": "Cyprus",
          "in": "India",
          "jp": "Japan",
          "mx": "Mexico",
          "il": "Israel",
          "other": "Other"
        },
        "freezing_method": {
          "vitrification": "Vitrification",
          "slow_freeze": "Slow Freeze",
          "unknown": "Unknown"
        },
        "oocyte_status": {
          "in_storage": "In Storage",
          "partially_thawed": "Partially Thawed",
          "all_thawed": "All Thawed",
          "used": "Used",
          "discarded": "Discarded",
          "donated": "Donated"
        },
        "embryo_day": {
          "1": "Day 1",
          "2": "Day 2",
          "3": "Day 3 (Cleavage)",
          "4": "Day 4 (Morula)",
          "5": "Day 5 (Blastocyst)",
          "6": "Day 6 (Blastocyst)",
          "7": "Day 7"
        },
        "embryo_grade": {
          "6AA": "6AA – Excellent",
          "5AA": "5AA – Excellent",
          "4AA": "4AA – Excellent",
          "4AB": "4AB – Very Good",
          "4BA": "4BA – Very Good",
          "4BB": "4BB – Good",
          "3AA": "3AA – Good",
          "3AB": "3AB – Good",
          "3BA": "3BA – Fair",
          "3BB": "3BB – Fair",
          "2BB": "2BB – Fair",
          "other": "Other / Unknown"
        },
        "fertilisation_method": {
          "ivf": "Conventional IVF",
          "icsi": "ICSI",
          "split": "Split IVF/ICSI",
          "unknown": "Unknown"
        },
        "pgt": {
          "not_performed": "Not Performed",
          "pgt_a": "PGT-A (Aneuploidy)",
          "pgt_m": "PGT-M (Monogenic)",
          "pgt_sr": "PGT-SR (Structural)",
          "pgt_a_m": "PGT-A + PGT-M",
          "pgt_p": "PGT-P (Polygenic)",
          "pending": "Pending Results"
        },
        "genetic_status": {
          "euploid": "Euploid (Normal)",
          "aneuploid": "Aneuploid (Abnormal)",
          "mosaic_low": "Low-level Mosaic",
          "mosaic_high": "High-level Mosaic",
          "no_result": "No Result",
          "not_tested": "Not Tested",
          "pending": "Pending"
        },
        "embryo_status": {
          "frozen": "Frozen",
          "arrested": "Arrested / not frozen",
          "transferred": "Transferred",
          "discarded": "Discarded",
          "donated": "Donated",
          "research": "Donated to Research",
          "thawed_refrozen": "Thawed & Refrozen"
        },
        "sex": {
          "unknown": "Unknown",
          "xx": "XX (Female)",
          "xy": "XY (Male)",
          "prefer_not": "Prefer Not to Know"
        },
        "semen_processing": {
          "none": "No additional preparation",
          "washed": "Washed",
          "swim_up": "Swim-up selection",
          "density_gradient": "Density-gradient selection",
          "dgc_swim_up": "Density-gradient + swim-up",
          "microfluidics": "Microfluidic selection",
          "macs": "MACS selection",
          "other": "Other / I don't know"
        },
        "semen_collection": {
          "ejaculation": "Ejaculation",
          "tese": "TESE (testicular extraction)",
          "pesa": "PESA (epididymal aspiration)",
          "mesa": "MESA (microsurgical extraction)",
          "other": "Other"
        }
      }
    }
  },
  "homepage": {
    "shared": {
      "stimulation": "Stimulation",
      "semen_analysis": "Semen analysis",
      "eggs_retrieved": "Eggs retrieved",
      "done": "Done",
      "blastocysts": "Blastocysts",
      "baseline": "Baseline",
      "upload_semen_analysis_results": "Upload semen analysis results",
      "step_n_of_total": "Step ${stepNumber} of ${totalSteps}",
      "step_n_complete": "Step ${stepNumber} complete",
      "sperm_side": "Sperm side",
      "set_cycle_start": "Set cycle start",
      "scheduled_date": "Scheduled: ${date}",
      "results_pending": "Results pending",
      "results_expected_date": "Results expected: ${date}",
      "reduce_avoidable_exposures": "Reduce avoidable exposures",
      "partner": "Partner",
      "often_10_20_eggs": "Often 10-20 eggs",
      "mature_eggs": "Mature eggs",
      "lifestyle_factors": "Lifestyle factors",
      "future_use": "Future use",
      "freezing": "Freezing",
      "cycle_timing": "Cycle timing",
      "cycle_estimate": "Cycle estimate",
      "continue_medical_history": "Continue medical history",
      "checklist_both": "Checklist — both of you",
      "check_semen_testing": "Check semen testing"
    },
    "afc_source_sheet": {
      "title": "Record AFC result",
      "subtitle": "Attach the report or enter the count.",
      "existing_section": "Your AFC results",
      "value_label": "Your AFC value",
      "value_hint": "Total 2–10 mm follicles across both ovaries",
      "date_label": "Test date",
      "notes_label": "Notes (optional)",
      "notes_placeholder": "Anything you'd like to remember about this result...",
      "saving": "Saving…",
      "save_error": "We couldn't save that. Please try again.",
      "remove_afc": "Don't use AFC in this estimate",
      "high_value_warning": "That count is unusually high. Double-check you're counting only 2–10 mm follicles across both ovaries."
    },
    "amh_source_sheet": {
      "title": "Your AMH value",
      "subtitle_with_result": "Using your latest result. Add a newer result to update the estimate.",
      "subtitle_empty": "Add an AMH result to personalize your estimate.",
      "latest_section": "Latest result used",
      "previous_section": "Previous results",
      "add_first_section": "Add your result",
      "add_new_section": "Add a newer result",
      "add_new_action": "Add a newer result",
      "manual_section": "Enter manually",
      "value_label": "Value",
      "unit_label": "Unit",
      "date_label": "Date",
      "save_and_use": "Save and use in my estimate",
      "saving": "Saving…",
      "save_error": "We couldn't save that. Please try again.",
      "remove_amh": "Don't use AMH in this estimate",
      "high_value_warning_ng": "That's an unusually high AMH. Check the unit — 100 pmol/L is about 14 ng/mL.",
      "high_value_warning_pmol": "Values this high are uncommon. Double-check the unit is really pmol/L.",
      "source_line": "Estimate based on La Marca et al., 2011 (age + AMH nomogram). Values above 10 ng/mL are treated as 10 for the estimate."
    },
    "test_result_document": {
      "upload_action": "Upload a test result",
      "upload_description": "Attach a report and extract every result with the document kept as proof."
    },
    "clinic_shortlist_section": {
      "criterion_added": "${label} added",
      "criterion_add": "Add ${label}",
      "unlock_shortlist": "Unlock your clinic shortlist",
      "not_ready_yet": "Clinic shortlist not ready yet"
    },
    "education_block": {
      "how_it_works": "How it works",
      "personalized_for_age": "Personalized for your age",
      "see_personalized_estimate": "See your personalized estimate"
    },
    "emotional_context_card": {
      "youre_not_alone": "You're not alone"
    },
    "enhanced_emotional_card": {
      "physically": "Physically"
    },
    "hero": {
      "open_hero_actions": "Open hero actions"
    },
    "medication_row": {
      "in_transit": "In transit",
      "pickup_ready": "Pickup ready",
      "low_stock": "Low stock",
      "not_on_hand": "Not on hand",
      "ordered": "Ordered"
    },
    "outcome_dot_funnel_rows": {
      "add_stage": "Add ${label}",
      "action_add": "Add",
      "action_edit": "Edit"
    },
    "step_card": {
      "checklist": "Checklist"
    },
    "step_section": {
      "learn": "Learn",
      "continue_cycle": "Continue your cycle"
    },
    "substep_row": {
      "results_will_appear_message": "When your results arrive, they'll appear right here with a personalized interpretation. We'll notify you when they're in.",
      "in_the_meantime": "In the meantime",
      "results_in": "Results in"
    },
    "task_section_card": {
      "collapse_title": "Collapse ${title}",
      "expand_title": "Expand ${title}",
      "mark_title_incomplete": "Mark ${title} incomplete",
      "mark_title_done": "Mark ${title} done",
      "collapse_step": "Collapse ${stepLabel}",
      "expand_step": "Expand ${stepLabel}",
      "mark_step_incomplete": "Mark ${stepLabel} incomplete",
      "mark_step_done": "Mark ${stepLabel} done",
      "mark_as_done": "Mark as done"
    },
    "test_result_insight_card": {
      "waiting_for_results": "Waiting for results",
      "new_result": "New result",
      "scheduled": "Scheduled",
      "scheduled_trimmed": "Scheduled ${trimmed}",
      "purpose_with_expected": "${testPurpose} · result expected ${expectedLabel}"
    },
    "embryo_freezing_clinic_step": {
      "know_what_to_compare": "Know what to compare",
      "know_what_to_compare_detail": "Lab quality, ICSI, PGT-A, update cadence, freezing, storage, and total cost."
    },
    "embryo_freezing_start_cycle": {
      "title": "Starting an embryo freezing cycle?",
      "body": "When your clinic gives you a date, this becomes your treatment home for stimulation, retrieval, sperm collection, fertilization, embryo culture, and freezing updates.",
      "sperm_collection_plan": "Sperm collection plan",
      "fertilization_method": "Fertilization method",
      "lab_update_schedule": "Lab update schedule"
    },
    "optimization_card": {
      "optimization_window": "Optimization Window",
      "window_description": "${cycle}. You have a ${window} window to improve your baseline before ${retest}.",
      "count_items": "${count} items",
      "supplements": "Supplements"
    },
    "optimization_card_v2": {
      "optimize_before_cycle": "Optimize before your cycle",
      "things_to_start_now": "Things you can start now that take time to work",
      "egg_quality_paragraph": "Egg quality is influenced by factors over the 3 months before retrieval, which is how long it takes for eggs to mature. Starting supplements and lifestyle changes now gives them time to take effect before your cycle.",
      "evidence_paragraph": "These won't make or break your outcome, but the evidence supports a meaningful edge for egg quality. Your partner's sperm quality also benefits from the same timeline (~74 days for sperm regeneration).",
      "start_supplements": "Start supplements",
      "supplements_subtitle": "CoQ10 (400-600mg/day) supports mitochondrial function in eggs. Vitamin D, folate, and omega-3 also commonly recommended. Start 2-3 months before your cycle for best effect.",
      "lifestyle_subtitle": "Sleep, moderate exercise, balanced nutrition, and limiting alcohol all support egg quality. No single change is critical. The pattern is what matters.",
      "partner_start_supplements": "Partner: start supplements",
      "partner_supplements_subtitle": "CoQ10, zinc, folate, and vitamin D support sperm quality. Avoid heat exposure (hot tubs, saunas, laptops on lap), limit alcohol, and stay active.",
      "track_progress": "Track your progress",
      "track_progress_subtitle": "Get a baseline AMH now and retest in 2-3 months to see if your protocol is working.",
      "guided_program": "Guided program",
      "guided_program_subtitle": "We'll send you the tests and the supplements, and track your day-by-day progress toward your retrieval target.",
      "coming_soon": "Coming soon"
    },
    "medical_history_step": {
      "title": "Medical History",
      "level_health_champion": "Health Champion",
      "level_wellness_pro": "Wellness Pro",
      "level_health_explorer": "Health Explorer",
      "level_getting_started": "Getting Started",
      "level_newcomer": "Newcomer",
      "level_xp": "${title} · ${xp} XP",
      "loading": "Loading...",
      "all_sections_complete": "All sections complete!",
      "complete_history_unlocks": "A complete history unlocks",
      "unlock_treatment_personalisation": "treatment personalisation",
      "unlock_medication_safety": "medication safety checks",
      "unlock_risk_screening": "risk-factor screening",
      "unlock_clinic_summaries": "clinic-ready summaries",
      "and_more": "and more.",
      "continue": "Continue"
    },
    "pre_cycle_hero_card": {
      "your_plan": "Your plan",
      "edit_plan": "Edit plan",
      "complete_setup": "Complete your setup to personalize this plan",
      "keep_shaping_plan": "Keep shaping your plan before treatment starts",
      "start_with_history": "Start with medical history so your prep, care options, and cycle timing can adjust to you.",
      "active_step_summary": "${activeStepTitle} is the next step. ${subtitle}",
      "fallback_subtitle": "Use this to keep your plan moving.",
      "your_path": "Your path",
      "steps_complete": "${completedSteps} out of ${totalSteps} steps complete",
      "steps_complete_one": "${completedSteps} out of ${totalSteps} steps complete",
      "plan_not_set": "Plan not set"
    },
    "pre_cycle_egg_freezing": {
      "eyebrow": "Egg freezing planning",
      "title": "Explore egg freezing and shape your plan",
      "cycle_start_label": "Not scheduled yet",
      "phase_description": "Before you choose a clinic or start stimulation, this home helps you understand the process, collect useful baseline information, compare options, and decide what needs to happen next. Once a cycle is scheduled, it can switch into your active treatment view.",
      "intro": "In only a few minutes, we'll take you through what you need to know and what you can do next.",
      "open_plan_a11y": "Open egg freezing prep plan",
      "toggle_plan_a11y": "Toggle your egg freezing prep plan",
      "next": "Next",
      "choose_next_step": "Choose your next step",
      "treatment_cycle": "Treatment cycle",
      "no_treatment_scheduled": "No treatment scheduled",
      "add_treatment_dates": "Add treatment dates"
    },
    "pre_cycle_embryo_freezing": {
      "eyebrow": "Embryo freezing planning",
      "title": "Prepare for embryo freezing",
      "cycle_start_label": "Not scheduled yet",
      "phase_description": "Before a cycle starts, embryo freezing means coordinating ovarian stimulation, sperm source or sperm testing, fertilization method, embryo culture, possible PGT-A, and lab fit. This home helps you understand what matters before it becomes active treatment.",
      "intro": "In a few minutes, we'll walk through what you need to understand, test, optimize, and compare before starting.",
      "open_plan_a11y": "Open embryo freezing prep plan",
      "toggle_plan_a11y": "Toggle your embryo freezing prep plan"
    },
    "pre_cycle_sperm_freezing": {
      "eyebrow": "Sperm freezing planning",
      "title": "Plan sperm freezing without guessing",
      "cycle_start_label": "Not scheduled yet",
      "phase_description": "Before you bank samples, this home helps you understand semen analysis, collection timing, storage, whether to bank now, and whether a 90-day optimization window is worth doing first.",
      "intro": "In a few minutes, we will walk through what to test, what can change, and how to move toward banking.",
      "open_plan_a11y": "Open sperm freezing prep plan",
      "toggle_plan_a11y": "Toggle your sperm freezing prep plan",
      "reset_window": "Reset window",
      "reset_window_value": "72-90 day reset window"
    },
    "treatment_phase": {
      "baseline": "Baseline",
      "stimulation": "Stimulation",
      "trigger": "Trigger Shot",
      "retrieval": "Egg Retrieval",
      "fertilization": "Fertilization",
      "embryo_development": "Embryo Development",
      "transfer": "Embryo Transfer",
      "waiting": "Two-Week Wait",
      "complete": "Cycle Complete",
      "day_of_total": "Day ${dayInPhase} of ~${totalPhaseDays}",
      "day_only": "Day ${dayInPhase}",
      "guidance_stim_1_3": "Low response is normal in the first few days. Your follicles are just starting to respond.",
      "guidance_stim_4_7": "Follicles are growing. You may start feeling bloating and pressure.",
      "guidance_stim_8_10": "Most growth happens now. Frequent monitoring visits. Follicles should be in the 14-18mm range.",
      "guidance_stim_10_14": "Approaching trigger. Largest follicles should be 17-20mm.",
      "guidance_wait_1_3": "The embryo is hatching and beginning to attach.",
      "guidance_wait_4_7": "Implantation is happening. Cramping and spotting are normal.",
      "guidance_wait_8_14": "hCG levels are rising if implantation was successful. The blood test will give you a definitive answer."
    },
    "sperm_freezing_baseline": {
      "step_label": "Step 2: Know your baseline",
      "what_to_test": "What you can test",
      "what_to_test_subtitle": "Start with semen analysis, then go deeper only when the result or history makes it useful.",
      "upload_subtitle": "Keep baseline and repeat results in one place so the plan can compare changes.",
      "core_test": "Core test",
      "semen_analysis_body": "Measures volume, concentration, total count, motility, morphology, and sometimes round cells or viscosity. This is the baseline for freezing decisions.",
      "check_testing": "Check testing",
      "often_required": "Often required",
      "infectious_disease_title": "Infectious disease screening",
      "infectious_disease_body": "Labs may require HIV, hepatitis B, hepatitis C, syphilis, and other screening before or around storage, especially if samples may be used later in treatment.",
      "sometimes_useful": "Sometimes useful",
      "dna_fragmentation_title": "DNA fragmentation",
      "dna_fragmentation_body": "This can be discussed when there are abnormal semen results, recurrent pregnancy loss, repeated IVF issues, age-related concerns, or significant exposures.",
      "if_abnormal": "If abnormal",
      "hormones_urology_title": "Hormones and urology review",
      "hormones_urology_body": "If count is low or symptoms suggest a hormone issue, a clinician may check testosterone, FSH, LH, prolactin, estradiol, thyroid, or refer to reproductive urology."
    },
    "sperm_freezing_start": {
      "title": "Ready to bank samples?",
      "body": "When you're ready, set a starting date to begin your banking view for collection timing, sample reports, vials, and storage. You can add a lab or clinic when you have one.",
      "set_banking_start": "Set banking start",
      "collection_timing": "Collection timing",
      "abstinence_window": "Abstinence window",
      "sample_reports": "Sample reports",
      "storage_plan": "Storage plan"
    },
    "sperm_freezing_understand": {
      "step_label": "Step 1: Understand",
      "how_it_works_title": "How sperm freezing works",
      "how_it_works_subtitle": "Sperm production, semen analysis, freezing, vials, storage, and future use.",
      "what_matters_here_label": "What matters here",
      "turnover_label": "Sperm turnover",
      "continuous_title": "Sperm is made continuously",
      "continuous_body": "New sperm develops over roughly 72-90 days. That means recent heat, illness, medications, hormones, smoking, cannabis, alcohol, sleep, and metabolic health can show up in the sample.",
      "continuous_callout": "This is why many people bank a baseline sample now, then optimize and retest later if they have time.",
      "semen_analysis_title": "A semen analysis explains the starting point",
      "semen_analysis_body": "The main numbers are volume, concentration, total count, motility, and morphology. These help decide how many samples to bank and what future use may be realistic.",
      "semen_analysis_callout": "A normal result does not guarantee future fertility; it gives a useful snapshot.",
      "collection_label": "Collection",
      "collection_title": "Collection timing affects the sample",
      "collection_body": "Most labs ask for 2-5 days of abstinence before collection. Longer is not automatically better because older sperm can have lower motility or more DNA damage.",
      "collection_callout": "Many people bank 2-3 samples, often spaced a few days apart, to create redundancy.",
      "freezing_title": "The sample is divided into frozen vials",
      "freezing_body": "The lab analyzes the sample, adds cryoprotectant, divides it into vials, and stores it in liquid nitrogen at about -196 C.",
      "freezing_callout": "Some motility loss after thaw is expected, so pre-freeze numbers and vial count both matter.",
      "future_use_title": "Vials map to different future procedures",
      "future_use_body": "IUI usually needs more motile sperm per attempt. IVF with ICSI can often use fewer sperm, but still depends on lab policy, sample quality, and future plans.",
      "future_use_callout": "The goal is not just freezing one sample. It is banking enough usable material for the future path you may choose.",
      "storage_label": "Storage",
      "storage_title": "Storage is an ongoing decision",
      "storage_body": "You will usually have annual storage fees, consent renewals, and future choices about keeping, shipping, donating, or discarding samples.",
      "storage_callout": "A good lab should make storage terms, transfer rules, and future access clear before you bank."
    },
    "egg_freezing_clinic_timeline": {
      "see_clinic_matches": "See clinic matches",
      "complete_medical_history": "Complete medical history",
      "check_coverage_status": "Check coverage status",
      "add_location": "Add location",
      "explore_concierge": "Explore concierge matching",
      "concierge_program": "Concierge matching program",
      "concierge_subtitle": "Get help coordinating testing, doctor fit, clinic access, and savings options before you commit.",
      "testing": "Testing",
      "doctors": "Doctors",
      "savings": "Savings",
      "history": "History",
      "history_added": "History added",
      "complete_history": "Complete history",
      "location": "Location",
      "location_added": "Location added",
      "coverage_status": "Coverage status",
      "coverage_checked": "Coverage checked",
      "check_coverage": "Check coverage",
      "step_4_find_care": "Step 4: Find care",
      "step_3_choose_clinic": "Step 3: Choose your clinic",
      "find_care": "Find care",
      "find_care_sperm": "Search labs, clinics, and sperm banks for semen analysis, cryopreservation, and storage.",
      "find_care_embryo": "Search clinics, embryology labs, and providers for embryo freezing.",
      "find_care_egg": "Search clinics, labs, and providers for egg freezing.",
      "labs_selected": "Labs selected for you",
      "clinics_selected": "Clinics selected for you",
      "shortlist_sperm": "A shortlist based on your location, coverage status, testing needs, collection preferences, and storage fit.",
      "shortlist_embryo": "A shortlist based on your location, coverage status, embryo lab needs, and what matters for this cycle.",
      "shortlist_egg": "A shortlist based on your location, coverage status, and what matters for this cycle.",
      "locked_sperm": "We use your health history, location, coverage status, and sample-banking preferences to make matches relevant. Coverage status can mean benefits or self-pay.",
      "locked_embryo": "We use your health history, location, coverage status, and embryo-freezing preferences to make matches relevant. Coverage status can mean benefits or self-pay.",
      "locked_egg": "We use your health history, location, and coverage status to make matches relevant. Coverage status can mean benefits or self-pay.",
      "empty_sperm": "Your requirements are ready, but lab match data is not connected here yet. You can still search the Find Care directory.",
      "empty_clinic": "Your requirements are ready, but clinic match data is not connected here yet. You can still search the Find Care directory."
    },
    "egg_freezing_cycle_start": {
      "starting_soon": "Starting soon?",
      "body": "When your clinic gives you a date, this becomes your treatment home for the days ahead.",
      "medication_schedule": "Medication schedule",
      "monitoring_plan": "Monitoring plan",
      "daily_guidance": "Daily guidance"
    },
    "cycle_complete": {
      "your_results": "Your results",
      "positive": "Positive",
      "positive_message": "Congratulations. Take a breath. Your clinic will monitor rising hCG levels over the next few weeks.",
      "negative_message": "This cycle did not result in pregnancy. We're sorry. A failed cycle provides your clinic with valuable information about how your body responds — it's not starting over, it's building on data.",
      "maturity_rate": "${maturityRate}% maturity rate",
      "fertilized": "Fertilized",
      "frozen": "Frozen",
      "what_numbers_mean": "What these numbers mean",
      "eggs": "eggs",
      "embryos": "embryos",
      "samples": "samples",
      "cryo_storage": "Cryo storage",
      "count_type_at_facility": "${itemCount} ${typeLabel} at ${facilityName}",
      "count_type": "${itemCount} ${typeLabel}",
      "storage_with_payment": "Storage: ${annualCost}/year • Next payment: ${nextPaymentDate}",
      "storage_only": "Storage: ${annualCost}/year",
      "view_cryo_vault_details": "View cryo vault details",
      "mature_eggs_matter": "Mature eggs matter most",
      "mature_eggs_matter_body": "Only mature MII eggs are usually vitrified. The mature count can be lower than the retrieval count.",
      "storage_ongoing": "Storage is ongoing",
      "storage_ongoing_body": "Most facilities bill annually. Storage fees are often separate from the cycle cost.",
      "decide_later": "You can decide later",
      "decide_later_body": "Some people store and wait. Others consider another cycle if their goal needs more eggs banked.",
      "open_cryo_vault": "Open your cryo vault",
      "open_cryo_vault_subtitle": "Track frozen eggs, storage details, and future use.",
      "view_cryo_vault": "View cryo vault",
      "add_documents": "Add retrieval or storage documents",
      "add_documents_subtitle": "Upload lab reports, storage agreements, or bills.",
      "upload_documents": "Upload storage documents",
      "consider_another": "Consider another cycle",
      "consider_another_subtitle": "Use your results to decide whether banking more eggs makes sense.",
      "start_another": "Start another cycle",
      "after_retrieval": "After retrieval",
      "frozen_eggs_decisions": "Frozen eggs and next decisions",
      "cycle_is_complete": "Your Cycle is Complete",
      "whats_next": "What's next?",
      "emotional_message": "Whatever you're feeling right now — relief, exhaustion, pride, uncertainty — it's all valid. You've done something meaningful for your future self.",
      "annual_reminders": "Annual reminders",
      "storage_payment_reminder": "Storage payment reminder",
      "annual_wellness_check": "Annual wellness check",
      "review_fertility_plan": "Review your fertility plan"
    },
    "outcome_funnel": {
      "family_outlook": "Family-building outlook",
      "cycle_estimate": "${cycleType} estimate",
      "intro": "This planning view starts with your latest treatment data, then narrows through the egg freezing and future-use funnel. These numbers update as monitoring, retrieval, lab, and genetic testing results come in. Adjust any step to see the downstream funnel update.",
      "planning_targets": "Planning targets",
      "one_child": "1 child",
      "one_child_value": "Often starts around 10-20 mature frozen eggs",
      "two_children": "2 children",
      "two_children_value": "Often starts around 20-35 mature frozen eggs",
      "three_children": "3 children",
      "three_children_value": "Often starts around 35-50+ mature frozen eggs",
      "disclaimer": "Estimates are planning ranges, not guarantees. Your clinic can adjust them for age, diagnosis, lab history, and treatment response.",
      "eggs_retrieved_detail": "Projected from current follicle response",
      "mature_eggs_detail": "Estimated MII eggs",
      "frozen_eggs_label": "Frozen eggs",
      "frozen_eggs_detail": "Estimated usable frozen eggs",
      "fertilized_eggs_label": "Fertilized eggs",
      "fertilized_eggs_detail": "Future thaw + fertilization projection",
      "euploids_label": "Euploids",
      "euploids_detail": "Future embryo + testing projection",
      "live_births_label": "Live births",
      "live_births_detail": "Future family-building projection"
    },
    "partner_home": {
      "your_partner": "your partner",
      "shared_summary_unavailable_title": "Shared journey details aren't available yet",
      "shared_summary_unavailable_body": "Your partner's journey will appear here once an authorized shared summary is available. Private clinical details stay private.",
      "partner_tasks_unavailable_body": "Partner tasks will appear here once the server assigns an owner and confirms permission to act.",
      "how_to_support": "How to support ${primaryName}",
      "primary_journey": "${primaryName}'s ${journeyTitle} journey",
      "your_tasks": "Your tasks",
      "count_remaining": "${count} remaining",
      "all_done": "All done!",
      "completed_count": "Completed (${count})",
      "what_experiencing": "What they're experiencing",
      "how_feeling": "How they might be feeling",
      "how_you_help": "How you can help",
      "test_physical": "${primaryName} is going through baseline testing. Some tests require specific cycle timing, which can add stress.",
      "test_emotional": "Waiting for results can be anxiety-inducing. Being available to listen without trying to fix things is the best support.",
      "test_help_1": "Offer to drive to appointments",
      "test_help_2": "Ask if they want to talk about results or just sit with them",
      "test_help_3": "Complete your own testing promptly — it shows you're equally invested",
      "prep_physical": "${primaryName} is preparing for the cycle — paperwork, supplements, and logistics.",
      "prep_emotional": "The anticipation before treatment can be exciting and terrifying at the same time.",
      "prep_help_1": "Help with insurance calls and paperwork",
      "prep_help_2": "Learn about the medications and injection process",
      "prep_help_3": "Plan logistics for monitoring visits and retrieval day",
      "treatment_physical": "${primaryName} is on daily injections that cause bloating, mood swings, and fatigue. This is normal — it means the medications are working.",
      "treatment_emotional": "The physical discomfort combined with emotional stakes can be overwhelming. Patience and presence matter more than words.",
      "treatment_help_1": "Help with injection prep and timing reminders",
      "treatment_help_2": "Take over household tasks — they may be physically uncomfortable",
      "treatment_help_3": "Attend monitoring appointments when possible",
      "treatment_help_4": "On retrieval day: drive them home, have comfort items ready",
      "wait_physical": "${primaryName} is in the two-week wait after embryo transfer. They're on progesterone, which causes symptoms identical to early pregnancy symptoms.",
      "wait_emotional": "This is the hardest emotional period. Every symptom feels meaningful. Resist the urge to be overly optimistic or dismissive.",
      "wait_help_1": "Don't ask 'do you feel pregnant?' — they can't tell and neither can you",
      "wait_help_2": "Keep life normal — routine is stabilizing",
      "wait_help_3": "Be present without making it the only topic of conversation",
      "wait_help_4": "Have a plan for both outcomes — know what to say either way"
    },
    "fet_participant_view": {
      "shared_plan_title": "Your FET participation view",
      "shared_plan_body": "This summary shows only tasks and consent status your active permissions allow. Private clinical and genetic details stay protected.",
      "role_summary": "Your role: ${role}",
      "plan_status": "Plan status: ${status}",
      "tasks_section": "Tasks assigned to you",
      "no_assigned_tasks": "No FET tasks are assigned to you yet.",
      "consent_section": "Consent status",
      "consent_status": "Status: ${status}",
      "role_recipient": "recipient",
      "role_partner": "partner",
      "role_intended_parent": "intended parent",
      "role_gestational_carrier": "gestational carrier",
      "role_donor": "donor",
      "role_genetic_source": "genetic source",
      "role_care_coordinator": "care coordinator",
      "role_custodian": "custodian",
      "role_not_reported": "not reported",
      "task_medications": "Recipient medication task",
      "task_monitoring": "Recipient monitoring task",
      "task_transfer_acknowledgement": "Transfer acknowledgement",
      "task_beta_collection": "Beta collection",
      "task_recipient_consent": "Recipient consent",
      "task_embryo_authorization": "Embryo authorization",
      "task_backup_decision": "Backup embryo decision",
      "task_clinic_coordination": "Clinic coordination",
      "task_transport_coordination": "Transport coordination",
      "task_storage_chain_of_custody": "Storage chain of custody",
      "task_result_review": "Result review"
    },
    "embryo_freezing_optimization": {
      "step_label": "Step 3: Improve inputs",
      "what_can_be_optimized": "What can be optimized",
      "what_can_be_optimized_subtitle": "If sperm is part of the plan, start there: the roughly 72-day sperm window is usually the highest-agency optimization lane.",
      "start_personalized_title": "Start a personalized optimization plan",
      "start_personalized_subtitle": "Review testing, supplements, exposures, and timing based on both sides of the plan.",
      "start_plan": "Start optimization plan",
      "sperm_title": "Highest-agency window: sperm",
      "sperm_body": "When sperm is part of the plan, this is often the clearest optimization lane because sperm develops over roughly a 72-day window.",
      "sperm_bullet_1": "Start with semen analysis so the plan is not guessing",
      "sperm_bullet_2": "Review heat, fever, smoking, alcohol, cannabis, medications, anabolic hormones, and supplements",
      "sperm_bullet_3": "Decide if repeat testing, urology, backup freezing, or ICSI planning is useful",
      "start_sperm_plan": "Start sperm plan",
      "egg_side": "Egg side",
      "egg_title": "Support the ovarian side",
      "egg_body": "Egg age cannot be reversed, but the cycle can still be planned around reserve, response, safety, and avoidable risks before retrieval.",
      "egg_bullet_1": "Use AMH, AFC, history, and prior response to plan timing",
      "egg_bullet_2": "Review medications, supplements, smoking, alcohol, cannabis, and exposures",
      "egg_bullet_3": "Address sleep, metabolic context, thyroid, vitamin D, or clear deficiencies when relevant",
      "check_reserve": "Check ovarian reserve"
    },
    "sperm_freezing_reset": {
      "step_label": "Step 3: Improve sperm inputs",
      "protocol_title": "90-day sperm reset program",
      "protocol_subtitle": "Baseline testing, exposure review, health basics, supplement evidence, and a repeat test.",
      "bank_or_reset": "Bank now or reset first?",
      "bank_or_reset_subtitle": "If timing is urgent, bank now. If it is elective and you have time, compare baseline results with a 90-day retest.",
      "start_program": "Start sperm reset program",
      "step_1": "Step 1",
      "step_2": "Step 2",
      "step_3": "Step 3",
      "step_4": "Step 4",
      "step_5": "Step 5",
      "bank_baseline_title": "Bank or test a baseline first",
      "bank_baseline_body": "If timing matters, bank now. If you have time, get a baseline semen analysis so the optimization plan is based on real numbers.",
      "bank_baseline_callout": "For cancer treatment, gender-affirming hormones, vasectomy planning, or urgent treatment, do not wait for a perfect optimization window.",
      "order_baseline_test": "Order baseline test",
      "avoid_exposures_body": "Heat, fever, smoking, vaping, cannabis, heavy alcohol, anabolic steroids, testosterone, some medications, and toxins can affect sperm production or DNA integrity.",
      "avoid_exposures_callout": "Do not stop prescribed medication or hormones without your clinician. The point is to identify what is modifiable.",
      "health_basics_title": "Fix obvious health levers",
      "health_basics_body": "Sleep, exercise, metabolic health, varicocele evaluation, infection/inflammation, and nutrient deficiencies can matter more than a generic supplement stack.",
      "start_sperm_plan": "Start sperm plan",
      "supplements_title": "Use supplements by evidence level",
      "supplements_body": "CoQ10, zinc, folate, omega-3, vitamin C/E, L-carnitine, and vitamin D are commonly discussed, but usefulness depends on baseline diet, deficiency, and semen pattern.",
      "supplements_callout": "This should be a review, not a shopping list. More supplements is not automatically better.",
      "review_supplements": "Review supplements",
      "retest_title": "Retest around 90 days",
      "retest_body": "Because new sperm takes about 72-90 days to develop, a repeat semen analysis after the reset window is the clearest way to see whether anything changed.",
      "retest_callout": "If improved, you can bank additional optimized samples while keeping the earlier baseline as backup."
    },
    "sperm_analysis_skeleton": {
      "volume_label": "Volume",
      "volume_unit": "ml",
      "volume_description": "How much fluid is in one sample. Affects how many vials it can be split into.",
      "concentration_label": "Concentration",
      "concentration_unit": "M/mL",
      "concentration_description": "Sperm count per milliliter. A core driver of how usable a frozen sample will be.",
      "progressive_motility_label": "Progressive motility",
      "progressive_motility_unit": "%",
      "progressive_motility_description": "Share of sperm swimming forward. Some loss after thaw is expected, so this matters at freeze.",
      "normal_morphology_label": "Normal morphology",
      "normal_morphology_unit": "%",
      "normal_morphology_description": "Share of normally shaped sperm. Helps set expectations for IUI versus IVF with ICSI.",
      "dna_fragmentation_label": "DNA fragmentation",
      "dna_fragmentation_unit": "% DFI",
      "dna_fragmentation_description": "Percent of sperm with broken DNA. Higher levels are linked to lower fertilization and higher miscarriage risk.",
      "methylation_label": "Sperm epigenetics (methylation)",
      "methylation_unit": "score",
      "methylation_description": "Chemical tags on sperm DNA that shift with age and exposures. Used to estimate sperm aging beyond a standard count.",
      "oxidative_stress_label": "Oxidative stress (ROS)",
      "oxidative_stress_unit": "level",
      "oxidative_stress_description": "Reactive oxygen species that damage sperm membranes and DNA. Often improvable with targeted changes before banking.",
      "vitality_label": "Vitality",
      "vitality_unit": "%",
      "vitality_description": "Share of live sperm. Separates truly immotile sperm from dead ones when motility is very low.",
      "aneuploidy_label": "Chromosomal screening",
      "aneuploidy_unit": "result",
      "aneuploidy_description": "Checks for extra or missing chromosomes. Considered with recurrent loss or repeated failed cycles.",
      "anatomy_acrosome": "Acrosome",
      "anatomy_head": "Head",
      "anatomy_neck": "Neck",
      "anatomy_tail": "Tail",
      "anatomy_motility": "Motility",
      "tab_basic": "Basic",
      "tab_advanced": "Advanced",
      "your_sperm_analysis": "Your sperm analysis",
      "what_is_going_on": "What's going on with your swimmers",
      "advanced_intro": "Deeper tests, usually added when results or history make them useful. Each one tells you something a standard count cannot.",
      "cta_explore_advanced": "Explore advanced sperm testing",
      "cta_get_analysis": "Get a semen analysis"
    },
    "egg_freezing_know_your_numbers": {
      "step_label": "Step 2: Know your numbers",
      "estimate_none_value": "Needs age + AMH + AFC",
      "estimate_none_body": "Age gives a rough starting range. AMH, AFC, and medical history make it useful.",
      "estimate_8_14": "Often 8-14 eggs",
      "estimate_5_10": "Often 5-10 eggs",
      "estimate_clinic_specific": "Clinic-specific",
      "estimate_full_value": "Often ${low}-${high} eggs",
      "estimate_full_body": "Personalized to your age, AMH, AFC, and FSH. Actual response still varies with protocol and cycle.",
      "estimate_amh_afc_value": "Often ${low}-${high} eggs",
      "estimate_amh_afc_body": "Based on your age, AMH, and AFC. FSH or a clinic evaluation can refine it further.",
      "estimate_amh_value": "Often ${low}-${high} eggs",
      "estimate_amh_body": "Based on your age and AMH (${reserve}). Adding AFC and FSH can refine this further.",
      "estimate_under_35_body": "This is a rough age-based range. Your AMH, AFC, and history can shift it a lot.",
      "estimate_35_37_body": "Many people still respond well, but AMH and AFC become more important for planning.",
      "estimate_37_40_body": "Clinics often discuss whether one or more cycles makes sense based on your numbers.",
      "estimate_over_40_body": "After 40, yield and egg quality vary more. A clinic should personalize this with your testing.",
      "history_title": "Complete medical history",
      "history_body": "This is the data layer for your estimate: diagnoses, meds, surgeries, allergies, periods, prior cycles, and risk factors.",
      "history_timing": "Required for personalization",
      "history_action": "Continue history",
      "amh_title": "AMH blood test",
      "amh_body": "AMH helps estimate ovarian reserve and expected response. It can usually be drawn any day of the cycle.",
      "amh_timing": "Blood test · any day",
      "amh_order_short": "Order AMH",
      "amh_order_long": "Order at-home AMH test",
      "find_lab_short": "Find lab",
      "find_lab_long": "Find a lab",
      "afc_title": "AFC ultrasound",
      "afc_body": "Antral follicle count is a transvaginal ultrasound that counts small resting follicles. AMH + AFC usually gives the clearest estimate.",
      "afc_timing": "Ultrasound · often cycle day 2-5",
      "find_clinic_short": "Find clinic",
      "find_clinic_long": "Find a clinic or mobile ultrasound",
      "upload_result_short": "Upload result",
      "upload_afc_long": "Upload AFC result",
      "hormones_title": "Day 2-3 hormones",
      "hormones_body": "FSH and estradiol help interpret ovarian reserve. Clinics may add LH, progesterone, TSH, prolactin, vitamin D, or infectious disease labs.",
      "hormones_timing": "Some labs must be timed",
      "add_results_short": "Add results",
      "add_results_long": "Add test results",
      "semen_body": "Count, motility, morphology, and volume help the lab decide whether conventional fertilization or ICSI may be recommended.",
      "semen_timing": "Partner, donor, lab, or at-home collection",
      "check_options_short": "Check options",
      "check_options_long": "Check semen analysis options",
      "upload_semen_long": "Upload semen analysis",
      "core_title": "Core estimate",
      "core_body": "Medical history, AMH, and AFC answer the main question: how your ovaries may respond in one egg-freezing cycle.",
      "core_action": "Start AMH",
      "optional_label": "Optional",
      "bloodwork_title": "Complete health panel",
      "bloodwork_body": "A 150+ biomarker panel can check vitamins, thyroid, metabolic health, inflammation, hormones, and other context for optimization.",
      "see_panels_short": "See panels",
      "see_panels_long": "See testing panels",
      "genetics_title": "Genetics",
      "genetics_body": "Carrier screening checks inherited-condition risk for future children. Whole genome is broader at-home DNA sequencing with more health context and more uncertainty.",
      "compare_options_short": "Compare options",
      "compare_options_long": "Compare genetic testing options",
      "add_partner_title": "Add partner or sperm source",
      "add_partner_subtitle": "Invite a partner or note whose sperm source should be included in the plan.",
      "what_you_can_test": "What you can test",
      "what_you_can_test_embryo": "Start with the ovarian side, add the sperm side, then decide whether genetics or broader panels are useful.",
      "what_you_can_test_egg": "A few options can make your estimate more useful. You can start simple or go deeper.",
      "eyebrow_ovarian_reserve": "Ovarian reserve",
      "eyebrow_ultrasound": "Ultrasound",
      "eyebrow_hormones": "Hormones",
      "expand_baseline": "Expand baseline tests",
      "collapse_baseline": "Collapse baseline tests",
      "get_baseline_tests": "Get baseline tests",
      "count_of_4": "${completedCount} of 4",
      "decide_testing_title": "Decide how much testing you want right now",
      "decide_testing_body": "Start with what predicts cycle response. Add broader bloodwork or genetics only if you want more health context before treatment.",
      "testing_levels": "Testing levels",
      "baseline_first_title": "Baseline first. Deeper testing is optional.",
      "baseline_first_body": "The baseline path answers the egg-freezing estimate question. Full blood panels and genetics answer broader health or future family-building questions.",
      "recent_results_note": "If you already have recent AMH, AFC, or hormone results, upload them here. A clinic may repeat baseline testing before treatment, but recent results can still help you understand your likely response now.",
      "turn_estimate_title": "Turn a rough estimate into a real plan",
      "turn_estimate_body": "The most useful next step is making your history complete, then adding the ovarian reserve numbers that shape egg-freezing planning.",
      "personalized_estimate": "Personalized estimate",
      "history_progress_title": "Medical history ${progressPercent}% complete",
      "history_progress_body": "This has to stay visible until it is complete because medications, surgeries, allergies, cycles, and diagnoses change what a clinic needs to know.",
      "core_numbers_base": "Core fertility numbers",
      "core_numbers_with_percent": "Core fertility numbers ${percent}% added",
      "core_numbers_body": "AMH and antral follicle count are the two numbers that most improve an egg-freezing estimate before you pick a protocol.",
      "optional_broader_title": "Optional broader blood panel",
      "optional_broader_body": "FSH, estradiol, LH, progesterone, TSH, prolactin, vitamin D, and similar labs can add context, but they are not all required just to explore.",
      "clinic_baseline_title": "Clinic baseline testing can happen later",
      "clinic_baseline_body": "Most clinics repeat baseline labs and ultrasound before treatment. Doing everything through the clinic can be easier, but sometimes costs more.",
      "review_history": "Review medical history",
      "complete_history": "Complete medical history",
      "history_complete_note": "Your history is complete. Reopen this if you want to add or review fertility testing."
    },
    "embryo_freezing_understand": {
      "step_label": "Step 1: Understand",
      "how_it_works_title": "How embryo freezing works",
      "how_it_works_subtitle": "Start with the three moving parts, then swipe through the full biology and lab sequence.",
      "how_many_embryos_title": "How many embryos might this become?",
      "how_many_embryos_subtitle": "Estimate egg yield, embryo attrition, and how many cycles may be needed.",
      "eggs_vs_embryos_title": "Freezing eggs versus freezing embryos",
      "eggs_vs_embryos_subtitle": "Compare flexibility, information gained, partner/legal implications, and future use.",
      "egg_quantity_label": "Egg quantity",
      "egg_supply_title": "The ovarian side still starts with egg supply",
      "egg_supply_body": "Embryo freezing usually starts with stimulation and retrieval, so age, AMH, AFC, and prior response still shape the likely egg count.",
      "egg_supply_callout_label": "Why it matters",
      "egg_supply_callout": "The embryo funnel starts with eggs. Fewer retrieved or mature eggs usually means fewer chances for embryos later.",
      "test_ovarian_reserve": "Test ovarian reserve",
      "egg_supply_detail_title": "Egg supply before embryo freezing",
      "egg_supply_section_1_title": "Embryos start with eggs",
      "egg_supply_section_1_body": "Even when the goal is embryos, the first biological constraint is often how many follicles respond and how many mature eggs are retrieved.",
      "egg_supply_section_2_title": "What testing can add",
      "egg_supply_section_2_body": "AMH, AFC, day 2-3 hormones, age, diagnosis, and prior cycle response help estimate likely yield and stimulation approach.",
      "normal_cycle_label": "Normal cycle",
      "normal_cycle_title": "Usually one egg ovulates in a month",
      "normal_cycle_body": "Each cycle, a small group of follicles starts growing. Usually one follicle becomes dominant and the others stop.",
      "why_stimulation_exists": "Why stimulation exists",
      "normal_cycle_callout": "Embryo freezing tries to mature more of that same cycle's group so more eggs can enter the lab.",
      "normal_cycle_detail_title": "Normal cycle versus stimulation cycle",
      "normal_cycle_section_1_title": "A small group starts together",
      "normal_cycle_section_1_body": "A cohort of follicles starts responding during a cycle. In a typical menstrual cycle, one usually becomes dominant and ovulates.",
      "normal_cycle_section_2_title": "Stimulation changes the outcome",
      "normal_cycle_section_2_body": "Stimulation does not make new eggs. It tries to keep more of the recruited follicles growing long enough to retrieve eggs from them.",
      "ovaries_follicles_label": "Ovaries & follicles",
      "follicles_title": "Eggs are inside follicles, and follicles are inside ovaries",
      "follicles_body": "Your clinic can measure follicles on ultrasound, but the egg inside each follicle is microscopic and checked only after retrieval.",
      "key_distinction_label": "Key distinction",
      "follicles_callout": "A follicle count is not the same as retrieved eggs, mature eggs, or embryos.",
      "follicles_detail_title": "Follicles, eggs, and ovaries",
      "follicles_section_1_title": "What the clinic can see",
      "follicles_section_1_body": "Ultrasound shows follicles and their size. The egg itself is too small to see directly, so the final egg count comes from the embryology lab.",
      "follicles_section_2_title": "Why numbers change",
      "follicles_section_2_body": "You may hear follicle count, retrieved egg count, mature egg count, fertilized egg count, and embryo count. Each one is a different checkpoint.",
      "stimulation_title": "Medication tries to mature more follicles at once",
      "stimulation_body": "Daily stimulation meds usually run about 10-14 days and aim to keep several follicles growing instead of just one.",
      "reserve_note_label": "Reserve note",
      "stimulation_callout": "This uses follicles already recruited in that cycle; it is not taking eggs your body was saving for future months.",
      "stimulation_detail_title": "Why stimulation is used",
      "stimulation_section_1_title": "The cycle cohort",
      "stimulation_section_1_body": "Each month, a group of follicles starts responding. Stimulation tries to keep more of that group growing long enough to retrieve eggs.",
      "stimulation_section_2_title": "Dose is personalized",
      "stimulation_section_2_body": "Age, AMH, AFC, weight, diagnosis, and prior response can change the starting dose and monitoring plan.",
      "monitoring_label": "Monitoring",
      "monitoring_title": "Monitoring decides when trigger and retrieval happen",
      "monitoring_body": "Visits often happen every 2-3 days. Ultrasound tracks follicle size and bloodwork helps time the trigger shot.",
      "procedure_note_label": "Procedure note",
      "monitoring_callout": "Retrieval is usually a short same-day transvaginal procedure with sedation, not abdominal surgery.",
      "monitoring_detail_title": "Monitoring, trigger, and retrieval",
      "monitoring_section_1_title": "Monitoring changes the plan",
      "monitoring_section_1_body": "Dose changes, extra visits, and shifted retrieval estimates are normal because the clinic is reacting to follicle growth and hormones.",
      "monitoring_section_2_title": "Trigger timing matters",
      "monitoring_section_2_body": "Retrieval is commonly scheduled about 34-36 hours after trigger, before ovulation would happen.",
      "monitoring_section_3_title": "What retrieval collects",
      "monitoring_section_3_body": "The clinician collects follicle fluid; the embryology lab searches that fluid for eggs under a microscope.",
      "sperm_source_title": "The sperm source is part of the embryo plan",
      "sperm_source_body": "The sperm may come from a partner, donor, fresh sample, or frozen sample. That choice affects consent, timing, transport, and the lab method.",
      "what_to_know_label": "What to know",
      "sperm_source_callout": "A sperm plan is not just logistics. It can change whether the lab uses conventional IVF or ICSI.",
      "sperm_source_detail_title": "Sperm source and embryo freezing",
      "sperm_source_section_1_title": "Fresh, frozen, partner, or donor",
      "sperm_source_section_1_body": "The sperm source affects logistics and consent. The lab needs a clear plan before retrieval day.",
      "sperm_source_section_2_title": "Why semen analysis matters",
      "sperm_source_section_2_body": "Count, motility, morphology, and volume can influence whether conventional insemination or ICSI is recommended.",
      "semen_sample_label": "Semen sample",
      "semen_sample_title": "A semen sample is collected or thawed",
      "semen_sample_body": "This often happens on retrieval day, but some people freeze backup sperm or use donor sperm that is already frozen.",
      "timing_label": "Timing",
      "semen_sample_callout": "The ovarian side takes days. The sperm handoff may be one day, but the preparation can start months earlier.",
      "semen_sample_detail_title": "How the sperm gets to the lab",
      "semen_sample_section_1_title": "Fresh sample",
      "semen_sample_section_1_body": "A fresh semen sample may be collected on retrieval day, then processed by the lab to prepare sperm for fertilization.",
      "semen_sample_section_2_title": "Frozen or donor sample",
      "semen_sample_section_2_body": "Frozen partner sperm or donor sperm can be thawed by the lab. The clinic should confirm timing, identity checks, consent, and backup plans before retrieval day.",
      "semen_sample_section_3_title": "Why backup plans matter",
      "semen_sample_section_3_body": "If collection may be difficult or sperm parameters are low, a clinic may discuss freezing backup sperm before the cycle.",
      "sperm_quality_label": "Sperm quality",
      "sperm_quality_title": "Semen analysis helps choose the lab method",
      "sperm_quality_body": "Count, motility, morphology, volume, prior fertilization history, and donor/partner status can all affect the fertilization plan.",
      "optimization_window_label": "Optimization window",
      "sperm_quality_callout": "Sperm is made continuously and turns over across roughly 2-3 months, so exposures can matter before embryo creation.",
      "sperm_quality_detail_title": "What semen analysis can change",
      "sperm_quality_section_1_title": "The usual parameters",
      "sperm_quality_section_1_body": "Semen analysis commonly looks at count, motility, morphology, volume, and sometimes additional measures depending on the clinic.",
      "sperm_quality_section_2_title": "Why it matters for embryos",
      "sperm_quality_section_2_body": "The result can influence whether the clinic recommends conventional insemination, ICSI, backup sperm freezing, urology referral, or donor sperm planning.",
      "ivf_icsi_label": "IVF vs ICSI",
      "ivf_icsi_title": "IVF and ICSI are two fertilization methods",
      "ivf_icsi_body": "With conventional IVF, eggs and prepared sperm are placed together. With ICSI, the embryologist injects one sperm into a mature egg.",
      "what_decides_label": "What decides it",
      "ivf_icsi_callout": "Semen results, prior fertilization, PGT plans, clinic policy, and egg count can all affect the recommendation.",
      "ivf_icsi_detail_title": "Conventional IVF versus ICSI",
      "ivf_icsi_section_1_title": "Conventional IVF",
      "ivf_icsi_section_1_body": "The lab places mature eggs with prepared sperm and lets fertilization happen without injecting each egg.",
      "ivf_icsi_section_2_title": "ICSI",
      "ivf_icsi_section_2_body": "ICSI means intracytoplasmic sperm injection. An embryologist selects one sperm and injects it directly into a mature egg.",
      "ivf_icsi_section_3_title": "Why the choice is personal",
      "ivf_icsi_section_3_body": "ICSI can be important for sperm-factor cases and is often used with PGT workflows, but it is not automatically better for every situation.",
      "day_1_label": "Day 1 check",
      "day_1_title": "The lab checks which eggs fertilized normally",
      "day_1_body": "The next day, the lab usually checks for normal fertilization. This is when the number can narrow again.",
      "day_1_callout": "Retrieved eggs, mature eggs, normally fertilized eggs, and embryos are separate numbers.",
      "day_1_detail_title": "What the fertilization check means",
      "day_1_section_1_title": "Maturity comes first",
      "day_1_section_1_body": "After retrieval, the lab checks which eggs are mature. Immature eggs are less likely to fertilize normally.",
      "day_1_section_2_title": "Normal fertilization",
      "day_1_section_2_body": "A fertilized egg at this stage is often called a zygote. Some eggs may not fertilize, and some may fertilize abnormally.",
      "embryo_culture_label": "Embryo culture",
      "embryo_culture_title": "Embryos are watched over several days",
      "embryo_culture_body": "Fertilized eggs divide over time. The lab may update you on cleavage-stage embryos around day 3 and blastocysts around day 5-7.",
      "embryo_culture_callout_label": "Why updates can feel hard",
      "embryo_culture_callout": "The number often drops at each lab checkpoint; that does not necessarily mean anything went wrong.",
      "embryo_culture_detail_title": "Embryo culture and attrition",
      "embryo_culture_section_1_title": "Early development",
      "embryo_culture_section_1_body": "The lab watches fertilized eggs divide. Some arrest early and some continue toward day 5, 6, or 7 blastocyst stage.",
      "embryo_culture_section_2_title": "Why the funnel narrows",
      "embryo_culture_section_2_body": "Egg maturity, sperm factors, chromosome errors, lab conditions, and biology all affect whether an embryo keeps developing.",
      "blastocyst_title": "Blastocysts are the embryos usually frozen or tested",
      "blastocyst_body": "By about day 5-7, some embryos may reach blastocyst stage. Labs decide which blastocysts meet criteria for freezing, biopsy, or transfer planning.",
      "after_blastocyst_label": "After blastocyst",
      "blastocyst_callout": "A blastocyst can be graded, frozen, biopsied for PGT, or sometimes not kept if it does not meet lab criteria.",
      "blastocyst_detail_title": "What happens at blastocyst stage",
      "blastocyst_section_1_title": "The day can vary",
      "blastocyst_section_1_body": "Some embryos reach blastocyst on day 5, some on day 6 or 7, and some stop before then.",
      "blastocyst_section_2_title": "Grading is not genetic testing",
      "blastocyst_section_2_body": "Embryo grading looks at appearance and expansion. It is useful, but it does not tell you whether the embryo has the expected number of chromosomes.",
      "pgt_pgd_label": "PGT / PGD",
      "pgt_pgd_title": "Genetic testing is optional and has different types",
      "pgt_pgd_body": "PGD is older wording. Today you'll usually hear PGT-A for chromosome count, PGT-M for a specific gene condition, or PGT-SR for chromosome rearrangements.",
      "what_it_does_label": "What it does",
      "pgt_pgd_callout": "PGT tests a few cells from a blastocyst biopsy. It gives information; it does not change the embryo.",
      "pgt_pgd_detail_title": "PGT, PGD, and what is tested",
      "pgt_pgd_section_1_title": "PGT-A",
      "pgt_pgd_section_1_body": "PGT-A screens whether the embryo biopsy has the expected number of chromosomes. It is usually discussed as euploid, aneuploid, mosaic, or no-result depending on the lab.",
      "pgt_pgd_section_2_title": "PGT-M and PGT-SR",
      "pgt_pgd_section_2_body": "PGT-M looks for a specific inherited single-gene condition when there is a known risk. PGT-SR looks for embryos affected by a known chromosome rearrangement.",
      "pgt_pgd_section_3_title": "Why counseling matters",
      "pgt_pgd_section_3_body": "Genetic testing decisions can affect cost, timing, embryo use, and emotional decisions. Many clinics involve a genetic counselor for PGT-M or complex results.",
      "euploidy_label": "Euploidy",
      "euploidy_title": "Euploid means the expected chromosome count",
      "euploidy_body": "A euploid PGT-A result means the tested biopsy had the expected chromosome number. Aneuploid means extra or missing chromosomes were detected.",
      "important_limit_label": "Important limit",
      "euploidy_callout": "Euploid does not guarantee pregnancy or live birth, and PGT-A is not a test for every possible genetic issue.",
      "euploidy_detail_title": "How to read PGT-A language",
      "euploidy_section_1_title": "Euploid",
      "euploidy_section_1_body": "A euploid result means the embryo biopsy had the expected number of chromosomes. Euploid embryos generally have better implantation potential than aneuploid embryos, but outcomes are not guaranteed.",
      "euploidy_section_2_title": "Aneuploid, mosaic, no-result",
      "euploidy_section_2_body": "Aneuploid means extra or missing chromosomes were detected. Mosaic means mixed cell-line signals. No-result means the lab did not get a usable result.",
      "freezing_storage_title": "Embryos are vitrified and stored",
      "freezing_storage_body": "Embryos that meet freezing criteria are usually vitrified, stored in liquid nitrogen tanks, and kept until a future thaw or transfer decision.",
      "how_long_label": "How long",
      "freezing_storage_callout": "When storage is maintained, embryos can remain frozen for many years. Practical limits are usually consent, clinic policy, storage fees, and law.",
      "freezing_storage_detail_title": "Embryo freezing and storage",
      "freezing_storage_section_1_title": "Vitrification",
      "freezing_storage_section_1_body": "Vitrification is rapid freezing designed to reduce ice crystal formation. Embryos are then stored in liquid nitrogen tanks.",
      "freezing_storage_section_2_title": "Storage is an ongoing decision",
      "freezing_storage_section_2_body": "Frozen embryos can involve annual storage fees, consent renewals, disposition decisions, legal considerations, and future transfer planning.",
      "freezing_storage_section_3_body": "When someone wants to use an embryo later, the embryo is thawed and a frozen embryo transfer plan is made. Not every embryo survives thaw, but modern vitrification survival is generally high.",
      "future_transfer_title": "Using an embryo later is a separate transfer step",
      "future_transfer_body": "Embryo freezing creates stored embryos. Pregnancy later requires thawing an embryo, preparing the uterus or gestational carrier, and doing an embryo transfer.",
      "why_this_matters_label": "Why this matters",
      "future_transfer_callout": "Freezing embryos gives more information than freezing eggs, but it also creates decisions about ownership, consent, transfer, storage, and disposition.",
      "future_transfer_detail_title": "After embryos are frozen",
      "future_transfer_section_1_title": "Frozen embryo transfer",
      "future_transfer_section_1_body": "A future transfer usually involves a separate cycle with uterine preparation, embryo thaw, transfer, and pregnancy testing afterward.",
      "future_transfer_section_2_title": "Consent and ownership",
      "future_transfer_section_2_body": "Because embryos may involve more than one genetic contributor, clinics usually require clear consent about storage, transfer, testing, discard, donation, and what happens if circumstances change.",
      "process_ovarian_label": "Ovarian side",
      "process_ovarian_timing": "10-14 days",
      "process_ovarian_title": "Get eggs through ovarian stimulation",
      "process_sperm_timing": "1 day",
      "process_sperm_title": "Collect or thaw a semen sample",
      "process_lab_label": "Lab side",
      "process_lab_timing": "5-7 days",
      "process_lab_title": "Fertilize, culture, test or freeze embryos"
    },
    "egg_freezing_biology_carousel": {
      "how_it_works": "How egg freezing works",
      "biology_first_intro": "A biology-first version of the process, including why stimulation does not use up future eggs.",
      "biology_detail": "Biology detail",
      "open_detail_for": "Open detail for ${title}",
      "reserve_note": "Reserve note",
      "normal_cycle_label": "Normal cycle",
      "normal_cycle_title": "Your body starts with a group",
      "normal_cycle_body": "Each month, a small group of follicles begins growing. Usually one becomes dominant and ovulates.",
      "normal_cycle_reserve_note": "Egg freezing does not use eggs your body was saving for later.",
      "normal_cycle_detail_title": "What happens in a normal cycle",
      "normal_cycle_section_1_title": "A cohort starts together",
      "normal_cycle_section_1_body": "At the beginning of a menstrual cycle, several small follicles are available to respond to follicle-stimulating hormone. Each follicle may contain one egg.",
      "normal_cycle_section_2_title": "Usually only one wins",
      "normal_cycle_section_2_body": "As the cycle continues, one follicle usually becomes dominant. The others from that same monthly group stop developing and are naturally reabsorbed.",
      "normal_cycle_section_3_title": "Why this matters for reserve",
      "normal_cycle_section_3_body": "Those non-dominant follicles were already part of that month's cohort. Egg freezing aims to help more of that cohort mature instead of letting most of them fade away.",
      "cohort_title": "Medication supports more of that group",
      "cohort_body": "FSH medication gives more follicles enough signal to keep growing in the same cycle.",
      "cohort_reserve_note": "It works with the month's recruited follicles, not the whole lifetime supply.",
      "cohort_detail_title": "Why multiple follicles can grow",
      "cohort_section_1_title": "The medication is a stronger signal",
      "cohort_section_1_body": "In an unstimulated cycle, the body's FSH level usually falls as one follicle takes the lead. With stimulation, FSH stays high enough for more follicles in the same cohort to continue.",
      "cohort_section_2_title": "This is not making new eggs",
      "cohort_section_2_body": "The medication does not create eggs and does not pull eggs from future years. It supports follicles that were already available during this cycle.",
      "cohort_section_3_title": "Why clinics monitor closely",
      "cohort_section_3_body": "People respond differently. Monitoring lets the clinic adjust dosing, reduce risk, and decide when the follicles are ready.",
      "daily_meds_label": "Daily meds",
      "medication_title": "The dose is trying to balance response",
      "medication_body": "The goal is enough growth to retrieve mature eggs, without overstimulating your ovaries.",
      "medication_reserve_note": "Dose changes affect this cycle's response, not future fertility.",
      "medication_detail_title": "What daily stimulation is doing",
      "medication_section_1_title": "FSH is a growth signal",
      "medication_section_1_body": "Most stimulation protocols use FSH, sometimes with LH activity, to encourage follicles to keep growing.",
      "medication_section_2_title": "More is not always better",
      "medication_section_2_body": "A higher dose does not guarantee more eggs. Clinics use age, AMH, antral follicle count, prior response, and hormone levels to choose and adjust a dose.",
      "medication_section_3_title": "Reserve and fertility",
      "medication_section_3_body": "A stimulation dose can change how many follicles mature in this cycle. It does not permanently lower ovarian reserve.",
      "monitoring_label": "Monitoring",
      "monitoring_title": "Size and hormones tell the story",
      "monitoring_body": "Ultrasound tracks follicle size. Bloodwork helps show how the follicles are responding.",
      "monitoring_reserve_note": "Monitoring is about timing and safety; it does not affect your eggs.",
      "monitoring_detail_title": "What monitoring is checking",
      "monitoring_section_1_title": "Follicle size",
      "monitoring_section_1_body": "Follicles usually grow over several days. Your clinic watches for a group that is large enough to likely contain mature eggs.",
      "monitoring_section_2_title": "Hormone levels",
      "monitoring_section_2_body": "Estradiol generally rises as follicles grow. LH and progesterone help the clinic make sure the timing still fits the plan.",
      "monitoring_section_3_title": "Why it protects you",
      "monitoring_section_3_body": "Monitoring helps reduce risks like triggering too early, triggering too late, or continuing stimulation when the response is too strong.",
      "trigger_label": "Trigger",
      "trigger_title": "The trigger matures the eggs",
      "trigger_body": "The trigger shot tells eggs to finish maturing before retrieval. Timing matters a lot.",
      "trigger_reserve_note": "The trigger changes timing for this cohort only.",
      "trigger_detail_title": "Why trigger timing matters",
      "trigger_section_1_title": "Final maturation",
      "trigger_section_1_body": "Follicles can look ready by size, but the egg inside still needs a final maturation signal. The trigger provides that signal.",
      "trigger_section_2_title": "Retrieval window",
      "trigger_section_2_body": "Retrieval is usually scheduled about 34 to 36 hours after trigger, before ovulation would release the eggs.",
      "trigger_section_3_title": "Future fertility",
      "trigger_section_3_body": "The trigger does not change future cycles. It is a timing signal for the follicles already grown during this cycle.",
      "retrieval_label": "Retrieval",
      "retrieval_title": "Eggs are collected before ovulation",
      "retrieval_body": "A needle guided by ultrasound removes fluid from follicles so the lab can find the eggs.",
      "retrieval_reserve_note": "The procedure collects this cycle's mature eggs; it does not remove future eggs.",
      "retrieval_detail_title": "What retrieval collects",
      "retrieval_section_1_title": "Follicles, not ovaries",
      "retrieval_section_1_body": "The needle enters follicles and aspirates fluid. The embryology lab checks that fluid for eggs.",
      "retrieval_section_2_title": "Why count can differ",
      "retrieval_section_2_body": "The number of eggs retrieved can be lower than the number of visible follicles. Some follicles may not contain an egg, or the egg may not be mature.",
      "retrieval_section_3_title": "Ovarian reserve",
      "retrieval_section_3_body": "Retrieval removes eggs from follicles that were already grown for this cycle. It does not empty the ovary or accelerate menopause.",
      "reserve_label": "Reserve",
      "reserve_title": "Your reserve is still your reserve",
      "reserve_body": "The cycle can reveal how your ovaries respond, but it is not considered harmful to ovarian reserve.",
      "reserve_reserve_note": "The main reserve markers are age, AMH, AFC, and prior response.",
      "reserve_detail_title": "Why egg freezing does not use up future eggs",
      "reserve_section_1_title": "Recruitment happens naturally",
      "reserve_section_1_body": "Every cycle, many follicles begin but most do not ovulate. Stimulation helps rescue more follicles from that same monthly group.",
      "reserve_section_2_title": "What can change",
      "reserve_section_2_body": "Your clinic may learn that your response is higher or lower than expected. That information can guide future cycles.",
      "reserve_section_3_title": "What does not change",
      "reserve_section_3_body": "A properly managed stimulation cycle is not understood to deplete the eggs that would have been available in future months.",
      "freezing_title": "Only mature eggs are frozen",
      "freezing_body": "The lab checks maturity and vitrifies the eggs that are ready for future use.",
      "freezing_reserve_note": "Frozen eggs are an option for later; they do not guarantee a future birth.",
      "freezing_detail_title": "What freezing preserves",
      "freezing_section_1_title": "Maturity matters",
      "freezing_section_1_body": "Usually only mature eggs are frozen because they are the eggs most likely to survive thawing and fertilize later.",
      "freezing_section_2_title": "Vitrification",
      "freezing_section_2_body": "Vitrification is rapid freezing that prevents ice crystals from damaging the egg.",
      "freezing_section_3_title": "What the number means",
      "freezing_section_3_body": "The number frozen is an important input, but future success also depends on age at freezing, thaw survival, fertilization, embryo development, and transfer outcomes."
    },
    "egg_freezing_biology_deep_carousel": {
      "step_1_understand": "Step 1: Understand",
      "step_1_complete": "Step 1 complete",
      "section_subtitle": "Biology, retrieval, freezing, and estimates.",
      "more_detail": "More detail",
      "mark_read": "Mark read",
      "read": "Read",
      "expand_how_it_works_a11y": "Expand how egg freezing works",
      "collapse_how_it_works_a11y": "Collapse how egg freezing works",
      "show_completed_a11y": "Show completed egg freezing guide",
      "collapse_completed_a11y": "Collapse completed egg freezing guide",
      "mark_as_read_a11y": "Mark egg freezing guide as read",
      "timeline_how_it_works_subtitle": "More dimensional biology visuals with clearer meaning.",
      "egg_estimate_subtitle": "Estimate yield, attrition, and how many cycles may be needed.",
      "optimization_protocol_title": "5-step egg optimization protocol",
      "optimization_protocol_subtitle": "Baseline, exposures, health basics, supplement evidence, and a targeted plan.",
      "archive_organic_title": "How egg freezing works · organic direction",
      "archive_organic_subtitle": "Archived comparison version with the earlier dimensional visual direction.",
      "archive_flat_title": "How egg freezing works · flat/current",
      "archive_flat_subtitle": "Archived comparison version with the older flatter illustration direction.",
      "egg_supply_label": "Egg quantity",
      "egg_supply_title": "Your egg supply goes down over time",
      "egg_supply_body": "You are born with all the eggs you will ever have. Eggs do not regenerate, so the supply naturally declines across life.",
      "egg_supply_callout_label": "What testing can tell you",
      "egg_supply_callout": "AMH and AFC do not count every egg, but they help estimate ovarian reserve and likely response in one cycle.",
      "egg_supply_cta": "Test my egg reserve",
      "egg_supply_detail_title": "Egg quantity and ovarian reserve",
      "egg_supply_s1_title": "Quantity means how many are left",
      "egg_supply_s1_body": "You are born with all the eggs you will ever have. The supply peaks before birth, is usually about 1-2 million at birth, and keeps declining. By puberty, there are often about 300,000-500,000 eggs left.",
      "egg_supply_s2_title": "The decline is normal",
      "egg_supply_s2_body": "Most eggs never ovulate. They are gradually lost over time through natural follicle loss, while only a small number ovulate across the reproductive years.",
      "egg_supply_s3_title": "What reserve testing measures",
      "egg_supply_s3_body": "AMH, antral follicle count, age, and prior response help estimate how the ovaries may respond to stimulation. They are not a direct count of every egg left.",
      "egg_quality_label": "Egg quality",
      "egg_quality_title": "Egg quality is different from egg quantity",
      "egg_quality_body": "There is no simple objective test for the quality of an individual egg before it is used. Age is still the strongest signal because eggs age with you.",
      "egg_quality_callout_label": "Why timing matters",
      "egg_quality_callout": "Freezing earlier can preserve eggs before more years of aging, inflammation, smoking, treatments, or environmental exposures affect them.",
      "egg_quality_detail_title": "Egg quality and time",
      "egg_quality_s1_title": "Quality means whether an egg can work later",
      "egg_quality_s1_body": "Quality is about whether the egg has the chromosomes, mitochondria, and cell machinery to fertilize, divide normally, and support embryo development.",
      "egg_quality_s2_title": "There is no direct egg-quality test",
      "egg_quality_s2_body": "Clinics can estimate risk from age and history, but they cannot look at a resting egg and know with certainty whether it will become a healthy embryo or birth.",
      "egg_quality_s3_title": "Why quality goes down",
      "egg_quality_s3_body": "Eggs are long-lived cells. Over time, they can be affected by chromosome-separation errors, oxidative stress, inflammation, smoking, chemotherapy, endometriosis, and other exposures or conditions.",
      "egg_quality_s4_title": "Why it matters",
      "egg_quality_s4_body": "If an egg is used later, lower quality can show up as failed fertilization, embryo fragmentation, embryo arrest, aneuploid embryos, failed implantation, or miscarriage.",
      "egg_quality_s5_title": "How this differs from sperm",
      "egg_quality_s5_body": "Sperm quality can also be affected by age and exposures, but sperm are made continuously and turn over. Eggs are not regenerated in the same way, which is why timing matters differently.",
      "ovaries_follicles_label": "Ovaries & follicles",
      "ovaries_follicles_title": "Eggs sit inside follicles, and follicles sit inside ovaries",
      "ovaries_follicles_body": "Clinics can measure follicles on ultrasound, but the egg inside each follicle is microscopic.",
      "key_distinction_label": "Key distinction",
      "ovaries_follicles_callout": "Clinics can see and measure follicles on ultrasound; the egg inside is microscopic.",
      "ovaries_follicles_detail_title": "Eggs, follicles, and ovaries",
      "ovaries_follicles_s1_title": "What is an ovary?",
      "ovaries_follicles_s1_body": "The ovaries are the organs that contain the egg supply and make hormones like estrogen and progesterone.",
      "ovaries_follicles_s2_title": "What is a follicle?",
      "ovaries_follicles_s2_body": "A follicle is a small fluid-filled sac in the ovary. It supports the egg as it grows and produces hormones during the cycle.",
      "ovaries_follicles_s3_title": "What is inside the follicle?",
      "ovaries_follicles_s3_body": "A follicle may contain one egg, but the egg is too small to see directly on ultrasound. This is why clinics measure follicles as a proxy for egg development.",
      "ovaries_follicles_s4_title": "How many do you start with?",
      "ovaries_follicles_s4_body": "People are born with their lifetime supply of eggs. The number declines over time. By puberty, there are usually hundreds of thousands left, and only a small fraction will ever ovulate.",
      "normal_cycle_label": "Normal menstrual cycle",
      "normal_cycle_title": "Each month, your body recruits a small group of follicles",
      "normal_cycle_body": "In a typical menstrual cycle, several follicles start responding. Usually one becomes dominant and ovulates; the rest stop growing.",
      "people_often_get_wrong_label": "People often get wrong",
      "normal_cycle_callout": "The other follicles from that month usually stop growing anyway.",
      "normal_cycle_detail_title": "What normally happens in a menstrual cycle",
      "normal_cycle_s1_title": "A small group starts together",
      "normal_cycle_s1_body": "Each month, the ovary recruits a group of small follicles. The exact number varies by age and ovarian reserve, and is related to the antral follicle count your clinic may measure.",
      "normal_cycle_s2_title": "Usually one follicle dominates",
      "normal_cycle_s2_body": "One follicle usually becomes the lead follicle. The others in that same cohort stop growing and are reabsorbed.",
      "normal_cycle_s3_title": "Why stimulation is different",
      "normal_cycle_s3_body": "Stimulation tries to keep more follicles from that same cohort growing long enough to retrieve eggs from them.",
      "normal_cycle_s4_title": "Why this matters for reserve",
      "normal_cycle_s4_body": "Egg freezing is not taking eggs from future months. It is trying to mature more of the follicles that were already recruited in the current cycle.",
      "stimulation_title": "Medication keeps more follicles in the race",
      "stimulation_body": "Injectable gonadotropins, often taken for about 10-14 days, support several follicles at once instead of one.",
      "what_matters_here_label": "What matters here",
      "stimulation_callout": "The goal is a coordinated group, not the largest possible number at any cost.",
      "stimulation_detail_title": "Why medication recruits more follicles",
      "stimulation_s1_title": "FSH is a growth signal",
      "stimulation_s1_body": "In a natural cycle, FSH drops as one follicle takes over. During stimulation, injectable FSH or related gonadotropins keep the signal high enough for more follicles to continue.",
      "stimulation_s2_title": "Clinics tune the dose",
      "stimulation_s2_body": "Age, AMH, AFC, weight, diagnosis, and prior response can all affect the starting dose and later adjustments.",
      "stimulation_s3_title": "Not all follicles respond the same",
      "stimulation_s3_body": "Some follicles grow quickly, some grow slowly, and some do not produce a mature egg. That variation is normal.",
      "maturity_label": "Maturity",
      "maturity_title": "Follicles grow while eggs mature inside",
      "maturity_body": "The follicle is the fluid-filled structure your clinic measures. The egg inside is what needs to mature.",
      "maturity_callout": "A follicle count is not the same thing as a mature egg count.",
      "maturity_cta": "Personalize with test results",
      "maturity_detail_title": "Follicles, eggs, and maturity",
      "maturity_s1_title": "Follicles are measured by ultrasound",
      "maturity_s1_body": "During monitoring, your clinic measures follicles in millimeters. Larger follicles are more likely to contain mature eggs, but size is not a guarantee.",
      "maturity_s2_title": "The egg matures inside the follicle",
      "maturity_s2_body": "As follicles grow, the egg inside moves through stages of maturity. The clinic times trigger and retrieval to maximize mature eggs.",
      "maturity_s3_title": "Why counts can change",
      "maturity_s3_body": "You might hear a follicle count, then a retrieved egg count, then a mature egg count. Each number is measuring a different step.",
      "monitoring_label": "Monitoring",
      "monitoring_title": "Monitoring tells the clinic when to adjust",
      "monitoring_body": "Visits often happen every 2-3 days. Ultrasound shows follicle size, and bloodwork shows hormone response.",
      "monitoring_callout": "Monitoring is not just confirmation. It is how the clinic keeps the cycle safer and better timed.",
      "monitoring_detail_title": "Why monitoring matters",
      "monitoring_s1_title": "Size is one signal",
      "monitoring_s1_body": "Follicles often need to reach a certain size range before trigger, but clinics consider the whole cohort, not only the largest follicle.",
      "monitoring_s2_title": "Hormones add context",
      "monitoring_s2_body": "Estradiol usually rises as follicles grow. LH and progesterone help the clinic watch for timing problems.",
      "monitoring_s3_title": "The cadence is concrete",
      "monitoring_s3_body": "Many people are monitored every 2-3 days during stimulation. Near trigger, the clinic may bring you in more often because timing gets tighter.",
      "monitoring_s4_title": "Adjustments are normal",
      "monitoring_s4_body": "Dose changes, extra visits, and shifted retrieval estimates are common. They usually mean the clinic is responding to your data.",
      "trigger_label": "Trigger",
      "trigger_title": "The trigger starts final maturation",
      "trigger_body": "The trigger shot tells eggs to complete the last maturation steps before retrieval.",
      "trigger_callout": "The trigger is not just another dose. Timing it correctly is one of the most important parts of the cycle.",
      "trigger_detail_title": "The trigger and final maturation",
      "trigger_s1_title": "Follicles can look ready before eggs are ready",
      "trigger_s1_body": "A follicle can be near the right size while the egg inside still needs a final maturation signal.",
      "trigger_s2_title": "Retrieval is timed around the trigger",
      "trigger_s2_body": "Retrieval is commonly scheduled about 34 to 36 hours after trigger, before ovulation would happen.",
      "trigger_s3_title": "Why clinics give exact times",
      "trigger_s3_body": "Taking the trigger too early or too late can affect whether eggs are mature or retrievable. This is why the instruction is usually very precise.",
      "retrieval_label": "Retrieval",
      "retrieval_procedure_title": "Retrieval is a short same-day procedure",
      "retrieval_procedure_body": "You are usually sedated while ultrasound guides a thin needle through the vaginal wall into the follicles.",
      "what_people_worry_label": "What people worry about",
      "retrieval_procedure_callout": "It is a procedure, but not abdominal surgery. There are usually no skin incisions, and most people go home the same day.",
      "retrieval_procedure_detail_title": "What egg retrieval is like",
      "retrieval_procedure_s1_title": "It is transvaginal",
      "retrieval_procedure_s1_body": "The retrieval is typically done with a vaginal ultrasound probe. A thin needle passes through the vaginal wall into each accessible follicle to collect fluid.",
      "retrieval_procedure_s2_title": "You are usually sedated",
      "retrieval_procedure_s2_body": "Most clinics use IV sedation or anesthesia, so you are not awake in the same way you would be for a routine ultrasound. The exact anesthesia plan depends on the clinic.",
      "retrieval_procedure_s3_title": "Same-day recovery",
      "retrieval_procedure_s3_body": "The procedure itself is often short, with recovery afterward at the clinic. Most people need someone to take them home and rest the remainder of the day.",
      "lab_handoff_label": "Lab handoff",
      "lab_handoff_title": "The clinic collects follicle fluid, then the lab finds eggs",
      "lab_handoff_body": "The needle removes fluid from follicles. The embryology lab checks that fluid for eggs under a microscope.",
      "lab_handoff_callout": "Follicles are visible on ultrasound. Eggs are microscopic, so the final egg count is only known after retrieval.",
      "lab_handoff_detail_title": "How follicles become an egg count",
      "lab_handoff_s1_title": "The follicle is the target",
      "lab_handoff_s1_body": "During retrieval, the clinician aims for follicles that are large enough and safely accessible. The goal is to collect the fluid where an egg may be.",
      "lab_handoff_s2_title": "The lab searches the fluid",
      "lab_handoff_s2_body": "An embryologist examines the collected fluid to identify eggs. This is why the number of visible follicles and the number of retrieved eggs can differ.",
      "lab_handoff_s3_title": "Not every follicle gives a mature egg",
      "lab_handoff_s3_body": "Some follicles may not contain an egg, and some eggs may be immature. Retrieved eggs and mature eggs are separate checkpoints.",
      "egg_count_label": "Egg count",
      "egg_count_title": "The retrieval number is one checkpoint",
      "egg_count_body": "The lab counts how many eggs are found after fluid is collected from the follicles.",
      "what_people_ask_label": "What people ask",
      "egg_count_callout": "Eggs retrieved is not the final number. The mature egg count is usually the more useful number for freezing.",
      "egg_count_cta": "See the outcome funnel",
      "egg_count_detail_title": "How many eggs are usually collected?",
      "egg_count_s1_title": "It varies by person",
      "egg_count_s1_body": "Age, AMH, antral follicle count, diagnosis, protocol, and ovarian response all affect the number retrieved.",
      "egg_count_s2_title": "A rough range",
      "egg_count_s2_body": "Many egg freezing cycles retrieve somewhere around 5 to 20 eggs, but some cycles retrieve fewer and some retrieve more. Your clinic should personalize expectations.",
      "egg_count_s3_title": "Retrieved is not the same as mature",
      "egg_count_s3_body": "After retrieval, the lab checks which eggs are mature enough to freeze. That mature count can be lower than the retrieved count.",
      "mii_label": "MII eggs",
      "mii_title": "Mature eggs are vitrified for storage",
      "mii_body": "You may see the term MII. Mature eggs are usually rapidly frozen and stored in liquid nitrogen at about -196°C.",
      "term_to_know_label": "Term to know",
      "mii_callout": "MII is the mature egg stage clinics usually care about most for egg freezing.",
      "mii_cta": "Read about MII eggs",
      "mii_detail_title": "What MII means",
      "mii_s1_title": "MII means metaphase II",
      "mii_s1_body": "MII is the stage where an egg has completed the maturation step needed before fertilization can happen later.",
      "mii_s2_title": "Why immature eggs may not be frozen",
      "mii_s2_body": "Immature eggs are less likely to perform well after thawing. Many labs freeze mature MII eggs because they have the best chance of later use.",
      "mii_s3_title": "Vitrification",
      "mii_s3_body": "Vitrification is rapid freezing designed to reduce ice-crystal formation. Frozen eggs are stored in liquid nitrogen tanks at about -196°C.",
      "mii_s4_title": "Why the number changes",
      "mii_s4_body": "A cycle might produce 14 retrieved eggs and 10 mature eggs, for example. The mature count is usually the number that enters your frozen egg bank.",
      "later_use_label": "Later use",
      "attrition_title": "Eggs, embryos, and births are different numbers",
      "attrition_body": "Not every frozen egg survives thaw, fertilizes, becomes an embryo, tests normal, implants, or leads to a birth.",
      "why_estimates_exist_label": "Why estimates exist",
      "attrition_callout": "The target egg number is about improving odds, not guaranteeing a future baby.",
      "attrition_cta": "Personalize estimate",
      "attrition_detail_title": "The attrition funnel",
      "attrition_s1_title": "Eggs are not embryos",
      "attrition_s1_body": "A frozen egg is one step earlier than an embryo. Later, the egg must thaw, fertilize with sperm, and develop into an embryo.",
      "attrition_s2_title": "Attrition is expected",
      "attrition_s2_body": "Some eggs do not survive thaw, some do not fertilize, some embryos stop developing, and some embryos are not chromosomally normal.",
      "attrition_s3_title": "Why age matters",
      "attrition_s3_body": "Age at freezing affects egg quality and the chance that a mature egg eventually becomes a viable embryo and live birth.",
      "estimate_none_value": "Needs your numbers",
      "estimate_none_body": "Age is only a starting point. AMH, AFC, and medical history make the estimate useful.",
      "estimate_8_14": "Often 8-14 eggs",
      "estimate_5_10": "Often 5-10 eggs",
      "estimate_clinic_specific": "Clinic-specific",
      "estimate_under_35_body": "This is a rough age-based range. Your AMH, AFC, and history can shift it.",
      "estimate_35_37_body": "Age still helps, but ovarian reserve numbers become more important for planning.",
      "estimate_37_40_body": "Many people use AMH and AFC to decide whether more than one cycle makes sense.",
      "estimate_over_40_body": "After 40, yield varies more. A clinic should personalize this with testing.",
      "funnel_retrieved_detail": "Starting estimate for one retrieval before lab attrition.",
      "general_estimate": "General estimate",
      "funnel_mature_detail": "${diff} may be immature, missing, or not usable after retrieval.",
      "funnel_frozen_label": "Frozen eggs",
      "funnel_frozen_detail": "Usually the mature eggs are the ones vitrified and stored.",
      "funnel_thawed_label": "Thawed eggs",
      "funnel_thawed_detail": "${diff} may not survive thaw later.",
      "funnel_fertilized_label": "Fertilized eggs",
      "funnel_fertilized_detail": "${diff} may not fertilize after thaw.",
      "funnel_blastocysts_detail": "${diff} may stop before blastocyst stage.",
      "funnel_euploids_label": "Euploids",
      "funnel_euploids_detail": "${diff} may be chromosomally abnormal or untested.",
      "funnel_birth_label": "Live birth chance",
      "funnel_birth_detail": "This is a general population estimate of the chance of at least one live birth from this cohort.",
      "embryo_funnel_retrieved_detail": "Starting estimate for one retrieval before maturity and lab attrition.",
      "embryo_funnel_mature_detail": "${diff} may be immature, missing, or not usable for fertilization.",
      "embryo_funnel_fertilized_detail": "${diff} may not fertilize or may fertilize abnormally.",
      "embryo_funnel_blastocysts_detail": "${diff} may stop developing before day 5-7 blastocyst stage.",
      "embryo_funnel_frozen_label": "Embryos frozen/tested",
      "embryo_funnel_frozen_detail": "Blastocysts that meet lab criteria are usually vitrified; some may also be biopsied for PGT-A.",
      "embryo_funnel_euploids_label": "Euploid embryos",
      "embryo_funnel_euploids_detail": "${diff} may be aneuploid, mosaic, untested, or otherwise not transferable depending on the plan.",
      "embryo_funnel_birth_detail": "This is a general population planning estimate of the chance of at least one live birth from the estimated euploid embryo cohort.",
      "age_label": "age",
      "age_with_value": "age: ${userAge}",
      "add_amh": "Add AMH",
      "amh_with_value": "AMH ${value} ${unit}",
      "afc_with_value": "AFC ${value}",
      "add_afc": "Add AFC",
      "semen_analysis_lower": "semen analysis",
      "add_semen_analysis": "Add semen analysis",
      "planning_unit_embryos": "euploid embryos",
      "planning_unit_eggs": "mature frozen eggs",
      "intro_copy_embryo": "This starts with an age-based egg-yield estimate, then narrows through fertilization, blastocyst development, possible PGT-A, and freezing.",
      "intro_copy_embryo_with_amh": "Your AMH and age drive a personalised egg-yield estimate, then the funnel narrows through fertilization, blastocyst development, possible PGT-A, and freezing.",
      "intro_copy_egg": "This starts with an age-based cycle estimate, then narrows through the future-use funnel. Add AMH and AFC to make this more personal.",
      "intro_copy_egg_with_amh": "Your AMH and age drive a personalised retrieval estimate, then the funnel narrows through freezing, thaw, fertilization, and future use. Add AFC or a clinic evaluation to refine it further.",
      "intro_copy_egg_with_amh_afc": "Your age, AMH, and AFC drive a personalised retrieval estimate, then the funnel narrows through freezing, thaw, fertilization, and future use. A clinic evaluation can refine it further.",
      "intro_copy_embryo_with_amh_afc": "Your age, AMH, and AFC drive a personalised egg-yield estimate, then the funnel narrows through fertilization, blastocyst development, possible PGT-A, and freezing.",
      "cta_check_testing": "Check testing options",
      "cta_test_reserve": "Test ovarian reserve",
      "open_detail_a11y": "Open detail for egg estimate assumptions",
      "how_many_children": "How many children would you like to plan for?",
      "planning_for_summary": "Planning for ${childrenGoal} ${childLabel} means aiming for about ${target} ${planningUnitLabel} — that's around ${estimatedCycles} retrieval ${cycleLabel}.",
      "child_singular": "child",
      "child_plural": "children",
      "cycle_singular": "cycle",
      "cycle_plural": "cycles",
      "reduce_children_goal": "Reduce children goal",
      "increase_children_goal": "Increase children goal",
      "planning_for_summary_empty": "You're planning for ${childrenGoal} ${childLabel}.",
      "no_estimate_add_amh": "Add your AMH result to see a personalized estimate.",
      "young_age_baseline_hint": "At your age, AMH is the main input. Your outcomes are likely at or above the 30-year-old baseline shown below.",
      "advanced_age_needs_amh": "At your age, an AMH measurement is needed to give you a meaningful estimate.",
      "add_amh_cta": "Add AMH",
      "illustrative_baseline_note": "Illustrative baseline for age ${baselineAge} — add your AMH to personalize this.",
      "illustrative_live_birth_probability": "About ${percent}% chance of at least ${childrenGoal} ${childLabel} at that age.",
      "planning_disclaimer": "This is a planning estimate, not a guarantee. Your clinic can adjust it with AMH, AFC, diagnosis, protocol, sperm parameters, lab plan, and prior response.",
      "planning_disclaimer_with_amh": "This uses your AMH and age — it's a planning estimate, not a guarantee. Your clinic can refine it with AFC, diagnosis, protocol, sperm parameters, lab plan, and prior response.",
      "planning_disclaimer_with_amh_afc": "This uses your age, AMH, and AFC — it's a planning estimate, not a guarantee. Your clinic can refine it further with diagnosis, protocol, sperm parameters, and prior response.",
      "date_of_birth": "Date of birth",
      "date_of_birth_subtitle": "Used to personalise your cycle estimate.",
      "date_of_birth_field": "Your date of birth",
      "save": "Save",
      "where_numbers_come_from": "Understanding these numbers",
      "attrition_funnel": "Why the number drops at each step",
      "family_planning_target": "How many cycles for your goal?",
      "detail_cycle_estimate_title": "Where the per-cycle estimate comes from",
      "detail_cycle_estimate_embryo": "The first number is a population average for your age. If you add your AMH or AFC, we refine it with those values. Your diagnosis, semen analysis, fertilization method, protocol, and prior cycle response can move it up or down — your clinic is best placed to give you a number that fits your situation.",
      "detail_cycle_estimate_egg": "The first number is a population average for your age. If you add your AMH or AFC, we refine it with those values. It's a range to orient you, not a prediction — your diagnosis and treatment response can shift it, and your clinic is best placed to give you a number that fits your situation.",
      "detail_attrition_embryo": "Not every retrieved egg becomes a transferable embryo. Some are immature, some don't fertilize, some don't reach blastocyst, and if PGT-A is done, not all will be euploid. That's normal — the funnel shows these typical steps so the final number is easier to read.",
      "detail_attrition_egg": "Not every retrieved egg becomes a baby. Some are immature, some don't survive thaw, some don't fertilize, and not every fertilization leads to pregnancy. That's normal — the funnel shows these steps to help you read the final number, not to predict what will happen to you.",
      "detail_family_target_embryo": "Depending on how many children you're planning for, we estimate a target of euploid embryos (roughly 2 for one, 4 for two, 6 for three). We divide that target by your per-cycle estimate to give you an idea of how many cycles this might take.",
      "detail_family_target_egg": "Depending on how many children you're planning for, we estimate a target of mature frozen eggs (roughly 15 for one, 28 for two, 42 for three). We divide that target by your per-cycle estimate to give you a rough idea — a higher count gives more margin, but quality matters as much as quantity.",
      "sources_title": "What this is based on",
      "sources_body": "These are population averages from published research — not a Louise-authored model. Your clinic is best placed to give you a number that fits your situation.",
      "sources_intro": "These are population averages from published research — not a Louise-authored model. Your clinic is best placed to give you a number that fits your situation.",
      "sources_item_retrieval_age": "Egg estimate from age — Machtinger et al., 2025.",
      "sources_item_retrieval_amh": "Estimate refined with AMH — La Marca et al., 2011.",
      "sources_item_retrieval_amh_afc": "Estimate refined with AMH and AFC — Choi et al., 2016.",
      "sources_item_goldman": "Goldman model — an idealized theoretical estimate we keep for reference, but don't fold into the shown live-birth chance.",
      "sources_item_doyle": "Live-birth chance by age band — Doyle et al., 2016.",
      "sources_item_cobo": "Live-birth chance per thawed egg — Cobo et al., 2016.",
      "get_personalized_estimate": "Get your personalized estimate",
      "how_many_eggs_question": "How many eggs may I get per cycle?",
      "bridge_estimate_text": "${value}. ${body} One cycle means one stimulation round plus one egg retrieval; some people do multiple cycles.",
      "know_your_numbers": "Know your numbers",
      "coverage_title_default": "Understand your likely costs",
      "coverage_title_sperm": "Understand banking and storage costs",
      "coverage_subtitle_default": "Check coverage status before comparing clinics or self-pay options.",
      "coverage_subtitle_sperm": "Check coverage status before comparing semen analysis, cryostorage, and self-pay options.",
      "coverage_tag_treatment": "Treatment",
      "coverage_treatment_body": "Clinic fees, monitoring, retrieval, lab work, and freezing can be estimated once we know the coverage path.",
      "coverage_treatment_footer": "Covered, partial, or self-pay",
      "coverage_tag_medication": "Medication",
      "coverage_medication_title": "Medication range",
      "coverage_medication_body": "Stim meds can be a large swing factor. Some plans cover pharmacy, some cover treatment only, and some require authorization.",
      "coverage_medication_footer": "Pharmacy benefits matter",
      "coverage_tag_benefits": "Benefits",
      "coverage_employer_title": "Employer programs",
      "coverage_employer_body": "Progyny, Carrot, Maven, Kindbody, direct employer benefits, HSA/FSA, and state rules can change the final estimate.",
      "coverage_employer_footer": "Not just fertility insurance",
      "coverage_tag_banking": "Banking",
      "coverage_sample_title": "Sample and storage estimate",
      "coverage_sample_body": "Semen analysis, collection, processing, freezing, and annual storage can be estimated once we know the coverage path.",
      "coverage_sample_footer": "Testing, banking, storage",
      "coverage_tag_retest": "Retest",
      "coverage_retest_title": "Baseline and repeat costs",
      "coverage_retest_body": "If you bank now and retest after a reset window, the estimate can separate the first sample from follow-up testing and extra vials.",
      "coverage_retest_footer": "Baseline + 90-day retest",
      "coverage_sperm_employer_body": "Employer benefits, HSA/FSA, self-pay bundles, storage fees, and fertility coverage rules can all change the final path.",
      "criterion_health_insurance": "Health insurance",
      "criterion_insurance_added": "Insurance added",
      "criterion_add_insurance": "Add insurance",
      "criterion_employer_benefits": "Employer benefits",
      "criterion_benefits_added": "Benefits added",
      "criterion_benefits_checked": "Benefits checked",
      "criterion_check_benefits": "Check benefits",
      "criterion_coverage_status": "Coverage status",
      "criterion_status_checked": "Status checked",
      "criterion_confirm_status": "Confirm status",
      "action_check_coverage_status": "Check coverage status",
      "action_open_cost_estimate": "Open cost estimate",
      "unlock_cost_estimate": "Unlock your cost estimate",
      "coverage_status_ready": "Coverage status is ready",
      "unlock_explainer": "We check health insurance, employer fertility benefits, and self-pay status. Some coverage can apply to diagnostics, medications, storage, or employer programs even when fertility treatment itself is not covered.",
      "ready_explainer": "We can now show the estimate with your known coverage path and keep refining it as benefits, authorizations, and clinic prices come in.",
      "step_1": "Step 1",
      "step_2": "Step 2",
      "step_3": "Step 3",
      "step_4": "Step 4",
      "step_5": "Step 5",
      "opt_step_1_title": "Get your baseline",
      "opt_step_1_body": "Start before your cycle with the numbers and history that help explain likely response and what could change the plan.",
      "opt_step_1_bullet_1": "AMH, AFC, age, and prior response help estimate likely yield",
      "opt_step_1_bullet_2": "Day 2-3 hormones, thyroid, vitamin D, and metabolic markers may matter",
      "opt_step_1_bullet_3": "Your history helps decide what is worth testing now",
      "opt_step_1_detail_title": "Baseline testing and history",
      "opt_step_1_s1_title": "Why this comes first",
      "opt_step_1_s1_body": "Optimization should start with what is measurable and actionable. AMH, AFC, age, history, and selected labs can help estimate likely response and identify issues that could change timing or safety.",
      "opt_step_1_s2_title": "Do not test everything blindly",
      "opt_step_1_s2_body": "Testing is most useful when it can change a next step: treatment planning, deficiency correction, medication safety, or whether to involve a specialist.",
      "opt_step_2_body": "Start now with one of the clearest, lowest-cost places to act. This is not about buying a stack of products.",
      "opt_step_2_bullet_1": "Stop smoking or vaping if possible",
      "opt_step_2_bullet_2": "Review alcohol, cannabis, and environmental exposures",
      "opt_step_2_bullet_3": "Prioritize sleep and recovery over extreme routines",
      "opt_step_2_cta": "Build my plan",
      "opt_step_2_detail_title": "Oxidative stress and exposures",
      "opt_step_2_s1_title": "Why people talk about oxidative stress",
      "opt_step_2_s1_body": "Oxidative stress can affect cells, including reproductive cells. Smoking and vaping are among the clearest modifiable exposure categories to address before fertility treatment.",
      "opt_step_2_s2_title": "Avoid perfectionism",
      "opt_step_2_s2_body": "The point is not to eliminate every possible exposure. It is to identify the big, realistic changes that matter for your situation.",
      "opt_step_3_title": "Support sleep, nutrition, and metabolic health",
      "opt_step_3_body": "Over the weeks before treatment, address patterns that can affect hormones, inflammation, and cycle planning.",
      "opt_step_3_bullet_1": "Especially relevant for PMOS (ex PCOS), irregular cycles, or insulin resistance",
      "opt_step_3_bullet_2": "Protein, fiber, movement, and sleep can support metabolic stability",
      "opt_step_3_bullet_3": "Medication changes should be clinician-guided",
      "opt_step_3_cta": "Complete health history",
      "opt_step_3_detail_title": "Sleep, nutrition, and metabolic context",
      "opt_step_3_s1_title": "Why this matters",
      "opt_step_3_s1_body": "Metabolic and hormone patterns can affect stimulation planning, medication choice, safety, and sometimes the timing of a cycle.",
      "opt_step_3_s2_title": "What is practical",
      "opt_step_3_s2_body": "The goal is not extreme dieting. It is stable meals, appropriate movement, sleep, and treatment of clear issues such as thyroid dysfunction or insulin resistance when present.",
      "opt_step_4_title": "Review supplements by evidence level",
      "opt_step_4_body": "Before starting anything new, review supplements by evidence level. This should be a review, not a shopping list.",
      "opt_step_4_bullet_1": "Stronger/common baseline: prenatal or folate when relevant; vitamin D if deficient",
      "opt_step_4_bullet_2": "Moderate/common discussion: CoQ10",
      "opt_step_4_bullet_3": "Context-specific or clinician-guided: myo-inositol, omega-3, DHEA, hormone-like supplements",
      "opt_step_4_cta": "Review supplement evidence",
      "opt_step_4_detail_title": "Supplement evidence tiers",
      "opt_step_4_s1_title": "Why this gets confusing",
      "opt_step_4_s1_body": "Online fertility spaces often mix personal anecdotes, clinic habits, and limited studies. That can make supplements feel mandatory even when the evidence is mixed or person-specific.",
      "opt_step_4_s2_title": "The useful question",
      "opt_step_4_s2_body": "The question is not 'what does everyone take?' It is 'what has evidence, what is relevant to my diagnosis, and what could interact with my meds or protocol?'",
      "opt_step_4_s3_title": "Clinician-guided category",
      "opt_step_4_s3_body": "DHEA and hormone-like supplements should not be started casually. They may be inappropriate for some diagnoses and should be reviewed with a clinician.",
      "opt_step_5_title": "Track and personalize",
      "opt_step_5_body": "Louise can help turn your history, labs, meds, supplements, exposures, and timeline into a practical pre-cycle plan.",
      "opt_step_5_bullet_1": "Use labs, history, age, timeline, and goals",
      "opt_step_5_bullet_2": "Decide what is worth doing now and what can wait",
      "opt_step_5_bullet_3": "Explain what is worth paying for and what is not",
      "opt_step_5_cta": "Build my optimization protocol",
      "opt_step_5_detail_title": "Targeted optimization protocol",
      "opt_step_5_s1_title": "What the review should do",
      "opt_step_5_s1_body": "A good optimization review should translate history, labs, medications, supplements, exposures, and goals into a practical plan.",
      "opt_step_5_s2_title": "What it should avoid",
      "opt_step_5_s2_body": "It should avoid generic fear-based lists, unsupported promises, and expensive steps that do not change treatment planning."
    },
    "recorded_birth": {
      "a_baby_was_born": "Your baby was born",
      "babies_were_born": "Your babies were born",
      "congratulations_close_whenever_you_are_ready": "Congratulations. It's saved to this cycle \u2014 close it whenever you're ready, and it moves into your history.",
      "keep_this_with_your_records": "Keep this with your records",
      "the_record_stays_and_louise_holds_your_questions": "Everything recorded against this cycle stays in your records. Louise can hold a question until you want to ask it.",
      "ask_louise_your_questions": "Ask Louise your questions",
      "the_result_stays_with_your_records": "The result stays with your records",
      "the_cycle_joins_your_history_once_closed": "The cycle joins your history once it's closed",
      "chat_prompt_after_a_birth": "My fertility treatment ended in a birth. Help me put together the questions I want to ask my care team, and what is worth keeping in my records. Do not make a diagnosis or change my medication plan.",
      "supporting": {
        "congratulations_to_you_both": "Congratulations to you both. It's saved to this cycle."
      }
    },
    "standing_pregnancy": {
      "congratulations_its_positive": "Congratulations — it's positive",
      "saved_and_tell_us_where_you_are": "It's saved to this cycle. Take the time you need; when you want to, tell us where you are and we'll date what comes next.",
      "supporting": {
        "congratulations_to_you_both": "Congratulations to you both. It's saved to this cycle."
      }
    },
    "closed_without_a_result": {
      "this_cycle_is_closed": "This cycle is closed",
      "what_stays_in_your_records": "What stays in your records",
      "nothing_here_needs_deciding_today": "Nothing here needs a decision today. It is here when you want it.",
      "review_this_cycle": "Review this cycle",
      "take_a_breath_the_record_is_kept_and_can_wait": "Take a breath \u2014 nothing needs deciding today. Everything recorded against this cycle stays in your records, and you can tell us how it ended whenever you want to.",
      "supporting": {
        "this_cycle_is_closed": "This cycle is closed",
        "the_record_is_kept_and_nothing_needs_doing": "Take a breath. Everything recorded against this cycle is kept, and nothing needs doing today."
      }
    },
    "cycle_closing": {
      "ui": {
        "close_cycle": "Close this cycle",
        "review_cycle": "Review this cycle",
        "done": "Got it",
        "done_early": "Got it",
        "open_cycle": "Open this cycle"
      },
      "conceiving": {
        "pregnancy": {
          "positive_result": "A positive result",
          "positive_result_clinic_guidance": "Congratulations. There's nothing to decide today — your clinic will confirm what comes next.",
          "supporting": {
            "positive_result": "A positive result",
            "positive_result_shared_clinic_guidance": "Congratulations to you both. Your part in this cycle is done — the clinic will guide the next steps."
          }
        },
        "no_pregnancy": {
          "cycle_is_complete": "This cycle is complete",
          "no_pregnancy_context": "This one didn't end in a pregnancy. Nothing needs deciding today, and nothing about this was your fault.",
          "supporting": {
            "cycle_is_complete": "This cycle is complete",
            "no_pregnancy_support_context": "This one didn't end in a pregnancy. There's nothing to fix today — being there is enough."
          }
        },
        "loss": {
          "cycle_ended_in_loss": "This cycle ended in a loss",
          "loss_care_guidance": "We're so sorry. Take the time you need. Your care team is the right place for what comes next.",
          "supporting": {
            "cycle_ended_in_loss": "This cycle ended in a loss",
            "loss_support_guidance": "We're so sorry. Take the time you both need — there's nothing you need to do today."
          }
        },
        "cancelled": {
          "cycle_was_cancelled": "This cycle was cancelled",
          "cancelled_cycle_guidance": "A cancelled cycle isn't a result. Whatever the reason, stopping was a reasonable thing to do."
        },
        "unresolved": {
          "result_is_not_settled": "This result isn't settled yet",
          "unresolved_result_guidance": "We don't have enough to call this one way or the other, so we won't guess. Your clinic can confirm it."
        }
      },
      "preservation": {
        "complete": {
          "preservation_reached_completion": "You went all the way through",
          "stored_materials_are_ready": "That asked a lot of you, and it's done. What you've stored is yours to use when you're ready."
        },
        "cancelled": {
          "cycle_was_cancelled": "This cycle was cancelled",
          "preservation_cancellation_guidance": "Nothing was stored this time. Stopping was a reasonable thing to do, and it can be tried again."
        },
        "unresolved": {
          "result_is_not_settled": "This cycle's ending isn't settled yet",
          "preservation_result_guidance": "We don't have enough information to describe what happened. Your care team can confirm it."
        }
      },
      "donation": {
        "complete": {
          "donation_is_complete": "Your donation is complete",
          "donation_acknowledgement": "Thank you — that was a generous thing to do."
        },
        "cancelled": {
          "cycle_was_cancelled": "This cycle was cancelled",
          "donation_cancellation_guidance": "This donation cycle didn't go ahead. Stopping was a reasonable thing to do."
        },
        "unresolved": {
          "result_is_not_settled": "This donation cycle's ending isn't settled yet",
          "donation_result_guidance": "We don't have enough information to describe what happened. Your care team can confirm it."
        }
      },
      "surrogacy": {
        "pregnancy": {
          "positive_result": "A positive result",
          "positive_result_clinic_guidance": "Congratulations. Your clinic and your surrogate's care team will guide what comes next.",
          "supporting": {
            "positive_result": "A positive result",
            "positive_result_shared_clinic_guidance": "Congratulations to you both. The clinic and your surrogate's care team will guide the next steps."
          }
        },
        "no_pregnancy": {
          "cycle_is_complete": "This cycle is complete",
          "no_pregnancy_context": "This one didn't end in a pregnancy. Nothing needs deciding today.",
          "supporting": {
            "cycle_is_complete": "This cycle is complete",
            "no_pregnancy_support_context": "This one didn't end in a pregnancy. There's nothing to fix today."
          }
        },
        "loss": {
          "cycle_ended_in_loss": "This cycle ended in a loss",
          "loss_care_guidance": "We're so sorry. Take the time you need — for you and for your surrogate.",
          "supporting": {
            "cycle_ended_in_loss": "This cycle ended in a loss",
            "loss_support_guidance": "We're so sorry. Take the time you both need."
          }
        },
        "cancelled": {
          "cycle_was_cancelled": "This cycle was cancelled",
          "cancelled_cycle_guidance": "A cancelled cycle isn't a result. Stopping was a reasonable thing to do."
        },
        "unresolved": {
          "result_is_not_settled": "This result isn't settled yet",
          "unresolved_result_guidance": "We don't have enough to call this one way or the other, so we won't guess."
        }
      },
      "slides": {
        "conceiving": {
          "now": {
            "nothing_needs_deciding_today": "Nothing to decide today",
            "saved_result_can_wait": "You don't have to choose what happens next right now. This result is saved, and it will still be here when you're ready to look at it."
          },
          "next": {
            "cycle_history": "Where things are",
            "cycle_history_guidance": "The result and everything recorded with it live in this cycle's history. Louise can hold your questions until your next appointment."
          }
        },
        "preservation": {
          "now": {
            "nothing_needs_deciding_today": "Nothing to decide today",
            "stored_materials_can_wait": "There's no next step to choose right now. What you've stored stays stored, and you can come back to it whenever you want."
          },
          "next": {
            "cryo_vault": "What you've stored",
            "cryo_vault_guidance": "Your cryo vault has what was frozen and where it's kept. Storage details and costs live there too."
          }
        },
        "donation": {
          "now": {
            "nothing_needs_deciding_today": "Nothing to decide today",
            "donation_needs_no_action": "Your part is done. There's nothing you need to do now."
          },
          "next": {
            "cycle_record": "Where things are",
            "cycle_record_guidance": "This cycle's record has what was collected and when. Louise can hold any questions you still have."
          }
        },
        "surrogacy": {
          "now": {
            "nothing_needs_deciding_today": "Nothing to decide today",
            "saved_result_can_wait": "You don't have to choose what happens next right now. This result is saved, and it will still be here when you're ready."
          },
          "next": {
            "cycle_history": "Where things are",
            "cycle_history_guidance": "The result and everything recorded with it live in this cycle's history. Louise can hold your questions until your next conversation."
          }
        }
      }
    },
    "review_concept": {
      "today_done_banner_title": "All set for today.",
      "today_done_banner_subtitle": "Tiny victories count. Today is done.",
      "today_empty_banner_title": "Nothing scheduled today.",
      "today_empty_banner_subtitle": "Medications and appointments you add will show up here.",
      "future_use_vault_unavailable_title": "Your vault is temporarily unavailable.",
      "future_use_vault_unavailable_subtitle": "We couldn't load the records behind this projection. Open your Cryo Vault to review them.",
      "future_use_vault_partial_title": "Some vault records are still loading.",
      "future_use_vault_partial_subtitle": "This projection will update when the remaining storage records are available.",
      "peek_at_tomorrow": "Peek at tomorrow",
      "peek_a11y": "Take a peek ahead",
      "peek_dialog_title": "A peek ahead",
      "peek_dialog_subtitle": "The next few days may shift after monitoring, but this is the current plan.",
      "peek_nothing_scheduled_title": "Nothing scheduled yet.",
      "peek_nothing_scheduled_detail": "If the clinic adds something, it will show up here.",
      "peek_day_tomorrow": "Tomorrow",
      "dialog_cancel": "Cancel",
      "dialog_close": "Close",
      "dialog_save": "Save",
      "cycle_status_review_title": "Let's keep this cycle open to the facts",
      "cycle_status_review_summary": "A cancelled or changed treatment path is not the same as a negative result. Review what was recorded and confirm the next step with your care team.",
      "post_procedure": {
        "subtitle": "A quick check-in helps us move you to the right next step.",
        "back": "Back",
        "yes_title": "Yes, it happened",
        "yes_detail": "Tell us the date and anything you want to remember.",
        "not_yet_title": "Not yet",
        "not_yet_detail": "We'll leave this hand-off here so you can come back after it happens.",
        "not_yet_details_title": "Not yet",
        "not_yet_details_prompt": "If you want, add a note about the timing or what you're waiting for.",
        "not_yet_notes_placeholder": "Anything about the delay or next step...",
        "not_yet_save": "Save and keep the hand-off",
        "cancelled_title": "It was cancelled",
        "cancelled_detail": "We'll keep this from prompting you again for now.",
        "cancelled_details_title": "It was cancelled",
        "cancelled_details_prompt": "If you want, add anything you'd like to remember about the cancellation.",
        "cancelled_notes_placeholder": "Anything you want to remember about the cancellation...",
        "cancelled_save": "Save and close",
        "cancellation_title": "What happens next?",
        "cancellation_prompt": "A cancelled procedure does not always mean the whole cycle is over.",
        "rescheduled_title": "It will be rescheduled",
        "rescheduled_detail": "Keep the cycle open and add any note about the new plan.",
        "rescheduled_details_title": "Add a note about the new plan",
        "rescheduled_details_prompt": "If you know what happens next, you can add it here.",
        "rescheduled_date_label": "New scheduled date and time (time optional)",
        "rescheduled_notes_placeholder": "Anything about the new date or next step...",
        "rescheduled_save": "Save and keep the cycle open",
        "cycle_cancelled_title": "The cycle is ending",
        "cycle_cancelled_detail": "We'll guide you through closing the whole cycle.",
        "not_sure_title": "I'm not sure yet",
        "not_sure_detail": "Keep the cycle open while you wait for the clinic.",
        "not_sure_details_title": "Keep this open for now",
        "not_sure_details_prompt": "If you want, add a note while you wait for the clinic's next step.",
        "not_sure_notes_placeholder": "Anything you want to remember while you wait...",
        "not_sure_save": "Save and keep this open",
        "embryos_label": "Embryos transferred (optional)",
        "embryos_placeholder": "e.g. 1",
        "notes_label": "Notes (optional)",
        "notes_placeholder": "Anything you want to remember or ask the clinic...",
        "save_and_continue": "Save and start the wait",
        "save_failed": "We couldn't save this procedure yet. Please try again.",
        "transfer": {
          "title": "Did your embryo transfer happen?",
          "prompt": "If it did, add the date and any details you'd like to keep with your cycle.",
          "question": "Your transfer was scheduled for today. What happened?",
          "date_label": "Transfer date and time",
          "details_subtitle": "Tell us about your transfer",
          "handoff_title": "Your transfer day",
          "handoff_body": "When you're ready, tell us how your embryo transfer went. We'll carry the right date into your two-week wait.",
          "handoff_cta": "Tell us what happened",
          "handoff_check_1": "Confirm the procedure",
          "handoff_check_2": "Add notes for later",
          "handoff_check_3": "Start the two-week wait"
        },
        "insemination": {
          "title": "Did your IUI happen?",
          "prompt": "If it did, add the date and any details you'd like to keep with your cycle.",
          "question": "Your IUI was scheduled for today. What happened?",
          "date_label": "IUI date and time",
          "details_subtitle": "Tell us about your IUI",
          "handoff_title": "Your IUI day",
          "handoff_body": "When you're ready, tell us how your IUI went. We'll carry the right date into your two-week wait.",
          "handoff_cta": "Tell us what happened",
          "handoff_check_1": "Confirm the procedure",
          "handoff_check_2": "Add notes for later",
          "handoff_check_3": "Start the two-week wait"
        },
        "ovulation_window": {
          "title": "Did your ovulation window happen?",
          "prompt": "If it did, add the date and any details you'd like to keep with your cycle.",
          "question": "Your ovulation window was scheduled for today. What happened?",
          "date_label": "Procedure date and time",
          "details_subtitle": "Tell us what happened",
          "handoff_title": "Your ovulation window",
          "handoff_body": "When you're ready, tell us what happened. We'll carry the right date into your next wait.",
          "handoff_cta": "Tell us what happened",
          "handoff_check_1": "Confirm the procedure",
          "handoff_check_2": "Add notes for later",
          "handoff_check_3": "Start the next wait"
        }
      },
      "log_prefix": "Log ${title}",
      "log_monitoring_visit_title": "Log monitoring visit",
      "log_monitoring_results_title": "Log monitoring results",
      "log_symptoms_title": "Log symptoms",
      "log_medication_summary": "Confirm how the dose went. If anything was late, missed, painful, or unclear, add it here.",
      "log_monitoring_summary": "Add the ultrasound and bloodwork values from this visit. You can come back and edit them later.",
      "log_appointment_summary": "Confirm the appointment status and add any result or follow-up note.",
      "log_monitoring_results_summary": "Choose the visit date, then add ultrasound and bloodwork values.",
      "log_symptoms_summary": "Choose the day, add symptoms, and flag anything that feels worse than expected.",
      "log_monitoring_results_unavailable_summary": "Monitoring entry from Home is not connected to saved Care records yet.",
      "log_appointment_unavailable_summary": "Appointment completion from Home is not connected to saved Care records yet.",
      "log_task_unavailable_summary": "This Home task is not connected to saved Care records yet.",
      "log_task_summary": "Confirm what happened and add anything you want to remember.",
      "log_symptoms_unavailable_summary": "Symptom check-ins from Home are not connected to saved Care records yet.",
      "completion_unavailable_monitoring": "Louise cannot save monitoring results from Home yet, so this item was not marked complete. Use Care if you need to update saved records.",
      "completion_unavailable_appointment": "Louise cannot save appointment completion from Home yet, so this item was not marked complete. Use Care if you need to update saved records.",
      "completion_unavailable_task": "Louise cannot save this Home task yet, so it was not marked complete.",
      "completion_unavailable_symptoms": "Louise cannot save symptom check-ins from Home yet. Nothing was saved.",
      "field_notes": "Notes",
      "field_estradiol": "Estradiol",
      "field_estradiol_e2": "Estradiol (E2)",
      "field_lh": "LH",
      "field_progesterone": "Progesterone",
      "field_lining": "Lining",
      "field_lead_follicle": "Lead follicle",
      "field_left_ovary_follicles": "Left ovary follicles",
      "field_right_ovary_follicles": "Right ovary follicles",
      "field_clinic_notes": "Clinic notes",
      "field_weight_change": "Weight change",
      "field_result_or_followup": "Result or follow-up",
      "field_severity": "Severity",
      "field_symptoms": "Symptoms",
      "placeholder_e2_example": "e.g. 1820",
      "placeholder_follicle_example": "e.g. 18",
      "placeholder_lh_example": "e.g. 12.4",
      "placeholder_progesterone_example": "e.g. 1.2",
      "placeholder_lining_example": "e.g. 8",
      "placeholder_optional": "optional",
      "placeholder_follicle_sizes": "Sizes in mm, comma-separated",
      "placeholder_medication_notes": "Dose issue, injection site, side effect, or anything to ask the clinic...",
      "placeholder_monitoring_notes": "Dose changes, trigger guidance, next visit, questions...",
      "placeholder_clinic_notes": "Dose changes, trigger guidance, questions for the clinic...",
      "placeholder_appointment_result": "Results, instructions, next steps, or anything missing...",
      "placeholder_generic_notes": "Anything you want to remember...",
      "placeholder_symptom_notes": "What changed, what helped, or what you want the care team to know...",
      "medication_log_on_time_label": "Taken on time",
      "medication_log_on_time_detail": "Dose was taken at the scheduled time.",
      "medication_log_late_label": "Taken late",
      "medication_log_late_detail": "Dose was taken outside the target window.",
      "medication_log_missed_label": "Missed dose",
      "medication_log_missed_detail": "Dose was missed. Add a note for injection problems, side effects, or supply issues.",
      "medication_log_skipped_label": "Skipped dose",
      "medication_log_skipped_detail": "Dose was intentionally not taken. Add a note if you want to remember why.",
      "medication_log_missing_medication_id": "This medication is missing its saved ID, so the dose could not be logged.",
      "medication_log_save_failed": "We couldn't save this dose. Your selections are still here. Save again when you're ready.",
      "appointment_log_complete_label": "Completed",
      "appointment_log_complete_detail": "Visit happened as planned.",
      "appointment_log_rescheduled_label": "Rescheduled",
      "appointment_log_rescheduled_detail": "The appointment moved to another time.",
      "appointment_log_issue_label": "Need help",
      "appointment_log_issue_detail": "Something is missing or needs follow-up.",
      "monitoring_log_attended_label": "I attended this visit",
      "monitoring_log_attended_detail": "The visit happened. This does not record clinical measurements.",
      "task_log_complete_label": "Completed",
      "task_log_complete_detail": "This patient action is done.",
      "action_log_save_failed": "We couldn't save this completion. Please try again.",
      "attach_document": "Attach a document",
      "attach_document_detail": "Add a clinic report, image, or PDF with this action.",
      "symptom_bloating": "Bloating",
      "symptom_cramping": "Cramping",
      "symptom_headache": "Headache",
      "symptom_fatigue": "Fatigue",
      "symptom_nausea": "Nausea",
      "symptom_mood_changes": "Mood changes",
      "severity_none": "None",
      "severity_mild": "Mild",
      "severity_moderate": "Moderate",
      "severity_severe": "Severe",
      "log_date_today": "Today",
      "log_date_yesterday": "Yesterday",
      "log_date_cycle_day": "Day ${day}",
      "log_for_a11y": "Log for ${label}",
      "complete_for_a11y": "Complete ${label}",
      "completed_a11y": "${label} completed",
      "optimize_step_label": "Step 3: Improve inputs",
      "optimize_step_label_iui": "Step 3: Get ready",
      "optimize_title_default": "What can be optimized",
      "optimize_title_ivf": "What can be optimized before IVF",
      "optimize_title_iui": "What can be tightened before IUI",
      "optimize_title_amab": "What can be optimized or coordinated",
      "optimize_subtitle_default": "If sperm is part of the plan, start there: the roughly 72-day sperm window is usually the highest-agency optimization lane.",
      "optimize_subtitle_ivf": "Use the pre-cycle window to line up sperm source, ovarian-side testing, transfer readiness, exposures, and lab decisions.",
      "optimize_subtitle_iui": "IUI readiness is mostly timing, tube status, sperm logistics, and clinic cancellation rules.",
      "optimize_subtitle_amab": "Start with sperm agency, then keep egg source, donor or carrier requirements, lab method, and legal timing connected.",
      "optimize_action_title_default": "Start a personalized optimization plan",
      "optimize_action_title_ivf": "Start a personalized IVF preparation plan",
      "optimize_action_title_iui": "Build an IUI readiness plan",
      "optimize_action_title_amab": "Start a family-building coordination plan",
      "optimize_action_subtitle_default": "Review testing, supplements, exposures, and timing based on both sides of the plan.",
      "optimize_action_subtitle_ivf": "Review testing, supplements, exposures, sperm source, transfer route, and timing based on both sides of the IVF plan.",
      "optimize_action_subtitle_iui": "Review monitoring, trigger timing, sperm source, meds, and beta-test timing before cycle day 1.",
      "optimize_action_subtitle_amab": "Review sperm testing, donor or carrier readiness, legal steps, storage, and clinic sequencing.",
      "optimize_action_cta": "Start optimization plan",
      "optimize_default_sperm_eyebrow": "Sperm side",
      "optimize_default_sperm_title": "Highest-agency window: sperm",
      "optimize_default_sperm_body": "When sperm is part of the plan, this is often the clearest optimization lane because sperm develops over roughly a 72-day window.",
      "optimize_default_sperm_bullet_1": "Start with semen analysis so the plan is not guessing",
      "optimize_default_sperm_bullet_2": "Review heat, fever, smoking, alcohol, cannabis, medications, anabolic hormones, and supplements",
      "optimize_default_sperm_bullet_3": "Decide if repeat testing, urology, backup freezing, or ICSI planning is useful",
      "optimize_default_sperm_cta": "Start sperm plan",
      "optimize_default_egg_eyebrow": "Egg side",
      "optimize_default_egg_title": "Support the ovarian side",
      "optimize_default_egg_body": "Egg age cannot be reversed, but the cycle can still be planned around reserve, response, safety, and avoidable risks before retrieval.",
      "optimize_default_egg_bullet_1": "Use AMH, AFC, history, and prior response to plan timing",
      "optimize_default_egg_bullet_2": "Review medications, supplements, smoking, alcohol, cannabis, and exposures",
      "optimize_default_egg_bullet_3": "Address sleep, metabolic context, thyroid, vitamin D, or clear deficiencies when relevant",
      "optimize_default_egg_cta": "Check ovarian reserve",
      "optimize_iui_timing_eyebrow": "Timing",
      "optimize_iui_timing_title": "Make ovulation timing precise",
      "optimize_iui_timing_body": "IUI success depends heavily on sperm being present close to ovulation, so monitoring, LH testing, and trigger timing should be clear before the cycle starts.",
      "optimize_iui_timing_bullet_1": "Decide natural, oral-medication, injectable, or trigger protocol",
      "optimize_iui_timing_bullet_2": "Confirm how follicle size, LH surge, and bloodwork are tracked",
      "optimize_iui_timing_bullet_3": "Know when the clinic schedules IUI after trigger or surge",
      "optimize_iui_timing_cta": "Check timing plan",
      "optimize_iui_sperm_eyebrow": "Sperm side",
      "optimize_iui_sperm_title": "Confirm sperm source and post-wash fit",
      "optimize_iui_sperm_body": "For IUI, sperm count after washing, donor inventory, collection timing, and backup plans can decide whether the cycle is practical.",
      "optimize_iui_sperm_bullet_1": "Review semen analysis and expected post-wash motile count",
      "optimize_iui_sperm_bullet_2": "Confirm fresh, frozen partner, or donor-sperm logistics",
      "optimize_iui_sperm_bullet_3": "Decide if IVF should be discussed before using more vials or attempts",
      "optimize_iui_sperm_cta": "Check sperm plan",
      "optimize_iui_tube_eyebrow": "Tubes + uterus",
      "optimize_iui_tube_title": "Remove avoidable fit problems",
      "optimize_iui_tube_body": "Because fertilization happens inside the body, tubal status and uterine readiness matter before investing in IUI attempts.",
      "optimize_iui_tube_bullet_1": "Confirm whether HSG, HyCoSy, or prior imaging is needed",
      "optimize_iui_tube_bullet_2": "Review uterine cavity findings if your clinic recommends it",
      "optimize_iui_tube_bullet_3": "Clarify cancellation rules for too many follicles or poor timing",
      "optimize_iui_tube_cta": "Find evaluation",
      "optimize_amab_sperm_eyebrow": "Sperm side",
      "optimize_amab_sperm_title": "Highest-agency window: sperm",
      "optimize_amab_sperm_body": "When sperm is your contribution, semen analysis, urology, exposure review, and backup freezing may be the most actionable pre-cycle work.",
      "optimize_amab_sperm_bullet_1": "Start with semen analysis so the plan is not guessing",
      "optimize_amab_sperm_bullet_2": "Review heat, fever, smoking, alcohol, cannabis, medications, anabolic hormones, and supplements",
      "optimize_amab_sperm_bullet_3": "Decide if repeat testing, urology, backup freezing, surgical sperm, or donor sperm is useful",
      "optimize_amab_sperm_cta": "Start sperm plan",
      "optimize_amab_egg_eyebrow": "Egg source",
      "optimize_amab_egg_title": "Coordinate the ovarian-side source",
      "optimize_amab_egg_body": "Donor, partner, or known-source eggs determine the retrieval timeline, screening needs, legal work, and lab handoff.",
      "optimize_amab_egg_bullet_1": "Confirm fresh donor, frozen donor, partner, or known-source path",
      "optimize_amab_egg_bullet_2": "Track screening, infectious disease labs, genetic screening, and consent",
      "optimize_amab_egg_bullet_3": "Know whether sperm needs to be ready before eggs are shipped or retrieved",
      "optimize_amab_egg_cta": "Compare sources",
      "optimize_amab_carrier_eyebrow": "Carrier route",
      "optimize_amab_carrier_title": "Keep transfer logistics visible early",
      "optimize_amab_carrier_body": "If a gestational carrier is part of the plan, legal, agency, clinic, and medical-screening steps can run before embryos exist.",
      "optimize_amab_carrier_bullet_1": "Clarify whether embryos are being created for carrier transfer",
      "optimize_amab_carrier_bullet_2": "Track legal, agency, clinic, and medical-screening readiness",
      "optimize_amab_carrier_bullet_3": "Connect PGT, storage, shipping, and transfer preferences",
      "optimize_amab_carrier_cta": "Review route",
      "clinic_step_label_egg": "Step 3: Choose your clinic",
      "clinic_step_label_find_care": "Step 4: Find care",
      "clinic_search_subtitle_egg_freezing": "Search clinics, labs, and providers for egg freezing.",
      "clinic_search_subtitle_embryo_freezing": "Search clinics, embryology labs, and providers for embryo freezing.",
      "clinic_search_subtitle_sperm_freezing": "Search labs, clinics, and sperm banks for semen analysis, cryopreservation, and storage.",
      "clinic_search_subtitle_ivf": "Search IVF clinics, embryology labs, monitoring options, and transfer programs.",
      "clinic_search_subtitle_iui": "Search clinics that can handle monitoring, trigger timing, sperm prep, weekend coverage, and IUI procedures.",
      "clinic_search_subtitle_amab": "Search IVF clinics, embryology labs, donor egg programs, sperm services, carrier support, and legal-aware care teams.",
      "clinic_matches_title_clinics": "Clinics selected for you",
      "clinic_matches_title_labs": "Labs selected for you",
      "clinic_matches_title_ivf": "IVF clinics selected for you",
      "clinic_matches_title_iui": "IUI clinics selected for you",
      "clinic_matches_title_amab": "Family-building care selected for you",
      "clinic_matches_subtitle_egg_freezing": "A shortlist based on your location, coverage status, and what matters for this cycle.",
      "clinic_matches_subtitle_embryo_freezing": "A shortlist based on your location, coverage status, embryo lab needs, and what matters for this cycle.",
      "clinic_matches_subtitle_sperm_freezing": "A shortlist based on your location, coverage status, testing needs, collection preferences, and storage fit.",
      "clinic_matches_subtitle_ivf": "A shortlist based on your location, coverage status, lab needs, transfer route, and sperm or donor requirements.",
      "clinic_matches_subtitle_iui": "A shortlist based on location, coverage, monitoring access, sperm source, tube testing, and appointment timing.",
      "clinic_matches_subtitle_amab": "A shortlist based on sperm plan, egg source, carrier route, lab needs, location, coverage, and coordination complexity.",
      "clinic_locked_description_egg_freezing": "We use your health history, location, and coverage status to make matches relevant. Coverage status can mean benefits or self-pay.",
      "clinic_locked_description_embryo_freezing": "We use your health history, location, coverage status, and embryo-freezing preferences to make matches relevant. Coverage status can mean benefits or self-pay.",
      "clinic_locked_description_sperm_freezing": "We use your health history, location, coverage status, and sample-banking preferences to make matches relevant. Coverage status can mean benefits or self-pay.",
      "clinic_locked_description_ivf": "We use your health history, location, coverage status, ovarian-side testing, sperm source, and transfer preferences to make IVF matches relevant.",
      "clinic_locked_description_iui": "We use your health history, location, coverage status, ovulation plan, tube status, and sperm source to make IUI matches relevant.",
      "clinic_locked_description_amab": "We use your sperm source, egg source, carrier route, history, location, and coverage status to make family-building care matches relevant.",
      "clinic_empty_description_default": "Your requirements are ready, but clinic match data is not connected here yet. You can still search the Find Care directory.",
      "clinic_empty_description_labs": "Your requirements are ready, but lab match data is not connected here yet. You can still search the Find Care directory.",
      "clinic_empty_description_ivf": "Your requirements are ready, but IVF match data is not connected here yet. You can still search the Find Care directory.",
      "clinic_empty_description_iui": "Your requirements are ready, but IUI match data is not connected here yet. You can still search the Find Care directory.",
      "clinic_empty_description_amab": "Your requirements are ready, but family-building match data is not connected here yet. You can still search the Find Care directory.",
      "clinic_action_find_care": "Find care",
      "clinic_action_see_matches": "See clinic matches",
      "clinic_action_complete_history": "Complete medical history",
      "clinic_action_check_coverage": "Check coverage status",
      "clinic_action_add_location": "Add location",
      "clinic_criteria_history_label": "History",
      "clinic_criteria_history_done": "History added",
      "clinic_criteria_history_missing": "Complete history",
      "clinic_criteria_location_label": "Location",
      "clinic_criteria_location_done": "Location added",
      "clinic_criteria_location_missing": "Add location",
      "clinic_criteria_coverage_label": "Coverage status",
      "clinic_criteria_coverage_done": "Coverage checked",
      "clinic_criteria_coverage_missing": "Check coverage",
      "concierge_title": "Concierge matching program",
      "concierge_body": "Get help coordinating testing, doctor fit, clinic access, and savings options before you commit.",
      "concierge_tag_testing": "Testing",
      "concierge_tag_doctors": "Doctors",
      "concierge_tag_savings": "Savings",
      "concierge_explore_label": "Explore concierge matching",
      "cycle_start_title": "Starting soon?",
      "cycle_start_body": "When your clinic gives you a date, this becomes your treatment home for the days ahead.",
      "cycle_start_cta": "Set cycle start",
      "cycle_start_checklist_timing": "Cycle timing",
      "cycle_start_checklist_medication": "Medication schedule",
      "cycle_start_checklist_monitoring": "Monitoring plan",
      "cycle_start_checklist_daily_guidance": "Daily guidance",
      "cycle_start_action_label": "Set your start date",
      "understand_step_label": "Step 1: Understand",
      "understand_default_title": "How embryo freezing works",
      "understand_default_subtitle": "Start with the three moving parts, then swipe through the full biology and lab sequence.",
      "understand_attrition_embryo_title": "How many embryos might this become?",
      "understand_attrition_embryo_subtitle": "Estimate egg yield, embryo attrition, and how many cycles may be needed.",
      "understand_attrition_ivf_title": "How many embryos might this IVF cycle become?",
      "understand_attrition_ivf_subtitle": "Estimate egg yield, fertilization, blastocyst development, possible PGT-A, and transfer or freezing options.",
      "understand_attrition_amab_title": "How many embryos might the plan create?",
      "understand_attrition_amab_subtitle": "Estimate egg source yield, fertilization, blastocyst development, possible PGT-A, and transfer options.",
      "understand_compare_embryo_title": "Freezing eggs versus freezing embryos",
      "understand_compare_embryo_subtitle": "Compare flexibility, information gained, partner/legal implications, and future use.",
      "understand_compare_embryo_cta": "Freezing eggs versus freezing embryos",
      "understand_compare_ivf_title": "IVF, ICSI, testing, and transfer choices",
      "understand_compare_ivf_subtitle": "Review the lab and transfer decisions that should be clear before retrieval.",
      "understand_compare_ivf_cta": "Review IVF lab decisions",
      "understand_compare_amab_title": "Sperm, donor eggs, carriers, and embryos",
      "understand_compare_amab_subtitle": "Keep the sperm-side plan, egg source, legal steps, lab method, and transfer route connected.",
      "understand_compare_amab_cta": "Compare family-building paths",
      "understand_compare_iui_title": "When IUI stops being the right next step",
      "understand_compare_iui_subtitle": "Review the tubal, sperm, age, diagnosis, and repeated-attempt signals that may shift the plan toward IVF.",
      "understand_compare_iui_cta": "Review IUI fit",
      "process_embryo_ovarian_label": "Ovarian side",
      "process_embryo_ovarian_timing": "10-14 days",
      "process_embryo_ovarian_title": "Get eggs through ovarian stimulation",
      "process_embryo_sperm_label": "Sperm side",
      "process_embryo_sperm_timing": "1 day",
      "process_embryo_sperm_title": "Collect or thaw a semen sample",
      "process_embryo_lab_label": "Lab side",
      "process_embryo_lab_timing": "5-7 days",
      "process_embryo_lab_title": "Fertilize, culture, test or freeze embryos",
      "process_ivf_ovarian_label": "Ovarian side",
      "process_ivf_ovarian_timing": "10-14 days",
      "process_ivf_ovarian_title": "Stimulate follicles and retrieve eggs",
      "process_ivf_sperm_label": "Sperm side",
      "process_ivf_sperm_timing": "Before retrieval",
      "process_ivf_sperm_title": "Confirm source, testing, and backup",
      "process_ivf_lab_label": "Lab + transfer",
      "process_ivf_lab_timing": "5-7 days +",
      "process_ivf_lab_title": "Create embryos, freeze, test, or transfer",
      "process_amab_sperm_label": "Sperm plan",
      "process_amab_sperm_timing": "2-12 weeks",
      "process_amab_sperm_title": "Test, optimize, freeze backup, or use donor",
      "process_amab_egg_label": "Egg source",
      "process_amab_egg_timing": "Variable",
      "process_amab_egg_title": "Coordinate donor, partner, or known source",
      "process_amab_lab_label": "Lab + carrier",
      "process_amab_lab_timing": "5-7 days +",
      "process_amab_lab_title": "Create embryos and plan transfer route",
      "process_iui_fit_label": "Fit",
      "process_iui_fit_timing": "Before cycle",
      "process_iui_fit_title": "Confirm tubes, ovulation, and sperm plan",
      "process_iui_timing_label": "Timing",
      "process_iui_timing_timing": "Cycle days",
      "process_iui_timing_title": "Track follicle growth, LH, or trigger",
      "process_iui_procedure_label": "IUI + wait",
      "process_iui_procedure_timing": "1 day + beta",
      "process_iui_procedure_title": "Wash sperm, inseminate, then wait",
      "bio_callout_why_matters": "Why it matters",
      "bio_callout_why_stim": "Why stimulation exists",
      "bio_callout_key_distinction": "Key distinction",
      "bio_callout_reserve_note": "Reserve note",
      "bio_callout_procedure_note": "Procedure note",
      "bio_callout_what_to_know": "What to know",
      "bio_callout_timing": "Timing",
      "bio_callout_optimization_window": "Optimization window",
      "bio_callout_what_decides": "What decides it",
      "bio_callout_why_updates_hard": "Why updates can feel hard",
      "bio_callout_after_blastocyst": "After blastocyst",
      "bio_callout_what_does": "What it does",
      "bio_callout_important_limit": "Important limit",
      "bio_callout_how_long": "How long",
      "bio_callout_why_matters_freeze": "Why this matters",
      "bio_callout_before_starting": "Before starting",
      "bio_callout_test_examples": "Test examples",
      "bio_callout_safety": "Safety",
      "bio_callout_common_timing": "Common timing",
      "bio_callout_what_matters": "What matters",
      "bio_callout_afterward": "Afterward",
      "bio_callout_different_timeline": "Different timeline",
      "bio_callout_why_start_here": "Why start here",
      "bio_cta_test_ovarian": "Test ovarian reserve",
      "bio_cta_check_semen": "Check semen testing",
      "bio_cta_find_tube": "Find tube testing",
      "bio_emb_supply_label": "Egg quantity",
      "bio_emb_supply_title": "The ovarian side still starts with egg supply",
      "bio_emb_supply_body": "Embryo freezing usually starts with stimulation and retrieval, so age, AMH, AFC, and prior response still shape the likely egg count.",
      "bio_emb_supply_callout": "The embryo funnel starts with eggs. Fewer retrieved or mature eggs usually means fewer chances for embryos later.",
      "bio_emb_supply_detail_title": "Egg supply before embryo freezing",
      "bio_emb_supply_d1_title": "Embryos start with eggs",
      "bio_emb_supply_d1_body": "Even when the goal is embryos, the first biological constraint is often how many follicles respond and how many mature eggs are retrieved.",
      "bio_emb_supply_d2_title": "What testing can add",
      "bio_emb_supply_d2_body": "AMH, AFC, day 2-3 hormones, age, diagnosis, and prior cycle response help estimate likely yield and stimulation approach.",
      "bio_emb_normal_label": "Normal cycle",
      "bio_emb_normal_title": "Usually one egg ovulates in a month",
      "bio_emb_normal_body": "Each cycle, a small group of follicles starts growing. Usually one follicle becomes dominant and the others stop.",
      "bio_emb_normal_callout": "Embryo freezing tries to mature more of that same cycle's group so more eggs can enter the lab.",
      "bio_emb_normal_detail_title": "Normal cycle versus stimulation cycle",
      "bio_emb_normal_d1_title": "A small group starts together",
      "bio_emb_normal_d1_body": "A cohort of follicles starts responding during a cycle. In a typical menstrual cycle, one usually becomes dominant and ovulates.",
      "bio_emb_normal_d2_title": "Stimulation changes the outcome",
      "bio_emb_normal_d2_body": "Stimulation does not make new eggs. It tries to keep more of the recruited follicles growing long enough to retrieve eggs from them.",
      "bio_emb_follicles_label": "Ovaries & follicles",
      "bio_emb_follicles_title": "Eggs are inside follicles, and follicles are inside ovaries",
      "bio_emb_follicles_body": "Your clinic can measure follicles on ultrasound, but the egg inside each follicle is microscopic and checked only after retrieval.",
      "bio_emb_follicles_callout": "A follicle count is not the same as retrieved eggs, mature eggs, or embryos.",
      "bio_emb_follicles_detail_title": "Follicles, eggs, and ovaries",
      "bio_emb_follicles_d1_title": "What the clinic can see",
      "bio_emb_follicles_d1_body": "Ultrasound shows follicles and their size. The egg itself is too small to see directly, so the final egg count comes from the embryology lab.",
      "bio_emb_follicles_d2_title": "Why numbers change",
      "bio_emb_follicles_d2_body": "You may hear follicle count, retrieved egg count, mature egg count, fertilized egg count, and embryo count. Each one is a different checkpoint.",
      "bio_emb_stim_label": "Stimulation",
      "bio_emb_stim_title": "Medication tries to mature more follicles at once",
      "bio_emb_stim_body": "Daily stimulation meds usually run about 10-14 days and aim to keep several follicles growing instead of just one.",
      "bio_emb_stim_callout": "This uses follicles already recruited in that cycle; it is not taking eggs your body was saving for future months.",
      "bio_emb_stim_detail_title": "Why stimulation is used",
      "bio_emb_stim_d1_title": "The cycle cohort",
      "bio_emb_stim_d1_body": "Each month, a group of follicles starts responding. Stimulation tries to keep more of that group growing long enough to retrieve eggs.",
      "bio_emb_stim_d2_title": "Dose is personalized",
      "bio_emb_stim_d2_body": "Age, AMH, AFC, weight, diagnosis, and prior response can change the starting dose and monitoring plan.",
      "bio_emb_monitor_label": "Monitoring",
      "bio_emb_monitor_title": "Monitoring decides when trigger and retrieval happen",
      "bio_emb_monitor_body": "Visits often happen every 2-3 days. Ultrasound tracks follicle size and bloodwork helps time the trigger shot.",
      "bio_emb_monitor_callout": "Retrieval is usually a short same-day transvaginal procedure with sedation, not abdominal surgery.",
      "bio_emb_monitor_detail_title": "Monitoring, trigger, and retrieval",
      "bio_emb_monitor_d1_title": "Monitoring changes the plan",
      "bio_emb_monitor_d1_body": "Dose changes, extra visits, and shifted retrieval estimates are normal because the clinic is reacting to follicle growth and hormones.",
      "bio_emb_monitor_d2_title": "Trigger timing matters",
      "bio_emb_monitor_d2_body": "Retrieval is commonly scheduled about 34-36 hours after trigger, before ovulation would happen.",
      "bio_emb_monitor_d3_title": "What retrieval collects",
      "bio_emb_monitor_d3_body": "The clinician collects follicle fluid; the embryology lab searches that fluid for eggs under a microscope.",
      "bio_emb_sperm_label": "Sperm side",
      "bio_emb_sperm_title": "The sperm source is part of the embryo plan",
      "bio_emb_sperm_body": "The sperm may come from a partner, donor, fresh sample, or frozen sample. That choice affects consent, timing, transport, and the lab method.",
      "bio_emb_sperm_callout": "A sperm plan is not just logistics. It can change whether the lab uses conventional IVF or ICSI.",
      "bio_emb_sperm_detail_title": "Sperm source and embryo freezing",
      "bio_emb_sperm_d1_title": "Fresh, frozen, partner, or donor",
      "bio_emb_sperm_d1_body": "The sperm source affects logistics and consent. The lab needs a clear plan before retrieval day.",
      "bio_emb_sperm_d2_title": "Why semen analysis matters",
      "bio_emb_sperm_d2_body": "Count, motility, morphology, and volume can influence whether conventional insemination or ICSI is recommended.",
      "bio_emb_sample_label": "Semen sample",
      "bio_emb_sample_title": "A semen sample is collected or thawed",
      "bio_emb_sample_body": "This often happens on retrieval day, but some people freeze backup sperm or use donor sperm that is already frozen.",
      "bio_emb_sample_callout": "The ovarian side takes days. The sperm handoff may be one day, but the preparation can start months earlier.",
      "bio_emb_sample_detail_title": "How the sperm gets to the lab",
      "bio_emb_sample_d1_title": "Fresh sample",
      "bio_emb_sample_d1_body": "A fresh semen sample may be collected on retrieval day, then processed by the lab to prepare sperm for fertilization.",
      "bio_emb_sample_d2_title": "Frozen or donor sample",
      "bio_emb_sample_d2_body": "Frozen partner sperm or donor sperm can be thawed by the lab. The clinic should confirm timing, identity checks, consent, and backup plans before retrieval day.",
      "bio_emb_sample_d3_title": "Why backup plans matter",
      "bio_emb_sample_d3_body": "If collection may be difficult or sperm parameters are low, a clinic may discuss freezing backup sperm before the cycle.",
      "bio_emb_quality_label": "Sperm quality",
      "bio_emb_quality_title": "Semen analysis helps choose the lab method",
      "bio_emb_quality_body": "Count, motility, morphology, volume, prior fertilization history, and donor/partner status can all affect the fertilization plan.",
      "bio_emb_quality_callout": "Sperm is made continuously and turns over across roughly 2-3 months, so exposures can matter before embryo creation.",
      "bio_emb_quality_detail_title": "What semen analysis can change",
      "bio_emb_quality_d1_title": "The usual parameters",
      "bio_emb_quality_d1_body": "Semen analysis commonly looks at count, motility, morphology, volume, and sometimes additional measures depending on the clinic.",
      "bio_emb_quality_d2_title": "Why it matters for embryos",
      "bio_emb_quality_d2_body": "The result can influence whether the clinic recommends conventional insemination, ICSI, backup sperm freezing, urology referral, or donor sperm planning.",
      "bio_emb_ivficsi_label": "IVF vs ICSI",
      "bio_emb_ivficsi_title": "IVF and ICSI are two fertilization methods",
      "bio_emb_ivficsi_body": "With conventional IVF, eggs and prepared sperm are placed together. With ICSI, the embryologist injects one sperm into a mature egg.",
      "bio_emb_ivficsi_callout": "Semen results, prior fertilization, PGT plans, clinic policy, and egg count can all affect the recommendation.",
      "bio_emb_ivficsi_detail_title": "Conventional IVF versus ICSI",
      "bio_emb_ivficsi_d1_title": "Conventional IVF",
      "bio_emb_ivficsi_d1_body": "The lab places mature eggs with prepared sperm and lets fertilization happen without injecting each egg.",
      "bio_emb_ivficsi_d2_title": "ICSI",
      "bio_emb_ivficsi_d2_body": "ICSI means intracytoplasmic sperm injection. An embryologist selects one sperm and injects it directly into a mature egg.",
      "bio_emb_ivficsi_d3_title": "Why the choice is personal",
      "bio_emb_ivficsi_d3_body": "ICSI can be important for sperm-factor cases and is often used with PGT workflows, but it is not automatically better for every situation.",
      "bio_emb_fertcheck_label": "Day 1 check",
      "bio_emb_fertcheck_title": "The lab checks which eggs fertilized normally",
      "bio_emb_fertcheck_body": "The next day, the lab usually checks for normal fertilization. This is when the number can narrow again.",
      "bio_emb_fertcheck_callout": "Retrieved eggs, mature eggs, normally fertilized eggs, and embryos are separate numbers.",
      "bio_emb_fertcheck_detail_title": "What the fertilization check means",
      "bio_emb_fertcheck_d1_title": "Maturity comes first",
      "bio_emb_fertcheck_d1_body": "After retrieval, the lab checks which eggs are mature. Immature eggs are less likely to fertilize normally.",
      "bio_emb_fertcheck_d2_title": "Normal fertilization",
      "bio_emb_fertcheck_d2_body": "A fertilized egg at this stage is often called a zygote. Some eggs may not fertilize, and some may fertilize abnormally.",
      "bio_emb_culture_label": "Embryo culture",
      "bio_emb_culture_title": "Embryos are watched over several days",
      "bio_emb_culture_body": "Fertilized eggs divide over time. The lab may update you on cleavage-stage embryos around day 3 and blastocysts around day 5-7.",
      "bio_emb_culture_callout": "The number often drops at each lab checkpoint; that does not necessarily mean anything went wrong.",
      "bio_emb_culture_detail_title": "Embryo culture and attrition",
      "bio_emb_culture_d1_title": "Early development",
      "bio_emb_culture_d1_body": "The lab watches fertilized eggs divide. Some arrest early and some continue toward day 5, 6, or 7 blastocyst stage.",
      "bio_emb_culture_d2_title": "Why the funnel narrows",
      "bio_emb_culture_d2_body": "Egg maturity, sperm factors, chromosome errors, lab conditions, and biology all affect whether an embryo keeps developing.",
      "bio_emb_blast_label": "Blastocysts",
      "bio_emb_blast_title": "Blastocysts are the embryos usually frozen or tested",
      "bio_emb_blast_body": "By about day 5-7, some embryos may reach blastocyst stage. Labs decide which blastocysts meet criteria for freezing, biopsy, or transfer planning.",
      "bio_emb_blast_callout": "A blastocyst can be graded, frozen, biopsied for PGT, or sometimes not kept if it does not meet lab criteria.",
      "bio_emb_blast_detail_title": "What happens at blastocyst stage",
      "bio_emb_blast_d1_title": "The day can vary",
      "bio_emb_blast_d1_body": "Some embryos reach blastocyst on day 5, some on day 6 or 7, and some stop before then.",
      "bio_emb_blast_d2_title": "Grading is not genetic testing",
      "bio_emb_blast_d2_body": "Embryo grading looks at appearance and expansion. It is useful, but it does not tell you whether the embryo has the expected number of chromosomes.",
      "bio_emb_pgt_label": "PGT / PGD",
      "bio_emb_pgt_title": "Genetic testing is optional and has different types",
      "bio_emb_pgt_body": "PGD is older wording. Today you'll usually hear PGT-A for chromosome count, PGT-M for a specific gene condition, or PGT-SR for chromosome rearrangements.",
      "bio_emb_pgt_callout": "PGT tests a few cells from a blastocyst biopsy. It gives information; it does not change the embryo.",
      "bio_emb_pgt_detail_title": "PGT, PGD, and what is tested",
      "bio_emb_pgt_d1_title": "PGT-A",
      "bio_emb_pgt_d1_body": "PGT-A screens whether the embryo biopsy has the expected number of chromosomes. It is usually discussed as euploid, aneuploid, mosaic, or no-result depending on the lab.",
      "bio_emb_pgt_d2_title": "PGT-M and PGT-SR",
      "bio_emb_pgt_d2_body": "PGT-M looks for a specific inherited single-gene condition when there is a known risk. PGT-SR looks for embryos affected by a known chromosome rearrangement.",
      "bio_emb_pgt_d3_title": "Why counseling matters",
      "bio_emb_pgt_d3_body": "Genetic testing decisions can affect cost, timing, embryo use, and emotional decisions. Many clinics involve a genetic counselor for PGT-M or complex results.",
      "bio_emb_euploidy_label": "Euploidy",
      "bio_emb_euploidy_title": "Euploid means the expected chromosome count",
      "bio_emb_euploidy_body": "A euploid PGT-A result means the tested biopsy had the expected chromosome number. Aneuploid means extra or missing chromosomes were detected.",
      "bio_emb_euploidy_callout": "Euploid does not guarantee pregnancy or live birth, and PGT-A is not a test for every possible genetic issue.",
      "bio_emb_euploidy_detail_title": "How to read PGT-A language",
      "bio_emb_euploidy_d1_title": "Euploid",
      "bio_emb_euploidy_d1_body": "A euploid result means the embryo biopsy had the expected number of chromosomes. Euploid embryos generally have better implantation potential than aneuploid embryos, but outcomes are not guaranteed.",
      "bio_emb_euploidy_d2_title": "Aneuploid, mosaic, no-result",
      "bio_emb_euploidy_d2_body": "Aneuploid means extra or missing chromosomes were detected. Mosaic means mixed cell-line signals. No-result means the lab did not get a usable result.",
      "bio_emb_freeze_label": "Freezing",
      "bio_emb_freeze_title": "Embryos are vitrified and stored",
      "bio_emb_freeze_body": "Embryos that meet freezing criteria are usually vitrified, stored in liquid nitrogen tanks, and kept until a future thaw or transfer decision.",
      "bio_emb_freeze_callout": "When storage is maintained, embryos can remain frozen for many years. Practical limits are usually consent, clinic policy, storage fees, and law.",
      "bio_emb_freeze_detail_title": "Embryo freezing and storage",
      "bio_emb_freeze_d1_title": "Vitrification",
      "bio_emb_freeze_d1_body": "Vitrification is rapid freezing designed to reduce ice crystal formation. Embryos are then stored in liquid nitrogen tanks.",
      "bio_emb_freeze_d2_title": "Storage is an ongoing decision",
      "bio_emb_freeze_d2_body": "Frozen embryos can involve annual storage fees, consent renewals, disposition decisions, legal considerations, and future transfer planning.",
      "bio_emb_freeze_d3_title": "Future use",
      "bio_emb_freeze_d3_body": "When someone wants to use an embryo later, the embryo is thawed and a frozen embryo transfer plan is made. Not every embryo survives thaw, but modern vitrification survival is generally high.",
      "bio_emb_future_label": "Future use",
      "bio_emb_future_title": "Using an embryo later is a separate transfer step",
      "bio_emb_future_body": "Embryo freezing creates stored embryos. Pregnancy later requires thawing an embryo, preparing the uterus or gestational carrier, and doing an embryo transfer.",
      "bio_emb_future_callout": "Freezing embryos gives more information than freezing eggs, but it also creates decisions about ownership, consent, transfer, storage, and disposition.",
      "bio_emb_future_detail_title": "After embryos are frozen",
      "bio_emb_future_d1_title": "Frozen embryo transfer",
      "bio_emb_future_d1_body": "A future transfer usually involves a separate cycle with uterine preparation, embryo thaw, transfer, and pregnancy testing afterward.",
      "bio_emb_future_d2_title": "Consent and ownership",
      "bio_emb_future_d2_body": "Because embryos may involve more than one genetic contributor, clinics usually require clear consent about storage, transfer, testing, discard, donation, and what happens if circumstances change.",
      "bio_ivf_supply_title": "IVF still starts with egg supply and response",
      "bio_ivf_supply_body": "IVF usually begins with stimulation and retrieval, so age, AMH, AFC, diagnosis, and prior response shape the likely egg count.",
      "bio_ivf_supply_callout": "The IVF funnel starts with eggs. Fewer retrieved or mature eggs usually means fewer chances for fertilization, embryos, and transfer later.",
      "bio_ivf_supply_detail_title": "Egg supply before IVF",
      "bio_ivf_supply_d1_title": "IVF starts with eggs",
      "bio_ivf_supply_d1_body": "The first biological constraint is often how many follicles respond and how many mature eggs are retrieved.",
      "bio_ivf_supply_d2_title": "What testing can add",
      "bio_ivf_supply_d2_body": "AMH, AFC, day 2-3 hormones, age, diagnosis, and prior response help estimate likely yield and stimulation approach.",
      "bio_ivf_sperm_title": "The sperm source changes the IVF lab plan",
      "bio_ivf_sperm_body": "Partner sperm, donor sperm, fresh collection, frozen backup, or surgical sperm can change consent, timing, transport, and fertilization method.",
      "bio_ivf_sperm_detail_title": "Sperm source and IVF",
      "bio_ivf_sperm_d1_title": "Fresh, frozen, partner, donor, or surgical",
      "bio_ivf_sperm_d1_body": "The sperm source affects logistics and consent. The lab needs a clear plan before retrieval day.",
      "bio_ivf_sperm_d2_title": "Why semen analysis matters",
      "bio_ivf_sperm_d2_body": "Count, motility, morphology, and volume can influence whether conventional IVF, ICSI, backup freezing, urology, or donor sperm planning is recommended.",
      "bio_ivf_freeze_title": "Embryos may be frozen, transferred, or tested",
      "bio_ivf_freeze_body": "Some IVF plans freeze embryos, some transfer an embryo fresh, and some biopsy embryos for PGT before freezing.",
      "bio_ivf_freeze_callout": "Freezing, testing, transfer timing, storage fees, and consent are clinic-specific decisions to clarify before retrieval.",
      "bio_ivf_freeze_detail_title": "After blastocysts form",
      "bio_ivf_freeze_d1_title": "Transfer or freeze",
      "bio_ivf_freeze_d1_body": "A blastocyst may be transferred, frozen, biopsied for PGT, or not kept if it does not meet lab criteria.",
      "bio_ivf_freeze_d2_title": "Storage is an ongoing decision",
      "bio_ivf_freeze_d2_body": "Frozen embryos can involve annual storage fees, consent renewals, disposition decisions, legal considerations, and future transfer planning.",
      "bio_ivf_transfer_title": "Embryo transfer is its own step",
      "bio_ivf_transfer_body": "Pregnancy through IVF requires preparing the uterus or gestational carrier, choosing an embryo, thawing if frozen, and doing a transfer.",
      "bio_ivf_transfer_callout": "Retrieval, embryo creation, and transfer can happen in the same overall plan, but they are separate clinical steps.",
      "bio_amab_agency_label": "Sperm side",
      "bio_amab_agency_title": "The highest-agency starting point is often sperm",
      "bio_amab_agency_body": "When sperm is your contribution to the plan, semen analysis, repeat testing, urology questions, backup freezing, and lifestyle exposures can change the next steps.",
      "bio_amab_agency_callout": "Sperm turns over across roughly 2-3 months, so this side may have a real optimization window before embryo creation.",
      "bio_amab_agency_detail_title": "Sperm inputs before embryo creation",
      "bio_amab_agency_d1_title": "What semen analysis adds",
      "bio_amab_agency_d1_body": "Count, motility, morphology, and volume help decide whether conventional IVF, ICSI, backup freezing, urology, or donor sperm planning is relevant.",
      "bio_amab_agency_d2_title": "What timing can change",
      "bio_amab_agency_d2_body": "Heat, fever, smoking, cannabis, alcohol, medications, anabolic hormones, supplements, and illness history may matter because sperm is continuously produced.",
      "bio_amab_source_label": "Sperm source",
      "bio_amab_source_title": "The lab needs a clear sperm source plan",
      "bio_amab_source_body": "The plan may use a fresh sample, frozen backup, surgical sperm, donor sperm, or a combination depending on testing and collection reliability.",
      "bio_amab_source_callout": "Collection may look like a single day, but testing, backup freezing, donor matching, or urology can take weeks or months.",
      "bio_amab_source_detail_title": "Getting sperm to the lab",
      "bio_amab_source_d1_title": "Fresh or frozen",
      "bio_amab_source_d1_body": "A fresh sample may be collected on retrieval day, while frozen backup or donor sperm must be shipped, thawed, identified, and consented correctly.",
      "bio_amab_source_d2_title": "When backup matters",
      "bio_amab_source_d2_body": "If collection may be difficult or semen parameters are low, clinics often discuss freezing backup sperm before the cycle.",
      "bio_amab_eggsource_label": "Egg source",
      "bio_amab_eggsource_title": "Egg source determines the ovarian-side timeline",
      "bio_amab_eggsource_body": "Embryo creation needs eggs from a partner, donor, or known source. That choice changes screening, consent, stimulation timing, retrieval logistics, and cost.",
      "bio_amab_eggsource_callout": "Your sperm plan may be ready before the egg source is ready, so the home should track both sides separately.",
      "bio_amab_eggsource_detail_title": "Egg source and ovarian-side planning",
      "bio_amab_eggsource_d1_title": "Partner or known source",
      "bio_amab_eggsource_d1_body": "A partner or known source usually needs medical history, ovarian reserve testing, cycle planning, infectious disease labs, and consent.",
      "bio_amab_eggsource_d2_title": "Donor eggs",
      "bio_amab_eggsource_d2_body": "Donor eggs can be fresh or frozen. Matching, legal work, donor screening, shipping, and cohort size all affect the plan.",
      "bio_iui_fit_label": "IUI fit",
      "bio_iui_fit_title": "IUI depends on ovulation, tubes, and sperm reach",
      "bio_iui_fit_body": "IUI puts prepared sperm into the uterus near ovulation. It still depends on at least one open tube, ovulation timing, sperm quality, and the clinical reason for treatment.",
      "bio_iui_fit_callout": "The key pre-cycle question is whether IUI is a good fit or whether IVF should be discussed sooner.",
      "bio_iui_fit_detail_title": "What makes IUI a fit",
      "bio_iui_fit_d1_title": "The biology it relies on",
      "bio_iui_fit_d1_body": "Egg and sperm still need to meet in the tube, fertilize there, and then the embryo must travel to the uterus.",
      "bio_iui_fit_d2_title": "When clinics pause",
      "bio_iui_fit_d2_body": "Blocked tubes, very low motile sperm count, severe sperm-factor results, some age-related goals, or repeated unsuccessful IUIs may shift the discussion toward IVF.",
      "bio_iui_tubes_label": "Tubes",
      "bio_iui_tubes_title": "Tube status matters before IUI",
      "bio_iui_tubes_body": "Because fertilization happens inside the body, clinics often confirm at least one tube appears open before investing in IUI attempts.",
      "bio_iui_tubes_callout": "HSG, HyCoSy, saline ultrasound, laparoscopy history, or prior imaging may be used depending on the clinic.",
      "bio_iui_tubes_detail_title": "Why tubes matter for IUI",
      "bio_iui_tubes_d1_title": "IUI is not a lab fertilization step",
      "bio_iui_tubes_d1_body": "Prepared sperm is placed into the uterus, but egg pickup and fertilization still happen through the fallopian tube.",
      "bio_iui_tubes_d2_title": "One side can be enough",
      "bio_iui_tubes_d2_body": "Some people can still do IUI with one open tube, but timing and which ovary is responding may matter.",
      "bio_iui_med_label": "Medication",
      "bio_iui_med_title": "Medication choice changes the number of follicles",
      "bio_iui_med_body": "Some IUIs are natural-cycle. Others use letrozole, clomiphene, or injectable medication to support ovulation or recruit more than one follicle.",
      "bio_iui_med_callout": "More follicles can raise the chance of pregnancy, but also raises the chance of multiples or cancellation.",
      "bio_iui_med_detail_title": "Natural versus medicated IUI",
      "bio_iui_med_d1_title": "Natural cycle",
      "bio_iui_med_d1_body": "The clinic tracks the follicle your body is already developing and times insemination around ovulation.",
      "bio_iui_med_d2_title": "Medicated cycle",
      "bio_iui_med_d2_body": "Medication may help ovulation or recruit more follicles. Monitoring helps decide whether it is safe to proceed.",
      "bio_iui_trigger_label": "Trigger",
      "bio_iui_trigger_title": "Monitoring and trigger control the timing",
      "bio_iui_trigger_body": "Ultrasound, LH testing, bloodwork, or a trigger shot can be used to time insemination close to ovulation.",
      "bio_iui_trigger_callout": "Many clinics schedule IUI roughly 24-36 hours after trigger, but protocols vary.",
      "bio_iui_trigger_detail_title": "How timing is chosen",
      "bio_iui_trigger_d1_title": "Follicle size",
      "bio_iui_trigger_d1_body": "Ultrasound helps estimate whether a follicle is mature enough to ovulate.",
      "bio_iui_trigger_d2_title": "Hormone signals",
      "bio_iui_trigger_d2_body": "LH surge, estradiol, progesterone, and trigger timing can all affect when the IUI is scheduled.",
      "bio_iui_prep_label": "Sperm prep",
      "bio_iui_prep_title": "The sperm sample is washed before IUI",
      "bio_iui_prep_body": "A fresh, frozen partner, or donor sample is processed by the lab to concentrate motile sperm and remove seminal fluid before insemination.",
      "bio_iui_prep_callout": "Post-wash motile sperm count is often more useful for IUI planning than the raw semen analysis alone.",
      "bio_iui_prep_detail_title": "Sperm preparation for IUI",
      "bio_iui_prep_d1_title": "Why washing happens",
      "bio_iui_prep_d1_body": "Semen is processed before placement in the uterus. Clinics look at how many motile sperm remain after preparation.",
      "bio_iui_prep_d2_title": "Fresh, frozen, or donor",
      "bio_iui_prep_d2_body": "Fresh partner sperm, frozen partner sperm, and donor sperm have different timing, transport, consent, and inventory needs.",
      "bio_iui_proc_label": "IUI day",
      "bio_iui_proc_title": "IUI is a short office procedure",
      "bio_iui_proc_body": "A thin catheter places prepared sperm into the uterus. Most people leave soon after and continue the plan their clinic gives them.",
      "bio_iui_proc_callout": "Your clinic may give progesterone, activity guidance, and a beta test date after the procedure.",
      "bio_iui_proc_detail_title": "What happens on IUI day",
      "bio_iui_proc_d1_title": "Sample timing",
      "bio_iui_proc_d1_body": "Fresh collection usually happens shortly before the procedure. Frozen or donor sperm is thawed and prepared by the lab.",
      "bio_iui_proc_d2_title": "Procedure timing",
      "bio_iui_proc_d2_body": "The IUI is timed around ovulation or trigger so sperm is present when the egg may be released.",
      "bio_iui_wait_label": "Two-week wait",
      "bio_iui_wait_title": "The beta date is part of the plan",
      "bio_iui_wait_body": "After IUI, the home should switch into wait support with medication reminders, symptom context, and the clinic's pregnancy-test timing.",
      "bio_iui_wait_callout": "A blood beta is often planned about two weeks after IUI, though the exact date depends on protocol.",
      "bio_iui_wait_detail_title": "After IUI",
      "bio_iui_wait_d1_title": "Support tasks",
      "bio_iui_wait_d1_body": "Medication instructions, side-effect context, and appointment reminders are more useful than daily pregnancy predictions.",
      "bio_iui_wait_d2_title": "Result path",
      "bio_iui_wait_d2_body": "The next home should know whether this becomes another IUI attempt, IVF discussion, early pregnancy support, or a recovery plan.",
      "stepper_done": "Done",
      "stepper_mark_done": "Mark as done",
      "stepper_mark_done_a11y": "Mark ${stepLabel} done",
      "stepper_mark_incomplete_a11y": "Mark ${stepLabel} incomplete",
      "stepper_expand_a11y": "Expand ${stepLabel}",
      "stepper_collapse_a11y": "Collapse ${stepLabel}",
      "start_embryo_cycle_title": "Starting an embryo freezing cycle?",
      "start_embryo_cycle_body": "When your clinic gives you a date, this becomes your treatment home for stimulation, retrieval, sperm collection, fertilization, embryo culture, and freezing updates.",
      "start_embryo_cycle_cta": "Set cycle start",
      "start_embryo_cycle_checklist_timing": "Cycle timing",
      "start_embryo_cycle_checklist_sperm": "Sperm collection plan",
      "start_embryo_cycle_checklist_fertilization": "Fertilization method",
      "start_embryo_cycle_checklist_lab_updates": "Lab update schedule",
      "numbers_step_label": "Step 2: Know your numbers",
      "numbers_step_label_explorer": "Step 2: Know Your Numbers",
      "numbers_what_to_test": "What you can test",
      "numbers_subtitle_egg_freezing": "A few options can make your estimate more useful. You can start simple or go deeper.",
      "numbers_subtitle_embryo_freezing": "Start with the ovarian side, add the sperm side, then decide whether genetics or broader panels are useful.",
      "numbers_subtitle_ivf_ovarian": "Start with ovarian reserve, add the sperm side, then account for transfer readiness and clinic-required labs.",
      "numbers_subtitle_ivf_sperm": "Start with semen analysis and sperm source, while keeping AMH, AFC, ovarian-side labs, and transfer readiness in the same IVF plan.",
      "numbers_subtitle_iui": "Confirm the inputs that make IUI work: ovulation timing, tube status, sperm source, and clinic-required labs.",
      "numbers_subtitle_amab": "Start with semen analysis, then connect egg source, donor or carrier requirements, genetics, and clinic-required labs.",
      "numbers_subtitle_explorer": "Add only the numbers that help you compare paths. The right set depends on what you choose next.",
      "numbers_step_label_iui": "Step 2: Confirm IUI fit",
      "numbers_step_label_amab": "Step 2: Confirm inputs",
      "guided_ivf_cycle_title": "Starting an IVF cycle?",
      "guided_ivf_cycle_body": "When your clinic gives you a date, this becomes your treatment home for stimulation, monitoring, retrieval, fertilization, transfer planning, and beta timing.",
      "guided_iui_cycle_title": "Starting an IUI cycle?",
      "guided_iui_cycle_body": "When your clinic gives you a date, this becomes your treatment home for monitoring, trigger timing, the IUI procedure, and the two-week wait.",
      "guided_iui_checklist_timing": "Cycle timing",
      "guided_iui_checklist_monitoring": "Monitoring",
      "guided_iui_checklist_sperm": "Sperm prep",
      "guided_iui_checklist_beta": "Beta timing",
      "guided_ivf_checklist_timing": "Cycle timing",
      "guided_ivf_checklist_meds": "Medication schedule",
      "guided_ivf_checklist_monitoring": "Monitoring plan",
      "guided_ivf_checklist_lab": "Lab and transfer updates",
      "guided_iui_cycle_body_full": "When your clinic gives you a cycle day 1 or monitoring date, this becomes your IUI home for medication, monitoring, trigger timing, sperm prep, insemination, and beta testing.",
      "guided_ivf_cycle_body_full": "When your clinic gives you a date, this becomes your treatment home for stimulation, retrieval, sperm collection, fertilization, embryo culture, transfer planning, and lab updates.",
      "guided_iui_cycle_cta": "Set IUI cycle start",
      "guided_ivf_cycle_cta": "Set cycle start",
      "guided_iui_checklist_day1": "Cycle day 1 or baseline date",
      "guided_iui_checklist_meds_mon": "Medication and monitoring plan",
      "guided_iui_checklist_sperm_wash": "Sperm source and wash timing",
      "guided_iui_checklist_trigger_beta": "Trigger, IUI, and beta dates",
      "guided_ivf_checklist_timing_v2": "Cycle timing",
      "guided_ivf_checklist_sperm": "Sperm source or collection plan",
      "guided_ivf_checklist_fertilization": "Fertilization method",
      "guided_ivf_checklist_transfer": "Transfer or freeze plan",
      "guided_amab_cycle_title": "Starting embryo creation?",
      "guided_amab_cycle_body": "When the donor, carrier, sperm, and clinic plan are ready, this becomes your treatment home for retrieval, collection, fertilization, embryo culture, transfer planning, and lab updates.",
      "guided_amab_checklist_sperm": "Sperm source and backup plan",
      "guided_amab_checklist_egg": "Donor egg or ovarian-side timing",
      "guided_amab_checklist_carrier": "Carrier or transfer plan",
      "guided_amab_checklist_lab": "Fertilization and lab update schedule",
      "past_cycle_coming_soon": "Coming soon",
      "past_cycle_unlock_export": "Unlock cycle export",
      "past_cycle_continue": "Continue",
      "embryo_clinic_compare_title": "Know what to compare",
      "embryo_clinic_compare_subtitle": "Lab quality, ICSI, PGT-A, update cadence, freezing, storage, and total cost.",
      "ivf_clinic_compare_title": "Compare IVF clinic and lab fit",
      "ivf_clinic_compare_subtitle": "Look at stimulation style, embryology lab, ICSI policy, PGT workflows, fresh/frozen transfer options, communication, and total cost.",
      "ivf_clinic_compare_cta": "Compare IVF clinic fit",
      "iui_clinic_compare_title": "Compare IUI logistics before choosing",
      "iui_clinic_compare_subtitle": "Weekend availability, monitoring access, trigger timing, sperm wash lab, donor-sperm handling, and beta plan can matter as much as location.",
      "iui_clinic_compare_cta": "Compare IUI care",
      "amab_clinic_compare_title": "Compare the full care team",
      "amab_clinic_compare_subtitle": "IVF lab, sperm services, donor egg path, carrier support, legal coordination, storage, and update cadence need to work together.",
      "amab_clinic_compare_cta": "Compare family-building care",
      "test_eyebrow_ovarian_reserve": "Ovarian reserve",
      "test_eyebrow_ultrasound": "Ultrasound",
      "test_eyebrow_sperm_side": "Sperm side",
      "test_eyebrow_cycle_timing": "Cycle timing",
      "test_eyebrow_tube_status": "Tube status",
      "test_eyebrow_transfer_readiness": "Transfer readiness",
      "test_eyebrow_egg_source": "Egg source",
      "test_eyebrow_carrier_route": "Carrier route",
      "test_eyebrow_clinic_labs": "Clinic labs",
      "test_eyebrow_hormones": "Hormones",
      "test_eyebrow_baseline": "Baseline",
      "test_eyebrow_optional": "Optional",
      "test_history_title": "Complete medical history",
      "test_history_body": "This is the data layer for your estimate: diagnoses, meds, surgeries, allergies, periods, prior cycles, and risk factors.",
      "test_history_timing": "Required for personalization",
      "test_history_cta": "Continue history",
      "test_history_action_label": "Continue medical history",
      "test_amh_title": "AMH blood test",
      "test_amh_body": "AMH helps estimate ovarian reserve and expected response. It can usually be drawn any day of the cycle.",
      "test_amh_timing": "Blood test · any day",
      "test_amh_cta": "Order AMH",
      "test_amh_action_label": "Order at-home AMH test",
      "test_find_lab_cta": "Find lab",
      "test_find_lab_action_label": "Find a lab",
      "test_afc_title": "AFC ultrasound",
      "test_afc_body": "Antral follicle count is a transvaginal ultrasound that counts small resting follicles. AMH + AFC usually gives the clearest estimate.",
      "test_afc_timing": "Ultrasound · often cycle day 2-5",
      "test_afc_cta": "Find clinic",
      "test_afc_action_label": "Find a clinic or mobile ultrasound",
      "test_upload_result_cta": "Upload result",
      "test_afc_upload_action_label": "Upload AFC result",
      "test_hormones_title": "Day 2-3 hormones",
      "test_hormones_body": "FSH and estradiol help interpret ovarian reserve. Clinics may add LH, progesterone, TSH, prolactin, vitamin D, or infectious disease labs.",
      "test_hormones_timing": "Some labs must be timed",
      "test_add_results_cta": "Add results",
      "test_add_results_action_label": "Add test results",
      "test_semen_title": "Semen analysis",
      "test_semen_body": "Count, motility, morphology, and volume help the lab decide whether conventional fertilization or ICSI may be recommended.",
      "test_semen_timing": "Partner, donor, lab, or at-home collection",
      "test_check_options_cta": "Check options",
      "test_semen_check_action_label": "Check semen analysis options",
      "test_semen_upload_action_label": "Upload semen analysis",
      "test_ovulation_title": "Ovulation and cycle timing",
      "test_ovulation_body": "LH patterns, cycle history, ultrasound timing, or bloodwork help decide whether the IUI should be natural, medicated, monitored, or triggered.",
      "test_ovulation_timing": "Cycle-specific",
      "test_check_timing_cta": "Check timing",
      "test_check_timing_action_label": "Check ovulation timing",
      "test_find_iui_monitoring_cta": "Find clinic",
      "test_find_iui_monitoring_action_label": "Find IUI monitoring",
      "test_tube_title": "Tube and uterine evaluation",
      "test_tube_body": "IUI needs sperm and egg to meet inside the body, so clinics often confirm at least one tube appears open and the uterus is ready.",
      "test_tube_timing": "Often before first IUI",
      "test_find_testing_cta": "Find testing",
      "test_find_tube_action_label": "Find tube testing",
      "test_upload_tube_action_label": "Upload tube test result",
      "test_semen_iui_title": "Semen analysis and sperm source",
      "test_semen_iui_body": "Count, motility, morphology, donor inventory, and expected post-wash motile count help decide whether IUI is a reasonable fit.",
      "test_semen_iui_timing": "Partner, donor, fresh, or frozen",
      "test_clinic_labs_title": "Clinic-required labs",
      "test_clinic_labs_body": "Many clinics require infectious disease labs, pregnancy test timing, blood type, rubella or varicella status, genetic screening, or thyroid checks before IUI.",
      "test_clinic_labs_timing": "Clinic-specific",
      "test_uterine_title": "Uterine and transfer readiness",
      "test_uterine_body": "If a transfer may be part of the IVF plan, clinics may add saline ultrasound, mock transfer, thyroid, infectious disease labs, or protocol-specific testing.",
      "test_uterine_timing": "Before transfer planning",
      "test_find_evaluation_cta": "Find evaluation",
      "test_find_uterine_action_label": "Find uterine evaluation",
      "test_upload_uterine_action_label": "Upload uterine evaluation",
      "test_level_core_title": "Core estimate",
      "test_level_core_body": "Medical history, AMH, and AFC answer the main question: how your ovaries may respond in one egg-freezing cycle.",
      "test_level_core_cta": "Start AMH",
      "test_level_panel_title": "Complete health panel",
      "test_level_panel_body": "A 150+ biomarker panel can check vitamins, thyroid, metabolic health, inflammation, hormones, and other context for optimization.",
      "test_level_panel_cta": "See panels",
      "test_level_panel_action_label": "See testing panels",
      "test_level_genetics_title": "Genetics",
      "test_level_genetics_body": "Carrier screening checks inherited-condition risk for future children. Whole genome is broader at-home DNA sequencing with more health context and more uncertainty.",
      "test_level_genetics_cta": "Compare options",
      "test_level_genetics_action_label": "Compare genetic testing options",
      "numbers_partner_action_iui_title": "Add partner or sperm source",
      "numbers_partner_action_iui_subtitle": "IUI guidance needs to know whether sperm is partner, donor, fresh, frozen, or still undecided.",
      "numbers_partner_action_ivf_sperm_title": "Add ovarian-side partner, donor, or clinic plan",
      "numbers_partner_action_ivf_sperm_subtitle": "IVF guidance still needs AMH, AFC, ovarian-side labs, retrieval timing, and transfer route alongside the semen plan.",
      "numbers_partner_action_ivf_title": "Add partner, donor, or sperm source",
      "numbers_partner_action_ivf_subtitle": "IVF guidance needs the ovarian side, sperm source, and possible transfer route in one plan.",
      "numbers_partner_action_amab_title": "Add sperm, egg source, and carrier details",
      "numbers_partner_action_amab_subtitle": "This plan should know whether sperm, egg source, and carrier route are confirmed, still being screened, or undecided.",
      "numbers_partner_action_default_title": "Add partner or sperm source",
      "numbers_partner_action_default_subtitle": "Invite a partner or note whose sperm source should be included in the plan.",
      "numbers_add_source_label": "Add partner or sperm source",
      "test_amab_egg_title": "Egg source screening",
      "test_amab_egg_body": "Donor, partner, or known-source eggs change medical screening, genetics, retrieval timing, consent, and shipping.",
      "test_amab_egg_timing": "Partner, known source, or donor",
      "test_compare_sources_cta": "Compare sources",
      "test_amab_egg_compare_action_label": "Compare egg source options",
      "test_find_care_cta": "Find care",
      "test_amab_egg_find_action_label": "Find donor or IVF care",
      "test_amab_carrier_title": "Carrier or transfer path",
      "test_amab_carrier_body": "If a gestational carrier is involved, legal, agency, clinic, and uterine-readiness steps need to be tracked before embryos are used.",
      "test_amab_carrier_timing": "Can run before or after embryo creation",
      "test_amab_carrier_review_cta": "Review path",
      "test_amab_carrier_review_action_label": "Review carrier path",
      "past_cycle_record_completion_title": "Cycle record completion",
      "past_cycle_record_completion_body": "${completed} of ${total} details complete. Finish the record to unlock a shareable export that tells the story of this cycle.",
      "past_cycle_continue_a11y": "Continue cycle record completion",
      "past_cycle_upload_title": "Upload or drop cycle records",
      "past_cycle_upload_body": "We can parse lab reports, embryo details, medications, visits, and costs into this cycle.",
      "today_label": "today",
      "yesterday_label": "yesterday",
      "last_monitoring": "Last monitoring",
      "last_monitoring_when": "Last monitoring ${when}",
      "on_date": "on ${date}",
      "follicles_count": "${count} follicles",
      "lead_mm": "lead ${value} mm",
      "e2_value": "E2 ${value}",
      "projected_e2": "~E2 ${value}",
      "next_label": "Next",
      "not_yet_label": "Not yet",
      "pending_label": "pending",
      "lab_status_next": "Next",
      "calendar_label": "Calendar",
      "outlook_label": "Outlook",
      "journey_map_label": "Journey map",
      "open_care_label": "Open care",
      "expand_a11y": "Expand ${title}",
      "collapse_a11y": "Collapse ${title}",
      "hero_setup_title": "Let's set up the right path",
      "hero_setup_summary": "Choose your goal and who is involved so Louise can route the next steps correctly.",
      "hero_learn_explorer_title": "Compare paths before you decide",
      "hero_learn_explorer_summary": "Save questions, compare options, and add baseline data only if you want it.",
      "hero_egg_freezing_active_title": "All on track for tomorrow's monitoring",
      "hero_egg_freezing_active_summary": "You have two meds today. Tomorrow's visit will confirm trigger timing and the retrieval estimate.",
      "hero_egg_freezing_postcycle_title": "Your egg-freezing cycle is complete",
      "hero_egg_freezing_postcycle_summary": "Review what was recorded, add storage details, and decide what you want to do next.",
      "hero_egg_freezing_postcycle_stored_title": "${count} eggs are stored",
      "hero_egg_freezing_postcycle_stored_summary": "Your storage record is available. Review what is recorded and decide what you want to do next.",
      "hero_embryo_freezing_active_title": "Stimulation is on track, monitoring is tomorrow",
      "hero_embryo_freezing_active_summary": "Expect some bloating or ovary pressure today. Retrieval is currently estimated for May 24, and tomorrow's scan will update that.",
      "hero_embryo_freezing_postcycle_title": "Your embryo-freezing cycle is complete",
      "hero_embryo_freezing_postcycle_summary": "Review recorded embryo results, add any pending reports, and decide what you want to do next.",
      "hero_embryo_freezing_postcycle_stored_title": "${count} embryos are stored",
      "hero_embryo_freezing_postcycle_stored_summary": "Your storage record is available. Add any pending lab report and review what comes next.",
      "hero_sperm_freezing_active_title": "You're ready for tomorrow's collection",
      "hero_sperm_freezing_active_summary": "Your abstinence window is on target. Bring ID and complete storage consent.",
      "hero_sperm_freezing_wait_title": "Your sample is with the lab",
      "hero_sperm_freezing_wait_summary": "Semen analysis and storage confirmation usually post within 2 to 5 days.",
      "hero_sperm_freezing_postcycle_title": "Your sperm-freezing cycle is complete",
      "hero_sperm_freezing_postcycle_summary": "Review what was recorded, add any pending lab report, and decide what you want to do next.",
      "hero_sperm_freezing_postcycle_stored_title": "${count} sperm samples are stored",
      "hero_sperm_freezing_postcycle_stored_summary": "Your storage record is available. Review any lab results and decide what comes next.",
      "hero_ivf_precycle_title": "Baseline and sperm plan are the next unlocks",
      "hero_ivf_precycle_summary": "Complete history, AMH/AFC, semen analysis, and coverage before protocol start.",
      "hero_ivf_active_title": "All on track, monitoring is tomorrow",
      "hero_ivf_active_summary": "You have meds today. Tomorrow's results will confirm trigger timing and the retrieval plan.",
      "hero_post_retrieval_title": "Retrieval complete",
      "hero_post_retrieval_ivf_eyebrow": "IVF / ICSI",
      "hero_post_retrieval_ivf_summary": "Your clinic is recording fertilization and embryo-development updates. Today's real care plan stays close while you wait.",
      "hero_post_retrieval_egg_freezing_eyebrow": "Egg freezing",
      "hero_post_retrieval_egg_freezing_summary": "Your clinic is recording lab and storage updates. Today's real care plan stays close while you wait.",
      "hero_post_retrieval_embryo_freezing_eyebrow": "Embryo freezing",
      "hero_post_retrieval_embryo_freezing_summary": "Your clinic is recording fertilization, embryo-development, and storage updates. Today's real care plan stays close while you wait.",
      "hero_beta_wait_title_with_date": "Beta is ${date}, keep meds steady",
      "hero_beta_wait_title_no_date": "Beta day is coming, keep meds steady",
      "hero_beta_wait_summary": "Symptoms are not predictive right now. Call for severe pain, heavy bleeding, fever, or shortness of breath.",
      "hero_ivf_positive_title": "Positive beta, repeat in 48 hours",
      "hero_ivf_positive_summary": "Continue meds until the clinic changes the plan. Ultrasound timing comes after the beta trend.",
      "hero_ivf_negative_title": "Result reviewed, consult is May 23",
      "hero_ivf_negative_summary": "Medication stop plan is set for today. Your cycle recap and remaining embryos are ready for review.",
      "hero_iui_precycle_title": "Call with cycle day 1 to start timing",
      "hero_iui_precycle_summary": "Trigger coverage, sperm plan, and baseline schedule need to be ready before monitoring.",
      "hero_iui_active_title": "Trigger tonight at 9 PM",
      "hero_iui_active_summary": "IUI is scheduled 36 hours later; partner sample is May 20 at 8 AM.",
      "fet_active_plan_eyebrow": "FET",
      "fet_active_plan_heading": "Your frozen embryo transfer plan",
      "fet_active_plan_summary": "Review the clinic-recorded preparation, transfer, and testing steps. Louise does not infer a dose, date, or result.",
      "hero_iui_wait_title": "Clinic beta is May 31",
      "hero_iui_wait_summary": "The trigger shot can confuse home tests. Keep meds and wait for the clinic result plan.",
      "hero_oi_wait_title": "The wait after ovulation",
      "hero_oi_wait_summary": "Keep your clinic plan and expected test date visible while you wait for a clearer answer.",
      "hero_oi_active_title": "Your stimulation is under way",
      "hero_oi_active_summary": "Today's medications and your next monitoring scan, with the response recorded so far.",
      "hero_amab_family_building_precycle_title": "Partner B's semen analysis is the next step",
      "hero_amab_family_building_precycle_summary": "Compare both sperm inputs before donor egg, carrier, embryo, legal, and cost decisions.",
      "hero_partner_precycle_title": "Your next task is semen analysis",
      "hero_partner_precycle_summary": "Add coverage details too; both can affect the shared IVF/IUI plan.",
      "hero_partner_active_title": "Confirm the sample plan today",
      "hero_partner_active_summary": "Monitoring is tomorrow. Pickup planning and injection support may be needed soon.",
      "hero_egg_donor_title": "Screening labs and coordinator call today",
      "hero_egg_donor_summary": "Your donor profile is live. Psych consult and legal packet come next.",
      "hero_sperm_donor_title": "Donation visit is Friday at 9 AM",
      "hero_sperm_donor_summary": "Keep the abstinence window in target; sample and payout status update after lab review.",
      "hero_carrier_title": "Upload OB records to move screening forward",
      "hero_carrier_summary": "Insurance review is in progress. Psych consult unlocks after medical pre-clearance.",
      "hero_intended_parent_title": "Choose donor shortlist this week",
      "hero_intended_parent_summary": "Carrier agency calls, legal intake, and escrow all depend on the matching decision.",
      "hero_dynamic": {
        "eyebrow_with_day": "${type} · day ${day}",
        "eyebrow_no_day": "${type}",
        "eyebrow_type": {
          "pre_treatment": "Preparation",
          "stimulation": "Stimulation",
          "retrieval": "Retrieval",
          "fertilization": "Fertilization",
          "embryo_development": "Embryo development",
          "transfer": "Transfer"
        },
        "metric": {
          "stim_day": "Stim · day",
          "next_monitoring": "Next monitoring",
          "lead_follicle": "Lead follicle",
          "estradiol": "Estradiol",
          "next_injection": "Next injection",
          "trigger": "Trigger",
          "retrieval_estimate": "Estimated retrieval",
          "retrieval_date": "Retrieval",
          "retrieved_on": "Retrieved",
          "embryo_dev_day": "Development · day",
          "endometrium": "Endometrium",
          "transfer_date": "Transfer",
          "beta_date": "Blood test",
          "days_post_transfer": "Days post-transfer",
          "meds_today": "Meds today"
        },
        "cta": {
          "open_cycle": "Open my cycle",
          "add_medications": "Add my medications",
          "schedule_retrieval": "Schedule my retrieval",
          "log_monitoring": "Log monitoring results",
          "view_meds_plan": "View my meds plan",
          "prepare_retrieval": "Prepare for retrieval",
          "log_retrieval_results": "Log retrieval results",
          "view_embryo_updates": "View embryo updates",
          "prepare_transfer": "Prepare for transfer",
          "view_beta_plan": "View my beta plan",
          "record_my_beta": "Record my beta"
        },
        "pre_treatment_title": "Prepare your body before stimulation",
        "pre_treatment_summary": "Supplements, birth control, baseline monitoring — laying the groundwork before the ovaries get to work.",
        "result_recorded_title": "Your result is saved",
        "result_recorded_summary": "It's recorded against this cycle. When you're ready, close the cycle from the Outcome step.",
        "unknown_active_title": "Active cycle",
        "unknown_active_summary": "Keep meds up to date and log each step so your team can follow along.",
        "stim_trigger_logged_title": "Trigger done",
        "stim_trigger_logged_summary": "Your body is doing the final maturation. Retrieval lands ~36 h after the trigger — the clinic confirms the time.",
        "stim_monitoring_title": "Monitoring ${when}",
        "stim_monitoring_summary": "Keep meds steady. The next visit confirms trigger timing.",
        "stim_med_title": "Next injection ${when} at ${time}",
        "stim_med_summary": "Stay on schedule until the next monitoring — don't shift the time by more than an hour.",
        "stim_generic_title": "Your follicles are growing",
        "stim_generic_summary": "Stay on the injection schedule. Bloating and ovary pressure are normal at this stage.",
        "retrieval_scheduled_title": "Retrieval ${when}",
        "retrieval_scheduled_summary": "No solid food in the 8 h before. Arrive 30 min early for check-in.",
        "retrieval_done_pending_title": "Retrieval done",
        "retrieval_done_pending_summary": "The lab confirms fertilization within 24 h. Take it easy today, hydrate well.",
        "fertilization_title": "Your eggs are in the lab",
        "fertilization_summary": "The embryology team is watching fertilization. First results tomorrow.",
        "embryo_dev_title": "Your embryos are developing · day ${day}",
        "embryo_dev_summary": "Daily check-ins through the blastocyst stage (D5-D7). Transfer or freezing decision after.",
        "transfer_scheduled_title": "Transfer ${when}",
        "transfer_scheduled_summary": "Full bladder for transfer. No strict rest after — ease back into activity.",
        "beta_scheduled_title": "Beta ${when}",
        "beta_scheduled_summary": "Symptoms are not predictive right now. Keep meds going until the blood test.",
        "beta_pending_title": "Two-week wait",
        "beta_pending_summary": "Keep meds going. Schedule your blood test as soon as the clinic confirms the date.",
        "wait_eyebrow": "Two-week wait",
        "wait_day_title": "Day ${day} of your wait",
        "wait_day_title_no_total": "Day ${day} since transfer",
        "wait_reassure_early": "The early days. There is nothing to detect yet, so try not to read into symptoms. Keep your meds steady and be gentle with yourself.",
        "wait_reassure_mid": "The middle stretch. Progesterone can mimic early pregnancy signs, so symptoms will not tell you the result. The blood test is what counts.",
        "wait_reassure_late": "Almost at your test. However you feel, the beta is the honest answer. Keep meds going until the clinic says otherwise.",
        "wait_progress_start": "Transfer",
        "wait_progress_start_fet": "FET transfer",
        "wait_progress_start_iui": "Insemination",
        "wait_progress_start_oi": "Ovulation",
        "wait_progress_end": "Blood test",
        "wait_eyebrow_fet": "FET two-week wait",
        "wait_eyebrow_iui": "Two-week wait after insemination",
        "wait_day_title_no_total_fet": "Day ${day} since frozen transfer",
        "wait_day_title_no_total_iui": "Day ${day} since insemination",
        "wait_day_title_no_total_oi": "Day ${day} since ovulation",
        "wait_reassure_early_fet": "Your frozen transfer is complete. Keep estrogen and progesterone exactly as prescribed; symptoms cannot tell you the outcome.",
        "wait_reassure_mid_fet": "Progesterone timing supports the lining after FET. Symptoms can come from medication, so the clinic blood test is what counts.",
        "wait_reassure_late_fet": "Almost at your FET blood test. Keep your transfer medications going until your clinic gives new instructions.",
        "wait_reassure_early_iui": "It is still early after insemination. The trigger shot and support medications can mimic symptoms; keep your plan steady.",
        "wait_reassure_mid_iui": "The trigger shot can linger and progesterone can feel like early pregnancy. Symptoms and home tests will not tell you the result.",
        "wait_reassure_late_iui": "Almost at your IUI blood test. The clinic beta is the reliable answer; keep medications going until your clinic says otherwise.",
        "wait_eyebrow_oi": "Wait after ovulation",
        "wait_reassure_early_oi": "It is still early after ovulation. Symptoms cannot tell you the result; keep the plan your clinic gave you.",
        "wait_reassure_mid_oi": "The middle of the wait can feel long. If progesterone was prescribed, it can cause symptoms that overlap with early pregnancy.",
        "wait_reassure_late_oi": "Your test date is getting closer. Keep medications going until the clinic tells you what to do."
      },
      "wait_extras": {
        "chat_title": "How are you feeling?",
        "chat_subtitle": "Tell Louise about symptoms or worries. We keep track for you.",
        "chat_empty_prompt": "Share how you feel today, any symptoms you have noticed, or anything on your mind. I am here to help, and I will keep track of what you tell me.",
        "chat_input_placeholder": "How are you feeling?",
        "readings_label": "Readings for this stage",
        "tag_wait": "The wait",
        "tag_science": "The science",
        "tag_transfer": "Your transfer",
        "tag_fet": "Your FET",
        "tag_insemination": "Your insemination"
      },
      "outcome_extras": {
        "readings_label": "Reading for this moment",
        "tag_next_chapter": "The next chapter",
        "tag_coping": "Moving through it",
        "tag_emotional": "How you feel"
      },
      "stim_extras": {
        "readings_label": "Reading for this stage",
        "tag_daily_habits": "Daily habits",
        "tag_emotional": "How you feel"
      },
      "egg_lab": {
        "retrieval": {
          "title": "Retrieval day",
          "timeframe": "Same day",
          "body": "The clinic collects follicle fluid and the lab checks how many eggs are found.",
          "m1_label": "Retrieved",
          "m1_value": "Pending",
          "m1_note": "eggs found in follicle fluid",
          "m2_label": "Mature MII",
          "m2_value": "Pending",
          "m2_note": "eggs eligible for freezing",
          "m3_label": "Recovery",
          "m3_value": "Same day",
          "m3_note": "after sedation instructions"
        },
        "maturity": {
          "title": "Maturity check",
          "timeframe": "After retrieval",
          "body": "Not every egg collected is mature. The mature MII eggs are the ones usually frozen for future use.",
          "m1_value": "Pending",
          "m1_note": "mature eggs",
          "m2_label": "Immature",
          "m2_value": "Pending",
          "m2_note": "GV or MI if reported",
          "m3_label": "Update",
          "m3_value": "Lab call",
          "m3_note": "timing varies by clinic"
        },
        "vitrification": {
          "title": "Vitrification confirmation",
          "timeframe": "Same day or next day",
          "body": "Mature eggs are vitrified, which means rapidly cooled and moved into cryostorage.",
          "m1_label": "Frozen",
          "m1_value": "Pending",
          "m1_note": "final mature egg count",
          "m2_label": "Method",
          "m2_value": "Vitrification",
          "m2_note": "rapid freezing",
          "m3_label": "Report",
          "m3_value": "Pending",
          "m3_note": "attach when received"
        },
        "storage": {
          "title": "Storage",
          "timeframe": "After freezing",
          "body": "The storage report should show the facility, identifiers, renewal timing, and annual fees.",
          "m1_label": "Facility",
          "m1_value": "Pending",
          "m1_note": "storage location",
          "m2_label": "Renewal",
          "m2_value": "Pending",
          "m2_note": "annual fee date",
          "m3_label": "IDs",
          "m3_value": "Pending",
          "m3_note": "vial or cane labels"
        }
      },
      "embryo_lab": {
        "retrieval": {
          "title": "Retrieval day",
          "timeframe": "Same day",
          "body": "The lab confirms how many eggs were collected and how many are mature enough to fertilize.",
          "m1_label": "Retrieved",
          "m1_note": "eggs collected during retrieval",
          "m2_label": "Mature MII",
          "m2_note": "eggs ready for IVF or ICSI",
          "m3_label": "Method",
          "m3_note": "or IVF / split plan if selected"
        },
        "day1": {
          "title": "Day 1",
          "timeframe": "Fertilization check",
          "body": "The lab checks which eggs fertilized normally. A normal fertilization result is often called 2PN.",
          "m1_note": "normally fertilized embryos",
          "m2_label": "Abnormal",
          "m2_note": "0PN, 1PN, or 3PN if reported",
          "m3_label": "Next update",
          "m3_value": "Day 3",
          "m3_note": "depends on clinic reporting"
        },
        "day2_3": {
          "title": "Day 2-3",
          "timeframe": "Cleavage stage",
          "body": "Embryos should be dividing. Some clinics report cell count, symmetry, and fragmentation.",
          "m1_label": "Dividing",
          "m1_note": "embryos still growing",
          "m2_label": "Grade",
          "m2_note": "fragmentation / symmetry",
          "m3_label": "Plan",
          "m3_value": "Culture",
          "m3_note": "continue toward blastocyst"
        },
        "day5_7": {
          "title": "Day 5-7",
          "timeframe": "Blastocyst + vitrification",
          "body": "Embryos that keep developing may reach blastocyst stage and become eligible for biopsy and vitrification.",
          "m1_label": "Blastocysts",
          "m1_note": "some reach this later",
          "m2_label": "Frozen / biopsied",
          "m2_note": "vitrified if frozen",
          "m3_label": "Storage IDs",
          "m3_note": "shown once banked"
        },
        "pgta": {
          "timeframe": "If planned",
          "body": "If embryos are biopsied, genetic screening results usually arrive after the biopsy is sent out.",
          "m1_label": "Euploid",
          "m1_note": "chromosomally typical",
          "m2_label": "Aneuploid / mosaic",
          "m2_note": "clinic explains transfer options",
          "m3_label": "ETA",
          "m3_value": "7-10 days",
          "m3_note": "lab-dependent"
        }
      },
      "logistics": {
        "med_supply": {
          "title": "Medication supply",
          "timeframe": "Check before the next dose change",
          "body": "Dose changes can happen fast during stimulation. Keep tonight, tomorrow, antagonist, and trigger meds physically accounted for.",
          "i1_label": "Tonight's stimulation meds",
          "i1_detail": "Enough on hand",
          "i2_label": "Antagonist dose",
          "i2_detail": "Confirm tomorrow's dose is available",
          "i3_label": "Trigger meds",
          "i3_detail": "Refill early if the clinic may move timing"
        },
        "retrieval_prep": {
          "title": "Retrieval prep",
          "timeframe": "Before trigger day",
          "body": "Retrieval timing usually moves quickly once follicles are ready. Keep anesthesia, fasting, arrival, and ride-home instructions easy to find.",
          "i1_label": "Anesthesia instructions",
          "i1_detail": "Fasting and medication rules",
          "i2_label": "Ride home",
          "i2_detail": "Required after sedation",
          "i3_label": "Arrival time",
          "i3_detail": "Confirmed when trigger is scheduled"
        },
        "care_team": {
          "title": "Care team access",
          "timeframe": "Keep close during stimulation",
          "body": "The highest-friction moments are usually dose changes, refill timing, and after-hours retrieval questions.",
          "i1_label": "Clinic nurse line",
          "i1_detail": "For dose and monitoring instructions",
          "i2_label": "Specialty pharmacy",
          "i2_detail": "For same-day refills",
          "i3_label": "After-hours number",
          "i3_detail": "For urgent retrieval or trigger questions"
        },
        "embryo_paperwork": {
          "title": "Clinic paperwork",
          "timeframe": "This week",
          "body": "Embryo freezing depends on the clinic and lab having the right consents and decisions before retrieval day.",
          "i1_label": "IVF / ICSI consents",
          "i1_detail": "Signed or ready for clinic review",
          "i2_label": "PGT-A decision",
          "i2_detail": "Mark planned, undecided, or not using",
          "i3_label": "Partner / donor paperwork",
          "i3_detail": "Needed if sperm source changes"
        },
        "egg_consent": {
          "title": "Consent and storage",
          "timeframe": "Before retrieval",
          "body": "Egg freezing paperwork is mostly about retrieval consent, cryostorage, renewal timing, and future disposition choices.",
          "i1_label": "Retrieval consent",
          "i1_detail": "Signed or ready for clinic review",
          "i2_label": "Cryostorage agreement",
          "i2_detail": "Facility, renewal, and annual fee terms",
          "i3_label": "Future disposition",
          "i3_detail": "What happens if eggs are unused later"
        }
      },
      "monitoring": {
        "baseline": "Baseline",
        "mid_stim_1": "Mid-stim 1",
        "mid_stim_2": "Mid-stim 2",
        "yesterday": "Yesterday",
        "tomorrow": "Tomorrow",
        "pre_trigger": "Pre-trigger"
      },
      "embryo_funnel": {
        "s1_label": "Retrieved eggs",
        "s1_detail": "Eggs found by the lab.",
        "s2_label": "Mature",
        "s2_detail": "MII eggs ready for ICSI.",
        "s3_label": "Fertilized",
        "s3_detail": "Normal 2PN fertilization check.",
        "s4_label": "Blastocysts",
        "s4_detail": "Day 5-7 embryos for freeze/test.",
        "s5_label": "Euploid",
        "s5_detail": "Estimated after PGT-A; the lab report confirms the result."
      },
      "semen": {
        "volume_label": "Volume",
        "volume_note": "sample volume",
        "concentration_label": "Concentration",
        "concentration_note": "sperm per mL",
        "motility_label": "Motility",
        "motility_note": "moving sperm",
        "morphology_label": "Morphology",
        "morphology_note": "strict normal forms"
      },
      "sperm_funnel": {
        "s1_label": "Sample",
        "s1_detail": "Pre-freeze usable sperm estimate.",
        "s2_label": "Processed",
        "s2_detail": "After lab wash and prep.",
        "s3_label": "Frozen vials",
        "s3_detail": "Banked across two samples.",
        "s4_label": "Post-thaw usable",
        "s4_detail": "Estimated motile vials."
      },
      "beta": {
        "date_label": "Beta date",
        "date_note": "blood test",
        "dpt_label": "Days past transfer",
        "dpt_note": "5-day embryo",
        "meds_label": "Meds",
        "meds_value": "3 today",
        "meds_note": "continue",
        "symptoms_label": "Symptoms",
        "symptoms_value": "Not predictive",
        "symptoms_note": "track if severe"
      },
      "stim_cards": {
        "support": {
          "badge": "Today",
          "title": "Support the cycle",
          "body": "The goal is steady inputs, not a perfect lifestyle. These are the basics that matter most during stimulation.",
          "b1": "Take stimulation meds exactly on the clinic schedule.",
          "b2": "Eat regular meals with protein, plants, whole grains, and healthy fats.",
          "b3": "Hydrate, sleep, and keep caffeine or alcohol within clinic guidance.",
          "b4": "Use stress tools for your nervous system; stress has not been proven to determine IVF outcome."
        },
        "safety": {
          "badge": "Safety",
          "title": "Avoid or ask first",
          "body": "As ovaries enlarge and trigger timing approaches, some normal activities and medicines need clearer clinic guidance.",
          "b1": "Avoid intercourse or use condoms only if your clinic explicitly clears it.",
          "b2": "Ask before ibuprofen, naproxen, aspirin, supplements, or any new medication.",
          "b3": "Avoid high-impact exercise, twisting, and anything that worsens pelvic pressure.",
          "b4": "Call urgently for severe pain, rapid weight gain, shortness of breath, fever, or heavy bleeding."
        },
        "nutrition": {
          "badge": "Nutrition",
          "title": "What to eat",
          "body": "No food pattern can guarantee a better retrieval. The strongest practical angle is a steady, Mediterranean-style baseline.",
          "b1": "Prioritize vegetables, fruit, legumes, whole grains, olive oil, nuts, and fish if you eat it.",
          "b2": "Do not crash diet or sharply cut carbs during stimulation.",
          "b3": "If nausea or bloating hits, smaller protein-containing meals can be easier."
        },
        "movement": {
          "badge": "Movement",
          "title": "How to move",
          "body": "Movement is mostly about comfort and torsion risk once the ovaries are enlarged.",
          "b1": "Walking and gentle daily movement are usually the safest defaults.",
          "b2": "Avoid running, HIIT, jumping, twisting yoga, and heavy lifting unless cleared.",
          "b3": "Scale down if pelvic pressure, bloating, or one-sided pain increases."
        },
        "medication": {
          "badge": "Medication",
          "title": "Medicine timing",
          "body": "During stimulation, timing and clinic approval matter more than self-adjusting.",
          "b1": "Trigger timing is exact; call immediately if it is late or missed.",
          "b2": "Check before new prescriptions, NSAIDs, aspirin, antihistamines, or blood thinners.",
          "b3": "Acetaminophen is commonly allowed, but use your clinic's pain plan."
        },
        "supplements": {
          "badge": "Supplements",
          "title": "Supplement rules",
          "body": "Supplements are not harmless just because they are over the counter, especially near retrieval.",
          "b1": "Prenatal or folate is commonly recommended; confirm dose with your clinic.",
          "b2": "Do not start DHEA, herbs, high-dose antioxidants, or hormone-active supplements mid-cycle without approval.",
          "b3": "Tell the clinic about CoQ10, omega-3, vitamin D, biotin, and anything that affects bleeding or labs."
        }
      },
      "today_rows": {
        "collection": {
          "appt_title": "Collection appointment",
          "appt_detail": "Main lab, bring ID. Abstinence window: day 3 of 2-5.",
          "proc_title": "Sample processing",
          "proc_detail": "Lab checks count, motility, morphology, and vial estimate.",
          "storage_title": "Storage confirmation",
          "storage_detail": "Expected same day if the sample is banked."
        },
        "wait": {
          "prog_title": "Progesterone",
          "prog_detail": "Continue unless the clinic changes the plan.",
          "any_time": "Any time",
          "symptom_title": "Symptom check",
          "symptom_detail": "Call for severe pain, heavy bleeding, fever, or shortness of breath.",
          "beta_title": "Beta blood draw",
          "beta_detail": "The clinic will call after the result is reviewed."
        },
        "donor": {
          "screening_title": "Screening labs",
          "screening_detail": "Infectious disease and genetic carrier screening draw.",
          "coord_title": "Coordinator call",
          "coord_detail": "Review match status, next paperwork, and compensation timing."
        },
        "stim": {
          "gonal_detail": "Gives follicles the FSH signal to keep growing together.",
          "subc_pen": "Subcutaneous pen",
          "monitoring_title": "Monitoring visit",
          "monitoring_detail": "Ultrasound + estradiol. Next retrieval estimate updates after this.",
          "cetrotide_detail": "Prevents early ovulation while follicles finish growing.",
          "subc_vial": "Subcutaneous vial"
        }
      },
      "section": {
        "today_title": "Today",
        "today_subtitle": "Concrete actions for this cycle day.",
        "calendar_action": "Calendar",
        "testing_title": "Testing",
        "testing_subtitle": "Recent results and monitoring context for this cycle day.",
        "all_tests_action": "All tests",
        "good_to_know_title": "Good to know",
        "good_to_know_subtitle": "Useful guidance and estimates for what comes next.",
        "cycle_logistics_title": "Cycle Logistics",
        "cycle_logistics_subtitle": "Medications, retrieval prep, clinic contacts, and lab update timing.",
        "ivf_specifics_title": "IVF specifics",
        "ivf_specifics_subtitle": "Sperm, fertilization, embryo testing, and transfer choices change what happens after retrieval."
      },
      "widget": {
        "timeline_title": "Timeline",
        "test_results_title": "Test results",
        "test_results_subtitle": "New and pending results show up here.",
        "monitoring_progress_title": "Monitoring progress",
        "monitoring_progress_subtitle": "Log each visit to see follicle growth, estradiol, symptoms, and retrieval timing move together.",
        "what_to_know_title": "What to know",
        "what_to_know_subtitle": "Use this as a quick safety check between monitoring visits. Your clinic's instructions come first.",
        "cycle_may_freeze_title": "What this cycle may freeze",
        "cycle_may_freeze_subtitle": "An estimate from today's follicle count. The actual numbers update after retrieval, maturity check, and freezing.",
        "cycle_may_become_title": "What this cycle may become",
        "cycle_may_become_subtitle": "An estimate from today's follicle count. After retrieval, this updates from eggs collected to mature eggs, fertilization, blastocysts, and any PGT-A results.",
        "logistics_checklist_title": "Cycle logistics checklist",
        "after_retrieval_title": "After retrieval",
        "after_retrieval_egg_subtitle": "Swipe through retrieval day, maturity check, freezing confirmation, and storage.",
        "after_retrieval_embryo_subtitle": "Swipe through retrieval day, fertilization, cleavage, blastocyst, freezing, and PGT-A.",
        "ivf_plan_title": "IVF plan",
        "retrieval_decisions_title": "Retrieval-day decisions"
      },
      "test_results_preview": {
        "purpose_amh": "Reflects the size of your remaining egg supply",
        "purpose_fsh": "How hard your body works to mature an egg",
        "purpose_vitamin_d": "Supports egg quality and implantation",
        "purpose_tsh": "How your thyroid is keeping pace with fertility hormones",
        "tomorrow": "tomorrow",
        "friday": "Friday",
        "prep_baseline": "Cycle day 2-3 if this is baseline testing",
        "prep_thyroid": "Ask about fasting and biotin before thyroid labs"
      },
      "monitoring_action": {
        "log_monitoring": "Log monitoring results",
        "log_symptoms": "Log symptoms"
      },
      "ivf_plan": {
        "endometrium_label": "Endometrium",
        "endometrium_note": "trilaminar",
        "sperm_label": "Sperm plan",
        "sperm_value": "Fresh + backup",
        "sperm_note": "sample retrieval morning",
        "fertilization_label": "Fertilization",
        "fertilization_note": "clinic plan",
        "pgta_value": "Planned",
        "pgta_note": "freeze-all first",
        "task1_title": "Partner sample",
        "task1_detail": "Fresh sample is scheduled; backup vial is available if needed.",
        "task2_title": "ICSI consent",
        "task2_detail": "Signed and attached to the cycle.",
        "task3_title": "PGT-A plan",
        "task3_detail": "Biopsy and freeze-all plan is ready for the lab."
      },
      "owner": {
        "you": "You",
        "partner": "Partner",
        "clinic": "Clinic",
        "lab": "Lab",
        "legal": "Legal",
        "agency": "Agency",
        "louise": "Louise"
      },
      "due": {
        "now": "Now",
        "optional": "Optional",
        "done": "Done",
        "today": "Today",
        "tomorrow": "Tomorrow",
        "this_week": "This week",
        "retrieval_morning": "Retrieval morning"
      },
      "status": {
        "available": "Available",
        "learn": "Learn"
      },
      "setup": {
        "eyebrow": "Setup",
        "title": "Set up your path",
        "summary": "Answer a few essentials so Louise can show the right care path from the start.",
        "hm1_label": "Next",
        "hm1_value": "Choose a path",
        "hm1_note": "2 minutes",
        "hm2_label": "Known",
        "hm2_value": "Age + location",
        "hm2_note": "from profile",
        "hm3_label": "Missing",
        "hm3_value": "Goal + timeline",
        "hm3_note": "needed to route",
        "primary_action": "Start setup",
        "section_title": "Your setup",
        "section_subtitle": "Start with the essentials that change what appears next.",
        "tasks_title": "Answer these first",
        "t1_title": "Choose your goal",
        "t1_detail": "Preserve, get pregnant, donate, use a donor/carrier, adopt, or learn.",
        "t2_title": "Add who is involved",
        "t2_detail": "Partner, donor, carrier, intended parent, or solo.",
        "t3_title": "Mark urgent timing",
        "t3_detail": "Cancer care, hormones, age, cycle timing, or a clinic deadline.",
        "routes_title": "Likely routes",
        "r1_title": "Preserve fertility",
        "r1_detail": "Egg, sperm, or embryo freezing planning.",
        "r2_title": "Get pregnant",
        "r2_detail": "IUI, IVF, donor, carrier, or learn-first routing.",
        "r3_title": "Donate or carry",
        "r3_detail": "Donor/carrier paths with agency and screening tasks."
      },
      "learn": {
        "eyebrow": "Learn",
        "title": "Explore without being pushed into treatment",
        "summary": "Explore with clarity before selecting a clinic, test, or treatment path.",
        "hm1_label": "Mode",
        "hm1_value": "Learning",
        "hm1_note": "no treatment assumed",
        "hm2_label": "Saved",
        "hm2_value": "4 questions",
        "hm2_note": "for consults",
        "hm3_label": "Next",
        "hm3_value": "Compare options",
        "hm3_note": "10 minutes",
        "section_title": "Start here",
        "section_subtitle": "Compare options and choose optional actions without starting a treatment plan.",
        "paths_title": "Compare paths",
        "p1_title": "Freezing eggs",
        "p1_detail": "Best when preserving unfertilized eggs.",
        "p2_title": "Freezing sperm",
        "p2_detail": "Fast, lower-complexity banking with semen analysis.",
        "p3_title": "Freezing embryos",
        "p3_detail": "Requires egg source, sperm source, and lab decisions.",
        "p4_title": "IUI vs IVF",
        "p4_detail": "Different timing, cost, success rates, and lab involvement.",
        "actions_title": "Optional next actions",
        "a1_title": "Save clinic questions",
        "a1_detail": "Build a consult checklist from the topics you read.",
        "a2_title": "Check baseline tests",
        "a2_detail": "AMH/AFC or semen analysis if you want data before deciding.",
        "a3_title": "Find care near you",
        "a3_detail": "Browse clinics, labs, and programs without committing."
      },
      "post_procedure_outcome": {
        "early_pregnancy": {
          "whats_next": "What's next",
          "what_usually_comes_next": "What comes next",
          "weeks_and_days_along": "You're ${weeks} weeks and ${days} days along.",
          "about_weeks_along": "You're about ${weeks} weeks along.",
          "usually_between_dates": "Estimated between ${start} and ${end}",
          "your_clinic_plan_comes_first": "These are usual markers, not appointments. Always check the schedule with your clinic — theirs is the one that counts.",
          "milestone_repeat_beta": "A repeat blood test",
          "milestone_first_scan": "The first ultrasound",
          "milestone_care_handover": "The handover to pregnancy care",
          "milestone_first_trimester_screening": "First-trimester screening",
          "first_weeks_confirm_the_result_ivf": "After an IVF transfer, the next few weeks are mostly about confirming the result and working out how far along you are.",
          "first_weeks_confirm_the_result_fet": "After a frozen transfer, the next few weeks are mostly about confirming the result and working out how far along you are.",
          "first_weeks_confirm_the_result_iui": "After an insemination, the next few weeks are mostly about confirming the result and working out how far along you are.",
          "first_weeks_confirm_the_result_oi": "After a monitored ovulation cycle, the next few weeks are mostly about confirming the result and working out how far along you are.",
          "next_weeks_repeat_beta": "A repeat blood test, often a couple of days apart.",
          "next_weeks_first_scan": "A first scan, usually a few weeks after the result.",
          "clinic_says_what_to_keep_taking": "Your clinic will tell you what to keep taking, and when anything changes.",
          "next_weeks_care_handover": "At some point your fertility clinic hands over to pregnancy care. They will tell you when.",
          "next_weeks_first_trimester_screening": "A first-trimester screening is usually offered; your clinic will say when.",
          "about_the_numbers": "About the numbers",
          "one_number_says_little": "One number says little on its own",
          "a_beta_is_read_with_its_timing": "A beta result is read together with when it was taken and what came before it. Louise does not interpret yours.",
          "numbers_timing_matters": "The same value can mean different things at different points after your procedure.",
          "numbers_clinic_reads_trend": "Your clinic reads the timing and the trend across results.",
          "numbers_louise_keeps_record": "Louise keeps every result you record, so you can bring the whole picture to them.",
          "if_something_worries_you": "If something worries you",
          "do_not_wait_to_call": "You do not have to wait for your next appointment",
          "some_things_are_worth_a_call_today": "Some things are worth a call the same day, even if you are seen soon. This is not a complete list, and doubt is reason enough to call.",
          "bleeding_pain_fever_or_anything_else": "Bleeding, pain, or fever are reasons to contact your clinic, and so is anything else that does not feel right to you.",
          "most_clinics_answer_without_an_appointment": "Most clinics will answer a question without an appointment.",
          "reach_out_local_emergency": "If you feel unwell or unsafe, use your local emergency number.",
          "update_this_pregnancy": "Update this pregnancy",
          "record_a_result_or_say_what_changed": "Open your cycle to add or change what is recorded."
        },
        "shared": {
          "hero_positive_action": "Let's look at what's next",
          "hero_negative_action": "Let's look at what's next",
          "hero_uncertain_action": "Review the result details",
          "take_a_breath_after_this_cycle": "Take a breath after this cycle",
          "hero_adverse_action": "Review what was recorded",
          "hero_unavailable_action": "Add or review the result",
          "handoff_title": "Choose what comes next",
          "handoff_body": "When you're ready, use Louise to turn the result you recorded into questions and a concrete next step with your clinic.",
          "handoff_cta": "Explore what comes next",
          "handoff_check_1": "Keep the result with your records",
          "handoff_check_2": "Review follow-up timing",
          "handoff_chat_prompt": "Help me understand the next steps after my confirmed fertility treatment result. Keep the result source and procedure context in mind, help me prepare questions for my clinic, and end with one concrete next step. Do not make a diagnosis or change my medication plan.",
          "handoff_positive_title": "What comes next, at your pace",
          "handoff_positive_body": "When you're ready, Louise can help you keep the result and your questions together for your clinic.",
          "handoff_positive_cta": "Chat about it",
          "handoff_positive_check_1": "Keep the result with your records",
          "handoff_positive_check_2": "Prepare your questions for your clinic",
          "handoff_positive_chat_prompt": "Help me prepare for follow-up after my positive fertility treatment result. Keep the procedure context in mind, help me prepare questions for my clinic, and end with one concrete next step. Do not make a diagnosis or change my medication plan.",
          "handoff_negative_title": "What comes next, when you decide",
          "handoff_negative_body": "When you're ready, Louise can help you turn this result into clear questions for your clinic without assuming what you want to do next.",
          "handoff_negative_cta": "Chat about it",
          "specify_this_cycles_outcome": "Specify this cycle's outcome",
          "handoff_negative_secondary_cta": "Plan another cycle",
          "handoff_negative_check_1": "Keep the result with your records",
          "handoff_negative_check_2": "Prepare questions for your clinic",
          "handoff_negative_chat_prompt": "Help me prepare questions for my clinic after my negative fertility treatment result. Keep the procedure context in mind, do not assume what I want to do next, and end with one concrete next step. Do not make a diagnosis or change my medication plan.",
          "handoff_unavailable_title": "Stay supported while you wait",
          "handoff_unavailable_body": "Your result is not available in Louise yet. When you're ready, we can help you prepare a question or keep a confirmed follow-up step together without guessing the outcome.",
          "handoff_unavailable_cta": "Chat while you wait",
          "handoff_unavailable_check_1": "Keep the result unlabelled until confirmed",
          "handoff_unavailable_check_2": "Prepare a question for your clinic",
          "handoff_unavailable_chat_prompt": "My fertility treatment result is not available in Louise yet. Help me prepare a question for my clinic or identify the next confirmed step without guessing whether the result is positive or negative. Do not make a diagnosis or change my medication plan.",
          "pause_eyebrow": "After this cycle",
          "pause_title": "Take this one step at a time",
          "pause_summary": "You can leave this cycle here for now. If you want, we can look back together, help you prepare questions, or give you space until you want to pick it up again.",
          "pause_summary_supporting": "You can leave this cycle here for now. If you want, we can look back through it together, or help you get questions ready. There's nothing you need to fix — being there is enough.",
          "pause_primary_action": "Look back together",
          "setup_eyebrow": "When you're ready",
          "setup_title": "Let's take this one step at a time",
          "setup_summary": "You don't have to organise everything today. Start with an appointment, a medication note, or a question, and come back to the rest when you're ready.",
          "setup_primary_action": "Start with one thing",
          "next_clinic_title": "Next clinic step",
          "next_clinic_subtitle": "Only appointments, tests, and instructions recorded for you appear here.",
          "setup_next_clinic_subtitle": "Start with the next confirmed appointment, test, or instruction.",
          "next_clinic_today_title": "Upcoming appointment or instruction",
          "known_title": "What is known",
          "known_subtitle": "Keep the procedure and result available without making them the headline.",
          "good_to_know": "Good to know",
          "the_first_few_weeks": "The first few weeks",
          "what_happens_next_and_who_to_ask": "What usually happens next, and who to ask.",
          "known_result_title": "Result record",
          "known_result_value_pregnancy": "Positive result recorded.",
          "known_result_value_no_pregnancy": "Negative result recorded.",
          "known_result_value_not_confirmed": "Result status is not confirmed.",
          "known_result_source_provider": "Added by your clinic or care team.",
          "known_result_source_patient": "You recorded this result.",
          "known_result_source_partner": "Added by a shared partner.",
          "known_result_source_system": "Added by a connected system.",
          "known_result_source_unknown": "The source is not recorded yet.",
          "known_result_verification_verified": "This record is marked verified.",
          "known_result_verification_unverified": "This record is not marked as verified.",
          "known_result_verification_refuted": "This record is marked refuted; review the correction before relying on it.",
          "known_timeline_title": "Your care timeline",
          "known_procedure_detail": "The procedure details stay connected to this cycle.",
          "known_result_detail": "The result remains available in your cycle history and Records.",
          "known_next_label": "Next step",
          "known_next_detail": "Add or review a real follow-up when you have one.",
          "setup_next_label": "Set up follow-up",
          "setup_next_detail": "Add the next confirmed appointment, test, or clinic instruction.",
          "when_ready_title": "When you're ready",
          "when_ready_subtitle": "Choose a useful next action. Nothing starts automatically.",
          "setup_ready_title": "Set up what helps",
          "setup_ready_subtitle": "Keep confirmed care steps together before choosing optional tracking.",
          "stage_action_add_follow_up": "Add follow-up appointment",
          "stage_action_add_follow_up_detail": "Save the date, time, and notes your clinic gave you.",
          "stage_action_schedule_appointment": "Schedule an appointment",
          "stage_action_schedule_appointment_detail": "Add the date, time, and notes for your next visit.",
          "stage_action_add_medication": "Add medication",
          "stage_action_add_medication_detail": "Record a medication, dose, or instruction from your care team.",
          "stage_action_review_records": "Review this cycle",
          "could_not_save_that_try_again": "We couldn't save that. Try again.",
          "stage_action_review_records_detail": "Open your procedure and result history.",
          "stage_action_review_records_detail_ivf": "Open your IVF procedure and result history.",
          "stage_action_review_records_detail_fet": "Open your FET transfer and result history.",
          "stage_action_review_records_detail_iui": "Open your IUI insemination and result history.",
          "stage_action_review_records_detail_oi": "Open your ovulation-induction cycle and result history.",
          "stage_action_save_question": "Ask a question about this result",
          "stage_action_save_question_detail": "Open the assistant with this cycle in context and prepare for follow-up.",
          "stage_action_save_question_prompt": "I want to prepare a question about my fertility treatment result and next appointment. Help me make it specific and concise, without making a diagnosis or changing my medication plan.",
          "stage_action_explore_next": "Explore another step",
          "stage_action_explore_next_detail": "Open care planning when you are ready; no treatment is started.",
          "stage_action_tracking": "Talk through pregnancy tracking",
          "stage_action_tracking_detail": "Choose whether to turn it on; no week or due-date view starts automatically.",
          "stage_action_tracking_prompt": "I have a positive fertility treatment result and want to understand pregnancy tracking. Explain what information is useful to record now, what dating methods my clinic may use, and which follow-up questions I should ask. Do not make a diagnosis or change my medication plan."
        },
        "pregnancy_tracking": {
          "title": "Set up pregnancy tracking",
          "summary": "This is optional. Louise can keep your follow-up, questions, and result together without guessing a week or due date.",
          "opted_in_title": "Pregnancy tracking is ready",
          "opted_in_summary": "You are in control of what to add. There is no week or due-date view until a dating method is recorded.",
          "action_appointment": "Add a follow-up appointment",
          "action_appointment_detail": "Save the next scan, beta, or clinic visit when you have the details.",
          "action_question": "Prepare a question",
          "action_question_detail": "Ask Louise to help you make a question specific for your care team.",
          "action_question_prompt": "I have a positive fertility treatment result and want to prepare a question for my next follow-up. Help me make it specific without making a diagnosis or changing my medication plan.",
          "action_records": "Review the result record",
          "action_records_detail": "Keep the procedure, result source, and cycle history connected.",
          "action_open": "Set up pregnancy tracking",
          "action_review": "Review pregnancy tracking",
          "the_weeks_ahead": "The weeks ahead",
          "what_usually_comes_next_and_who_to_ask": "What usually comes next, and who to ask. Nothing to do today.",
          "you_will_find_this_on_your_home_page": "You'll find all of this on your home page, at your own pace."
        },
        "ivf": {
          "positive": {
            "eyebrow": "IVF result",
            "title": "A positive IVF result is on record — take a breath",
            "summary": "Whatever you're feeling, you don't have to decide what comes next today. When you're ready, we'll help you keep this result, your transfer details, and your questions together for your next conversation with your clinic.",
            "section_title": "What happens next",
            "section_subtitle": "Keep the result connected to the transfer, embryo, and clinic records.",
            "today_section_title": "Today",
            "procedure_label": "Fresh IVF/ICSI transfer",
            "result_label": "IVF result"
          },
          "negative": {
            "eyebrow": "IVF result",
            "summary": "Whatever you're feeling, you don't have to decide what comes next today. When you're ready, we'll help you make sense of this cycle and prepare your questions for your next conversation with your clinic.",
            "section_title": "What happens next",
            "section_subtitle": "Keep the result connected to the transfer, embryo, and clinic records.",
            "today_section_title": "Today",
            "procedure_label": "Fresh IVF/ICSI transfer",
            "result_label": "IVF result"
          },
          "unavailable": {
            "eyebrow": "IVF result",
            "title": "Your IVF result is still to come",
            "summary": "When your clinic or test result is ready, you can add it here. Until then, we won't label this cycle positive or negative.",
            "section_title": "Keep this cycle in view",
            "section_subtitle": "Save the next real step while you wait for an official result.",
            "today_section_title": "What you can do now",
            "procedure_label": "Fresh IVF/ICSI transfer",
            "result_label": "IVF result"
          },
          "uncertain": {
            "eyebrow": "IVF result",
            "title": "Let's take another look at your IVF result",
            "summary": "This result is not clear enough to label the cycle positive or negative. Review the record or check the next step with your care team.",
            "section_title": "Clarify what was recorded",
            "section_subtitle": "Keep the transfer context together while the result is checked.",
            "today_section_title": "What you can do now",
            "procedure_label": "Fresh IVF/ICSI transfer",
            "result_label": "IVF result"
          },
          "adverse": {
            "eyebrow": "After your IVF result",
            "title": "Take this one step at a time",
            "summary": "You do not have to make another treatment decision today. When you are ready, we can help you keep the record together and prepare for a conversation with your care team.",
            "section_title": "What may help now",
            "section_subtitle": "Keep the transfer context and your next conversation together. If you have urgent symptoms, contact your care team or local emergency services.",
            "today_section_title": "What you can do now",
            "procedure_label": "Fresh IVF/ICSI transfer",
            "result_label": "IVF result"
          }
        },
        "fet": {
          "positive": {
            "eyebrow": "FET result",
            "title": "A positive FET result is on record — take a breath",
            "summary": "Whatever you're feeling, you don't have to decide what comes next today. When you're ready, we'll help you keep this result, your transfer details, and your questions together for your next conversation with your clinic.",
            "section_title": "What happens next",
            "section_subtitle": "Keep the confirmed result connected to your clinic plan and transfer history.",
            "today_section_title": "Today",
            "procedure_label": "FET transfer",
            "result_label": "FET result"
          },
          "negative": {
            "eyebrow": "FET result",
            "summary": "Whatever you're feeling, you don't have to decide what comes next today. When you're ready, we'll help you make sense of this cycle and prepare your questions for your next conversation with your clinic.",
            "section_title": "What happens next",
            "section_subtitle": "Take the next step with your clinic without turning one result into a prescription.",
            "today_section_title": "Today",
            "procedure_label": "FET transfer",
            "result_label": "FET result"
          },
          "unavailable": {
            "eyebrow": "FET result",
            "title": "Your FET result is still to come",
            "summary": "When your clinic or test result is ready, you can add it here. Until then, we won't label this cycle positive or negative.",
            "section_title": "Keep this cycle in view",
            "section_subtitle": "Save the next real step while you wait for an official result.",
            "today_section_title": "What you can do now",
            "procedure_label": "FET transfer",
            "result_label": "FET result"
          },
          "uncertain": {
            "eyebrow": "FET result",
            "title": "Let's take another look at your FET result",
            "summary": "This result is not clear enough to label the cycle positive or negative. Review the record or check the next step with your care team.",
            "section_title": "Clarify what was recorded",
            "section_subtitle": "Keep the FET transfer context together while the result is checked.",
            "today_section_title": "What you can do now",
            "procedure_label": "FET transfer",
            "result_label": "FET result"
          },
          "adverse": {
            "eyebrow": "After your FET result",
            "title": "Take this one step at a time",
            "summary": "You do not have to make another treatment decision today. When you are ready, we can help you keep the record together and prepare for a conversation with your care team.",
            "section_title": "What may help now",
            "section_subtitle": "Keep the transfer context and your next conversation together. If you have urgent symptoms, contact your care team or local emergency services.",
            "today_section_title": "What you can do now",
            "procedure_label": "FET transfer",
            "result_label": "FET result"
          }
        },
        "iui": {
          "positive": {
            "eyebrow": "Insemination result",
            "title": "A positive IUI result is on record — take a breath",
            "summary": "Whatever you're feeling, you don't have to decide what comes next today. When you're ready, we'll help you keep this result, your insemination details, and your questions together for your next conversation with your clinic.",
            "section_title": "What happens next",
            "section_subtitle": "Keep the confirmed result connected to your insemination date and care plan.",
            "today_section_title": "Today",
            "procedure_label": "IUI procedure",
            "result_label": "IUI result"
          },
          "negative": {
            "eyebrow": "Insemination result",
            "summary": "Whatever you're feeling, you don't have to decide what comes next today. When you're ready, we'll help you make sense of this cycle and prepare your questions for your next conversation with your clinic.",
            "section_title": "What happens next",
            "section_subtitle": "Take the next step with your clinic without assuming what you want to do next.",
            "today_section_title": "Today",
            "procedure_label": "IUI procedure",
            "result_label": "IUI result"
          },
          "unavailable": {
            "eyebrow": "Insemination result",
            "title": "Your IUI result is still to come",
            "summary": "When your clinic or test result is ready, you can add it here. Until then, we won't label this cycle positive or negative.",
            "section_title": "Keep this cycle in view",
            "section_subtitle": "Save the next real step while you wait for an official result.",
            "today_section_title": "What you can do now",
            "procedure_label": "IUI procedure",
            "result_label": "IUI result"
          },
          "uncertain": {
            "eyebrow": "Insemination result",
            "title": "Let's take another look at your IUI result",
            "summary": "This result is not clear enough to label the cycle positive or negative. Review the record or check the next step with your care team.",
            "section_title": "Clarify what was recorded",
            "section_subtitle": "Keep the insemination context together while the result is checked.",
            "today_section_title": "What you can do now",
            "procedure_label": "IUI procedure",
            "result_label": "IUI result"
          },
          "adverse": {
            "eyebrow": "After your IUI result",
            "title": "Take this one step at a time",
            "summary": "You do not have to make another treatment decision today. When you are ready, we can help you keep the record together and prepare for a conversation with your care team.",
            "section_title": "What may help now",
            "section_subtitle": "Keep the insemination context and your next conversation together. If you have urgent symptoms, contact your care team or local emergency services.",
            "today_section_title": "What you can do now",
            "procedure_label": "IUI procedure",
            "result_label": "IUI result"
          }
        },
        "oi": {
          "positive": {
            "eyebrow": "Ovulation induction result",
            "title": "A positive result is on record — take a breath",
            "summary": "Whatever you're feeling, you don't have to decide what comes next today. When you're ready, we'll help you keep this result, your treatment details, and your questions together for your next conversation with your clinic.",
            "section_title": "What happens next",
            "section_subtitle": "Keep the confirmed result connected to ovulation timing and your clinic plan.",
            "today_section_title": "Today",
            "procedure_label": "Ovulation-induction cycle",
            "result_label": "OI result"
          },
          "negative": {
            "eyebrow": "Ovulation induction result",
            "summary": "Whatever you're feeling, you don't have to decide what comes next today. When you're ready, we'll help you make sense of this cycle and prepare your questions for your next conversation with your clinic.",
            "section_title": "What happens next",
            "section_subtitle": "Take the next step with your clinic without assuming what you want to do next.",
            "today_section_title": "Today",
            "procedure_label": "Ovulation-induction cycle",
            "result_label": "OI result"
          },
          "unavailable": {
            "eyebrow": "Ovulation induction result",
            "title": "Your ovulation-induction result is still to come",
            "summary": "When your clinic or test result is ready, you can add it here. Until then, we won't label this cycle positive or negative.",
            "section_title": "Keep this cycle in view",
            "section_subtitle": "Save the next real step while you wait for an official result.",
            "today_section_title": "What you can do now",
            "procedure_label": "Ovulation-induction cycle",
            "result_label": "OI result"
          },
          "uncertain": {
            "eyebrow": "Ovulation induction result",
            "title": "Let's take another look at your ovulation-induction result",
            "summary": "This result is not clear enough to label the cycle positive or negative. Review the record or check the next step with your care team.",
            "section_title": "Clarify what was recorded",
            "section_subtitle": "Keep the ovulation-induction context together while the result is checked.",
            "today_section_title": "What you can do now",
            "procedure_label": "Ovulation-induction cycle",
            "result_label": "OI result"
          },
          "adverse": {
            "eyebrow": "After your ovulation-induction result",
            "title": "Take this one step at a time",
            "summary": "You do not have to make another treatment decision today. When you are ready, we can help you keep the record together and prepare for a conversation with your care team.",
            "section_title": "What may help now",
            "section_subtitle": "Keep the ovulation-induction context and your next conversation together. If you have urgent symptoms, contact your care team or local emergency services.",
            "today_section_title": "What you can do now",
            "procedure_label": "Ovulation-induction cycle",
            "result_label": "OI result"
          }
        }
      },
      "concepts": {
        "egg_freezing_active": {
          "eyebrow": "Egg freezing",
          "title": "Stimulation day 7",
          "summary": "Follicles are growing and pressure/bloating can increase today. Monitoring tomorrow decides whether retrieval moves earlier.",
          "hm1_label": "Progress",
          "hm1_value": "Day 7",
          "hm1_note": "retrieval est. May 24",
          "hm2_label": "Follicles",
          "hm2_value": "12",
          "hm2_note": "lead 18 mm",
          "hm3_label": "Next",
          "hm3_value": "Monitoring",
          "hm3_note": "tomorrow 8:20 AM"
        },
        "embryo_freezing_active": {
          "eyebrow": "Embryo freezing",
          "title": "Stimulation day 7",
          "summary": "12 follicles are growing, lead is 18 mm, and retrieval is currently estimated for May 24.",
          "hm1_label": "Progress",
          "hm1_value": "Day 7",
          "hm1_note": "retrieval est. May 24",
          "hm2_label": "Follicles",
          "hm2_value": "12",
          "hm2_note": "lead 18 mm",
          "hm3_label": "Next",
          "hm3_value": "Monitoring",
          "hm3_note": "tomorrow 8:20 AM"
        },
        "ivf_active": {
          "eyebrow": "IVF",
          "title": "Stimulation with embryo plan ready",
          "summary": "Track today's meds and appointments, current ovarian response, sperm readiness, and the lab timeline that starts at retrieval.",
          "hm1_label": "Phase",
          "hm1_value": "Stim day 7",
          "hm1_note": "retrieval est. May 24",
          "hm2_label": "Follicles",
          "hm2_value": "12",
          "hm2_note": "lead 18 mm",
          "hm3_label": "Lab",
          "hm3_value": "ICSI",
          "hm3_note": "PGT-A planned"
        },
        "egg_freezing_postcycle": {
          "eyebrow": "Egg freezing",
          "title": "11 mature eggs frozen",
          "summary": "Your lab report is in. See what was frozen, where it is stored, and whether another cycle is worth considering.",
          "hm1_label": "Retrieved",
          "hm1_value": "14",
          "hm1_note": "from follicle fluid",
          "hm2_label": "Mature",
          "hm2_value": "11",
          "hm2_note": "MII eggs",
          "hm3_label": "Frozen",
          "hm3_value": "11",
          "hm3_note": "stored at NY Cryo",
          "section_title": "Results",
          "section_subtitle": "The funnel follows the lab checkpoints from retrieval to storage.",
          "funnel_title": "Egg freezing result",
          "f1_label": "Retrieved",
          "f1_detail": "Eggs found by embryology.",
          "f2_label": "Mature",
          "f2_detail": "MII eggs eligible for freezing.",
          "f3_label": "Frozen",
          "f3_detail": "Vitrified and stored.",
          "inv_title": "Cryo inventory",
          "inv_m1_label": "Storage facility",
          "inv_m1_value": "NY Cryo",
          "inv_m1_note": "active",
          "inv_m2_label": "Renewal",
          "inv_m2_value": "May 18, 2027",
          "inv_m2_note": "$650/year",
          "inv_m3_label": "Specimens",
          "inv_m3_value": "3 straws",
          "inv_m3_note": "11 eggs total",
          "dec_title": "Next decision",
          "d1_title": "Stop for now",
          "d1_detail": "11 mature eggs are stored and annual renewal is active.",
          "d1_status": "Reasonable",
          "d2_title": "Consider another cycle",
          "d2_detail": "For 2+ future children, another cycle may increase odds.",
          "d2_status": "Discuss",
          "d3_title": "Upload lab report",
          "d3_detail": "Keep the embryology and storage documents in the vault.",
          "d3_status": "Next"
        },
        "embryo_freezing_postcycle": {
          "eyebrow": "Embryo freezing",
          "title": "4 blastocysts frozen, PGT pending",
          "summary": "Your results view focuses on attrition, embryo status, PGT, storage, and the next decision.",
          "hm1_label": "Fertilized",
          "hm1_value": "8",
          "hm1_note": "normal 2PN",
          "hm2_label": "Blasts",
          "hm2_value": "4",
          "hm2_note": "frozen",
          "hm3_label": "PGT-A",
          "hm3_value": "Pending",
          "hm3_note": "est. 7-10 days",
          "section_title": "Lab results",
          "section_subtitle": "Every number in the embryo funnel has a different meaning.",
          "funnel_title": "Embryo funnel",
          "inv_title": "Embryo inventory",
          "inv_m1_label": "Embryos frozen",
          "inv_m1_value": "4",
          "inv_m1_note": "2 day 5, 2 day 6",
          "inv_m2_label": "Biopsied",
          "inv_m2_value": "4",
          "inv_m2_note": "PGT-A sent",
          "inv_m3_label": "Storage",
          "inv_m3_value": "Active",
          "inv_m3_note": "renewal May 2027",
          "dec_title": "What happens next",
          "d1_title": "Wait for PGT-A",
          "d1_detail": "Euploid results update transfer planning and family-building estimates.",
          "d1_status": "Current",
          "d2_title": "Plan transfer later",
          "d2_detail": "Needs uterine prep, medication protocol, and transfer timing.",
          "d2_status": "Next",
          "d3_title": "Consider another cycle",
          "d3_detail": "Depends on euploid count and target family size.",
          "d3_status": "Discuss"
        },
        "sperm_freezing_active": {
          "eyebrow": "Sperm freezing",
          "title": "Collection tomorrow",
          "summary": "Your appointment, abstinence window, sample instructions, expected analysis, and storage target are all in one place.",
          "hm1_label": "Collection",
          "hm1_value": "Tomorrow",
          "hm1_note": "8:30 AM",
          "hm2_label": "Abstinence",
          "hm2_value": "Day 3",
          "hm2_note": "target 2-5 days",
          "hm3_label": "Goal",
          "hm3_value": "6 vials",
          "hm3_note": "2 visits planned",
          "section_title": "Collection day",
          "section_subtitle": "Everything needed to avoid a bad sample or missed appointment.",
          "today_title": "Schedule",
          "tasks_title": "Before you go",
          "t1_title": "Bring photo ID",
          "t1_detail": "Required for sample identity checks.",
          "t1_due": "Tomorrow",
          "t2_title": "Avoid heat today",
          "t2_detail": "No sauna, hot tub, or fever/illness exposure if avoidable.",
          "t2_due": "Today",
          "t3_title": "Sign storage consent",
          "t3_detail": "Consent and disposition choices must be complete before long-term storage.",
          "t3_due": "Before banking",
          "metrics_title": "Baseline semen snapshot",
          "metrics_subtitle": "These values appear after the lab posts results."
        },
        "sperm_freezing_wait": {
          "eyebrow": "Sperm freezing",
          "title": "Sample processing",
          "summary": "The sample was collected today. Results and storage confirmation are expected in the next few days.",
          "hm1_label": "Collected",
          "hm1_value": "Today",
          "hm1_note": "8:42 AM",
          "hm2_label": "Results",
          "hm2_value": "2-5 days",
          "hm2_note": "lab processing",
          "hm3_label": "Storage",
          "hm3_value": "Pending",
          "hm3_note": "same week",
          "section_title": "Waiting for results",
          "section_subtitle": "See what is pending and what each result changes.",
          "timeline_title": "Lab status",
          "tl1_label": "Sample received",
          "tl1_detail": "Identity check and collection time logged.",
          "tl2_label": "Semen analysis",
          "tl2_detail": "Volume, concentration, motility, morphology.",
          "tl3_label": "Freeze/thaw estimate",
          "tl3_detail": "Expected usable motile sperm after thaw.",
          "tl4_label": "Storage confirmation",
          "tl4_detail": "Vials, facility, and annual renewal date posted.",
          "funnel_title": "Expected storage funnel",
          "dec_title": "Likely next step",
          "d1_title": "Bank another sample",
          "d1_detail": "Recommended if the first sample yields fewer than 3 usable vials.",
          "d1_status": "Possible",
          "d2_title": "Start 90-day reset",
          "d2_detail": "Useful if count, motility, or DNA fragmentation is abnormal.",
          "d2_status": "Depends on result",
          "d3_title": "Store and stop",
          "d3_detail": "Reasonable if vial target is met and future use is IVF/ICSI.",
          "d3_status": "Possible"
        },
        "sperm_freezing_postcycle": {
          "eyebrow": "Sperm freezing",
          "title": "6 vials stored",
          "summary": "The inventory is banked. See what is stored, what it can support, and whether a retest or additional collection helps.",
          "hm1_label": "Samples",
          "hm1_value": "2",
          "hm1_note": "banked",
          "hm2_label": "Vials",
          "hm2_value": "6",
          "hm2_note": "stored",
          "hm3_label": "Renewal",
          "hm3_value": "May 2027",
          "hm3_note": "$420/year",
          "section_title": "Inventory",
          "section_subtitle": "See which future paths the frozen vials are likely to support.",
          "funnel_title": "Banked sample funnel",
          "metrics_title": "Post-thaw estimate",
          "m1_label": "Total motile",
          "m1_value": "24M",
          "m1_note": "across vials",
          "m2_label": "IUI fit",
          "m2_value": "Limited",
          "m2_note": "may need more vials",
          "m3_label": "IVF/ICSI fit",
          "m3_value": "Strong",
          "m3_note": "lower sperm quantity needed",
          "dec_title": "Retest or bank more",
          "d1_title": "No urgent retest",
          "d1_detail": "Inventory fits IVF/ICSI backup use.",
          "d1_status": "Okay",
          "d2_title": "Bank one more sample",
          "d2_detail": "Improves IUI flexibility and redundancy.",
          "d2_status": "Consider",
          "d3_title": "90-day reset",
          "d3_detail": "Useful if trying to improve a future fresh sample.",
          "d3_status": "Optional"
        },
        "ivf_precycle": {
          "eyebrow": "IVF planning",
          "title": "Get IVF-ready",
          "summary": "Coordinate eggs, sperm, uterus, lab plan, clinic fit, and costs before protocol start.",
          "hm1_label": "Next",
          "hm1_value": "Baseline tests",
          "hm1_note": "AMH + AFC",
          "hm2_label": "Sperm",
          "hm2_value": "Needed",
          "hm2_note": "semen analysis",
          "hm3_label": "Clinic",
          "hm3_value": "2 matches",
          "hm3_note": "coverage pending",
          "section_title": "Readiness",
          "section_subtitle": "See what is ready before a cycle start can be confirmed.",
          "tasks_title": "Open items",
          "t1_title": "Complete medical history",
          "t1_detail": "Cycle plan needs meds, diagnoses, surgeries, and prior pregnancy history.",
          "t1_owner": "You",
          "t1_due": "Today",
          "t2_title": "Add semen analysis",
          "t2_detail": "Required to choose conventional IVF, ICSI, donor sperm, or backup freeze.",
          "t2_owner": "Partner/lab",
          "t2_due": "This week",
          "t3_title": "Check coverage",
          "t3_detail": "Separates diagnostics, meds, IVF lab, retrieval, transfer, and storage.",
          "t3_owner": "You",
          "t3_due": "This week",
          "metrics_title": "Baseline snapshot",
          "m1_label": "AMH",
          "m1_value": "Missing",
          "m1_note": "order or upload",
          "m2_label": "AFC",
          "m2_value": "Missing",
          "m2_note": "ultrasound",
          "m3_label": "Uterine eval",
          "m3_value": "Not done",
          "m3_note": "SIS/HSG if clinic requires",
          "dec_title": "Care path",
          "d1_title": "2 clinics fit location",
          "d1_detail": "Both offer IVF + ICSI + PGT-A.",
          "d1_status": "Unlocked after coverage",
          "d2_title": "Embryology lab quality",
          "d2_detail": "Review blast rates, PGT workflow, storage, and transfer coordination.",
          "d2_status": "Compare",
          "d3_title": "Start cycle",
          "d3_detail": "Available once clinic, protocol, and cycle start are confirmed.",
          "d3_status": "Locked"
        },
        "ivf_positive": {
          "eyebrow": "Result",
          "title": "Positive beta",
          "summary": "Keep the next beta, medications, warning symptoms, and ultrasound timing clear.",
          "hm1_label": "Beta",
          "hm1_value": "186",
          "hm1_note": "positive",
          "hm2_label": "Repeat",
          "hm2_value": "48 hours",
          "hm2_note": "May 20",
          "hm3_label": "Meds",
          "hm3_value": "Continue",
          "hm3_note": "no changes yet",
          "section_title": "Next medical steps",
          "section_subtitle": "Early pregnancy follow-up needs precise tasks.",
          "trend_title": "Beta trend",
          "tr1_label": "Beta 1",
          "tr1_value": "186",
          "tr1_note": "today",
          "tr2_label": "Beta 2",
          "tr2_value": "Scheduled",
          "tr2_note": "48 hours",
          "tr3_label": "Ultrasound",
          "tr3_value": "Est. 6-7 wks",
          "tr3_note": "after beta trend",
          "today_title": "Continue today",
          "tasks_title": "Before ultrasound",
          "t1_title": "Repeat beta",
          "t1_detail": "Second blood draw confirms trend.",
          "t1_owner": "Clinic",
          "t1_due": "May 20",
          "t2_title": "Continue progesterone",
          "t2_detail": "Do not stop unless clinic changes the plan.",
          "t2_owner": "You",
          "t2_due": "Daily",
          "t3_title": "OB handoff folder",
          "t3_detail": "Pregnancy summary and IVF records are prepared after ultrasound.",
          "t3_owner": "Louise",
          "t3_due": "Later"
        },
        "ivf_negative": {
          "eyebrow": "Result",
          "title": "Negative beta",
          "summary": "Clear next steps: medication instructions, support, cycle recap, and next options.",
          "hm1_label": "Beta",
          "hm1_value": "Negative",
          "hm1_note": "reviewed",
          "hm2_label": "Next",
          "hm2_value": "Consult",
          "hm2_note": "May 23",
          "hm3_label": "Embryos",
          "hm3_value": "2 stored",
          "hm3_note": "available",
          "section_title": "What happens now",
          "section_subtitle": "Support and concrete instructions for the next few days.",
          "tasks_title": "Today",
          "t1_title": "Medication plan",
          "t1_detail": "Clinic says to stop progesterone tonight.",
          "t1_owner": "Clinic",
          "t1_due": "Today",
          "t2_title": "Bleeding expectations",
          "t2_detail": "Period may start in a few days; call for heavy bleeding or severe pain.",
          "t2_owner": "You",
          "t2_due": "This week",
          "t3_title": "Follow-up consult",
          "t3_detail": "Review embryo quality, transfer protocol, and next attempt options.",
          "t3_owner": "You + clinic",
          "t3_due": "May 23",
          "funnel_title": "Cycle recap",
          "f1_label": "Retrieved",
          "f1_detail": "Eggs collected.",
          "f2_label": "Mature",
          "f2_detail": "MII eggs.",
          "f3_label": "Fertilized",
          "f3_detail": "Normal fertilization.",
          "f4_label": "Blasts",
          "f4_detail": "Blastocysts.",
          "f5_label": "Transferred",
          "f5_detail": "This attempt.",
          "dec_title": "Next attempt options",
          "d1_title": "Use stored embryo",
          "d1_detail": "2 embryos remain frozen.",
          "d1_status": "Available",
          "d2_title": "Change protocol",
          "d2_detail": "Discuss progesterone timing, lining prep, or embryo selection.",
          "d2_status": "Consult",
          "d3_title": "Pause",
          "d3_detail": "Keep storage active and decide later.",
          "d3_status": "Available"
        },
        "iui_precycle": {
          "eyebrow": "IUI planning",
          "title": "Prepare for IUI timing",
          "summary": "Center ovulation timing, sperm/vial readiness, monitoring, trigger, insemination, and the beta wait.",
          "hm1_label": "Cycle",
          "hm1_value": "Not started",
          "hm1_note": "call with day 1",
          "hm2_label": "Sperm source",
          "hm2_value": "Partner",
          "hm2_note": "SA uploaded",
          "hm3_label": "Plan",
          "hm3_value": "Medicated IUI",
          "hm3_note": "letrozole + trigger",
          "section_title": "Readiness",
          "section_subtitle": "Everything needed before cycle day 1.",
          "tasks_title": "Open items",
          "t1_title": "Confirm day 1 call",
          "t1_detail": "Clinic opens monitoring schedule when period starts.",
          "t1_owner": "You",
          "t1_due": "Cycle day 1",
          "t2_title": "Partner sample plan",
          "t2_detail": "2-5 day abstinence before collection.",
          "t2_owner": "Partner",
          "t2_due": "IUI day",
          "t3_title": "Trigger coverage",
          "t3_detail": "Ovidrel prescription and pharmacy benefit check.",
          "t3_owner": "You",
          "t3_due": "This week",
          "metrics_title": "Baseline",
          "m1_label": "Semen analysis",
          "m1_value": "Normal",
          "m1_note": "uploaded",
          "m2_label": "Tubes",
          "m2_value": "HSG clear",
          "m2_note": "both patent",
          "m3_label": "Protocol",
          "m3_value": "Letrozole",
          "m3_note": "CD 3-7",
          "timeline_title": "IUI cycle shape",
          "tl1_label": "Cycle day 1",
          "tl1_detail": "Call clinic and schedule baseline.",
          "tl2_label": "CD 3-7",
          "tl2_detail": "Letrozole.",
          "tl3_label": "CD 10-12",
          "tl3_detail": "Monitoring and possible trigger.",
          "tl4_label": "IUI",
          "tl4_detail": "Insemination 24-36 hours after trigger.",
          "tl5_label": "Beta wait",
          "tl5_detail": "Blood test about 14 days later."
        },
        "iui_active": {
          "eyebrow": "IUI",
          "title": "Trigger tonight",
          "summary": "A timing dashboard for follicle, lining, trigger, sperm sample, insemination, and the wait start.",
          "hm1_label": "Cycle day",
          "hm1_value": "CD 11",
          "hm1_note": "monitoring complete",
          "hm2_label": "Lead follicle",
          "hm2_value": "20 mm",
          "hm2_note": "right ovary",
          "hm3_label": "IUI",
          "hm3_value": "36 hours",
          "hm3_note": "May 20 9:30 AM",
          "section_title": "Timing",
          "section_subtitle": "The next 36 hours are mapped to exact actions.",
          "today_title": "Today and tomorrow",
          "r1_title": "Ovidrel trigger",
          "r1_detail": "Inject tonight. IUI is scheduled 36 hours later.",
          "r2_title": "Partner sample",
          "r2_detail": "Collection before lab wash. Abstinence window: day 3.",
          "r2_procedure": "Sperm collection",
          "r3_title": "IUI appointment",
          "r3_detail": "Arrive 15 minutes early.",
          "metrics_title": "Monitoring result",
          "m1_label": "Lead follicle",
          "m1_value": "20 mm",
          "m1_note": "ready",
          "m2_label": "Lining",
          "m2_value": "8.6 mm",
          "m2_note": "trilaminar",
          "m3_label": "LH",
          "m3_value": "Low",
          "m3_note": "trigger planned",
          "tasks_title": "Do not miss",
          "t1_title": "Trigger at 9 PM",
          "t1_detail": "Timing controls insemination window.",
          "t1_owner": "You",
          "t1_due": "Tonight",
          "t2_title": "Partner collection",
          "t2_detail": "Sample must arrive before lab wash cutoff.",
          "t2_owner": "Partner",
          "t2_due": "May 20",
          "t3_title": "Start wait plan",
          "t3_detail": "Beta date and meds appear after IUI is logged.",
          "t3_owner": "Louise",
          "t3_due": "After IUI"
        },
        "iui_wait": {
          "eyebrow": "IUI wait",
          "title": "5 days after IUI",
          "summary": "Trigger-shot caveats, symptom uncertainty, meds, and what happens on test day.",
          "hm1_label": "IUI",
          "hm1_value": "5 days ago",
          "hm1_note": "May 20",
          "hm2_label": "Test",
          "hm2_value": "May 31",
          "hm2_note": "clinic beta",
          "hm3_label": "Trigger",
          "hm3_value": "Can linger",
          "hm3_note": "avoid early tests",
          "section_title": "During the wait",
          "section_subtitle": "Support during the wait, with IUI-specific timing.",
          "today_title": "Today",
          "dec_title": "Home test timing",
          "d1_title": "Too early",
          "d1_detail": "hCG trigger can create false positives soon after injection.",
          "d1_status": "Do not rely",
          "d2_title": "Clinic beta",
          "d2_detail": "Blood test is scheduled for May 31.",
          "d2_status": "Use this",
          "d3_title": "Period starts",
          "d3_detail": "Message the clinic; they may still want instructions logged.",
          "d3_status": "Plan"
        },
        "amab_family_building_precycle": {
          "eyebrow": "Family building",
          "title": "Compare sperm, donor, carrier, and embryo path",
          "summary": "Coordinate both partners' sperm options plus donor egg, gestational carrier, embryo creation, legal, and costs.",
          "hm1_label": "Partner A",
          "hm1_value": "SA ready",
          "hm1_note": "46M/mL",
          "hm2_label": "Partner B",
          "hm2_value": "Testing due",
          "hm2_note": "this week",
          "hm3_label": "Donor/carrier",
          "hm3_value": "Not selected",
          "hm3_note": "matching open",
          "section_title": "Build the path",
          "section_subtitle": "Keep sperm testing, donor egg, carrier, legal, and cost tasks in one place.",
          "metrics_title": "Compare sperm inputs",
          "m1_label": "Partner A motility",
          "m1_value": "52%",
          "m1_note": "bank backup",
          "m2_label": "Partner B test",
          "m2_value": "Missing",
          "m2_note": "order semen analysis",
          "m3_label": "Split plan",
          "m3_value": "Undecided",
          "m3_note": "A/B embryos possible",
          "tasks_title": "Source and legal tasks",
          "t1_title": "Shortlist egg donors",
          "t1_detail": "3 donors match age, carrier status, and agency compatibility.",
          "t1_owner": "You",
          "t1_due": "This week",
          "t2_title": "Choose carrier route",
          "t2_detail": "Agency matching vs known carrier.",
          "t2_owner": "You",
          "t2_due": "Next",
          "t3_title": "Legal intake",
          "t3_detail": "Parentage and donor/carrier agreement checklist.",
          "t3_owner": "Legal",
          "t3_due": "After shortlist",
          "timeline_title": "Family-building sequence",
          "tl1_label": "Now",
          "tl1_detail": "Test and optionally freeze sperm for both partners.",
          "tl2_label": "Next",
          "tl2_detail": "Choose donor egg source and carrier path.",
          "tl3_label": "Then",
          "tl3_detail": "Create embryos with split sperm plan if desired.",
          "tl4_label": "After PGT/storage",
          "tl4_detail": "Prepare carrier transfer."
        },
        "partner_precycle": {
          "eyebrow": "Partner view",
          "title": "Your tasks before treatment starts",
          "summary": "See what you own and what is shared from the treatment plan.",
          "hm1_label": "Your tasks",
          "hm1_value": "2 open",
          "hm1_note": "semen + coverage",
          "hm2_label": "Shared plan",
          "hm2_value": "Pre-cycle",
          "hm2_note": "clinic shortlist",
          "hm3_label": "Next",
          "hm3_value": "Semen analysis",
          "hm3_note": "this week",
          "section_title": "Owned by you",
          "section_subtitle": "Focus on your tasks while keeping the shared plan visible.",
          "tasks_title": "Your tasks",
          "t1_title": "Book semen analysis",
          "t1_detail": "Needed before IVF/IUI sperm plan is final.",
          "t1_owner": "You",
          "t1_due": "This week",
          "t2_title": "Add coverage details",
          "t2_detail": "Employer benefits or insurance may affect shared estimate.",
          "t2_owner": "You",
          "t2_due": "This week",
          "t3_title": "Read retrieval-day support",
          "t3_detail": "Ride, food, meds, and what symptoms to watch.",
          "t3_owner": "You",
          "t3_due": "Later",
          "timeline_title": "Shared progress",
          "tl1_label": "Medical history",
          "tl1_detail": "Primary patient completed baseline history.",
          "tl2_label": "Clinic shortlist",
          "tl2_detail": "2 clinics unlocked after coverage status.",
          "tl3_label": "Cycle start",
          "tl3_detail": "Not scheduled yet."
        },
        "partner_active": {
          "eyebrow": "Partner view",
          "title": "What you can do today",
          "summary": "Partner-owned actions, shared appointments, and practical support for today.",
          "hm1_label": "Today",
          "hm1_value": "Sample backup",
          "hm1_note": "confirm by 5 PM",
          "hm2_label": "Shared",
          "hm2_value": "Monitoring tomorrow",
          "hm2_note": "8:20 AM",
          "hm3_label": "Support",
          "hm3_value": "Bloating likely",
          "hm3_note": "stimulation day 7",
          "section_title": "Today",
          "section_subtitle": "The partner can act without reading the primary patient's whole chart.",
          "tasks_title": "Your actions",
          "t1_title": "Confirm sample backup",
          "t1_detail": "Tell clinic whether fresh sample or frozen backup is primary.",
          "t1_owner": "You",
          "t1_due": "Today",
          "t2_title": "Prepare pickup plan",
          "t2_detail": "Retrieval may require a ride home with sedation.",
          "t2_owner": "You",
          "t2_due": "Before retrieval",
          "t3_title": "Support meds routine",
          "t3_detail": "Help make space for evening injection timing.",
          "t3_owner": "You",
          "t3_due": "Tonight",
          "today_title": "Shared schedule",
          "dec_title": "How to support today",
          "d1_title": "Practical",
          "d1_detail": "Hydration, low-pressure food, ride planning, and medication reminders.",
          "d1_status": "Useful",
          "d2_title": "Emotional",
          "d2_detail": "Ask before problem-solving; stimulation discomfort can fluctuate.",
          "d2_status": "Useful"
        },
        "egg_donor": {
          "eyebrow": "Egg donor",
          "title": "Screening in progress",
          "summary": "Agency and clinic operations: application, screening, legal, match, cycle readiness, compensation, and documents.",
          "hm1_label": "Status",
          "hm1_value": "Screening",
          "hm1_note": "2 tasks today",
          "hm2_label": "Match",
          "hm2_value": "Profile live",
          "hm2_note": "agency review",
          "hm3_label": "Compensation",
          "hm3_value": "$8,000",
          "hm3_note": "pending match",
          "section_title": "Screening",
          "section_subtitle": "Track today's screening tasks, appointments, and next documents.",
          "today_title": "Today",
          "tasks_title": "Open requirements",
          "t1_title": "Upload prior labs",
          "t1_detail": "Agency needs records before medical clearance.",
          "t1_owner": "You",
          "t1_due": "Today",
          "t2_title": "Psych consult",
          "t2_detail": "Virtual screening appointment.",
          "t2_owner": "Agency",
          "t2_due": "May 22",
          "t3_title": "Legal packet",
          "t3_detail": "Unlocks after intended-parent match.",
          "t3_owner": "Legal",
          "t3_due": "After match",
          "timeline_title": "Donor path",
          "tl1_label": "Application",
          "tl1_detail": "Profile accepted by agency.",
          "tl2_label": "Screening",
          "tl2_detail": "Labs, psych, genetic carrier screening.",
          "tl3_label": "Match",
          "tl3_detail": "Intended parents select donor profile.",
          "tl4_label": "Cycle",
          "tl4_detail": "Meds, monitoring, trigger, retrieval.",
          "tl5_label": "Payment",
          "tl5_detail": "Compensation milestones after retrieval."
        },
        "sperm_donor": {
          "eyebrow": "Sperm donor",
          "title": "Donation visit this week",
          "summary": "Track eligibility, collection schedule, abstinence windows, sample status, quarantine/retest, and compensation.",
          "hm1_label": "Status",
          "hm1_value": "Approved",
          "hm1_note": "active donor",
          "hm2_label": "Samples",
          "hm2_value": "3 accepted",
          "hm2_note": "1 pending",
          "hm3_label": "Next visit",
          "hm3_value": "Friday",
          "hm3_note": "9:00 AM",
          "section_title": "Donation operations",
          "section_subtitle": "See the donation visit, sample status, and program requirements.",
          "today_title": "Donation schedule",
          "metrics_title": "Sample status",
          "m1_label": "Accepted",
          "m1_value": "3",
          "m1_note": "eligible for quarantine",
          "m2_label": "Pending",
          "m2_value": "1",
          "m2_note": "lab review",
          "m3_label": "Rejected",
          "m3_value": "0",
          "m3_note": "this month",
          "m4_label": "Compensation",
          "m4_value": "$350",
          "m4_note": "next payout",
          "tasks_title": "Program requirements",
          "t1_title": "Retest infectious labs",
          "t1_detail": "Required before samples are released from quarantine.",
          "t1_owner": "You",
          "t1_due": "In 6 months",
          "t2_title": "Keep abstinence window",
          "t2_detail": "Target 2-5 days before Friday visit.",
          "t2_owner": "You",
          "t2_due": "Friday"
        },
        "carrier": {
          "eyebrow": "Carrier",
          "title": "Application and screening",
          "summary": "Coordinate agency intake, medical records, screening, legal, transfer readiness, and compensation.",
          "hm1_label": "Status",
          "hm1_value": "Application",
          "hm1_note": "records needed",
          "hm2_label": "Agency",
          "hm2_value": "2 matches",
          "hm2_note": "reviewing",
          "hm3_label": "Next",
          "hm3_value": "OB records",
          "hm3_note": "upload",
          "section_title": "Carrier readiness",
          "section_subtitle": "Agency, legal, and medical responsibilities are separated.",
          "tasks_title": "Open requirements",
          "t1_title": "Upload OB records",
          "t1_detail": "Pregnancy and delivery history needed for medical review.",
          "t1_owner": "You",
          "t1_due": "Today",
          "t2_title": "Insurance review",
          "t2_detail": "Carrier pregnancy coverage review in progress.",
          "t2_owner": "Agency",
          "t2_due": "This week",
          "t3_title": "Psych consult",
          "t3_detail": "Scheduled after medical pre-clearance.",
          "t3_owner": "Agency",
          "t3_due": "Next",
          "timeline_title": "Carrier path",
          "tl1_label": "Application",
          "tl1_detail": "Profile and initial eligibility.",
          "tl2_label": "Screening",
          "tl2_detail": "Medical, psych, insurance, and home context.",
          "tl3_label": "Match and legal",
          "tl3_detail": "Intended-parent match and contract.",
          "tl4_label": "Transfer prep",
          "tl4_detail": "Embryo, meds, lining checks, transfer."
        },
        "intended_parent": {
          "eyebrow": "Intended parent",
          "title": "Donor, carrier, embryos, legal, and costs",
          "summary": "Coordinate agency work, source matching, embryo readiness, legal milestones, and money.",
          "hm1_label": "Egg donor",
          "hm1_value": "3 shortlisted",
          "hm1_note": "carrier status checked",
          "hm2_label": "Carrier",
          "hm2_value": "Search open",
          "hm2_note": "2 agency calls",
          "hm3_label": "Escrow",
          "hm3_value": "Not started",
          "hm3_note": "legal first",
          "section_title": "Operating plan",
          "section_subtitle": "Keep agency, clinic, lab, and legal work in one view.",
          "tasks_title": "Open tasks",
          "t1_title": "Choose donor shortlist",
          "t1_detail": "3 candidates match profile, availability, and carrier screening.",
          "t1_owner": "You",
          "t1_due": "This week",
          "t2_title": "Carrier agency intake",
          "t2_detail": "Two calls scheduled; one requires embryo plan first.",
          "t2_owner": "You",
          "t2_due": "This week",
          "t3_title": "Legal intake",
          "t3_detail": "Parentage, donor, and carrier contracts.",
          "t3_owner": "Legal",
          "t3_due": "After donor/carrier choice",
          "metrics_title": "Cost snapshot",
          "m1_label": "Agency retainers",
          "m1_value": "$18k-25k",
          "m1_note": "range",
          "m2_label": "Donor cycle",
          "m2_value": "$35k-55k",
          "m2_note": "est.",
          "m3_label": "Carrier escrow",
          "m3_value": "Not opened",
          "m3_note": "legal first",
          "timeline_title": "Path to transfer",
          "tl1_label": "Now",
          "tl1_detail": "Select donor and carrier pathway.",
          "tl2_label": "Next",
          "tl2_detail": "Create embryos or confirm embryo inventory.",
          "tl3_label": "Legal",
          "tl3_detail": "Contracts and escrow.",
          "tl4_label": "Transfer",
          "tl4_detail": "Carrier medical clearance and transfer cycle."
        }
      },
      "detailed": {
        "egg_freezing_postcycle": {
          "s1_title": "What the result means",
          "s1_subtitle": "Translate the lab report into storage and family-planning context.",
          "quality_title": "Quality of result",
          "q1_label": "Maturity rate",
          "q1_value": "79%",
          "q1_note": "11 of 14 retrieved",
          "q2_label": "Freeze method",
          "q2_value": "Vitrified",
          "q2_note": "rapid cooling",
          "q3_label": "Thaw survival",
          "q3_value": "Not known",
          "q3_note": "estimated later by clinic/lab",
          "funnel_title": "Future-use estimate",
          "f1_label": "Frozen eggs",
          "f1_detail": "Stored now.",
          "f2_label": "Survive thaw",
          "f2_detail": "Many, not all, eggs are expected to survive thawing.",
          "f3_label": "Fertilize",
          "f3_detail": "If used with sperm later, not all eggs fertilize.",
          "f4_label": "Blastocysts",
          "f4_detail": "Embryos must keep developing before transfer/testing.",
          "f5_label": "Live birth estimate",
          "f5_detail": "Age at freezing and sperm/embryo factors change this.",
          "s2_title": "Storage operations",
          "s2_subtitle": "Keep the cryo inventory visible and usable.",
          "tasks_title": "Keep storage current",
          "t1_title": "Confirm facility contact",
          "t1_detail": "NY Cryo is listed as the active storage facility.",
          "t1_owner": "You",
          "t1_due": "This week",
          "t2_title": "Set renewal reminder",
          "t2_detail": "Annual renewal is due before May 18, 2027.",
          "t2_owner": "Louise",
          "t2_due": "Done",
          "t3_title": "Upload final report",
          "t3_detail": "Embryology report and storage certificate belong in documents.",
          "t3_owner": "You",
          "t3_due": "Optional"
        },
        "embryo_freezing_postcycle": {
          "section_title": "PGT and storage",
          "section_subtitle": "Review embryo inventory, PGT timing, storage, and next decisions.",
          "metrics_title": "PGT-A status",
          "m1_label": "Biopsied",
          "m1_value": "4",
          "m1_note": "all frozen blasts",
          "m2_label": "Result ETA",
          "m2_value": "May 27",
          "m2_note": "lab estimate",
          "m3_label": "Transferable",
          "m3_value": "Pending",
          "m3_note": "requires PGT-A or clinic review",
          "tasks_title": "Inventory tasks",
          "t1_title": "Upload PGT report",
          "t1_detail": "Report attaches euploid/aneuploid/mosaic results to each embryo.",
          "t1_owner": "You",
          "t1_due": "When ready",
          "t2_title": "Confirm embryo labels",
          "t2_detail": "Match lab identifiers to storage inventory.",
          "t2_owner": "Lab",
          "t2_due": "This week",
          "t3_title": "Transfer planning consult",
          "t3_detail": "Book after PGT-A results if using embryos soon.",
          "t3_owner": "You",
          "t3_due": "After results"
        },
        "sperm_freezing_active": {
          "s1_title": "Collection quality",
          "s1_subtitle": "Focus on the collection factors you can control.",
          "checks_title": "Pre-collection checks",
          "c1_label": "Abstinence",
          "c1_value": "3 days",
          "c1_note": "inside 2-5 day target",
          "c2_label": "Fever/heat",
          "c2_value": "None",
          "c2_note": "last 10 days",
          "c3_label": "Hydration",
          "c3_value": "Logged",
          "c3_note": "today",
          "c4_label": "ID + consent",
          "c4_value": "Ready",
          "c4_note": "required",
          "tasks_title": "Collection instructions",
          "t1_title": "Arrive with ID",
          "t1_detail": "Identity check is required before the sample is accepted.",
          "t1_owner": "You",
          "t1_due": "8:30 AM",
          "t2_title": "Ask for post-thaw estimate",
          "t2_detail": "This determines whether the inventory is better suited for IUI or IVF/ICSI.",
          "t2_owner": "You",
          "t2_due": "At visit",
          "t3_title": "Choose disposition settings",
          "t3_detail": "Storage, future use, discard, and death/incapacity choices must be documented.",
          "t3_owner": "You",
          "t3_due": "Before storage",
          "s2_title": "Storage target",
          "s2_subtitle": "See whether this visit is enough or another collection is useful.",
          "funnel_title": "Target vials",
          "funnel_subtitle": "A second collection is already scheduled if the first sample produces fewer usable vials than planned."
        },
        "sperm_freezing_wait": {
          "section_title": "What the lab is checking",
          "section_subtitle": "See why results take time and what each metric changes.",
          "metrics_title": "Pending semen metrics",
          "m1_label": "Volume",
          "m1_value": "Pending",
          "m1_note": "sample amount",
          "m2_label": "Concentration",
          "m2_value": "Pending",
          "m2_note": "sperm per mL",
          "m3_label": "Motility",
          "m3_value": "Pending",
          "m3_note": "moving sperm",
          "m4_label": "Morphology",
          "m4_value": "Pending",
          "m4_note": "strict forms",
          "dec_title": "Result branches",
          "d1_title": "Target met",
          "d1_detail": "Storage confirmation becomes the main task.",
          "d1_status": "Store",
          "d2_title": "Borderline vial count",
          "d2_detail": "Another collection improves redundancy.",
          "d2_status": "Collect again",
          "d3_title": "Abnormal analysis",
          "d3_detail": "A 72-90 day reset, repeat semen analysis, and urology review become useful.",
          "d3_status": "Optimize"
        },
        "sperm_freezing_postcycle": {
          "section_title": "Using the inventory later",
          "section_subtitle": "See what the frozen vials are likely to support.",
          "metrics_title": "Use-case fit",
          "m1_label": "IUI",
          "m1_value": "Maybe",
          "m1_note": "depends on post-thaw motile count per vial",
          "m2_label": "IVF",
          "m2_value": "Strong",
          "m2_note": "lower sperm count needed",
          "m3_label": "ICSI",
          "m3_value": "Strongest",
          "m3_note": "single sperm per egg",
          "m4_label": "Backup",
          "m4_value": "Ready",
          "m4_note": "for IVF retrieval day",
          "tasks_title": "Storage maintenance",
          "t1_title": "Save storage certificate",
          "t1_detail": "Facility, number of vials, and renewal date are stored in documents.",
          "t1_owner": "Louise",
          "t1_due": "Done",
          "t2_title": "Renewal payment",
          "t2_detail": "Annual storage fee due May 2027.",
          "t2_owner": "You",
          "t2_due": "May 2027",
          "t3_title": "Retest if trying soon",
          "t3_detail": "Repeat semen analysis if planning fresh sperm use.",
          "t3_owner": "You",
          "t3_due": "Optional"
        },
        "ivf_precycle": {
          "s1_title": "Required readiness",
          "s1_subtitle": "Separate baseline data, sperm source, uterine readiness, and clinic fit.",
          "tasks_title": "Before protocol",
          "t1_title": "Medical history",
          "t1_detail": "Medications, prior pregnancies, surgeries, diagnoses, allergies, and losses.",
          "t1_owner": "You",
          "t1_due": "Today",
          "t2_title": "Ovarian reserve",
          "t2_detail": "AMH plus AFC gives the clinic a starting point for stimulation dosing.",
          "t2_owner": "You/clinic",
          "t2_due": "This week",
          "t3_title": "Sperm plan",
          "t3_detail": "Semen analysis, donor sperm, or frozen backup decides IVF vs ICSI details.",
          "t3_owner": "Partner/lab",
          "t3_due": "This week",
          "t4_title": "Uterine evaluation",
          "t4_detail": "HSG, SIS, or hysteroscopy if the clinic needs a cavity/tube check.",
          "t4_owner": "Clinic",
          "t4_due": "Before transfer",
          "dec_title": "Clinic shortlist",
          "d1_title": "RMA Brooklyn",
          "d1_detail": "Strong IVF lab, PGT-A workflow, in-network estimate pending.",
          "d1_status": "91% fit",
          "d2_title": "NYU Langone Fertility",
          "d2_detail": "Hospital-based care, known for complex histories, consult in 12 days.",
          "d2_status": "88% fit",
          "d3_title": "Spring Tribeca",
          "d3_detail": "Fast consult, transparent self-pay package, storage onsite.",
          "d3_status": "84% fit",
          "s2_title": "Cost and coverage",
          "s2_subtitle": "See what changes the out-of-pocket estimate.",
          "estimate_title": "Estimate inputs",
          "e1_label": "Diagnostics",
          "e1_value": "$0-850",
          "e1_note": "depends on coverage",
          "e2_label": "Meds",
          "e2_value": "$3k-7k",
          "e2_note": "dose dependent",
          "e3_label": "IVF + lab",
          "e3_value": "$12k-22k",
          "e3_note": "ICSI/PGT/storage separate",
          "e4_label": "Coverage",
          "e4_value": "Unknown",
          "e4_note": "check benefits"
        },
        "ivf_positive": {
          "section_title": "Early follow-up",
          "section_subtitle": "Stay medically precise until the pregnancy is confirmed by trend and ultrasound.",
          "timeline_title": "Next checkpoints",
          "tl1_label": "Today",
          "tl1_detail": "Positive beta reviewed; continue meds.",
          "tl2_label": "48 hours",
          "tl2_detail": "Repeat beta checks trend.",
          "tl3_label": "5-6 weeks",
          "tl3_detail": "Early ultrasound confirms location and gestational sac.",
          "tl4_label": "6-7 weeks",
          "tl4_detail": "Heartbeat ultrasound if trend and first scan are reassuring.",
          "tl5_label": "OB handoff",
          "tl5_detail": "Transfer summary and IVF dates go to OB after fertility-clinic release.",
          "tasks_title": "Call now if",
          "t1_title": "Severe one-sided pain",
          "t1_detail": "Especially with dizziness or shoulder pain.",
          "t1_owner": "You",
          "t1_due": "Any time",
          "t2_title": "Heavy bleeding",
          "t2_detail": "Soaking a pad or passing large clots.",
          "t2_owner": "You",
          "t2_due": "Any time",
          "t3_title": "Medication issue",
          "t3_detail": "Missed progesterone or refill problem.",
          "t3_owner": "You",
          "t3_due": "Today"
        },
        "ivf_negative": {
          "section_title": "After a negative result",
          "section_subtitle": "Keep care instructions and cycle data ready for the consult.",
          "metrics_title": "Remaining options",
          "m1_label": "Stored embryos",
          "m1_value": "2",
          "m1_note": "both frozen",
          "m2_label": "PGT-A",
          "m2_value": "1 euploid",
          "m2_note": "1 untested",
          "m3_label": "Follow-up",
          "m3_value": "May 23",
          "m3_note": "virtual",
          "m4_label": "Meds",
          "m4_value": "Stop tonight",
          "m4_note": "per clinic",
          "tasks_title": "Prepare for consult",
          "t1_title": "Save questions",
          "t1_detail": "Embryo quality, progesterone timing, lining prep, and protocol changes.",
          "t1_owner": "You",
          "t1_due": "Before consult",
          "t2_title": "Upload result note",
          "t2_detail": "Beta result and stop instructions attach to this cycle.",
          "t2_owner": "Louise",
          "t2_due": "Done",
          "t3_title": "Decide pace",
          "t3_detail": "Use stored embryo, repeat retrieval, or pause.",
          "t3_owner": "You",
          "t3_due": "After consult"
        },
        "iui_precycle": {
          "section_title": "IUI readiness",
          "section_subtitle": "Focus on timing, tubes, sperm/vials, ovulation plan, trigger, and coverage.",
          "metrics_title": "Inputs",
          "m1_label": "Tube check",
          "m1_value": "Clear",
          "m1_note": "HSG uploaded",
          "m2_label": "Semen",
          "m2_value": "Normal",
          "m2_note": "partner SA",
          "m3_label": "Protocol",
          "m3_value": "Letrozole",
          "m3_note": "CD 3-7",
          "m4_label": "Trigger",
          "m4_value": "Ovidrel",
          "m4_note": "coverage pending",
          "dec_title": "Care shortlist",
          "d1_title": "Clinic with weekend IUI",
          "d1_detail": "Useful because ovulation timing can land on a weekend.",
          "d1_status": "Best fit",
          "d2_title": "Known OB office",
          "d2_detail": "Lower cost but less monitoring flexibility.",
          "d2_status": "Compare",
          "d3_title": "At-home monitoring + clinic IUI",
          "d3_detail": "Works if trigger and lab timing are reliable.",
          "d3_status": "Optional"
        },
        "iui_active": {
          "section_title": "Trigger and insemination",
          "section_subtitle": "Turn a narrow timing window into exact appointments and responsibilities.",
          "metrics_title": "Sperm plan",
          "m1_label": "Source",
          "m1_value": "Partner",
          "m1_note": "fresh collection",
          "m2_label": "Abstinence",
          "m2_value": "3 days",
          "m2_note": "in target",
          "m3_label": "Wash",
          "m3_value": "8:15 AM",
          "m3_note": "lab appointment",
          "m4_label": "IUI",
          "m4_value": "9:30 AM",
          "m4_note": "same clinic",
          "timeline_title": "Next 48 hours",
          "tl1_label": "Tonight 9 PM",
          "tl1_detail": "Trigger injection.",
          "tl2_label": "Tomorrow",
          "tl2_detail": "No extra ovulation tests needed unless clinic asks.",
          "tl3_label": "May 20 8 AM",
          "tl3_detail": "Partner sample and lab wash.",
          "tl4_label": "May 20 9:30 AM",
          "tl4_detail": "IUI procedure.",
          "tl5_label": "After IUI",
          "tl5_detail": "Two-week wait instructions and beta date."
        },
        "iui_wait": {
          "section_title": "IUI result plan",
          "section_subtitle": "Handle trigger-shot confusion and keep test timing clear.",
          "metrics_title": "Testing window",
          "m1_label": "Trigger shot",
          "m1_value": "May 18",
          "m1_note": "can affect home tests",
          "m2_label": "Reliable beta",
          "m2_value": "May 31",
          "m2_note": "blood draw",
          "m3_label": "Period plan",
          "m3_value": "Message clinic",
          "m3_note": "if bleeding starts",
          "tasks_title": "During the wait",
          "t1_title": "Continue meds",
          "t1_detail": "Progesterone or luteal support if prescribed.",
          "t1_owner": "You",
          "t1_due": "Daily",
          "t2_title": "Avoid early conclusions",
          "t2_detail": "Trigger hCG can cause false positives before it clears.",
          "t2_owner": "You",
          "t2_due": "This week",
          "t3_title": "Plan next cycle branch",
          "t3_detail": "If negative, clinic may restart baseline with next period.",
          "t3_owner": "Clinic",
          "t3_due": "After beta"
        },
        "amab_family_building_precycle": {
          "s1_title": "Two sperm inputs",
          "s1_subtitle": "For AMAB + AMAB family building, sperm optimization and split-embryo strategy are first-class.",
          "compare_title": "Partner comparison",
          "c1_label": "Partner A",
          "c1_value": "Normal SA",
          "c1_note": "backup freeze recommended",
          "c2_label": "Partner B",
          "c2_value": "Missing SA",
          "c2_note": "order test",
          "c3_label": "DNA frag",
          "c3_value": "Optional",
          "c3_note": "if abnormal SA/history",
          "c4_label": "Optimization",
          "c4_value": "72-90 days",
          "c4_note": "sperm cycle",
          "tasks_title": "Sperm reset program",
          "t1_title": "Baseline semen analysis",
          "t1_detail": "Count, motility, morphology; optional DNA fragmentation.",
          "t1_owner": "Partner B",
          "t1_due": "This week",
          "t2_title": "Freeze backup samples",
          "t2_detail": "Protects against collection-day problems during embryo creation.",
          "t2_owner": "Both partners",
          "t2_due": "Before donor cycle",
          "t3_title": "Repeat test",
          "t3_detail": "After the reset window, compare count/motility/DNA fragmentation.",
          "t3_owner": "Both partners",
          "t3_due": "90 days",
          "s2_title": "Donor, carrier, legal, money",
          "s2_subtitle": "Keep every external dependency visible.",
          "program_title": "Program snapshot",
          "p1_label": "Egg donor",
          "p1_value": "3 shortlisted",
          "p1_note": "carrier status compatible",
          "p2_label": "Carrier",
          "p2_value": "2 agency calls",
          "p2_note": "this week",
          "p3_label": "Legal",
          "p3_value": "Not started",
          "p3_note": "after shortlist",
          "p4_label": "Budget",
          "p4_value": "$145k-210k",
          "p4_note": "wide early range"
        },
        "partner_precycle": {
          "section_title": "Shared context",
          "section_subtitle": "See treatment progress and your own work in one place.",
          "metrics_title": "Primary plan",
          "m1_label": "Treatment",
          "m1_value": "IVF planning",
          "m1_note": "pre-cycle",
          "m2_label": "Clinic",
          "m2_value": "Shortlist open",
          "m2_note": "coverage pending",
          "m3_label": "Cycle start",
          "m3_value": "Not set",
          "m3_note": "after consult",
          "dec_title": "Partner contribution",
          "d1_title": "Semen analysis",
          "d1_detail": "Needed for IVF/IUI sperm plan and ICSI decisions.",
          "d1_status": "Book",
          "d2_title": "Coverage details",
          "d2_detail": "Employer benefits can materially change the shared estimate.",
          "d2_status": "Add",
          "d3_title": "Support plan",
          "d3_detail": "Ride, meds timing, and retrieval-day logistics appear as the cycle starts.",
          "d3_status": "Later"
        },
        "partner_active": {
          "section_title": "Permission-aware dashboard",
          "section_subtitle": "Support the cycle with your own tasks and shared context.",
          "metrics_title": "Shared cycle",
          "m1_label": "Phase",
          "m1_value": "Stim day 7",
          "m1_note": "retrieval est. May 24",
          "m2_label": "Today's help",
          "m2_value": "2 items",
          "m2_note": "sample + ride",
          "m3_label": "Next appointment",
          "m3_value": "Tomorrow",
          "m3_note": "8:20 AM",
          "tasks_title": "Partner-owned",
          "t1_title": "Confirm sample plan",
          "t1_detail": "Fresh sample or backup vial decision is due before retrieval.",
          "t1_owner": "You",
          "t1_due": "Today",
          "t2_title": "Block retrieval window",
          "t2_detail": "Sedation usually requires an escort and flexible pickup time.",
          "t2_owner": "You",
          "t2_due": "May 24",
          "t3_title": "Medication support",
          "t3_detail": "Evening injections can be easier with a stable time and supplies ready.",
          "t3_owner": "You",
          "t3_due": "Tonight"
        },
        "egg_donor": {
          "section_title": "Agency operations",
          "section_subtitle": "Track clearance tasks and medical screening.",
          "comp_title": "Compensation timeline",
          "c1_label": "Base comp",
          "c1_value": "$8,000",
          "c1_note": "after retrieval",
          "c2_label": "Screening",
          "c2_value": "Covered",
          "c2_note": "agency/clinic pays",
          "c3_label": "Travel",
          "c3_value": "Reimbursed",
          "c3_note": "receipts needed",
          "tasks_title": "Clearance checklist",
          "t1_title": "Infectious disease labs",
          "t1_detail": "Blood draw scheduled today.",
          "t1_owner": "Clinic",
          "t1_due": "Today",
          "t2_title": "Genetic carrier screen",
          "t2_detail": "Sample collected with lab draw.",
          "t2_owner": "Clinic",
          "t2_due": "Today",
          "t3_title": "Psych clearance",
          "t3_detail": "Virtual appointment; result sent to agency.",
          "t3_owner": "Agency",
          "t3_due": "May 22",
          "t4_title": "Legal review",
          "t4_detail": "Unlocks after match with intended parents.",
          "t4_owner": "Legal",
          "t4_due": "After match"
        },
        "sperm_donor": {
          "section_title": "Donation program",
          "section_subtitle": "Track each sample and the quarantine/retest path.",
          "timeline_title": "Sample release path",
          "tl1_label": "Visit",
          "tl1_detail": "Sample collected and screened.",
          "tl2_label": "Lab acceptance",
          "tl2_detail": "Count, motility, infectious screening, and quarantine entry.",
          "tl3_label": "Quarantine",
          "tl3_detail": "Samples remain held until required retest window.",
          "tl4_label": "Retest",
          "tl4_detail": "Infectious labs repeat before release.",
          "tl5_label": "Payout",
          "tl5_detail": "Compensation follows program rules and accepted samples.",
          "metrics_title": "Month-to-date",
          "m1_label": "Accepted samples",
          "m1_value": "3",
          "m1_note": "eligible",
          "m2_label": "Pending samples",
          "m2_value": "1",
          "m2_note": "lab review",
          "m3_label": "Payout",
          "m3_value": "$350",
          "m3_note": "next cycle"
        },
        "carrier": {
          "section_title": "Match readiness",
          "section_subtitle": "Keep medical, insurance, legal, and screening requirements in one view.",
          "metrics_title": "Application snapshot",
          "m1_label": "Pregnancy history",
          "m1_value": "2 prior births",
          "m1_note": "records pending",
          "m2_label": "Insurance",
          "m2_value": "Reviewing",
          "m2_note": "surrogacy exclusions",
          "m3_label": "Agency match",
          "m3_value": "2 agencies",
          "m3_note": "intake open",
          "tasks_title": "Before matching",
          "t1_title": "Upload OB records",
          "t1_detail": "Delivery notes, complications, and postpartum history.",
          "t1_owner": "You",
          "t1_due": "Today",
          "t2_title": "Insurance policy review",
          "t2_detail": "Checks exclusions and pregnancy coverage.",
          "t2_owner": "Agency",
          "t2_due": "This week",
          "t3_title": "Household/background checks",
          "t3_detail": "Program-specific requirements before match.",
          "t3_owner": "Agency",
          "t3_due": "Next",
          "t4_title": "Legal consult",
          "t4_detail": "Compensation, rights, decision-making, and termination clauses.",
          "t4_owner": "Legal",
          "t4_due": "After match"
        },
        "intended_parent": {
          "section_title": "Matching workspace",
          "section_subtitle": "Make donor, carrier, embryo, and legal work concrete.",
          "dec_title": "Shortlists",
          "d1_title": "Egg donor A",
          "d1_detail": "27, carrier compatible, available July, agency fee $18k.",
          "d1_status": "Favorite",
          "d2_title": "Egg donor B",
          "d2_detail": "31, strong prior cycle, one carrier overlap to review.",
          "d2_status": "Review",
          "d3_title": "Carrier agency",
          "d3_detail": "Two agencies accept your state/legal criteria.",
          "d3_status": "Calls",
          "tasks_title": "Before embryo creation",
          "t1_title": "Choose sperm source",
          "t1_detail": "Partner sperm, donor sperm, or split fertilization.",
          "t1_owner": "You",
          "t1_due": "This week",
          "t2_title": "Legal intake",
          "t2_detail": "Donor and carrier agreements plus escrow structure.",
          "t2_owner": "Legal",
          "t2_due": "After shortlist",
          "t3_title": "Embryo creation plan",
          "t3_detail": "Clinic and lab create embryos before carrier transfer.",
          "t3_owner": "Clinic",
          "t3_due": "After donor selected",
          "metrics_title": "Money snapshot",
          "m1_label": "Agency retainers",
          "m1_value": "$18k-25k",
          "m1_note": "early",
          "m2_label": "Donor cycle",
          "m2_value": "$35k-55k",
          "m2_note": "without IVF meds variability",
          "m3_label": "Carrier comp/escrow",
          "m3_value": "$65k-95k",
          "m3_note": "legal + state dependent"
        }
      },
      "inline": {
        "today_timeline_title": "Timeline",
        "today_schedule_title": "Schedule",
        "test_results_title": "Test results",
        "test_results_subtitle": "New and pending results show up here.",
        "test_results_not_recorded_detail": "Only test results recorded for you will appear here.",
        "monitoring_data_not_recorded_detail": "Only monitoring values recorded by your care team will appear here.",
        "active_logistics_not_recorded_detail": "Clinic logistics will appear here when the related appointment, medication, or document is recorded.",
        "ivf_plan_not_recorded_detail": "Fertilization, sperm, embryo, and testing details will appear when your clinic records them.",
        "post_retrieval_eyebrow": "After retrieval",
        "post_retrieval_title": "Retrieval complete",
        "post_retrieval_summary": "Keep today's real care plan close while your clinic records the next lab or storage update.",
        "post_retrieval_today_section_title": "Today",
        "post_retrieval_today_section_subtitle": "Keep medications and appointments visible without carrying stimulation metrics forward.",
        "post_retrieval_guidance_section_title": "After retrieval",
        "post_retrieval_guidance_section_subtitle": "Recovery guidance and the hand-off to clinic-recorded results.",
        "post_retrieval_guidance_title": "What to know now",
        "post_retrieval_guidance_subtitle": "Your clinic's instructions come first while the lab completes its work.",
        "post_retrieval": {
          "lab_section_title": "Lab updates",
          "retrieved_eggs_label": "Retrieved eggs",
          "retrieved_eggs_waiting": "Lab counting underway.",
          "mature_eggs_label": "Mature eggs",
          "mature_eggs_waiting": "Maturity check underway.",
          "fertilized_eggs_label": "Fertilized eggs",
          "fertilized_eggs_waiting": "Fertilization check underway.",
          "day_three_embryos_label": "Day 3 embryos",
          "day_three_embryos_waiting": "Early development check underway.",
          "day_five_embryos_label": "Day 5 embryos",
          "day_five_embryos_waiting": "Day 5 development check underway.",
          "frozen_eggs_label": "Frozen eggs",
          "frozen_eggs_waiting": "Freezing confirmation pending.",
          "frozen_embryos_label": "Frozen embryos",
          "frozen_embryos_waiting": "Freezing confirmation pending.",
          "awaiting_update": "Awaiting update",
          "unit_eggs": "eggs",
          "unit_embryos": "embryos",
          "from_clinic": "From your clinic",
          "added_by_you": "Added by you",
          "added_by_partner": "Added by your partner",
          "recorded": "Recorded",
          "add_or_edit_results": "Add or edit results",
          "recovery_badge": "RECOVERY",
          "recovery_title": "Take recovery at your pace",
          "recovery_body": "Follow the activity, medication, and hydration guidance your clinic gave you.",
          "recovery_b1": "Keep the clinic's instructions easy to find.",
          "recovery_b2": "Use Today for any real medication or appointment reminders.",
          "recovery_b3": "Contact your clinic if symptoms feel severe or different from what they prepared you for.",
          "lab_badge": "LAB",
          "lab_title": "Updates should come from the clinic",
          "lab_body": "The Home should show recorded lab and storage milestones, not estimated counts or outcomes.",
          "lab_b1": "Fertilization and embryo-development updates belong here when recorded.",
          "lab_b2": "Egg-storage updates belong here for egg-freezing cycles.",
          "lab_b3": "Missing data stays unknown until the clinic records it.",
          "safety_badge": "WHEN TO CALL",
          "safety_title": "Keep the safety signal clear",
          "safety_body": "The clinic's post-retrieval instructions should remain easy to find without implying a diagnosis.",
          "safety_b1": "Follow the warning signs and contact instructions your clinic provided.",
          "safety_b2": "Do not change medication based on an unrecorded result.",
          "safety_b3": "Ask the care team when the next update or follow-up is unclear."
        },
        "sperm_active_data_not_recorded_detail": "Collection instructions and lab updates will appear when your clinic records them.",
        "sperm_wait_data_not_recorded_detail": "Only recorded lab results and next-step instructions will appear here.",
        "sperm_postcycle_data_not_recorded_detail": "Only recorded semen inventory and lab values will appear here.",
        "cycle_status_review_eyebrow": "Cycle status",
        "cycle_status_review_title": "Let's keep this cycle open to the facts",
        "cycle_status_review_summary": "A cancelled or changed treatment path is not the same as a negative result. Review what was recorded and confirm the next step with your care team.",
        "cycle_status_review_section_title": "What you can do now",
        "cycle_status_review_section_subtitle": "Nothing starts automatically. Keep the cycle context together while you wait for a confirmed plan.",
        "cycle_status_review_today_title": "Today",
        "cycle_status_review_records_title": "Review this cycle",
        "cycle_status_review_records_detail": "Open the procedure history and any recorded cancellation or conversion notes.",
        "cycle_status_review_records_action": "Review cycle details",
        "cycle_status_review_clinic_title": "Add the next clinic step",
        "cycle_status_review_clinic_detail": "Save a rescheduled visit, follow-up, or instruction when your care team confirms it.",
        "cycle_status_review_clinic_action": "Open appointments",
        "cycle_status_review_question_title": "Prepare a question",
        "cycle_status_review_question_detail": "Ask Louise to help you make the next clinic conversation specific.",
        "cycle_status_review_question_action": "Prepare a question",
        "cycle_status_review_question_prompt": "My fertility treatment cycle was cancelled or changed rather than completed as planned. Help me prepare a concise question for my care team about what was recorded and what happens next. Do not label the cycle positive or negative, make a diagnosis, or change my medication plan.",
        "cycle_status_review_cancelled_title": "This cycle was cancelled",
        "cycle_status_review_cancelled_summary": "Review what was recorded and confirm any follow-up with your care team. A cancellation is not a negative result.",
        "cycle_status_review_cancelled_question_prompt": "My fertility treatment cycle was cancelled. Help me prepare a concise question for my care team about what was recorded and what happens next. Do not label the cycle positive or negative, make a diagnosis, or change my medication plan.",
        "cycle_status_review_converted_title": "This treatment path changed",
        "cycle_status_review_converted_summary": "Review what was recorded and confirm the new plan with your care team. A changed treatment path is not a negative result.",
        "cycle_status_review_converted_question_prompt": "My fertility treatment path changed. Help me prepare a concise question for my care team about what was recorded and what happens next. Do not label the cycle positive or negative, make a diagnosis, or change my medication plan.",
        "cycle_status_review_handoff_title": "Make the next clinic conversation easier",
        "cycle_status_review_handoff_body": "When you're ready, Louise can help turn what was recorded into one clear question or next step without guessing what the cancellation or change means.",
        "cycle_status_review_handoff_cta": "Talk through the next step",
        "cycle_status_review_handoff_check_1": "Review what was recorded",
        "cycle_status_review_handoff_check_2": "Prepare a question for your care team",
        "cycle_status_review_cancelled_handoff_title": "Make the cancellation follow-up easier",
        "cycle_status_review_cancelled_handoff_body": "When you are ready, Louise can help turn the recorded cancellation details into one clear question or next step without guessing what happens next.",
        "cycle_status_review_cancelled_handoff_cta": "Talk through the cancellation",
        "cycle_status_review_cancelled_handoff_check_1": "Review what was recorded",
        "cycle_status_review_cancelled_handoff_check_2": "Prepare a question for your care team",
        "cycle_status_review_converted_handoff_title": "Make the treatment change easier to navigate",
        "cycle_status_review_converted_handoff_body": "When you are ready, Louise can help turn the recorded treatment change into one clear question or next step without assuming why the plan changed.",
        "cycle_status_review_converted_handoff_cta": "Talk through the treatment change",
        "cycle_status_review_converted_handoff_check_1": "Review what was recorded",
        "cycle_status_review_converted_handoff_check_2": "Prepare a question for your care team",
        "test_results_iui_subtitle": "New and pending timing results show up here.",
        "monitoring_progress_title": "Monitoring progress",
        "monitoring_progress_subtitle": "Log each visit to see follicle growth, estradiol, symptoms, and retrieval timing move together.",
        "monitoring_progress_iui_subtitle": "Use this to keep follicle growth, trigger timing, sperm prep, and insemination timing connected.",
        "what_to_know_title": "What to know",
        "what_to_know_subtitle": "Use this as a quick safety check between monitoring visits. Your clinic's instructions come first.",
        "what_to_know_iui_subtitle": "Your clinic's trigger and insemination instructions come first.",
        "cycle_may_freeze_title": "What this cycle may freeze",
        "cycle_may_freeze_subtitle": "An estimate from today's follicle count. The actual numbers update after retrieval, maturity check, and freezing.",
        "cycle_may_become_title": "What this cycle may become",
        "cycle_may_become_subtitle": "An estimate from today's follicle count. After retrieval, this updates from eggs collected to mature eggs, fertilization, blastocysts, and any PGT-A results.",
        "logistics_checklist_title": "Cycle logistics checklist",
        "iui_logistics_checklist_title": "IUI logistics checklist",
        "after_retrieval_title": "After retrieval",
        "after_retrieval_egg_subtitle": "Swipe through retrieval day, maturity check, freezing confirmation, and storage.",
        "after_retrieval_embryo_subtitle": "Swipe through retrieval day, fertilization, cleavage, blastocyst, freezing, and PGT-A.",
        "section_today_title": "Today",
        "section_today_subtitle": "Concrete actions for this cycle day.",
        "section_today_iui_subtitle": "Concrete actions for this IUI timing window.",
        "section_testing_title": "Testing",
        "section_testing_subtitle": "Recent results and monitoring context for this cycle day.",
        "section_testing_iui_subtitle": "Recent monitoring and sperm-source context for this IUI cycle day.",
        "section_good_to_know_title": "Good to know",
        "section_good_to_know_subtitle": "Useful guidance and estimates for what comes next.",
        "section_good_to_know_iui_subtitle": "Useful guidance for trigger, sperm timing, and the transition into the wait.",
        "section_cycle_logistics_title": "Cycle Logistics",
        "section_cycle_logistics_subtitle": "Medications, retrieval prep, clinic contacts, and lab update timing.",
        "section_iui_logistics_subtitle": "Trigger timing, sample handling, procedure prep, and wait handoff.",
        "fet_active_plan_section_heading": "Follow the recorded plan",
        "fet_active_plan_section_supporting": "Only orders, appointments, and results recorded for you appear here.",
        "fet_active_records_heading": "Clinic plan and readiness",
        "fet_active_records_detail": "Your clinic's medication, monitoring, and readiness decisions will appear here when recorded.",
        "fet_active_transfer_heading": "Transfer and result records",
        "fet_active_transfer_detail": "A transfer, thaw, or beta record appears here only after it is recorded by your clinic.",
        "section_ivf_specifics_title": "IVF specifics",
        "section_ivf_specifics_subtitle": "Sperm, fertilization, embryo testing, and transfer choices change what happens after retrieval.",
        "ivf_plan_title": "IVF plan",
        "ivf_plan_endometrium_label": "Endometrium",
        "ivf_plan_endometrium_value": "8.2 mm",
        "ivf_plan_endometrium_note": "trilaminar",
        "ivf_plan_sperm_label": "Sperm plan",
        "ivf_plan_sperm_value": "Fresh + backup",
        "ivf_plan_sperm_note": "sample retrieval morning",
        "ivf_plan_fertilization_label": "Fertilization",
        "ivf_plan_fertilization_value": "ICSI",
        "ivf_plan_fertilization_note": "clinic plan",
        "ivf_plan_pgta_label": "PGT-A",
        "ivf_plan_pgta_value": "Planned",
        "ivf_plan_pgta_note": "freeze-all first",
        "retrieval_decisions_title": "Retrieval-day decisions",
        "retrieval_decisions_partner_sample_title": "Partner sample",
        "retrieval_decisions_partner_sample_detail": "Fresh sample is scheduled; backup vial is available if needed.",
        "retrieval_decisions_icsi_title": "ICSI consent",
        "retrieval_decisions_icsi_detail": "Signed and attached to the cycle.",
        "retrieval_decisions_pgta_title": "PGT-A plan",
        "retrieval_decisions_pgta_detail": "Biopsy and freeze-all plan is ready for the lab.",
        "calendar_action": "Calendar",
        "all_tests_action": "All tests",
        "egg_postcycle_section_title": "Egg freezing results",
        "egg_postcycle_section_subtitle": "Lab checkpoints from retrieval to storage.",
        "egg_postcycle_funnel_retrieved_label": "Retrieved",
        "egg_postcycle_funnel_retrieved_detail": "Eggs found by embryology.",
        "egg_postcycle_funnel_mature_label": "Mature",
        "egg_postcycle_funnel_mature_detail": "MII eggs eligible for freezing.",
        "egg_postcycle_funnel_frozen_label": "Frozen",
        "egg_postcycle_funnel_frozen_detail": "Vitrified and stored.",
        "embryo_postcycle_section_title": "Embryo freezing results",
        "embryo_postcycle_section_subtitle": "Lab checkpoints from fertilization to storage.",
        "embryo_funnel_retrieved_label": "Retrieved eggs",
        "embryo_funnel_retrieved_detail": "Eggs found by the lab.",
        "embryo_funnel_mature_label": "Mature",
        "embryo_funnel_mature_detail": "MII eggs ready for ICSI.",
        "embryo_funnel_fertilized_label": "Fertilized",
        "embryo_funnel_fertilized_detail": "Normal 2PN fertilization check.",
        "embryo_funnel_blastocysts_label": "Blastocysts",
        "embryo_funnel_blastocysts_detail": "Day 5-7 embryos for freeze/test.",
        "embryo_funnel_euploid_label": "Euploid",
        "embryo_funnel_euploid_detail": "Estimated after PGT-A; the lab report confirms the result.",
        "sperm_active_eyebrow": "Sperm freezing",
        "sperm_active_title": "Collection tomorrow",
        "sperm_active_summary": "Your appointment, abstinence window, sample instructions, expected analysis, and storage target are all in one place.",
        "sperm_active_hm1_label": "Collection",
        "sperm_active_hm1_value": "Tomorrow",
        "sperm_active_hm1_note": "8:30 AM",
        "sperm_active_hm2_label": "Abstinence",
        "sperm_active_hm2_value": "Day 3",
        "sperm_active_hm2_note": "target 2-5 days",
        "sperm_active_hm3_label": "Goal",
        "sperm_active_hm3_value": "6 vials",
        "sperm_active_hm3_note": "2 visits planned",
        "sperm_active_section_title": "Collection day",
        "sperm_active_section_subtitle": "Everything needed to avoid a bad sample or missed appointment.",
        "sperm_active_tasks_title": "Before you go",
        "sperm_active_t1_title": "Bring photo ID",
        "sperm_active_t1_detail": "Required for sample identity checks.",
        "sperm_active_t2_title": "Avoid heat today",
        "sperm_active_t2_detail": "No sauna, hot tub, or fever/illness exposure if avoidable.",
        "sperm_active_t3_title": "Sign storage consent",
        "sperm_active_t3_detail": "Consent and disposition choices must be complete before long-term storage.",
        "sperm_active_semen_title": "Sperm analysis results",
        "sperm_wait_section_title": "Waiting for results",
        "sperm_wait_section_subtitle": "See what is pending and what each result changes.",
        "sperm_wait_lab_status_title": "Lab status",
        "sperm_wait_tl1_label": "Sample received",
        "sperm_wait_tl1_detail": "Identity check and collection time logged.",
        "sperm_wait_tl2_label": "Semen analysis",
        "sperm_wait_tl2_detail": "Volume, concentration, motility, morphology.",
        "sperm_wait_tl3_label": "Freeze/thaw estimate",
        "sperm_wait_tl3_detail": "Expected usable motile sperm after thaw.",
        "sperm_wait_tl4_label": "Storage confirmation",
        "sperm_wait_tl4_detail": "Vials, facility, and annual renewal date posted.",
        "sperm_wait_dec_title": "Likely next step",
        "sperm_wait_d1_title": "Bank another sample",
        "sperm_wait_d1_detail": "Recommended if the first sample yields fewer than 3 usable vials.",
        "sperm_wait_d1_status": "Possible",
        "sperm_wait_d2_title": "Start 90-day reset",
        "sperm_wait_d2_detail": "Useful if count, motility, or DNA fragmentation is abnormal.",
        "sperm_wait_d2_status": "Depends on result",
        "sperm_wait_d3_title": "Store and stop",
        "sperm_wait_d3_detail": "Reasonable if vial target is met and future use is IVF/ICSI.",
        "sperm_wait_d3_status": "Possible",
        "sperm_postcycle_section_title": "Sperm freezing results",
        "sperm_postcycle_section_subtitle": "What was banked and where it is stored.",
        "sperm_postcycle_semen_title": "Sperm analysis results",
        "beta_wait_eyebrow": "Waiting",
        "beta_wait_title": "6 days past transfer",
        "beta_wait_summary": "Make the wait concrete: beta timing, medications, symptoms, and when to call.",
        "beta_wait_section_today_title": "Today",
        "beta_wait_section_today_subtitle": "Reduce uncertainty without predicting the outcome.",
        "beta_wait_today_title": "Today",
        "beta_wait_section_testing_title": "Testing",
        "beta_wait_section_testing_subtitle": "Keep the beta timing and result branches clear.",
        "beta_wait_result_plan_title": "Beta result plan",
        "beta_wait_result_plan_subtitle": "Swipe through the beta draw, positive branch, and negative branch.",
        "beta_wait_section_more_title": "Good to know",
        "beta_wait_section_more_subtitle": "Useful context for symptoms, home tests, and when to call.",
        "beta_wait_what_to_know_title": "What to know",
        "beta_wait_what_to_know_subtitle": "Symptoms can be real without being predictive.",
        "ivf_positive_eyebrow": "Result",
        "ivf_positive_title": "Positive beta",
        "ivf_positive_summary": "Keep the next beta, medications, warning symptoms, and ultrasound timing clear.",
        "ivf_positive_section_title": "Next medical steps",
        "ivf_positive_section_subtitle": "Early pregnancy follow-up needs precise tasks.",
        "ivf_positive_today_title": "Continue today",
        "ivf_positive_tasks_title": "Before ultrasound",
        "ivf_positive_t1_title": "Repeat beta",
        "ivf_positive_t1_detail": "Second blood draw confirms trend.",
        "ivf_positive_t3_title": "OB handoff folder",
        "ivf_positive_t3_detail": "Pregnancy summary and IVF records are prepared after ultrasound.",
        "ivf_negative_eyebrow": "Result",
        "ivf_negative_title": "Negative beta",
        "ivf_negative_summary": "Clear next steps: medication instructions, support, cycle recap, and next options.",
        "ivf_negative_section_title": "What happens now",
        "ivf_negative_section_subtitle": "Support and concrete instructions for the next few days.",
        "ivf_negative_tasks_title": "Today",
        "ivf_negative_t1_title": "Medication plan",
        "ivf_negative_t1_detail": "Clinic says to stop progesterone tonight.",
        "ivf_negative_t2_title": "Bleeding expectations",
        "ivf_negative_t2_detail": "Period may start in a few days; call for heavy bleeding or severe pain.",
        "ivf_negative_t3_title": "Follow-up consult",
        "ivf_negative_t3_detail": "Review embryo quality, transfer protocol, and next attempt options.",
        "ivf_negative_funnel_title": "Cycle recap",
        "ivf_negative_funnel_retrieved_label": "Retrieved",
        "ivf_negative_funnel_retrieved_detail": "Eggs collected.",
        "ivf_negative_funnel_mature_label": "Mature",
        "ivf_negative_funnel_mature_detail": "MII eggs.",
        "ivf_negative_funnel_fertilized_label": "Fertilized",
        "ivf_negative_funnel_fertilized_detail": "Normal fertilization.",
        "ivf_negative_funnel_blasts_label": "Blasts",
        "ivf_negative_funnel_blasts_detail": "Blastocysts.",
        "ivf_negative_funnel_transferred_label": "Transferred",
        "ivf_negative_funnel_transferred_detail": "This attempt.",
        "ivf_negative_dec_title": "Next attempt options",
        "ivf_negative_d1_title": "Use stored embryo",
        "ivf_negative_d1_detail": "2 embryos remain frozen.",
        "ivf_negative_d1_status": "Available",
        "ivf_negative_d2_title": "Change protocol",
        "ivf_negative_d2_detail": "Discuss progesterone timing, lining prep, or embryo selection.",
        "ivf_negative_d2_status": "Consult",
        "ivf_negative_d3_title": "Pause",
        "ivf_negative_d3_detail": "Keep storage active and decide later.",
        "ivf_negative_d3_status": "Available",
        "iui_wait_section_today_title": "Today",
        "iui_wait_section_today_subtitle": "Support during the wait, with IUI-specific timing.",
        "iui_wait_today_title": "Today",
        "iui_wait_section_testing_title": "Testing",
        "iui_wait_section_testing_subtitle": "Handle trigger-shot confusion and keep beta timing clear.",
        "iui_wait_result_plan_title": "IUI result plan",
        "iui_wait_result_plan_subtitle": "Swipe through the reliable test window and what to do if bleeding starts.",
        "iui_wait_section_more_title": "Good to know",
        "iui_wait_section_more_subtitle": "Useful context for trigger hCG, symptoms, and the next branch.",
        "iui_wait_what_to_know_title": "What to know",
        "iui_wait_what_to_know_subtitle": "The trigger can make early testing noisy.",
        "oi_wait_section_today_title": "Today",
        "oi_wait_section_today_subtitle": "Keep the days after ovulation grounded in your clinic plan.",
        "oi_wait_today_title": "Today",
        "oi_wait_section_testing_title": "Testing",
        "oi_wait_section_testing_subtitle": "Keep the expected test date and the next branch visible.",
        "oi_wait_result_plan_title": "OI result plan",
        "oi_wait_result_plan_subtitle": "Keep ovulation timing, the planned test, and follow-up together.",
        "oi_wait_section_more_title": "Good to know",
        "oi_wait_section_more_subtitle": "Useful context for ovulation timing, support medication, and the next branch.",
        "oi_wait_what_to_know_title": "What to know",
        "oi_wait_what_to_know_subtitle": "Ovulation tells you the timing, not the result.",
        "intended_parent_hm1_label": "Egg donor",
        "intended_parent_hm1_value": "3 shortlisted",
        "intended_parent_hm1_note": "carrier status checked",
        "intended_parent_hm2_label": "Carrier",
        "intended_parent_hm2_value": "Search open",
        "intended_parent_hm2_note": "2 agency calls",
        "intended_parent_hm3_label": "Escrow",
        "intended_parent_hm3_value": "Not started",
        "intended_parent_hm3_note": "legal first",
        "intended_parent_section_title": "Operating plan",
        "intended_parent_section_subtitle": "Keep agency, clinic, lab, and legal work in one view.",
        "intended_parent_tasks_title": "Open tasks",
        "intended_parent_t1_title": "Choose donor shortlist",
        "intended_parent_t1_detail": "3 candidates match profile, availability, and carrier screening.",
        "intended_parent_t1_due": "This week",
        "intended_parent_t2_title": "Carrier agency intake",
        "intended_parent_t2_detail": "Two calls scheduled; one requires embryo plan first.",
        "intended_parent_t2_due": "This week",
        "intended_parent_t3_title": "Legal intake",
        "intended_parent_t3_detail": "Parentage, donor, and carrier contracts.",
        "intended_parent_t3_due": "After donor/carrier choice",
        "intended_parent_timeline_title": "Path to transfer",
        "intended_parent_tl1_label": "Now",
        "intended_parent_tl1_detail": "Select donor and carrier pathway.",
        "intended_parent_tl2_label": "Next",
        "intended_parent_tl2_detail": "Create embryos or confirm embryo inventory.",
        "intended_parent_tl3_label": "Legal",
        "intended_parent_tl3_detail": "Contracts and escrow.",
        "intended_parent_tl4_label": "Transfer",
        "intended_parent_tl4_detail": "Carrier medical clearance and transfer cycle.",
        "owner_you": "You",
        "owner_partner": "Partner",
        "owner_clinic": "Clinic",
        "owner_lab": "Lab",
        "owner_legal": "Legal",
        "owner_louise": "Louise",
        "owner_you_clinic": "You + clinic",
        "due_now": "Now",
        "due_today": "Today",
        "due_tomorrow": "Tomorrow",
        "due_done": "Done",
        "due_daily": "Daily",
        "due_clinic_scheduled": "Clinic will schedule",
        "due_later": "Later",
        "due_this_week": "This week",
        "due_any_time": "Any time",
        "due_retrieval_morning": "Retrieval morning",
        "due_before_banking": "Before banking",
        "due_may_23": "May 23",
        "egg_postcycle_eyebrow": "Egg freezing",
        "egg_postcycle_title": "Egg-freezing cycle complete",
        "egg_postcycle_summary": "Review your recorded results, storage details, and next options.",
        "egg_freezing_active_eyebrow": "Egg freezing",
        "egg_freezing_active_title": "Stimulation day 7",
        "egg_freezing_active_summary": "Follicles are growing and pressure/bloating can increase today. Monitoring tomorrow decides whether retrieval moves earlier.",
        "embryo_freezing_active_eyebrow": "Embryo freezing",
        "embryo_freezing_active_title": "Stimulation day 7",
        "embryo_freezing_active_summary": "12 follicles are growing, lead is 18 mm, and retrieval is currently estimated for May 24.",
        "embryo_postcycle_eyebrow": "Embryo freezing",
        "embryo_postcycle_title": "Embryo-freezing cycle complete",
        "embryo_postcycle_summary": "Review recorded embryo results, pending testing, storage, and next options.",
        "embryo_postcycle_testing_title": "Embryo testing",
        "embryo_postcycle_testing_subtitle": "Upload your PGT report when the clinic sends it. Only recorded results will appear here.",
        "sperm_freezing_wait_eyebrow": "Sperm freezing",
        "sperm_freezing_wait_title": "Sample processing",
        "sperm_freezing_wait_summary": "The sample was collected today. Results and storage confirmation are expected in the next few days.",
        "sperm_freezing_postcycle_eyebrow": "Sperm freezing",
        "sperm_freezing_postcycle_title": "Sperm-freezing cycle complete",
        "sperm_freezing_postcycle_summary": "Review your recorded analysis, storage details, and next options.",
        "ivf_active_eyebrow": "IVF",
        "oi_active_eyebrow": "Ovulation induction",
        "oi_active_title": "Stimulation under way",
        "oi_active_summary": "Follow today's medications and appointments, and your ovarian response as each scan comes in.",
        "follow_growth_and_trigger_timing": "Log every visit to follow follicle growth, estradiol, symptoms and trigger timing.",
        "ivf_active_title": "Stimulation with embryo plan ready",
        "ivf_active_summary": "Track today's meds and appointments, current ovarian response, sperm readiness, and the lab timeline that starts at retrieval.",
        "iui_active_eyebrow": "IUI",
        "iui_active_title": "Trigger tonight",
        "iui_active_summary": "A timing dashboard for follicle, lining, trigger, sperm sample, insemination, and the wait start.",
        "iui_wait_eyebrow": "IUI wait",
        "iui_wait_title": "5 days after IUI",
        "iui_wait_summary": "Trigger-shot caveats, symptom uncertainty, meds, and what happens on test day.",
        "intended_parent_eyebrow": "Intended parent",
        "intended_parent_title": "Donor, carrier, embryos, legal, and costs",
        "intended_parent_summary": "Coordinate agency work, source matching, embryo readiness, legal milestones, and money.",
        "iui_monitoring_baseline": "Baseline",
        "iui_monitoring_cd9": "CD 9",
        "iui_monitoring_today": "Today",
        "iui_monitoring_trigger": "Trigger",
        "iui_monitoring_iui": "IUI",
        "iui_what_to_know_timing_badge": "Timing",
        "iui_what_to_know_timing_title": "Trigger timing drives the IUI window",
        "iui_what_to_know_timing_body": "Once the clinic gives a trigger time, the next useful guidance is exact timing, not more prediction.",
        "iui_what_to_know_timing_b1": "Use the trigger time your clinic gave you; do not move it earlier or later without calling.",
        "iui_what_to_know_timing_b2": "The IUI appointment is usually scheduled around the expected ovulation window.",
        "iui_what_to_know_timing_b3": "Extra ovulation tests are usually unnecessary unless the clinic asks for them.",
        "iui_what_to_know_sperm_badge": "Sperm",
        "iui_what_to_know_sperm_title": "Sample timing is part of the treatment plan",
        "iui_what_to_know_sperm_body": "The sample and lab wash need enough time before insemination, especially when collection is fresh.",
        "iui_what_to_know_sperm_b1": "Follow the abstinence window your clinic gave you.",
        "iui_what_to_know_sperm_b2": "Bring ID and any donor or partner paperwork the lab requires.",
        "iui_what_to_know_sperm_b3": "Call the clinic if collection may be delayed or difficult.",
        "iui_what_to_know_after_badge": "After",
        "iui_what_to_know_after_title": "The wait starts after insemination",
        "iui_what_to_know_after_body": "After IUI, the home should switch from timing to medication reminders, symptom context, and beta-test timing.",
        "iui_what_to_know_after_b1": "Keep taking luteal support exactly as prescribed if your clinic uses it.",
        "iui_what_to_know_after_b2": "Trigger shots can confuse early urine tests.",
        "iui_what_to_know_after_b3": "Use the beta date from your clinic rather than testing earlier for decisions.",
        "iui_logistics_trigger_title": "Trigger plan",
        "iui_logistics_trigger_timeframe": "Tonight",
        "iui_logistics_trigger_body": "The trigger time anchors the insemination appointment. Keep the medication, dose, and injection instructions easy to find.",
        "iui_logistics_trigger_i1_label": "Ovidrel on hand",
        "iui_logistics_trigger_i1_detail": "Ready for 9:00 PM",
        "iui_logistics_trigger_i2_label": "Injection instructions",
        "iui_logistics_trigger_i2_detail": "Dose and route confirmed by clinic",
        "iui_logistics_trigger_i3_label": "If late or missed",
        "iui_logistics_trigger_i3_detail": "Call clinic before changing timing",
        "iui_logistics_sperm_title": "Sperm logistics",
        "iui_logistics_sperm_timeframe": "IUI morning",
        "iui_logistics_sperm_body": "Fresh collection, donor thaw, or frozen partner sperm all need lab timing before the IUI appointment.",
        "iui_logistics_sperm_i1_label": "Collection time",
        "iui_logistics_sperm_i1_detail": "May 20 at 8:00 AM",
        "iui_logistics_sperm_i2_label": "Lab wash",
        "iui_logistics_sperm_i2_detail": "Processing before 9:30 AM IUI",
        "iui_logistics_sperm_i3_label": "Backup plan",
        "iui_logistics_sperm_i3_detail": "Call if collection timing changes",
        "iui_logistics_after_title": "After IUI",
        "iui_logistics_after_timeframe": "Same day",
        "iui_logistics_after_body": "The next home state should shift into the beta wait with medication reminders and symptom context.",
        "iui_logistics_after_i1_label": "Procedure note",
        "iui_logistics_after_i1_detail": "IUI details attach to the cycle",
        "iui_logistics_after_i2_label": "Medication instructions",
        "iui_logistics_after_i2_detail": "Progesterone or other support if prescribed",
        "iui_logistics_after_i3_label": "Beta date",
        "iui_logistics_after_i3_detail": "Clinic blood test timing after IUI",
        "beta_wait_result_clinic_title": "Clinic beta",
        "beta_wait_result_clinic_timeframe": "May 24",
        "beta_wait_result_clinic_timeframe_pending": "Date not yet confirmed",
        "beta_wait_result_clinic_body": "The blood beta is the decision-making test. Home tests and symptoms can be confusing in this window.",
        "beta_wait_result_clinic_i1_label": "Blood draw",
        "beta_wait_result_clinic_i1_detail": "Clinic lab appointment",
        "beta_wait_result_clinic_i2_label": "Result call",
        "beta_wait_result_clinic_i2_detail": "Same day after clinical review",
        "beta_wait_result_clinic_i3_label": "Medication plan",
        "beta_wait_result_clinic_i3_detail": "Continue until the clinic changes instructions",
        "beta_wait_result_positive_title": "If positive",
        "beta_wait_result_positive_timeframe": "About 48 hours later",
        "beta_wait_result_positive_body": "The next useful information is whether the beta rises appropriately, followed by ultrasound timing.",
        "beta_wait_result_positive_i1_label": "Repeat beta",
        "beta_wait_result_positive_i1_detail": "Usually around 48 hours",
        "beta_wait_result_positive_i2_label": "Continue meds",
        "beta_wait_result_positive_i2_detail": "Progesterone and support meds stay visible",
        "beta_wait_result_positive_i3_label": "Ultrasound timing",
        "beta_wait_result_positive_i3_detail": "Scheduled after the beta trend is reviewed",
        "beta_wait_result_negative_title": "If negative",
        "beta_wait_result_negative_timeframe": "After review",
        "beta_wait_result_negative_body": "The home should switch to stop instructions, emotional support, and a consult-ready cycle recap.",
        "beta_wait_result_negative_i1_label": "Stop plan",
        "beta_wait_result_negative_i1_detail": "Only after clinic instructions",
        "beta_wait_result_negative_i2_label": "Follow-up consult",
        "beta_wait_result_negative_i2_detail": "Protocol, embryo, and transfer review",
        "beta_wait_result_negative_i3_label": "Next branch",
        "beta_wait_result_negative_i3_detail": "Stored embryo, repeat cycle, or pause",
        "iui_wait_result_window_title": "Reliable test window",
        "iui_wait_result_window_timeframe": "May 31",
        "iui_wait_result_window_body": "After an hCG trigger, early urine tests can be misleading. The clinic beta is the result that should drive decisions.",
        "iui_wait_result_window_i1_label": "Trigger shot",
        "iui_wait_result_window_i1_detail": "May 18; can affect home tests",
        "iui_wait_result_window_i2_label": "Clinic beta",
        "iui_wait_result_window_i2_detail": "Blood draw on May 31",
        "iui_wait_result_window_i3_label": "Result call",
        "iui_wait_result_window_i3_detail": "Clinic reviews before next steps",
        "iui_wait_result_bleeding_title": "If bleeding starts",
        "iui_wait_result_bleeding_timeframe": "Any time",
        "iui_wait_result_bleeding_body": "Bleeding does not need to be interpreted alone. The clinic may still want the beta or may give restart instructions.",
        "iui_wait_result_bleeding_i1_label": "Message clinic",
        "iui_wait_result_bleeding_i1_detail": "Log timing, flow, and symptoms",
        "iui_wait_result_bleeding_i2_label": "Medication question",
        "iui_wait_result_bleeding_i2_detail": "Ask before stopping luteal support",
        "iui_wait_result_bleeding_i3_label": "Next baseline",
        "iui_wait_result_bleeding_i3_detail": "Clinic may plan around the next period",
        "oi_wait_result_window_title": "The planned test window",
        "oi_wait_result_window_timeframe": "May 31",
        "oi_wait_result_window_body": "After ovulation, the clinic's test date is the clearest next signal. Symptoms cannot confirm the result.",
        "oi_wait_result_window_i1_label": "Ovulation timing",
        "oi_wait_result_window_i1_detail": "Recorded in your cycle",
        "oi_wait_result_window_i2_label": "Clinic test",
        "oi_wait_result_window_i2_detail": "Use the date your clinic gave you",
        "oi_wait_result_window_i3_label": "Next conversation",
        "oi_wait_result_window_i3_detail": "Review the result before changing your plan",
        "oi_wait_result_bleeding_title": "If bleeding starts",
        "oi_wait_result_bleeding_timeframe": "Any time",
        "oi_wait_result_bleeding_body": "Message the clinic if bleeding starts before the planned test or if you are unsure what to do with medication.",
        "oi_wait_result_bleeding_i1_label": "Message clinic",
        "oi_wait_result_bleeding_i1_detail": "Log timing, flow, and symptoms",
        "oi_wait_result_bleeding_i2_label": "Medication question",
        "oi_wait_result_bleeding_i2_detail": "Ask before stopping prescribed support",
        "oi_wait_result_bleeding_i3_label": "Next cycle",
        "oi_wait_result_bleeding_i3_detail": "Plan only after the clinic confirms the next step",
        "beta_wait_wtk_symptoms_badge": "Symptoms",
        "beta_wait_wtk_symptoms_title": "Symptoms are not a result",
        "beta_wait_wtk_symptoms_body": "Cramping, breast tenderness, spotting, or no symptoms can all happen after transfer and with progesterone.",
        "beta_wait_wtk_symptoms_b1": "Track symptoms if they help you communicate with the clinic.",
        "beta_wait_wtk_symptoms_b2": "Do not use symptom intensity to predict the beta.",
        "beta_wait_wtk_symptoms_b3": "Rest, hydration, and gentle normal activity are all fine.",
        "beta_wait_wtk_testing_badge": "Testing",
        "beta_wait_wtk_testing_title": "Use the beta for decisions",
        "beta_wait_wtk_testing_body": "The beta blood test is the cleanest signal for the next branch. Testing earlier can add noise without changing the plan.",
        "beta_wait_wtk_testing_b1": "Keep the beta appointment visible.",
        "beta_wait_wtk_testing_b2": "Continue medications until the clinic changes them.",
        "beta_wait_wtk_testing_b3": "Expect a second beta if the first result is positive.",
        "beta_wait_wtk_hometest_badge": "Home tests",
        "beta_wait_wtk_hometest_title": "Took a home test?",
        "beta_wait_wtk_hometest_body": "Lots of people test at home during the wait. Right now the result can mislead you either way, so treat it gently and let the beta be the answer.",
        "beta_wait_wtk_hometest_b1": "Your trigger shot is hCG, so an early positive can just be leftover trigger.",
        "beta_wait_wtk_hometest_b2": "It can be too early to show a true positive, so a negative now is not reliable.",
        "beta_wait_wtk_hometest_b3": "Whatever the strip says, the clinic beta is what decides the next step.",
        "beta_wait_wtk_support_badge": "When to call",
        "beta_wait_wtk_support_title": "When to call your clinic",
        "beta_wait_wtk_support_body": "Most of what you feel in the wait is normal. These are the signs that are worth a call right away.",
        "beta_wait_wtk_support_b1": "Severe or one-sided pelvic pain.",
        "beta_wait_wtk_support_b2": "Heavy bleeding, fever, or feeling faint.",
        "beta_wait_wtk_support_b3": "Shortness of breath or rapid, severe bloating.",
        "iui_wait_wtk_trigger_badge": "Trigger",
        "iui_wait_wtk_trigger_title": "The trigger can confuse early tests",
        "iui_wait_wtk_trigger_body": "Ovidrel and other hCG triggers can linger, so early urine tests can look positive before pregnancy can be confirmed.",
        "iui_wait_wtk_trigger_b1": "Use the clinic beta date for decisions.",
        "iui_wait_wtk_trigger_b2": "Avoid changing medications based on home tests.",
        "iui_wait_wtk_trigger_b3": "Log symptoms for context, not prediction.",
        "iui_wait_wtk_meds_badge": "Meds",
        "iui_wait_wtk_meds_title": "Keep luteal support boring",
        "iui_wait_wtk_meds_body": "If progesterone or other support was prescribed, the homepage should keep it as a normal Today row.",
        "iui_wait_wtk_meds_b1": "Continue unless the clinic changes the plan.",
        "iui_wait_wtk_meds_b2": "Ask before stopping if bleeding starts.",
        "iui_wait_wtk_meds_b3": "Keep refill or missed-dose issues visible as tasks.",
        "iui_wait_wtk_next_badge": "Next",
        "iui_wait_wtk_next_title": "The next state depends on the beta",
        "iui_wait_wtk_next_body": "After the result, the page should branch to positive support, negative-result instructions, or next-cycle planning.",
        "iui_wait_wtk_next_b1": "If positive, repeat beta timing becomes the focus.",
        "iui_wait_wtk_next_b2": "If negative, stop instructions and consult prep become the focus.",
        "iui_wait_wtk_next_b3": "If unclear, clinic repeat testing should stay in Testing.",
        "oi_wait_wtk_ovulation_badge": "Timing",
        "oi_wait_wtk_ovulation_title": "Ovulation is not the result",
        "oi_wait_wtk_ovulation_body": "Ovulation gives you a point in time, but only the planned test can answer whether pregnancy occurred.",
        "oi_wait_wtk_ovulation_b1": "Use the clinic test date for decisions.",
        "oi_wait_wtk_ovulation_b2": "Symptoms cannot confirm the result.",
        "oi_wait_wtk_ovulation_b3": "Note timing or symptoms if they help you talk with the clinic.",
        "oi_wait_wtk_meds_badge": "Meds",
        "oi_wait_wtk_meds_title": "Keep your clinic plan steady",
        "oi_wait_wtk_meds_body": "If progesterone or other support was prescribed, keep it visible as a normal Today row.",
        "oi_wait_wtk_meds_b1": "Continue unless the clinic changes the plan.",
        "oi_wait_wtk_meds_b2": "Ask before stopping if bleeding starts.",
        "oi_wait_wtk_meds_b3": "Keep missed doses or refill questions visible.",
        "oi_wait_wtk_next_badge": "Next",
        "oi_wait_wtk_next_title": "The next state depends on the test",
        "oi_wait_wtk_next_body": "After the result, Home should move to positive support, a between-cycle pause, or clarification without assuming what you want next.",
        "oi_wait_wtk_next_b1": "If positive, follow-up timing becomes the focus.",
        "oi_wait_wtk_next_b2": "If negative, review and pause options become the focus.",
        "oi_wait_wtk_next_b3": "If unclear, repeat testing stays with the clinic.",
        "today_rows_iui_wait_luteal_title": "Luteal support",
        "today_rows_iui_wait_luteal_detail": "Continue progesterone or other support if prescribed.",
        "today_rows_iui_wait_avoid_title": "Avoid early conclusions",
        "today_rows_iui_wait_avoid_detail": "Trigger hCG can affect home tests before the clinic beta.",
        "today_rows_iui_wait_this_week": "This week",
        "today_rows_iui_wait_beta_title": "Clinic beta",
        "today_rows_iui_wait_beta_detail": "Blood test for the IUI result.",
        "today_rows_oi_wait_luteal_title": "Prescribed support",
        "today_rows_oi_wait_luteal_detail": "Continue progesterone or other support if prescribed.",
        "today_rows_oi_wait_avoid_title": "Wait for the planned test",
        "today_rows_oi_wait_avoid_detail": "Home tests and symptoms cannot confirm the result this early.",
        "today_rows_oi_wait_this_week": "This week",
        "today_rows_oi_wait_beta_title": "Pregnancy test",
        "today_rows_oi_wait_beta_detail": "Use the date your clinic gave you after ovulation.",
        "today_rows_iui_active_trigger_title": "Ovidrel trigger",
        "today_rows_iui_active_trigger_detail": "Inject tonight. IUI is scheduled 36 hours later.",
        "today_rows_iui_active_partner_title": "Partner sample",
        "today_rows_iui_active_partner_detail": "Collection before lab wash. Abstinence window: day 3.",
        "today_rows_iui_active_iui_title": "IUI appointment",
        "today_rows_iui_active_iui_detail": "Arrive 15 minutes early.",
        "today_rows_stim_gonal_title": "Gonal-F 225 IU",
        "peek_day_tomorrow": "Tomorrow",
        "peek_day_may_21": "May 21",
        "peek_day_may_22": "May 22",
        "peek_monitoring_title": "Monitoring visit",
        "peek_monitoring_detail": "Ultrasound + bloodwork. Dose timing may update after this.",
        "peek_gonal_title": "Gonal-F 225 IU",
        "peek_gonal_detail": "Keep the dose on the calendar unless the clinic changes it.",
        "peek_cetrotide_title": "Cetrotide",
        "peek_cetrotide_detail": "Prevents early ovulation while follicles keep growing.",
        "peek_supply_title": "Medication supply check",
        "peek_supply_detail": "Make sure antagonist and trigger meds are physically on hand.",
        "peek_dose_title": "Possible dose update",
        "peek_dose_detail": "The clinic may adjust the plan after reviewing results.",
        "peek_dose_afternoon": "Afternoon",
        "peek_empty_title": "Nothing scheduled yet.",
        "peek_empty_detail": "This day may fill in after tomorrow's monitoring visit and clinic instructions.",
        "due_at_visit": "At visit",
        "due_before_consult": "Before consult",
        "due_after_consult": "After consult",
        "due_after_shortlist": "After shortlist",
        "due_after_donor_selected": "After donor selected",
        "sperm_active_collection_quality_section_title": "Collection quality",
        "sperm_active_collection_quality_section_subtitle": "Focus on the collection factors you can control.",
        "sperm_active_metrics_title": "Pre-collection checks",
        "sperm_active_metric_abstinence_label": "Abstinence",
        "sperm_active_metric_abstinence_value": "3 days",
        "sperm_active_metric_abstinence_note": "inside 2-5 day target",
        "sperm_active_metric_fever_label": "Fever/heat",
        "sperm_active_metric_fever_value": "None",
        "sperm_active_metric_fever_note": "last 10 days",
        "sperm_active_metric_hydration_label": "Hydration",
        "sperm_active_metric_hydration_value": "Logged",
        "sperm_active_metric_hydration_note": "today",
        "sperm_active_metric_id_label": "ID + consent",
        "sperm_active_metric_id_value": "Ready",
        "sperm_active_metric_id_note": "required",
        "sperm_active_tasks_collection_title": "Collection instructions",
        "sperm_active_task_arrive_title": "Arrive with ID",
        "sperm_active_task_arrive_detail": "Identity check is required before the sample is accepted.",
        "sperm_active_task_arrive_time": "8:30 AM",
        "sperm_active_task_estimate_title": "Ask for post-thaw estimate",
        "sperm_active_task_estimate_detail": "This determines whether the inventory is better suited for IUI or IVF/ICSI.",
        "sperm_active_task_disposition_title": "Choose disposition settings",
        "sperm_active_task_disposition_detail": "Storage, future use, discard, and death/incapacity choices must be documented.",
        "sperm_active_task_disposition_due": "Before storage",
        "sperm_wait_section_lab_check_title": "What the lab is checking",
        "sperm_wait_section_lab_check_subtitle": "See why results take time and what each metric changes.",
        "sperm_wait_semen_title": "Sperm analysis results",
        "sperm_wait_decision_title": "Result branches",
        "sperm_wait_decision_d1_title": "Target met",
        "sperm_wait_decision_d1_detail": "Storage confirmation becomes the main task.",
        "sperm_wait_decision_d1_status": "Store",
        "sperm_wait_decision_d2_title": "Borderline vial count",
        "sperm_wait_decision_d2_detail": "Another collection improves redundancy.",
        "sperm_wait_decision_d2_status": "Collect again",
        "sperm_wait_decision_d3_title": "Abnormal analysis",
        "sperm_wait_decision_d3_detail": "A 72-90 day reset, repeat semen analysis, and urology review become useful.",
        "sperm_wait_decision_d3_status": "Optimize",
        "sperm_postcycle_future_use_title": "Future use estimate",
        "sperm_postcycle_future_use_subtitle": "If you use these later, here's a rough projection.",
        "sperm_postcycle_projection_unavailable_title": "Future-use estimate unavailable",
        "sperm_postcycle_projection_unavailable_detail": "We'll show a clinically reviewed estimate when the sample and report records support it.",
        "sperm_postcycle_funnel_s1_label": "Sample",
        "sperm_postcycle_funnel_s1_detail": "Pre-freeze usable sperm estimate.",
        "sperm_postcycle_funnel_s2_label": "Processed",
        "sperm_postcycle_funnel_s2_detail": "After lab wash and prep.",
        "sperm_postcycle_funnel_s3_label": "Frozen vials",
        "sperm_postcycle_funnel_s3_detail": "Banked across collections.",
        "sperm_postcycle_funnel_s4_label": "Post-thaw usable",
        "sperm_postcycle_funnel_s4_detail": "Estimated motile vials after thaw.",
        "egg_postcycle_future_use_title": "Future use estimate",
        "egg_postcycle_future_use_subtitle": "If you use these later, here's a rough projection.",
        "embryo_postcycle_future_use_title": "Future use estimate",
        "embryo_postcycle_future_use_subtitle": "If you use these later, here's a rough projection.",
        "handoff_decide_title": "Decide your next step",
        "handoff_egg_body": "When you're ready, you can do another cycle to bank more eggs, or thaw and use them for IVF.",
        "handoff_egg_cta": "Explore your options",
        "handoff_egg_chat_prompt": "Review my full current profile, fertility history, treatment and cycle results, and goals. Help me compare my options after egg freezing, including another retrieval cycle, using my frozen eggs for IVF, or keeping them in storage. Explain the tradeoffs, what information may be missing, and useful questions for my care team. I want to ask follow-up questions. When I choose a path, end with one concrete next step I can take and ask before opening any treatment setup.",
        "handoff_egg_check_1": "Start a new cycle to bank more",
        "handoff_egg_check_2": "Use your eggs for IVF",
        "handoff_egg_check_3": "Keep them in storage",
        "handoff_embryo_body": "When you're ready, you can plan a frozen embryo transfer, create more embryos, or keep them in storage.",
        "handoff_embryo_cta": "Explore your options",
        "handoff_embryo_chat_prompt": "Review my full current profile, fertility history, treatment and cycle results, and goals. Help me compare my options after embryo freezing, including planning a frozen embryo transfer, creating more embryos, or keeping them in storage. Explain the tradeoffs, what information may be missing, and useful questions for my care team. I want to ask follow-up questions. When I choose a path, end with one concrete next step I can take and ask before opening any treatment setup.",
        "handoff_embryo_check_1": "Plan a frozen transfer",
        "handoff_embryo_check_2": "Create more embryos",
        "handoff_embryo_check_3": "Keep them in storage",
        "handoff_sperm_body": "When you're ready, you can use your banked samples for treatment, collect more, or keep them in storage.",
        "handoff_sperm_cta": "Explore your options",
        "handoff_sperm_chat_prompt": "Review my full current profile, fertility history, treatment and cycle results, and goals. Help me compare my options after sperm freezing, including using my banked samples for treatment, collecting more, or keeping them in storage. Explain the tradeoffs, what information may be missing, and useful questions for my care team. I want to ask follow-up questions. When I choose a path, end with one concrete next step I can take and ask before opening any treatment setup.",
        "handoff_sperm_check_1": "Use your samples for treatment",
        "handoff_sperm_check_2": "Bank another sample",
        "handoff_sperm_check_3": "Keep them in storage",
        "ivf_negative_after_section_title": "After a negative result",
        "ivf_negative_after_section_subtitle": "Keep care instructions and cycle data ready for the consult.",
        "ivf_negative_after_tasks_title": "Prepare for consult",
        "ivf_negative_after_t1_title": "Save questions",
        "ivf_negative_after_t1_detail": "Embryo quality, progesterone timing, lining prep, and protocol changes.",
        "ivf_negative_after_t2_title": "Upload result note",
        "ivf_negative_after_t2_detail": "Beta result and stop instructions attach to this cycle.",
        "ivf_negative_after_t3_title": "Decide pace",
        "ivf_negative_after_t3_detail": "Use stored embryo, repeat retrieval, or pause.",
        "intended_parent_match_section_title": "Matching workspace",
        "intended_parent_match_section_subtitle": "Make donor, carrier, embryo, and legal work concrete.",
        "intended_parent_match_decision_title": "Shortlists",
        "intended_parent_match_d1_title": "Egg donor A",
        "intended_parent_match_d1_detail": "27, carrier compatible, available July, agency fee $18k.",
        "intended_parent_match_d1_status": "Favorite",
        "intended_parent_match_d2_title": "Egg donor B",
        "intended_parent_match_d2_detail": "31, strong prior cycle, one carrier overlap to review.",
        "intended_parent_match_d2_status": "Review",
        "intended_parent_match_d3_title": "Carrier agency",
        "intended_parent_match_d3_detail": "Two agencies accept your state/legal criteria.",
        "intended_parent_match_d3_status": "Calls",
        "intended_parent_match_tasks_title": "Before embryo creation",
        "intended_parent_match_t1_title": "Choose sperm source",
        "intended_parent_match_t1_detail": "Partner sperm, donor sperm, or split fertilization.",
        "intended_parent_match_t2_title": "Legal intake",
        "intended_parent_match_t2_detail": "Donor and carrier agreements plus escrow structure.",
        "intended_parent_match_t3_title": "Embryo creation plan",
        "intended_parent_match_t3_detail": "Clinic and lab create embryos before carrier transfer.",
        "log_date_today": "Today",
        "log_date_yesterday": "Yesterday",
        "log_date_may_15": "May 15",
        "log_cycle_day_4": "Day 4",
        "log_cycle_day_6": "Day 6",
        "log_cycle_day_7": "Day 7",
        "today_label_today": "Today",
        "today_label_any_time": "Any time",
        "action_calendar": "Calendar",
        "action_complete_history": "Complete history",
        "action_check_tests": "Check tests",
        "action_find_care": "Find care",
        "action_check_coverage": "Check coverage",
        "action_open_program": "Open program",
        "action_open_documents": "Open documents",
        "action_review_meds": "Review meds",
        "action_open_care_team": "Open care team",
        "action_log_monitoring": "Log monitoring results",
        "action_log_symptoms": "Log symptoms",
        "action_open_care": "Open care",
        "action_view_cryo_vault": "View cryo vault",
        "test_preview_new_result": "New result",
        "test_preview_waiting": "Waiting for results",
        "iui_insight_lh_test_name": "LH",
        "iui_insight_lh_purpose": "Shows whether your body is already surging before trigger",
        "iui_insight_lh_value": "Low",
        "iui_insight_lh_headline": "LH is low before trigger",
        "iui_insight_lh_interpretation": "A low LH result means the clinic is not seeing a spontaneous surge yet.",
        "iui_insight_lh_meaning": "That supports using the planned trigger shot to control IUI timing.",
        "iui_insight_lh_next": "Use the trigger time your clinic gave you.",
        "iui_insight_progesterone_test_name": "Progesterone",
        "iui_insight_progesterone_purpose": "Checks whether ovulation has already started",
        "iui_insight_progesterone_headline": "Progesterone is still pre-ovulatory",
        "iui_insight_progesterone_interpretation": "Progesterone is low enough that ovulation has likely not already happened.",
        "iui_insight_progesterone_meaning": "The current timing window still fits the trigger and IUI plan.",
        "iui_insight_progesterone_next": "Continue with the scheduled trigger unless the clinic changes instructions.",
        "iui_insight_semen_test_name": "Semen analysis",
        "iui_insight_semen_purpose": "Helps estimate whether the sample is suitable for IUI",
        "iui_insight_semen_value": "Pending",
        "iui_insight_semen_headline": "Post-wash count will update on IUI day",
        "iui_insight_semen_interpretation": "For IUI, the post-wash motile sperm count is often the most useful sample number.",
        "iui_insight_semen_meaning": "The lab will process the sample before insemination and document the final count.",
        "iui_insight_semen_next": "Keep the collection appointment and lab wash timing visible.",
        "iui_insight_beta_test_name": "Beta hCG",
        "iui_insight_beta_purpose": "Confirms pregnancy after the IUI wait",
        "iui_insight_beta_value": "Scheduled",
        "iui_insight_beta_headline": "Beta is scheduled after the wait",
        "iui_insight_beta_interpretation": "A blood beta is the clinic result used for decisions after IUI.",
        "iui_insight_beta_meaning": "Testing too early can be confusing, especially after an hCG trigger.",
        "iui_insight_beta_next": "Use the clinic beta date for next-step decisions."
      }
    },
    "schedule": {
      "tomorrow": "Tomorrow",
      "nothing_scheduled": "Nothing scheduled",
      "nothing_scheduled_detail": "No medications or appointments on this day yet."
    },
    "pending_semen_analysis": {
      "test_name": "Semen analysis",
      "test_purpose": "Sperm count, motility, and morphology together",
      "value": "See details",
      "headline": "Semen analysis pending",
      "interpretation": "The lab is processing the sample and will post the semen analysis when it is ready.",
      "what_this_means": "This result helps decide whether the current sample is enough, whether another collection is useful, and how the sample may be used later.",
      "next_step": "Wait for the lab result before changing the plan."
    },
    "guided_precycle": {
      "actions": {
        "plan_builder": "Choose path",
        "learn": "Learn options",
        "testing": "Check tests",
        "medical_history": "Complete history",
        "care": "Open Care",
        "find_care": "Find care",
        "coverage": "Check coverage"
      },
      "setup": {
        "eyebrow": "Setup",
        "title": "Set up your fertility home",
        "phase_description": "Start with the few inputs that make every pre-cycle plan more useful: what you are trying to do, where you are in the process, and what data you already have.",
        "intro": "In a few minutes, we’ll turn a blank profile into a guided pre-cycle plan.",
        "snapshot_next_label": "Next",
        "snapshot_next_value": "Choose your path",
        "snapshot_cycle_label": "Treatment cycle",
        "snapshot_cycle_value": "Not selected yet",
        "section_path_step_label": "Step 1: Choose path",
        "section_path_title": "Tell us what you are exploring",
        "section_path_body": "Pick the goal that fits right now. The home can then switch into egg freezing, embryo freezing, sperm freezing, IVF, IUI, donor, carrier, or intended-parent planning.",
        "section_path_bullet_preserve": "Preserve fertility for later",
        "section_path_bullet_pregnant": "Try to get pregnant",
        "section_path_bullet_donate": "Donate eggs, sperm, or carry for someone",
        "section_baseline_step_label": "Step 2: Add baseline",
        "section_baseline_title": "Add the first details that change guidance",
        "section_baseline_body": "Age, cycle history, partner or donor plans, prior tests, and medical history decide which pre-cycle sections matter first.",
        "section_baseline_bullet_history": "Medical history",
        "section_baseline_bullet_labs": "Prior labs",
        "section_baseline_bullet_coverage": "Coverage and location",
        "section_care_step_label": "Step 3: Find care",
        "section_care_title": "Start comparing the right care path",
        "section_care_body": "Once the goal is clear, clinic, lab, donor, carrier, and coverage tasks can move into the same guided plan.",
        "section_care_bullet_clinics": "Clinics",
        "section_care_bullet_programs": "Programs",
        "section_care_bullet_coverage_fit": "Coverage fit"
      },
      "learn_explorer": {
        "eyebrow": "Learn",
        "title": "Explore options without choosing too early",
        "phase_description": "Use the same guided planning structure to compare paths before you know whether the next best step is testing, clinic selection, donor support, or treatment.",
        "intro": "Start broad, then narrow into the pre-cycle plan that matches your goal.",
        "snapshot_next_label": "Next",
        "snapshot_next_value": "Compare paths",
        "snapshot_cycle_label": "Treatment cycle",
        "snapshot_cycle_value": "Not selected yet",
        "section_options_step_label": "Step 1: Compare Options",
        "section_options_title": "Compare Options",
        "section_options_body": "Switch between biology paths as you learn.",
        "section_options_bullet_preservation": "Preservation",
        "section_options_bullet_pregnancy": "Pregnancy treatment",
        "section_options_bullet_donor_or_carrier": "Donor or carrier",
        "section_numbers_step_label": "Step 2: Know Your Numbers",
        "section_numbers_title": "Know Your Numbers",
        "section_numbers_body": "Add only the numbers that help you compare the paths you are considering.",
        "section_numbers_bullet_ovarian": "Ovarian reserve",
        "section_numbers_bullet_semen": "Semen analysis",
        "section_numbers_bullet_carrier": "Carrier screening",
        "section_care_step_label": "Step 3: Find Care",
        "section_care_title": "Find Care",
        "section_care_body": "When you are ready, compare care that fits the path you want to take.",
        "section_care_bullet_clinics": "Clinics",
        "section_care_bullet_labs": "Labs",
        "section_care_bullet_programs": "Programs",
        "biology_options_title": "Look at your different options",
        "biology_options_subtitle": "Choose a path to see the biology, timing, and decisions that shape it. You can switch whenever you want.",
        "biology_option_egg_freezing": "Egg freezing",
        "biology_option_embryo_freezing": "Embryo freezing",
        "biology_option_iui": "IUI",
        "biology_option_ivf": "IVF",
        "biology_option_sperm_freezing": "Sperm freezing",
        "handoff_title": "Ready to choose a path?",
        "handoff_body": "When one direction feels right, turn what you learned into a plan with the next steps, people, and care that fit.",
        "handoff_cta": "Choose your path",
        "handoff_chat": "Chat about it",
        "handoff_chat_prompt": "I’m exploring fertility and reproductive options and would like help comparing what I’ve learned. Please ask what matters to me, name any information I may still need, and help me choose one useful next step without assuming that I have chosen a treatment path.",
        "handoff_check_options": "Options compared",
        "handoff_check_numbers": "Numbers gathered",
        "handoff_check_care": "Care ready to review"
      },
      "trying_naturally": {
        "eyebrow": "Trying naturally",
        "title": "A plan for trying naturally",
        "phase_description": "Use the care you already have without being pushed into a treatment plan.",
        "intro": "Start with the basics, track only what feels useful, and keep a clear path to care if your needs change.",
        "snapshot_next_label": "Next",
        "snapshot_next_value": "Review your history",
        "snapshot_cycle_label": "Treatment cycle",
        "snapshot_cycle_value": "Not needed to get started",
        "section_preparation_step_label": "Step 1: Prepare",
        "section_preparation_title": "Get your starting context in one place",
        "section_preparation_body": "Review your medical history and preconception basics before deciding whether you need testing or a clinic visit.",
        "section_preparation_bullet_history": "Medical history",
        "section_preparation_bullet_health": "Preconception basics",
        "section_preparation_bullet_partner": "Partner or donor context",
        "section_tracking_step_label": "Step 2: Track what helps",
        "section_tracking_title": "Use Care without starting treatment",
        "section_tracking_body": "You can use the calendar and available logs without creating a treatment cycle. Predictions are estimates, not proof of ovulation or fertility.",
        "section_tracking_bullet_cycle": "Cycle history",
        "section_tracking_bullet_optional": "Optional signals",
        "section_tracking_bullet_estimates": "Transparent estimates",
        "section_care_step_label": "Step 3: Know when to seek care",
        "section_care_title": "Keep evaluation and care within reach",
        "section_care_body": "When your timeline, symptoms, risk factors, or questions call for support, use Find Care to explore an appropriate next conversation.",
        "section_care_bullet_timing": "Trying timeline",
        "section_care_bullet_risk": "Risk-aware questions",
        "section_care_bullet_provider": "Provider options"
      },
      "ivf_precycle": {
        "eyebrow": "IVF planning",
        "title": "Prepare for IVF before a cycle starts",
        "phase_description": "IVF pre-cycle planning needs ovarian reserve, uterine readiness, sperm or donor source, fertilization method, clinic fit, medications, lab decisions, and transfer planning in one place.",
        "intro": "Use this guided plan to understand IVF, complete baseline work, compare care, and get ready for cycle start.",
        "snapshot_next_label": "Next",
        "snapshot_next_value": "Baseline testing",
        "snapshot_cycle_label": "Treatment cycle",
        "snapshot_cycle_value": "Not scheduled yet"
      },
      "iui_precycle": {
        "eyebrow": "IUI planning",
        "title": "Prepare for IUI before cycle day 1",
        "phase_description": "IUI planning needs ovulation timing, tube status, sperm source, medication choice, monitoring schedule, trigger timing, and a beta plan.",
        "intro": "Use this guided plan to confirm IUI fit, complete baseline work, and understand the timing before treatment begins.",
        "snapshot_next_label": "Next",
        "snapshot_next_value": "Confirm IUI fit",
        "snapshot_cycle_label": "Treatment cycle",
        "snapshot_cycle_value": "Not scheduled yet"
      },
      "amab_family_building_precycle": {
        "eyebrow": "Family-building planning",
        "title": "Build the path around sperm, donor, carrier, and embryos",
        "phase_description": "AMAB family-building planning should use the same guided structure, but foreground sperm testing, donor egg options, carrier path, legal work, cost, and embryo creation.",
        "intro": "Use this guided plan to compare sperm inputs, donor and carrier routes, care teams, and the sequence before embryo creation.",
        "snapshot_next_label": "Next",
        "snapshot_next_value": "Sperm and source plan",
        "snapshot_cycle_label": "Treatment cycle",
        "snapshot_cycle_value": "Not scheduled yet"
      }
    }
  },
  "you": {
    "panel_titles": {
      "personal_info": "Personal Info",
      "medical_fertility": "Medical & Fertility",
      "coverage_benefits": "Coverage & Benefits",
      "connections": "Connections and Sharing",
      "research_studies": "Research & Studies",
      "notifications": "Notifications",
      "integrations": "Integrations",
      "preferences": "Preferences",
      "account": "Account"
    },
    "overview": {
      "your_info_header": "Your Info",
      "settings_header": "Settings",
      "personal_info_value": "${filled} of ${total}",
      "medical_fertility_progress": "${completed} of ${total} complete",
      "medical_fertility_not_set": "Not set",
      "coverage_on_file": "Insurance on file",
      "coverage_add": "Add insurance",
      "connections_count": "${count} connected",
      "connections_recorded_count": "${count} care-team records",
      "connections_none": "None",
      "research_matched": "${count} matched",
      "research_none": "No eligible studies",
      "notifications_active": "${count} active",
      "notifications_loading": "Loading…",
      "notifications_unavailable": "Unavailable",
      "integrations_apple_health_data": "Apple Health data",
      "integrations_none": "None"
    },
    "profile_header": {
      "add_your_name": "Add your name",
      "name_save_failed": "We couldn't save your name. Your attempted name is still here.",
      "avatar_upload_failed": "We couldn't update your profile photo. Your previous photo is still in place."
    },
    "email_badge": {
      "verify": "Verify",
      "resend": "Resend",
      "check_your_email": "Check your email",
      "sent": "Sent!",
      "failed_to_send": "We couldn't send the verification link. Try again."
    },
    "phone_badge": {
      "verify": "Verify",
      "submit": "Submit",
      "code_placeholder": "000000",
      "failed_to_send": "Failed to send code",
      "invalid_code": "Invalid code"
    },
    "personal_info": {
      "section_title": "Personal Info",
      "name_label": "Name",
      "name_placeholder": "Your first name",
      "first_name_label": "First name",
      "first_name_placeholder": "First name",
      "last_name_label": "Last name",
      "last_name_placeholder": "Last name",
      "email_label": "Email",
      "email_placeholder": "name@example.com",
      "phone_label": "Phone",
      "sex_at_birth_label": "Sex at birth",
      "sex_at_birth_placeholder": "Select sex at birth",
      "sex_female": "Female (AFAB)",
      "sex_male": "Male (AMAB)",
      "sex_at_birth_change_hint": "Changing this selection requires confirmation.",
      "sex_at_birth_change_title": "Change sex at birth?",
      "sex_at_birth_change_personalization_description": "We’ll update the questions, recommendations, and tests shown to you. Your goals, history, conversations, cycles, and documents will stay unchanged.",
      "sex_at_birth_change_goal_update_description": "You currently have ${goal} selected. We’ll keep that goal, but may update the questions, recommendations, tests, and care tasks shown to you. Your saved history will stay unchanged.",
      "sex_at_birth_change_goal_conflict_description": "You currently have ${goal} selected. This change makes that goal incompatible with the care context we use. Your saved history will stay unchanged, but you’ll need to review your goal before this change can be saved.",
      "sex_at_birth_goal_conflict_save_message": "Review your ${goal} goal before saving this sex-at-birth change. Your saved data has not been changed.",
      "sex_at_birth_goal_review_action": "Review goal",
      "sex_at_birth_change_cancel": "Keep current",
      "sex_at_birth_change_confirm": "Change it",
      "birth_date_label": "Birth Date",
      "address_label": "Address",
      "address_hint": "Used for shipping and care-related mail.",
      "emergency_contact_label": "Emergency contact",
      "emergency_contact_placeholder": "Add emergency contact",
      "emergency_name_label": "Name",
      "emergency_name_placeholder": "Contact name",
      "emergency_phone_label": "Phone",
      "emergency_relationship_label": "Relationship",
      "emergency_relationship_placeholder": "Select relationship",
      "save_changes": "Save",
      "cancel": "Cancel",
      "relationship_partner": "Partner",
      "relationship_spouse": "Spouse",
      "relationship_parent": "Parent",
      "relationship_child": "Child",
      "relationship_sibling": "Sibling",
      "relationship_friend": "Friend",
      "relationship_colleague": "Colleague",
      "relationship_other": "Other",
      "save_failed_message": "We couldn't save your changes. Please try again.",
      "save_partial_message": "We saved some changes, but couldn't save ${fields}. Please try again.",
      "profile_not_ready_message": "Your profile is still loading. Please try again in a moment.",
      "email_verification_send_failed": "Your email was saved, but we couldn't send the verification link. Use Verify to try again.",
      "invite_sent": "Invite Sent!",
      "invite_failed": "Failed — Tap to Retry",
      "invite_send_sms": "Send SMS Invite"
    },
    "my_journey": {
      "menu_start_cycle": "Start a treatment cycle",
      "menu_end_cycle": "End treatment cycle",
      "menu_journey_map": "Journey map",
      "menu_change_goal": "Change goal",
      "menu_a11y": "Cycle actions",
      "set_your_path": "Set your path",
      "past_cycles_one": "${count} past cycle",
      "past_cycles_other": "${count} past cycles",
      "add_history": "Add history",
      "clinic_linked": "Clinic linked",
      "map": "Map",
      "phase_deciding_label": "Decide",
      "phase_preparing_label": "Prep",
      "phase_in_treatment_label": "Treat",
      "phase_storing_label": "Store",
      "phase_deciding_heading": "Deciding",
      "phase_deciding_message": "Take your time — you're building clarity.",
      "phase_preparing_heading": "Preparing",
      "phase_preparing_message": "Getting everything in place for what's ahead.",
      "phase_in_treatment_heading": "In Treatment",
      "phase_in_treatment_message": "You're in it now. One step at a time.",
      "phase_storing_heading": "Storing",
      "phase_storing_message": "Safely kept for whenever you're ready.",
      "phase_result_label": "Result",
      "phase_result_heading": "Your result",
      "phase_result_message": "The cycle is behind you — this is where its answer lands.",
      "intent_exploring": "Exploring",
      "intent_preservation": "Preservation",
      "intent_egg_freezing": "Egg freezing",
      "intent_sperm_freezing": "Sperm freezing",
      "intent_embryo_freezing": "Embryo freezing",
      "intent_pregnancy": "Trying to conceive",
      "intent_egg_donation": "Egg donation",
      "intent_sperm_donation": "Sperm donation",
      "intent_adoption": "Adoption",
      "intent_surrogacy": "Surrogacy",
      "intent_donation": "Egg donation",
      "intent_conception": "Trying to conceive",
      "intent_starting_treatment": "Getting ready",
      "intent_in_treatment": "Active cycle"
    },
    "my_passport": {
      "header": "My Passport",
      "done": "Done",
      "badges_collected": "${unlocked} of ${total} badges collected",
      "earned_on": "Earned ${date}",
      "badges_unlocked_together": "${count} badges unlocked",
      "badge_position": "Badge ${position} of ${count}",
      "newly_unlocked": "Milestone reached — you earned a new badge!",
      "new_in_passport": "This milestone is now in your Passport.",
      "view_in_passport": "View in Passport",
      "complete_to_unlock": "Complete the action above to unlock",
      "loading": "Loading your Passport…",
      "unavailable": "Your Passport is temporarily unavailable. Please try again in a moment."
    },
    "partner_card": {
      "waiting_for": "Waiting for ${name}...",
      "waiting_for_partner": "Waiting for your partner...",
      "we_sent_invite": "We sent ${name} an invite. We'll let you know when they join.",
      "we_sent_invite_generic": "We sent an invitation. We'll let you know when they join.",
      "pending": "Pending",
      "resend": "Resend",
      "manage_invitation": "Manage invitation",
      "doing_this_with_someone": "Doing this with someone?",
      "invite_blurb": "Invite a partner to coordinate care and share the journey. You choose what they can see.",
      "compact_blurb": "Invite a partner to coordinate care.",
      "invite_partner": "Invite a partner",
      "dismiss": "Dismiss partner invitation",
      "linked_with_name": "Linked with ${name}",
      "linked_with_partner": "Linked with your partner",
      "linked_blurb": "Their care shows up in your schedule. Tap to manage what they can see of yours.",
      "connected": "Connected"
    },
    "connections_sharing": {
      "section_title": "Connections and Sharing",
      "partner_label": "Partner",
      "partner_add": "Invite partner",
      "clinic_label": "Clinic",
      "clinic_add": "Add clinic to care team",
      "clinic_detail": "Keep your clinic details in one place",
      "pharmacy_label": "Pharmacy",
      "pharmacy_add": "Add pharmacy",
      "pharmacy_detail": "Keep your pharmacy details in one place",
      "provider_label": "Other provider",
      "provider_add": "Add provider",
      "provider_detail": "Keep your broader care team in one place",
      "recorded": "Recorded",
      "care_team_member": "Care-team member",
      "load_failed": "We couldn’t load your care-team records.",
      "retry": "Try again",
      "loading": "Loading your care team…",
      "connected": "Connected",
      "pending": "Pending",
      "failed": "Failed",
      "sharing": "Sharing",
      "add_provider_or_connection": "Add a provider or connection",
      "connection_status": {
        "not_requested_label": "Not requested",
        "not_requested_subtitle": "Recorded — no connection request has started.",
        "requested_label": "Requested",
        "requested_subtitle": "We’ll check whether they can connect.",
        "contacted_label": "Contacted",
        "contacted_subtitle": "We’re reviewing whether a secure connection is possible.",
        "available_label": "Ready to connect",
        "available_subtitle": "Secure syncing is available.",
        "not_available_label": "Not available yet",
        "not_available_subtitle": "They don’t offer secure syncing yet. We’ll keep your request on file.",
        "connected_label": "Connected",
        "connected_subtitle": "Secure syncing is active."
      },
      "integration_status": {
        "unknown_label": "Not connected",
        "unknown_subtitle": "Your care-team details are saved here while you decide what to do next.",
        "not_available_label": "Not available yet",
        "not_available_subtitle": "We can’t connect with them yet, but we’ll keep your care-team details here.",
        "discovered_label": "Connection being reviewed",
        "discovered_subtitle": "We’re checking how to connect with them securely.",
        "ready_label": "Ready to connect",
        "ready_subtitle": "You can start sharing securely.",
        "connected_label": "Connected",
        "connected_subtitle": "Secure syncing is active."
      },
      "identity_status": {
        "unmatched": "Not matched",
        "candidate": "Match to review",
        "matched": "Matched",
        "verified": "Verified",
        "rejected": "Not matched"
      },
      "sharing_status": {
        "not_shared": "Not shared",
        "ready": "Ready to share",
        "active": "Shared",
        "expired": "Share expired",
        "revoked": "Share revoked"
      },
      "official_identity": "We found a match for this care-team member.",
      "connection_summary": {
        "clinic_multiple": "${count} clinics",
        "pharmacy_multiple": "${count} pharmacies",
        "provider_multiple": "${count} providers",
        "multiple_subtitle": "View and manage your care team"
      },
      "connection_management": {
        "description": "Review the people and organizations you’ve recorded on your care team.",
        "remove_title": "Remove ${name}?",
        "remove_description": "This removes the record from Louise. It won’t contact them or affect their records.",
        "remove_confirm": "Remove",
        "clinic": {
          "title": "Your clinics",
          "empty": "No clinics added yet.",
          "add": "Add another clinic",
          "remove": "Remove clinic"
        },
        "pharmacy": {
          "title": "Your pharmacies",
          "empty": "No pharmacies added yet.",
          "add": "Add another pharmacy",
          "remove": "Remove pharmacy"
        },
        "provider": {
          "title": "Your providers",
          "empty": "No providers added yet.",
          "add": "Add another provider",
          "remove": "Remove provider"
        }
      },
      "connection_modal": {
        "clinic": {
          "title": "Add your clinic",
          "edit_title": "Edit clinic",
          "description": "Save your clinic details in your care team.",
          "name_label": "Clinic name",
          "name_placeholder": "e.g. Spring Fertility"
        },
        "pharmacy": {
          "title": "Add your pharmacy",
          "edit_title": "Edit pharmacy",
          "description": "Save your pharmacy details in your care team.",
          "name_label": "Pharmacy name",
          "name_placeholder": "e.g. Alto Pharmacy"
        },
        "provider": {
          "title": "Add a provider",
          "edit_title": "Edit provider",
          "description": "Save someone on your care team and keep their details in one place.",
          "name_label": "Provider name",
          "name_placeholder": "e.g. Dr. Maya Chen"
        },
        "name_required": "Please enter a name.",
        "contact_email": "Contact email",
        "contact_email_hint": "Optional. If you have a team email, it helps us find the right contact.",
        "contact_email_placeholder": "care@example.com",
        "email_invalid": "Enter a valid email address.",
        "specialty": "Specialty",
        "specialty_placeholder": "e.g. OB-GYN, therapist, acupuncturist",
        "relationship": "Role on your care team",
        "relationship_placeholder": "e.g. REI, nurse coordinator, therapist",
        "practice_name": "Practice or organization",
        "practice_name_placeholder": "e.g. Harbor Women’s Health",
        "location": "Location",
        "location_placeholder": "e.g. Boston, MA or 123 Main St",
        "contact_phone": "Contact phone",
        "contact_phone_placeholder": "Optional phone number",
        "notes": "Notes for yourself",
        "notes_placeholder": "Anything you want to remember about this care-team member",
        "privacy_note": "We won’t share your health information with them without your permission.",
        "save_failed": "We couldn’t save this connection. Please try again.",
        "delete_failed": "We couldn’t remove this connection. Please try again.",
        "saved_title": "${name} is added to your care team",
        "saved_description": "You can edit or remove it at any time.",
        "done": "Done",
        "cancel": "Cancel",
        "back": "Back",
        "save": "Save"
      }
    },
    "reminders_notifications": {
      "section_title": "Notifications",
      "appointments_label": "Appointment reminders",
      "appointments_description": "Get notified before upcoming appointments",
      "medications_label": "Medication reminders",
      "medications_description": "Daily reminders for your medications",
      "cycle_updates_label": "Cycle updates",
      "cycle_updates_description": "Daily cycle phase and predictions",
      "test_results_label": "Test results ready",
      "test_results_description": "Know when new results are available",
      "coverage_status_label": "Coverage updates",
      "coverage_status_description": "Insurance verification and benefit changes",
      "documents_label": "Document updates",
      "documents_description": "Know when a document in your care record changes",
      "payments_label": "Payments",
      "payments_description": "Payment confirmations and reminders",
      "period_predictions_label": "Period predictions",
      "period_predictions_description": "Get ahead-of-time cycle alerts",
      "chat_messages_label": "Chat messages",
      "chat_messages_description": "New messages from your care team",
      "timing_label": "Remind me",
      "device_ready": "This device is ready for the reminder categories you enable below.",
      "device_access_limited": "This device has limited notification access. Reminders may arrive quietly.",
      "device_access_temporary": "This device has temporary notification access. Check device settings to keep receiving reminders.",
      "device_access_not_requested": "This device has not been connected for push reminders yet. Your preferences remain saved separately.",
      "device_connecting": "Connecting this device so it can receive your enabled reminders.",
      "device_access_denied": "Device notifications are off. Your reminder preferences stay saved, but push reminders cannot arrive here.",
      "device_access_restricted": "Device notification access is restricted. Your reminder preferences stay saved, but push reminders cannot arrive here.",
      "device_unsupported": "Push reminders are not available on the web or a simulator. In-app notifications and reminder preferences remain available.",
      "device_token_rejected": "Your reminder preferences stay saved, but this device could not create a notification address. Try again or check device settings.",
      "device_registration_failed": "Your reminder preferences are still on, but this device could not be connected. Try again.",
      "device_status_updating": "Checking this device’s notification access…",
      "learn_about_device_notifications": "Learn how reminders reach this device",
      "open_device_settings": "Open device settings",
      "retry_device_registration": "Try again",
      "permission_education_title": "Choose how reminders reach you",
      "permission_education_body": "Louise can send timely medication and appointment reminders, plus updates when supported care results or documents are ready. You choose the categories and reminder timing below, and you can change this choice here or in device settings later.",
      "permission_education_categories": "Your reminder preferences stay separate from device permission. Turning a category on saves your choice even if this device cannot deliver push notifications.",
      "permission_education_privacy": "Your device controls lock-screen visibility and previews. Louise does not show raw device tokens or clinical reminder content in diagnostics.",
      "permission_education_not_now": "Not now",
      "permission_education_continue": "Continue",
      "load_failed": "We couldn’t load your notification settings.",
      "save_failed": "We couldn’t save that change. Your previous setting is still active.",
      "try_again": "Try again"
    },
    "insurance_card": {
      "your_coverage": "Your Coverage",
      "insurance": "Insurance",
      "coverage_and_costs": "Coverage & cost estimates",
      "add_title": "Add your insurance details",
      "add_description": "Add your plan and member ID so we can check your coverage and estimate costs.",
      "add_action": "Add insurance details",
      "empty_title": "No policy on file",
      "empty_subtitle": "Add details to estimate your costs",
      "loading": "Loading",
      "loading_title": "Checking your coverage",
      "loading_subtitle": "Looking for insurance already on file",
      "not_on_file": "Not on file",
      "not_added": "Not added",
      "plan_not_added": "Plan not added",
      "member_id": "Member ID",
      "plan": "Plan",
      "ivf_coverage": "IVF Coverage",
      "ivf_coverage_value": "Up to 3 cycles",
      "lifetime_max": "Lifetime Max",
      "lifetime_max_value": "$15,000",
      "egg_freezing": "Egg Freezing",
      "egg_freezing_value": "Covered",
      "medications": "Medications",
      "medications_value": "80% covered",
      "add_insurance_to_unlock": "Add insurance to unlock",
      "active": "Active",
      "expired": "Expired",
      "verification": "Verification",
      "verification_verified": "Verified",
      "verification_pending": "Checking coverage",
      "verification_unverified": "Needs verification",
      "edit": "Edit insurance"
    },
    "preferences": {
      "section_title": "Preferences",
      "language_label": "Language",
      "language_english": "English",
      "language_french": "Français",
      "date_format_label": "Date format",
      "timezone_label": "Location",
      "timezone_description": "Care schedule in local time",
      "location_picker_title": "Where are you?",
      "location_picker_description": "Search for your city and country. We’ll set your time zone for you.",
      "location_search_placeholder": "Search city or country",
      "location_suggested": "Common locations",
      "location_no_matches": "No locations found. Try a city and country.",
      "location_lookup_failed": "We couldn’t determine a time zone for that place. Choose one manually instead.",
      "manual_timezone_title": "Choose a time zone manually",
      "manual_timezone_description": "Use this if your city is unavailable.",
      "manual_timezone_picker_title": "Time zone",
      "tz_eastern": "Eastern (ET)",
      "tz_central": "Central (CT)",
      "tz_mountain": "Mountain (MT)",
      "tz_pacific": "Pacific (PT)",
      "tz_alaska": "Alaska (AKT)",
      "tz_hawaii": "Hawaii (HT)",
      "tz_london": "London (GMT)",
      "tz_paris": "Paris (CET)",
      "tz_berlin": "Berlin (CET)",
      "tz_tokyo": "Tokyo (JST)",
      "tz_sydney": "Sydney (AEST)",
      "tz_utc": "UTC",
      "haptics_label": "Haptic feedback",
      "haptics_description": "Vibration on taps and interactions",
      "sound_label": "UI sounds",
      "sound_description": "Subtle sounds on interactions",
      "picker_choose": "Choose ${setting}",
      "preferences_load_failed": "We couldn't load your preferences.",
      "preferences_save_failed": "We couldn't save that change. Your previous setting is still active.",
      "try_again": "Try again"
    },
    "integrations": {
      "apple_health_description": "Import cycle history, symptoms, and fertility tracking",
      "apple_health_data_on_file": "Apple Health data is on file",
      "apple_health_no_compatible_data": "No compatible Apple Health data found yet",
      "import_data": "Import data",
      "refresh_data": "Refresh data",
      "iphone_only": "iPhone only",
      "oura_description": "Sleep, HRV, readiness, and temperature trends",
      "tempdrop_description": "Basal body temperature tracking",
      "natural_cycles_description": "Cycle data when a secure connection is available",
      "apple_health_status_load_failed": "We couldn't check whether Apple Health data is on file.",
      "apple_health_import_failed": "We couldn't import Apple Health data. Please try again.",
      "try_again": "Try again"
    },
    "calendar_sync": {
      "add_care_events_to_device_calendar": "Add your appointments and medication reminders to your device calendar",
      "available_in_mobile_app": "Mobile app only",
      "set_up_sync": "Set up",
      "sync_now": "Sync now",
      "sync_in_progress": "Syncing…",
      "not_synced_yet": "Connected — not synced yet",
      "last_synced_at": "Last synced ${when}",
      "sync_failed_try_again": "We couldn't update your calendar. Please try again.",
      "partial_sync_failure_retry": "Some events couldn't be added last time. Sync again to retry.",
      "before_you_connect": "Before you connect",
      "events_visible_to_calendar_viewers": "My Louise will add your upcoming appointments and medication reminders for the next 90 days to a calendar you choose. Anyone who can see that calendar — including shared or work accounts — will see these events. Your Louise reminders keep working either way.",
      "continue_and_allow_access": "Continue",
      "not_now": "Not now",
      "choose_a_calendar": "Choose a calendar",
      "only_writable_calendars_listed": "My Louise can only add events to calendars that allow changes.",
      "add_events_to_this_calendar": "Add events",
      "no_writable_calendars_found": "No writable calendars were found on this device. Add a calendar in your device's calendar app first.",
      "calendar_access_needed": "Calendar access needed",
      "calendar_access_denied_open_settings": "Calendar access is turned off for My Louise. Allow it in your device settings to continue.",
      "open_device_settings": "Open settings",
      "connected_calendar": "Connected calendar",
      "upcoming_events_in_calendar": "${count} upcoming events in your calendar",
      "disconnect_and_remove_events": "Disconnect & remove events",
      "untitled_appointment": "Appointment",
      "unnamed_medication": "Medication",
      "online_appointment_location": "Online"
    },
    "fertility_profile": {
      "section_title": "Fertility Profile",
      "conditions_label": "Conditions",
      "partner_label": "Partner",
      "timeline_label": "Timeline",
      "ethnicity_label": "Ethnicity",
      "location_label": "Location",
      "not_set": "Not set",
      "connected": "Connected",
      "conditions": {
        "none_selected": "None selected",
        "pcos": "PMOS (ex PCOS)",
        "endo": "Endometriosis",
        "thyroid": "Thyroid",
        "irregular": "Irregular periods",
        "loss": "Pregnancy loss",
        "cancer": "Cancer",
        "none": "None",
        "unsure": "Not sure"
      },
      "timeline_value": {
        "asap": "ASAP",
        "three_months": "Within 3 months",
        "six_months": "Within 6 months",
        "exploring": "Just exploring",
        "not_set": "Not set"
      },
      "language_labels": {
        "en": "English",
        "es": "Español",
        "fr": "Français"
      }
    },
    "care_context": {
      "section_title": "Care context",
      "loading": "Loading…",
      "medical_history_label": "Medical history",
      "medical_history_continue": "Continue your medical history",
      "past_treatment_label": "Past treatment",
      "past_treatment_reported": "Past treatment reported",
      "past_treatment_none": "No past treatment on record",
      "past_treatment_one": "1 past cycle on record",
      "past_treatment_other": "${count} past cycles on record",
      "cryo_inventory_label": "Cryo inventory",
      "cryo_inventory_empty": "No cryo inventory on record",
      "cryo_inventory_one": "1 stored specimen",
      "cryo_inventory_other": "${count} stored specimens",
      "records_label": "Care records",
      "records_empty": "No care records on file",
      "records_one": "1 care record on file",
      "records_other": "${count} care records on file",
      "records_filter_label": "Medical history"
    },
    "account_footer": {
      "two_factor_label": "Two-factor authentication",
      "enabled": "Enabled",
      "disabled": "Disabled",
      "two_factor_disabled_description": "Protect your account with an authenticator app or passkey.",
      "two_factor_enabled_description": "Two-factor authentication is protecting your account.",
      "two_factor_totp_enabled_description": "Your authenticator app is protecting your account.",
      "two_factor_passkey_enabled_description": "Your passkey is protecting your account.",
      "two_factor_both_enabled_description": "Your authenticator app and passkey are protecting your account.",
      "logout_label": "Log out",
      "logout_description": "Sign out on this device. You can log back in anytime.",
      "deactivate_label": "Deactivate account",
      "deactivate_description": "Disable access and sign out."
    },
    "research_studies": {
      "anonymous_label": "Anonymous data contribution",
      "anonymous_description": "Help improve fertility care through de-identified data",
      "empty_title": "No eligible studies at the moment",
      "empty_description": "When a study may be relevant, we’ll show its details here.",
      "contribution_load_failed": "We couldn’t load your contribution choice. Please try again.",
      "contribution_save_failed": "We couldn’t save your contribution choice. Please try again."
    },
    "coverage_benefits": {
      "insurance_label": "Insurance",
      "insurance_add": "Add insurance",
      "insurance_on_file": "Insurance on file",
      "plan_label": "Plan",
      "plan_not_specified": "Not specified",
      "member_id_label": "Member ID",
      "fertility_coverage_label": "Fertility coverage",
      "treatments_count": "${count} treatments",
      "fertility_coverage_pending": "We're verifying your coverage",
      "fertility_coverage_unverified": "Insurance has not been verified",
      "fertility_coverage_not_found": "No fertility benefit details on record",
      "coverage_load_failed": "We couldn't load your coverage details.",
      "try_again": "Try again",
      "verified": "Verified",
      "pending": "Pending",
      "unverified": "Unverified",
      "employer_benefits_label": "Employer fertility benefits",
      "employer_benefits_add": "Add employer benefits",
      "employer_benefits_on_file": "Benefits on file",
      "employer_benefits_not_listed": "No employer benefit listed",
      "employer_benefits_modal_title": "Add employer benefits",
      "employer_benefits_modal_description": "Add the workplace benefit you use for fertility care. It can be separate from your health insurance.",
      "employer_benefits_question": "Do you have fertility benefits through work?",
      "employer_benefits_yes": "Yes",
      "employer_benefits_no": "No",
      "employer_benefits_provider_label": "Benefit provider",
      "employer_benefits_provider_hint": "Add a provider such as Progyny, Carrot, Maven, or Kindbody if you know it.",
      "employer_benefits_provider_placeholder": "e.g. Progyny",
      "employer_benefits_question_hint": "Not sure? Check your benefits portal or ask your HR or benefits team. Employer fertility benefits can be separate from health insurance.",
      "employer_benefits_none_action": "I don't have employer benefits",
      "employer_benefits_card_title": "Employer fertility benefits",
      "employer_benefits_card_subtitle": "Optional workplace support",
      "employer_benefits_card_empty_title": "See whether work can help",
      "employer_benefits_card_empty_description": "Your workplace may offer fertility benefits separately from your health insurance.",
      "employer_benefits_card_empty_card_title": "No workplace plan on file",
      "employer_benefits_card_empty_card_subtitle": "Add the fertility benefit your workplace provides, if you have one.",
      "employer_benefits_card_action": "Add employer benefits",
      "employer_benefits_card_program": "Benefit program",
      "employer_benefits_card_status": "Status",
      "employer_benefits_card_not_on_file": "Not on file",
      "employer_benefits_card_not_added": "Not added",
      "employer_benefits_card_optional": "Optional",
      "employer_benefits_card_check_work": "Check with work",
      "employer_benefits_card_on_file": "On file",
      "employer_benefits_card_saved_title": "Benefit details added",
      "employer_benefits_card_saved_description": "This may be separate from your health insurance.",
      "employer_benefits_card_none_subtitle": "Answer on file",
      "employer_benefits_card_none_title": "No employer benefit listed",
      "employer_benefits_card_none_description": "Update this anytime if your benefits change.",
      "employer_benefits_card_update": "Update answer",
      "employer_benefits_cancel": "Cancel",
      "employer_benefits_save": "Save",
      "employer_benefits_save_failed": "We couldn't save your employer benefits. Please try again."
    },
    "support": {
      "section_title": "Support",
      "chat_label": "Chat with support",
      "chat_value": "Get help",
      "chat_title": "Chat with support",
      "chat_subtitle": "Your messages stay here. We usually reply within 24 hours.",
      "chat_history_label": "Support conversation",
      "chat_empty_title": "Start a conversation",
      "chat_empty_subtitle": "Ask anything about Louise, your care, or your account.",
      "chat_load_error": "We couldn't load your messages right now.",
      "chat_retry": "Try again",
      "feedback_label": "Request a feature or give feedback",
      "message_title": "Message Louise",
      "message_feedback_title": "Share feedback",
      "message_subtitle": "Ask us anything. We usually reply within 24 hours.",
      "message_feedback_subtitle": "Tell us what would make Louise better. We usually reply within 24 hours.",
      "message_feedback_sent": "Sent. You can find it anytime in Chat with support.",
      "message_input_label": "Your message",
      "message_placeholder": "Type your message",
      "message_attach": "Attach a file",
      "message_attachment_too_large": "Each attachment must be 10 MB or smaller.",
      "message_too_many_attachments": "You can add up to 5 attachments to one message.",
      "message_send": "Send",
      "message_from_support": "Louise Support",
      "message_from_you": "You",
      "privacy_label": "Privacy Policy",
      "terms_label": "Terms of Service"
    },
    "medical_details": {
      "section_title": "Medical Details",
      "blood_type_label": "Blood type",
      "blood_type_placeholder": "Not set",
      "blood_type_picker_title": "Select blood type",
      "blood_type_save_failed": "We couldn't save your blood type. Please try again.",
      "allergies_label": "Allergies",
      "allergies_none": "None",
      "allergies_add": "Add allergy information",
      "emergency_contact_section_title": "Emergency Contact",
      "emergency_contact_label": "Emergency contact",
      "emergency_contact_placeholder": "Add emergency contact",
      "emergency_name_label": "Name",
      "emergency_name_placeholder": "Contact name",
      "emergency_phone_label": "Phone",
      "emergency_relationship_label": "Relationship",
      "emergency_relationship_placeholder": "Select relationship",
      "save_changes": "Save changes",
      "save": "Save",
      "cancel": "Cancel",
      "emergency_name_required": "Add their name",
      "emergency_phone_required": "Add their phone number",
      "emergency_contact_save_failed": "We couldn't save your emergency contact. Please try again.",
      "remove_emergency_contact": "Remove emergency contact",
      "relationship_partner": "Partner",
      "relationship_spouse": "Spouse",
      "relationship_parent": "Parent",
      "relationship_child": "Child",
      "relationship_sibling": "Sibling",
      "relationship_friend": "Friend",
      "relationship_colleague": "Colleague",
      "relationship_other": "Other"
    },
    "invite_friend": {
      "section_title": "Help a friend",
      "blurb": "Know someone on a similar journey?\nShare Louise for a chance to win a free fertility-care cycle.",
      "compact_blurb": "Share Louise for a chance to win a free cycle.",
      "share_button": "Share Louise",
      "dismiss": "Dismiss Help a friend card",
      "share_title": "Louise: Your Fertility Care Companion",
      "share_message": "I've been using Louise to navigate fertility care: track treatment, find clinics, manage costs. Thought you might find it helpful too: ${url}",
      "share_sheet_title": "Share Louise",
      "share_sheet_subtitle": "Send this link to someone who might benefit from Louise.",
      "share_sheet_copy": "Copy link",
      "share_sheet_copied": "Link copied",
      "landing_title": "A friend invited you",
      "landing_subtitle": "Louise is your fertility care companion. Track treatment, find clinics, and manage costs. Start with a few questions to get set up.",
      "landing_cta": "Get started"
    },
    "shared": {
      "select": "Select",
      "back": "Back"
    },
    "insurance_modal": {
      "title": "Insurance Details",
      "edit": "Edit",
      "add_blurb": "Save the details you have now and add more later.",
      "edit_blurb": "Update the insurance details you have on hand.",
      "insurance_card_label": "Insurance card",
      "front_card_label": "Front",
      "back_card_label": "Back",
      "add_card_action": "Add ${side} of insurance card",
      "retry_card_action": "Retry ${side} insurance card upload",
      "add_card_button": "Add",
      "retry_card_button": "Retry",
      "card_add_hint": "Add a photo or PDF",
      "card_uploading": "Uploading…",
      "card_reading": "Reading card…",
      "card_upload_error": "Couldn't upload. Tap to try again.",
      "card_ocr_error": "We couldn't read the card details. You can enter them manually.",
      "open_card_action": "Open ${side} insurance card",
      "view_card_action": "View ${side} insurance card",
      "replace_card_action": "Replace ${side} insurance card",
      "remove_card_action": "Remove ${side} of insurance card",
      "carrier_label": "Insurance carrier",
      "carrier_placeholder": "e.g. Blue Cross Blue Shield",
      "carrier_search_unavailable": "Carrier search is unavailable. You can still type the name manually and save.",
      "carrier_searching": "Searching carriers…",
      "member_id_label": "Member ID",
      "member_id_placeholder": "e.g. ABC123456789",
      "group_number_label": "Group number",
      "group_number_placeholder": "e.g. 12345",
      "no_details_error": "Add at least one insurance detail before saving.",
      "error_generic": "We couldn't save your insurance details. Please try again.",
      "cancel_button": "Cancel",
      "save_button": "Save",
      "delete_card_title": "Remove card image?",
      "delete_card_message": "This removes this insurance card image. You can upload it again anytime.",
      "delete_card_cancel": "Cancel",
      "delete_card_confirm": "Remove",
      "provider_label": "Insurance Provider",
      "plan_name_label": "Plan Name",
      "group_number_summary_label": "Group Number",
      "plan_type_label": "Plan Type",
      "not_provided": "Not provided",
      "status_verified": "Verified",
      "status_verified_description": "Your insurance has been verified with your provider.",
      "status_pending": "Verification Pending",
      "status_pending_description": "We're verifying your coverage. This usually takes 1-2 business days.",
      "status_unverified": "Not Verified",
      "status_unverified_description": "Your insurance information has not been verified yet.",
      "fertility_coverage_header": "Fertility Coverage",
      "deductible_label": "Deductible",
      "oop_max_label": "Out-of-Pocket Max",
      "coinsurance_label": "Coinsurance",
      "treatments_covered_label": "Treatments Covered"
    },
    "modals": {
      "logout": {
        "title": "Log out",
        "message": "You'll be signed out of your account on this device. You can log back in anytime.",
        "cancel": "Cancel",
        "confirm": "Log out"
      },
      "delete_account": {
        "title": "Deactivate account",
        "message": "We'll disable access and sign you out. Required care records stay linked to your clinics and care relationships.",
        "deactivation_title": "Access will be disabled",
        "deactivation_description": "Required care records remain linked to clinics and care relationships.",
        "reactivation_title": "Need to come back?",
        "reactivation_description": "Contact support to restore access.",
        "confirmation_token": "DEACTIVATE",
        "type_prefix": "Type",
        "type_suffix": "to confirm",
        "type_placeholder": "Type DEACTIVATE",
        "cancel": "Cancel",
        "confirm": "Deactivate",
        "error": "Something went wrong. Please try again or contact support."
      },
      "roadmap": {
        "title": "Your Roadmap",
        "current_badge": "Current",
        "deciding_label": "Deciding Phase",
        "deciding_description": "Learn about your fertility options and determine the best path forward.",
        "deciding_milestone_1": "Set your journey goal",
        "deciding_milestone_2": "Add a first document or result",
        "deciding_milestone_3": "Schedule initial consultation",
        "deciding_milestone_4": "Add your clinic to your care team",
        "preparing_label": "Preparation Phase",
        "preparing_description": "Get your body and logistics ready for your fertility treatment.",
        "preparing_milestone_1": "Complete baseline bloodwork and screening",
        "preparing_milestone_2": "Begin prescribed medications if needed",
        "preparing_milestone_3": "Set up your care team and schedule",
        "preparing_milestone_4": "Connect your partner",
        "in_treatment_label": "Treatment Phase",
        "in_treatment_description": "Active fertility treatment, including monitoring, procedures, and day-to-day care.",
        "in_treatment_milestone_1": "Attend monitoring appointments",
        "in_treatment_milestone_2": "Follow medication protocol",
        "in_treatment_milestone_3": "Egg retrieval or transfer procedure",
        "in_treatment_milestone_4": "Post-procedure recovery",
        "storing_label": "Storage Phase",
        "storing_description": "Your eggs, embryos, or samples are safely stored for the future.",
        "storing_milestone_1": "Confirm storage facility and plan",
        "storing_milestone_2": "Add your specimens to your vault",
        "storing_milestone_3": "Upload your lab report",
        "storing_milestone_4": "Start a new cycle when you're ready",
        "result_label": "Result",
        "result_description": "Your cycle is done. This is the wait for the result and what it tells you.",
        "result_milestone_1": "Keep taking your support medication",
        "result_milestone_2": "Record your beta hCG result",
        "result_milestone_3": "Upload your beta report",
        "result_milestone_4": "Start your next cycle"
      },
      "partner_manage": {
        "pending_invite_to": "Pending invite to ${name}",
        "pending_invitation": "Pending invitation",
        "manage_named": "Manage ${name}",
        "manage_partner": "Manage partner",
        "pending_message_named": "${name} hasn't accepted the invite yet. You can cancel and send a new one anytime.",
        "pending_message_generic": "The invite hasn't been accepted yet. You can cancel and send a new one anytime.",
        "done": "Done",
        "cancel_invitation": "Cancel invitation",
        "remove_partner": "Remove partner",
        "cancel_invitation_title": "Cancel this invitation?",
        "cancel_invitation_message": "The invitation link will stop working. You can send a new invitation later.",
        "remove_partner_connection_title": "Remove this partner connection",
        "remove_partner_connection_message": "This stops new partner access and sharing after the server confirms. Records you own remain yours; copies already downloaded may not be retractable.",
        "cancel": "Cancel",
        "confirm_invitation_cancellation": "Cancel invitation",
        "remove_connection": "Remove",
        "remove_failed": "Failed to remove partner"
      },
      "data_sharing": {
        "connect_partner": "Connect a partner",
        "connect_clinic": "Connect a clinic",
        "connect_pharmacy": "Connect a pharmacy",
        "connect_provider": "Connect a provider",
        "sharing_with": "Sharing with ${name}",
        "generic_partner": "Partner data sharing",
        "generic_clinic": "Clinic data sharing",
        "generic_pharmacy": "Pharmacy data sharing",
        "generic_provider": "Provider data sharing",
        "pending_intro": "Sharing controls for this connection unlock once it goes live. Nothing is saved yet — you'll set your preferences when the connection exists.",
        "pending_invitation_for": "Invitation pending for ${name}",
        "pending_invite_status_value": "Pending",
        "pending_invite_status_with_expiry": "Pending · Expires ${date}",
        "pending_invite_sent_to": "Sent to ${phone}",
        "save_invitation": "Save",
        "pending_sharing_updated": "Sharing preferences saved.",
        "pending_sharing_update_failed": "We couldn't save the sharing preferences. Try again.",
        "local_history_notice": "Your latest Medical History changes remain only on this device. You can turn off existing access now, but new access cannot be enabled until those changes sync or are reviewed.",
        "medical_history_label": "Medical history",
        "medical_history_description": "Conditions, diagnoses, and treatment history",
        "test_results_label": "Test results",
        "test_results_description": "Lab work, hormone levels, and imaging",
        "medications_label": "Medications",
        "medications_description": "Current and past prescriptions",
        "cycle_data_label": "Cycle data",
        "cycle_data_description": "Period tracking, predictions, and symptoms",
        "appointments_label": "Appointments",
        "appointments_description": "Appointments for shared care",
        "documents_label": "Documents",
        "documents_description": "Uploaded files, consent forms, and records",
        "remove_partner": "Remove partner",
        "cancel_invitation": "Cancel invitation",
        "partner_phone_unavailable": "Phone number unavailable",
        "remove_failed": "Failed to remove partner",
        "done": "Done"
      },
      "disable_2fa": {
        "title": "Disable two-factor authentication",
        "message": "Enter a current code from your authenticator app to confirm. Your account will be less secure without 2FA.",
        "passkey_message": "Confirm with your passkey to turn off two-factor authentication. Your account will be less secure without it.",
        "code_placeholder": "000000",
        "error_invalid": "Invalid code. Please try again.",
        "error_generic": "Something went wrong. Please try again.",
        "cancel": "Cancel",
        "confirm": "Disable"
      },
      "setup_2fa": {
        "intro_title": "Two-factor authentication",
        "intro_message": "Add an extra layer of security to your account. You'll need an authenticator app like Google Authenticator or Authy.",
        "intro_error_default": "Setup failed",
        "intro_cancel": "Cancel",
        "intro_setup": "Set up",
        "scan_title": "Scan QR code",
        "scan_message_web": "Open your authenticator app and scan this code.",
        "scan_message_mobile": "Tap to open your authenticator app, or scan from another device.",
        "scan_open_in_app": "Open in authenticator app",
        "scan_secret_copied": "No authenticator app found — secret copied to clipboard.",
        "scan_qr_a11y": "2FA QR code",
        "scan_manual_intro": "Or enter this code manually:",
        "scan_next": "Next",
        "verify_title": "Enter verification code",
        "verify_message": "Enter the 6-digit code from your authenticator app.",
        "verify_code_placeholder": "000000",
        "verify_error_invalid": "Invalid code. Please try again.",
        "verify_confirm": "Verify",
        "recovery_title": "Save your recovery codes",
        "recovery_message": "Store these somewhere safe. Each code can only be used once if you lose access to your authenticator.",
        "recovery_copy_all": "Copy all",
        "recovery_acknowledge": "I've saved these codes. I understand they won't be shown again.",
        "recovery_done": "Done",
        "passkey_or": "or",
        "passkey_button": "Set up a passkey",
        "passkey_error_default": "Couldn't set up your passkey. Please try again.",
        "passkey_success": "Passkey added"
      },
      "end_cycle": {
        "title": "End treatment cycle",
        "subtitle": "How did this cycle end? We'll close it and keep it in your history.",
        "past_outcome_prompt": "What was the outcome of this past cycle? Add it to your treatment history.",
        "past_preservation_outcome_prompt": "What happened during this past preservation cycle? Add the outcome to your treatment history.",
        "past_donation_outcome_prompt": "What happened during this past donation cycle? Add the outcome to your treatment history.",
        "current_close_after_procedure_prompt": "Your transfer or insemination is complete. What was the outcome of this treatment cycle?",
        "current_close_before_outcome_prompt": "This cycle has not reached a pregnancy outcome. Tell us how you want to close it.",
        "current_close_recorded_result_prompt": "This cycle already has a recorded result. Confirm it below to close the treatment cycle.",
        "recorded_result_recap_title": "Review your recorded result",
        "recorded_result_recap_prompt": "This result is already saved. Check the details below before closing the cycle.",
        "recorded_result_label": "Recorded outcome",
        "recorded_result_date_label": "Recorded on",
        "recorded_result_status_label": "Result status",
        "recorded_result_notes_label": "Notes",
        "recorded_result_positive_status": "Positive",
        "recorded_result_negative_status": "Negative",
        "recorded_result_uncertain_status": "Uncertain",
        "close_with_recorded_result": "Close with this result",
        "choose_different_outcome": "Choose a different outcome",
        "history_note": "Your treatment information, progress, and records will stay accessible from your treatment history.",
        "outcome_completed_preservation": "Cycle completed",
        "completed_preservation_description": "The planned preservation steps are complete.",
        "outcome_completed_donation": "Donation completed",
        "completed_donation_description": "The planned donation steps are complete.",
        "prompt_preservation": "How did this cycle end? Completing it moves it into your history — what you stored stays in your cryo vault.",
        "prompt_donation": "How did this cycle end? Completing it moves it into your history.",
        "confirm_completed_title": "This cycle is complete",
        "confirm_completed_body": "It's saved to your history. Nothing needs deciding today.",
        "outcome_pregnancy": "Pregnancy",
        "pregnancy_outcome_description": "The cycle ended with a positive pregnancy result.",
        "outcome_no_pregnancy": "No pregnancy",
        "no_pregnancy_outcome_description": "The cycle ended without a pregnancy.",
        "outcome_miscarriage": "Pregnancy loss",
        "pregnancy_loss_outcome_description": "The cycle ended after a pregnancy loss.",
        "outcome_cancelled": "Cycle cancelled",
        "cycle_cancelled_outcome_description": "The cycle stopped before treatment was complete.",
        "outcome_other": "Other",
        "other_outcome_description": "Choose this when another outcome best fits.",
        "outcome_details_title": "Add a note about this cycle",
        "outcome_details_prompt": "Add anything you want to remember about how it ended.",
        "cancelled_details_title": "Why was the cycle cancelled?",
        "cancelled_details_prompt": "Choose the reason that best matches what happened.",
        "other_details_title": "Report a change",
        "other_details_prompt": "Add a note so your history reflects what happened.",
        "reason_label": "Reason (optional)",
        "reason_doctor": "Doctor recommended",
        "reason_side_effects": "Side effects too much",
        "reason_schedule": "Schedule conflict",
        "reason_personal": "Personal reasons",
        "reason_other": "Other",
        "notes_placeholder": "Add a note (optional)",
        "cancel": "Cancel",
        "confirm": "End cycle"
      },
      "partner_invite": {
        "visual_you": "You",
        "visual_together": "Together",
        "step_who_title": "Who is your person?",
        "step_who_subtitle": "The one walking this journey with you.",
        "step_who_name_label": "Their first name",
        "step_who_name_hint": "Enter a name to continue.",
        "step_who_name_placeholder": "Their first name",
        "step_share_title": "What would you like to share with ${name} for this journey?",
        "step_share_subtitle": "Choose what you want to share as you go through this fertility journey. Your private medical history stays yours.",
        "step_share_note": "They can create their own Louise account and manage their own health information separately.",
        "sharing_scope_required": "A current shared journey is required before you can send this invitation.",
        "shared_cycle_data_label": "Cycle & menstrual data",
        "shared_cycle_data_description": "Period tracking, symptoms, and cycle updates",
        "shared_appointments_label": "Appointments",
        "shared_appointments_description": "Appointments for shared care",
        "shared_medications_label": "Medications",
        "shared_medications_description": "Medication details shared with this partner",
        "shared_test_results_label": "Test results",
        "shared_test_results_description": "Access to your test results; include this only if you want to share them.",
        "step_phone_title": "Reach out to ${name}",
        "step_phone_subtitle": "Enter their phone number so they can receive an invitation.",
        "step_phone_number_label": "Their phone number",
        "step_phone_number_placeholder": "Phone number",
        "step_progress": "Step ${current} of ${total}",
        "send_invite": "Send invite",
        "update_invite": "Update invitation",
        "step_sent_title": "The invite is sent",
        "step_sent_message": "${name} will receive a link to join you. You can find the pending invite in Partner connections in Settings, where you can cancel it any time.",
        "step_updated_title": "The invitation is updated",
        "step_updated_message": "${name} will receive the updated invitation. You can find it in Partner connections in Settings, where you can cancel it any time.",
        "sending": "Sending...",
        "done": "Done",
        "close": "Close",
        "back": "Back",
        "continue": "Continue",
        "dismiss_error": "Dismiss error",
        "unlink_pending": "Unlinking…",
        "unlink_action": "Unlink current partner & try again"
      }
    },
    "intent_picker": {
      "title_goal": "Your journey",
      "title_stage": "Where are you in your journey?",
      "subtitle": "So we can personalize every part of your experience.",
      "journey_save_in_progress": "Saving your journey…",
      "journey_save_failed": "We couldn't save your journey. Your current selection is unchanged. Try again.",
      "goal": {
        "preserve_label": "Preserve my fertility",
        "preserve_sublabel": "Freeze eggs or embryos",
        "grow_label": "Build my family",
        "grow_sublabel": "Naturally or with treatment",
        "donate_label": "Help someone else",
        "donate_sublabel": "Donation",
        "explore_label": "Just exploring",
        "explore_sublabel": "See what's out there"
      },
      "preserve": {
        "exploring_label": "Just exploring options",
        "exploring_sublabel": "Learning about my options",
        "egg_freezing_label": "Egg freezing",
        "sperm_freezing_label": "Sperm freezing",
        "freezing_sublabel": "Thinking about it or already started",
        "embryo_label": "Embryo freezing",
        "embryo_sublabel": "Thinking about it or already started"
      },
      "grow": {
        "trying_label": "Trying on my own",
        "trying_sublabel": "Conceiving without treatment",
        "researching_label": "Researching my options",
        "researching_sublabel": "Comparing paths to family",
        "adoption_label": "Adoption",
        "adoption_sublabel": "Exploring adoption and other family-building paths",
        "ready_label": "Getting ready for treatment",
        "ready_sublabel": "Considering IUI, IVF, or other procedures",
        "in_treatment_label": "Already in treatment",
        "in_treatment_sublabel": "Currently doing IUI, IVF, or similar"
      },
      "help": {
        "sperm_donation_label": "Donate sperm",
        "sperm_donation_sublabel": "Help others build their family",
        "egg_donation_label": "Donate eggs",
        "egg_donation_sublabel": "Help others build their family",
        "surrogacy_label": "Be a surrogate",
        "surrogacy_sublabel": "Carry a pregnancy for someone else"
      }
    }
  },
  "med_history": {
    "save_failed_title": "Save Failed",
    "save_failed_message": "We couldn't save your information. Please try again.",
    "save_failed_ok": "OK",
    "shared": {
      "next": "Next",
      "continue": "Continue",
      "yes": "Yes",
      "no": "No",
      "unknown": "I don't know",
      "yes_diagnosed": "Yes, it was diagnosed",
      "maybe_undiagnosed": "I think I may have it but it wasn't diagnosed",
      "remind_me_later": "Remind me later",
      "not_provided": "Not provided",
      "tap_to_update": "Tap any answer to update it",
      "edit_all": "Go through all questions",
      "recorded": "Recorded",
      "none_recorded": "None recorded"
    },
    "family_history": {
      "ancestry_title": "What is your ancestry?",
      "ancestry_subtitle": "Your ethnic background can provide important insights into genetic health risks. You can select multiple options.",
      "ancestry": {
        "african": "African",
        "african_or_african_american": "African American/\nCaribbean",
        "middle_eastern_north_african": "Middle-eastern/\nNorth African",
        "american_indian_native_american": "Native/\nIndigenous Peoples",
        "caucasian": "European/White",
        "asian": "Asian",
        "hispanic_caribbean": "Hispanic/latino",
        "multi_racial": "Multiracial",
        "other": "Other",
        "i_dont_know": "Prefer not to say"
      },
      "adopted_title": "Are you adopted or uninformed about your family's medical history?",
      "adopted_subtitle": "Knowing your situation allows us to consider any unknown genetic risks, as well as get a better understanding of your whole medical history.",
      "adoption": {
        "adopted_or_dont_know_biological_parents": "I am adopted / don't know my biological parents",
        "from_gamete_donation": "I was born from a gamete donation",
        "not_adopted": "None of the above, proceed with my family medical history"
      },
      "family_member_title": "Which family member?",
      "family_member_subtitle": "Specify the relative who has faced fertility challenges",
      "family_member": {
        "mother": "Mother",
        "father": "Father",
        "brother": "Brother",
        "sister": "Sister",
        "grandmother_mother_side": "Maternal\ngrandmother",
        "grandfather_mother_side": "Maternal\ngrandfather",
        "grandmother_father_side": "Paternal\ngrandmother",
        "grandfather_father_side": "Paternal\ngrandfather",
        "other": "Other"
      },
      "des_title": "Did your mother take DES or any other medication while she was pregnant with you?",
      "des_subtitle": "We ask because DES can cause reproductive issues for those exposed in the womb",
      "dna_test_title": "Have you ever done a DNA test to confirm your ancestry?",
      "dna_test_subtitle": "A DNA test analyzes your genetic material to confirm your ancestry",
      "dna_report_title": "Do you have a DNA ancestry report?",
      "dna_report_section_label": "My report",
      "dna_report_info": "This document will also be available in your Documents section.",
      "dna_report_test_date_label": "Test Date",
      "dna_report_test_date_placeholder": "What date was this test done?",
      "dna_report_dont_have": "I don't have the report",
      "dna_report_add_another": "Add another DNA report",
      "dna_report_default_name": "DNA Report",
      "family_infertility_title": "Have any of your immediate family members had difficulty conceiving a child?",
      "family_infertility_subtitle": "This question helps identify any patterns of fertility issues in your family",
      "maternal_diseases_title": "Do you know of any diseases on your mother's side of the family?",
      "maternal_diseases_description": "It can include your mother.",
      "maternal_diseases_example": "It can be general, \"I heard my mom's uncle had diabetes\" or precise, \"my grandma had a stroke at 67\".",
      "paternal_diseases_title": "Do you know of any diseases on your father's side of the family?",
      "paternal_diseases_description": "It can include your father.",
      "paternal_diseases_example": "It can be general, \"I heard my father's cousin had diabetes\" or precise, \"my grandma had a stroke at 67\".",
      "diseases_label": "Known diseases or conditions",
      "diseases_placeholder": "Feel free to write anything",
      "complete_subtitle": "You have finished your family history questions"
    },
    "basic_info": {
      "flow": {
        "section_label": "About you",
        "help_accessibility_label": "Why we ask this",
        "chips": {
          "about_you": "About you",
          "pregnancy": "Pregnancy history",
          "medical_history": "Medical history",
          "allergies": "Allergies",
          "medications": "Medications"
        }
      },
      "help": {
        "sex_at_birth": "Sex assigned at birth helps us show the reproductive health questions that are relevant to you.",
        "basics": "Your date of birth, height, and weight help put health information in context. You can update them later.",
        "pregnancy": "Count every pregnancy, including pregnancies that ended in miscarriage, stillbirth, or abortion.",
        "endometriosis": "Choose diagnosed if a clinician has confirmed endometriosis. Choose the suspected option if it has been discussed but not confirmed.",
        "pcos": "Choose diagnosed if a clinician has confirmed PCOS. Choose the suspected option if it has been discussed but not confirmed.",
        "varicocele": "Choose diagnosed if a clinician has confirmed a varicocele. Choose the suspected option if it has been discussed but not confirmed.",
        "cancer": "Include any past or current cancer diagnosis. You can add the type, dates, and treatments in Disease History.",
        "allergies": "This question is specifically about reactions to medications. Other allergy types can be added in the Allergies section.",
        "allergy_details": "Add one medication or substance per entry. Use the notes field to describe the reaction and when it happened.",
        "medications": "Include prescription, over-the-counter, hormone, and fertility medications that you take regularly or as needed.",
        "medication_details": "Add one medication per entry. Include the frequency and any useful context in the notes.",
        "quick_exposure": "This quick check helps us identify context that may affect care. You can add frequency and other details later in Substances."
      },
      "sex_at_birth": {
        "title": "What sex were you born as?",
        "subtitle": "This helps us understand your needs and offer relevant advice on next steps",
        "female": "Female",
        "male": "Male"
      },
      "basics": {
        "title": "Some basic information about you",
        "subtitle": "These factors can be relevant in tailoring care and advice specific to your needs.",
        "date_of_birth": "Date of birth",
        "weight": "Weight",
        "height": "Height",
        "date_placeholder": "MM/DD/YYYY",
        "weight_placeholder": "Your weight",
        "height_placeholder_cm": "Your height",
        "height_placeholder_ft": "e.g. 5'10"
      },
      "quick_exposure": {
        "title": "Do you currently use any of these?",
        "subtitle": "Select all that apply. You can add details later.",
        "alcohol": "Alcohol",
        "cannabis": "Cannabis / weed",
        "cigarettes": "Tobacco / cigarettes",
        "vape": "Nicotine / vaping",
        "other": "Other substances",
        "none": "None of these"
      },
      "pregnancy": {
        "title_afab": "Have you ever been pregnant?",
        "title_amab": "Have you ever had a baby?",
        "subtitle": "Including miscarriages and abortions",
        "counter_label": "How many?",
        "counter_description": "Including miscarriages and abortions"
      },
      "pregnancy_count": {
        "title": "Your pregnancies",
        "subtitle": "Including miscarriages and abortions",
        "counter_label": "Your pregnancies",
        "counter_description": "How many pregnancies have you had?"
      },
      "endometriosis": {
        "title": "Do you have endometriosis?"
      },
      "pcos": {
        "title": "Do you have PMOS (ex PCOS)?"
      },
      "varicocele": {
        "title": "Do you have varicocele?"
      },
      "cancer": {
        "title": "Have you ever had cancer?",
        "subtitle": "You will be able to add more details later"
      },
      "allergies": {
        "title": "Are you allergic to any medications?"
      },
      "allergies_details": {
        "title": "What medications are you allergic to?",
        "subtitle": "You can add the name of a brand or a specific chemical",
        "field_label": "Medication Allergy ${n}",
        "name_placeholder": "Medication name or chemical",
        "comments_placeholder": "Add any comments or details",
        "add_another": "Add another medication allergy",
        "remove": "Remove medication allergy ${n}"
      },
      "medications": {
        "current_medications": "Your current medications",
        "edit_medications_in_medications_and_vaccines": "Review what you have shared here. Add or change medications in the Medications & Vaccines section.",
        "no_current_medications_recorded": "You have not added any current medications yet.",
        "manage_medications_and_vaccines": "Manage medications & vaccines",
        "open_categorized_medical_history_editor": "Open the categorized Medical History editor."
      },
      "complete": {
        "title": "It's all about you",
        "subtitle": "Thank you for answering those questions, we will be able to tailor your experience!",
        "saving": "Saving...",
        "save_failed_title": "Save Failed",
        "save_failed_message": "We couldn't save your information. Please try again.",
        "save_failed_ok": "OK"
      }
    },
    "fertility": {
      "continue": "Continue",
      "save_info": "Save info",
      "testing": {
        "types_title": "Have you done any types of fertility testing?",
        "types_subtitle": "Select all that apply, or choose None if you haven't done any.",
        "upload_label": "Upload pictures or files",
        "none": "None of these",
        "other_details_label": "Tell us about another test",
        "other_details_placeholder": "Add any other test or relevant details",
        "type": {
          "urine": "Urine Tests",
          "imaging": "Imaging Tests",
          "sampling": "Sampling Tests",
          "genetic": "Genetic Tests",
          "blood": "Blood Tests",
          "semen": "Semen Analysis",
          "other": "Other"
        },
        "blood_title": "Have you done any of these blood tests?",
        "blood_subtitle": "Select all that apply.",
        "blood_type": {
          "hormonal": "Hormonal Testing",
          "std": "STD Testing",
          "thyroid": "Thyroid Testing",
          "other": "Other Blood Test"
        },
        "urine_title": "What type of urine test did you complete?",
        "urine_subtitle": "Select one",
        "urine_type": {
          "ovulation": "Ovulation Test",
          "pregnancy": "Pregnancy Test",
          "other": "Other Urine Test"
        },
        "imaging_title": "Have you done any of these imaging tests?",
        "imaging_subtitle": "Select all that apply.",
        "imaging_type": {
          "transabdominal": "Transabdominal Ultrasound",
          "transvaginal": "Transvaginal Ultrasound",
          "hysterosonography": "Hysterosonography (SIS)",
          "hysterosalpingography": "Hysterosalpingography (HSG)",
          "antral_follicle": "Antral follicle count",
          "laparoscopy": "Laparoscopy",
          "hysteroscopy": "Hysteroscopy",
          "pelvic_mri": "Pelvic MRI",
          "other": "Other imaging test"
        },
        "genetic_title": "Which genetic tests have you done?",
        "genetic_subtitle": "You can select multiple answers",
        "genetic_type": {
          "karyotyping": "Karyotyping",
          "carrier_testing": "Carrier testing",
          "exome_genome": "Exome or genome sequencing",
          "other": "Other genetic test"
        },
        "sampling_title": "Have you done any of these sampling tests?",
        "sampling_subtitle": "Select all that apply.",
        "sampling_type": {
          "swab_test": "Swab Test",
          "pap_smear": "Pap smear",
          "endometrial_biopsy": "Endometrial biopsy",
          "other": "Other sampling test"
        },
        "complete_section_label": "Fertility testing",
        "complete_title": "Your testing history is taking shape",
        "complete_subtitle": "You captured the tests that are already part of your story.",
        "complete_return_hint": "You can add or update results whenever you need to.",
        "complete_recap": "You told us about ${types}.",
        "complete_recap_empty": "You did not add a test type this time.",
        "complete_insight_default": "Keeping this together helps us avoid repeat questions and make the next conversation with your provider more focused.",
        "complete_insight_blood": "Because you included blood testing, we can connect those results with the rest of your fertility picture when you review care options.",
        "complete_insight_semen": "Because you included semen analysis, we can keep that context visible when your care team considers next steps.",
        "complete_insight_file": "You added ${count} file to your history. We can use that record to fill in details later.",
        "complete_insight_files": "You added ${count} files to your history. We can use those records to fill in details later."
      },
      "treatments": {
        "done_title": "Have you done any ART treatments before?",
        "done_subtitle": "ART includes Egg Freezing, IUI, ICSI, OI, IVF etc.",
        "types_title": "Have you done any of these ART treatments?",
        "types_subtitle": "Select all that apply, or choose None of these.",
        "none": "None of these",
        "type": {
          "ivf_icsi": "IVF/ICSI",
          "iui": "IUI",
          "medicated_cycle": "Ovarian\nInduction",
          "ovulation_induction": "Ovulation\nInduction",
          "medications_only": "Medications\nonly",
          "timed_intercourse": "Timed\nintercourse",
          "other_treatment": "Other\ntreatment",
          "unknown_treatment": "Unknown\ntreatment",
          "fet": "Frozen Embryo\nTransfer",
          "egg_freezing": "Egg Freezing",
          "embryo_freezing": "Embryo Freezing"
        },
        "common": {
          "details_subtitle": "You will be able to add more details later",
          "name_label": "Treatment name or protocol",
          "name_placeholder": "Name (optional)",
          "date_label": "Treatment start date",
          "date_placeholder": "When did this treatment start?",
          "clinic_label": "Clinic",
          "clinic_placeholder": "At which clinic was it done?",
          "outcome_label": "Outcome",
          "outcome_placeholder": "What was the outcome?",
          "notes_label": "Notes",
          "notes_placeholder": "Notes (optional)",
          "remove_cycle_title": "Remove this treatment record?",
          "remove_cycle_message": "The last treatment details will be removed from this answer.",
          "remove_cycle_cancel": "Keep it",
          "remove_cycle_confirm": "Remove",
          "cycle": "Cycle ${n}"
        },
        "outcome": {
          "miscarriage": "Miscarriage",
          "chemical_pregnancy": "Chemical pregnancy",
          "ectopic_pregnancy": "Ectopic pregnancy",
          "still_birth": "Still birth",
          "other": "Other",
          "live_birth": "Live birth",
          "multiple_live_births": "Multiple live births"
        },
        "ivf": {
          "title": "IVF/ICSI cycle details",
          "counter_label": "Your IVF/ICSI cycles",
          "counter_description": "How many IVF/ICSI cycles have you started? This includes cancelled cycles."
        },
        "iui": {
          "title": "IUI cycle details",
          "counter_label": "Your IUI cycles",
          "counter_description": "How many IUI cycles have you started? This includes cancelled cycles."
        },
        "fet": {
          "title": "Frozen Embryo Transfer details",
          "counter_label": "Your FET cycles",
          "counter_description": "How many FET cycles have you started? This includes cancelled cycles.",
          "patient_report_notice": "These are records you entered. Louise keeps them as patient-reported history, and you can update them anytime.",
          "unknown_placeholder": "Unknown / not reported",
          "protocol_label": "Protocol, if known",
          "protocol_unknown": "Unknown / not reported",
          "protocol_true_natural": "True natural",
          "protocol_modified_natural": "Modified natural",
          "protocol_programmed": "Programmed / HRT",
          "protocol_stimulated": "Stimulated",
          "protocol_down_regulated": "Down-regulated",
          "protocol_other": "Other",
          "transfer_state_label": "What happened with the transfer?",
          "transfer_unknown": "Unknown / not reported",
          "transfer_planned": "Planned",
          "transfer_scheduled": "Scheduled",
          "transfer_performed": "Transfer performed",
          "transfer_cancelled": "Cancelled",
          "transfer_no_transfer": "Attempted / no transfer",
          "transfer_thaw_failure": "No transfer after thaw failure",
          "transfer_paused": "Paused",
          "thaw_state_label": "What do you know about thawing?",
          "thaw_unknown": "Unknown / not reported",
          "thaw_not_applicable": "Not applicable",
          "thaw_ordered": "Ordered",
          "thaw_survived": "Survived",
          "thaw_failed": "Did not survive",
          "thaw_partial": "Partial / mixed result",
          "thaw_not_reported": "Not reported",
          "embryo_count_label": "Embryo count, if known",
          "embryo_count_placeholder": "Leave blank if unknown",
          "result_state_label": "Result or pregnancy state, if known",
          "result_unknown": "Unknown / not reported",
          "result_not_yet_known": "Result not yet known",
          "result_negative": "Negative / no pregnancy",
          "result_indeterminate_repeat": "Indeterminate / repeat needed",
          "result_pregnancy_detected": "Pregnancy detected",
          "result_pregnancy_unknown_location": "Pregnancy of unknown location",
          "result_ongoing": "Ongoing pregnancy",
          "result_biochemical_pregnancy": "Biochemical pregnancy",
          "result_ectopic_pregnancy": "Ectopic pregnancy",
          "result_early_pregnancy_loss": "Early pregnancy loss / miscarriage",
          "result_stillbirth": "Stillbirth",
          "result_live_birth": "Live birth",
          "result_no_transfer": "No transfer",
          "result_cancelled": "Cancelled",
          "result_paused": "Paused"
        },
        "egg_freezing": {
          "title": "Egg Freezing details",
          "counter_label": "Your egg freezing cycles",
          "counter_description": "How many egg freezing cycles have you started? This includes cancelled cycles.",
          "date_label": "Treatment date",
          "clinic_label": "Clinic",
          "eggs_frozen_label": "Eggs frozen",
          "eggs_frozen_placeholder": "How many eggs were frozen?"
        },
        "embryo_freezing": {
          "title": "Embryo Freezing details",
          "counter_label": "Your embryo freezing cycles",
          "counter_description": "How many embryo freezing cycles have you done? This includes cancelled cycles.",
          "date_label": "Treatment date",
          "clinic_label": "Clinic",
          "embryos_frozen_label": "Embryos frozen",
          "embryos_frozen_placeholder": "How many embryos were frozen?"
        },
        "meds_only": {
          "title": "Medicated cycle details",
          "counter_label": "Your medicated cycles",
          "counter_description": "How many medicated cycles have you started? This includes cancelled cycles."
        },
        "oi": {
          "cycle_details": "Ovulation induction details",
          "reported_cycles": "Your ovulation-induction cycles",
          "reported_cycles_description": "How many ovulation-induction cycles have you reported? This includes cancelled cycles."
        },
        "other": {
          "title": "Other treatment",
          "timed_intercourse_details": "Timed intercourse details",
          "unknown_treatment_details": "Treatment details you do not know",
          "subtitle": "Add any details",
          "name_label": "Treatment name",
          "name_placeholder": "Name (optional)",
          "date_label": "Treatment date",
          "date_placeholder": "Date (optional)",
          "notes_label": "Notes",
          "notes_placeholder": "Notes (optional)"
        },
        "complete_subtitle": "You have finished your fertility treatments questions",
        "save_error": "We couldn't save these treatment records. Your answers are still here — try again."
      },
      "infertility": {
        "diagnosis_title": "Have you been diagnosed with infertility?",
        "diagnosis_subtitle": "According to any tests provided by a professional.",
        "diagnosis_art_needed": "No, but I need ART to screen embryos",
        "cause_title": "What was the cause of infertility?",
        "cause_subtitle": "You can select multiple answers.",
        "cause": {
          "tubal_causes": "Tubal\npathology",
          "ovulation_disorders": "Ovulatory\ndisorder",
          "uterus_anomalies": "Uterus\nanomalies",
          "endometriosis": "Endometriosis",
          "premature_ovarian_insufficiency": "Premature\nOvarian Insufficiency",
          "production": "Low sperm\nproduction",
          "anatomical": "Varicocele /\nanatomical",
          "functional": "Motility /\nfunctional",
          "endocrine": "Endocrine\n(thyroid, hormonal...)",
          "genetics": "Genetic",
          "psychosexual": "Psychosexual",
          "unexplained_infertility": "Unexplained\n(idiopathic)",
          "other": "Other"
        },
        "cause_other_title": "You've selected other, please provide us any additional info about it",
        "cause_other_label": "Other cause details",
        "cause_other_placeholder": "Feel free to write anything",
        "partner_diagnosis_title": "Has your partner been diagnosed with infertility?",
        "partner_diagnosis_subtitle": "If yes, share anything you know about their diagnosis below.",
        "partner_details_label": "Can you tell us more about your partner's infertility?",
        "partner_details_placeholder": "Share anything you know about their diagnosis, tests, or treatment.",
        "complete_subtitle": "You have finished your infertility diagnosis questions"
      },
      "past_cycles": {
        "back": "Back to medical history",
        "title": "Past Cycles",
        "add_cycle": "add a cycle",
        "empty": "No cycles added yet",
        "treatment": {
          "ivf": "IVF/ICSI",
          "iui": "IUI",
          "fet": "FET",
          "meds_only": "OI",
          "egg_freezing": "Egg Freeze",
          "embryo_freezing": "Embryo Freeze",
          "sperm_freezing": "Sperm Freeze",
          "other": "Other",
          "default": "Treatment"
        },
        "action": {
          "embryo_details": "embryo details",
          "exam": "exam",
          "medications": "medications",
          "exams": "exams",
          "transfer": "transfer",
          "document": "document",
          "sperm_source": "sperm source",
          "egg_details": "egg details",
          "details": "details"
        }
      }
    },
    "gynae": {
      "menstrual_health": {
        "cycle_status_title": "Do any of these apply to you?",
        "cycle_status_subtitle": "Select the option that best describes your cycle.",
        "continue": "Continue",
        "cycle_status": {
          "regular_cycle": "I have a regular cycle",
          "irregular_cycle": "I have an irregular cycle",
          "no_longer_have_period": "I no longer have my period",
          "never_had_period": "I've never had a period",
          "no_period_due_to_contraception": "No period due to contraception"
        },
        "cycle_details_title": "Cycle details",
        "cycle_details_subtitle": "Tell us about your average cycle length and flow.",
        "min_cycle_length_label": "Min cycle length (days)",
        "max_cycle_length_label": "Max cycle length (days)",
        "flow_intensity_label": "Usual flow intensity",
        "flow_intensity": {
          "light": "Light",
          "medium": "Medium",
          "heavy": "Heavy"
        },
        "last_3_periods_title": "Your last 3 periods",
        "last_3_periods_subtitle": "Enter any dates you know. We'll estimate your cycle length from them.",
        "period_label": "PERIOD ${number}",
        "start_date_placeholder": "Start date",
        "end_date_placeholder": "End date",
        "age_first_period_title": "What age did you get your first period?",
        "age_label": "Age",
        "fertile_window_title": "Are you aware of your fertile window?",
        "fertile_window_subtitle": "Your fertile window is the days in your cycle when pregnancy is most likely.",
        "bleed_outside_period_title": "Do you bleed outside of your period?",
        "symptoms_title": "Tell us anything about your periods",
        "symptoms_subtitle": "Sharing these details may help us identify underlying conditions and tailor your care.",
        "symptoms_details_label": "What would you like us to know about your periods?",
        "symptoms_details_placeholder": "Share any symptoms, patterns, or changes you have noticed.",
        "pain_scale_title": "Pain scale",
        "pain_scale_subtitle": "On a scale of 1-10, how much pain do you experience during your period?",
        "pain_no_pain": "No pain",
        "pain_worst_pain": "Worst pain",
        "pain_medication_title": "Do you take pain medication during your period?",
        "complete_subtitle": "You have finished your menstrual health questions"
      },
      "sexual_health": {
        "continue": "Continue",
        "pap_smear_title": "Have you ever had a pap smear?",
        "pap_smear_subtitle": "A pap smear looks for abnormal cells in your cervix, including signs of infection or cancer.",
        "pap_smear_result_title": "Was the result abnormal?",
        "pap_smear_result_subtitle": "This helps us know whether follow-up procedures may be relevant.",
        "pap_smear_procedures_title": "Have you undergone any of the following procedures as a result of an abnormal pap smear?",
        "pap_smear_procedures_subtitle": "Select all that apply.",
        "select_procedures_label": "SELECT PROCEDURES",
        "pap_smear_procedure": {
          "colposcopy": "Colposcopy",
          "laser_treatment": "Laser treatment",
          "cryotherapy": "Cryosurgery (freezing)",
          "other": "Other"
        },
        "none": "None",
        "pap_smear_procedure_details_title": "Tell us more about your procedures after an abnormal pap smear",
        "pap_smear_procedure_details_subtitle": "Detailed information helps us diagnose and manage your condition effectively.",
        "procedure_date_label": "Procedure date",
        "procedure_date_placeholder": "When did it happen?",
        "notes_label": "Comments or notes",
        "notes_placeholder": "Add any comments and notes",
        "add_another": "Add another ${name}",
        "stds_title": "Have you ever had or been treated for any of the following?",
        "stds_subtitle": "Select all that apply.",
        "select_conditions_label": "SELECT CONDITIONS",
        "std": {
          "syphilis": "Syphilis",
          "gonorrhea": "Gonorrhea",
          "chlamydia": "Chlamydia",
          "hpv": "Genital warts",
          "hepatitis": "Hepatitis",
          "hiv": "HIV",
          "genital_herpes": "Genital herpes",
          "trichomonas_vaginalis": "Trichomonas vaginalis",
          "other": "Other"
        },
        "std_details_title": "Tell us more about your STI",
        "std_details_subtitle": "Detailed information helps us diagnose and manage your condition effectively.",
        "std_other_card_title": "You selected 'Other' — please share more details so we can advise.",
        "other_label": "Other condition",
        "std_other_placeholder": "What was it called?",
        "std_diagnosed_label": "Diagnosis date",
        "std_diagnosed_placeholder": "When was it diagnosed?",
        "treatment_label": "Treatment",
        "std_treatment_placeholder": "If you took a treatment, which one?",
        "std_notes_placeholder": "Any comments and notes",
        "vaginal_infections_title": "Do you suffer from vaginal infections?",
        "vaginal_infections_subtitle": "This includes infections like yeast infections, bacterial vaginosis, or others.",
        "vaginal_infection": {
          "often": "Yes, often",
          "past": "I have had them in the past but not recently",
          "none": "No"
        },
        "vaginal_infection_details_title": "Tell us more about your vaginal infection",
        "vaginal_infection_details_subtitle": "Detailed information helps us diagnose and manage your condition effectively.",
        "vaginal_infection_card_title": "Vaginal infection details",
        "vaginal_infection_description_label": "Infection details",
        "vaginal_infection_description_placeholder": "Please describe your infection",
        "vaginal_infection_start_label": "Start date",
        "vaginal_infection_start_placeholder": "When did the infection begin?",
        "vaginal_infection_notes_label": "Comments or notes",
        "lubricants_title": "Do you use lubricants?",
        "lubricants_subtitle": "Some lubricants can affect sperm movement and fertility.",
        "lubricants_frequency_label": "How often do you use lubricants?",
        "lubricants_name_label": "Which lubricant do you use?",
        "lubricants_name_placeholder": "Lubricant name",
        "frequency": {
          "rarely": "Rarely",
          "sometimes": "Sometimes",
          "often": "Often"
        },
        "painful_intercourse_title": "Is intercourse painful for you?",
        "painful_intercourse_subtitle": "Pain during intercourse can indicate health issues we need to address for proper care.",
        "painful_intercourse_rate_label": "RATE YOUR PAIN FROM 1 TO 10",
        "no_pain": "No pain",
        "worst_pain": "Worst pain",
        "erectile_difficulties_title": "Do you have difficulties with erections?",
        "erectile_difficulties_subtitle": "Erectile difficulties can be linked to underlying health conditions that may affect fertility.",
        "partner_ejaculate_title_afab": "Does your partner ejaculate in your vagina during intercourse?",
        "partner_ejaculate_title_amab": "Do you ejaculate in your partner's vagina during intercourse?",
        "partner_ejaculate_subtitle": "This helps us understand factors that could influence your chances of conception.",
        "partner_ejaculate_frequency_label": "How often?",
        "complete_subtitle": "You have finished your sexual health questions"
      },
      "contraception": {
        "continue": "Continue",
        "usage_title": "Do you use or have you used contraception?",
        "usage_subtitle": "This helps us understand your fertility journey and provide personalised guidance.",
        "methods_title": "Have you used any of these contraception methods?",
        "methods_subtitle": "Select all that apply, or choose None of these.",
        "select_methods_label": "SELECT METHODS",
        "none": "None of these",
        "method": {
          "birth_control_pill": "Birth control pill",
          "female_condom": "Female condom",
          "male_condom": "Male condom",
          "hormonal_iud": "Hormonal IUD",
          "copper_iud": "Copper IUD",
          "contraceptive_implant": "Implant",
          "contraceptive_ring": "Vaginal ring",
          "contraceptive_injection": "Injection",
          "contraceptive_patch": "Patch",
          "spermicide": "Spermicide",
          "female_sterilization": "Tubal ligation",
          "vasectomy": "Vasectomy",
          "withdrawal": "Withdrawal",
          "andro_switch": "Andro-switch",
          "thermal_underwear": "Thermal underwear",
          "contraceptive_slip": "Contraceptive slip",
          "fertility_awareness": "Fertility awareness",
          "abstinence": "Abstinence",
          "foam": "Foam",
          "calendar_method": "Fertility awareness",
          "other": "Other"
        },
        "details_title": "Tell us more about your contraception",
        "details_subtitle": "Details about your contraception help us provide better guidance.",
        "other_card_title": "You selected 'Other' — please provide details",
        "other_label": "Other method",
        "other_placeholder": "What was it called?",
        "name_label": "Brand or method name",
        "name_placeholder": "Brand or method name (e.g. 'Yasmin')",
        "start_date_label": "Start date",
        "start_date_placeholder": "When did you start?",
        "end_date_label": "End date",
        "end_date_placeholder": "When did you stop? (if applicable)",
        "days_till_period_label": "Days until period returned after stopping",
        "days_till_period_placeholder": "Days until period returned after stopping",
        "notes_label": "Comments or notes",
        "notes_placeholder": "Any comments or notes",
        "complete_subtitle": "You have finished your contraception questions"
      },
      "pregnancies": {
        "next": "Next",
        "usage_title": "Have you ever been pregnant?",
        "usage_subtitle": "Including miscarriages and abortions.",
        "details_title": "Your pregnancies",
        "details_subtitle": "How many times have you been pregnant? This includes miscarriages and abortions.",
        "pregnancy_counter_label": "Your pregnancies",
        "pregnancy_counter_description": "How many times have you been pregnant?",
        "pregnancy_card_title": "Pregnancy ${number}",
        "more_details_later": "You will be able to add more details later.",
        "start_date_label": "Start date",
        "start_date_placeholder": "When did this pregnancy start?",
        "outcome_label": "Outcome",
        "outcome_placeholder": "What was the outcome?",
        "delivery_type_label": "Delivery type",
        "delivery_type_placeholder": "What type of delivery?",
        "delivery_date_label": "Delivery date",
        "delivery_date_placeholder": "When was the delivery?",
        "with_current_partner_label": "Current partner",
        "with_current_partner_placeholder": "Was it with your current partner?",
        "notes_label": "Notes",
        "notes_placeholder": "Add any comments and notes",
        "outcome": {
          "live_birth": "Live birth",
          "miscarriage": "Miscarriage",
          "still_birth": "Stillbirth",
          "abortion": "Abortion"
        },
        "delivery_type": {
          "natural": "Natural",
          "c_section": "C-section"
        },
        "complete_subtitle": "You have finished your pregnancy questions"
      }
    },
    "lifestyle": {
      "continue": "Continue",
      "next": "Next",
      "none": "None",
      "diet_supplements": {
        "diet_title": "How would you describe your diet currently?",
        "diet_subtitle": "Select all that apply. Your current diet provides key insights into how it may affect your fertility.",
        "diet_type": {
          "all_round": "All-round diet",
          "vegetarian": "Vegetarian",
          "vegan": "Vegan",
          "food_hypersensitivity": "Hypersensitivity of some food",
          "religious_restriction": "Religious avoidance of some food",
          "lchf_diet": "LCHF-diet",
          "low_gi_food": "Lo-GI-food",
          "other": "Other diet"
        },
        "supplements_title": "Are you currently taking any supplements?",
        "supplements_subtitle": "List any over-the-counter supplements you are currently taking",
        "supplement_type": {
          "folic_acid": "Folic acid",
          "coenzyme_q10": "Co Enzyme Q10",
          "minerals": "Minerals",
          "herbal": "Herbal",
          "other": "Other"
        },
        "details_title": "Some details about the supplements",
        "details_subtitle": "You can add any detail you would like on what you've selected — nothing is mandatory of course, this will just help your doctor",
        "details_card_subtitle": "You will be able to add more details later",
        "start_date_label": "Start Date",
        "start_date_placeholder": "When did you start taking it?",
        "frequency_placeholder": "Describe frequency",
        "frequency_modal_title": "How often do you take it?",
        "frequency": {
          "1_6_times_year": "1-6 times/year",
          "1_time_month": "1 time/month",
          "2_3_times_month": "2-3 times a month",
          "1_2_times_week": "1-2 times/week",
          "3_4_times_week": "3-4 times/week",
          "at_least_5_times_week": "At least 5 times/week"
        },
        "herbal_placeholder": "What type of herbal supplement?",
        "herbal_label": "Herbal supplement",
        "other_supplement_placeholder": "What supplement is it?",
        "other_supplement_label": "Other supplement",
        "notes_placeholder": "Anything else you'd like to add? Brand name, comments etc",
        "notes_label": "Supplement notes",
        "add_another": "Add another supplement",
        "complete_subtitle": "You have finished your diet & supplements questions"
      },
      "exposure": {
        "types_title": "Which kinds of exposure have you experienced?",
        "types_subtitle": "Select all that apply.",
        "details_subtitle": "Tell us more about this exposure.",
        "details_default_title": "Exposure",
        "exposure_type": {
          "chemicals": "Chemicals",
          "x_rays": "X-rays",
          "agricultural_area": "Agricultural areas",
          "nuclear": "Nuclear sources",
          "toxins": "Toxins",
          "prolonged_heat": "Prolonged heat",
          "other_exposure": "Other"
        },
        "exposure_frequency": {
          "less_1_a_year": "Less than once a year",
          "less_1_a_month": "Less than once a month",
          "1_a_month": "Once a month",
          "2-3_a_month": "2-3 times a month",
          "1_a_week": "Once a week",
          "2-3_a_week": "2-3 times a week",
          "4-6_a_week": "4-6 times a week",
          "everyday": "Every day"
        },
        "frequency_label": "FREQUENCY",
        "frequency_placeholder": "Select frequency",
        "context_label": "CONTEXT",
        "context_placeholder": "Where or in what context does this happen?",
        "other_label": "EXPOSURE TYPE",
        "other_placeholder": "What kind of exposure?",
        "complete_subtitle": "You have finished your exposure questions"
      },
      "sleep_activity": {
        "sleep_title": "How many hours a night do you usually sleep?",
        "sleep_subtitle": "Past month average",
        "activity_title": "Do you exercise?",
        "activity_subtitle": "This includes any sports, gym workouts, or regular physical activities you participate in",
        "activity_slider_label": "How many hours a week do you typically exercise?",
        "complete_title": "Great!",
        "complete_subtitle": "You have finished your sleep & activity questions"
      },
      "substances": {
        "intro_title": "Do you currently use any stimulants or substances?",
        "intro_subtitle": "This includes alcohol, nicotine, cannabis, and more.",
        "select_title": "Which substances do you use?",
        "select_subtitle": "Select all that apply.",
        "substance_type": {
          "alcohol": "Alcohol",
          "coffee": "Coffee",
          "cigarettes": "Cigarettes",
          "vape": "Vapes",
          "snus": "Snus",
          "cannabis": "Cannabis",
          "cbd": "CBD",
          "cocaine": "Cocaine",
          "hookah": "Hookah",
          "other": "Other"
        },
        "substance_frequency": {
          "yearly_or_less": "Yearly or less",
          "monthly_or_less": "Monthly or less",
          "weekly_or_less": "Weekly or less",
          "daily": "Daily",
          "stopped": "I stopped"
        },
        "details_subtitle": "Share a bit more so we can tailor recommendations.",
        "frequency_label": "FREQUENCY",
        "frequency_placeholder": "Select frequency",
        "quantity_placeholder": "Enter a number",
        "notes_placeholder": "Add a few details",
        "start_date_label": "START DATE",
        "start_date_placeholder": "When did you start?",
        "stop_date_label": "STOP DATE",
        "stop_date_placeholder": "If you stopped, when was that?",
        "other_label": "SUBSTANCE TYPE",
        "other_placeholder": "Which substance is this?",
        "substance_title": {
          "alcohol": "Alcohol",
          "coffee": "Coffee",
          "cigarettes": "Cigarettes",
          "vape": "Vapes",
          "snus": "Snus",
          "cannabis": "Cannabis",
          "cbd": "CBD",
          "cocaine": "Cocaine",
          "hookah": "Hookah",
          "other": "Other substances"
        },
        "substance_context_label": {
          "alcohol": "What kind of drinks or occasions?",
          "coffee": "What type of coffee or energy drinks?",
          "cigarettes": "Any specific brand or strength?",
          "vape": "What devices or liquids do you use?",
          "snus": "Brand or format?",
          "cannabis": "What form do you use (flower, edibles, etc.)?",
          "cbd": "What kind of CBD products?",
          "cocaine": "What is the typical setting?",
          "hookah": "Where do you usually smoke?",
          "other": "What substance is this?"
        },
        "substance_quantity_label": {
          "alcohol": "How many drinks on a typical day?",
          "coffee": "How many cups per day?",
          "cigarettes": "How many per day?",
          "vape": "How many puffs or cartridges per day?",
          "snus": "How many portions per day?",
          "cannabis": "How often per session?",
          "cbd": "What dose per day?",
          "cocaine": "How much per session?",
          "hookah": "How many sessions per week?",
          "other": "How often and how much?"
        },
        "complete_title": "Great!",
        "complete_subtitle": "Your substance use details are saved."
      }
    },
    "medical": {
      "shared": {
        "next": "Next",
        "continue": "Continue",
        "none": "None",
        "other": "Other",
        "remove": "Remove",
        "delete": "Delete"
      },
      "allergies": {
        "intro_title": "Are you allergic to any medications?",
        "intro_subtitle": "This helps us understand your medical history and avoid potential reactions",
        "details_title": "What medications are you allergic to?",
        "details_subtitle": "You can add the name of a brand or a specific chemical",
        "medication_allergy_label": "Medication Allergy ${index}",
        "name_placeholder": "Medication name or chemical",
        "comments_placeholder": "Add any comments or details",
        "add_another": "Add another medication allergy",
        "complete_subtitle": "You have finished your allergies questions"
      },
      "disease_history": {
        "breast_testing": {
          "title": "Have you done any of the following tests?",
          "subtitle": "You can select multiple answers",
          "section_label": "TEST HISTORY",
          "test_types": {
            "mammogram": "Mammogram",
            "breast_ultrasound": "Breast ultrasound",
            "breast_tomosynthesis": "Breast tomosynthesis",
            "breast_mri": "Breast MRI",
            "clinical_breast_exam": "Clinical Breast exam",
            "other": "Others"
          },
          "details_title": "Add test details",
          "details_subtitle": "Upload a copy of your exam results if you have one.",
          "result_label": "RESULT ${index}",
          "other_section_label": "OTHER",
          "other_name_label": "Test name",
          "other_name_placeholder": "What is the name of this test?",
          "exam_date_label": "Exam Date",
          "exam_date_placeholder": "What date was this exam done?",
          "outcome_label": "Exam outcome",
          "outcome_placeholder": "What was the exam outcome?",
          "notes_label": "Test notes",
          "notes_placeholder": "Type notes about this test",
          "add_another_result": "Add another ${label} result"
        },
        "breast_conditions": {
          "title": "Are you experiencing any of the following breast symptoms",
          "subtitle": "You can select multiple answers",
          "section_label": "SELECT SYMPTOMS",
          "condition_types": {
            "discharge": "Discharge",
            "pain": "Pain",
            "other": "Others"
          }
        },
        "breast_symptom_other": {
          "title": "Other",
          "subtitle": "You've selected other, please provide us any additional info about it",
          "label": "Other breast symptom",
          "placeholder": "Feel free to write anything"
        },
        "cancer_history": {
          "title": "Have you ever been diagnosed with cancer?",
          "subtitle": "You will be able to add details about your diagnosis"
        },
        "cancer_details": {
          "title": "Tell us about your cancer diagnosis",
          "subtitle": "Add details for each cancer diagnosis",
          "card_label": "CANCER",
          "card_label_indexed": "CANCER ${index}",
          "type_label": "Cancer type",
          "type_placeholder": "Type of cancer",
          "diagnosis_date_label": "Diagnosis Date",
          "diagnosis_date_placeholder": "When were you diagnosed?",
          "remission_label": "Remission status",
          "remission_placeholder": "Are you in remission?",
          "add_another": "Add another cancer diagnosis",
          "cancer_fallback": "Cancer ${index}"
        },
        "cancer_treatments": {
          "title": "What treatments have you received?",
          "subtitle": "You can select multiple answers",
          "cancer_label": "CANCER ${index}",
          "treatment_types": {
            "surgery": "Surgery",
            "chemotherapy": "Chemotherapy",
            "radiation_therapy": "Radiation Therapy",
            "bone_marrow_transplant": "Bone Marrow Transplant",
            "immunotherapy": "Immunotherapy",
            "hormone_therapy": "Hormone Therapy",
            "targeted_drug_therapy": "Targeted Drug Therapy",
            "radiofrequency_therapy": "Radiofrequency Therapy",
            "other": "Other"
          }
        },
        "cancer_treatment_details": {
          "title": "Tell us more about your treatments",
          "subtitle": "Add details for each treatment you've received",
          "other_section_label": "OTHER",
          "other_name_label": "Treatment name",
          "other_name_placeholder": "What is the name of this treatment?",
          "start_label": "Treatment Start",
          "start_placeholder": "When did treatment start?",
          "end_label": "Treatment End",
          "end_placeholder": "When did treatment end?",
          "notes_label": "Treatment notes",
          "notes_placeholder": "Type notes about this treatment",
          "add_another": "Add another treatment"
        },
        "disease_categories": {
          "title": "Do you have a history of any of the following conditions?",
          "subtitle": "You can select multiple answers",
          "section_label": "DISEASE CATEGORIES",
          "categories": {
            "endocrine": "Endocrine",
            "infectious": "Infectious",
            "cardiovascular": "Cardiovascular",
            "respiratory": "Respiratory",
            "gastrointestinal": "Gastrointestinal",
            "hepatic_biliary": "Hepatic & Biliary",
            "renal_urinary": "Renal & Urinary",
            "musculoskeletal": "Musculoskeletal",
            "hematological": "Hematological",
            "autoimmune": "Autoimmune",
            "genetic": "Genetic",
            "eating_disorders": "Eating Disorders",
            "neurological_mental_health": "Neurological & Mental Health"
          },
          "category_questions": {
            "endocrine": "Do any of the following endocrine disorders or symptoms apply to you?",
            "infectious": "Do any of the following infectious diseases apply to you?",
            "cardiovascular": "Do any of the following cardiovascular diseases apply to you?",
            "respiratory": "Do any of the following respiratory diseases apply to you?",
            "gastrointestinal": "Do any of the following gastrointestinal diseases apply to you?",
            "hepatic_biliary": "Do any of the following Hepatic and biliary disorders apply to you?",
            "renal_urinary": "Do any of the following Renal and Urinary disorders apply to you?",
            "musculoskeletal": "Do any of the following Musculoskeletal disorders apply to you?",
            "hematological": "Do any of the following Haematological disorders apply to you?",
            "autoimmune": "Do any of the following Autoimmune diseases apply to you?",
            "genetic": "Do any of the following Genetic diseases apply to you?",
            "eating_disorders": "Do any of the following eating disorders apply to you?",
            "neurological_mental_health": "Do any of the following Neurological and Mental Health disorders apply to you?"
          }
        },
        "diseases": {
          "endocrine": {
            "diabetes": "Diabetes",
            "pcos": "PMOS (ex PCOS)",
            "thyroid_disease": "Thyroid Disease",
            "excessive_body_or_facial_hair": "Excessive Body/Facial Hair",
            "hair_loss": "Hair Loss",
            "rapid_weight_gain_or_loss": "Rapid Weight Change",
            "temperature_intolerance": "Temperature Intolerance",
            "excessive_hunger_or_thirst": "Excessive Hunger/Thirst",
            "hypothalamic_pituitary": "Hypothalamic Pituitary",
            "hyperthyroidism_failure": "Hyperthyroidism",
            "primary_ovarian_insufficiency": "Primary Ovarian Insufficiency",
            "diminished_ovarian_reserve": "Diminished Ovarian Reserve",
            "other": "Other"
          },
          "infectious": {
            "rubella": "Rubella",
            "chicken_pox": "Chicken Pox",
            "measles": "Measles",
            "mumps": "Mumps",
            "rheumatic_fever": "Rheumatic Fever",
            "covid_19": "COVID-19",
            "other": "Other"
          },
          "cardiovascular": {
            "elevated_blood_pressure": "Elevated Blood Pressure",
            "blood_clots": "Blood Clots",
            "heart_murmur": "Heart Murmur",
            "mitral_valve_prolapse": "Mitral Valve Prolapse",
            "stroke": "Stroke",
            "other": "Other"
          },
          "respiratory": {
            "lung_disease": "Lung Disease",
            "asthma": "Asthma",
            "seizures": "Seizures",
            "other": "Other"
          },
          "gastrointestinal": {
            "irritable_bowel_syndrome": "IBS",
            "frequent_nausea_vomiting": "Frequent Nausea/Vomiting",
            "blood_in_stool": "Blood in Stool",
            "frequent_diarrhea": "Frequent Diarrhea",
            "other": "Other"
          },
          "hepatic_biliary": {
            "liver_disease": "Liver Disease",
            "gallbladder_disease": "Gallbladder Disease",
            "other": "Other"
          },
          "renal_urinary": {
            "kidney_issues": "Kidney Issues",
            "frequent_urination": "Frequent Urination",
            "bladder_infection": "Bladder Infection",
            "blood_in_urine": "Blood in Urine",
            "frequent_urinary_tract_infections": "Frequent UTIs",
            "other": "Other"
          },
          "musculoskeletal": {
            "arthritis": "Arthritis",
            "gout": "Gout",
            "fibrodysplasia_ossificans_progressiva": "Fibrodysplasia Ossificans",
            "malignant_hyperthermia": "Malignant Hyperthermia",
            "other": "Other"
          },
          "hematological": {
            "easy_bruising": "Easy Bruising",
            "sickle_cell_anemia": "Sickle Cell Anemia",
            "other": "Other"
          },
          "autoimmune": {
            "lupus": "Lupus",
            "rheumatoid_arthritis": "Rheumatoid Arthritis",
            "multiple_sclerosis": "Multiple Sclerosis",
            "vitiligo": "Vitiligo",
            "crohns_disease": "Crohn's Disease",
            "other": "Other"
          },
          "genetic": {
            "klinefelter_syndrome": "Klinefelter Syndrome",
            "noonan_syndrome": "Noonan Syndrome",
            "cftr": "CFTR",
            "y_chromosome_microdeletions": "Y Chromosome Microdeletions",
            "other": "Other"
          },
          "eating_disorders": {
            "bulimia": "Bulimia",
            "anorexia": "Anorexia",
            "orthorexia": "Orthorexia",
            "binge_eating_disorder": "Binge Eating",
            "rumination_disorder": "Rumination Disorder",
            "other": "Other"
          },
          "neurological_mental_health": {
            "anxiety": "Anxiety",
            "depression": "Depression",
            "bipolar_disorder": "Bipolar Disorder",
            "schizophrenia": "Schizophrenia",
            "endometriosis": "Endometriosis",
            "other": "Other"
          }
        },
        "disease_details": {
          "title": "Tell us more about your conditions",
          "subtitle": "Add details for each condition you selected",
          "other_section_label": "OTHER",
          "other_name_label": "Condition name",
          "other_name_placeholder": "What is the name of this condition?",
          "diagnosis_date_label": "Diagnosis Date",
          "diagnosis_date_placeholder": "When were you diagnosed?",
          "treatment_label": "Treatment received",
          "treatment_placeholder": "What treatment have you received?"
        },
        "disease_other": {
          "title": "Other conditions",
          "subtitle": "Please provide details about your other conditions",
          "label": "Other condition details",
          "placeholder": "Describe your other ${category} condition"
        },
        "select_conditions_fallback": "Select conditions",
        "complete_subtitle": "You have finished the diseases & checkups questions"
      },
      "medications_vaccines": {
        "intro_title": "Do you currently take any medications?",
        "products_title": "Do you use any of the products below?",
        "products_subtitle": "You can select multiple answers",
        "medication_products": {
          "nose_drops": "Nose drops",
          "cold_medicine": "Cold medicine",
          "diuretics": "Diuretics",
          "pain_relief": "Pain or inflammation relief",
          "relaxants": "Relaxants",
          "sleeping_pills": "Sleeping pills",
          "allergy_medication": "Allergy medication",
          "nicotine_subs": "Nicotine subs & anti smoking products",
          "other": "Other",
          "none": "None"
        },
        "other_medication_placeholder": "Please specify or enter more details",
        "other_medication_label": "Other medication or details",
        "medication_details_title": "Tell us more about the medications you are taking",
        "medication_name_required_other_details_optional": "Add the medication name; other details are optional.",
        "medication_card_fallback": "Medication",
        "medication_name_label": "Medication name or brand",
        "medication_name_placeholder": "Medication name or brand",
        "frequency_label": "Frequency",
        "frequency_placeholder": "Describe frequency",
        "comments_label": "Comments or details",
        "comments_placeholder": "Add any comments or details",
        "add_another_medication": "Add another medication",
        "vaccines_title": "Select the vaccines you have received",
        "vaccines_subtitle": "You can select multiple answers",
        "vaccine_options": {
          "hpv": "HPV",
          "covid19": "Covid 19",
          "chicken_pox": "Chicken Pox",
          "tetanus": "Tetanus",
          "polio": "Polio",
          "influenza": "Influenza",
          "mmr": "Measles, mumps & rubella",
          "hepatitis_a": "Hepatitis A",
          "hepatitis_b": "Hepatitis B",
          "other": "Other",
          "none": "None"
        },
        "other_vaccine_placeholder": "Please specify or enter more details",
        "other_vaccine_label": "Other vaccine or details",
        "vaccine_details_title": "Tell us more about your vaccine",
        "vaccine_details_subtitle": "No information is mandatory",
        "vaccine_card_fallback": "Vaccine",
        "vaccine_card_title": "${label} details",
        "date_received_label": "Date received",
        "date_label": "Date",
        "date_placeholder": "Do you remember when?",
        "brand_label": "Vaccine brand",
        "brand_placeholder": "Which vaccine brand was it?",
        "notes_label": "Comments or notes",
        "notes_placeholder": "Add any comments and notes",
        "add_another_vaccine": "Add another vaccine",
        "complete_subtitle": "You have finished your medications & vaccines questions"
      },
      "surgeries": {
        "title": "Have you had any surgeries?",
        "subtitle": "You can select multiple answers",
        "section_label": "SURGICAL HISTORY",
        "never_had_surgery": "I've never had a surgery",
        "surgery_types": {
          "tubal_ligation": "Tubal Ligation",
          "salpingectomy": "Salpingectomy",
          "operative_laparoscopy": "Operative Laparoscopy",
          "myomectomy": "Myomectomy",
          "operative_hysteroscopy": "Operative Hysteroscopy",
          "varicocelectomy": "Varicocelectomy",
          "orchiopexy": "Orchiopexy",
          "vasectomy": "Vasectomy",
          "other": "Other"
        },
        "details_title": "Tell us more about your procedures",
        "details_subtitle": "Details help us assess the procedures' impact on your fertility",
        "other_card_label": "YOU SELECTED 'OTHER' FOR SURGERIES",
        "card_label": "${label} DETAILS",
        "other_name_placeholder": "What was the name of the surgery?",
        "other_name_label": "Surgery name",
        "procedure_date_label": "Procedure Date",
        "procedure_date_placeholder": "When have you done this procedure?",
        "comments_placeholder": "Add any comments and notes",
        "comments_label": "Comments or notes",
        "complete_subtitle": "You have finished your surgical history questions"
      }
    },
    "complete": {
      "title_default": "Your answers are saved",
      "secondary_subtitle_default": "You can add or update details whenever you need to.",
      "recap_label": "What we heard",
      "insight_label": "Why this helps",
      "button_label_default": "Finish",
      "submitting_label_default": "Saving…",
      "back_to_medical_history": "Back to medical history",
      "local_answers_notice": "This section is complete here, but Medical History changes are not ready to share until syncing finishes.",
      "next_section_prefix": "Let's move to ${section}",
      "next_section": {
        "basicInfo": "about you",
        "infertility": "infertility diagnosis",
        "fertilityTesting": "fertility testing",
        "fertilityTreatments": "fertility treatments",
        "menstrualHealth": "menstrual health",
        "sexualHealth": "sexual health",
        "contraception": "contraception",
        "pregnancy": "pregnancies",
        "medicationsVaccines": "medications & vaccines",
        "allergies": "allergies",
        "diseaseHistory": "diseases & checkups",
        "surgeries": "surgeries",
        "exposure": "exposure",
        "substances": "substances",
        "sleepActivity": "sleep & activity",
        "dietSupplements": "diet & supplements",
        "familyHistory": "family history"
      }
    },
    "medical_history_card": {
      "tagline": "Start answering",
      "title": "Medical History",
      "subtitle": "Complete the sections & help your doctor to optimise your fertility journey!"
    },
    "overview": {
      "insight_start_basics": "Start with basics — clinics use this to personalize your care",
      "insight_great_start": "Great start — the more you share, the better your care plan",
      "insight_drug_interactions": "Drug interactions can now be checked against your profile",
      "insight_test_results": "Your test results help match you with the right protocols",
      "insight_profile_powerful": "${completed} of ${total} sections done — your profile is becoming powerful",
      "recap_age": "Age ${age}",
      "recap_no_diagnosis": "No diagnosis reported",
      "recap_test_results_one": "${count} test result recorded",
      "recap_test_results_other": "${count} test results recorded",
      "recap_no_test_results": "No test results yet",
      "recap_cycles_one": "${count} cycle: ${types}",
      "recap_cycles_other": "${count} cycles: ${types}",
      "recap_no_treatments": "No treatments recorded",
      "recap_pain_scale": "pain ${value}/10",
      "recap_pap_done": "Pap smear done",
      "recap_std_history": "STD history",
      "recap_no_std": "No STD history",
      "recap_no_contraception": "No contraception history",
      "recap_pregnancies_one": "${count} pregnancy recorded",
      "recap_pregnancies_other": "${count} pregnancies recorded",
      "recap_no_pregnancies": "No pregnancies",
      "recap_medications_one": "${count} medication",
      "recap_medications_other": "${count} medications",
      "recap_no_medications": "No medications",
      "recap_vaccines_one": "${count} vaccine",
      "recap_vaccines_other": "${count} vaccines",
      "recap_no_allergies": "No known allergies",
      "recap_conditions_one": "${count} condition reported",
      "recap_conditions_other": "${count} conditions reported",
      "recap_no_conditions": "No conditions reported",
      "recap_no_surgeries": "No surgeries",
      "recap_no_exposures": "No exposures",
      "recap_no_substances": "No substances",
      "recap_sleep_hours": "${min}–${max}h sleep",
      "recap_exercises_regularly": "Exercises regularly",
      "recap_not_exercising": "Not exercising",
      "recap_supplements_one": "${count} supplement",
      "recap_supplements_other": "${count} supplements",
      "recap_adopted": "Adopted",
      "recap_gamete_donation": "Gamete donation",
      "back": "Back",
      "header_title": "(hi)story",
      "header_blurb": "Answer your history and add records to unlock better care guidance.",
      "complete_badge": "Complete",
      "xp_badge": "${xp} XP",
      "level_badge": "Lv.${level} — ${title}",
      "level": {
        "newcomer": "Newcomer",
        "getting_started": "Getting Started",
        "health_explorer": "Health Explorer",
        "wellness_pro": "Wellness Pro",
        "health_champion": "Health Champion"
      },
      "group": {
        "basic": "Basic Info",
        "fertility": "Fertility & Testing",
        "gynae": "Gynae & Obstetrics",
        "gynae_male": "Sexual & Reproductive Health",
        "medical": "Medical History",
        "lifestyle": "Lifestyle",
        "family_history": "Family History"
      },
      "row": {
        "basic_info": "About You",
        "infertility": "Infertility Diagnosis",
        "fertility_testing": "Fertility Testing",
        "fertility_treatments": "Fertility Treatment",
        "menstrual_health": "Menstrual Health",
        "sexual_health": "Sexual Health",
        "contraception": "Contraception",
        "pregnancies": "Pregnancies",
        "medications_vaccines": "Medications & Vaccines",
        "allergies": "Allergies",
        "diseases": "Diseases & Checkups",
        "surgeries": "Surgeries",
        "exposure": "Exposure",
        "substances": "Substances",
        "sleep_activity": "Sleep & Activity",
        "diet_supplements": "Diet & Supplements",
        "family_history": "Ancestry & Family"
      },
      "hero_complete_local_title": "Your Medical History is complete on this device",
      "hero_complete_local_summary": "Louise is still saving local changes before this history is ready to use or share with providers.",
      "sync_status": {
        "title_checking": "Checking saved changes…",
        "title_saving": "Saving changes…",
        "title_session_changed": "Your patient session changed",
        "title_needs_attention": "Some changes need your attention",
        "title_retained": "An answer remains on this device",
        "title_not_synced": "Not synced yet",
        "title_saved": "All changes saved",
        "detail_undurable_one": "${count} change is still open here while Louise retries secure storage. Keep this screen open.",
        "detail_undurable_other": "${count} changes are still open here while Louise retries secure storage. Keep this screen open.",
        "detail_storage_error": "Louise could not check saved changes on this device yet. It will retry automatically.",
        "detail_checking": "Louise is restoring any changes kept safely on this device.",
        "detail_saving": "You can keep going while Louise syncs in the background.",
        "detail_failed_identity": "The answer remains safely on this device, but it belongs to a patient session that is no longer available. Sign in again before retrying it. Dismissing this warning will not delete the answer.",
        "detail_failed_visible": "The answer remains visible. Retry it or open its section to edit it. Dismissing this warning will not delete the answer.",
        "detail_failed_retained": "The answer is still retained here. Open its section to edit it or retry when ready.",
        "detail_pending_one": "${count} change is safe on this device. Louise will retry automatically.",
        "detail_pending_other": "${count} changes are safe on this device. Louise will retry automatically.",
        "detail_saved": "Your Medical History is up to date.",
        "acceptance_failed": "This change could not be kept on this device. Try again.",
        "accessibility_status": "Medical History sync status: ${title}",
        "accessibility_saving": "Saving Medical History changes",
        "retry": "Retry",
        "accessibility_retry": "Retry this Medical History change",
        "action_failed": "That didn't work just now. The answer is still safely on this device — try again.",
        "edit_section": "Edit ${section}",
        "dismiss": "Dismiss warning",
        "accessibility_dismiss": "Dismiss this Medical History sync warning"
      },
      "progress_card": {
        "title": "Medical History",
        "blurb": "A complete history unlocks treatment personalisation, medication safety checks, risk-factor screening, and clinic-ready summaries.",
        "level_xp": "${level} · ${xp} XP",
        "start": "Start",
        "accessibility_start": "Start medical history",
        "continue": "Continue",
        "accessibility_continue": "Continue medical history",
        "accessibility_open_category": "Open ${title}"
      }
    },
    "question_screen": {
      "default_caption": "About you",
      "help_accessibility_label": "Why we ask this",
      "files_added": "Files added",
      "file_ready": "Added to your medical history",
      "flow_help": {
        "basic-info": "These questions help us understand your baseline health and show the parts of your history that are relevant to you.",
        "infertility": "These questions help us understand fertility diagnoses and possible causes so your care team can plan next steps.",
        "fertility-testing": "These questions help us organize your fertility test history and connect results to your care.",
        "fertility-treatments": "These questions help us understand treatments you have tried and how they shaped your fertility journey.",
        "menstrual-health": "These questions help us understand your cycle patterns, symptoms, and timing.",
        "sexual-health": "These questions help us understand sexual and reproductive factors that may affect your care.",
        "contraception": "These questions help us understand past and current contraception and its context.",
        "pregnancies": "These questions help us understand pregnancy history, outcomes, and details relevant to your care.",
        "medications-vaccines": "These questions help us keep medication and vaccination information visible for safer care.",
        "allergies": "These questions help us record allergies so your care team can avoid known reactions.",
        "diseases": "These questions help us capture conditions and checkups that may affect your fertility and overall care.",
        "surgeries": "These questions help us record procedures and details that may affect your reproductive health.",
        "exposure": "These questions help us understand environmental exposures that may be relevant to fertility and health.",
        "substances": "These questions help us understand substance use so guidance can reflect your context.",
        "sleep-activity": "These questions help us understand sleep and activity patterns that can shape your wellbeing.",
        "diet-supplements": "These questions help us understand diet and supplements that may interact with your care.",
        "family-history": "These questions help us understand inherited risks and patterns in your family history."
      }
    },
    "review": {
      "section_title": {
        "basic-info": "About You",
        "infertility": "Infertility Diagnosis",
        "fertility-testing": "Fertility Testing",
        "fertility-treatments": "Fertility Treatments",
        "menstrual-health": "Menstrual Health",
        "sexual-health": "Sexual Health",
        "contraception": "Contraception",
        "pregnancies": "Pregnancies",
        "medications-vaccines": "Medications & Vaccines",
        "allergies": "Allergies",
        "diseases": "Diseases & Checkups",
        "surgeries": "Surgeries",
        "exposure": "Exposure",
        "substances": "Substances",
        "sleep-activity": "Sleep & Activity",
        "diet-supplements": "Diet & Supplements",
        "family-history": "Family History"
      },
      "item": {
        "sex_at_birth": "Sex at birth",
        "female": "Female",
        "male": "Male",
        "date_of_birth": "Date of birth",
        "height": "Height",
        "weight": "Weight",
        "been_pregnant_before": "Been pregnant before",
        "endometriosis": "Endometriosis",
        "pcos": "PMOS (ex PCOS)",
        "pcos_diagnosed": "Diagnosed",
        "pcos_suspected": "Suspected",
        "varicocele": "Varicocele",
        "cancer_history": "Cancer history",
        "allergies": "Allergies",
        "no_known_allergies": "No known allergies",
        "unknown_allergy_name": "Unknown",
        "currently_taking_medications": "Currently taking medications",
        "infertility_diagnosis": "Infertility diagnosis",
        "infertility_yes_diagnosed": "Yes, diagnosed",
        "infertility_art_carrier": "ART needed to screen embryos",
        "causes": "Causes",
        "partner_infertility": "Partner infertility",
        "partner_details": "Partner infertility details",
        "test_results": "Test results",
        "no_test_results": "No test results recorded",
        "test_n": "Test ${n}",
        "treatments": "Treatments",
        "no_treatments": "No treatments recorded",
        "treatment": "Treatment",
        "treatment_n": "${name} #${n}",
        "cycle_status": "Cycle status",
        "cycle_length": "Cycle length",
        "cycle_length_days": "${count} days",
        "flow_intensity": "Usual flow intensity",
        "period_length": "Period length",
        "period_length_days": "${count} days",
        "pain_scale": "Pain scale",
        "pain_scale_value": "${value}/10",
        "period_details": "Period details",
        "last_periods_tracked": "Last periods tracked",
        "periods_recorded_one": "${count} period recorded",
        "periods_recorded_other": "${count} periods recorded",
        "had_pap_smear": "Had a pap smear",
        "pap_smear_result_abnormal": "Pap smear result abnormal",
        "abnormal_pap_smear_procedures": "Pap smear follow-up procedures",
        "std_history": "STD history",
        "vaginal_infections": "Vaginal infections",
        "painful_intercourse": "Painful intercourse",
        "uses_lubricant": "Uses lubricant",
        "partner_ejaculates_in_vagina": "Partner ejaculates in vagina",
        "self_ejaculates_in_partner_vagina": "You ejaculate in your partner's vagina",
        "erectile_difficulties": "Erectile difficulties",
        "contraception_history": "Contraception history",
        "no_contraception_history": "No contraception history",
        "contraception_methods": "Contraception methods",
        "method_n": "Method ${n}",
        "pregnancy_history": "Pregnancy history",
        "no_pregnancies": "No pregnancies",
        "pregnancies": "Pregnancies",
        "pregnancy_n": "Pregnancy ${n}",
        "medication": "Medication",
        "vaccine": "Vaccine",
        "vaccinations": "Vaccinations",
        "disease_history": "Disease history",
        "no_conditions_reported": "No conditions reported",
        "condition": "Condition",
        "surgical_history": "Surgical history",
        "no_surgeries": "No surgeries",
        "has_surgeries": "Has surgeries",
        "surgery": "Surgery",
        "environmental_exposures": "Environmental exposures",
        "no_exposures_reported": "No exposures reported",
        "has_exposures": "Has exposures",
        "exposure": "Exposure",
        "substance_use": "Substance use",
        "no_substances_reported": "No substances reported",
        "uses_substances": "Uses substances",
        "substance": "Substance",
        "hours_of_sleep": "Hours of sleep",
        "hours_of_sleep_range": "${min}–${max} hours",
        "exercises_regularly": "Exercises regularly",
        "exercise_type": "Exercise type",
        "exercise_frequency": "Exercise frequency",
        "diet": "Diet",
        "supplement": "Supplement",
        "diet_and_supplements": "Diet & supplements",
        "no_diet_supplements_recorded": "No diet or supplements recorded",
        "taking": "Taking",
        "has_allergies": "Has allergies",
        "ancestry": "Ancestry",
        "dna_test": "DNA test",
        "adoption_status": "Adoption",
        "family_infertility": "Family fertility issues",
        "des_exposure": "DES exposure",
        "no_family_history_recorded": "No family history recorded"
      }
    },
    "components": {
      "form_fields": {
        "result_n": "Result ${n}",
        "test_name_placeholder": "What was tested?",
        "value_placeholder": "Lab result",
        "add_another": "Add another lab result"
      },
      "file_upload": {
        "uploaded": "UPLOADED",
        "upload_cta": "Upload a copy of document",
        "file_types": "PDF, JPEG or PNG"
      }
    }
  },
  "notifications": {
    "title": "Notifications",
    "unread_badge": "${count} new",
    "mark_all_read": "Mark all as read",
    "try_again": "Try again",
    "load_error": "Couldn't load notifications",
    "empty_title": "No notifications yet",
    "empty_subtitle": "When there is something to review, it will appear here.",
    "all_caught_up": "You're all caught up",
    "badge_ready_title": "A Passport milestone is ready",
    "badge_ready_body": "Open Passport to review this update.",
    "time_upcoming": "Upcoming",
    "time_just_now": "Just now",
    "time_minutes": "${minutes}m ago",
    "time_hours": "${hours}h ago",
    "time_yesterday": "Yesterday",
    "time_days": "${days}d ago"
  },
  "learn": {
    "title": "Learn",
    "subtitle": "Guides & answers for your journey",
    "recommended_for_you": "Recommended for you",
    "encyclopedia": "Encyclopedia",
    "todays_spotlight": "Today's spotlight",
    "back_to_learn": "Learn",
    "section_progress": "${read}/${total} read",
    "article_tags": {
      "guides": "Guides",
      "travel": "Travel",
      "decisions": "Decisions",
      "science": "Science",
      "costs": "Costs",
      "endometriosis": "Endometriosis",
      "pcos": "PMOS (ex PCOS)",
      "thyroid": "Thyroid",
      "clinic": "Clinic",
      "treatment": "Treatment",
      "preparation": "Preparation",
      "egg_freezing": "Egg freezing",
      "lifestyle": "Lifestyle",
      "optimization": "Optimization",
      "emotional_support": "Emotional support",
      "testing": "Testing",
      "practical": "Practical",
      "partners": "Partners",
      "male_fertility": "Male fertility",
      "female_fertility": "Female fertility"
    },
    "filter_chips": {
      "all": "All",
      "guides": "Guides",
      "travel": "Travel",
      "decisions": "Decisions",
      "science": "Science",
      "costs": "Costs",
      "conditions": "Conditions",
      "treatments": "Treatments",
      "lifestyle": "Lifestyle",
      "support": "Support",
      "encyclopedia": "Encyclopedia",
      "saved": "Saved"
    },
    "section_labels": {
      "guides": "Guides",
      "travel": "Travel",
      "decisions": "Decisions",
      "science": "Science & Numbers",
      "costs": "Costs & Coverage",
      "conditions": "Conditions",
      "treatments": "Treatments",
      "lifestyle": "Lifestyle",
      "support": "Support",
      "saved": "Saved"
    },
    "empty_saved_title": "No saved articles yet",
    "empty_saved_subtitle": "Tap the bookmark icon when reading an article",
    "empty_articles_title": "No articles yet",
    "empty_articles_subtitle": "We're adding more content for this topic soon",
    "encyclopedia_cards": {
      "medications_title": "Medications",
      "medications_subtitle": "What they do, how to take them",
      "medications_detail": "Gonadotropins · Triggers · Progesterone · more",
      "procedures_title": "Procedures",
      "procedures_subtitle": "Steps & processes in treatment",
      "procedures_detail": "Stimulation · Retrieval · Transfer · more",
      "tests_title": "Tests & Markers",
      "tests_subtitle": "What's measured & what it means",
      "tests_detail": "AMH · Ultrasound · Bloodwork · more",
      "conditions_title": "Conditions",
      "conditions_subtitle": "Understanding what affects fertility",
      "conditions_detail": "DOR · PMOS (ex PCOS) · Endometriosis · more"
    },
    "ai_assistant": {
      "default_title": "Ask anything",
      "default_subtitle": "Personalized to your journey",
      "default_empty_prompt": "Ask me about fertility treatments, timelines, costs, or anything on your mind.",
      "default_input_placeholder": "What's on your mind?",
      "analysing": "Analysing…",
      "progress": {
        "checking_context": "Checking the context you shared",
        "reviewing_guidance": "Reviewing relevant fertility guidance",
        "preparing_reply": "Preparing a clear reply"
      },
      "info_sheet_title": "About your assistant",
      "info_what_title": "What can I ask?",
      "info_what_body": "Anything about your fertility journey — treatment options, what to expect, how to prepare, costs, timelines, supplements, and more.",
      "info_personalized_title": "Personalized to you",
      "info_personalized_body": "Your assistant has context on your profile, preferences, and where you are in your journey, so answers are relevant to your situation.",
      "info_not_advice_title": "Not medical advice",
      "info_not_advice_body": "This is an educational tool, not a substitute for professional medical guidance. Always consult your doctor before making treatment decisions.",
      "connection_error_title": "Chat unavailable",
      "connection_error_message": "I couldn't reach the chat right now. Try sending your question again.",
      "error_title": "Error",
      "error_message": "Something went wrong: ${message}",
      "error_generic": "Something went wrong"
    },
    "article_reader": {
      "related_articles": "Related articles",
      "continue_reading": "Continue reading"
    },
    "read_time_minutes": "${minutes} min",
    "article_chat_prompt": {
      "just_read_article": "I just read a Louise Learn article and would like to talk it through.",
      "article_line": "Article: ${title}",
      "summary_line": "Article summary: ${teaser}",
      "no_summary": "not provided",
      "key_takeaways_heading": "Key takeaways:",
      "help_me_understand": "Please help me understand the main ideas in plain language, then ask what part I would like to explore or apply to my situation."
    },
    "article_actions": {
      "chat_about_this": "Chat about this",
      "chat_about_this_accessibility": "Chat about this article",
      "saved": "Saved",
      "save_accessibility": "Save article",
      "remove_saved_accessibility": "Remove article from saved",
      "close_accessibility": "Close"
    },
    "disclaimer_medical_info": "This information is for educational purposes only and does not replace medical advice. Always consult your healthcare team about your specific situation.",
    "condition_detail": {
      "section_what_is_it": "What is it",
      "section_symptoms": "Symptoms",
      "section_how_diagnosed": "How it's diagnosed",
      "section_impact_on_fertility": "Impact on fertility",
      "section_prevalence": "Prevalence",
      "section_treatment_options": "Treatment options",
      "section_prognosis": "Prognosis",
      "section_evidence": "Evidence",
      "symptoms_log_hint": "Tap a symptom for details. Use + to log it for today.",
      "for_whom_her": "Her",
      "for_whom_him": "Him",
      "for_whom_both": "Both partners"
    },
    "ai_message_blocks": {
      "thinking": "Thinking…",
      "analyzing": "Analyzing…",
      "reasoning": "Reasoning",
      "what_i_checked": "What I checked",
      "updating": "Updating",
      "sources": "Sources",
      "ask_about_this": "Ask about this",
      "suggested_for_question": "Suggested for this question",
      "buy_now": "Buy now",
      "view_details": "View details",
      "sdk_reasoning_default": "SDK Reasoning",
      "lead_narration": "I'll look at the relevant records and health history, then connect them with your goals to explain this result in context.",
      "sources_narration": "Next, I'll search medical literature for evidence that matches your profile.",
      "steps": {
        "profile": "Reviewing your goals and health history",
        "test_results": "Looking at relevant results in your record",
        "records": "Looking at relevant records and health history",
        "goals": "Reviewing your goals",
        "biomarkers": "Checking your relevant biomarkers",
        "treatment_context": "Reviewing your treatment context",
        "medical_history": "Reviewing your medical history",
        "fertility_history": "Reviewing your fertility history",
        "medications": "Reviewing your current medications",
        "lifestyle": "Reviewing your lifestyle",
        "family_history": "Reviewing your family history",
        "cycle_timing": "Checking your cycle timing",
        "other": "Reviewing additional context",
        "research": "Searching medical research"
      }
    },
    "evidence_levels": {
      "expert_opinion": {
        "label": "Expert opinion",
        "description": "Expert opinion or mechanism-based reasoning can explain biological plausibility, but it does not directly test whether an intervention improves outcomes."
      },
      "observational": {
        "label": "Observational",
        "description": "An observational study looks for patterns in real-world data without assigning people to a treatment or control group. It can show associations, but cannot prove cause and effect."
      },
      "cohort": {
        "label": "Cohort",
        "description": "A cohort study follows a group of people over time to observe outcomes. While not as strong as an RCT, cohort studies provide valuable real-world evidence about associations and trends."
      },
      "review": {
        "label": "Review",
        "description": "A systematic or narrative review summarizes existing research on a topic. Reviews are useful for context, but the strength depends on the studies included and how rigorously the review was conducted."
      },
      "rct": {
        "label": "RCT",
        "description": "A Randomized Controlled Trial (RCT) is considered the gold standard of clinical research. Participants are randomly assigned to treatment or control groups, minimizing bias and providing strong causal evidence."
      },
      "meta_analysis": {
        "label": "Meta-analysis",
        "description": "A meta-analysis combines results from multiple independent studies to draw stronger conclusions. It is one of the highest levels of evidence when the included studies are relevant and high quality."
      },
      "guideline": {
        "label": "Guideline",
        "description": "A clinical practice guideline issued by a major scientific society (ESHRE, ASRM, ACOG, ACMG, ATA, Endocrine Society, NICE, HAS, CNGOF, etc.). Guidelines synthesize meta-analyses, RCTs, and expert consensus into clinical recommendations — they represent the highest level of consensus on how to apply evidence in practice."
      },
      "official": {
        "label": "Official source",
        "description": "Institutional or government source (ameli.fr, service-public.fr, French Biomedicine Agency, WHO). Authoritative for legal, administrative, and reimbursement matters."
      },
      "reference": {
        "label": "Medical reference",
        "description": "Patient-facing medical reference (Mayo Clinic, NHS, Cleveland Clinic, Orphanet). Useful for explanation, but should be supplemented with primary sources for clinical decisions."
      }
    },
    "supplement_detail": {
      "badge_supplement": "Supplement",
      "evidence_strength": {
        "strong": "Strong",
        "moderate": "Moderate",
        "emerging": "Emerging",
        "mixed": "Mixed",
        "debunked": "Debunked"
      },
      "evidence_badge": "${strength} evidence",
      "you_are_taking": "You're taking this supplement",
      "you_have_taken": "You've taken this supplement before",
      "you_stopped_taking": "You stopped taking this supplement",
      "row_your_supplement": "Supplement",
      "section_how_to_take": "How to take",
      "row_dosage": "Dosage: ${value}",
      "row_timing": "Timing: ${value}",
      "how_to_take_label_dosage": "Dosage",
      "how_to_take_label_timing": "Timing",
      "how_to_take_label_best_time": "Best time",
      "how_to_take_label_start_timing": "When to start",
      "how_to_take_label_cycle_note": "Cycle note",
      "section_bioavailability": "Bioavailability",
      "row_form": "Form: ${value}",
      "row_absorption": "Absorption: ${value}",
      "row_metabolism": "Metabolism: ${value}",
      "row_bioavailability_timing": "Timing note: ${value}",
      "row_caution": "Watch for: ${value}",
      "bioavailability_label_form": "Form",
      "bioavailability_label_absorption": "Absorption",
      "bioavailability_label_metabolism": "Metabolism",
      "bioavailability_label_timing": "Timing",
      "bioavailability_label_caution": "Watch for",
      "section_what_to_expect": "What to expect",
      "section_keep_in_mind": "Keep in mind",
      "section_interacts_with": "Interacts with",
      "interaction_taking": "Taking",
      "interaction_severity_note": "Note",
      "interaction_severity_caution": "Caution",
      "interaction_severity_critical": "Critical",
      "section_food_sources": "Food sources",
      "section_evidence": "Evidence",
      "interest_button_label": "Get it",
      "interest_button_captured": "We'll let you know!",
      "food_modal_serving": "Serving",
      "food_modal_per_serving": "Per serving"
    },
    "program_detail": {
      "badge_coming_soon": "Coming soon",
      "for_whom_her": "Her",
      "for_whom_him": "Him",
      "for_whom_both": "Her & Him",
      "modules_count_one": "${count} module",
      "modules_count_other": "${count} modules",
      "section_whats_included": "What's included",
      "section_how_it_works": "How it works",
      "phase_parallel_suffix": " (parallel)",
      "section_what_youll_track": "What you'll track",
      "marker_retest": "Retest: ${value}",
      "section_evidence": "Evidence",
      "row_evidence_level": "Evidence: ${level}",
      "notify_when_launches": "We'll notify you when this program launches"
    },
    "test_detail": {
      "section_what_it_measures": "What it measures",
      "section_marker_timing": "Timing by marker",
      "section_at_a_glance": "At a glance",
      "section_sold_as": "Sold as",
      "section_result_types": "What to expect for each result type",
      "section_best_for": "Best for",
      "section_research": "What the research shows",
      "section_what_to_expect": "What to expect",
      "section_biomarkers_tracked": "Biomarkers tracked",
      "section_available_as": "Available as",
      "marketed_as": "Marketed as",
      "what_it_is": "What it is",
      "evidence_note": "Evidence note",
      "view_all_related": "View all related tests",
      "view_all_prefix": "View all ${category}",
      "female_test_a11y": "Female test",
      "male_test_a11y": "Male test",
      "evidence_strength_strong": "Strong evidence",
      "evidence_strength_moderate": "Moderate evidence",
      "evidence_strength_emerging": "Emerging",
      "evidence_strength_mixed": "Mixed evidence",
      "evidence_strength_debunked": "Not supported by evidence",
      "sold_by": "Sold by ${company}",
      "section_how_it_works": "How it works",
      "section_why_it_matters": "Why it matters",
      "section_turnaround_time": "Turnaround time",
      "section_cost": "Cost",
      "cost_fr_covered": "Pris en charge à 100 % par la Sécurité sociale dans le cadre d'un parcours d'AMP conventionné.",
      "cost_fr_limited": "Pris en charge par la Sécurité sociale uniquement dans des indications cliniques précises. Hors indication, à payer (compter quelques centaines d'euros).",
      "cost_fr_out_of_pocket": "Examen complémentaire généralement non remboursé par la Sécurité sociale en France. Coût à payer, variable selon le laboratoire.",
      "section_when_to_take": "When to take it",
      "section_about_product": "About this product",
      "section_panel_parameters": "What this panel tests",
      "section_evidence": "Evidence",
      "section_considerations": "Considerations",
      "section_possible_results": "Possible result types",
      "related_commercial_tests_description": "These are the commercial assays linked to this canonical test category.",
      "no_result_types_available": "This test does not have a fixed set of report categories yet.",
      "section_price": "Price",
      "order_from_provider": "Order from provider",
      "order_now": "Order kit",
      "order_success": "Order placed",
      "order_error": "Could not start checkout. Please try again.",
      "order_in_app": "Available to order in the Louise app",
      "badge_at_home": "At-home",
      "badge_clinic_visit": "Clinic visit",
      "category_blood_marker": "Blood marker",
      "category_imaging": "Imaging",
      "category_genetic": "Genetic",
      "category_semen": "Semen analysis",
      "category_monitoring": "Monitoring",
      "category_biopsy": "Biopsy",
      "quick_fact_sample": "Sample",
      "quick_fact_time": "Time",
      "quick_fact_pain": "Pain",
      "quick_fact_anesthesia": "Anesthesia",
      "quick_fact_prep": "Prep",
      "quick_fact_results": "Results"
    },
    "encyclopedia_screens": {
      "all": "All",
      "medications": {
        "title": "Medications",
        "subtitle": "Fertility medications and how they work",
        "search_placeholder": "Search medications, brands...",
        "count_one": "${count} medication",
        "count_other": "${count} medications",
        "empty": "No medications match your search",
        "drug_classes": {
          "gonadotropin": "Gonadotropins",
          "gnrh_antagonist": "GnRH Antagonists",
          "gnrh_agonist": "GnRH Agonists",
          "trigger_shot": "Trigger Shots",
          "progesterone": "Progesterone",
          "estrogen": "Estrogen",
          "oral_ovulation_induction": "Oral Ovulation",
          "anticoagulant": "Anticoagulants",
          "supplement": "Supplements"
        },
        "routes": {
          "subcutaneous": "Subcutaneous",
          "intramuscular": "Intramuscular",
          "oral": "Oral",
          "topical": "Topical",
          "vaginal": "Vaginal"
        }
      },
      "conditions": {
        "title": "Conditions",
        "subtitle": "Understanding what affects your fertility",
        "search_placeholder": "Search conditions...",
        "count_one": "${count} condition",
        "count_other": "${count} conditions",
        "empty": "No conditions match your search",
        "categories": {
          "reproductive": "Reproductive",
          "endocrine": "Endocrine",
          "autoimmune": "Autoimmune",
          "structural": "Structural",
          "genetic": "Genetic",
          "male_factor": "Male factor"
        }
      },
      "tests": {
        "title": "Tests & Markers",
        "subtitle": "What's measured and what it means",
        "search_placeholder": "Search tests...",
        "count_one": "${count} item",
        "count_other": "${count} items",
        "empty": "No tests match your search",
        "categories": {
          "blood_marker": "Blood markers",
          "imaging": "Imaging",
          "genetic": "Genetic",
          "semen": "Semen",
          "monitoring": "Monitoring"
        }
      },
      "procedures": {
        "title": "Procedures",
        "subtitle": "Steps & processes in your treatment",
        "search_placeholder": "Search procedures...",
        "count_one": "${count} procedure",
        "count_other": "${count} procedures",
        "empty": "No procedures match your search",
        "categories": {
          "consultation": "Consultations",
          "stimulation": "Stimulation",
          "retrieval": "Retrieval",
          "lab": "Lab",
          "transfer": "Transfer",
          "diagnostic": "Diagnostic",
          "recovery": "Recovery"
        }
      }
    }
  }
}
